function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire420a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire420a"] = parcelRequire;
}
parcelRequire.register("8XIvq", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $68665b61144b794b$export$ffb0004e005737fa; }, function (v) { return $68665b61144b794b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $68665b61144b794b$export$34b9dba7ce09269b; }, function (v) { return $68665b61144b794b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $68665b61144b794b$export$25062201e9e25d76; }, function (v) { return $68665b61144b794b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68665b61144b794b$export$ffb0004e005737fa;
var $68665b61144b794b$export$34b9dba7ce09269b;
var $68665b61144b794b$export$25062201e9e25d76;
"use strict";

var $eXaQ2 = parcelRequire("eXaQ2");
var $68665b61144b794b$var$k = Symbol.for("react.element"), $68665b61144b794b$var$l = Symbol.for("react.fragment"), $68665b61144b794b$var$m = Object.prototype.hasOwnProperty, $68665b61144b794b$var$n = $eXaQ2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $68665b61144b794b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $68665b61144b794b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$68665b61144b794b$var$m.call(a, b) && !$68665b61144b794b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $68665b61144b794b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $68665b61144b794b$var$n.current
    };
}
$68665b61144b794b$export$ffb0004e005737fa = $68665b61144b794b$var$l;
$68665b61144b794b$export$34b9dba7ce09269b = $68665b61144b794b$var$q;
$68665b61144b794b$export$25062201e9e25d76 = $68665b61144b794b$var$q;

});
parcelRequire.register("eXaQ2", function(module, exports) {
"use strict";

module.exports = (parcelRequire("59YRD"));

});
parcelRequire.register("59YRD", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $3c1d015488173b00$export$dca3b0875bd9a954; }, function (v) { return $3c1d015488173b00$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $3c1d015488173b00$export$16fa2f45be04daa8; }, function (v) { return $3c1d015488173b00$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3c1d015488173b00$export$ffb0004e005737fa; }, function (v) { return $3c1d015488173b00$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $3c1d015488173b00$export$e2c29f18771995cb; }, function (v) { return $3c1d015488173b00$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $3c1d015488173b00$export$221d75b3f55bb0bd; }, function (v) { return $3c1d015488173b00$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3c1d015488173b00$export$5f8d39834fd61797; }, function (v) { return $3c1d015488173b00$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3c1d015488173b00$export$74bf444e3cd11ea5; }, function (v) { return $3c1d015488173b00$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3c1d015488173b00$export$ae55be85d98224ed; }, function (v) { return $3c1d015488173b00$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $3c1d015488173b00$export$e530037191fcd5d7; }, function (v) { return $3c1d015488173b00$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $3c1d015488173b00$export$fd42f52fd3ae1109; }, function (v) { return $3c1d015488173b00$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $3c1d015488173b00$export$c8a8987d4410bf2d; }, function (v) { return $3c1d015488173b00$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $3c1d015488173b00$export$d38cd72104c1f0e9; }, function (v) { return $3c1d015488173b00$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $3c1d015488173b00$export$7d1e3a5e95ceca43; }, function (v) { return $3c1d015488173b00$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $3c1d015488173b00$export$257a8862b851cb5b; }, function (v) { return $3c1d015488173b00$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $3c1d015488173b00$export$a8257692ac88316c; }, function (v) { return $3c1d015488173b00$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $3c1d015488173b00$export$488013bae63b21da; }, function (v) { return $3c1d015488173b00$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $3c1d015488173b00$export$7c73462e0d25e514; }, function (v) { return $3c1d015488173b00$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $3c1d015488173b00$export$7568632d0d33d16d; }, function (v) { return $3c1d015488173b00$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $3c1d015488173b00$export$88948ce120ea2619; }, function (v) { return $3c1d015488173b00$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $3c1d015488173b00$export$35808ee640e87ca7; }, function (v) { return $3c1d015488173b00$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $3c1d015488173b00$export$fae74005e78b1a27; }, function (v) { return $3c1d015488173b00$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $3c1d015488173b00$export$dc8fbce3eb94dc1e; }, function (v) { return $3c1d015488173b00$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $3c1d015488173b00$export$6a7bc4e911dc01cf; }, function (v) { return $3c1d015488173b00$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $3c1d015488173b00$export$6d9c69b0de29b591; }, function (v) { return $3c1d015488173b00$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $3c1d015488173b00$export$f680877a34711e37; }, function (v) { return $3c1d015488173b00$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $3c1d015488173b00$export$d5a552a76deda3c2; }, function (v) { return $3c1d015488173b00$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $3c1d015488173b00$export$aaabe4eda9ed9969; }, function (v) { return $3c1d015488173b00$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $3c1d015488173b00$export$e5c5a5f917a5871c; }, function (v) { return $3c1d015488173b00$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $3c1d015488173b00$export$1538c33de8887b59; }, function (v) { return $3c1d015488173b00$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $3c1d015488173b00$export$13e3392192263954; }, function (v) { return $3c1d015488173b00$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $3c1d015488173b00$export$b8f5890fc79d6aca; }, function (v) { return $3c1d015488173b00$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $3c1d015488173b00$export$60241385465d0a34; }, function (v) { return $3c1d015488173b00$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $3c1d015488173b00$export$306c0aa65ff9ec16; }, function (v) { return $3c1d015488173b00$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $3c1d015488173b00$export$7b286972b8d8ccbf; }, function (v) { return $3c1d015488173b00$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $3c1d015488173b00$export$83d89fbfd8236492; }, function (v) { return $3c1d015488173b00$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c1d015488173b00$export$dca3b0875bd9a954;
var $3c1d015488173b00$export$16fa2f45be04daa8;
var $3c1d015488173b00$export$ffb0004e005737fa;
var $3c1d015488173b00$export$e2c29f18771995cb;
var $3c1d015488173b00$export$221d75b3f55bb0bd;
var $3c1d015488173b00$export$5f8d39834fd61797;
var $3c1d015488173b00$export$74bf444e3cd11ea5;
var $3c1d015488173b00$export$ae55be85d98224ed;
var $3c1d015488173b00$export$e530037191fcd5d7;
var $3c1d015488173b00$export$fd42f52fd3ae1109;
var $3c1d015488173b00$export$c8a8987d4410bf2d;
var $3c1d015488173b00$export$d38cd72104c1f0e9;
var $3c1d015488173b00$export$7d1e3a5e95ceca43;
var $3c1d015488173b00$export$257a8862b851cb5b;
var $3c1d015488173b00$export$a8257692ac88316c;
var $3c1d015488173b00$export$488013bae63b21da;
var $3c1d015488173b00$export$7c73462e0d25e514;
var $3c1d015488173b00$export$7568632d0d33d16d;
var $3c1d015488173b00$export$88948ce120ea2619;
var $3c1d015488173b00$export$35808ee640e87ca7;
var $3c1d015488173b00$export$fae74005e78b1a27;
var $3c1d015488173b00$export$dc8fbce3eb94dc1e;
var $3c1d015488173b00$export$6a7bc4e911dc01cf;
var $3c1d015488173b00$export$6d9c69b0de29b591;
var $3c1d015488173b00$export$f680877a34711e37;
var $3c1d015488173b00$export$d5a552a76deda3c2;
var $3c1d015488173b00$export$aaabe4eda9ed9969;
var $3c1d015488173b00$export$e5c5a5f917a5871c;
var $3c1d015488173b00$export$1538c33de8887b59;
var $3c1d015488173b00$export$13e3392192263954;
var $3c1d015488173b00$export$b8f5890fc79d6aca;
var $3c1d015488173b00$export$60241385465d0a34;
var $3c1d015488173b00$export$306c0aa65ff9ec16;
var $3c1d015488173b00$export$7b286972b8d8ccbf;
var $3c1d015488173b00$export$83d89fbfd8236492;
"use strict";
var $3c1d015488173b00$var$l = Symbol.for("react.element"), $3c1d015488173b00$var$n = Symbol.for("react.portal"), $3c1d015488173b00$var$p = Symbol.for("react.fragment"), $3c1d015488173b00$var$q = Symbol.for("react.strict_mode"), $3c1d015488173b00$var$r = Symbol.for("react.profiler"), $3c1d015488173b00$var$t = Symbol.for("react.provider"), $3c1d015488173b00$var$u = Symbol.for("react.context"), $3c1d015488173b00$var$v = Symbol.for("react.forward_ref"), $3c1d015488173b00$var$w = Symbol.for("react.suspense"), $3c1d015488173b00$var$x = Symbol.for("react.memo"), $3c1d015488173b00$var$y = Symbol.for("react.lazy"), $3c1d015488173b00$var$z = Symbol.iterator;
function $3c1d015488173b00$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3c1d015488173b00$var$z && a[$3c1d015488173b00$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3c1d015488173b00$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $3c1d015488173b00$var$C = Object.assign, $3c1d015488173b00$var$D = {};
function $3c1d015488173b00$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3c1d015488173b00$var$D;
    this.updater = e || $3c1d015488173b00$var$B;
}
$3c1d015488173b00$var$E.prototype.isReactComponent = {};
$3c1d015488173b00$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$3c1d015488173b00$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $3c1d015488173b00$var$F() {}
$3c1d015488173b00$var$F.prototype = $3c1d015488173b00$var$E.prototype;
function $3c1d015488173b00$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3c1d015488173b00$var$D;
    this.updater = e || $3c1d015488173b00$var$B;
}
var $3c1d015488173b00$var$H = $3c1d015488173b00$var$G.prototype = new $3c1d015488173b00$var$F;
$3c1d015488173b00$var$H.constructor = $3c1d015488173b00$var$G;
$3c1d015488173b00$var$C($3c1d015488173b00$var$H, $3c1d015488173b00$var$E.prototype);
$3c1d015488173b00$var$H.isPureReactComponent = !0;
var $3c1d015488173b00$var$I = Array.isArray, $3c1d015488173b00$var$J = Object.prototype.hasOwnProperty, $3c1d015488173b00$var$K = {
    current: null
}, $3c1d015488173b00$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3c1d015488173b00$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$3c1d015488173b00$var$J.call(b, d) && !$3c1d015488173b00$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $3c1d015488173b00$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $3c1d015488173b00$var$K.current
    };
}
function $3c1d015488173b00$var$N(a, b) {
    return {
        $$typeof: $3c1d015488173b00$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $3c1d015488173b00$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3c1d015488173b00$var$l;
}
function $3c1d015488173b00$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $3c1d015488173b00$var$P = /\/+/g;
function $3c1d015488173b00$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $3c1d015488173b00$var$escape("" + a.key) : b.toString(36);
}
function $3c1d015488173b00$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $3c1d015488173b00$var$l:
                case $3c1d015488173b00$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $3c1d015488173b00$var$Q(h, 0) : d, $3c1d015488173b00$var$I(c) ? (e = "", null != a && (e = a.replace($3c1d015488173b00$var$P, "$&/") + "/"), $3c1d015488173b00$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($3c1d015488173b00$var$O(c) && (c = $3c1d015488173b00$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($3c1d015488173b00$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($3c1d015488173b00$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $3c1d015488173b00$var$Q(k, g);
        h += $3c1d015488173b00$var$R(k, b, e, f, c);
    }
    else if (f = $3c1d015488173b00$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $3c1d015488173b00$var$Q(k, g++), h += $3c1d015488173b00$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $3c1d015488173b00$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $3c1d015488173b00$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $3c1d015488173b00$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $3c1d015488173b00$var$U = {
    current: null
}, $3c1d015488173b00$var$V = {
    transition: null
}, $3c1d015488173b00$var$W = {
    ReactCurrentDispatcher: $3c1d015488173b00$var$U,
    ReactCurrentBatchConfig: $3c1d015488173b00$var$V,
    ReactCurrentOwner: $3c1d015488173b00$var$K
};
$3c1d015488173b00$export$dca3b0875bd9a954 = {
    map: $3c1d015488173b00$var$S,
    forEach: function(a, b, e) {
        $3c1d015488173b00$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $3c1d015488173b00$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $3c1d015488173b00$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$3c1d015488173b00$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$3c1d015488173b00$export$16fa2f45be04daa8 = $3c1d015488173b00$var$E;
$3c1d015488173b00$export$ffb0004e005737fa = $3c1d015488173b00$var$p;
$3c1d015488173b00$export$e2c29f18771995cb = $3c1d015488173b00$var$r;
$3c1d015488173b00$export$221d75b3f55bb0bd = $3c1d015488173b00$var$G;
$3c1d015488173b00$export$5f8d39834fd61797 = $3c1d015488173b00$var$q;
$3c1d015488173b00$export$74bf444e3cd11ea5 = $3c1d015488173b00$var$w;
$3c1d015488173b00$export$ae55be85d98224ed = $3c1d015488173b00$var$W;
$3c1d015488173b00$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $3c1d015488173b00$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $3c1d015488173b00$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$3c1d015488173b00$var$J.call(b, f) && !$3c1d015488173b00$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $3c1d015488173b00$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$3c1d015488173b00$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $3c1d015488173b00$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $3c1d015488173b00$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$3c1d015488173b00$export$c8a8987d4410bf2d = $3c1d015488173b00$var$M;
$3c1d015488173b00$export$d38cd72104c1f0e9 = function(a) {
    var b = $3c1d015488173b00$var$M.bind(null, a);
    b.type = a;
    return b;
};
$3c1d015488173b00$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3c1d015488173b00$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $3c1d015488173b00$var$v,
        render: a
    };
};
$3c1d015488173b00$export$a8257692ac88316c = $3c1d015488173b00$var$O;
$3c1d015488173b00$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $3c1d015488173b00$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $3c1d015488173b00$var$T
    };
};
$3c1d015488173b00$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $3c1d015488173b00$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$3c1d015488173b00$export$7568632d0d33d16d = function(a) {
    var b = $3c1d015488173b00$var$V.transition;
    $3c1d015488173b00$var$V.transition = {};
    try {
        a();
    } finally{
        $3c1d015488173b00$var$V.transition = b;
    }
};
$3c1d015488173b00$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$3c1d015488173b00$export$35808ee640e87ca7 = function(a, b) {
    return $3c1d015488173b00$var$U.current.useCallback(a, b);
};
$3c1d015488173b00$export$fae74005e78b1a27 = function(a) {
    return $3c1d015488173b00$var$U.current.useContext(a);
};
$3c1d015488173b00$export$dc8fbce3eb94dc1e = function() {};
$3c1d015488173b00$export$6a7bc4e911dc01cf = function(a) {
    return $3c1d015488173b00$var$U.current.useDeferredValue(a);
};
$3c1d015488173b00$export$6d9c69b0de29b591 = function(a, b) {
    return $3c1d015488173b00$var$U.current.useEffect(a, b);
};
$3c1d015488173b00$export$f680877a34711e37 = function() {
    return $3c1d015488173b00$var$U.current.useId();
};
$3c1d015488173b00$export$d5a552a76deda3c2 = function(a, b, e) {
    return $3c1d015488173b00$var$U.current.useImperativeHandle(a, b, e);
};
$3c1d015488173b00$export$aaabe4eda9ed9969 = function(a, b) {
    return $3c1d015488173b00$var$U.current.useInsertionEffect(a, b);
};
$3c1d015488173b00$export$e5c5a5f917a5871c = function(a, b) {
    return $3c1d015488173b00$var$U.current.useLayoutEffect(a, b);
};
$3c1d015488173b00$export$1538c33de8887b59 = function(a, b) {
    return $3c1d015488173b00$var$U.current.useMemo(a, b);
};
$3c1d015488173b00$export$13e3392192263954 = function(a, b, e) {
    return $3c1d015488173b00$var$U.current.useReducer(a, b, e);
};
$3c1d015488173b00$export$b8f5890fc79d6aca = function(a) {
    return $3c1d015488173b00$var$U.current.useRef(a);
};
$3c1d015488173b00$export$60241385465d0a34 = function(a) {
    return $3c1d015488173b00$var$U.current.useState(a);
};
$3c1d015488173b00$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $3c1d015488173b00$var$U.current.useSyncExternalStore(a, b, e);
};
$3c1d015488173b00$export$7b286972b8d8ccbf = function() {
    return $3c1d015488173b00$var$U.current.useTransition();
};
$3c1d015488173b00$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("cQaOR", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9592bbddf786be94$export$ae55be85d98224ed; }, function (v) { return $9592bbddf786be94$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $9592bbddf786be94$export$d39a5bbd09211389; }, function (v) { return $9592bbddf786be94$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $9592bbddf786be94$export$882461b6382ed46c; }, function (v) { return $9592bbddf786be94$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $9592bbddf786be94$export$466bfc07425424d5; }, function (v) { return $9592bbddf786be94$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9592bbddf786be94$export$cd75ccfd720a3cd4; }, function (v) { return $9592bbddf786be94$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $9592bbddf786be94$export$fa8d919ba61d84db; }, function (v) { return $9592bbddf786be94$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $9592bbddf786be94$export$757ceba2d55c277e; }, function (v) { return $9592bbddf786be94$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $9592bbddf786be94$export$b3890eb0ae9dca99; }, function (v) { return $9592bbddf786be94$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $9592bbddf786be94$export$502457920280e6be; }, function (v) { return $9592bbddf786be94$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9592bbddf786be94$export$c78a37762a8d58e1; }, function (v) { return $9592bbddf786be94$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $9592bbddf786be94$export$dc54d992c10e8a18; }, function (v) { return $9592bbddf786be94$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $9592bbddf786be94$export$83d89fbfd8236492; }, function (v) { return $9592bbddf786be94$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9592bbddf786be94$export$ae55be85d98224ed;
var $9592bbddf786be94$export$d39a5bbd09211389;
var $9592bbddf786be94$export$882461b6382ed46c;
var $9592bbddf786be94$export$466bfc07425424d5;
var $9592bbddf786be94$export$cd75ccfd720a3cd4;
var $9592bbddf786be94$export$fa8d919ba61d84db;
var $9592bbddf786be94$export$757ceba2d55c277e;
var $9592bbddf786be94$export$b3890eb0ae9dca99;
var $9592bbddf786be94$export$502457920280e6be;
var $9592bbddf786be94$export$c78a37762a8d58e1;
var $9592bbddf786be94$export$dc54d992c10e8a18;
var $9592bbddf786be94$export$83d89fbfd8236492;
"use strict";

var $eXaQ2 = parcelRequire("eXaQ2");

var $k7mRH = parcelRequire("k7mRH");
function $9592bbddf786be94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9592bbddf786be94$var$da = new Set, $9592bbddf786be94$var$ea = {};
function $9592bbddf786be94$var$fa(a, b) {
    $9592bbddf786be94$var$ha(a, b);
    $9592bbddf786be94$var$ha(a + "Capture", b);
}
function $9592bbddf786be94$var$ha(a, b) {
    $9592bbddf786be94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9592bbddf786be94$var$da.add(b[a]);
}
var $9592bbddf786be94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9592bbddf786be94$var$ja = Object.prototype.hasOwnProperty, $9592bbddf786be94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9592bbddf786be94$var$la = {}, $9592bbddf786be94$var$ma = {};
function $9592bbddf786be94$var$oa(a) {
    if ($9592bbddf786be94$var$ja.call($9592bbddf786be94$var$ma, a)) return !0;
    if ($9592bbddf786be94$var$ja.call($9592bbddf786be94$var$la, a)) return !1;
    if ($9592bbddf786be94$var$ka.test(a)) return $9592bbddf786be94$var$ma[a] = !0;
    $9592bbddf786be94$var$la[a] = !0;
    return !1;
}
function $9592bbddf786be94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9592bbddf786be94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9592bbddf786be94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9592bbddf786be94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9592bbddf786be94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9592bbddf786be94$var$z[b] = new $9592bbddf786be94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9592bbddf786be94$var$ra = /[\-:]([a-z])/g;
function $9592bbddf786be94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9592bbddf786be94$var$ra, $9592bbddf786be94$var$sa);
    $9592bbddf786be94$var$z[b] = new $9592bbddf786be94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9592bbddf786be94$var$ra, $9592bbddf786be94$var$sa);
    $9592bbddf786be94$var$z[b] = new $9592bbddf786be94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9592bbddf786be94$var$ra, $9592bbddf786be94$var$sa);
    $9592bbddf786be94$var$z[b] = new $9592bbddf786be94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9592bbddf786be94$var$z.xlinkHref = new $9592bbddf786be94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9592bbddf786be94$var$z[a] = new $9592bbddf786be94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9592bbddf786be94$var$ta(a, b, c, d) {
    var e = $9592bbddf786be94$var$z.hasOwnProperty(b) ? $9592bbddf786be94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9592bbddf786be94$var$qa(b, c, e, d) && (c = null), d || null === e ? $9592bbddf786be94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9592bbddf786be94$var$ua = $eXaQ2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9592bbddf786be94$var$va = Symbol.for("react.element"), $9592bbddf786be94$var$wa = Symbol.for("react.portal"), $9592bbddf786be94$var$ya = Symbol.for("react.fragment"), $9592bbddf786be94$var$za = Symbol.for("react.strict_mode"), $9592bbddf786be94$var$Aa = Symbol.for("react.profiler"), $9592bbddf786be94$var$Ba = Symbol.for("react.provider"), $9592bbddf786be94$var$Ca = Symbol.for("react.context"), $9592bbddf786be94$var$Da = Symbol.for("react.forward_ref"), $9592bbddf786be94$var$Ea = Symbol.for("react.suspense"), $9592bbddf786be94$var$Fa = Symbol.for("react.suspense_list"), $9592bbddf786be94$var$Ga = Symbol.for("react.memo"), $9592bbddf786be94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9592bbddf786be94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9592bbddf786be94$var$Ja = Symbol.iterator;
function $9592bbddf786be94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9592bbddf786be94$var$Ja && a[$9592bbddf786be94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9592bbddf786be94$var$A = Object.assign, $9592bbddf786be94$var$La;
function $9592bbddf786be94$var$Ma(a) {
    if (void 0 === $9592bbddf786be94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9592bbddf786be94$var$La = b && b[1] || "";
    }
    return "\n" + $9592bbddf786be94$var$La + a;
}
var $9592bbddf786be94$var$Na = !1;
function $9592bbddf786be94$var$Oa(a, b) {
    if (!a || $9592bbddf786be94$var$Na) return "";
    $9592bbddf786be94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9592bbddf786be94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9592bbddf786be94$var$Ma(a) : "";
}
function $9592bbddf786be94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9592bbddf786be94$var$Ma(a.type);
        case 16:
            return $9592bbddf786be94$var$Ma("Lazy");
        case 13:
            return $9592bbddf786be94$var$Ma("Suspense");
        case 19:
            return $9592bbddf786be94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9592bbddf786be94$var$Oa(a.type, !1), a;
        case 11:
            return a = $9592bbddf786be94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9592bbddf786be94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9592bbddf786be94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9592bbddf786be94$var$ya:
            return "Fragment";
        case $9592bbddf786be94$var$wa:
            return "Portal";
        case $9592bbddf786be94$var$Aa:
            return "Profiler";
        case $9592bbddf786be94$var$za:
            return "StrictMode";
        case $9592bbddf786be94$var$Ea:
            return "Suspense";
        case $9592bbddf786be94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9592bbddf786be94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9592bbddf786be94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9592bbddf786be94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9592bbddf786be94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9592bbddf786be94$var$Qa(a.type) || "Memo";
        case $9592bbddf786be94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9592bbddf786be94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9592bbddf786be94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9592bbddf786be94$var$Qa(b);
        case 8:
            return b === $9592bbddf786be94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9592bbddf786be94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9592bbddf786be94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9592bbddf786be94$var$Ua(a) {
    var b = $9592bbddf786be94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9592bbddf786be94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9592bbddf786be94$var$Ua(a));
}
function $9592bbddf786be94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9592bbddf786be94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9592bbddf786be94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9592bbddf786be94$var$Ya(a, b) {
    var c = b.checked;
    return $9592bbddf786be94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9592bbddf786be94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9592bbddf786be94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9592bbddf786be94$var$ab(a, b) {
    b = b.checked;
    null != b && $9592bbddf786be94$var$ta(a, "checked", b, !1);
}
function $9592bbddf786be94$var$bb(a, b) {
    $9592bbddf786be94$var$ab(a, b);
    var c = $9592bbddf786be94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9592bbddf786be94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9592bbddf786be94$var$cb(a, b.type, $9592bbddf786be94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9592bbddf786be94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9592bbddf786be94$var$cb(a, b, c) {
    if ("number" !== b || $9592bbddf786be94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9592bbddf786be94$var$eb = Array.isArray;
function $9592bbddf786be94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9592bbddf786be94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9592bbddf786be94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9592bbddf786be94$var$p(91));
    return $9592bbddf786be94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9592bbddf786be94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9592bbddf786be94$var$p(92));
            if ($9592bbddf786be94$var$eb(c)) {
                if (1 < c.length) throw Error($9592bbddf786be94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9592bbddf786be94$var$Sa(c)
    };
}
function $9592bbddf786be94$var$ib(a, b) {
    var c = $9592bbddf786be94$var$Sa(b.value), d = $9592bbddf786be94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9592bbddf786be94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9592bbddf786be94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9592bbddf786be94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9592bbddf786be94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9592bbddf786be94$var$mb, $9592bbddf786be94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9592bbddf786be94$var$mb = $9592bbddf786be94$var$mb || document.createElement("div");
        $9592bbddf786be94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9592bbddf786be94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9592bbddf786be94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9592bbddf786be94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9592bbddf786be94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9592bbddf786be94$var$pb).forEach(function(a) {
    $9592bbddf786be94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9592bbddf786be94$var$pb[b] = $9592bbddf786be94$var$pb[a];
    });
});
function $9592bbddf786be94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9592bbddf786be94$var$pb.hasOwnProperty(a) && $9592bbddf786be94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9592bbddf786be94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9592bbddf786be94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9592bbddf786be94$var$tb = $9592bbddf786be94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9592bbddf786be94$var$ub(a, b) {
    if (b) {
        if ($9592bbddf786be94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9592bbddf786be94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9592bbddf786be94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9592bbddf786be94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9592bbddf786be94$var$p(62));
    }
}
function $9592bbddf786be94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9592bbddf786be94$var$wb = null;
function $9592bbddf786be94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9592bbddf786be94$var$yb = null, $9592bbddf786be94$var$zb = null, $9592bbddf786be94$var$Ab = null;
function $9592bbddf786be94$var$Bb(a) {
    if (a = $9592bbddf786be94$var$Cb(a)) {
        if ("function" !== typeof $9592bbddf786be94$var$yb) throw Error($9592bbddf786be94$var$p(280));
        var b = a.stateNode;
        b && (b = $9592bbddf786be94$var$Db(b), $9592bbddf786be94$var$yb(a.stateNode, a.type, b));
    }
}
function $9592bbddf786be94$var$Eb(a) {
    $9592bbddf786be94$var$zb ? $9592bbddf786be94$var$Ab ? $9592bbddf786be94$var$Ab.push(a) : $9592bbddf786be94$var$Ab = [
        a
    ] : $9592bbddf786be94$var$zb = a;
}
function $9592bbddf786be94$var$Fb() {
    if ($9592bbddf786be94$var$zb) {
        var a = $9592bbddf786be94$var$zb, b = $9592bbddf786be94$var$Ab;
        $9592bbddf786be94$var$Ab = $9592bbddf786be94$var$zb = null;
        $9592bbddf786be94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9592bbddf786be94$var$Bb(b[a]);
    }
}
function $9592bbddf786be94$var$Gb(a, b) {
    return a(b);
}
function $9592bbddf786be94$var$Hb() {}
var $9592bbddf786be94$var$Ib = !1;
function $9592bbddf786be94$var$Jb(a, b, c) {
    if ($9592bbddf786be94$var$Ib) return a(b, c);
    $9592bbddf786be94$var$Ib = !0;
    try {
        return $9592bbddf786be94$var$Gb(a, b, c);
    } finally{
        if ($9592bbddf786be94$var$Ib = !1, null !== $9592bbddf786be94$var$zb || null !== $9592bbddf786be94$var$Ab) $9592bbddf786be94$var$Hb(), $9592bbddf786be94$var$Fb();
    }
}
function $9592bbddf786be94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9592bbddf786be94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9592bbddf786be94$var$p(231, b, typeof c));
    return c;
}
var $9592bbddf786be94$var$Lb = !1;
if ($9592bbddf786be94$var$ia) try {
    var $9592bbddf786be94$var$Mb = {};
    Object.defineProperty($9592bbddf786be94$var$Mb, "passive", {
        get: function() {
            $9592bbddf786be94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9592bbddf786be94$var$Mb, $9592bbddf786be94$var$Mb);
    window.removeEventListener("test", $9592bbddf786be94$var$Mb, $9592bbddf786be94$var$Mb);
} catch (a) {
    $9592bbddf786be94$var$Lb = !1;
}
function $9592bbddf786be94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9592bbddf786be94$var$Ob = !1, $9592bbddf786be94$var$Pb = null, $9592bbddf786be94$var$Qb = !1, $9592bbddf786be94$var$Rb = null, $9592bbddf786be94$var$Sb = {
    onError: function(a) {
        $9592bbddf786be94$var$Ob = !0;
        $9592bbddf786be94$var$Pb = a;
    }
};
function $9592bbddf786be94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9592bbddf786be94$var$Ob = !1;
    $9592bbddf786be94$var$Pb = null;
    $9592bbddf786be94$var$Nb.apply($9592bbddf786be94$var$Sb, arguments);
}
function $9592bbddf786be94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9592bbddf786be94$var$Tb.apply(this, arguments);
    if ($9592bbddf786be94$var$Ob) {
        if ($9592bbddf786be94$var$Ob) {
            var l = $9592bbddf786be94$var$Pb;
            $9592bbddf786be94$var$Ob = !1;
            $9592bbddf786be94$var$Pb = null;
        } else throw Error($9592bbddf786be94$var$p(198));
        $9592bbddf786be94$var$Qb || ($9592bbddf786be94$var$Qb = !0, $9592bbddf786be94$var$Rb = l);
    }
}
function $9592bbddf786be94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9592bbddf786be94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9592bbddf786be94$var$Xb(a) {
    if ($9592bbddf786be94$var$Vb(a) !== a) throw Error($9592bbddf786be94$var$p(188));
}
function $9592bbddf786be94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9592bbddf786be94$var$Vb(a);
        if (null === b) throw Error($9592bbddf786be94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9592bbddf786be94$var$Xb(e), a;
                if (f === d) return $9592bbddf786be94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9592bbddf786be94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9592bbddf786be94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9592bbddf786be94$var$p(190));
    }
    if (3 !== c.tag) throw Error($9592bbddf786be94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9592bbddf786be94$var$Zb(a) {
    a = $9592bbddf786be94$var$Yb(a);
    return null !== a ? $9592bbddf786be94$var$$b(a) : null;
}
function $9592bbddf786be94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9592bbddf786be94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9592bbddf786be94$var$ac = $k7mRH.unstable_scheduleCallback, $9592bbddf786be94$var$bc = $k7mRH.unstable_cancelCallback, $9592bbddf786be94$var$cc = $k7mRH.unstable_shouldYield, $9592bbddf786be94$var$dc = $k7mRH.unstable_requestPaint, $9592bbddf786be94$var$B = $k7mRH.unstable_now, $9592bbddf786be94$var$ec = $k7mRH.unstable_getCurrentPriorityLevel, $9592bbddf786be94$var$fc = $k7mRH.unstable_ImmediatePriority, $9592bbddf786be94$var$gc = $k7mRH.unstable_UserBlockingPriority, $9592bbddf786be94$var$hc = $k7mRH.unstable_NormalPriority, $9592bbddf786be94$var$ic = $k7mRH.unstable_LowPriority, $9592bbddf786be94$var$jc = $k7mRH.unstable_IdlePriority, $9592bbddf786be94$var$kc = null, $9592bbddf786be94$var$lc = null;
function $9592bbddf786be94$var$mc(a) {
    if ($9592bbddf786be94$var$lc && "function" === typeof $9592bbddf786be94$var$lc.onCommitFiberRoot) try {
        $9592bbddf786be94$var$lc.onCommitFiberRoot($9592bbddf786be94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9592bbddf786be94$var$oc = Math.clz32 ? Math.clz32 : $9592bbddf786be94$var$nc, $9592bbddf786be94$var$pc = Math.log, $9592bbddf786be94$var$qc = Math.LN2;
function $9592bbddf786be94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9592bbddf786be94$var$pc(a) / $9592bbddf786be94$var$qc | 0) | 0;
}
var $9592bbddf786be94$var$rc = 64, $9592bbddf786be94$var$sc = 4194304;
function $9592bbddf786be94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9592bbddf786be94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9592bbddf786be94$var$tc(h) : (f &= g, 0 !== f && (d = $9592bbddf786be94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9592bbddf786be94$var$tc(g) : 0 !== f && (d = $9592bbddf786be94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9592bbddf786be94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9592bbddf786be94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9592bbddf786be94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9592bbddf786be94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9592bbddf786be94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9592bbddf786be94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9592bbddf786be94$var$yc() {
    var a = $9592bbddf786be94$var$rc;
    $9592bbddf786be94$var$rc <<= 1;
    0 === ($9592bbddf786be94$var$rc & 4194240) && ($9592bbddf786be94$var$rc = 64);
    return a;
}
function $9592bbddf786be94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9592bbddf786be94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9592bbddf786be94$var$oc(b);
    a[b] = c;
}
function $9592bbddf786be94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9592bbddf786be94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9592bbddf786be94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9592bbddf786be94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9592bbddf786be94$var$C = 0;
function $9592bbddf786be94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9592bbddf786be94$var$Ec, $9592bbddf786be94$var$Fc, $9592bbddf786be94$var$Gc, $9592bbddf786be94$var$Hc, $9592bbddf786be94$var$Ic, $9592bbddf786be94$var$Jc = !1, $9592bbddf786be94$var$Kc = [], $9592bbddf786be94$var$Lc = null, $9592bbddf786be94$var$Mc = null, $9592bbddf786be94$var$Nc = null, $9592bbddf786be94$var$Oc = new Map, $9592bbddf786be94$var$Pc = new Map, $9592bbddf786be94$var$Qc = [], $9592bbddf786be94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9592bbddf786be94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9592bbddf786be94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9592bbddf786be94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9592bbddf786be94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9592bbddf786be94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9592bbddf786be94$var$Pc.delete(b.pointerId);
    }
}
function $9592bbddf786be94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9592bbddf786be94$var$Cb(b), null !== b && $9592bbddf786be94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9592bbddf786be94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9592bbddf786be94$var$Lc = $9592bbddf786be94$var$Tc($9592bbddf786be94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9592bbddf786be94$var$Mc = $9592bbddf786be94$var$Tc($9592bbddf786be94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9592bbddf786be94$var$Nc = $9592bbddf786be94$var$Tc($9592bbddf786be94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9592bbddf786be94$var$Oc.set(f, $9592bbddf786be94$var$Tc($9592bbddf786be94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9592bbddf786be94$var$Pc.set(f, $9592bbddf786be94$var$Tc($9592bbddf786be94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9592bbddf786be94$var$Vc(a) {
    var b = $9592bbddf786be94$var$Wc(a.target);
    if (null !== b) {
        var c = $9592bbddf786be94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9592bbddf786be94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9592bbddf786be94$var$Ic(a.priority, function() {
                        $9592bbddf786be94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9592bbddf786be94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9592bbddf786be94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9592bbddf786be94$var$wb = d;
            c.target.dispatchEvent(d);
            $9592bbddf786be94$var$wb = null;
        } else return b = $9592bbddf786be94$var$Cb(c), null !== b && $9592bbddf786be94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9592bbddf786be94$var$Zc(a, b, c) {
    $9592bbddf786be94$var$Xc(a) && c.delete(b);
}
function $9592bbddf786be94$var$$c() {
    $9592bbddf786be94$var$Jc = !1;
    null !== $9592bbddf786be94$var$Lc && $9592bbddf786be94$var$Xc($9592bbddf786be94$var$Lc) && ($9592bbddf786be94$var$Lc = null);
    null !== $9592bbddf786be94$var$Mc && $9592bbddf786be94$var$Xc($9592bbddf786be94$var$Mc) && ($9592bbddf786be94$var$Mc = null);
    null !== $9592bbddf786be94$var$Nc && $9592bbddf786be94$var$Xc($9592bbddf786be94$var$Nc) && ($9592bbddf786be94$var$Nc = null);
    $9592bbddf786be94$var$Oc.forEach($9592bbddf786be94$var$Zc);
    $9592bbddf786be94$var$Pc.forEach($9592bbddf786be94$var$Zc);
}
function $9592bbddf786be94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9592bbddf786be94$var$Jc || ($9592bbddf786be94$var$Jc = !0, $k7mRH.unstable_scheduleCallback($k7mRH.unstable_NormalPriority, $9592bbddf786be94$var$$c)));
}
function $9592bbddf786be94$var$bd(a) {
    function b(b) {
        return $9592bbddf786be94$var$ad(b, a);
    }
    if (0 < $9592bbddf786be94$var$Kc.length) {
        $9592bbddf786be94$var$ad($9592bbddf786be94$var$Kc[0], a);
        for(var c = 1; c < $9592bbddf786be94$var$Kc.length; c++){
            var d = $9592bbddf786be94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9592bbddf786be94$var$Lc && $9592bbddf786be94$var$ad($9592bbddf786be94$var$Lc, a);
    null !== $9592bbddf786be94$var$Mc && $9592bbddf786be94$var$ad($9592bbddf786be94$var$Mc, a);
    null !== $9592bbddf786be94$var$Nc && $9592bbddf786be94$var$ad($9592bbddf786be94$var$Nc, a);
    $9592bbddf786be94$var$Oc.forEach(b);
    $9592bbddf786be94$var$Pc.forEach(b);
    for(c = 0; c < $9592bbddf786be94$var$Qc.length; c++)d = $9592bbddf786be94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9592bbddf786be94$var$Qc.length && (c = $9592bbddf786be94$var$Qc[0], null === c.blockedOn);)$9592bbddf786be94$var$Vc(c), null === c.blockedOn && $9592bbddf786be94$var$Qc.shift();
}
var $9592bbddf786be94$var$cd = $9592bbddf786be94$var$ua.ReactCurrentBatchConfig, $9592bbddf786be94$var$dd = !0;
function $9592bbddf786be94$var$ed(a, b, c, d) {
    var e = $9592bbddf786be94$var$C, f = $9592bbddf786be94$var$cd.transition;
    $9592bbddf786be94$var$cd.transition = null;
    try {
        $9592bbddf786be94$var$C = 1, $9592bbddf786be94$var$fd(a, b, c, d);
    } finally{
        $9592bbddf786be94$var$C = e, $9592bbddf786be94$var$cd.transition = f;
    }
}
function $9592bbddf786be94$var$gd(a, b, c, d) {
    var e = $9592bbddf786be94$var$C, f = $9592bbddf786be94$var$cd.transition;
    $9592bbddf786be94$var$cd.transition = null;
    try {
        $9592bbddf786be94$var$C = 4, $9592bbddf786be94$var$fd(a, b, c, d);
    } finally{
        $9592bbddf786be94$var$C = e, $9592bbddf786be94$var$cd.transition = f;
    }
}
function $9592bbddf786be94$var$fd(a, b, c, d) {
    if ($9592bbddf786be94$var$dd) {
        var e = $9592bbddf786be94$var$Yc(a, b, c, d);
        if (null === e) $9592bbddf786be94$var$hd(a, b, d, $9592bbddf786be94$var$id, c), $9592bbddf786be94$var$Sc(a, d);
        else if ($9592bbddf786be94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9592bbddf786be94$var$Sc(a, d), b & 4 && -1 < $9592bbddf786be94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9592bbddf786be94$var$Cb(e);
                null !== f && $9592bbddf786be94$var$Ec(f);
                f = $9592bbddf786be94$var$Yc(a, b, c, d);
                null === f && $9592bbddf786be94$var$hd(a, b, d, $9592bbddf786be94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9592bbddf786be94$var$hd(a, b, d, null, c);
    }
}
var $9592bbddf786be94$var$id = null;
function $9592bbddf786be94$var$Yc(a, b, c, d) {
    $9592bbddf786be94$var$id = null;
    a = $9592bbddf786be94$var$xb(d);
    a = $9592bbddf786be94$var$Wc(a);
    if (null !== a) {
        if (b = $9592bbddf786be94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9592bbddf786be94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9592bbddf786be94$var$id = a;
    return null;
}
function $9592bbddf786be94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9592bbddf786be94$var$ec()){
                case $9592bbddf786be94$var$fc:
                    return 1;
                case $9592bbddf786be94$var$gc:
                    return 4;
                case $9592bbddf786be94$var$hc:
                case $9592bbddf786be94$var$ic:
                    return 16;
                case $9592bbddf786be94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9592bbddf786be94$var$kd = null, $9592bbddf786be94$var$ld = null, $9592bbddf786be94$var$md = null;
function $9592bbddf786be94$var$nd() {
    if ($9592bbddf786be94$var$md) return $9592bbddf786be94$var$md;
    var a, b = $9592bbddf786be94$var$ld, c = b.length, d, e = "value" in $9592bbddf786be94$var$kd ? $9592bbddf786be94$var$kd.value : $9592bbddf786be94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9592bbddf786be94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9592bbddf786be94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9592bbddf786be94$var$pd() {
    return !0;
}
function $9592bbddf786be94$var$qd() {
    return !1;
}
function $9592bbddf786be94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9592bbddf786be94$var$pd : $9592bbddf786be94$var$qd;
        this.isPropagationStopped = $9592bbddf786be94$var$qd;
        return this;
    }
    $9592bbddf786be94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9592bbddf786be94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9592bbddf786be94$var$pd);
        },
        persist: function() {},
        isPersistent: $9592bbddf786be94$var$pd
    });
    return b;
}
var $9592bbddf786be94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9592bbddf786be94$var$td = $9592bbddf786be94$var$rd($9592bbddf786be94$var$sd), $9592bbddf786be94$var$ud = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$sd, {
    view: 0,
    detail: 0
}), $9592bbddf786be94$var$vd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$ud), $9592bbddf786be94$var$wd, $9592bbddf786be94$var$xd, $9592bbddf786be94$var$yd, $9592bbddf786be94$var$Ad = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9592bbddf786be94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9592bbddf786be94$var$yd && ($9592bbddf786be94$var$yd && "mousemove" === a.type ? ($9592bbddf786be94$var$wd = a.screenX - $9592bbddf786be94$var$yd.screenX, $9592bbddf786be94$var$xd = a.screenY - $9592bbddf786be94$var$yd.screenY) : $9592bbddf786be94$var$xd = $9592bbddf786be94$var$wd = 0, $9592bbddf786be94$var$yd = a);
        return $9592bbddf786be94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9592bbddf786be94$var$xd;
    }
}), $9592bbddf786be94$var$Bd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Ad), $9592bbddf786be94$var$Cd = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$Ad, {
    dataTransfer: 0
}), $9592bbddf786be94$var$Dd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Cd), $9592bbddf786be94$var$Ed = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$ud, {
    relatedTarget: 0
}), $9592bbddf786be94$var$Fd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Ed), $9592bbddf786be94$var$Gd = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9592bbddf786be94$var$Hd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Gd), $9592bbddf786be94$var$Id = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9592bbddf786be94$var$Jd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Id), $9592bbddf786be94$var$Kd = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$sd, {
    data: 0
}), $9592bbddf786be94$var$Ld = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Kd), $9592bbddf786be94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9592bbddf786be94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9592bbddf786be94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9592bbddf786be94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9592bbddf786be94$var$Od[a]) ? !!b[a] : !1;
}
function $9592bbddf786be94$var$zd() {
    return $9592bbddf786be94$var$Pd;
}
var $9592bbddf786be94$var$Qd = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9592bbddf786be94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9592bbddf786be94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9592bbddf786be94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9592bbddf786be94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9592bbddf786be94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9592bbddf786be94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9592bbddf786be94$var$Rd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Qd), $9592bbddf786be94$var$Sd = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9592bbddf786be94$var$Td = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Sd), $9592bbddf786be94$var$Ud = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9592bbddf786be94$var$zd
}), $9592bbddf786be94$var$Vd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Ud), $9592bbddf786be94$var$Wd = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9592bbddf786be94$var$Xd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Wd), $9592bbddf786be94$var$Yd = $9592bbddf786be94$var$A({}, $9592bbddf786be94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9592bbddf786be94$var$Zd = $9592bbddf786be94$var$rd($9592bbddf786be94$var$Yd), $9592bbddf786be94$var$$d = [
    9,
    13,
    27,
    32
], $9592bbddf786be94$var$ae = $9592bbddf786be94$var$ia && "CompositionEvent" in window, $9592bbddf786be94$var$be = null;
$9592bbddf786be94$var$ia && "documentMode" in document && ($9592bbddf786be94$var$be = document.documentMode);
var $9592bbddf786be94$var$ce = $9592bbddf786be94$var$ia && "TextEvent" in window && !$9592bbddf786be94$var$be, $9592bbddf786be94$var$de = $9592bbddf786be94$var$ia && (!$9592bbddf786be94$var$ae || $9592bbddf786be94$var$be && 8 < $9592bbddf786be94$var$be && 11 >= $9592bbddf786be94$var$be), $9592bbddf786be94$var$ee = String.fromCharCode(32), $9592bbddf786be94$var$fe = !1;
function $9592bbddf786be94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9592bbddf786be94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9592bbddf786be94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9592bbddf786be94$var$ie = !1;
function $9592bbddf786be94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9592bbddf786be94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9592bbddf786be94$var$fe = !0;
            return $9592bbddf786be94$var$ee;
        case "textInput":
            return a = b.data, a === $9592bbddf786be94$var$ee && $9592bbddf786be94$var$fe ? null : a;
        default:
            return null;
    }
}
function $9592bbddf786be94$var$ke(a, b) {
    if ($9592bbddf786be94$var$ie) return "compositionend" === a || !$9592bbddf786be94$var$ae && $9592bbddf786be94$var$ge(a, b) ? (a = $9592bbddf786be94$var$nd(), $9592bbddf786be94$var$md = $9592bbddf786be94$var$ld = $9592bbddf786be94$var$kd = null, $9592bbddf786be94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9592bbddf786be94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9592bbddf786be94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9592bbddf786be94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9592bbddf786be94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9592bbddf786be94$var$ne(a, b, c, d) {
    $9592bbddf786be94$var$Eb(d);
    b = $9592bbddf786be94$var$oe(b, "onChange");
    0 < b.length && (c = new $9592bbddf786be94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9592bbddf786be94$var$pe = null, $9592bbddf786be94$var$qe = null;
function $9592bbddf786be94$var$re(a) {
    $9592bbddf786be94$var$se(a, 0);
}
function $9592bbddf786be94$var$te(a) {
    var b = $9592bbddf786be94$var$ue(a);
    if ($9592bbddf786be94$var$Wa(b)) return a;
}
function $9592bbddf786be94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9592bbddf786be94$var$we = !1;
if ($9592bbddf786be94$var$ia) {
    var $9592bbddf786be94$var$xe;
    if ($9592bbddf786be94$var$ia) {
        var $9592bbddf786be94$var$ye = "oninput" in document;
        if (!$9592bbddf786be94$var$ye) {
            var $9592bbddf786be94$var$ze = document.createElement("div");
            $9592bbddf786be94$var$ze.setAttribute("oninput", "return;");
            $9592bbddf786be94$var$ye = "function" === typeof $9592bbddf786be94$var$ze.oninput;
        }
        $9592bbddf786be94$var$xe = $9592bbddf786be94$var$ye;
    } else $9592bbddf786be94$var$xe = !1;
    $9592bbddf786be94$var$we = $9592bbddf786be94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9592bbddf786be94$var$Ae() {
    $9592bbddf786be94$var$pe && ($9592bbddf786be94$var$pe.detachEvent("onpropertychange", $9592bbddf786be94$var$Be), $9592bbddf786be94$var$qe = $9592bbddf786be94$var$pe = null);
}
function $9592bbddf786be94$var$Be(a) {
    if ("value" === a.propertyName && $9592bbddf786be94$var$te($9592bbddf786be94$var$qe)) {
        var b = [];
        $9592bbddf786be94$var$ne(b, $9592bbddf786be94$var$qe, a, $9592bbddf786be94$var$xb(a));
        $9592bbddf786be94$var$Jb($9592bbddf786be94$var$re, b);
    }
}
function $9592bbddf786be94$var$Ce(a, b, c) {
    "focusin" === a ? ($9592bbddf786be94$var$Ae(), $9592bbddf786be94$var$pe = b, $9592bbddf786be94$var$qe = c, $9592bbddf786be94$var$pe.attachEvent("onpropertychange", $9592bbddf786be94$var$Be)) : "focusout" === a && $9592bbddf786be94$var$Ae();
}
function $9592bbddf786be94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9592bbddf786be94$var$te($9592bbddf786be94$var$qe);
}
function $9592bbddf786be94$var$Ee(a, b) {
    if ("click" === a) return $9592bbddf786be94$var$te(b);
}
function $9592bbddf786be94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9592bbddf786be94$var$te(b);
}
function $9592bbddf786be94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9592bbddf786be94$var$He = "function" === typeof Object.is ? Object.is : $9592bbddf786be94$var$Ge;
function $9592bbddf786be94$var$Ie(a, b) {
    if ($9592bbddf786be94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9592bbddf786be94$var$ja.call(b, e) || !$9592bbddf786be94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9592bbddf786be94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9592bbddf786be94$var$Ke(a, b) {
    var c = $9592bbddf786be94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9592bbddf786be94$var$Je(c);
    }
}
function $9592bbddf786be94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9592bbddf786be94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9592bbddf786be94$var$Me() {
    for(var a = window, b = $9592bbddf786be94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9592bbddf786be94$var$Xa(a.document);
    }
    return b;
}
function $9592bbddf786be94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9592bbddf786be94$var$Oe(a) {
    var b = $9592bbddf786be94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9592bbddf786be94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9592bbddf786be94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9592bbddf786be94$var$Ke(c, f);
                var g = $9592bbddf786be94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9592bbddf786be94$var$Pe = $9592bbddf786be94$var$ia && "documentMode" in document && 11 >= document.documentMode, $9592bbddf786be94$var$Qe = null, $9592bbddf786be94$var$Re = null, $9592bbddf786be94$var$Se = null, $9592bbddf786be94$var$Te = !1;
function $9592bbddf786be94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9592bbddf786be94$var$Te || null == $9592bbddf786be94$var$Qe || $9592bbddf786be94$var$Qe !== $9592bbddf786be94$var$Xa(d) || (d = $9592bbddf786be94$var$Qe, "selectionStart" in d && $9592bbddf786be94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9592bbddf786be94$var$Se && $9592bbddf786be94$var$Ie($9592bbddf786be94$var$Se, d) || ($9592bbddf786be94$var$Se = d, d = $9592bbddf786be94$var$oe($9592bbddf786be94$var$Re, "onSelect"), 0 < d.length && (b = new $9592bbddf786be94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9592bbddf786be94$var$Qe)));
}
function $9592bbddf786be94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9592bbddf786be94$var$We = {
    animationend: $9592bbddf786be94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9592bbddf786be94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9592bbddf786be94$var$Ve("Animation", "AnimationStart"),
    transitionend: $9592bbddf786be94$var$Ve("Transition", "TransitionEnd")
}, $9592bbddf786be94$var$Xe = {}, $9592bbddf786be94$var$Ye = {};
$9592bbddf786be94$var$ia && ($9592bbddf786be94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9592bbddf786be94$var$We.animationend.animation, delete $9592bbddf786be94$var$We.animationiteration.animation, delete $9592bbddf786be94$var$We.animationstart.animation), "TransitionEvent" in window || delete $9592bbddf786be94$var$We.transitionend.transition);
function $9592bbddf786be94$var$Ze(a) {
    if ($9592bbddf786be94$var$Xe[a]) return $9592bbddf786be94$var$Xe[a];
    if (!$9592bbddf786be94$var$We[a]) return a;
    var b = $9592bbddf786be94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9592bbddf786be94$var$Ye) return $9592bbddf786be94$var$Xe[a] = b[c];
    return a;
}
var $9592bbddf786be94$var$$e = $9592bbddf786be94$var$Ze("animationend"), $9592bbddf786be94$var$af = $9592bbddf786be94$var$Ze("animationiteration"), $9592bbddf786be94$var$bf = $9592bbddf786be94$var$Ze("animationstart"), $9592bbddf786be94$var$cf = $9592bbddf786be94$var$Ze("transitionend"), $9592bbddf786be94$var$df = new Map, $9592bbddf786be94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9592bbddf786be94$var$ff(a, b) {
    $9592bbddf786be94$var$df.set(a, b);
    $9592bbddf786be94$var$fa(b, [
        a
    ]);
}
for(var $9592bbddf786be94$var$gf = 0; $9592bbddf786be94$var$gf < $9592bbddf786be94$var$ef.length; $9592bbddf786be94$var$gf++){
    var $9592bbddf786be94$var$hf = $9592bbddf786be94$var$ef[$9592bbddf786be94$var$gf], $9592bbddf786be94$var$jf = $9592bbddf786be94$var$hf.toLowerCase(), $9592bbddf786be94$var$kf = $9592bbddf786be94$var$hf[0].toUpperCase() + $9592bbddf786be94$var$hf.slice(1);
    $9592bbddf786be94$var$ff($9592bbddf786be94$var$jf, "on" + $9592bbddf786be94$var$kf);
}
$9592bbddf786be94$var$ff($9592bbddf786be94$var$$e, "onAnimationEnd");
$9592bbddf786be94$var$ff($9592bbddf786be94$var$af, "onAnimationIteration");
$9592bbddf786be94$var$ff($9592bbddf786be94$var$bf, "onAnimationStart");
$9592bbddf786be94$var$ff("dblclick", "onDoubleClick");
$9592bbddf786be94$var$ff("focusin", "onFocus");
$9592bbddf786be94$var$ff("focusout", "onBlur");
$9592bbddf786be94$var$ff($9592bbddf786be94$var$cf, "onTransitionEnd");
$9592bbddf786be94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9592bbddf786be94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9592bbddf786be94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9592bbddf786be94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9592bbddf786be94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9592bbddf786be94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9592bbddf786be94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9592bbddf786be94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9592bbddf786be94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9592bbddf786be94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9592bbddf786be94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9592bbddf786be94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9592bbddf786be94$var$lf));
function $9592bbddf786be94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9592bbddf786be94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9592bbddf786be94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9592bbddf786be94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9592bbddf786be94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9592bbddf786be94$var$Qb) throw a = $9592bbddf786be94$var$Rb, $9592bbddf786be94$var$Qb = !1, $9592bbddf786be94$var$Rb = null, a;
}
function $9592bbddf786be94$var$D(a, b) {
    var c = b[$9592bbddf786be94$var$of];
    void 0 === c && (c = b[$9592bbddf786be94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9592bbddf786be94$var$pf(b, a, 2, !1), c.add(d));
}
function $9592bbddf786be94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9592bbddf786be94$var$pf(c, a, d, b);
}
var $9592bbddf786be94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9592bbddf786be94$var$sf(a) {
    if (!a[$9592bbddf786be94$var$rf]) {
        a[$9592bbddf786be94$var$rf] = !0;
        $9592bbddf786be94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9592bbddf786be94$var$mf.has(b) || $9592bbddf786be94$var$qf(b, !1, a), $9592bbddf786be94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9592bbddf786be94$var$rf] || (b[$9592bbddf786be94$var$rf] = !0, $9592bbddf786be94$var$qf("selectionchange", !1, b));
    }
}
function $9592bbddf786be94$var$pf(a, b, c, d) {
    switch($9592bbddf786be94$var$jd(b)){
        case 1:
            var e = $9592bbddf786be94$var$ed;
            break;
        case 4:
            e = $9592bbddf786be94$var$gd;
            break;
        default:
            e = $9592bbddf786be94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9592bbddf786be94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9592bbddf786be94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9592bbddf786be94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9592bbddf786be94$var$Jb(function() {
        var d = f, e = $9592bbddf786be94$var$xb(c), g = [];
        a: {
            var h = $9592bbddf786be94$var$df.get(a);
            if (void 0 !== h) {
                var k = $9592bbddf786be94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9592bbddf786be94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9592bbddf786be94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9592bbddf786be94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9592bbddf786be94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9592bbddf786be94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9592bbddf786be94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9592bbddf786be94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9592bbddf786be94$var$Vd;
                        break;
                    case $9592bbddf786be94$var$$e:
                    case $9592bbddf786be94$var$af:
                    case $9592bbddf786be94$var$bf:
                        k = $9592bbddf786be94$var$Hd;
                        break;
                    case $9592bbddf786be94$var$cf:
                        k = $9592bbddf786be94$var$Xd;
                        break;
                    case "scroll":
                        k = $9592bbddf786be94$var$vd;
                        break;
                    case "wheel":
                        k = $9592bbddf786be94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9592bbddf786be94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9592bbddf786be94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9592bbddf786be94$var$Kb(w, x), null != F && t.push($9592bbddf786be94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9592bbddf786be94$var$wb && (n = c.relatedTarget || c.fromElement) && ($9592bbddf786be94$var$Wc(n) || n[$9592bbddf786be94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9592bbddf786be94$var$Wc(n) : null, null !== n && (J = $9592bbddf786be94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9592bbddf786be94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9592bbddf786be94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9592bbddf786be94$var$ue(k);
                        u = null == n ? h : $9592bbddf786be94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9592bbddf786be94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9592bbddf786be94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9592bbddf786be94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9592bbddf786be94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9592bbddf786be94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9592bbddf786be94$var$vf(t);
                                x = $9592bbddf786be94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9592bbddf786be94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9592bbddf786be94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9592bbddf786be94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9592bbddf786be94$var$ve;
                else if ($9592bbddf786be94$var$me(h)) {
                    if ($9592bbddf786be94$var$we) na = $9592bbddf786be94$var$Fe;
                    else {
                        na = $9592bbddf786be94$var$De;
                        var xa = $9592bbddf786be94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9592bbddf786be94$var$Ee);
                if (na && (na = na(a, d))) {
                    $9592bbddf786be94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9592bbddf786be94$var$cb(h, "number", h.value);
            }
            xa = d ? $9592bbddf786be94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9592bbddf786be94$var$me(xa) || "true" === xa.contentEditable) $9592bbddf786be94$var$Qe = xa, $9592bbddf786be94$var$Re = d, $9592bbddf786be94$var$Se = null;
                    break;
                case "focusout":
                    $9592bbddf786be94$var$Se = $9592bbddf786be94$var$Re = $9592bbddf786be94$var$Qe = null;
                    break;
                case "mousedown":
                    $9592bbddf786be94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9592bbddf786be94$var$Te = !1;
                    $9592bbddf786be94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9592bbddf786be94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9592bbddf786be94$var$Ue(g, c, e);
            }
            var $a;
            if ($9592bbddf786be94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9592bbddf786be94$var$ie ? $9592bbddf786be94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9592bbddf786be94$var$de && "ko" !== c.locale && ($9592bbddf786be94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9592bbddf786be94$var$ie && ($a = $9592bbddf786be94$var$nd()) : ($9592bbddf786be94$var$kd = e, $9592bbddf786be94$var$ld = "value" in $9592bbddf786be94$var$kd ? $9592bbddf786be94$var$kd.value : $9592bbddf786be94$var$kd.textContent, $9592bbddf786be94$var$ie = !0)), xa = $9592bbddf786be94$var$oe(d, ba), 0 < xa.length && (ba = new $9592bbddf786be94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9592bbddf786be94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9592bbddf786be94$var$ce ? $9592bbddf786be94$var$je(a, c) : $9592bbddf786be94$var$ke(a, c)) d = $9592bbddf786be94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9592bbddf786be94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9592bbddf786be94$var$se(g, b);
    });
}
function $9592bbddf786be94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9592bbddf786be94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9592bbddf786be94$var$Kb(a, c), null != f && d.unshift($9592bbddf786be94$var$tf(a, f, e)), f = $9592bbddf786be94$var$Kb(a, b), null != f && d.push($9592bbddf786be94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9592bbddf786be94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9592bbddf786be94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9592bbddf786be94$var$Kb(c, f), null != k && g.unshift($9592bbddf786be94$var$tf(c, k, h))) : e || (k = $9592bbddf786be94$var$Kb(c, f), null != k && g.push($9592bbddf786be94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9592bbddf786be94$var$xf = /\r\n?/g, $9592bbddf786be94$var$yf = /\u0000|\uFFFD/g;
function $9592bbddf786be94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9592bbddf786be94$var$xf, "\n").replace($9592bbddf786be94$var$yf, "");
}
function $9592bbddf786be94$var$Af(a, b, c) {
    b = $9592bbddf786be94$var$zf(b);
    if ($9592bbddf786be94$var$zf(a) !== b && c) throw Error($9592bbddf786be94$var$p(425));
}
function $9592bbddf786be94$var$Bf() {}
var $9592bbddf786be94$var$Cf = null, $9592bbddf786be94$var$Df = null;
function $9592bbddf786be94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9592bbddf786be94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9592bbddf786be94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9592bbddf786be94$var$Hf = "function" === typeof Promise ? Promise : void 0, $9592bbddf786be94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9592bbddf786be94$var$Hf ? function(a) {
    return $9592bbddf786be94$var$Hf.resolve(null).then(a).catch($9592bbddf786be94$var$If);
} : $9592bbddf786be94$var$Ff;
function $9592bbddf786be94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9592bbddf786be94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9592bbddf786be94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9592bbddf786be94$var$bd(b);
}
function $9592bbddf786be94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9592bbddf786be94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9592bbddf786be94$var$Nf = Math.random().toString(36).slice(2), $9592bbddf786be94$var$Of = "__reactFiber$" + $9592bbddf786be94$var$Nf, $9592bbddf786be94$var$Pf = "__reactProps$" + $9592bbddf786be94$var$Nf, $9592bbddf786be94$var$uf = "__reactContainer$" + $9592bbddf786be94$var$Nf, $9592bbddf786be94$var$of = "__reactEvents$" + $9592bbddf786be94$var$Nf, $9592bbddf786be94$var$Qf = "__reactListeners$" + $9592bbddf786be94$var$Nf, $9592bbddf786be94$var$Rf = "__reactHandles$" + $9592bbddf786be94$var$Nf;
function $9592bbddf786be94$var$Wc(a) {
    var b = a[$9592bbddf786be94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9592bbddf786be94$var$uf] || c[$9592bbddf786be94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9592bbddf786be94$var$Mf(a); null !== a;){
                if (c = a[$9592bbddf786be94$var$Of]) return c;
                a = $9592bbddf786be94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9592bbddf786be94$var$Cb(a) {
    a = a[$9592bbddf786be94$var$Of] || a[$9592bbddf786be94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9592bbddf786be94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9592bbddf786be94$var$p(33));
}
function $9592bbddf786be94$var$Db(a) {
    return a[$9592bbddf786be94$var$Pf] || null;
}
var $9592bbddf786be94$var$Sf = [], $9592bbddf786be94$var$Tf = -1;
function $9592bbddf786be94$var$Uf(a) {
    return {
        current: a
    };
}
function $9592bbddf786be94$var$E(a) {
    0 > $9592bbddf786be94$var$Tf || (a.current = $9592bbddf786be94$var$Sf[$9592bbddf786be94$var$Tf], $9592bbddf786be94$var$Sf[$9592bbddf786be94$var$Tf] = null, $9592bbddf786be94$var$Tf--);
}
function $9592bbddf786be94$var$G(a, b) {
    $9592bbddf786be94$var$Tf++;
    $9592bbddf786be94$var$Sf[$9592bbddf786be94$var$Tf] = a.current;
    a.current = b;
}
var $9592bbddf786be94$var$Vf = {}, $9592bbddf786be94$var$H = $9592bbddf786be94$var$Uf($9592bbddf786be94$var$Vf), $9592bbddf786be94$var$Wf = $9592bbddf786be94$var$Uf(!1), $9592bbddf786be94$var$Xf = $9592bbddf786be94$var$Vf;
function $9592bbddf786be94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9592bbddf786be94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9592bbddf786be94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9592bbddf786be94$var$$f() {
    $9592bbddf786be94$var$E($9592bbddf786be94$var$Wf);
    $9592bbddf786be94$var$E($9592bbddf786be94$var$H);
}
function $9592bbddf786be94$var$ag(a, b, c) {
    if ($9592bbddf786be94$var$H.current !== $9592bbddf786be94$var$Vf) throw Error($9592bbddf786be94$var$p(168));
    $9592bbddf786be94$var$G($9592bbddf786be94$var$H, b);
    $9592bbddf786be94$var$G($9592bbddf786be94$var$Wf, c);
}
function $9592bbddf786be94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9592bbddf786be94$var$p(108, $9592bbddf786be94$var$Ra(a) || "Unknown", e));
    return $9592bbddf786be94$var$A({}, c, d);
}
function $9592bbddf786be94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9592bbddf786be94$var$Vf;
    $9592bbddf786be94$var$Xf = $9592bbddf786be94$var$H.current;
    $9592bbddf786be94$var$G($9592bbddf786be94$var$H, a);
    $9592bbddf786be94$var$G($9592bbddf786be94$var$Wf, $9592bbddf786be94$var$Wf.current);
    return !0;
}
function $9592bbddf786be94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9592bbddf786be94$var$p(169));
    c ? (a = $9592bbddf786be94$var$bg(a, b, $9592bbddf786be94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9592bbddf786be94$var$E($9592bbddf786be94$var$Wf), $9592bbddf786be94$var$E($9592bbddf786be94$var$H), $9592bbddf786be94$var$G($9592bbddf786be94$var$H, a)) : $9592bbddf786be94$var$E($9592bbddf786be94$var$Wf);
    $9592bbddf786be94$var$G($9592bbddf786be94$var$Wf, c);
}
var $9592bbddf786be94$var$eg = null, $9592bbddf786be94$var$fg = !1, $9592bbddf786be94$var$gg = !1;
function $9592bbddf786be94$var$hg(a) {
    null === $9592bbddf786be94$var$eg ? $9592bbddf786be94$var$eg = [
        a
    ] : $9592bbddf786be94$var$eg.push(a);
}
function $9592bbddf786be94$var$ig(a) {
    $9592bbddf786be94$var$fg = !0;
    $9592bbddf786be94$var$hg(a);
}
function $9592bbddf786be94$var$jg() {
    if (!$9592bbddf786be94$var$gg && null !== $9592bbddf786be94$var$eg) {
        $9592bbddf786be94$var$gg = !0;
        var a = 0, b = $9592bbddf786be94$var$C;
        try {
            var c = $9592bbddf786be94$var$eg;
            for($9592bbddf786be94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9592bbddf786be94$var$eg = null;
            $9592bbddf786be94$var$fg = !1;
        } catch (e) {
            throw null !== $9592bbddf786be94$var$eg && ($9592bbddf786be94$var$eg = $9592bbddf786be94$var$eg.slice(a + 1)), $9592bbddf786be94$var$ac($9592bbddf786be94$var$fc, $9592bbddf786be94$var$jg), e;
        } finally{
            $9592bbddf786be94$var$C = b, $9592bbddf786be94$var$gg = !1;
        }
    }
    return null;
}
var $9592bbddf786be94$var$kg = [], $9592bbddf786be94$var$lg = 0, $9592bbddf786be94$var$mg = null, $9592bbddf786be94$var$ng = 0, $9592bbddf786be94$var$og = [], $9592bbddf786be94$var$pg = 0, $9592bbddf786be94$var$qg = null, $9592bbddf786be94$var$rg = 1, $9592bbddf786be94$var$sg = "";
function $9592bbddf786be94$var$tg(a, b) {
    $9592bbddf786be94$var$kg[$9592bbddf786be94$var$lg++] = $9592bbddf786be94$var$ng;
    $9592bbddf786be94$var$kg[$9592bbddf786be94$var$lg++] = $9592bbddf786be94$var$mg;
    $9592bbddf786be94$var$mg = a;
    $9592bbddf786be94$var$ng = b;
}
function $9592bbddf786be94$var$ug(a, b, c) {
    $9592bbddf786be94$var$og[$9592bbddf786be94$var$pg++] = $9592bbddf786be94$var$rg;
    $9592bbddf786be94$var$og[$9592bbddf786be94$var$pg++] = $9592bbddf786be94$var$sg;
    $9592bbddf786be94$var$og[$9592bbddf786be94$var$pg++] = $9592bbddf786be94$var$qg;
    $9592bbddf786be94$var$qg = a;
    var d = $9592bbddf786be94$var$rg;
    a = $9592bbddf786be94$var$sg;
    var e = 32 - $9592bbddf786be94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9592bbddf786be94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9592bbddf786be94$var$rg = 1 << 32 - $9592bbddf786be94$var$oc(b) + e | c << e | d;
        $9592bbddf786be94$var$sg = f + a;
    } else $9592bbddf786be94$var$rg = 1 << f | c << e | d, $9592bbddf786be94$var$sg = a;
}
function $9592bbddf786be94$var$vg(a) {
    null !== a.return && ($9592bbddf786be94$var$tg(a, 1), $9592bbddf786be94$var$ug(a, 1, 0));
}
function $9592bbddf786be94$var$wg(a) {
    for(; a === $9592bbddf786be94$var$mg;)$9592bbddf786be94$var$mg = $9592bbddf786be94$var$kg[--$9592bbddf786be94$var$lg], $9592bbddf786be94$var$kg[$9592bbddf786be94$var$lg] = null, $9592bbddf786be94$var$ng = $9592bbddf786be94$var$kg[--$9592bbddf786be94$var$lg], $9592bbddf786be94$var$kg[$9592bbddf786be94$var$lg] = null;
    for(; a === $9592bbddf786be94$var$qg;)$9592bbddf786be94$var$qg = $9592bbddf786be94$var$og[--$9592bbddf786be94$var$pg], $9592bbddf786be94$var$og[$9592bbddf786be94$var$pg] = null, $9592bbddf786be94$var$sg = $9592bbddf786be94$var$og[--$9592bbddf786be94$var$pg], $9592bbddf786be94$var$og[$9592bbddf786be94$var$pg] = null, $9592bbddf786be94$var$rg = $9592bbddf786be94$var$og[--$9592bbddf786be94$var$pg], $9592bbddf786be94$var$og[$9592bbddf786be94$var$pg] = null;
}
var $9592bbddf786be94$var$xg = null, $9592bbddf786be94$var$yg = null, $9592bbddf786be94$var$I = !1, $9592bbddf786be94$var$zg = null;
function $9592bbddf786be94$var$Ag(a, b) {
    var c = $9592bbddf786be94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9592bbddf786be94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9592bbddf786be94$var$xg = a, $9592bbddf786be94$var$yg = $9592bbddf786be94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9592bbddf786be94$var$xg = a, $9592bbddf786be94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9592bbddf786be94$var$qg ? {
                id: $9592bbddf786be94$var$rg,
                overflow: $9592bbddf786be94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9592bbddf786be94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9592bbddf786be94$var$xg = a, $9592bbddf786be94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9592bbddf786be94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9592bbddf786be94$var$Eg(a) {
    if ($9592bbddf786be94$var$I) {
        var b = $9592bbddf786be94$var$yg;
        if (b) {
            var c = b;
            if (!$9592bbddf786be94$var$Cg(a, b)) {
                if ($9592bbddf786be94$var$Dg(a)) throw Error($9592bbddf786be94$var$p(418));
                b = $9592bbddf786be94$var$Lf(c.nextSibling);
                var d = $9592bbddf786be94$var$xg;
                b && $9592bbddf786be94$var$Cg(a, b) ? $9592bbddf786be94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9592bbddf786be94$var$I = !1, $9592bbddf786be94$var$xg = a);
            }
        } else {
            if ($9592bbddf786be94$var$Dg(a)) throw Error($9592bbddf786be94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9592bbddf786be94$var$I = !1;
            $9592bbddf786be94$var$xg = a;
        }
    }
}
function $9592bbddf786be94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9592bbddf786be94$var$xg = a;
}
function $9592bbddf786be94$var$Gg(a) {
    if (a !== $9592bbddf786be94$var$xg) return !1;
    if (!$9592bbddf786be94$var$I) return $9592bbddf786be94$var$Fg(a), $9592bbddf786be94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9592bbddf786be94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9592bbddf786be94$var$yg)) {
        if ($9592bbddf786be94$var$Dg(a)) throw $9592bbddf786be94$var$Hg(), Error($9592bbddf786be94$var$p(418));
        for(; b;)$9592bbddf786be94$var$Ag(a, b), b = $9592bbddf786be94$var$Lf(b.nextSibling);
    }
    $9592bbddf786be94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9592bbddf786be94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9592bbddf786be94$var$yg = $9592bbddf786be94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9592bbddf786be94$var$yg = null;
        }
    } else $9592bbddf786be94$var$yg = $9592bbddf786be94$var$xg ? $9592bbddf786be94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9592bbddf786be94$var$Hg() {
    for(var a = $9592bbddf786be94$var$yg; a;)a = $9592bbddf786be94$var$Lf(a.nextSibling);
}
function $9592bbddf786be94$var$Ig() {
    $9592bbddf786be94$var$yg = $9592bbddf786be94$var$xg = null;
    $9592bbddf786be94$var$I = !1;
}
function $9592bbddf786be94$var$Jg(a) {
    null === $9592bbddf786be94$var$zg ? $9592bbddf786be94$var$zg = [
        a
    ] : $9592bbddf786be94$var$zg.push(a);
}
var $9592bbddf786be94$var$Kg = $9592bbddf786be94$var$ua.ReactCurrentBatchConfig;
function $9592bbddf786be94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $9592bbddf786be94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $9592bbddf786be94$var$Mg = $9592bbddf786be94$var$Uf(null), $9592bbddf786be94$var$Ng = null, $9592bbddf786be94$var$Og = null, $9592bbddf786be94$var$Pg = null;
function $9592bbddf786be94$var$Qg() {
    $9592bbddf786be94$var$Pg = $9592bbddf786be94$var$Og = $9592bbddf786be94$var$Ng = null;
}
function $9592bbddf786be94$var$Rg(a) {
    var b = $9592bbddf786be94$var$Mg.current;
    $9592bbddf786be94$var$E($9592bbddf786be94$var$Mg);
    a._currentValue = b;
}
function $9592bbddf786be94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9592bbddf786be94$var$Tg(a, b) {
    $9592bbddf786be94$var$Ng = a;
    $9592bbddf786be94$var$Pg = $9592bbddf786be94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9592bbddf786be94$var$Ug = !0), a.firstContext = null);
}
function $9592bbddf786be94$var$Vg(a) {
    var b = a._currentValue;
    if ($9592bbddf786be94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9592bbddf786be94$var$Og) {
            if (null === $9592bbddf786be94$var$Ng) throw Error($9592bbddf786be94$var$p(308));
            $9592bbddf786be94$var$Og = a;
            $9592bbddf786be94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9592bbddf786be94$var$Og = $9592bbddf786be94$var$Og.next = a;
    }
    return b;
}
var $9592bbddf786be94$var$Wg = null;
function $9592bbddf786be94$var$Xg(a) {
    null === $9592bbddf786be94$var$Wg ? $9592bbddf786be94$var$Wg = [
        a
    ] : $9592bbddf786be94$var$Wg.push(a);
}
function $9592bbddf786be94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9592bbddf786be94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9592bbddf786be94$var$Zg(a, d);
}
function $9592bbddf786be94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9592bbddf786be94$var$$g = !1;
function $9592bbddf786be94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9592bbddf786be94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9592bbddf786be94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9592bbddf786be94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9592bbddf786be94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9592bbddf786be94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9592bbddf786be94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9592bbddf786be94$var$Zg(a, c);
}
function $9592bbddf786be94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9592bbddf786be94$var$Cc(a, c);
    }
}
function $9592bbddf786be94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9592bbddf786be94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $9592bbddf786be94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9592bbddf786be94$var$A({}, q, r);
                            break a;
                        case 2:
                            $9592bbddf786be94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9592bbddf786be94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9592bbddf786be94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9592bbddf786be94$var$p(191, e));
            e.call(d);
        }
    }
}
var $9592bbddf786be94$var$jh = (new $eXaQ2.Component).refs;
function $9592bbddf786be94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9592bbddf786be94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9592bbddf786be94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9592bbddf786be94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9592bbddf786be94$var$L(), e = $9592bbddf786be94$var$lh(a), f = $9592bbddf786be94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9592bbddf786be94$var$dh(a, f, e);
        null !== b && ($9592bbddf786be94$var$mh(b, a, e, d), $9592bbddf786be94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9592bbddf786be94$var$L(), e = $9592bbddf786be94$var$lh(a), f = $9592bbddf786be94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9592bbddf786be94$var$dh(a, f, e);
        null !== b && ($9592bbddf786be94$var$mh(b, a, e, d), $9592bbddf786be94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9592bbddf786be94$var$L(), d = $9592bbddf786be94$var$lh(a), e = $9592bbddf786be94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9592bbddf786be94$var$dh(a, e, d);
        null !== b && ($9592bbddf786be94$var$mh(b, a, d, c), $9592bbddf786be94$var$eh(b, a, d));
    }
};
function $9592bbddf786be94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9592bbddf786be94$var$Ie(c, d) || !$9592bbddf786be94$var$Ie(e, f) : !0;
}
function $9592bbddf786be94$var$ph(a, b, c) {
    var d = !1, e = $9592bbddf786be94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9592bbddf786be94$var$Vg(f) : (e = $9592bbddf786be94$var$Zf(b) ? $9592bbddf786be94$var$Xf : $9592bbddf786be94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9592bbddf786be94$var$Yf(a, e) : $9592bbddf786be94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9592bbddf786be94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9592bbddf786be94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9592bbddf786be94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $9592bbddf786be94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $9592bbddf786be94$var$jh;
    $9592bbddf786be94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9592bbddf786be94$var$Vg(f) : (f = $9592bbddf786be94$var$Zf(b) ? $9592bbddf786be94$var$Xf : $9592bbddf786be94$var$H.current, e.context = $9592bbddf786be94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9592bbddf786be94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9592bbddf786be94$var$nh.enqueueReplaceState(e, e.state, null), $9592bbddf786be94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9592bbddf786be94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9592bbddf786be94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9592bbddf786be94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $9592bbddf786be94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9592bbddf786be94$var$p(284));
        if (!c._owner) throw Error($9592bbddf786be94$var$p(290, a));
    }
    return a;
}
function $9592bbddf786be94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9592bbddf786be94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9592bbddf786be94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $9592bbddf786be94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9592bbddf786be94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9592bbddf786be94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9592bbddf786be94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9592bbddf786be94$var$Ha && $9592bbddf786be94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $9592bbddf786be94$var$sh(a, b, c), d.return = a, d;
        d = $9592bbddf786be94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9592bbddf786be94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9592bbddf786be94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9592bbddf786be94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9592bbddf786be94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9592bbddf786be94$var$va:
                    return c = $9592bbddf786be94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $9592bbddf786be94$var$sh(a, null, b), c.return = a, c;
                case $9592bbddf786be94$var$wa:
                    return b = $9592bbddf786be94$var$zh(b, a.mode, c), b.return = a, b;
                case $9592bbddf786be94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9592bbddf786be94$var$eb(b) || $9592bbddf786be94$var$Ka(b)) return b = $9592bbddf786be94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $9592bbddf786be94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9592bbddf786be94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9592bbddf786be94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9592bbddf786be94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9592bbddf786be94$var$eb(c) || $9592bbddf786be94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9592bbddf786be94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9592bbddf786be94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9592bbddf786be94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9592bbddf786be94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9592bbddf786be94$var$eb(d) || $9592bbddf786be94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9592bbddf786be94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9592bbddf786be94$var$I && $9592bbddf786be94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9592bbddf786be94$var$I && $9592bbddf786be94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9592bbddf786be94$var$I && $9592bbddf786be94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9592bbddf786be94$var$Ka(h);
        if ("function" !== typeof l) throw Error($9592bbddf786be94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9592bbddf786be94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9592bbddf786be94$var$I && $9592bbddf786be94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9592bbddf786be94$var$I && $9592bbddf786be94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9592bbddf786be94$var$I && $9592bbddf786be94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9592bbddf786be94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9592bbddf786be94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9592bbddf786be94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9592bbddf786be94$var$Ha && $9592bbddf786be94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9592bbddf786be94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9592bbddf786be94$var$ya ? (d = $9592bbddf786be94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9592bbddf786be94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $9592bbddf786be94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9592bbddf786be94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9592bbddf786be94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9592bbddf786be94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9592bbddf786be94$var$eb(f)) return n(a, d, f, h);
            if ($9592bbddf786be94$var$Ka(f)) return t(a, d, f, h);
            $9592bbddf786be94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9592bbddf786be94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9592bbddf786be94$var$Bh = $9592bbddf786be94$var$vh(!0), $9592bbddf786be94$var$Ch = $9592bbddf786be94$var$vh(!1), $9592bbddf786be94$var$Dh = {}, $9592bbddf786be94$var$Eh = $9592bbddf786be94$var$Uf($9592bbddf786be94$var$Dh), $9592bbddf786be94$var$Fh = $9592bbddf786be94$var$Uf($9592bbddf786be94$var$Dh), $9592bbddf786be94$var$Gh = $9592bbddf786be94$var$Uf($9592bbddf786be94$var$Dh);
function $9592bbddf786be94$var$Hh(a) {
    if (a === $9592bbddf786be94$var$Dh) throw Error($9592bbddf786be94$var$p(174));
    return a;
}
function $9592bbddf786be94$var$Ih(a, b) {
    $9592bbddf786be94$var$G($9592bbddf786be94$var$Gh, b);
    $9592bbddf786be94$var$G($9592bbddf786be94$var$Fh, a);
    $9592bbddf786be94$var$G($9592bbddf786be94$var$Eh, $9592bbddf786be94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9592bbddf786be94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9592bbddf786be94$var$lb(b, a);
    }
    $9592bbddf786be94$var$E($9592bbddf786be94$var$Eh);
    $9592bbddf786be94$var$G($9592bbddf786be94$var$Eh, b);
}
function $9592bbddf786be94$var$Jh() {
    $9592bbddf786be94$var$E($9592bbddf786be94$var$Eh);
    $9592bbddf786be94$var$E($9592bbddf786be94$var$Fh);
    $9592bbddf786be94$var$E($9592bbddf786be94$var$Gh);
}
function $9592bbddf786be94$var$Kh(a) {
    $9592bbddf786be94$var$Hh($9592bbddf786be94$var$Gh.current);
    var b = $9592bbddf786be94$var$Hh($9592bbddf786be94$var$Eh.current);
    var c = $9592bbddf786be94$var$lb(b, a.type);
    b !== c && ($9592bbddf786be94$var$G($9592bbddf786be94$var$Fh, a), $9592bbddf786be94$var$G($9592bbddf786be94$var$Eh, c));
}
function $9592bbddf786be94$var$Lh(a) {
    $9592bbddf786be94$var$Fh.current === a && ($9592bbddf786be94$var$E($9592bbddf786be94$var$Eh), $9592bbddf786be94$var$E($9592bbddf786be94$var$Fh));
}
var $9592bbddf786be94$var$M = $9592bbddf786be94$var$Uf(0);
function $9592bbddf786be94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9592bbddf786be94$var$Nh = [];
function $9592bbddf786be94$var$Oh() {
    for(var a = 0; a < $9592bbddf786be94$var$Nh.length; a++)$9592bbddf786be94$var$Nh[a]._workInProgressVersionPrimary = null;
    $9592bbddf786be94$var$Nh.length = 0;
}
var $9592bbddf786be94$var$Ph = $9592bbddf786be94$var$ua.ReactCurrentDispatcher, $9592bbddf786be94$var$Qh = $9592bbddf786be94$var$ua.ReactCurrentBatchConfig, $9592bbddf786be94$var$Rh = 0, $9592bbddf786be94$var$N = null, $9592bbddf786be94$var$O = null, $9592bbddf786be94$var$P = null, $9592bbddf786be94$var$Sh = !1, $9592bbddf786be94$var$Th = !1, $9592bbddf786be94$var$Uh = 0, $9592bbddf786be94$var$Vh = 0;
function $9592bbddf786be94$var$Q() {
    throw Error($9592bbddf786be94$var$p(321));
}
function $9592bbddf786be94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9592bbddf786be94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9592bbddf786be94$var$Xh(a, b, c, d, e, f) {
    $9592bbddf786be94$var$Rh = f;
    $9592bbddf786be94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9592bbddf786be94$var$Ph.current = null === a || null === a.memoizedState ? $9592bbddf786be94$var$Yh : $9592bbddf786be94$var$Zh;
    a = c(d, e);
    if ($9592bbddf786be94$var$Th) {
        f = 0;
        do {
            $9592bbddf786be94$var$Th = !1;
            $9592bbddf786be94$var$Uh = 0;
            if (25 <= f) throw Error($9592bbddf786be94$var$p(301));
            f += 1;
            $9592bbddf786be94$var$P = $9592bbddf786be94$var$O = null;
            b.updateQueue = null;
            $9592bbddf786be94$var$Ph.current = $9592bbddf786be94$var$$h;
            a = c(d, e);
        }while ($9592bbddf786be94$var$Th);
    }
    $9592bbddf786be94$var$Ph.current = $9592bbddf786be94$var$ai;
    b = null !== $9592bbddf786be94$var$O && null !== $9592bbddf786be94$var$O.next;
    $9592bbddf786be94$var$Rh = 0;
    $9592bbddf786be94$var$P = $9592bbddf786be94$var$O = $9592bbddf786be94$var$N = null;
    $9592bbddf786be94$var$Sh = !1;
    if (b) throw Error($9592bbddf786be94$var$p(300));
    return a;
}
function $9592bbddf786be94$var$bi() {
    var a = 0 !== $9592bbddf786be94$var$Uh;
    $9592bbddf786be94$var$Uh = 0;
    return a;
}
function $9592bbddf786be94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9592bbddf786be94$var$P ? $9592bbddf786be94$var$N.memoizedState = $9592bbddf786be94$var$P = a : $9592bbddf786be94$var$P = $9592bbddf786be94$var$P.next = a;
    return $9592bbddf786be94$var$P;
}
function $9592bbddf786be94$var$di() {
    if (null === $9592bbddf786be94$var$O) {
        var a = $9592bbddf786be94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9592bbddf786be94$var$O.next;
    var b = null === $9592bbddf786be94$var$P ? $9592bbddf786be94$var$N.memoizedState : $9592bbddf786be94$var$P.next;
    if (null !== b) $9592bbddf786be94$var$P = b, $9592bbddf786be94$var$O = a;
    else {
        if (null === a) throw Error($9592bbddf786be94$var$p(310));
        $9592bbddf786be94$var$O = a;
        a = {
            memoizedState: $9592bbddf786be94$var$O.memoizedState,
            baseState: $9592bbddf786be94$var$O.baseState,
            baseQueue: $9592bbddf786be94$var$O.baseQueue,
            queue: $9592bbddf786be94$var$O.queue,
            next: null
        };
        null === $9592bbddf786be94$var$P ? $9592bbddf786be94$var$N.memoizedState = $9592bbddf786be94$var$P = a : $9592bbddf786be94$var$P = $9592bbddf786be94$var$P.next = a;
    }
    return $9592bbddf786be94$var$P;
}
function $9592bbddf786be94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9592bbddf786be94$var$fi(a) {
    var b = $9592bbddf786be94$var$di(), c = b.queue;
    if (null === c) throw Error($9592bbddf786be94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9592bbddf786be94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9592bbddf786be94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9592bbddf786be94$var$N.lanes |= m;
                $9592bbddf786be94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9592bbddf786be94$var$He(d, b.memoizedState) || ($9592bbddf786be94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9592bbddf786be94$var$N.lanes |= f, $9592bbddf786be94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9592bbddf786be94$var$gi(a) {
    var b = $9592bbddf786be94$var$di(), c = b.queue;
    if (null === c) throw Error($9592bbddf786be94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9592bbddf786be94$var$He(f, b.memoizedState) || ($9592bbddf786be94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9592bbddf786be94$var$hi() {}
function $9592bbddf786be94$var$ii(a, b) {
    var c = $9592bbddf786be94$var$N, d = $9592bbddf786be94$var$di(), e = b(), f = !$9592bbddf786be94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9592bbddf786be94$var$Ug = !0);
    d = d.queue;
    $9592bbddf786be94$var$ji($9592bbddf786be94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9592bbddf786be94$var$P && $9592bbddf786be94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9592bbddf786be94$var$li(9, $9592bbddf786be94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $9592bbddf786be94$var$R) throw Error($9592bbddf786be94$var$p(349));
        0 !== ($9592bbddf786be94$var$Rh & 30) || $9592bbddf786be94$var$ni(c, b, e);
    }
    return e;
}
function $9592bbddf786be94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9592bbddf786be94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9592bbddf786be94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9592bbddf786be94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9592bbddf786be94$var$oi(b) && $9592bbddf786be94$var$pi(a);
}
function $9592bbddf786be94$var$ki(a, b, c) {
    return c(function() {
        $9592bbddf786be94$var$oi(b) && $9592bbddf786be94$var$pi(a);
    });
}
function $9592bbddf786be94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9592bbddf786be94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9592bbddf786be94$var$pi(a) {
    var b = $9592bbddf786be94$var$Zg(a, 1);
    null !== b && $9592bbddf786be94$var$mh(b, a, 1, -1);
}
function $9592bbddf786be94$var$qi(a) {
    var b = $9592bbddf786be94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9592bbddf786be94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9592bbddf786be94$var$ri.bind(null, $9592bbddf786be94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9592bbddf786be94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9592bbddf786be94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9592bbddf786be94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9592bbddf786be94$var$si() {
    return $9592bbddf786be94$var$di().memoizedState;
}
function $9592bbddf786be94$var$ti(a, b, c, d) {
    var e = $9592bbddf786be94$var$ci();
    $9592bbddf786be94$var$N.flags |= a;
    e.memoizedState = $9592bbddf786be94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9592bbddf786be94$var$ui(a, b, c, d) {
    var e = $9592bbddf786be94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9592bbddf786be94$var$O) {
        var g = $9592bbddf786be94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $9592bbddf786be94$var$Wh(d, g.deps)) {
            e.memoizedState = $9592bbddf786be94$var$li(b, c, f, d);
            return;
        }
    }
    $9592bbddf786be94$var$N.flags |= a;
    e.memoizedState = $9592bbddf786be94$var$li(1 | b, c, f, d);
}
function $9592bbddf786be94$var$vi(a, b) {
    return $9592bbddf786be94$var$ti(8390656, 8, a, b);
}
function $9592bbddf786be94$var$ji(a, b) {
    return $9592bbddf786be94$var$ui(2048, 8, a, b);
}
function $9592bbddf786be94$var$wi(a, b) {
    return $9592bbddf786be94$var$ui(4, 2, a, b);
}
function $9592bbddf786be94$var$xi(a, b) {
    return $9592bbddf786be94$var$ui(4, 4, a, b);
}
function $9592bbddf786be94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9592bbddf786be94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9592bbddf786be94$var$ui(4, 4, $9592bbddf786be94$var$yi.bind(null, b, a), c);
}
function $9592bbddf786be94$var$Ai() {}
function $9592bbddf786be94$var$Bi(a, b) {
    var c = $9592bbddf786be94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9592bbddf786be94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9592bbddf786be94$var$Ci(a, b) {
    var c = $9592bbddf786be94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9592bbddf786be94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9592bbddf786be94$var$Di(a, b, c) {
    if (0 === ($9592bbddf786be94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $9592bbddf786be94$var$Ug = !0), a.memoizedState = c;
    $9592bbddf786be94$var$He(c, b) || (c = $9592bbddf786be94$var$yc(), $9592bbddf786be94$var$N.lanes |= c, $9592bbddf786be94$var$hh |= c, a.baseState = !0);
    return b;
}
function $9592bbddf786be94$var$Ei(a, b) {
    var c = $9592bbddf786be94$var$C;
    $9592bbddf786be94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9592bbddf786be94$var$Qh.transition;
    $9592bbddf786be94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9592bbddf786be94$var$C = c, $9592bbddf786be94$var$Qh.transition = d;
    }
}
function $9592bbddf786be94$var$Fi() {
    return $9592bbddf786be94$var$di().memoizedState;
}
function $9592bbddf786be94$var$Gi(a, b, c) {
    var d = $9592bbddf786be94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9592bbddf786be94$var$Hi(a)) $9592bbddf786be94$var$Ii(b, c);
    else if (c = $9592bbddf786be94$var$Yg(a, b, c, d), null !== c) {
        var e = $9592bbddf786be94$var$L();
        $9592bbddf786be94$var$mh(c, a, d, e);
        $9592bbddf786be94$var$Ji(c, b, d);
    }
}
function $9592bbddf786be94$var$ri(a, b, c) {
    var d = $9592bbddf786be94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9592bbddf786be94$var$Hi(a)) $9592bbddf786be94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9592bbddf786be94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9592bbddf786be94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9592bbddf786be94$var$Yg(a, b, e, d);
        null !== c && (e = $9592bbddf786be94$var$L(), $9592bbddf786be94$var$mh(c, a, d, e), $9592bbddf786be94$var$Ji(c, b, d));
    }
}
function $9592bbddf786be94$var$Hi(a) {
    var b = a.alternate;
    return a === $9592bbddf786be94$var$N || null !== b && b === $9592bbddf786be94$var$N;
}
function $9592bbddf786be94$var$Ii(a, b) {
    $9592bbddf786be94$var$Th = $9592bbddf786be94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9592bbddf786be94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9592bbddf786be94$var$Cc(a, c);
    }
}
var $9592bbddf786be94$var$ai = {
    readContext: $9592bbddf786be94$var$Vg,
    useCallback: $9592bbddf786be94$var$Q,
    useContext: $9592bbddf786be94$var$Q,
    useEffect: $9592bbddf786be94$var$Q,
    useImperativeHandle: $9592bbddf786be94$var$Q,
    useInsertionEffect: $9592bbddf786be94$var$Q,
    useLayoutEffect: $9592bbddf786be94$var$Q,
    useMemo: $9592bbddf786be94$var$Q,
    useReducer: $9592bbddf786be94$var$Q,
    useRef: $9592bbddf786be94$var$Q,
    useState: $9592bbddf786be94$var$Q,
    useDebugValue: $9592bbddf786be94$var$Q,
    useDeferredValue: $9592bbddf786be94$var$Q,
    useTransition: $9592bbddf786be94$var$Q,
    useMutableSource: $9592bbddf786be94$var$Q,
    useSyncExternalStore: $9592bbddf786be94$var$Q,
    useId: $9592bbddf786be94$var$Q,
    unstable_isNewReconciler: !1
}, $9592bbddf786be94$var$Yh = {
    readContext: $9592bbddf786be94$var$Vg,
    useCallback: function(a, b) {
        $9592bbddf786be94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9592bbddf786be94$var$Vg,
    useEffect: $9592bbddf786be94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9592bbddf786be94$var$ti(4194308, 4, $9592bbddf786be94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9592bbddf786be94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9592bbddf786be94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9592bbddf786be94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9592bbddf786be94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9592bbddf786be94$var$Gi.bind(null, $9592bbddf786be94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9592bbddf786be94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9592bbddf786be94$var$qi,
    useDebugValue: $9592bbddf786be94$var$Ai,
    useDeferredValue: function(a) {
        return $9592bbddf786be94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $9592bbddf786be94$var$qi(!1), b = a[0];
        a = $9592bbddf786be94$var$Ei.bind(null, a[1]);
        $9592bbddf786be94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9592bbddf786be94$var$N, e = $9592bbddf786be94$var$ci();
        if ($9592bbddf786be94$var$I) {
            if (void 0 === c) throw Error($9592bbddf786be94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9592bbddf786be94$var$R) throw Error($9592bbddf786be94$var$p(349));
            0 !== ($9592bbddf786be94$var$Rh & 30) || $9592bbddf786be94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9592bbddf786be94$var$vi($9592bbddf786be94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9592bbddf786be94$var$li(9, $9592bbddf786be94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9592bbddf786be94$var$ci(), b = $9592bbddf786be94$var$R.identifierPrefix;
        if ($9592bbddf786be94$var$I) {
            var c = $9592bbddf786be94$var$sg;
            var d = $9592bbddf786be94$var$rg;
            c = (d & ~(1 << 32 - $9592bbddf786be94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9592bbddf786be94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9592bbddf786be94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9592bbddf786be94$var$Zh = {
    readContext: $9592bbddf786be94$var$Vg,
    useCallback: $9592bbddf786be94$var$Bi,
    useContext: $9592bbddf786be94$var$Vg,
    useEffect: $9592bbddf786be94$var$ji,
    useImperativeHandle: $9592bbddf786be94$var$zi,
    useInsertionEffect: $9592bbddf786be94$var$wi,
    useLayoutEffect: $9592bbddf786be94$var$xi,
    useMemo: $9592bbddf786be94$var$Ci,
    useReducer: $9592bbddf786be94$var$fi,
    useRef: $9592bbddf786be94$var$si,
    useState: function() {
        return $9592bbddf786be94$var$fi($9592bbddf786be94$var$ei);
    },
    useDebugValue: $9592bbddf786be94$var$Ai,
    useDeferredValue: function(a) {
        var b = $9592bbddf786be94$var$di();
        return $9592bbddf786be94$var$Di(b, $9592bbddf786be94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $9592bbddf786be94$var$fi($9592bbddf786be94$var$ei)[0], b = $9592bbddf786be94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9592bbddf786be94$var$hi,
    useSyncExternalStore: $9592bbddf786be94$var$ii,
    useId: $9592bbddf786be94$var$Fi,
    unstable_isNewReconciler: !1
}, $9592bbddf786be94$var$$h = {
    readContext: $9592bbddf786be94$var$Vg,
    useCallback: $9592bbddf786be94$var$Bi,
    useContext: $9592bbddf786be94$var$Vg,
    useEffect: $9592bbddf786be94$var$ji,
    useImperativeHandle: $9592bbddf786be94$var$zi,
    useInsertionEffect: $9592bbddf786be94$var$wi,
    useLayoutEffect: $9592bbddf786be94$var$xi,
    useMemo: $9592bbddf786be94$var$Ci,
    useReducer: $9592bbddf786be94$var$gi,
    useRef: $9592bbddf786be94$var$si,
    useState: function() {
        return $9592bbddf786be94$var$gi($9592bbddf786be94$var$ei);
    },
    useDebugValue: $9592bbddf786be94$var$Ai,
    useDeferredValue: function(a) {
        var b = $9592bbddf786be94$var$di();
        return null === $9592bbddf786be94$var$O ? b.memoizedState = a : $9592bbddf786be94$var$Di(b, $9592bbddf786be94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $9592bbddf786be94$var$gi($9592bbddf786be94$var$ei)[0], b = $9592bbddf786be94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9592bbddf786be94$var$hi,
    useSyncExternalStore: $9592bbddf786be94$var$ii,
    useId: $9592bbddf786be94$var$Fi,
    unstable_isNewReconciler: !1
};
function $9592bbddf786be94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $9592bbddf786be94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9592bbddf786be94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9592bbddf786be94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9592bbddf786be94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $9592bbddf786be94$var$Oi(a, b, c) {
    c = $9592bbddf786be94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9592bbddf786be94$var$Pi || ($9592bbddf786be94$var$Pi = !0, $9592bbddf786be94$var$Qi = d);
        $9592bbddf786be94$var$Mi(a, b);
    };
    return c;
}
function $9592bbddf786be94$var$Ri(a, b, c) {
    c = $9592bbddf786be94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9592bbddf786be94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9592bbddf786be94$var$Mi(a, b);
        "function" !== typeof d && (null === $9592bbddf786be94$var$Si ? $9592bbddf786be94$var$Si = new Set([
            this
        ]) : $9592bbddf786be94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9592bbddf786be94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9592bbddf786be94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9592bbddf786be94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $9592bbddf786be94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9592bbddf786be94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9592bbddf786be94$var$ch(-1, 1), b.tag = 2, $9592bbddf786be94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9592bbddf786be94$var$Xi = $9592bbddf786be94$var$ua.ReactCurrentOwner, $9592bbddf786be94$var$Ug = !1;
function $9592bbddf786be94$var$Yi(a, b, c, d) {
    b.child = null === a ? $9592bbddf786be94$var$Ch(b, null, c, d) : $9592bbddf786be94$var$Bh(b, a.child, c, d);
}
function $9592bbddf786be94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9592bbddf786be94$var$Tg(b, e);
    d = $9592bbddf786be94$var$Xh(a, b, c, d, f, e);
    c = $9592bbddf786be94$var$bi();
    if (null !== a && !$9592bbddf786be94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9592bbddf786be94$var$$i(a, b, e);
    $9592bbddf786be94$var$I && c && $9592bbddf786be94$var$vg(b);
    b.flags |= 1;
    $9592bbddf786be94$var$Yi(a, b, d, e);
    return b.child;
}
function $9592bbddf786be94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9592bbddf786be94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9592bbddf786be94$var$cj(a, b, f, d, e);
        a = $9592bbddf786be94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9592bbddf786be94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9592bbddf786be94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $9592bbddf786be94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9592bbddf786be94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9592bbddf786be94$var$Ie(f, d) && a.ref === b.ref) {
            if ($9592bbddf786be94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9592bbddf786be94$var$Ug = !0);
            else return b.lanes = a.lanes, $9592bbddf786be94$var$$i(a, b, e);
        }
    }
    return $9592bbddf786be94$var$dj(a, b, c, d, e);
}
function $9592bbddf786be94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9592bbddf786be94$var$G($9592bbddf786be94$var$fj, $9592bbddf786be94$var$gj), $9592bbddf786be94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9592bbddf786be94$var$G($9592bbddf786be94$var$fj, $9592bbddf786be94$var$gj), $9592bbddf786be94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9592bbddf786be94$var$G($9592bbddf786be94$var$fj, $9592bbddf786be94$var$gj);
            $9592bbddf786be94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9592bbddf786be94$var$G($9592bbddf786be94$var$fj, $9592bbddf786be94$var$gj), $9592bbddf786be94$var$gj |= d;
    $9592bbddf786be94$var$Yi(a, b, e, c);
    return b.child;
}
function $9592bbddf786be94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9592bbddf786be94$var$dj(a, b, c, d, e) {
    var f = $9592bbddf786be94$var$Zf(c) ? $9592bbddf786be94$var$Xf : $9592bbddf786be94$var$H.current;
    f = $9592bbddf786be94$var$Yf(b, f);
    $9592bbddf786be94$var$Tg(b, e);
    c = $9592bbddf786be94$var$Xh(a, b, c, d, f, e);
    d = $9592bbddf786be94$var$bi();
    if (null !== a && !$9592bbddf786be94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9592bbddf786be94$var$$i(a, b, e);
    $9592bbddf786be94$var$I && d && $9592bbddf786be94$var$vg(b);
    b.flags |= 1;
    $9592bbddf786be94$var$Yi(a, b, c, e);
    return b.child;
}
function $9592bbddf786be94$var$ij(a, b, c, d, e) {
    if ($9592bbddf786be94$var$Zf(c)) {
        var f = !0;
        $9592bbddf786be94$var$cg(b);
    } else f = !1;
    $9592bbddf786be94$var$Tg(b, e);
    if (null === b.stateNode) $9592bbddf786be94$var$jj(a, b), $9592bbddf786be94$var$ph(b, c, d), $9592bbddf786be94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9592bbddf786be94$var$Vg(l) : (l = $9592bbddf786be94$var$Zf(c) ? $9592bbddf786be94$var$Xf : $9592bbddf786be94$var$H.current, l = $9592bbddf786be94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9592bbddf786be94$var$qh(b, g, d, l);
        $9592bbddf786be94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $9592bbddf786be94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9592bbddf786be94$var$Wf.current || $9592bbddf786be94$var$$g ? ("function" === typeof m && ($9592bbddf786be94$var$kh(b, c, m, d), k = b.memoizedState), (h = $9592bbddf786be94$var$$g || $9592bbddf786be94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9592bbddf786be94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9592bbddf786be94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9592bbddf786be94$var$Vg(k) : (k = $9592bbddf786be94$var$Zf(c) ? $9592bbddf786be94$var$Xf : $9592bbddf786be94$var$H.current, k = $9592bbddf786be94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9592bbddf786be94$var$qh(b, g, d, k);
        $9592bbddf786be94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $9592bbddf786be94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9592bbddf786be94$var$Wf.current || $9592bbddf786be94$var$$g ? ("function" === typeof y && ($9592bbddf786be94$var$kh(b, c, y, d), n = b.memoizedState), (l = $9592bbddf786be94$var$$g || $9592bbddf786be94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9592bbddf786be94$var$kj(a, b, c, d, f, e);
}
function $9592bbddf786be94$var$kj(a, b, c, d, e, f) {
    $9592bbddf786be94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9592bbddf786be94$var$dg(b, c, !1), $9592bbddf786be94$var$$i(a, b, f);
    d = b.stateNode;
    $9592bbddf786be94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9592bbddf786be94$var$Bh(b, a.child, null, f), b.child = $9592bbddf786be94$var$Bh(b, null, h, f)) : $9592bbddf786be94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9592bbddf786be94$var$dg(b, c, !0);
    return b.child;
}
function $9592bbddf786be94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9592bbddf786be94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9592bbddf786be94$var$ag(a, b.context, !1);
    $9592bbddf786be94$var$Ih(a, b.containerInfo);
}
function $9592bbddf786be94$var$mj(a, b, c, d, e) {
    $9592bbddf786be94$var$Ig();
    $9592bbddf786be94$var$Jg(e);
    b.flags |= 256;
    $9592bbddf786be94$var$Yi(a, b, c, d);
    return b.child;
}
var $9592bbddf786be94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9592bbddf786be94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9592bbddf786be94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $9592bbddf786be94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9592bbddf786be94$var$G($9592bbddf786be94$var$M, e & 1);
    if (null === a) {
        $9592bbddf786be94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9592bbddf786be94$var$qj(g, d, 0, null), a = $9592bbddf786be94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9592bbddf786be94$var$oj(c), b.memoizedState = $9592bbddf786be94$var$nj, a) : $9592bbddf786be94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9592bbddf786be94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9592bbddf786be94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9592bbddf786be94$var$wh(h, f) : (f = $9592bbddf786be94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9592bbddf786be94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9592bbddf786be94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9592bbddf786be94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9592bbddf786be94$var$rj(a, b) {
    b = $9592bbddf786be94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9592bbddf786be94$var$tj(a, b, c, d) {
    null !== d && $9592bbddf786be94$var$Jg(d);
    $9592bbddf786be94$var$Bh(b, a.child, null, c);
    a = $9592bbddf786be94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9592bbddf786be94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9592bbddf786be94$var$Li(Error($9592bbddf786be94$var$p(422))), $9592bbddf786be94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9592bbddf786be94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9592bbddf786be94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9592bbddf786be94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $9592bbddf786be94$var$oj(g);
        b.memoizedState = $9592bbddf786be94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9592bbddf786be94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9592bbddf786be94$var$p(419));
        d = $9592bbddf786be94$var$Li(f, d, void 0);
        return $9592bbddf786be94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9592bbddf786be94$var$Ug || h) {
        d = $9592bbddf786be94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9592bbddf786be94$var$Zg(a, e), $9592bbddf786be94$var$mh(d, a, e, -1));
        }
        $9592bbddf786be94$var$uj();
        d = $9592bbddf786be94$var$Li(Error($9592bbddf786be94$var$p(421)));
        return $9592bbddf786be94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9592bbddf786be94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9592bbddf786be94$var$yg = $9592bbddf786be94$var$Lf(e.nextSibling);
    $9592bbddf786be94$var$xg = b;
    $9592bbddf786be94$var$I = !0;
    $9592bbddf786be94$var$zg = null;
    null !== a && ($9592bbddf786be94$var$og[$9592bbddf786be94$var$pg++] = $9592bbddf786be94$var$rg, $9592bbddf786be94$var$og[$9592bbddf786be94$var$pg++] = $9592bbddf786be94$var$sg, $9592bbddf786be94$var$og[$9592bbddf786be94$var$pg++] = $9592bbddf786be94$var$qg, $9592bbddf786be94$var$rg = a.id, $9592bbddf786be94$var$sg = a.overflow, $9592bbddf786be94$var$qg = b);
    b = $9592bbddf786be94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9592bbddf786be94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9592bbddf786be94$var$Sg(a.return, b, c);
}
function $9592bbddf786be94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9592bbddf786be94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9592bbddf786be94$var$Yi(a, b, d.children, c);
    d = $9592bbddf786be94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9592bbddf786be94$var$wj(a, c, b);
            else if (19 === a.tag) $9592bbddf786be94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9592bbddf786be94$var$G($9592bbddf786be94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9592bbddf786be94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9592bbddf786be94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9592bbddf786be94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9592bbddf786be94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $9592bbddf786be94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9592bbddf786be94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9592bbddf786be94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9592bbddf786be94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9592bbddf786be94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9592bbddf786be94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9592bbddf786be94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9592bbddf786be94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $9592bbddf786be94$var$lj(b);
            $9592bbddf786be94$var$Ig();
            break;
        case 5:
            $9592bbddf786be94$var$Kh(b);
            break;
        case 1:
            $9592bbddf786be94$var$Zf(b.type) && $9592bbddf786be94$var$cg(b);
            break;
        case 4:
            $9592bbddf786be94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9592bbddf786be94$var$G($9592bbddf786be94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9592bbddf786be94$var$G($9592bbddf786be94$var$M, $9592bbddf786be94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9592bbddf786be94$var$pj(a, b, c);
                $9592bbddf786be94$var$G($9592bbddf786be94$var$M, $9592bbddf786be94$var$M.current & 1);
                a = $9592bbddf786be94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9592bbddf786be94$var$G($9592bbddf786be94$var$M, $9592bbddf786be94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9592bbddf786be94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9592bbddf786be94$var$G($9592bbddf786be94$var$M, $9592bbddf786be94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9592bbddf786be94$var$ej(a, b, c);
    }
    return $9592bbddf786be94$var$$i(a, b, c);
}
var $9592bbddf786be94$var$Aj, $9592bbddf786be94$var$Bj, $9592bbddf786be94$var$Cj, $9592bbddf786be94$var$Dj;
$9592bbddf786be94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9592bbddf786be94$var$Bj = function() {};
$9592bbddf786be94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9592bbddf786be94$var$Hh($9592bbddf786be94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9592bbddf786be94$var$Ya(a, e);
                d = $9592bbddf786be94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9592bbddf786be94$var$A({}, e, {
                    value: void 0
                });
                d = $9592bbddf786be94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9592bbddf786be94$var$gb(a, e);
                d = $9592bbddf786be94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9592bbddf786be94$var$Bf);
        }
        $9592bbddf786be94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9592bbddf786be94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9592bbddf786be94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9592bbddf786be94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9592bbddf786be94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9592bbddf786be94$var$Ej(a, b) {
    if (!$9592bbddf786be94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9592bbddf786be94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9592bbddf786be94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $9592bbddf786be94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9592bbddf786be94$var$S(b), null;
        case 1:
            return $9592bbddf786be94$var$Zf(b.type) && $9592bbddf786be94$var$$f(), $9592bbddf786be94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9592bbddf786be94$var$Jh();
            $9592bbddf786be94$var$E($9592bbddf786be94$var$Wf);
            $9592bbddf786be94$var$E($9592bbddf786be94$var$H);
            $9592bbddf786be94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9592bbddf786be94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9592bbddf786be94$var$zg && ($9592bbddf786be94$var$Gj($9592bbddf786be94$var$zg), $9592bbddf786be94$var$zg = null));
            $9592bbddf786be94$var$Bj(a, b);
            $9592bbddf786be94$var$S(b);
            return null;
        case 5:
            $9592bbddf786be94$var$Lh(b);
            var e = $9592bbddf786be94$var$Hh($9592bbddf786be94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9592bbddf786be94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9592bbddf786be94$var$p(166));
                    $9592bbddf786be94$var$S(b);
                    return null;
                }
                a = $9592bbddf786be94$var$Hh($9592bbddf786be94$var$Eh.current);
                if ($9592bbddf786be94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9592bbddf786be94$var$Of] = b;
                    d[$9592bbddf786be94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9592bbddf786be94$var$D("cancel", d);
                            $9592bbddf786be94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9592bbddf786be94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9592bbddf786be94$var$lf.length; e++)$9592bbddf786be94$var$D($9592bbddf786be94$var$lf[e], d);
                            break;
                        case "source":
                            $9592bbddf786be94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9592bbddf786be94$var$D("error", d);
                            $9592bbddf786be94$var$D("load", d);
                            break;
                        case "details":
                            $9592bbddf786be94$var$D("toggle", d);
                            break;
                        case "input":
                            $9592bbddf786be94$var$Za(d, f);
                            $9592bbddf786be94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9592bbddf786be94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9592bbddf786be94$var$hb(d, f), $9592bbddf786be94$var$D("invalid", d);
                    }
                    $9592bbddf786be94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9592bbddf786be94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9592bbddf786be94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9592bbddf786be94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9592bbddf786be94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9592bbddf786be94$var$Va(d);
                            $9592bbddf786be94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9592bbddf786be94$var$Va(d);
                            $9592bbddf786be94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9592bbddf786be94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9592bbddf786be94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9592bbddf786be94$var$Of] = b;
                    a[$9592bbddf786be94$var$Pf] = d;
                    $9592bbddf786be94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9592bbddf786be94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9592bbddf786be94$var$D("cancel", a);
                                $9592bbddf786be94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9592bbddf786be94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9592bbddf786be94$var$lf.length; e++)$9592bbddf786be94$var$D($9592bbddf786be94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9592bbddf786be94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9592bbddf786be94$var$D("error", a);
                                $9592bbddf786be94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9592bbddf786be94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9592bbddf786be94$var$Za(a, d);
                                e = $9592bbddf786be94$var$Ya(a, d);
                                $9592bbddf786be94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9592bbddf786be94$var$A({}, d, {
                                    value: void 0
                                });
                                $9592bbddf786be94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9592bbddf786be94$var$hb(a, d);
                                e = $9592bbddf786be94$var$gb(a, d);
                                $9592bbddf786be94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9592bbddf786be94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9592bbddf786be94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9592bbddf786be94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9592bbddf786be94$var$ob(a, k) : "number" === typeof k && $9592bbddf786be94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9592bbddf786be94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9592bbddf786be94$var$D("scroll", a) : null != k && $9592bbddf786be94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9592bbddf786be94$var$Va(a);
                                $9592bbddf786be94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9592bbddf786be94$var$Va(a);
                                $9592bbddf786be94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9592bbddf786be94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9592bbddf786be94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9592bbddf786be94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9592bbddf786be94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9592bbddf786be94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9592bbddf786be94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9592bbddf786be94$var$p(166));
                c = $9592bbddf786be94$var$Hh($9592bbddf786be94$var$Gh.current);
                $9592bbddf786be94$var$Hh($9592bbddf786be94$var$Eh.current);
                if ($9592bbddf786be94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9592bbddf786be94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9592bbddf786be94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9592bbddf786be94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9592bbddf786be94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9592bbddf786be94$var$Of] = b, b.stateNode = d;
            }
            $9592bbddf786be94$var$S(b);
            return null;
        case 13:
            $9592bbddf786be94$var$E($9592bbddf786be94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9592bbddf786be94$var$I && null !== $9592bbddf786be94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9592bbddf786be94$var$Hg(), $9592bbddf786be94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9592bbddf786be94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9592bbddf786be94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9592bbddf786be94$var$p(317));
                        f[$9592bbddf786be94$var$Of] = b;
                    } else $9592bbddf786be94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9592bbddf786be94$var$S(b);
                    f = !1;
                } else null !== $9592bbddf786be94$var$zg && ($9592bbddf786be94$var$Gj($9592bbddf786be94$var$zg), $9592bbddf786be94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9592bbddf786be94$var$M.current & 1) ? 0 === $9592bbddf786be94$var$T && ($9592bbddf786be94$var$T = 3) : $9592bbddf786be94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9592bbddf786be94$var$S(b);
            return null;
        case 4:
            return $9592bbddf786be94$var$Jh(), $9592bbddf786be94$var$Bj(a, b), null === a && $9592bbddf786be94$var$sf(b.stateNode.containerInfo), $9592bbddf786be94$var$S(b), null;
        case 10:
            return $9592bbddf786be94$var$Rg(b.type._context), $9592bbddf786be94$var$S(b), null;
        case 17:
            return $9592bbddf786be94$var$Zf(b.type) && $9592bbddf786be94$var$$f(), $9592bbddf786be94$var$S(b), null;
        case 19:
            $9592bbddf786be94$var$E($9592bbddf786be94$var$M);
            f = b.memoizedState;
            if (null === f) return $9592bbddf786be94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9592bbddf786be94$var$Ej(f, !1);
                else {
                    if (0 !== $9592bbddf786be94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9592bbddf786be94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9592bbddf786be94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9592bbddf786be94$var$G($9592bbddf786be94$var$M, $9592bbddf786be94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9592bbddf786be94$var$B() > $9592bbddf786be94$var$Hj && (b.flags |= 128, d = !0, $9592bbddf786be94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9592bbddf786be94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9592bbddf786be94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9592bbddf786be94$var$I) return $9592bbddf786be94$var$S(b), null;
                    } else 2 * $9592bbddf786be94$var$B() - f.renderingStartTime > $9592bbddf786be94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $9592bbddf786be94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9592bbddf786be94$var$B(), b.sibling = null, c = $9592bbddf786be94$var$M.current, $9592bbddf786be94$var$G($9592bbddf786be94$var$M, d ? c & 1 | 2 : c & 1), b;
            $9592bbddf786be94$var$S(b);
            return null;
        case 22:
        case 23:
            return $9592bbddf786be94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9592bbddf786be94$var$gj & 1073741824) && ($9592bbddf786be94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9592bbddf786be94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9592bbddf786be94$var$p(156, b.tag));
}
function $9592bbddf786be94$var$Jj(a, b) {
    $9592bbddf786be94$var$wg(b);
    switch(b.tag){
        case 1:
            return $9592bbddf786be94$var$Zf(b.type) && $9592bbddf786be94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9592bbddf786be94$var$Jh(), $9592bbddf786be94$var$E($9592bbddf786be94$var$Wf), $9592bbddf786be94$var$E($9592bbddf786be94$var$H), $9592bbddf786be94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9592bbddf786be94$var$Lh(b), null;
        case 13:
            $9592bbddf786be94$var$E($9592bbddf786be94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9592bbddf786be94$var$p(340));
                $9592bbddf786be94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9592bbddf786be94$var$E($9592bbddf786be94$var$M), null;
        case 4:
            return $9592bbddf786be94$var$Jh(), null;
        case 10:
            return $9592bbddf786be94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $9592bbddf786be94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9592bbddf786be94$var$Kj = !1, $9592bbddf786be94$var$U = !1, $9592bbddf786be94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $9592bbddf786be94$var$V = null;
function $9592bbddf786be94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9592bbddf786be94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9592bbddf786be94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9592bbddf786be94$var$W(a, b, d);
    }
}
var $9592bbddf786be94$var$Oj = !1;
function $9592bbddf786be94$var$Pj(a, b) {
    $9592bbddf786be94$var$Cf = $9592bbddf786be94$var$dd;
    a = $9592bbddf786be94$var$Me();
    if ($9592bbddf786be94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9592bbddf786be94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9592bbddf786be94$var$dd = !1;
    for($9592bbddf786be94$var$V = b; null !== $9592bbddf786be94$var$V;)if (b = $9592bbddf786be94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9592bbddf786be94$var$V = a;
    else for(; null !== $9592bbddf786be94$var$V;){
        b = $9592bbddf786be94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9592bbddf786be94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9592bbddf786be94$var$p(163));
            }
        } catch (F) {
            $9592bbddf786be94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9592bbddf786be94$var$V = a;
            break;
        }
        $9592bbddf786be94$var$V = b.return;
    }
    n = $9592bbddf786be94$var$Oj;
    $9592bbddf786be94$var$Oj = !1;
    return n;
}
function $9592bbddf786be94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9592bbddf786be94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9592bbddf786be94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9592bbddf786be94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9592bbddf786be94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9592bbddf786be94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9592bbddf786be94$var$Of], delete b[$9592bbddf786be94$var$Pf], delete b[$9592bbddf786be94$var$of], delete b[$9592bbddf786be94$var$Qf], delete b[$9592bbddf786be94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9592bbddf786be94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9592bbddf786be94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9592bbddf786be94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9592bbddf786be94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9592bbddf786be94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9592bbddf786be94$var$Wj(a, b, c), a = a.sibling; null !== a;)$9592bbddf786be94$var$Wj(a, b, c), a = a.sibling;
}
function $9592bbddf786be94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9592bbddf786be94$var$Xj(a, b, c), a = a.sibling; null !== a;)$9592bbddf786be94$var$Xj(a, b, c), a = a.sibling;
}
var $9592bbddf786be94$var$X = null, $9592bbddf786be94$var$Yj = !1;
function $9592bbddf786be94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$9592bbddf786be94$var$ak(a, b, c), c = c.sibling;
}
function $9592bbddf786be94$var$ak(a, b, c) {
    if ($9592bbddf786be94$var$lc && "function" === typeof $9592bbddf786be94$var$lc.onCommitFiberUnmount) try {
        $9592bbddf786be94$var$lc.onCommitFiberUnmount($9592bbddf786be94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9592bbddf786be94$var$U || $9592bbddf786be94$var$Mj(c, b);
        case 6:
            var d = $9592bbddf786be94$var$X, e = $9592bbddf786be94$var$Yj;
            $9592bbddf786be94$var$X = null;
            $9592bbddf786be94$var$Zj(a, b, c);
            $9592bbddf786be94$var$X = d;
            $9592bbddf786be94$var$Yj = e;
            null !== $9592bbddf786be94$var$X && ($9592bbddf786be94$var$Yj ? (a = $9592bbddf786be94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9592bbddf786be94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9592bbddf786be94$var$X && ($9592bbddf786be94$var$Yj ? (a = $9592bbddf786be94$var$X, c = c.stateNode, 8 === a.nodeType ? $9592bbddf786be94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9592bbddf786be94$var$Kf(a, c), $9592bbddf786be94$var$bd(a)) : $9592bbddf786be94$var$Kf($9592bbddf786be94$var$X, c.stateNode));
            break;
        case 4:
            d = $9592bbddf786be94$var$X;
            e = $9592bbddf786be94$var$Yj;
            $9592bbddf786be94$var$X = c.stateNode.containerInfo;
            $9592bbddf786be94$var$Yj = !0;
            $9592bbddf786be94$var$Zj(a, b, c);
            $9592bbddf786be94$var$X = d;
            $9592bbddf786be94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9592bbddf786be94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9592bbddf786be94$var$Nj(c, b, g) : 0 !== (f & 4) && $9592bbddf786be94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9592bbddf786be94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$9592bbddf786be94$var$U && ($9592bbddf786be94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9592bbddf786be94$var$W(c, b, h);
            }
            $9592bbddf786be94$var$Zj(a, b, c);
            break;
        case 21:
            $9592bbddf786be94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9592bbddf786be94$var$U = (d = $9592bbddf786be94$var$U) || null !== c.memoizedState, $9592bbddf786be94$var$Zj(a, b, c), $9592bbddf786be94$var$U = d) : $9592bbddf786be94$var$Zj(a, b, c);
            break;
        default:
            $9592bbddf786be94$var$Zj(a, b, c);
    }
}
function $9592bbddf786be94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9592bbddf786be94$var$Lj);
        b.forEach(function(b) {
            var d = $9592bbddf786be94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9592bbddf786be94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9592bbddf786be94$var$X = h.stateNode;
                        $9592bbddf786be94$var$Yj = !1;
                        break a;
                    case 3:
                        $9592bbddf786be94$var$X = h.stateNode.containerInfo;
                        $9592bbddf786be94$var$Yj = !0;
                        break a;
                    case 4:
                        $9592bbddf786be94$var$X = h.stateNode.containerInfo;
                        $9592bbddf786be94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9592bbddf786be94$var$X) throw Error($9592bbddf786be94$var$p(160));
            $9592bbddf786be94$var$ak(f, g, e);
            $9592bbddf786be94$var$X = null;
            $9592bbddf786be94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9592bbddf786be94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9592bbddf786be94$var$ek(b, a), b = b.sibling;
}
function $9592bbddf786be94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            if (d & 4) {
                try {
                    $9592bbddf786be94$var$Qj(3, a, a.return), $9592bbddf786be94$var$Rj(3, a);
                } catch (t) {
                    $9592bbddf786be94$var$W(a, a.return, t);
                }
                try {
                    $9592bbddf786be94$var$Qj(5, a, a.return);
                } catch (t) {
                    $9592bbddf786be94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            d & 512 && null !== c && $9592bbddf786be94$var$Mj(c, c.return);
            break;
        case 5:
            $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            d & 512 && null !== c && $9592bbddf786be94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9592bbddf786be94$var$ob(e, "");
                } catch (t) {
                    $9592bbddf786be94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9592bbddf786be94$var$ab(e, f);
                    $9592bbddf786be94$var$vb(h, g);
                    var l = $9592bbddf786be94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9592bbddf786be94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9592bbddf786be94$var$nb(e, q) : "children" === m ? $9592bbddf786be94$var$ob(e, q) : $9592bbddf786be94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9592bbddf786be94$var$bb(e, f);
                            break;
                        case "textarea":
                            $9592bbddf786be94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9592bbddf786be94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9592bbddf786be94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9592bbddf786be94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9592bbddf786be94$var$Pf] = f;
                } catch (t) {
                    $9592bbddf786be94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9592bbddf786be94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9592bbddf786be94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9592bbddf786be94$var$bd(b.containerInfo);
            } catch (t) {
                $9592bbddf786be94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            break;
        case 13:
            $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9592bbddf786be94$var$gk = $9592bbddf786be94$var$B()));
            d & 4 && $9592bbddf786be94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9592bbddf786be94$var$U = (l = $9592bbddf786be94$var$U) || m, $9592bbddf786be94$var$dk(b, a), $9592bbddf786be94$var$U = l) : $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9592bbddf786be94$var$V = a, m = a.child; null !== m;){
                    for(q = $9592bbddf786be94$var$V = m; null !== $9592bbddf786be94$var$V;){
                        r = $9592bbddf786be94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9592bbddf786be94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $9592bbddf786be94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9592bbddf786be94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9592bbddf786be94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9592bbddf786be94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9592bbddf786be94$var$V = y) : $9592bbddf786be94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9592bbddf786be94$var$rb("display", g));
                            } catch (t) {
                                $9592bbddf786be94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9592bbddf786be94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9592bbddf786be94$var$dk(b, a);
            $9592bbddf786be94$var$fk(a);
            d & 4 && $9592bbddf786be94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $9592bbddf786be94$var$dk(b, a), $9592bbddf786be94$var$fk(a);
    }
}
function $9592bbddf786be94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9592bbddf786be94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9592bbddf786be94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9592bbddf786be94$var$ob(e, ""), d.flags &= -33);
                    var f = $9592bbddf786be94$var$Vj(a);
                    $9592bbddf786be94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9592bbddf786be94$var$Vj(a);
                    $9592bbddf786be94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($9592bbddf786be94$var$p(161));
            }
        } catch (k) {
            $9592bbddf786be94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9592bbddf786be94$var$ik(a, b, c) {
    $9592bbddf786be94$var$V = a;
    $9592bbddf786be94$var$jk(a, b, c);
}
function $9592bbddf786be94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9592bbddf786be94$var$V;){
        var e = $9592bbddf786be94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9592bbddf786be94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9592bbddf786be94$var$U;
                h = $9592bbddf786be94$var$Kj;
                var l = $9592bbddf786be94$var$U;
                $9592bbddf786be94$var$Kj = g;
                if (($9592bbddf786be94$var$U = k) && !l) for($9592bbddf786be94$var$V = e; null !== $9592bbddf786be94$var$V;)g = $9592bbddf786be94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9592bbddf786be94$var$kk(e) : null !== k ? (k.return = g, $9592bbddf786be94$var$V = k) : $9592bbddf786be94$var$kk(e);
                for(; null !== f;)$9592bbddf786be94$var$V = f, $9592bbddf786be94$var$jk(f, b, c), f = f.sibling;
                $9592bbddf786be94$var$V = e;
                $9592bbddf786be94$var$Kj = h;
                $9592bbddf786be94$var$U = l;
            }
            $9592bbddf786be94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9592bbddf786be94$var$V = f) : $9592bbddf786be94$var$lk(a, b, c);
    }
}
function $9592bbddf786be94$var$lk(a) {
    for(; null !== $9592bbddf786be94$var$V;){
        var b = $9592bbddf786be94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9592bbddf786be94$var$U || $9592bbddf786be94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9592bbddf786be94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9592bbddf786be94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9592bbddf786be94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9592bbddf786be94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9592bbddf786be94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9592bbddf786be94$var$p(163));
                }
                $9592bbddf786be94$var$U || b.flags & 512 && $9592bbddf786be94$var$Sj(b);
            } catch (r) {
                $9592bbddf786be94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9592bbddf786be94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9592bbddf786be94$var$V = c;
            break;
        }
        $9592bbddf786be94$var$V = b.return;
    }
}
function $9592bbddf786be94$var$hk(a) {
    for(; null !== $9592bbddf786be94$var$V;){
        var b = $9592bbddf786be94$var$V;
        if (b === a) {
            $9592bbddf786be94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9592bbddf786be94$var$V = c;
            break;
        }
        $9592bbddf786be94$var$V = b.return;
    }
}
function $9592bbddf786be94$var$kk(a) {
    for(; null !== $9592bbddf786be94$var$V;){
        var b = $9592bbddf786be94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9592bbddf786be94$var$Rj(4, b);
                    } catch (k) {
                        $9592bbddf786be94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9592bbddf786be94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9592bbddf786be94$var$Sj(b);
                    } catch (k) {
                        $9592bbddf786be94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9592bbddf786be94$var$Sj(b);
                    } catch (k) {
                        $9592bbddf786be94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9592bbddf786be94$var$W(b, b.return, k);
        }
        if (b === a) {
            $9592bbddf786be94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9592bbddf786be94$var$V = h;
            break;
        }
        $9592bbddf786be94$var$V = b.return;
    }
}
var $9592bbddf786be94$var$mk = Math.ceil, $9592bbddf786be94$var$nk = $9592bbddf786be94$var$ua.ReactCurrentDispatcher, $9592bbddf786be94$var$ok = $9592bbddf786be94$var$ua.ReactCurrentOwner, $9592bbddf786be94$var$pk = $9592bbddf786be94$var$ua.ReactCurrentBatchConfig, $9592bbddf786be94$var$K = 0, $9592bbddf786be94$var$R = null, $9592bbddf786be94$var$Y = null, $9592bbddf786be94$var$Z = 0, $9592bbddf786be94$var$gj = 0, $9592bbddf786be94$var$fj = $9592bbddf786be94$var$Uf(0), $9592bbddf786be94$var$T = 0, $9592bbddf786be94$var$qk = null, $9592bbddf786be94$var$hh = 0, $9592bbddf786be94$var$rk = 0, $9592bbddf786be94$var$sk = 0, $9592bbddf786be94$var$tk = null, $9592bbddf786be94$var$uk = null, $9592bbddf786be94$var$gk = 0, $9592bbddf786be94$var$Hj = Infinity, $9592bbddf786be94$var$vk = null, $9592bbddf786be94$var$Pi = !1, $9592bbddf786be94$var$Qi = null, $9592bbddf786be94$var$Si = null, $9592bbddf786be94$var$wk = !1, $9592bbddf786be94$var$xk = null, $9592bbddf786be94$var$yk = 0, $9592bbddf786be94$var$zk = 0, $9592bbddf786be94$var$Ak = null, $9592bbddf786be94$var$Bk = -1, $9592bbddf786be94$var$Ck = 0;
function $9592bbddf786be94$var$L() {
    return 0 !== ($9592bbddf786be94$var$K & 6) ? $9592bbddf786be94$var$B() : -1 !== $9592bbddf786be94$var$Bk ? $9592bbddf786be94$var$Bk : $9592bbddf786be94$var$Bk = $9592bbddf786be94$var$B();
}
function $9592bbddf786be94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9592bbddf786be94$var$K & 2) && 0 !== $9592bbddf786be94$var$Z) return $9592bbddf786be94$var$Z & -$9592bbddf786be94$var$Z;
    if (null !== $9592bbddf786be94$var$Kg.transition) return 0 === $9592bbddf786be94$var$Ck && ($9592bbddf786be94$var$Ck = $9592bbddf786be94$var$yc()), $9592bbddf786be94$var$Ck;
    a = $9592bbddf786be94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9592bbddf786be94$var$jd(a.type);
    return a;
}
function $9592bbddf786be94$var$mh(a, b, c, d) {
    if (50 < $9592bbddf786be94$var$zk) throw $9592bbddf786be94$var$zk = 0, $9592bbddf786be94$var$Ak = null, Error($9592bbddf786be94$var$p(185));
    $9592bbddf786be94$var$Ac(a, c, d);
    if (0 === ($9592bbddf786be94$var$K & 2) || a !== $9592bbddf786be94$var$R) a === $9592bbddf786be94$var$R && (0 === ($9592bbddf786be94$var$K & 2) && ($9592bbddf786be94$var$rk |= c), 4 === $9592bbddf786be94$var$T && $9592bbddf786be94$var$Dk(a, $9592bbddf786be94$var$Z)), $9592bbddf786be94$var$Ek(a, d), 1 === c && 0 === $9592bbddf786be94$var$K && 0 === (b.mode & 1) && ($9592bbddf786be94$var$Hj = $9592bbddf786be94$var$B() + 500, $9592bbddf786be94$var$fg && $9592bbddf786be94$var$jg());
}
function $9592bbddf786be94$var$Ek(a, b) {
    var c = a.callbackNode;
    $9592bbddf786be94$var$wc(a, b);
    var d = $9592bbddf786be94$var$uc(a, a === $9592bbddf786be94$var$R ? $9592bbddf786be94$var$Z : 0);
    if (0 === d) null !== c && $9592bbddf786be94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9592bbddf786be94$var$bc(c);
        if (1 === b) 0 === a.tag ? $9592bbddf786be94$var$ig($9592bbddf786be94$var$Fk.bind(null, a)) : $9592bbddf786be94$var$hg($9592bbddf786be94$var$Fk.bind(null, a)), $9592bbddf786be94$var$Jf(function() {
            0 === ($9592bbddf786be94$var$K & 6) && $9592bbddf786be94$var$jg();
        }), c = null;
        else {
            switch($9592bbddf786be94$var$Dc(d)){
                case 1:
                    c = $9592bbddf786be94$var$fc;
                    break;
                case 4:
                    c = $9592bbddf786be94$var$gc;
                    break;
                case 16:
                    c = $9592bbddf786be94$var$hc;
                    break;
                case 536870912:
                    c = $9592bbddf786be94$var$jc;
                    break;
                default:
                    c = $9592bbddf786be94$var$hc;
            }
            c = $9592bbddf786be94$var$Gk(c, $9592bbddf786be94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9592bbddf786be94$var$Hk(a, b) {
    $9592bbddf786be94$var$Bk = -1;
    $9592bbddf786be94$var$Ck = 0;
    if (0 !== ($9592bbddf786be94$var$K & 6)) throw Error($9592bbddf786be94$var$p(327));
    var c = a.callbackNode;
    if ($9592bbddf786be94$var$Ik() && a.callbackNode !== c) return null;
    var d = $9592bbddf786be94$var$uc(a, a === $9592bbddf786be94$var$R ? $9592bbddf786be94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9592bbddf786be94$var$Jk(a, d);
    else {
        b = d;
        var e = $9592bbddf786be94$var$K;
        $9592bbddf786be94$var$K |= 2;
        var f = $9592bbddf786be94$var$Kk();
        if ($9592bbddf786be94$var$R !== a || $9592bbddf786be94$var$Z !== b) $9592bbddf786be94$var$vk = null, $9592bbddf786be94$var$Hj = $9592bbddf786be94$var$B() + 500, $9592bbddf786be94$var$Lk(a, b);
        for(;;)try {
            $9592bbddf786be94$var$Mk();
            break;
        } catch (h) {
            $9592bbddf786be94$var$Nk(a, h);
        }
        $9592bbddf786be94$var$Qg();
        $9592bbddf786be94$var$nk.current = f;
        $9592bbddf786be94$var$K = e;
        null !== $9592bbddf786be94$var$Y ? b = 0 : ($9592bbddf786be94$var$R = null, $9592bbddf786be94$var$Z = 0, b = $9592bbddf786be94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9592bbddf786be94$var$xc(a), 0 !== e && (d = e, b = $9592bbddf786be94$var$Ok(a, e)));
        if (1 === b) throw c = $9592bbddf786be94$var$qk, $9592bbddf786be94$var$Lk(a, 0), $9592bbddf786be94$var$Dk(a, d), $9592bbddf786be94$var$Ek(a, $9592bbddf786be94$var$B()), c;
        if (6 === b) $9592bbddf786be94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9592bbddf786be94$var$Pk(e) && (b = $9592bbddf786be94$var$Jk(a, d), 2 === b && (f = $9592bbddf786be94$var$xc(a), 0 !== f && (d = f, b = $9592bbddf786be94$var$Ok(a, f))), 1 === b)) throw c = $9592bbddf786be94$var$qk, $9592bbddf786be94$var$Lk(a, 0), $9592bbddf786be94$var$Dk(a, d), $9592bbddf786be94$var$Ek(a, $9592bbddf786be94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9592bbddf786be94$var$p(345));
                case 2:
                    $9592bbddf786be94$var$Qk(a, $9592bbddf786be94$var$uk, $9592bbddf786be94$var$vk);
                    break;
                case 3:
                    $9592bbddf786be94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $9592bbddf786be94$var$gk + 500 - $9592bbddf786be94$var$B(), 10 < b)) {
                        if (0 !== $9592bbddf786be94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9592bbddf786be94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9592bbddf786be94$var$Ff($9592bbddf786be94$var$Qk.bind(null, a, $9592bbddf786be94$var$uk, $9592bbddf786be94$var$vk), b);
                        break;
                    }
                    $9592bbddf786be94$var$Qk(a, $9592bbddf786be94$var$uk, $9592bbddf786be94$var$vk);
                    break;
                case 4:
                    $9592bbddf786be94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9592bbddf786be94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9592bbddf786be94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9592bbddf786be94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9592bbddf786be94$var$Ff($9592bbddf786be94$var$Qk.bind(null, a, $9592bbddf786be94$var$uk, $9592bbddf786be94$var$vk), d);
                        break;
                    }
                    $9592bbddf786be94$var$Qk(a, $9592bbddf786be94$var$uk, $9592bbddf786be94$var$vk);
                    break;
                case 5:
                    $9592bbddf786be94$var$Qk(a, $9592bbddf786be94$var$uk, $9592bbddf786be94$var$vk);
                    break;
                default:
                    throw Error($9592bbddf786be94$var$p(329));
            }
        }
    }
    $9592bbddf786be94$var$Ek(a, $9592bbddf786be94$var$B());
    return a.callbackNode === c ? $9592bbddf786be94$var$Hk.bind(null, a) : null;
}
function $9592bbddf786be94$var$Ok(a, b) {
    var c = $9592bbddf786be94$var$tk;
    a.current.memoizedState.isDehydrated && ($9592bbddf786be94$var$Lk(a, b).flags |= 256);
    a = $9592bbddf786be94$var$Jk(a, b);
    2 !== a && (b = $9592bbddf786be94$var$uk, $9592bbddf786be94$var$uk = c, null !== b && $9592bbddf786be94$var$Gj(b));
    return a;
}
function $9592bbddf786be94$var$Gj(a) {
    null === $9592bbddf786be94$var$uk ? $9592bbddf786be94$var$uk = a : $9592bbddf786be94$var$uk.push.apply($9592bbddf786be94$var$uk, a);
}
function $9592bbddf786be94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9592bbddf786be94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9592bbddf786be94$var$Dk(a, b) {
    b &= ~$9592bbddf786be94$var$sk;
    b &= ~$9592bbddf786be94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9592bbddf786be94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9592bbddf786be94$var$Fk(a) {
    if (0 !== ($9592bbddf786be94$var$K & 6)) throw Error($9592bbddf786be94$var$p(327));
    $9592bbddf786be94$var$Ik();
    var b = $9592bbddf786be94$var$uc(a, 0);
    if (0 === (b & 1)) return $9592bbddf786be94$var$Ek(a, $9592bbddf786be94$var$B()), null;
    var c = $9592bbddf786be94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9592bbddf786be94$var$xc(a);
        0 !== d && (b = d, c = $9592bbddf786be94$var$Ok(a, d));
    }
    if (1 === c) throw c = $9592bbddf786be94$var$qk, $9592bbddf786be94$var$Lk(a, 0), $9592bbddf786be94$var$Dk(a, b), $9592bbddf786be94$var$Ek(a, $9592bbddf786be94$var$B()), c;
    if (6 === c) throw Error($9592bbddf786be94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9592bbddf786be94$var$Qk(a, $9592bbddf786be94$var$uk, $9592bbddf786be94$var$vk);
    $9592bbddf786be94$var$Ek(a, $9592bbddf786be94$var$B());
    return null;
}
function $9592bbddf786be94$var$Rk(a, b) {
    var c = $9592bbddf786be94$var$K;
    $9592bbddf786be94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9592bbddf786be94$var$K = c, 0 === $9592bbddf786be94$var$K && ($9592bbddf786be94$var$Hj = $9592bbddf786be94$var$B() + 500, $9592bbddf786be94$var$fg && $9592bbddf786be94$var$jg());
    }
}
function $9592bbddf786be94$var$Sk(a) {
    null !== $9592bbddf786be94$var$xk && 0 === $9592bbddf786be94$var$xk.tag && 0 === ($9592bbddf786be94$var$K & 6) && $9592bbddf786be94$var$Ik();
    var b = $9592bbddf786be94$var$K;
    $9592bbddf786be94$var$K |= 1;
    var c = $9592bbddf786be94$var$pk.transition, d = $9592bbddf786be94$var$C;
    try {
        if ($9592bbddf786be94$var$pk.transition = null, $9592bbddf786be94$var$C = 1, a) return a();
    } finally{
        $9592bbddf786be94$var$C = d, $9592bbddf786be94$var$pk.transition = c, $9592bbddf786be94$var$K = b, 0 === ($9592bbddf786be94$var$K & 6) && $9592bbddf786be94$var$jg();
    }
}
function $9592bbddf786be94$var$Ij() {
    $9592bbddf786be94$var$gj = $9592bbddf786be94$var$fj.current;
    $9592bbddf786be94$var$E($9592bbddf786be94$var$fj);
}
function $9592bbddf786be94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9592bbddf786be94$var$Gf(c));
    if (null !== $9592bbddf786be94$var$Y) for(c = $9592bbddf786be94$var$Y.return; null !== c;){
        var d = c;
        $9592bbddf786be94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9592bbddf786be94$var$$f();
                break;
            case 3:
                $9592bbddf786be94$var$Jh();
                $9592bbddf786be94$var$E($9592bbddf786be94$var$Wf);
                $9592bbddf786be94$var$E($9592bbddf786be94$var$H);
                $9592bbddf786be94$var$Oh();
                break;
            case 5:
                $9592bbddf786be94$var$Lh(d);
                break;
            case 4:
                $9592bbddf786be94$var$Jh();
                break;
            case 13:
                $9592bbddf786be94$var$E($9592bbddf786be94$var$M);
                break;
            case 19:
                $9592bbddf786be94$var$E($9592bbddf786be94$var$M);
                break;
            case 10:
                $9592bbddf786be94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $9592bbddf786be94$var$Ij();
        }
        c = c.return;
    }
    $9592bbddf786be94$var$R = a;
    $9592bbddf786be94$var$Y = a = $9592bbddf786be94$var$wh(a.current, null);
    $9592bbddf786be94$var$Z = $9592bbddf786be94$var$gj = b;
    $9592bbddf786be94$var$T = 0;
    $9592bbddf786be94$var$qk = null;
    $9592bbddf786be94$var$sk = $9592bbddf786be94$var$rk = $9592bbddf786be94$var$hh = 0;
    $9592bbddf786be94$var$uk = $9592bbddf786be94$var$tk = null;
    if (null !== $9592bbddf786be94$var$Wg) {
        for(b = 0; b < $9592bbddf786be94$var$Wg.length; b++)if (c = $9592bbddf786be94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9592bbddf786be94$var$Wg = null;
    }
    return a;
}
function $9592bbddf786be94$var$Nk(a, b) {
    do {
        var c = $9592bbddf786be94$var$Y;
        try {
            $9592bbddf786be94$var$Qg();
            $9592bbddf786be94$var$Ph.current = $9592bbddf786be94$var$ai;
            if ($9592bbddf786be94$var$Sh) {
                for(var d = $9592bbddf786be94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9592bbddf786be94$var$Sh = !1;
            }
            $9592bbddf786be94$var$Rh = 0;
            $9592bbddf786be94$var$P = $9592bbddf786be94$var$O = $9592bbddf786be94$var$N = null;
            $9592bbddf786be94$var$Th = !1;
            $9592bbddf786be94$var$Uh = 0;
            $9592bbddf786be94$var$ok.current = null;
            if (null === c || null === c.return) {
                $9592bbddf786be94$var$T = 1;
                $9592bbddf786be94$var$qk = b;
                $9592bbddf786be94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9592bbddf786be94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9592bbddf786be94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9592bbddf786be94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $9592bbddf786be94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9592bbddf786be94$var$Ti(f, l, b);
                            $9592bbddf786be94$var$uj();
                            break a;
                        }
                        k = Error($9592bbddf786be94$var$p(426));
                    }
                } else if ($9592bbddf786be94$var$I && h.mode & 1) {
                    var J = $9592bbddf786be94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9592bbddf786be94$var$Wi(J, g, h, f, b);
                        $9592bbddf786be94$var$Jg($9592bbddf786be94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $9592bbddf786be94$var$Ki(k, h);
                4 !== $9592bbddf786be94$var$T && ($9592bbddf786be94$var$T = 2);
                null === $9592bbddf786be94$var$tk ? $9592bbddf786be94$var$tk = [
                    f
                ] : $9592bbddf786be94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9592bbddf786be94$var$Oi(f, k, b);
                            $9592bbddf786be94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9592bbddf786be94$var$Si || !$9592bbddf786be94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9592bbddf786be94$var$Ri(f, h, b);
                                $9592bbddf786be94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9592bbddf786be94$var$Tk(c);
        } catch (na) {
            b = na;
            $9592bbddf786be94$var$Y === c && null !== c && ($9592bbddf786be94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9592bbddf786be94$var$Kk() {
    var a = $9592bbddf786be94$var$nk.current;
    $9592bbddf786be94$var$nk.current = $9592bbddf786be94$var$ai;
    return null === a ? $9592bbddf786be94$var$ai : a;
}
function $9592bbddf786be94$var$uj() {
    if (0 === $9592bbddf786be94$var$T || 3 === $9592bbddf786be94$var$T || 2 === $9592bbddf786be94$var$T) $9592bbddf786be94$var$T = 4;
    null === $9592bbddf786be94$var$R || 0 === ($9592bbddf786be94$var$hh & 268435455) && 0 === ($9592bbddf786be94$var$rk & 268435455) || $9592bbddf786be94$var$Dk($9592bbddf786be94$var$R, $9592bbddf786be94$var$Z);
}
function $9592bbddf786be94$var$Jk(a, b) {
    var c = $9592bbddf786be94$var$K;
    $9592bbddf786be94$var$K |= 2;
    var d = $9592bbddf786be94$var$Kk();
    if ($9592bbddf786be94$var$R !== a || $9592bbddf786be94$var$Z !== b) $9592bbddf786be94$var$vk = null, $9592bbddf786be94$var$Lk(a, b);
    for(;;)try {
        $9592bbddf786be94$var$Uk();
        break;
    } catch (e) {
        $9592bbddf786be94$var$Nk(a, e);
    }
    $9592bbddf786be94$var$Qg();
    $9592bbddf786be94$var$K = c;
    $9592bbddf786be94$var$nk.current = d;
    if (null !== $9592bbddf786be94$var$Y) throw Error($9592bbddf786be94$var$p(261));
    $9592bbddf786be94$var$R = null;
    $9592bbddf786be94$var$Z = 0;
    return $9592bbddf786be94$var$T;
}
function $9592bbddf786be94$var$Uk() {
    for(; null !== $9592bbddf786be94$var$Y;)$9592bbddf786be94$var$Vk($9592bbddf786be94$var$Y);
}
function $9592bbddf786be94$var$Mk() {
    for(; null !== $9592bbddf786be94$var$Y && !$9592bbddf786be94$var$cc();)$9592bbddf786be94$var$Vk($9592bbddf786be94$var$Y);
}
function $9592bbddf786be94$var$Vk(a) {
    var b = $9592bbddf786be94$var$Wk(a.alternate, a, $9592bbddf786be94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9592bbddf786be94$var$Tk(a) : $9592bbddf786be94$var$Y = b;
    $9592bbddf786be94$var$ok.current = null;
}
function $9592bbddf786be94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9592bbddf786be94$var$Fj(c, b, $9592bbddf786be94$var$gj), null !== c) {
                $9592bbddf786be94$var$Y = c;
                return;
            }
        } else {
            c = $9592bbddf786be94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9592bbddf786be94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9592bbddf786be94$var$T = 6;
                $9592bbddf786be94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9592bbddf786be94$var$Y = b;
            return;
        }
        $9592bbddf786be94$var$Y = b = a;
    }while (null !== b);
    0 === $9592bbddf786be94$var$T && ($9592bbddf786be94$var$T = 5);
}
function $9592bbddf786be94$var$Qk(a, b, c) {
    var d = $9592bbddf786be94$var$C, e = $9592bbddf786be94$var$pk.transition;
    try {
        $9592bbddf786be94$var$pk.transition = null, $9592bbddf786be94$var$C = 1, $9592bbddf786be94$var$Xk(a, b, c, d);
    } finally{
        $9592bbddf786be94$var$pk.transition = e, $9592bbddf786be94$var$C = d;
    }
    return null;
}
function $9592bbddf786be94$var$Xk(a, b, c, d) {
    do $9592bbddf786be94$var$Ik();
    while (null !== $9592bbddf786be94$var$xk);
    if (0 !== ($9592bbddf786be94$var$K & 6)) throw Error($9592bbddf786be94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9592bbddf786be94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9592bbddf786be94$var$Bc(a, f);
    a === $9592bbddf786be94$var$R && ($9592bbddf786be94$var$Y = $9592bbddf786be94$var$R = null, $9592bbddf786be94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9592bbddf786be94$var$wk || ($9592bbddf786be94$var$wk = !0, $9592bbddf786be94$var$Gk($9592bbddf786be94$var$hc, function() {
        $9592bbddf786be94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9592bbddf786be94$var$pk.transition;
        $9592bbddf786be94$var$pk.transition = null;
        var g = $9592bbddf786be94$var$C;
        $9592bbddf786be94$var$C = 1;
        var h = $9592bbddf786be94$var$K;
        $9592bbddf786be94$var$K |= 4;
        $9592bbddf786be94$var$ok.current = null;
        $9592bbddf786be94$var$Pj(a, c);
        $9592bbddf786be94$var$ek(c, a);
        $9592bbddf786be94$var$Oe($9592bbddf786be94$var$Df);
        $9592bbddf786be94$var$dd = !!$9592bbddf786be94$var$Cf;
        $9592bbddf786be94$var$Df = $9592bbddf786be94$var$Cf = null;
        a.current = c;
        $9592bbddf786be94$var$ik(c, a, e);
        $9592bbddf786be94$var$dc();
        $9592bbddf786be94$var$K = h;
        $9592bbddf786be94$var$C = g;
        $9592bbddf786be94$var$pk.transition = f;
    } else a.current = c;
    $9592bbddf786be94$var$wk && ($9592bbddf786be94$var$wk = !1, $9592bbddf786be94$var$xk = a, $9592bbddf786be94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($9592bbddf786be94$var$Si = null);
    $9592bbddf786be94$var$mc(c.stateNode, d);
    $9592bbddf786be94$var$Ek(a, $9592bbddf786be94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9592bbddf786be94$var$Pi) throw $9592bbddf786be94$var$Pi = !1, a = $9592bbddf786be94$var$Qi, $9592bbddf786be94$var$Qi = null, a;
    0 !== ($9592bbddf786be94$var$yk & 1) && 0 !== a.tag && $9592bbddf786be94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9592bbddf786be94$var$Ak ? $9592bbddf786be94$var$zk++ : ($9592bbddf786be94$var$zk = 0, $9592bbddf786be94$var$Ak = a) : $9592bbddf786be94$var$zk = 0;
    $9592bbddf786be94$var$jg();
    return null;
}
function $9592bbddf786be94$var$Ik() {
    if (null !== $9592bbddf786be94$var$xk) {
        var a = $9592bbddf786be94$var$Dc($9592bbddf786be94$var$yk), b = $9592bbddf786be94$var$pk.transition, c = $9592bbddf786be94$var$C;
        try {
            $9592bbddf786be94$var$pk.transition = null;
            $9592bbddf786be94$var$C = 16 > a ? 16 : a;
            if (null === $9592bbddf786be94$var$xk) var d = !1;
            else {
                a = $9592bbddf786be94$var$xk;
                $9592bbddf786be94$var$xk = null;
                $9592bbddf786be94$var$yk = 0;
                if (0 !== ($9592bbddf786be94$var$K & 6)) throw Error($9592bbddf786be94$var$p(331));
                var e = $9592bbddf786be94$var$K;
                $9592bbddf786be94$var$K |= 4;
                for($9592bbddf786be94$var$V = a.current; null !== $9592bbddf786be94$var$V;){
                    var f = $9592bbddf786be94$var$V, g = f.child;
                    if (0 !== ($9592bbddf786be94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9592bbddf786be94$var$V = l; null !== $9592bbddf786be94$var$V;){
                                    var m = $9592bbddf786be94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9592bbddf786be94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9592bbddf786be94$var$V = q;
                                    else for(; null !== $9592bbddf786be94$var$V;){
                                        m = $9592bbddf786be94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9592bbddf786be94$var$Tj(m);
                                        if (m === l) {
                                            $9592bbddf786be94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9592bbddf786be94$var$V = r;
                                            break;
                                        }
                                        $9592bbddf786be94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9592bbddf786be94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9592bbddf786be94$var$V = g;
                    else b: for(; null !== $9592bbddf786be94$var$V;){
                        f = $9592bbddf786be94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9592bbddf786be94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9592bbddf786be94$var$V = x;
                            break b;
                        }
                        $9592bbddf786be94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9592bbddf786be94$var$V = w; null !== $9592bbddf786be94$var$V;){
                    g = $9592bbddf786be94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9592bbddf786be94$var$V = u;
                    else b: for(g = w; null !== $9592bbddf786be94$var$V;){
                        h = $9592bbddf786be94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9592bbddf786be94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $9592bbddf786be94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9592bbddf786be94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9592bbddf786be94$var$V = F;
                            break b;
                        }
                        $9592bbddf786be94$var$V = h.return;
                    }
                }
                $9592bbddf786be94$var$K = e;
                $9592bbddf786be94$var$jg();
                if ($9592bbddf786be94$var$lc && "function" === typeof $9592bbddf786be94$var$lc.onPostCommitFiberRoot) try {
                    $9592bbddf786be94$var$lc.onPostCommitFiberRoot($9592bbddf786be94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9592bbddf786be94$var$C = c, $9592bbddf786be94$var$pk.transition = b;
        }
    }
    return !1;
}
function $9592bbddf786be94$var$Yk(a, b, c) {
    b = $9592bbddf786be94$var$Ki(c, b);
    b = $9592bbddf786be94$var$Oi(a, b, 1);
    a = $9592bbddf786be94$var$dh(a, b, 1);
    b = $9592bbddf786be94$var$L();
    null !== a && ($9592bbddf786be94$var$Ac(a, 1, b), $9592bbddf786be94$var$Ek(a, b));
}
function $9592bbddf786be94$var$W(a, b, c) {
    if (3 === a.tag) $9592bbddf786be94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9592bbddf786be94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9592bbddf786be94$var$Si || !$9592bbddf786be94$var$Si.has(d))) {
                a = $9592bbddf786be94$var$Ki(c, a);
                a = $9592bbddf786be94$var$Ri(b, a, 1);
                b = $9592bbddf786be94$var$dh(b, a, 1);
                a = $9592bbddf786be94$var$L();
                null !== b && ($9592bbddf786be94$var$Ac(b, 1, a), $9592bbddf786be94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9592bbddf786be94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9592bbddf786be94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $9592bbddf786be94$var$R === a && ($9592bbddf786be94$var$Z & c) === c && (4 === $9592bbddf786be94$var$T || 3 === $9592bbddf786be94$var$T && ($9592bbddf786be94$var$Z & 130023424) === $9592bbddf786be94$var$Z && 500 > $9592bbddf786be94$var$B() - $9592bbddf786be94$var$gk ? $9592bbddf786be94$var$Lk(a, 0) : $9592bbddf786be94$var$sk |= c);
    $9592bbddf786be94$var$Ek(a, b);
}
function $9592bbddf786be94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9592bbddf786be94$var$sc, $9592bbddf786be94$var$sc <<= 1, 0 === ($9592bbddf786be94$var$sc & 130023424) && ($9592bbddf786be94$var$sc = 4194304)));
    var c = $9592bbddf786be94$var$L();
    a = $9592bbddf786be94$var$Zg(a, b);
    null !== a && ($9592bbddf786be94$var$Ac(a, b, c), $9592bbddf786be94$var$Ek(a, c));
}
function $9592bbddf786be94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9592bbddf786be94$var$Zk(a, c);
}
function $9592bbddf786be94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9592bbddf786be94$var$p(314));
    }
    null !== d && d.delete(b);
    $9592bbddf786be94$var$Zk(a, c);
}
var $9592bbddf786be94$var$Wk;
$9592bbddf786be94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9592bbddf786be94$var$Wf.current) $9592bbddf786be94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9592bbddf786be94$var$Ug = !1, $9592bbddf786be94$var$zj(a, b, c);
            $9592bbddf786be94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9592bbddf786be94$var$Ug = !1, $9592bbddf786be94$var$I && 0 !== (b.flags & 1048576) && $9592bbddf786be94$var$ug(b, $9592bbddf786be94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9592bbddf786be94$var$jj(a, b);
            a = b.pendingProps;
            var e = $9592bbddf786be94$var$Yf(b, $9592bbddf786be94$var$H.current);
            $9592bbddf786be94$var$Tg(b, c);
            e = $9592bbddf786be94$var$Xh(null, b, d, a, e, c);
            var f = $9592bbddf786be94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9592bbddf786be94$var$Zf(d) ? (f = !0, $9592bbddf786be94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9592bbddf786be94$var$ah(b), e.updater = $9592bbddf786be94$var$nh, b.stateNode = e, e._reactInternals = b, $9592bbddf786be94$var$rh(b, d, a, c), b = $9592bbddf786be94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $9592bbddf786be94$var$I && f && $9592bbddf786be94$var$vg(b), $9592bbddf786be94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9592bbddf786be94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9592bbddf786be94$var$$k(d);
                a = $9592bbddf786be94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $9592bbddf786be94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9592bbddf786be94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9592bbddf786be94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9592bbddf786be94$var$aj(null, b, d, $9592bbddf786be94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($9592bbddf786be94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9592bbddf786be94$var$Lg(d, e), $9592bbddf786be94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9592bbddf786be94$var$Lg(d, e), $9592bbddf786be94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $9592bbddf786be94$var$lj(b);
                if (null === a) throw Error($9592bbddf786be94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9592bbddf786be94$var$bh(a, b);
                $9592bbddf786be94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9592bbddf786be94$var$Ki(Error($9592bbddf786be94$var$p(423)), b);
                        b = $9592bbddf786be94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9592bbddf786be94$var$Ki(Error($9592bbddf786be94$var$p(424)), b);
                        b = $9592bbddf786be94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($9592bbddf786be94$var$yg = $9592bbddf786be94$var$Lf(b.stateNode.containerInfo.firstChild), $9592bbddf786be94$var$xg = b, $9592bbddf786be94$var$I = !0, $9592bbddf786be94$var$zg = null, c = $9592bbddf786be94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9592bbddf786be94$var$Ig();
                    if (d === e) {
                        b = $9592bbddf786be94$var$$i(a, b, c);
                        break a;
                    }
                    $9592bbddf786be94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9592bbddf786be94$var$Kh(b), null === a && $9592bbddf786be94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9592bbddf786be94$var$Ef(d, e) ? g = null : null !== f && $9592bbddf786be94$var$Ef(d, f) && (b.flags |= 32), $9592bbddf786be94$var$hj(a, b), $9592bbddf786be94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $9592bbddf786be94$var$Eg(b), null;
        case 13:
            return $9592bbddf786be94$var$pj(a, b, c);
        case 4:
            return $9592bbddf786be94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9592bbddf786be94$var$Bh(b, null, d, c) : $9592bbddf786be94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9592bbddf786be94$var$Lg(d, e), $9592bbddf786be94$var$Zi(a, b, d, e, c);
        case 7:
            return $9592bbddf786be94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9592bbddf786be94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9592bbddf786be94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9592bbddf786be94$var$G($9592bbddf786be94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9592bbddf786be94$var$He(f.value, g)) {
                        if (f.children === e.children && !$9592bbddf786be94$var$Wf.current) {
                            b = $9592bbddf786be94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9592bbddf786be94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9592bbddf786be94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9592bbddf786be94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9592bbddf786be94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9592bbddf786be94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9592bbddf786be94$var$Tg(b, c), e = $9592bbddf786be94$var$Vg(e), d = d(e), b.flags |= 1, $9592bbddf786be94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9592bbddf786be94$var$Lg(d, b.pendingProps), e = $9592bbddf786be94$var$Lg(d.type, e), $9592bbddf786be94$var$aj(a, b, d, e, c);
        case 15:
            return $9592bbddf786be94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9592bbddf786be94$var$Lg(d, e), $9592bbddf786be94$var$jj(a, b), b.tag = 1, $9592bbddf786be94$var$Zf(d) ? (a = !0, $9592bbddf786be94$var$cg(b)) : a = !1, $9592bbddf786be94$var$Tg(b, c), $9592bbddf786be94$var$ph(b, d, e), $9592bbddf786be94$var$rh(b, d, e, c), $9592bbddf786be94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $9592bbddf786be94$var$yj(a, b, c);
        case 22:
            return $9592bbddf786be94$var$ej(a, b, c);
    }
    throw Error($9592bbddf786be94$var$p(156, b.tag));
};
function $9592bbddf786be94$var$Gk(a, b) {
    return $9592bbddf786be94$var$ac(a, b);
}
function $9592bbddf786be94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9592bbddf786be94$var$Bg(a, b, c, d) {
    return new $9592bbddf786be94$var$al(a, b, c, d);
}
function $9592bbddf786be94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9592bbddf786be94$var$$k(a) {
    if ("function" === typeof a) return $9592bbddf786be94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9592bbddf786be94$var$Da) return 11;
        if (a === $9592bbddf786be94$var$Ga) return 14;
    }
    return 2;
}
function $9592bbddf786be94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $9592bbddf786be94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9592bbddf786be94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9592bbddf786be94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9592bbddf786be94$var$ya:
            return $9592bbddf786be94$var$Ah(c.children, e, f, b);
        case $9592bbddf786be94$var$za:
            g = 8;
            e |= 8;
            break;
        case $9592bbddf786be94$var$Aa:
            return a = $9592bbddf786be94$var$Bg(12, c, b, e | 2), a.elementType = $9592bbddf786be94$var$Aa, a.lanes = f, a;
        case $9592bbddf786be94$var$Ea:
            return a = $9592bbddf786be94$var$Bg(13, c, b, e), a.elementType = $9592bbddf786be94$var$Ea, a.lanes = f, a;
        case $9592bbddf786be94$var$Fa:
            return a = $9592bbddf786be94$var$Bg(19, c, b, e), a.elementType = $9592bbddf786be94$var$Fa, a.lanes = f, a;
        case $9592bbddf786be94$var$Ia:
            return $9592bbddf786be94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9592bbddf786be94$var$Ba:
                    g = 10;
                    break a;
                case $9592bbddf786be94$var$Ca:
                    g = 9;
                    break a;
                case $9592bbddf786be94$var$Da:
                    g = 11;
                    break a;
                case $9592bbddf786be94$var$Ga:
                    g = 14;
                    break a;
                case $9592bbddf786be94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9592bbddf786be94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9592bbddf786be94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9592bbddf786be94$var$Ah(a, b, c, d) {
    a = $9592bbddf786be94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9592bbddf786be94$var$qj(a, b, c, d) {
    a = $9592bbddf786be94$var$Bg(22, a, d, b);
    a.elementType = $9592bbddf786be94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9592bbddf786be94$var$xh(a, b, c) {
    a = $9592bbddf786be94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9592bbddf786be94$var$zh(a, b, c) {
    b = $9592bbddf786be94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9592bbddf786be94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9592bbddf786be94$var$zc(0);
    this.expirationTimes = $9592bbddf786be94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9592bbddf786be94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9592bbddf786be94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $9592bbddf786be94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9592bbddf786be94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9592bbddf786be94$var$ah(f);
    return a;
}
function $9592bbddf786be94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9592bbddf786be94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9592bbddf786be94$var$el(a) {
    if (!a) return $9592bbddf786be94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9592bbddf786be94$var$Vb(a) !== a || 1 !== a.tag) throw Error($9592bbddf786be94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9592bbddf786be94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9592bbddf786be94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9592bbddf786be94$var$Zf(c)) return $9592bbddf786be94$var$bg(a, c, b);
    }
    return b;
}
function $9592bbddf786be94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $9592bbddf786be94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $9592bbddf786be94$var$el(null);
    c = a.current;
    d = $9592bbddf786be94$var$L();
    e = $9592bbddf786be94$var$lh(c);
    f = $9592bbddf786be94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9592bbddf786be94$var$dh(c, f, e);
    a.current.lanes = e;
    $9592bbddf786be94$var$Ac(a, e, d);
    $9592bbddf786be94$var$Ek(a, d);
    return a;
}
function $9592bbddf786be94$var$gl(a, b, c, d) {
    var e = b.current, f = $9592bbddf786be94$var$L(), g = $9592bbddf786be94$var$lh(e);
    c = $9592bbddf786be94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9592bbddf786be94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9592bbddf786be94$var$dh(e, b, g);
    null !== a && ($9592bbddf786be94$var$mh(a, e, g, f), $9592bbddf786be94$var$eh(a, e, g));
    return g;
}
function $9592bbddf786be94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9592bbddf786be94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9592bbddf786be94$var$jl(a, b) {
    $9592bbddf786be94$var$il(a, b);
    (a = a.alternate) && $9592bbddf786be94$var$il(a, b);
}
function $9592bbddf786be94$var$kl() {
    return null;
}
var $9592bbddf786be94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9592bbddf786be94$var$ml(a) {
    this._internalRoot = a;
}
$9592bbddf786be94$var$nl.prototype.render = $9592bbddf786be94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9592bbddf786be94$var$p(409));
    $9592bbddf786be94$var$gl(a, b, null, null);
};
$9592bbddf786be94$var$nl.prototype.unmount = $9592bbddf786be94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9592bbddf786be94$var$Sk(function() {
            $9592bbddf786be94$var$gl(null, a, null, null);
        });
        b[$9592bbddf786be94$var$uf] = null;
    }
};
function $9592bbddf786be94$var$nl(a) {
    this._internalRoot = a;
}
$9592bbddf786be94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9592bbddf786be94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9592bbddf786be94$var$Qc.length && 0 !== b && b < $9592bbddf786be94$var$Qc[c].priority; c++);
        $9592bbddf786be94$var$Qc.splice(c, 0, a);
        0 === c && $9592bbddf786be94$var$Vc(a);
    }
};
function $9592bbddf786be94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9592bbddf786be94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9592bbddf786be94$var$ql() {}
function $9592bbddf786be94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9592bbddf786be94$var$hl(g);
                f.call(a);
            };
        }
        var g = $9592bbddf786be94$var$fl(b, d, a, 0, null, !1, !1, "", $9592bbddf786be94$var$ql);
        a._reactRootContainer = g;
        a[$9592bbddf786be94$var$uf] = g.current;
        $9592bbddf786be94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9592bbddf786be94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9592bbddf786be94$var$hl(k);
            h.call(a);
        };
    }
    var k = $9592bbddf786be94$var$cl(a, 0, !1, null, null, !1, !1, "", $9592bbddf786be94$var$ql);
    a._reactRootContainer = k;
    a[$9592bbddf786be94$var$uf] = k.current;
    $9592bbddf786be94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9592bbddf786be94$var$Sk(function() {
        $9592bbddf786be94$var$gl(b, k, c, d);
    });
    return k;
}
function $9592bbddf786be94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9592bbddf786be94$var$hl(g);
                h.call(a);
            };
        }
        $9592bbddf786be94$var$gl(b, g, a, e);
    } else g = $9592bbddf786be94$var$rl(c, b, a, e, d);
    return $9592bbddf786be94$var$hl(g);
}
$9592bbddf786be94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9592bbddf786be94$var$tc(b.pendingLanes);
                0 !== c && ($9592bbddf786be94$var$Cc(b, c | 1), $9592bbddf786be94$var$Ek(b, $9592bbddf786be94$var$B()), 0 === ($9592bbddf786be94$var$K & 6) && ($9592bbddf786be94$var$Hj = $9592bbddf786be94$var$B() + 500, $9592bbddf786be94$var$jg()));
            }
            break;
        case 13:
            $9592bbddf786be94$var$Sk(function() {
                var b = $9592bbddf786be94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $9592bbddf786be94$var$L();
                    $9592bbddf786be94$var$mh(b, a, 1, c);
                }
            }), $9592bbddf786be94$var$jl(a, 1);
    }
};
$9592bbddf786be94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9592bbddf786be94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $9592bbddf786be94$var$L();
            $9592bbddf786be94$var$mh(b, a, 134217728, c);
        }
        $9592bbddf786be94$var$jl(a, 134217728);
    }
};
$9592bbddf786be94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9592bbddf786be94$var$lh(a), c = $9592bbddf786be94$var$Zg(a, b);
        if (null !== c) {
            var d = $9592bbddf786be94$var$L();
            $9592bbddf786be94$var$mh(c, a, b, d);
        }
        $9592bbddf786be94$var$jl(a, b);
    }
};
$9592bbddf786be94$var$Hc = function() {
    return $9592bbddf786be94$var$C;
};
$9592bbddf786be94$var$Ic = function(a, b) {
    var c = $9592bbddf786be94$var$C;
    try {
        return $9592bbddf786be94$var$C = a, b();
    } finally{
        $9592bbddf786be94$var$C = c;
    }
};
$9592bbddf786be94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9592bbddf786be94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9592bbddf786be94$var$Db(d);
                        if (!e) throw Error($9592bbddf786be94$var$p(90));
                        $9592bbddf786be94$var$Wa(d);
                        $9592bbddf786be94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9592bbddf786be94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9592bbddf786be94$var$fb(a, !!c.multiple, b, !1);
    }
};
$9592bbddf786be94$var$Gb = $9592bbddf786be94$var$Rk;
$9592bbddf786be94$var$Hb = $9592bbddf786be94$var$Sk;
var $9592bbddf786be94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $9592bbddf786be94$var$Cb,
        $9592bbddf786be94$var$ue,
        $9592bbddf786be94$var$Db,
        $9592bbddf786be94$var$Eb,
        $9592bbddf786be94$var$Fb,
        $9592bbddf786be94$var$Rk
    ]
}, $9592bbddf786be94$var$ul = {
    findFiberByHostInstance: $9592bbddf786be94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $9592bbddf786be94$var$vl = {
    bundleType: $9592bbddf786be94$var$ul.bundleType,
    version: $9592bbddf786be94$var$ul.version,
    rendererPackageName: $9592bbddf786be94$var$ul.rendererPackageName,
    rendererConfig: $9592bbddf786be94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9592bbddf786be94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9592bbddf786be94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9592bbddf786be94$var$ul.findFiberByHostInstance || $9592bbddf786be94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9592bbddf786be94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9592bbddf786be94$var$wl.isDisabled && $9592bbddf786be94$var$wl.supportsFiber) try {
        $9592bbddf786be94$var$kc = $9592bbddf786be94$var$wl.inject($9592bbddf786be94$var$vl), $9592bbddf786be94$var$lc = $9592bbddf786be94$var$wl;
    } catch (a) {}
}
$9592bbddf786be94$export$ae55be85d98224ed = $9592bbddf786be94$var$tl;
$9592bbddf786be94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9592bbddf786be94$var$ol(b)) throw Error($9592bbddf786be94$var$p(200));
    return $9592bbddf786be94$var$dl(a, b, null, c);
};
$9592bbddf786be94$export$882461b6382ed46c = function(a, b) {
    if (!$9592bbddf786be94$var$ol(a)) throw Error($9592bbddf786be94$var$p(299));
    var c = !1, d = "", e = $9592bbddf786be94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9592bbddf786be94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$9592bbddf786be94$var$uf] = b.current;
    $9592bbddf786be94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9592bbddf786be94$var$ml(b);
};
$9592bbddf786be94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9592bbddf786be94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9592bbddf786be94$var$p(268, a));
    }
    a = $9592bbddf786be94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9592bbddf786be94$export$cd75ccfd720a3cd4 = function(a) {
    return $9592bbddf786be94$var$Sk(a);
};
$9592bbddf786be94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9592bbddf786be94$var$pl(b)) throw Error($9592bbddf786be94$var$p(200));
    return $9592bbddf786be94$var$sl(null, a, b, !0, c);
};
$9592bbddf786be94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9592bbddf786be94$var$ol(a)) throw Error($9592bbddf786be94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9592bbddf786be94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9592bbddf786be94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9592bbddf786be94$var$uf] = b.current;
    $9592bbddf786be94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9592bbddf786be94$var$nl(b);
};
$9592bbddf786be94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9592bbddf786be94$var$pl(b)) throw Error($9592bbddf786be94$var$p(200));
    return $9592bbddf786be94$var$sl(null, a, b, !1, c);
};
$9592bbddf786be94$export$502457920280e6be = function(a) {
    if (!$9592bbddf786be94$var$pl(a)) throw Error($9592bbddf786be94$var$p(40));
    return a._reactRootContainer ? ($9592bbddf786be94$var$Sk(function() {
        $9592bbddf786be94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9592bbddf786be94$var$uf] = null;
        });
    }), !0) : !1;
};
$9592bbddf786be94$export$c78a37762a8d58e1 = $9592bbddf786be94$var$Rk;
$9592bbddf786be94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9592bbddf786be94$var$pl(c)) throw Error($9592bbddf786be94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9592bbddf786be94$var$p(38));
    return $9592bbddf786be94$var$sl(a, b, c, !1, d);
};
$9592bbddf786be94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("k7mRH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1rcZL"));

});
parcelRequire.register("1rcZL", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $10c264a6bcf1198f$export$c4744153514ff05d; }, function (v) { return $10c264a6bcf1198f$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $10c264a6bcf1198f$export$3e506c1ccc9cc1a7; }, function (v) { return $10c264a6bcf1198f$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $10c264a6bcf1198f$export$e26fe2ed2fa76875; }, function (v) { return $10c264a6bcf1198f$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $10c264a6bcf1198f$export$502329bbf4b505b1; }, function (v) { return $10c264a6bcf1198f$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $10c264a6bcf1198f$export$6e3807111c4874c4; }, function (v) { return $10c264a6bcf1198f$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $10c264a6bcf1198f$export$c27134553091fb3a; }, function (v) { return $10c264a6bcf1198f$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $10c264a6bcf1198f$export$33ee1acdc04fd2a2; }, function (v) { return $10c264a6bcf1198f$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $10c264a6bcf1198f$export$b00a404bbd5edef2; }, function (v) { return $10c264a6bcf1198f$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $10c264a6bcf1198f$export$8352ce38b91d0c62; }, function (v) { return $10c264a6bcf1198f$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $10c264a6bcf1198f$export$d66a1c1c77bd778b; }, function (v) { return $10c264a6bcf1198f$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $10c264a6bcf1198f$export$d3dfb8e4810cb555; }, function (v) { return $10c264a6bcf1198f$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $10c264a6bcf1198f$export$839f9183b0465a69; }, function (v) { return $10c264a6bcf1198f$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $10c264a6bcf1198f$export$72fdf0e06517287b; }, function (v) { return $10c264a6bcf1198f$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $10c264a6bcf1198f$export$4b844e58a3e414b4; }, function (v) { return $10c264a6bcf1198f$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $10c264a6bcf1198f$export$816d2913ae6b83b1; }, function (v) { return $10c264a6bcf1198f$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $10c264a6bcf1198f$export$61bcfe829111a1d0; }, function (v) { return $10c264a6bcf1198f$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $10c264a6bcf1198f$export$7ee8c9beb337bc3f; }, function (v) { return $10c264a6bcf1198f$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $10c264a6bcf1198f$export$b5836b71941fa3ed; }, function (v) { return $10c264a6bcf1198f$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $10c264a6bcf1198f$export$cf845f2c119da08a; }, function (v) { return $10c264a6bcf1198f$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $10c264a6bcf1198f$export$c4744153514ff05d;
var $10c264a6bcf1198f$export$3e506c1ccc9cc1a7;
var $10c264a6bcf1198f$export$e26fe2ed2fa76875;
var $10c264a6bcf1198f$export$502329bbf4b505b1;
var $10c264a6bcf1198f$export$6e3807111c4874c4;
var $10c264a6bcf1198f$export$c27134553091fb3a;
var $10c264a6bcf1198f$export$33ee1acdc04fd2a2;
var $10c264a6bcf1198f$export$b00a404bbd5edef2;
var $10c264a6bcf1198f$export$8352ce38b91d0c62;
var $10c264a6bcf1198f$export$d66a1c1c77bd778b;
var $10c264a6bcf1198f$export$d3dfb8e4810cb555;
var $10c264a6bcf1198f$export$839f9183b0465a69;
var $10c264a6bcf1198f$export$72fdf0e06517287b;
var $10c264a6bcf1198f$export$4b844e58a3e414b4;
var $10c264a6bcf1198f$export$816d2913ae6b83b1;
var $10c264a6bcf1198f$export$61bcfe829111a1d0;
var $10c264a6bcf1198f$export$7ee8c9beb337bc3f;
var $10c264a6bcf1198f$export$b5836b71941fa3ed;
var $10c264a6bcf1198f$export$cf845f2c119da08a;
"use strict";
function $10c264a6bcf1198f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $10c264a6bcf1198f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $10c264a6bcf1198f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $10c264a6bcf1198f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $10c264a6bcf1198f$var$g(C, c)) n < e && 0 > $10c264a6bcf1198f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $10c264a6bcf1198f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $10c264a6bcf1198f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $10c264a6bcf1198f$var$l = performance;
    $10c264a6bcf1198f$export$c4744153514ff05d = function() {
        return $10c264a6bcf1198f$var$l.now();
    };
} else {
    var $10c264a6bcf1198f$var$p = Date, $10c264a6bcf1198f$var$q = $10c264a6bcf1198f$var$p.now();
    $10c264a6bcf1198f$export$c4744153514ff05d = function() {
        return $10c264a6bcf1198f$var$p.now() - $10c264a6bcf1198f$var$q;
    };
}
var $10c264a6bcf1198f$var$r = [], $10c264a6bcf1198f$var$t = [], $10c264a6bcf1198f$var$u = 1, $10c264a6bcf1198f$var$v = null, $10c264a6bcf1198f$var$y = 3, $10c264a6bcf1198f$var$z = !1, $10c264a6bcf1198f$var$A = !1, $10c264a6bcf1198f$var$B = !1, $10c264a6bcf1198f$var$D = "function" === typeof setTimeout ? setTimeout : null, $10c264a6bcf1198f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $10c264a6bcf1198f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $10c264a6bcf1198f$var$G(a) {
    for(var b = $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$t); null !== b;){
        if (null === b.callback) $10c264a6bcf1198f$var$k($10c264a6bcf1198f$var$t);
        else if (b.startTime <= a) $10c264a6bcf1198f$var$k($10c264a6bcf1198f$var$t), b.sortIndex = b.expirationTime, $10c264a6bcf1198f$var$f($10c264a6bcf1198f$var$r, b);
        else break;
        b = $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$t);
    }
}
function $10c264a6bcf1198f$var$H(a) {
    $10c264a6bcf1198f$var$B = !1;
    $10c264a6bcf1198f$var$G(a);
    if (!$10c264a6bcf1198f$var$A) {
        if (null !== $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$r)) $10c264a6bcf1198f$var$A = !0, $10c264a6bcf1198f$var$I($10c264a6bcf1198f$var$J);
        else {
            var b = $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$t);
            null !== b && $10c264a6bcf1198f$var$K($10c264a6bcf1198f$var$H, b.startTime - a);
        }
    }
}
function $10c264a6bcf1198f$var$J(a, b) {
    $10c264a6bcf1198f$var$A = !1;
    $10c264a6bcf1198f$var$B && ($10c264a6bcf1198f$var$B = !1, $10c264a6bcf1198f$var$E($10c264a6bcf1198f$var$L), $10c264a6bcf1198f$var$L = -1);
    $10c264a6bcf1198f$var$z = !0;
    var c = $10c264a6bcf1198f$var$y;
    try {
        $10c264a6bcf1198f$var$G(b);
        for($10c264a6bcf1198f$var$v = $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$r); null !== $10c264a6bcf1198f$var$v && (!($10c264a6bcf1198f$var$v.expirationTime > b) || a && !$10c264a6bcf1198f$var$M());){
            var d = $10c264a6bcf1198f$var$v.callback;
            if ("function" === typeof d) {
                $10c264a6bcf1198f$var$v.callback = null;
                $10c264a6bcf1198f$var$y = $10c264a6bcf1198f$var$v.priorityLevel;
                var e = d($10c264a6bcf1198f$var$v.expirationTime <= b);
                b = $10c264a6bcf1198f$export$c4744153514ff05d();
                "function" === typeof e ? $10c264a6bcf1198f$var$v.callback = e : $10c264a6bcf1198f$var$v === $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$r) && $10c264a6bcf1198f$var$k($10c264a6bcf1198f$var$r);
                $10c264a6bcf1198f$var$G(b);
            } else $10c264a6bcf1198f$var$k($10c264a6bcf1198f$var$r);
            $10c264a6bcf1198f$var$v = $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$r);
        }
        if (null !== $10c264a6bcf1198f$var$v) var w = !0;
        else {
            var m = $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$t);
            null !== m && $10c264a6bcf1198f$var$K($10c264a6bcf1198f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $10c264a6bcf1198f$var$v = null, $10c264a6bcf1198f$var$y = c, $10c264a6bcf1198f$var$z = !1;
    }
}
var $10c264a6bcf1198f$var$N = !1, $10c264a6bcf1198f$var$O = null, $10c264a6bcf1198f$var$L = -1, $10c264a6bcf1198f$var$P = 5, $10c264a6bcf1198f$var$Q = -1;
function $10c264a6bcf1198f$var$M() {
    return $10c264a6bcf1198f$export$c4744153514ff05d() - $10c264a6bcf1198f$var$Q < $10c264a6bcf1198f$var$P ? !1 : !0;
}
function $10c264a6bcf1198f$var$R() {
    if (null !== $10c264a6bcf1198f$var$O) {
        var a = $10c264a6bcf1198f$export$c4744153514ff05d();
        $10c264a6bcf1198f$var$Q = a;
        var b = !0;
        try {
            b = $10c264a6bcf1198f$var$O(!0, a);
        } finally{
            b ? $10c264a6bcf1198f$var$S() : ($10c264a6bcf1198f$var$N = !1, $10c264a6bcf1198f$var$O = null);
        }
    } else $10c264a6bcf1198f$var$N = !1;
}
var $10c264a6bcf1198f$var$S;
if ("function" === typeof $10c264a6bcf1198f$var$F) $10c264a6bcf1198f$var$S = function() {
    $10c264a6bcf1198f$var$F($10c264a6bcf1198f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $10c264a6bcf1198f$var$T = new MessageChannel, $10c264a6bcf1198f$var$U = $10c264a6bcf1198f$var$T.port2;
    $10c264a6bcf1198f$var$T.port1.onmessage = $10c264a6bcf1198f$var$R;
    $10c264a6bcf1198f$var$S = function() {
        $10c264a6bcf1198f$var$U.postMessage(null);
    };
} else $10c264a6bcf1198f$var$S = function() {
    $10c264a6bcf1198f$var$D($10c264a6bcf1198f$var$R, 0);
};
function $10c264a6bcf1198f$var$I(a) {
    $10c264a6bcf1198f$var$O = a;
    $10c264a6bcf1198f$var$N || ($10c264a6bcf1198f$var$N = !0, $10c264a6bcf1198f$var$S());
}
function $10c264a6bcf1198f$var$K(a, b) {
    $10c264a6bcf1198f$var$L = $10c264a6bcf1198f$var$D(function() {
        a($10c264a6bcf1198f$export$c4744153514ff05d());
    }, b);
}
$10c264a6bcf1198f$export$3e506c1ccc9cc1a7 = 5;
$10c264a6bcf1198f$export$e26fe2ed2fa76875 = 1;
$10c264a6bcf1198f$export$502329bbf4b505b1 = 4;
$10c264a6bcf1198f$export$6e3807111c4874c4 = 3;
$10c264a6bcf1198f$export$c27134553091fb3a = null;
$10c264a6bcf1198f$export$33ee1acdc04fd2a2 = 2;
$10c264a6bcf1198f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$10c264a6bcf1198f$export$8352ce38b91d0c62 = function() {
    $10c264a6bcf1198f$var$A || $10c264a6bcf1198f$var$z || ($10c264a6bcf1198f$var$A = !0, $10c264a6bcf1198f$var$I($10c264a6bcf1198f$var$J));
};
$10c264a6bcf1198f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $10c264a6bcf1198f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$10c264a6bcf1198f$export$d3dfb8e4810cb555 = function() {
    return $10c264a6bcf1198f$var$y;
};
$10c264a6bcf1198f$export$839f9183b0465a69 = function() {
    return $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$r);
};
$10c264a6bcf1198f$export$72fdf0e06517287b = function(a) {
    switch($10c264a6bcf1198f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $10c264a6bcf1198f$var$y;
    }
    var c = $10c264a6bcf1198f$var$y;
    $10c264a6bcf1198f$var$y = b;
    try {
        return a();
    } finally{
        $10c264a6bcf1198f$var$y = c;
    }
};
$10c264a6bcf1198f$export$4b844e58a3e414b4 = function() {};
$10c264a6bcf1198f$export$816d2913ae6b83b1 = function() {};
$10c264a6bcf1198f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $10c264a6bcf1198f$var$y;
    $10c264a6bcf1198f$var$y = a;
    try {
        return b();
    } finally{
        $10c264a6bcf1198f$var$y = c;
    }
};
$10c264a6bcf1198f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $10c264a6bcf1198f$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $10c264a6bcf1198f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $10c264a6bcf1198f$var$f($10c264a6bcf1198f$var$t, a), null === $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$r) && a === $10c264a6bcf1198f$var$h($10c264a6bcf1198f$var$t) && ($10c264a6bcf1198f$var$B ? ($10c264a6bcf1198f$var$E($10c264a6bcf1198f$var$L), $10c264a6bcf1198f$var$L = -1) : $10c264a6bcf1198f$var$B = !0, $10c264a6bcf1198f$var$K($10c264a6bcf1198f$var$H, c - d))) : (a.sortIndex = e, $10c264a6bcf1198f$var$f($10c264a6bcf1198f$var$r, a), $10c264a6bcf1198f$var$A || $10c264a6bcf1198f$var$z || ($10c264a6bcf1198f$var$A = !0, $10c264a6bcf1198f$var$I($10c264a6bcf1198f$var$J)));
    return a;
};
$10c264a6bcf1198f$export$b5836b71941fa3ed = $10c264a6bcf1198f$var$M;
$10c264a6bcf1198f$export$cf845f2c119da08a = function(a) {
    var b = $10c264a6bcf1198f$var$y;
    return function() {
        var c = $10c264a6bcf1198f$var$y;
        $10c264a6bcf1198f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $10c264a6bcf1198f$var$y = c;
        }
    };
};

});



parcelRequire.register("5nsg4", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $3ea5053456bc525f$export$306c0aa65ff9ec16; }, function (v) { return $3ea5053456bc525f$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3ea5053456bc525f$export$306c0aa65ff9ec16;
"use strict";

var $eXaQ2 = parcelRequire("eXaQ2");
function $3ea5053456bc525f$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3ea5053456bc525f$var$k = "function" === typeof Object.is ? Object.is : $3ea5053456bc525f$var$h, $3ea5053456bc525f$var$l = $eXaQ2.useState, $3ea5053456bc525f$var$m = $eXaQ2.useEffect, $3ea5053456bc525f$var$n = $eXaQ2.useLayoutEffect, $3ea5053456bc525f$var$p = $eXaQ2.useDebugValue;
function $3ea5053456bc525f$var$q(a, b) {
    var d = b(), f = $3ea5053456bc525f$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $3ea5053456bc525f$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $3ea5053456bc525f$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $3ea5053456bc525f$var$m(function() {
        $3ea5053456bc525f$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $3ea5053456bc525f$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $3ea5053456bc525f$var$p(d);
    return d;
}
function $3ea5053456bc525f$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$3ea5053456bc525f$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $3ea5053456bc525f$var$t(a, b) {
    return b();
}
var $3ea5053456bc525f$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $3ea5053456bc525f$var$t : $3ea5053456bc525f$var$q;
$3ea5053456bc525f$export$306c0aa65ff9ec16 = void 0 !== $eXaQ2.useSyncExternalStore ? $eXaQ2.useSyncExternalStore : $3ea5053456bc525f$var$u;

});

parcelRequire.register("gOcBI", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $c3cb186d790dfa49$export$bf730a2d8bf68b42; }, function (v) { return $c3cb186d790dfa49$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c3cb186d790dfa49$export$bf730a2d8bf68b42;
"use strict";

var $eXaQ2 = parcelRequire("eXaQ2");

var $4QrSY = parcelRequire("4QrSY");
function $c3cb186d790dfa49$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c3cb186d790dfa49$var$q = "function" === typeof Object.is ? Object.is : $c3cb186d790dfa49$var$p, $c3cb186d790dfa49$var$r = $4QrSY.useSyncExternalStore, $c3cb186d790dfa49$var$t = $eXaQ2.useRef, $c3cb186d790dfa49$var$u = $eXaQ2.useEffect, $c3cb186d790dfa49$var$v = $eXaQ2.useMemo, $c3cb186d790dfa49$var$w = $eXaQ2.useDebugValue;
$c3cb186d790dfa49$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $c3cb186d790dfa49$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $c3cb186d790dfa49$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($c3cb186d790dfa49$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $c3cb186d790dfa49$var$r(a, c[0], c[1]);
    $c3cb186d790dfa49$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $c3cb186d790dfa49$var$w(d);
    return d;
};

});
parcelRequire.register("4QrSY", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5nsg4"));

});


parcelRequire.register("fHape", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b6d2f18fea3bc5b5$export$2b8d127b894957b9; }, function (v) { return $b6d2f18fea3bc5b5$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b6d2f18fea3bc5b5$export$cea3a54a6425200c; }, function (v) { return $b6d2f18fea3bc5b5$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b6d2f18fea3bc5b5$export$a7c73072b1a182ae; }, function (v) { return $b6d2f18fea3bc5b5$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b6d2f18fea3bc5b5$export$9f27bc3417b4524d; }, function (v) { return $b6d2f18fea3bc5b5$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b6d2f18fea3bc5b5$export$db77ccec0bb4ccac; }, function (v) { return $b6d2f18fea3bc5b5$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b6d2f18fea3bc5b5$export$8392c0c9d3dcbd35; }, function (v) { return $b6d2f18fea3bc5b5$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b6d2f18fea3bc5b5$export$ffb0004e005737fa; }, function (v) { return $b6d2f18fea3bc5b5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b6d2f18fea3bc5b5$export$b624eff549462981; }, function (v) { return $b6d2f18fea3bc5b5$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b6d2f18fea3bc5b5$export$7897aa7841a5380c; }, function (v) { return $b6d2f18fea3bc5b5$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b6d2f18fea3bc5b5$export$602eac185826482c; }, function (v) { return $b6d2f18fea3bc5b5$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b6d2f18fea3bc5b5$export$e2c29f18771995cb; }, function (v) { return $b6d2f18fea3bc5b5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b6d2f18fea3bc5b5$export$5f8d39834fd61797; }, function (v) { return $b6d2f18fea3bc5b5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b6d2f18fea3bc5b5$export$74bf444e3cd11ea5; }, function (v) { return $b6d2f18fea3bc5b5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b6d2f18fea3bc5b5$export$92387174baf9b227; }, function (v) { return $b6d2f18fea3bc5b5$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b6d2f18fea3bc5b5$export$ec112efeb987d9c6; }, function (v) { return $b6d2f18fea3bc5b5$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b6d2f18fea3bc5b5$export$b706b080d889d2c9; }, function (v) { return $b6d2f18fea3bc5b5$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b6d2f18fea3bc5b5$export$5be5a87408f70ddc; }, function (v) { return $b6d2f18fea3bc5b5$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b6d2f18fea3bc5b5$export$45a5e7f76e0caa8d; }, function (v) { return $b6d2f18fea3bc5b5$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b6d2f18fea3bc5b5$export$455c2e768291efa6; }, function (v) { return $b6d2f18fea3bc5b5$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b6d2f18fea3bc5b5$export$9522e17588c12572; }, function (v) { return $b6d2f18fea3bc5b5$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b6d2f18fea3bc5b5$export$2110ac352bb060b9; }, function (v) { return $b6d2f18fea3bc5b5$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b6d2f18fea3bc5b5$export$56885ab8b9c456ab; }, function (v) { return $b6d2f18fea3bc5b5$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b6d2f18fea3bc5b5$export$d927fcb6adf8f9de; }, function (v) { return $b6d2f18fea3bc5b5$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b6d2f18fea3bc5b5$export$b82d16f27459e05a; }, function (v) { return $b6d2f18fea3bc5b5$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b6d2f18fea3bc5b5$export$522c17b4f5e123e8; }, function (v) { return $b6d2f18fea3bc5b5$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b6d2f18fea3bc5b5$export$1aabd8a0274ecfd6; }, function (v) { return $b6d2f18fea3bc5b5$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b6d2f18fea3bc5b5$export$9b621391a187a31a; }, function (v) { return $b6d2f18fea3bc5b5$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b6d2f18fea3bc5b5$export$f5bbd400c2f4426f; }, function (v) { return $b6d2f18fea3bc5b5$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b6d2f18fea3bc5b5$export$2b8d127b894957b9;
var $b6d2f18fea3bc5b5$export$cea3a54a6425200c;
var $b6d2f18fea3bc5b5$export$a7c73072b1a182ae;
var $b6d2f18fea3bc5b5$export$9f27bc3417b4524d;
var $b6d2f18fea3bc5b5$export$db77ccec0bb4ccac;
var $b6d2f18fea3bc5b5$export$8392c0c9d3dcbd35;
var $b6d2f18fea3bc5b5$export$ffb0004e005737fa;
var $b6d2f18fea3bc5b5$export$b624eff549462981;
var $b6d2f18fea3bc5b5$export$7897aa7841a5380c;
var $b6d2f18fea3bc5b5$export$602eac185826482c;
var $b6d2f18fea3bc5b5$export$e2c29f18771995cb;
var $b6d2f18fea3bc5b5$export$5f8d39834fd61797;
var $b6d2f18fea3bc5b5$export$74bf444e3cd11ea5;
var $b6d2f18fea3bc5b5$export$92387174baf9b227;
var $b6d2f18fea3bc5b5$export$ec112efeb987d9c6;
var $b6d2f18fea3bc5b5$export$b706b080d889d2c9;
var $b6d2f18fea3bc5b5$export$5be5a87408f70ddc;
var $b6d2f18fea3bc5b5$export$45a5e7f76e0caa8d;
var $b6d2f18fea3bc5b5$export$455c2e768291efa6;
var $b6d2f18fea3bc5b5$export$9522e17588c12572;
var $b6d2f18fea3bc5b5$export$2110ac352bb060b9;
var $b6d2f18fea3bc5b5$export$56885ab8b9c456ab;
var $b6d2f18fea3bc5b5$export$d927fcb6adf8f9de;
var $b6d2f18fea3bc5b5$export$b82d16f27459e05a;
var $b6d2f18fea3bc5b5$export$522c17b4f5e123e8;
var $b6d2f18fea3bc5b5$export$1aabd8a0274ecfd6;
var $b6d2f18fea3bc5b5$export$9b621391a187a31a;
var $b6d2f18fea3bc5b5$export$f5bbd400c2f4426f;
"use strict";
var $b6d2f18fea3bc5b5$var$b = "function" === typeof Symbol && Symbol.for, $b6d2f18fea3bc5b5$var$c = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.element") : 60103, $b6d2f18fea3bc5b5$var$d = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.portal") : 60106, $b6d2f18fea3bc5b5$var$e = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.fragment") : 60107, $b6d2f18fea3bc5b5$var$f = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.strict_mode") : 60108, $b6d2f18fea3bc5b5$var$g = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.profiler") : 60114, $b6d2f18fea3bc5b5$var$h = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.provider") : 60109, $b6d2f18fea3bc5b5$var$k = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.context") : 60110, $b6d2f18fea3bc5b5$var$l = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.async_mode") : 60111, $b6d2f18fea3bc5b5$var$m = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b6d2f18fea3bc5b5$var$n = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.forward_ref") : 60112, $b6d2f18fea3bc5b5$var$p = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.suspense") : 60113, $b6d2f18fea3bc5b5$var$q = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.suspense_list") : 60120, $b6d2f18fea3bc5b5$var$r = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.memo") : 60115, $b6d2f18fea3bc5b5$var$t = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.lazy") : 60116, $b6d2f18fea3bc5b5$var$v = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.block") : 60121, $b6d2f18fea3bc5b5$var$w = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.fundamental") : 60117, $b6d2f18fea3bc5b5$var$x = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.responder") : 60118, $b6d2f18fea3bc5b5$var$y = $b6d2f18fea3bc5b5$var$b ? Symbol.for("react.scope") : 60119;
function $b6d2f18fea3bc5b5$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b6d2f18fea3bc5b5$var$c:
                switch(a = a.type, a){
                    case $b6d2f18fea3bc5b5$var$l:
                    case $b6d2f18fea3bc5b5$var$m:
                    case $b6d2f18fea3bc5b5$var$e:
                    case $b6d2f18fea3bc5b5$var$g:
                    case $b6d2f18fea3bc5b5$var$f:
                    case $b6d2f18fea3bc5b5$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b6d2f18fea3bc5b5$var$k:
                            case $b6d2f18fea3bc5b5$var$n:
                            case $b6d2f18fea3bc5b5$var$t:
                            case $b6d2f18fea3bc5b5$var$r:
                            case $b6d2f18fea3bc5b5$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b6d2f18fea3bc5b5$var$d:
                return u;
        }
    }
}
function $b6d2f18fea3bc5b5$var$A(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$m;
}
$b6d2f18fea3bc5b5$export$2b8d127b894957b9 = $b6d2f18fea3bc5b5$var$l;
$b6d2f18fea3bc5b5$export$cea3a54a6425200c = $b6d2f18fea3bc5b5$var$m;
$b6d2f18fea3bc5b5$export$a7c73072b1a182ae = $b6d2f18fea3bc5b5$var$k;
$b6d2f18fea3bc5b5$export$9f27bc3417b4524d = $b6d2f18fea3bc5b5$var$h;
$b6d2f18fea3bc5b5$export$db77ccec0bb4ccac = $b6d2f18fea3bc5b5$var$c;
$b6d2f18fea3bc5b5$export$8392c0c9d3dcbd35 = $b6d2f18fea3bc5b5$var$n;
$b6d2f18fea3bc5b5$export$ffb0004e005737fa = $b6d2f18fea3bc5b5$var$e;
$b6d2f18fea3bc5b5$export$b624eff549462981 = $b6d2f18fea3bc5b5$var$t;
$b6d2f18fea3bc5b5$export$7897aa7841a5380c = $b6d2f18fea3bc5b5$var$r;
$b6d2f18fea3bc5b5$export$602eac185826482c = $b6d2f18fea3bc5b5$var$d;
$b6d2f18fea3bc5b5$export$e2c29f18771995cb = $b6d2f18fea3bc5b5$var$g;
$b6d2f18fea3bc5b5$export$5f8d39834fd61797 = $b6d2f18fea3bc5b5$var$f;
$b6d2f18fea3bc5b5$export$74bf444e3cd11ea5 = $b6d2f18fea3bc5b5$var$p;
$b6d2f18fea3bc5b5$export$92387174baf9b227 = function(a) {
    return $b6d2f18fea3bc5b5$var$A(a) || $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$l;
};
$b6d2f18fea3bc5b5$export$ec112efeb987d9c6 = $b6d2f18fea3bc5b5$var$A;
$b6d2f18fea3bc5b5$export$b706b080d889d2c9 = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$k;
};
$b6d2f18fea3bc5b5$export$5be5a87408f70ddc = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$h;
};
$b6d2f18fea3bc5b5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b6d2f18fea3bc5b5$var$c;
};
$b6d2f18fea3bc5b5$export$455c2e768291efa6 = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$n;
};
$b6d2f18fea3bc5b5$export$9522e17588c12572 = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$e;
};
$b6d2f18fea3bc5b5$export$2110ac352bb060b9 = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$t;
};
$b6d2f18fea3bc5b5$export$56885ab8b9c456ab = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$r;
};
$b6d2f18fea3bc5b5$export$d927fcb6adf8f9de = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$d;
};
$b6d2f18fea3bc5b5$export$b82d16f27459e05a = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$g;
};
$b6d2f18fea3bc5b5$export$522c17b4f5e123e8 = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$f;
};
$b6d2f18fea3bc5b5$export$1aabd8a0274ecfd6 = function(a) {
    return $b6d2f18fea3bc5b5$var$z(a) === $b6d2f18fea3bc5b5$var$p;
};
$b6d2f18fea3bc5b5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b6d2f18fea3bc5b5$var$e || a === $b6d2f18fea3bc5b5$var$m || a === $b6d2f18fea3bc5b5$var$g || a === $b6d2f18fea3bc5b5$var$f || a === $b6d2f18fea3bc5b5$var$p || a === $b6d2f18fea3bc5b5$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b6d2f18fea3bc5b5$var$t || a.$$typeof === $b6d2f18fea3bc5b5$var$r || a.$$typeof === $b6d2f18fea3bc5b5$var$h || a.$$typeof === $b6d2f18fea3bc5b5$var$k || a.$$typeof === $b6d2f18fea3bc5b5$var$n || a.$$typeof === $b6d2f18fea3bc5b5$var$w || a.$$typeof === $b6d2f18fea3bc5b5$var$x || a.$$typeof === $b6d2f18fea3bc5b5$var$y || a.$$typeof === $b6d2f18fea3bc5b5$var$v);
};
$b6d2f18fea3bc5b5$export$f5bbd400c2f4426f = $b6d2f18fea3bc5b5$var$z;

});

parcelRequire.register("jwyvl", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $e36bc5636cf9a0ec$export$a7c73072b1a182ae; }, function (v) { return $e36bc5636cf9a0ec$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e36bc5636cf9a0ec$export$9f27bc3417b4524d; }, function (v) { return $e36bc5636cf9a0ec$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e36bc5636cf9a0ec$export$db77ccec0bb4ccac; }, function (v) { return $e36bc5636cf9a0ec$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e36bc5636cf9a0ec$export$8392c0c9d3dcbd35; }, function (v) { return $e36bc5636cf9a0ec$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e36bc5636cf9a0ec$export$ffb0004e005737fa; }, function (v) { return $e36bc5636cf9a0ec$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e36bc5636cf9a0ec$export$b624eff549462981; }, function (v) { return $e36bc5636cf9a0ec$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e36bc5636cf9a0ec$export$7897aa7841a5380c; }, function (v) { return $e36bc5636cf9a0ec$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e36bc5636cf9a0ec$export$602eac185826482c; }, function (v) { return $e36bc5636cf9a0ec$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e36bc5636cf9a0ec$export$e2c29f18771995cb; }, function (v) { return $e36bc5636cf9a0ec$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e36bc5636cf9a0ec$export$5f8d39834fd61797; }, function (v) { return $e36bc5636cf9a0ec$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e36bc5636cf9a0ec$export$74bf444e3cd11ea5; }, function (v) { return $e36bc5636cf9a0ec$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $e36bc5636cf9a0ec$export$998bcd577473dd93; }, function (v) { return $e36bc5636cf9a0ec$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e36bc5636cf9a0ec$export$92387174baf9b227; }, function (v) { return $e36bc5636cf9a0ec$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e36bc5636cf9a0ec$export$ec112efeb987d9c6; }, function (v) { return $e36bc5636cf9a0ec$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e36bc5636cf9a0ec$export$b706b080d889d2c9; }, function (v) { return $e36bc5636cf9a0ec$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e36bc5636cf9a0ec$export$5be5a87408f70ddc; }, function (v) { return $e36bc5636cf9a0ec$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e36bc5636cf9a0ec$export$45a5e7f76e0caa8d; }, function (v) { return $e36bc5636cf9a0ec$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e36bc5636cf9a0ec$export$455c2e768291efa6; }, function (v) { return $e36bc5636cf9a0ec$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e36bc5636cf9a0ec$export$9522e17588c12572; }, function (v) { return $e36bc5636cf9a0ec$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e36bc5636cf9a0ec$export$2110ac352bb060b9; }, function (v) { return $e36bc5636cf9a0ec$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e36bc5636cf9a0ec$export$56885ab8b9c456ab; }, function (v) { return $e36bc5636cf9a0ec$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e36bc5636cf9a0ec$export$d927fcb6adf8f9de; }, function (v) { return $e36bc5636cf9a0ec$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e36bc5636cf9a0ec$export$b82d16f27459e05a; }, function (v) { return $e36bc5636cf9a0ec$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e36bc5636cf9a0ec$export$522c17b4f5e123e8; }, function (v) { return $e36bc5636cf9a0ec$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e36bc5636cf9a0ec$export$1aabd8a0274ecfd6; }, function (v) { return $e36bc5636cf9a0ec$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $e36bc5636cf9a0ec$export$3d6c20d97e46b957; }, function (v) { return $e36bc5636cf9a0ec$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e36bc5636cf9a0ec$export$9b621391a187a31a; }, function (v) { return $e36bc5636cf9a0ec$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e36bc5636cf9a0ec$export$f5bbd400c2f4426f; }, function (v) { return $e36bc5636cf9a0ec$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e36bc5636cf9a0ec$export$a7c73072b1a182ae;
var $e36bc5636cf9a0ec$export$9f27bc3417b4524d;
var $e36bc5636cf9a0ec$export$db77ccec0bb4ccac;
var $e36bc5636cf9a0ec$export$8392c0c9d3dcbd35;
var $e36bc5636cf9a0ec$export$ffb0004e005737fa;
var $e36bc5636cf9a0ec$export$b624eff549462981;
var $e36bc5636cf9a0ec$export$7897aa7841a5380c;
var $e36bc5636cf9a0ec$export$602eac185826482c;
var $e36bc5636cf9a0ec$export$e2c29f18771995cb;
var $e36bc5636cf9a0ec$export$5f8d39834fd61797;
var $e36bc5636cf9a0ec$export$74bf444e3cd11ea5;
var $e36bc5636cf9a0ec$export$998bcd577473dd93;
var $e36bc5636cf9a0ec$export$92387174baf9b227;
var $e36bc5636cf9a0ec$export$ec112efeb987d9c6;
var $e36bc5636cf9a0ec$export$b706b080d889d2c9;
var $e36bc5636cf9a0ec$export$5be5a87408f70ddc;
var $e36bc5636cf9a0ec$export$45a5e7f76e0caa8d;
var $e36bc5636cf9a0ec$export$455c2e768291efa6;
var $e36bc5636cf9a0ec$export$9522e17588c12572;
var $e36bc5636cf9a0ec$export$2110ac352bb060b9;
var $e36bc5636cf9a0ec$export$56885ab8b9c456ab;
var $e36bc5636cf9a0ec$export$d927fcb6adf8f9de;
var $e36bc5636cf9a0ec$export$b82d16f27459e05a;
var $e36bc5636cf9a0ec$export$522c17b4f5e123e8;
var $e36bc5636cf9a0ec$export$1aabd8a0274ecfd6;
var $e36bc5636cf9a0ec$export$3d6c20d97e46b957;
var $e36bc5636cf9a0ec$export$9b621391a187a31a;
var $e36bc5636cf9a0ec$export$f5bbd400c2f4426f;
"use strict";
var $e36bc5636cf9a0ec$var$b = Symbol.for("react.element"), $e36bc5636cf9a0ec$var$c = Symbol.for("react.portal"), $e36bc5636cf9a0ec$var$d = Symbol.for("react.fragment"), $e36bc5636cf9a0ec$var$e = Symbol.for("react.strict_mode"), $e36bc5636cf9a0ec$var$f = Symbol.for("react.profiler"), $e36bc5636cf9a0ec$var$g = Symbol.for("react.provider"), $e36bc5636cf9a0ec$var$h = Symbol.for("react.context"), $e36bc5636cf9a0ec$var$k = Symbol.for("react.server_context"), $e36bc5636cf9a0ec$var$l = Symbol.for("react.forward_ref"), $e36bc5636cf9a0ec$var$m = Symbol.for("react.suspense"), $e36bc5636cf9a0ec$var$n = Symbol.for("react.suspense_list"), $e36bc5636cf9a0ec$var$p = Symbol.for("react.memo"), $e36bc5636cf9a0ec$var$q = Symbol.for("react.lazy"), $e36bc5636cf9a0ec$var$t = Symbol.for("react.offscreen"), $e36bc5636cf9a0ec$var$u;
$e36bc5636cf9a0ec$var$u = Symbol.for("react.module.reference");
function $e36bc5636cf9a0ec$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $e36bc5636cf9a0ec$var$b:
                switch(a = a.type, a){
                    case $e36bc5636cf9a0ec$var$d:
                    case $e36bc5636cf9a0ec$var$f:
                    case $e36bc5636cf9a0ec$var$e:
                    case $e36bc5636cf9a0ec$var$m:
                    case $e36bc5636cf9a0ec$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e36bc5636cf9a0ec$var$k:
                            case $e36bc5636cf9a0ec$var$h:
                            case $e36bc5636cf9a0ec$var$l:
                            case $e36bc5636cf9a0ec$var$q:
                            case $e36bc5636cf9a0ec$var$p:
                            case $e36bc5636cf9a0ec$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $e36bc5636cf9a0ec$var$c:
                return r;
        }
    }
}
$e36bc5636cf9a0ec$export$a7c73072b1a182ae = $e36bc5636cf9a0ec$var$h;
$e36bc5636cf9a0ec$export$9f27bc3417b4524d = $e36bc5636cf9a0ec$var$g;
$e36bc5636cf9a0ec$export$db77ccec0bb4ccac = $e36bc5636cf9a0ec$var$b;
$e36bc5636cf9a0ec$export$8392c0c9d3dcbd35 = $e36bc5636cf9a0ec$var$l;
$e36bc5636cf9a0ec$export$ffb0004e005737fa = $e36bc5636cf9a0ec$var$d;
$e36bc5636cf9a0ec$export$b624eff549462981 = $e36bc5636cf9a0ec$var$q;
$e36bc5636cf9a0ec$export$7897aa7841a5380c = $e36bc5636cf9a0ec$var$p;
$e36bc5636cf9a0ec$export$602eac185826482c = $e36bc5636cf9a0ec$var$c;
$e36bc5636cf9a0ec$export$e2c29f18771995cb = $e36bc5636cf9a0ec$var$f;
$e36bc5636cf9a0ec$export$5f8d39834fd61797 = $e36bc5636cf9a0ec$var$e;
$e36bc5636cf9a0ec$export$74bf444e3cd11ea5 = $e36bc5636cf9a0ec$var$m;
$e36bc5636cf9a0ec$export$998bcd577473dd93 = $e36bc5636cf9a0ec$var$n;
$e36bc5636cf9a0ec$export$92387174baf9b227 = function() {
    return !1;
};
$e36bc5636cf9a0ec$export$ec112efeb987d9c6 = function() {
    return !1;
};
$e36bc5636cf9a0ec$export$b706b080d889d2c9 = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$h;
};
$e36bc5636cf9a0ec$export$5be5a87408f70ddc = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$g;
};
$e36bc5636cf9a0ec$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e36bc5636cf9a0ec$var$b;
};
$e36bc5636cf9a0ec$export$455c2e768291efa6 = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$l;
};
$e36bc5636cf9a0ec$export$9522e17588c12572 = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$d;
};
$e36bc5636cf9a0ec$export$2110ac352bb060b9 = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$q;
};
$e36bc5636cf9a0ec$export$56885ab8b9c456ab = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$p;
};
$e36bc5636cf9a0ec$export$d927fcb6adf8f9de = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$c;
};
$e36bc5636cf9a0ec$export$b82d16f27459e05a = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$f;
};
$e36bc5636cf9a0ec$export$522c17b4f5e123e8 = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$e;
};
$e36bc5636cf9a0ec$export$1aabd8a0274ecfd6 = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$m;
};
$e36bc5636cf9a0ec$export$3d6c20d97e46b957 = function(a) {
    return $e36bc5636cf9a0ec$var$v(a) === $e36bc5636cf9a0ec$var$n;
};
$e36bc5636cf9a0ec$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e36bc5636cf9a0ec$var$d || a === $e36bc5636cf9a0ec$var$f || a === $e36bc5636cf9a0ec$var$e || a === $e36bc5636cf9a0ec$var$m || a === $e36bc5636cf9a0ec$var$n || a === $e36bc5636cf9a0ec$var$t || "object" === typeof a && null !== a && (a.$$typeof === $e36bc5636cf9a0ec$var$q || a.$$typeof === $e36bc5636cf9a0ec$var$p || a.$$typeof === $e36bc5636cf9a0ec$var$g || a.$$typeof === $e36bc5636cf9a0ec$var$h || a.$$typeof === $e36bc5636cf9a0ec$var$l || a.$$typeof === $e36bc5636cf9a0ec$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$e36bc5636cf9a0ec$export$f5bbd400c2f4426f = $e36bc5636cf9a0ec$var$v;

});

parcelRequire.register("b3NZy", function(module, exports) {
/* global window */ 
var $R4EgP = parcelRequire("R4EgP");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $R4EgP.default)(root);
var $80d6c0d5b5206416$export$2e2bcd8739ae039 = result;

});
parcelRequire.register("R4EgP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09f88e73b7a54933$export$2e2bcd8739ae039; });
function $09f88e73b7a54933$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === "function") // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for("https://github.com/benlesh/symbol-observable");
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol("https://github.com/benlesh/symbol-observable");
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});


parcelRequire.register("9flmG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $6bb616678f8a0d07$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6bb616678f8a0d07$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6bb616678f8a0d07$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6bb616678f8a0d07$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6bb616678f8a0d07$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $6bb616678f8a0d07$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $6bb616678f8a0d07$var$hasSymbol = function(name) {
    return $6bb616678f8a0d07$var$hasSymbols() && Boolean(Symbol[name]);
};
var $6bb616678f8a0d07$var$getSymbol = function(name) {
    return $6bb616678f8a0d07$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($6bb616678f8a0d07$var$hasSymbols() && !$6bb616678f8a0d07$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $6bb616678f8a0d07$var$SymbolIterator = $6bb616678f8a0d07$var$getSymbol("iterator");
var $6bb616678f8a0d07$var$SymbolObservable = $6bb616678f8a0d07$var$getSymbol("observable");
var $6bb616678f8a0d07$var$SymbolSpecies = $6bb616678f8a0d07$var$getSymbol("species"); // === Abstract Operations ===
function $6bb616678f8a0d07$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $6bb616678f8a0d07$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$6bb616678f8a0d07$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $6bb616678f8a0d07$var$Observable;
}
function $6bb616678f8a0d07$var$isObservable(x) {
    return x instanceof $6bb616678f8a0d07$var$Observable; // SPEC: Brand check
}
function $6bb616678f8a0d07$var$hostReportError(e) {
    if ($6bb616678f8a0d07$var$hostReportError.log) $6bb616678f8a0d07$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $6bb616678f8a0d07$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $6bb616678f8a0d07$var$hostReportError(e);
        }
    });
}
function $6bb616678f8a0d07$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $6bb616678f8a0d07$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $6bb616678f8a0d07$var$hostReportError(e);
    }
}
function $6bb616678f8a0d07$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $6bb616678f8a0d07$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $6bb616678f8a0d07$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $6bb616678f8a0d07$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $6bb616678f8a0d07$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $6bb616678f8a0d07$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $6bb616678f8a0d07$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $6bb616678f8a0d07$var$hostReportError(e);
    }
    if (subscription._state === "closed") $6bb616678f8a0d07$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $6bb616678f8a0d07$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $6bb616678f8a0d07$var$enqueue(function() {
            return $6bb616678f8a0d07$var$flushSubscription(subscription);
        });
        return;
    }
    $6bb616678f8a0d07$var$notifySubscription(subscription, type, value);
}
var $6bb616678f8a0d07$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $6bb616678f8a0d07$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $6bb616678f8a0d07$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    $6bb616678f8a0d07$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== "closed") {
                    $6bb616678f8a0d07$var$closeSubscription(this);
                    $6bb616678f8a0d07$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $6bb616678f8a0d07$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $6bb616678f8a0d07$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $6bb616678f8a0d07$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $6bb616678f8a0d07$var$onNotify(this._subscription, "next", value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $6bb616678f8a0d07$var$onNotify(this._subscription, "error", value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $6bb616678f8a0d07$var$onNotify(this._subscription, "complete");
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $6bb616678f8a0d07$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $6bb616678f8a0d07$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    $6bb616678f8a0d07$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $6bb616678f8a0d07$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== "function") {
                        reject(new TypeError(fn + " is not a function"));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $6bb616678f8a0d07$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $6bb616678f8a0d07$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $6bb616678f8a0d07$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $6bb616678f8a0d07$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $6bb616678f8a0d07$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $6bb616678f8a0d07$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === "function" ? this : Observable;
                if (x == null) throw new TypeError(x + " is not an object");
                var method = $6bb616678f8a0d07$var$getMethod(x, $6bb616678f8a0d07$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
                    if ($6bb616678f8a0d07$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($6bb616678f8a0d07$var$hasSymbol("iterator")) {
                    method = $6bb616678f8a0d07$var$getMethod(x, $6bb616678f8a0d07$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $6bb616678f8a0d07$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $6bb616678f8a0d07$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + " is not observable");
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === "function" ? this : Observable;
                return new C(function(observer) {
                    $6bb616678f8a0d07$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $6bb616678f8a0d07$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $6bb616678f8a0d07$var$Observable;
if ($6bb616678f8a0d07$var$hasSymbols()) Object.defineProperty($6bb616678f8a0d07$var$Observable, Symbol("extensions"), {
    value: {
        symbol: $6bb616678f8a0d07$var$SymbolObservable,
        hostReportError: $6bb616678f8a0d07$var$hostReportError
    },
    configurable: true
});

});

parcelRequire.register("igxP1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $gsu1H = parcelRequire("gsu1H");
function $d4c3f4f1a8aab406$var$emptyFunction() {}
function $d4c3f4f1a8aab406$var$emptyFunctionWithReset() {}
$d4c3f4f1a8aab406$var$emptyFunctionWithReset.resetWarningCache = $d4c3f4f1a8aab406$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gsu1H) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d4c3f4f1a8aab406$var$emptyFunctionWithReset,
        resetWarningCache: $d4c3f4f1a8aab406$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("gsu1H", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $bfb68d77e477b45c$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $bfb68d77e477b45c$var$ReactPropTypesSecret;

});


parcelRequire.register("hhjKe", function(module, exports) {
"use strict";
function $c943571176c6d7a2$var$_interopDefault(e) {
    return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

var $c943571176c6d7a2$var$React = $c943571176c6d7a2$var$_interopDefault((parcelRequire("eXaQ2")));

var $80Kwh = parcelRequire("80Kwh");
function $c943571176c6d7a2$var$_defaults2(e, t) {
    for(var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++){
        var i = n[a], r = Object.getOwnPropertyDescriptor(t, i);
        r && r.configurable && e[i] === undefined && Object.defineProperty(e, i, r);
    }
    return e;
}
function $c943571176c6d7a2$var$_extends() {
    return ($c943571176c6d7a2$var$_extends = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var a in n)Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
        }
        return e;
    }).apply(this, arguments);
}
function $c943571176c6d7a2$var$_inheritsLoose(e, t) {
    e.prototype = Object.create(t.prototype), $c943571176c6d7a2$var$_defaults2(e.prototype.constructor = e, t);
}
function $c943571176c6d7a2$var$_objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var n, a, i = {}, r = Object.keys(e);
    for(a = 0; a < r.length; a++)n = r[a], 0 <= t.indexOf(n) || (i[n] = e[n]);
    return i;
}
function $c943571176c6d7a2$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
var $c943571176c6d7a2$var$invariant = function(e, t, n, a, i, r, o, s) {
    if (!e) {
        var l;
        if (t === undefined) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var u = [
                n,
                a,
                i,
                r,
                o,
                s
            ], c = 0;
            (l = new Error(t.replace(/%s/g, function() {
                return u[c++];
            }))).name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
    }
}, $c943571176c6d7a2$var$invariant_1 = $c943571176c6d7a2$var$invariant;
function $c943571176c6d7a2$var$setInputSelection(e, t, n) {
    if ("selectionStart" in e && "selectionEnd" in e) e.selectionStart = t, e.selectionEnd = n;
    else {
        var a = e.createTextRange();
        a.collapse(!0), a.moveStart("character", t), a.moveEnd("character", n - t), a.select();
    }
}
function $c943571176c6d7a2$var$getInputSelection(e) {
    var t = 0, n = 0;
    if ("selectionStart" in e && "selectionEnd" in e) t = e.selectionStart, n = e.selectionEnd;
    else {
        var a = document.selection.createRange();
        a.parentElement() === e && (t = -a.moveStart("character", -e.value.length), n = -a.moveEnd("character", -e.value.length));
    }
    return {
        start: t,
        end: n,
        length: n - t
    };
}
var $c943571176c6d7a2$var$defaultFormatChars = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
}, $c943571176c6d7a2$var$defaultMaskChar = "_";
function $c943571176c6d7a2$var$parseMask(e, t, n) {
    var a = "", i = "", r = null, o = [];
    if (t === undefined && (t = $c943571176c6d7a2$var$defaultMaskChar), null == n && (n = $c943571176c6d7a2$var$defaultFormatChars), !e || "string" != typeof e) return {
        maskChar: t,
        formatChars: n,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
    };
    var s = !1;
    return e.split("").forEach(function(e) {
        s = !s && "\\" === e || (s || !n[e] ? (o.push(a.length), a.length === o.length - 1 && (i += e)) : r = a.length + 1, a += e, !1);
    }), {
        maskChar: t,
        formatChars: n,
        prefix: i,
        mask: a,
        lastEditablePosition: r,
        permanents: o
    };
}
function $c943571176c6d7a2$var$isPermanentCharacter(e, t) {
    return -1 !== e.permanents.indexOf(t);
}
function $c943571176c6d7a2$var$isAllowedCharacter(e, t, n) {
    var a = e.mask, i = e.formatChars;
    if (!n) return !1;
    if ($c943571176c6d7a2$var$isPermanentCharacter(e, t)) return a[t] === n;
    var r = i[a[t]];
    return new RegExp(r).test(n);
}
function $c943571176c6d7a2$var$isEmpty(n, e) {
    return e.split("").every(function(e, t) {
        return $c943571176c6d7a2$var$isPermanentCharacter(n, t) || !$c943571176c6d7a2$var$isAllowedCharacter(n, t, e);
    });
}
function $c943571176c6d7a2$var$getFilledLength(e, t) {
    var n = e.maskChar, a = e.prefix;
    if (!n) {
        for(; t.length > a.length && $c943571176c6d7a2$var$isPermanentCharacter(e, t.length - 1);)t = t.slice(0, t.length - 1);
        return t.length;
    }
    for(var i = a.length, r = t.length; r >= a.length; r--){
        var o = t[r];
        if (!$c943571176c6d7a2$var$isPermanentCharacter(e, r) && $c943571176c6d7a2$var$isAllowedCharacter(e, r, o)) {
            i = r + 1;
            break;
        }
    }
    return i;
}
function $c943571176c6d7a2$var$isFilled(e, t) {
    return $c943571176c6d7a2$var$getFilledLength(e, t) === e.mask.length;
}
function $c943571176c6d7a2$var$formatValue(e, t) {
    var n = e.maskChar, a = e.mask, i = e.prefix;
    if (!n) {
        for((t = $c943571176c6d7a2$var$insertString(e, "", t, 0)).length < i.length && (t = i); t.length < a.length && $c943571176c6d7a2$var$isPermanentCharacter(e, t.length);)t += a[t.length];
        return t;
    }
    if (t) return $c943571176c6d7a2$var$insertString(e, $c943571176c6d7a2$var$formatValue(e, ""), t, 0);
    for(var r = 0; r < a.length; r++)$c943571176c6d7a2$var$isPermanentCharacter(e, r) ? t += a[r] : t += n;
    return t;
}
function $c943571176c6d7a2$var$clearRange(n, e, a, t) {
    var i = a + t, r = n.maskChar, o = n.mask, s = n.prefix, l = e.split("");
    if (r) return l.map(function(e, t) {
        return t < a || i <= t ? e : $c943571176c6d7a2$var$isPermanentCharacter(n, t) ? o[t] : r;
    }).join("");
    for(var u = i; u < l.length; u++)$c943571176c6d7a2$var$isPermanentCharacter(n, u) && (l[u] = "");
    return a = Math.max(s.length, a), l.splice(a, i - a), e = l.join(""), $c943571176c6d7a2$var$formatValue(n, e);
}
function $c943571176c6d7a2$var$insertString(r, o, e, s) {
    var l = r.mask, u = r.maskChar, c = r.prefix, t = e.split(""), h = $c943571176c6d7a2$var$isFilled(r, o);
    return !u && s > o.length && (o += l.slice(o.length, s)), t.every(function(e) {
        for(; i = e, $c943571176c6d7a2$var$isPermanentCharacter(r, a = s) && i !== l[a];){
            if (s >= o.length && (o += l[s]), t = e, n = s, u && $c943571176c6d7a2$var$isPermanentCharacter(r, n) && t === u) return !0;
            if (++s >= l.length) return !1;
        }
        var t, n, a, i;
        return !$c943571176c6d7a2$var$isAllowedCharacter(r, s, e) && e !== u || (s < o.length ? o = u || h || s < c.length ? o.slice(0, s) + e + o.slice(s + 1) : (o = o.slice(0, s) + e + o.slice(s), $c943571176c6d7a2$var$formatValue(r, o)) : u || (o += e), ++s < l.length);
    }), o;
}
function $c943571176c6d7a2$var$getInsertStringLength(a, e, t, i) {
    var r = a.mask, o = a.maskChar, n = t.split(""), s = i;
    return n.every(function(e) {
        for(; n = e, $c943571176c6d7a2$var$isPermanentCharacter(a, t = i) && n !== r[t];)if (++i >= r.length) return !1;
        var t, n;
        return ($c943571176c6d7a2$var$isAllowedCharacter(a, i, e) || e === o) && i++, i < r.length;
    }), i - s;
}
function $c943571176c6d7a2$var$getLeftEditablePosition(e, t) {
    for(var n = t; 0 <= n; --n)if (!$c943571176c6d7a2$var$isPermanentCharacter(e, n)) return n;
    return null;
}
function $c943571176c6d7a2$var$getRightEditablePosition(e, t) {
    for(var n = e.mask, a = t; a < n.length; ++a)if (!$c943571176c6d7a2$var$isPermanentCharacter(e, a)) return a;
    return null;
}
function $c943571176c6d7a2$var$getStringValue(e) {
    return e || 0 === e ? e + "" : "";
}
function $c943571176c6d7a2$var$processChange(e, t, n, a, i) {
    var r = e.mask, o = e.prefix, s = e.lastEditablePosition, l = t, u = "", c = 0, h = 0, f = Math.min(i.start, n.start);
    if (n.end > i.start ? h = (c = $c943571176c6d7a2$var$getInsertStringLength(e, a, u = l.slice(i.start, n.end), f)) ? i.length : 0 : l.length < a.length && (h = a.length - l.length), l = a, h) {
        if (1 === h && !i.length) f = i.start === n.start ? $c943571176c6d7a2$var$getRightEditablePosition(e, n.start) : $c943571176c6d7a2$var$getLeftEditablePosition(e, n.start);
        l = $c943571176c6d7a2$var$clearRange(e, l, f, h);
    }
    return l = $c943571176c6d7a2$var$insertString(e, l, u, f), (f += c) >= r.length ? f = r.length : f < o.length && !c ? f = o.length : f >= o.length && f < s && c && (f = $c943571176c6d7a2$var$getRightEditablePosition(e, f)), u || (u = null), {
        value: l = $c943571176c6d7a2$var$formatValue(e, l),
        enteredString: u,
        selection: {
            start: f,
            end: f
        }
    };
}
function $c943571176c6d7a2$var$isWindowsPhoneBrowser() {
    var e = new RegExp("windows", "i"), t = new RegExp("phone", "i"), n = navigator.userAgent;
    return e.test(n) && t.test(n);
}
function $c943571176c6d7a2$var$isFunction(e) {
    return "function" == typeof e;
}
function $c943571176c6d7a2$var$getRequestAnimationFrame() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
}
function $c943571176c6d7a2$var$getCancelAnimationFrame() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
}
function $c943571176c6d7a2$var$defer(e) {
    return (!!$c943571176c6d7a2$var$getCancelAnimationFrame() ? $c943571176c6d7a2$var$getRequestAnimationFrame() : function() {
        return setTimeout(e, 1e3 / 60);
    })(e);
}
function $c943571176c6d7a2$var$cancelDefer(e) {
    ($c943571176c6d7a2$var$getCancelAnimationFrame() || clearTimeout)(e);
}
var $c943571176c6d7a2$var$InputElement = function(c) {
    function e(e) {
        var f = c.call(this, e) || this;
        f.focused = !1, f.mounted = !1, f.previousSelection = null, f.selectionDeferId = null, f.saveSelectionLoopDeferId = null, f.saveSelectionLoop = function() {
            f.previousSelection = f.getSelection(), f.saveSelectionLoopDeferId = $c943571176c6d7a2$var$defer(f.saveSelectionLoop);
        }, f.runSaveSelectionLoop = function() {
            null === f.saveSelectionLoopDeferId && f.saveSelectionLoop();
        }, f.stopSaveSelectionLoop = function() {
            null !== f.saveSelectionLoopDeferId && ($c943571176c6d7a2$var$cancelDefer(f.saveSelectionLoopDeferId), f.saveSelectionLoopDeferId = null, f.previousSelection = null);
        }, f.getInputDOMNode = function() {
            if (!f.mounted) return null;
            var e = $80Kwh.findDOMNode($c943571176c6d7a2$var$_assertThisInitialized($c943571176c6d7a2$var$_assertThisInitialized(f))), t = "undefined" != typeof window && e instanceof window.Element;
            if (e && !t) return null;
            if ("INPUT" !== e.nodeName && (e = e.querySelector("input")), !e) throw new Error("react-input-mask: inputComponent doesn't contain input node");
            return e;
        }, f.getInputValue = function() {
            var e = f.getInputDOMNode();
            return e ? e.value : null;
        }, f.setInputValue = function(e) {
            var t = f.getInputDOMNode();
            t && (f.value = e, t.value = e);
        }, f.setCursorToEnd = function() {
            var e = $c943571176c6d7a2$var$getFilledLength(f.maskOptions, f.value), t = $c943571176c6d7a2$var$getRightEditablePosition(f.maskOptions, e);
            null !== t && f.setCursorPosition(t);
        }, f.setSelection = function(e, t, n) {
            void 0 === n && (n = {});
            var a = f.getInputDOMNode(), i = f.isFocused();
            a && i && (n.deferred || $c943571176c6d7a2$var$setInputSelection(a, e, t), null !== f.selectionDeferId && $c943571176c6d7a2$var$cancelDefer(f.selectionDeferId), f.selectionDeferId = $c943571176c6d7a2$var$defer(function() {
                f.selectionDeferId = null, $c943571176c6d7a2$var$setInputSelection(a, e, t);
            }), f.previousSelection = {
                start: e,
                end: t,
                length: Math.abs(t - e)
            });
        }, f.getSelection = function() {
            return $c943571176c6d7a2$var$getInputSelection(f.getInputDOMNode());
        }, f.getCursorPosition = function() {
            return f.getSelection().start;
        }, f.setCursorPosition = function(e) {
            f.setSelection(e, e);
        }, f.isFocused = function() {
            return f.focused;
        }, f.getBeforeMaskedValueChangeConfig = function() {
            var e = f.maskOptions, t = e.mask, n = e.maskChar, a = e.permanents, i = e.formatChars;
            return {
                mask: t,
                maskChar: n,
                permanents: a,
                alwaysShowMask: !!f.props.alwaysShowMask,
                formatChars: i
            };
        }, f.isInputAutofilled = function(e, t, n, a) {
            var i = f.getInputDOMNode();
            try {
                if (i.matches(":-webkit-autofill")) return !0;
            } catch (r) {}
            return !f.focused || a.end < n.length && t.end === e.length;
        }, f.onChange = function(e) {
            var t = $c943571176c6d7a2$var$_assertThisInitialized($c943571176c6d7a2$var$_assertThisInitialized(f)).beforePasteState, n = $c943571176c6d7a2$var$_assertThisInitialized($c943571176c6d7a2$var$_assertThisInitialized(f)).previousSelection, a = f.props.beforeMaskedValueChange, i = f.getInputValue(), r = f.value, o = f.getSelection();
            f.isInputAutofilled(i, o, r, n) && (r = $c943571176c6d7a2$var$formatValue(f.maskOptions, ""), n = {
                start: 0,
                end: 0,
                length: 0
            }), t && (n = t.selection, r = t.value, o = {
                start: n.start + i.length,
                end: n.start + i.length,
                length: 0
            }, i = r.slice(0, n.start) + i + r.slice(n.end), f.beforePasteState = null);
            var s = $c943571176c6d7a2$var$processChange(f.maskOptions, i, o, r, n), l = s.enteredString, u = s.selection, c = s.value;
            if ($c943571176c6d7a2$var$isFunction(a)) {
                var h = a({
                    value: c,
                    selection: u
                }, {
                    value: r,
                    selection: n
                }, l, f.getBeforeMaskedValueChangeConfig());
                c = h.value, u = h.selection;
            }
            f.setInputValue(c), $c943571176c6d7a2$var$isFunction(f.props.onChange) && f.props.onChange(e), f.isWindowsPhoneBrowser ? f.setSelection(u.start, u.end, {
                deferred: !0
            }) : f.setSelection(u.start, u.end);
        }, f.onFocus = function(e) {
            var t = f.props.beforeMaskedValueChange, n = f.maskOptions, a = n.mask, i = n.prefix;
            if (f.focused = !0, f.mounted = !0, a) {
                if (f.value) $c943571176c6d7a2$var$getFilledLength(f.maskOptions, f.value) < f.maskOptions.mask.length && f.setCursorToEnd();
                else {
                    var r = $c943571176c6d7a2$var$formatValue(f.maskOptions, i), o = $c943571176c6d7a2$var$formatValue(f.maskOptions, r), s = $c943571176c6d7a2$var$getFilledLength(f.maskOptions, o), l = $c943571176c6d7a2$var$getRightEditablePosition(f.maskOptions, s), u = {
                        start: l,
                        end: l
                    };
                    if ($c943571176c6d7a2$var$isFunction(t)) {
                        var c = t({
                            value: o,
                            selection: u
                        }, {
                            value: f.value,
                            selection: null
                        }, null, f.getBeforeMaskedValueChangeConfig());
                        o = c.value, u = c.selection;
                    }
                    var h = o !== f.getInputValue();
                    h && f.setInputValue(o), h && $c943571176c6d7a2$var$isFunction(f.props.onChange) && f.props.onChange(e), f.setSelection(u.start, u.end);
                }
                f.runSaveSelectionLoop();
            }
            $c943571176c6d7a2$var$isFunction(f.props.onFocus) && f.props.onFocus(e);
        }, f.onBlur = function(e) {
            var t = f.props.beforeMaskedValueChange, n = f.maskOptions.mask;
            if (f.stopSaveSelectionLoop(), f.focused = !1, n && !f.props.alwaysShowMask && $c943571176c6d7a2$var$isEmpty(f.maskOptions, f.value)) {
                var a = "";
                if ($c943571176c6d7a2$var$isFunction(t)) a = t({
                    value: a,
                    selection: null
                }, {
                    value: f.value,
                    selection: f.previousSelection
                }, null, f.getBeforeMaskedValueChangeConfig()).value;
                var i = a !== f.getInputValue();
                i && f.setInputValue(a), i && $c943571176c6d7a2$var$isFunction(f.props.onChange) && f.props.onChange(e);
            }
            $c943571176c6d7a2$var$isFunction(f.props.onBlur) && f.props.onBlur(e);
        }, f.onMouseDown = function(e) {
            if (!f.focused && document.addEventListener) {
                f.mouseDownX = e.clientX, f.mouseDownY = e.clientY, f.mouseDownTime = (new Date).getTime();
                var r = function r(e) {
                    if (document.removeEventListener("mouseup", r), f.focused) {
                        var t = Math.abs(e.clientX - f.mouseDownX), n = Math.abs(e.clientY - f.mouseDownY), a = Math.max(t, n), i = (new Date).getTime() - f.mouseDownTime;
                        (a <= 10 && i <= 200 || a <= 5 && i <= 300) && f.setCursorToEnd();
                    }
                };
                document.addEventListener("mouseup", r);
            }
            $c943571176c6d7a2$var$isFunction(f.props.onMouseDown) && f.props.onMouseDown(e);
        }, f.onPaste = function(e) {
            $c943571176c6d7a2$var$isFunction(f.props.onPaste) && f.props.onPaste(e), e.defaultPrevented || (f.beforePasteState = {
                value: f.getInputValue(),
                selection: f.getSelection()
            }, f.setInputValue(""));
        }, f.handleRef = function(e) {
            null == f.props.children && $c943571176c6d7a2$var$isFunction(f.props.inputRef) && f.props.inputRef(e);
        };
        var t = e.mask, n = e.maskChar, a = e.formatChars, i = e.alwaysShowMask, r = e.beforeMaskedValueChange, o = e.defaultValue, s = e.value;
        f.maskOptions = $c943571176c6d7a2$var$parseMask(t, n, a), null == o && (o = ""), null == s && (s = o);
        var l = $c943571176c6d7a2$var$getStringValue(s);
        if (f.maskOptions.mask && (i || l) && (l = $c943571176c6d7a2$var$formatValue(f.maskOptions, l), $c943571176c6d7a2$var$isFunction(r))) {
            var u = e.value;
            null == e.value && (u = o), l = r({
                value: l,
                selection: null
            }, {
                value: u = $c943571176c6d7a2$var$getStringValue(u),
                selection: null
            }, null, f.getBeforeMaskedValueChangeConfig()).value;
        }
        return f.value = l, f;
    }
    $c943571176c6d7a2$var$_inheritsLoose(e, c);
    var t = e.prototype;
    return t.componentDidMount = function() {
        this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = $c943571176c6d7a2$var$isWindowsPhoneBrowser(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, t.componentDidUpdate = function() {
        var e = this.previousSelection, t = this.props, n = t.beforeMaskedValueChange, a = t.alwaysShowMask, i = t.mask, r = t.maskChar, o = t.formatChars, s = this.maskOptions, l = a || this.isFocused(), u = null != this.props.value, c = u ? $c943571176c6d7a2$var$getStringValue(this.props.value) : this.value, h = e ? e.start : null;
        if (this.maskOptions = $c943571176c6d7a2$var$parseMask(i, r, o), this.maskOptions.mask) {
            !s.mask && this.isFocused() && this.runSaveSelectionLoop();
            var f = this.maskOptions.mask && this.maskOptions.mask !== s.mask;
            if (s.mask || u || (c = this.getInputValue()), (f || this.maskOptions.mask && (c || l)) && (c = $c943571176c6d7a2$var$formatValue(this.maskOptions, c)), f) {
                var p = $c943571176c6d7a2$var$getFilledLength(this.maskOptions, c);
                (null === h || p < h) && (h = $c943571176c6d7a2$var$isFilled(this.maskOptions, c) ? p : $c943571176c6d7a2$var$getRightEditablePosition(this.maskOptions, p));
            }
            !this.maskOptions.mask || !$c943571176c6d7a2$var$isEmpty(this.maskOptions, c) || l || u && this.props.value || (c = "");
            var d = {
                start: h,
                end: h
            };
            if ($c943571176c6d7a2$var$isFunction(n)) {
                var m = n({
                    value: c,
                    selection: d
                }, {
                    value: this.value,
                    selection: this.previousSelection
                }, null, this.getBeforeMaskedValueChangeConfig());
                c = m.value, d = m.selection;
            }
            this.value = c;
            var g = this.getInputValue() !== this.value;
            g ? (this.setInputValue(this.value), this.forceUpdate()) : f && this.forceUpdate();
            var v = !1;
            null != d.start && null != d.end && (v = !e || e.start !== d.start || e.end !== d.end), (v || g) && this.setSelection(d.start, d.end);
        } else s.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, t.componentWillUnmount = function() {
        this.mounted = !1, null !== this.selectionDeferId && $c943571176c6d7a2$var$cancelDefer(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, t.render = function() {
        var t, e = this.props, n = (e.mask, e.alwaysShowMask, e.maskChar, e.formatChars, e.inputRef, e.beforeMaskedValueChange, e.children), a = $c943571176c6d7a2$var$_objectWithoutPropertiesLoose(e, [
            "mask",
            "alwaysShowMask",
            "maskChar",
            "formatChars",
            "inputRef",
            "beforeMaskedValueChange",
            "children"
        ]);
        if (n) {
            $c943571176c6d7a2$var$isFunction(n) || $c943571176c6d7a2$var$invariant_1(!1);
            var i = [
                "onChange",
                "onPaste",
                "onMouseDown",
                "onFocus",
                "onBlur",
                "value",
                "disabled",
                "readOnly"
            ], r = $c943571176c6d7a2$var$_extends({}, a);
            i.forEach(function(e) {
                return delete r[e];
            }), t = n(r), i.filter(function(e) {
                return null != t.props[e] && t.props[e] !== a[e];
            }).length && $c943571176c6d7a2$var$invariant_1(!1);
        } else t = $c943571176c6d7a2$var$React.createElement("input", $c943571176c6d7a2$var$_extends({
            ref: this.handleRef
        }, a));
        var o = {
            onFocus: this.onFocus,
            onBlur: this.onBlur
        };
        return this.maskOptions.mask && (a.disabled || a.readOnly || (o.onChange = this.onChange, o.onPaste = this.onPaste, o.onMouseDown = this.onMouseDown), null != a.value && (o.value = this.value)), t = $c943571176c6d7a2$var$React.cloneElement(t, o);
    }, e;
}($c943571176c6d7a2$var$React.Component);
module.exports = $c943571176c6d7a2$var$InputElement;

});
parcelRequire.register("80Kwh", function(module, exports) {
"use strict";
function $5d5268a35b0e64ee$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($5d5268a35b0e64ee$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$5d5268a35b0e64ee$var$checkDCE();

module.exports = (parcelRequire("cQaOR"));

});


parcelRequire.register("cE4fx", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRequire.register("kul33", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $92040325ceb96e24$export$2e2bcd8739ae039; });

var $AzipQ = parcelRequire("AzipQ");
var $92040325ceb96e24$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($AzipQ)));

});
parcelRequire.register("AzipQ", function(module, exports) {

var $02NG5 = parcelRequire("02NG5");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $06debdf6c8dfeff4$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $02NG5(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $06debdf6c8dfeff4$var$StyleToObject;
module.exports.default = $06debdf6c8dfeff4$var$StyleToObject; // ESM support

});
parcelRequire.register("02NG5", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $0086b90567c6700b$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $0086b90567c6700b$var$NEWLINE_REGEX = /\n/g;
var $0086b90567c6700b$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $0086b90567c6700b$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $0086b90567c6700b$var$COLON_REGEX = /^:\s*/;
var $0086b90567c6700b$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $0086b90567c6700b$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $0086b90567c6700b$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $0086b90567c6700b$var$NEWLINE = "\n";
var $0086b90567c6700b$var$FORWARD_SLASH = "/";
var $0086b90567c6700b$var$ASTERISK = "*";
var $0086b90567c6700b$var$EMPTY_STRING = "";
// types
var $0086b90567c6700b$var$TYPE_COMMENT = "comment";
var $0086b90567c6700b$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($0086b90567c6700b$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($0086b90567c6700b$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($0086b90567c6700b$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($0086b90567c6700b$var$FORWARD_SLASH != style.charAt(0) || $0086b90567c6700b$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($0086b90567c6700b$var$EMPTY_STRING != style.charAt(i) && ($0086b90567c6700b$var$ASTERISK != style.charAt(i) || $0086b90567c6700b$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($0086b90567c6700b$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $0086b90567c6700b$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($0086b90567c6700b$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($0086b90567c6700b$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($0086b90567c6700b$var$VALUE_REGEX);
        var ret = pos({
            type: $0086b90567c6700b$var$TYPE_DECLARATION,
            property: $0086b90567c6700b$var$trim(prop[0].replace($0086b90567c6700b$var$COMMENT_REGEX, $0086b90567c6700b$var$EMPTY_STRING)),
            value: val ? $0086b90567c6700b$var$trim(val[0].replace($0086b90567c6700b$var$COMMENT_REGEX, $0086b90567c6700b$var$EMPTY_STRING)) : $0086b90567c6700b$var$EMPTY_STRING
        });
        // ;
        match($0086b90567c6700b$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $0086b90567c6700b$var$trim(str) {
    return str ? str.replace($0086b90567c6700b$var$TRIM_REGEX, $0086b90567c6700b$var$EMPTY_STRING) : $0086b90567c6700b$var$EMPTY_STRING;
}

});



var $a1cc52fbd40b0eb4$exports = {};
"use strict";

$a1cc52fbd40b0eb4$exports = (parcelRequire("8XIvq"));


var $206751f6033bfbd8$export$882461b6382ed46c;
var $206751f6033bfbd8$export$757ceba2d55c277e;
"use strict";

var $80Kwh = parcelRequire("80Kwh");
var $206751f6033bfbd8$var$i;
$206751f6033bfbd8$export$882461b6382ed46c = $80Kwh.createRoot;
$206751f6033bfbd8$export$757ceba2d55c277e = $80Kwh.hydrateRoot;


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $4QrSY = parcelRequire("4QrSY");
var $50813aefa7450ddb$exports = {};
"use strict";

$50813aefa7450ddb$exports = (parcelRequire("gOcBI"));



var $80Kwh = parcelRequire("80Kwh");


var $80Kwh = parcelRequire("80Kwh");
// Default to a dummy "batch" implementation that just runs the callback
function $917cb4d654abf0d9$var$defaultNoopBatch(callback) {
    callback();
}
let $917cb4d654abf0d9$var$batch = $917cb4d654abf0d9$var$defaultNoopBatch; // Allow injecting another batching function later
const $917cb4d654abf0d9$export$4b9874722d0da7bc = (newBatch)=>$917cb4d654abf0d9$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $917cb4d654abf0d9$export$fc47d4c0ba3bd2c6 = ()=>$917cb4d654abf0d9$var$batch;



var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");
const $91adfd4e361c5fb3$var$ContextKey = Symbol.for(`react-redux-context`);
const $91adfd4e361c5fb3$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $91adfd4e361c5fb3$var$getContext() {
    var _gT$ContextKey;
    if (!$eXaQ2.createContext) return {};
    const contextMap = (_gT$ContextKey = $91adfd4e361c5fb3$var$gT[$91adfd4e361c5fb3$var$ContextKey]) != null ? _gT$ContextKey : $91adfd4e361c5fb3$var$gT[$91adfd4e361c5fb3$var$ContextKey] = new Map();
    let realContext = contextMap.get($eXaQ2.createContext);
    if (!realContext) {
        realContext = $eXaQ2.createContext(null);
        contextMap.set($eXaQ2.createContext, realContext);
    }
    return realContext;
}
const $91adfd4e361c5fb3$export$cc80c08dc91f1c00 = /*#__PURE__*/ $91adfd4e361c5fb3$var$getContext();
var $91adfd4e361c5fb3$export$2e2bcd8739ae039 = $91adfd4e361c5fb3$export$cc80c08dc91f1c00;


function $1851937f210d736f$export$d4d6226d5fc61558(context = (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $eXaQ2.useContext)(context);
        return contextValue;
    };
}
const $1851937f210d736f$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $1851937f210d736f$export$d4d6226d5fc61558();



const $4cf1506dc3ac666f$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $03bd938f38111844$var$useSyncExternalStoreWithSelector = (0, $4cf1506dc3ac666f$export$20656a4825650bd0);
const $03bd938f38111844$export$e2e6e3f3f3b782e3 = (fn)=>{
    $03bd938f38111844$var$useSyncExternalStoreWithSelector = fn;
};
const $03bd938f38111844$var$refEquality = (a, b)=>a === b;
function $03bd938f38111844$export$2b53f90d2bd1cbfb(context = (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00) ? (0, $1851937f210d736f$export$c1275ca9a6fd3ec5) : (0, $1851937f210d736f$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $03bd938f38111844$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $eXaQ2.useRef)(true);
        const wrappedSelector = (0, $eXaQ2.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $03bd938f38111844$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $eXaQ2.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $03bd938f38111844$export$2105062e25df4afe = /*#__PURE__*/ $03bd938f38111844$export$2b53f90d2bd1cbfb();


function $8226f1ee5684019b$export$2e2bcd8739ae039() {
    $8226f1ee5684019b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8226f1ee5684019b$export$2e2bcd8739ae039.apply(this, arguments);
}


function $ac03236e4a254241$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $dbde4074519d49fa$exports = {};
"use strict";
var $88f41ce0f74889aa$exports = {};
"use strict";

$88f41ce0f74889aa$exports = (parcelRequire("fHape"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $dbde4074519d49fa$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $dbde4074519d49fa$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $dbde4074519d49fa$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $dbde4074519d49fa$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $dbde4074519d49fa$var$TYPE_STATICS = {};
$dbde4074519d49fa$var$TYPE_STATICS[$88f41ce0f74889aa$exports.ForwardRef] = $dbde4074519d49fa$var$FORWARD_REF_STATICS;
$dbde4074519d49fa$var$TYPE_STATICS[$88f41ce0f74889aa$exports.Memo] = $dbde4074519d49fa$var$MEMO_STATICS;
function $dbde4074519d49fa$var$getStatics(component) {
    // React v16.11 and below
    if ($88f41ce0f74889aa$exports.isMemo(component)) return $dbde4074519d49fa$var$MEMO_STATICS;
     // React v16.12 and above
    return $dbde4074519d49fa$var$TYPE_STATICS[component["$$typeof"]] || $dbde4074519d49fa$var$REACT_STATICS;
}
var $dbde4074519d49fa$var$defineProperty = Object.defineProperty;
var $dbde4074519d49fa$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $dbde4074519d49fa$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $dbde4074519d49fa$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $dbde4074519d49fa$var$getPrototypeOf = Object.getPrototypeOf;
var $dbde4074519d49fa$var$objectPrototype = Object.prototype;
function $dbde4074519d49fa$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($dbde4074519d49fa$var$objectPrototype) {
            var inheritedComponent = $dbde4074519d49fa$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $dbde4074519d49fa$var$objectPrototype) $dbde4074519d49fa$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $dbde4074519d49fa$var$getOwnPropertyNames(sourceComponent);
        if ($dbde4074519d49fa$var$getOwnPropertySymbols) keys = keys.concat($dbde4074519d49fa$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $dbde4074519d49fa$var$getStatics(targetComponent);
        var sourceStatics = $dbde4074519d49fa$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$dbde4074519d49fa$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $dbde4074519d49fa$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $dbde4074519d49fa$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$dbde4074519d49fa$exports = $dbde4074519d49fa$var$hoistNonReactStatics;



var $eXaQ2 = parcelRequire("eXaQ2");
var $c8569a20eda3db7e$exports = {};
"use strict";

$c8569a20eda3db7e$exports = (parcelRequire("jwyvl"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $8bf8f169f54dd32d$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $f1acf569b3e9604c$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $8bf8f169f54dd32d$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f1acf569b3e9604c$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f1acf569b3e9604c$var$verify(mapStateToProps, "mapStateToProps");
    $f1acf569b3e9604c$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f1acf569b3e9604c$var$verify(mergeProps, "mergeProps");
}


const $4c25bb3565a0a08e$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $4c25bb3565a0a08e$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $4c25bb3565a0a08e$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $ac03236e4a254241$export$2e2bcd8739ae039)(_ref, $4c25bb3565a0a08e$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $4c25bb3565a0a08e$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $6ed7547c14ca94f5$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $5d6787eebc80de1f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $22954d20316d0fa1$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $5d6787eebc80de1f$export$2e2bcd8739ae039)(value)) (0, $8bf8f169f54dd32d$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $b89700ae2d6041f8$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $b89700ae2d6041f8$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $b89700ae2d6041f8$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $b89700ae2d6041f8$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $b89700ae2d6041f8$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $cd6a90529ec440d0$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $1c623d3ccdc54e51$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $b89700ae2d6041f8$export$710f7c60f68acd3e)((dispatch)=>(0, $6ed7547c14ca94f5$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $b89700ae2d6041f8$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $b89700ae2d6041f8$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $cd6a90529ec440d0$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $5db7daa859a80340$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $b89700ae2d6041f8$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $b89700ae2d6041f8$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $cd6a90529ec440d0$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $95b466051160b745$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $95b466051160b745$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $95b466051160b745$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$95b466051160b745$export$691c327fc30bc857 : typeof mergeProps === "function" ? $95b466051160b745$export$5b105939c84b5234(mergeProps) : (0, $cd6a90529ec440d0$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $16f123034e2fbfec$var$createListenerCollection() {
    const batch = (0, $917cb4d654abf0d9$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $16f123034e2fbfec$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $16f123034e2fbfec$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $16f123034e2fbfec$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $16f123034e2fbfec$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $16f123034e2fbfec$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $eXaQ2 = parcelRequire("eXaQ2");
const $1d9d062b1015538c$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $1d9d062b1015538c$export$700979bc83e7db82 = $1d9d062b1015538c$export$71594e8a50f746f4 ? $eXaQ2.useLayoutEffect : $eXaQ2.useEffect;


function $4b392ff4549309c6$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $4b392ff4549309c6$export$2e2bcd8739ae039(objA, objB) {
    if ($4b392ff4549309c6$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$4b392ff4549309c6$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $efdc42c6d84b565a$var$_excluded = [
    "reactReduxForwardedRef"
];
let $efdc42c6d84b565a$var$useSyncExternalStore = (0, $4cf1506dc3ac666f$export$20656a4825650bd0);
const $efdc42c6d84b565a$export$36d45daa6a4925b8 = (fn)=>{
    $efdc42c6d84b565a$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $efdc42c6d84b565a$var$EMPTY_ARRAY = [
    null,
    0
];
const $efdc42c6d84b565a$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $efdc42c6d84b565a$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $efdc42c6d84b565a$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $1d9d062b1015538c$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $efdc42c6d84b565a$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $efdc42c6d84b565a$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $efdc42c6d84b565a$var$initStateUpdates = ()=>$efdc42c6d84b565a$var$EMPTY_ARRAY;
function $efdc42c6d84b565a$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $efdc42c6d84b565a$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $efdc42c6d84b565a$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $efdc42c6d84b565a$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $4b392ff4549309c6$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $4b392ff4549309c6$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $4b392ff4549309c6$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $5db7daa859a80340$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $1c623d3ccdc54e51$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $95b466051160b745$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $eXaQ2.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $ac03236e4a254241$export$2e2bcd8739ae039)(props, $efdc42c6d84b565a$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $eXaQ2.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $c8569a20eda3db7e$exports.isContextConsumer)(/*#__PURE__*/ $eXaQ2.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $eXaQ2.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $eXaQ2.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $4c25bb3565a0a08e$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $eXaQ2.useMemo(()=>{
                if (!shouldHandleStateChanges) return $efdc42c6d84b565a$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $16f123034e2fbfec$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $eXaQ2.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $eXaQ2.useRef();
            const lastWrapperProps = $eXaQ2.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $eXaQ2.useRef();
            const renderIsScheduled = $eXaQ2.useRef(false);
            const isProcessingDispatch = $eXaQ2.useRef(false);
            const isMounted = $eXaQ2.useRef(false);
            const latestSubscriptionCallbackError = $eXaQ2.useRef();
            (0, $1d9d062b1015538c$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $eXaQ2.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $eXaQ2.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $efdc42c6d84b565a$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $efdc42c6d84b565a$var$useIsomorphicLayoutEffectWithArgs($efdc42c6d84b565a$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $efdc42c6d84b565a$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $1d9d062b1015538c$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $eXaQ2.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $eXaQ2.createElement(WrappedComponent, (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $eXaQ2.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $eXaQ2.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $eXaQ2.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $eXaQ2.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $eXaQ2.createElement(Connect, (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dbde4074519d49fa$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($dbde4074519d49fa$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $efdc42c6d84b565a$export$2e2bcd8739ae039 = $efdc42c6d84b565a$var$connect;



var $eXaQ2 = parcelRequire("eXaQ2");



function $ab710f6f1c73e2e9$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $eXaQ2.useMemo(()=>{
        const subscription = (0, $16f123034e2fbfec$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $eXaQ2.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $1d9d062b1015538c$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $eXaQ2.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $ab710f6f1c73e2e9$export$2e2bcd8739ae039 = $ab710f6f1c73e2e9$var$Provider;







function $781bab3c47dc1551$export$671dba69185d0304(context = (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00) ? (0, $1851937f210d736f$export$c1275ca9a6fd3ec5) : (0, $1851937f210d736f$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $781bab3c47dc1551$export$6ccbb43953eebf8 = /*#__PURE__*/ $781bab3c47dc1551$export$671dba69185d0304();


function $17add675b6a5b2c1$export$bc9b55530897c558(context = (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $91adfd4e361c5fb3$export$cc80c08dc91f1c00) ? (0, $781bab3c47dc1551$export$6ccbb43953eebf8) : (0, $781bab3c47dc1551$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $17add675b6a5b2c1$export$8ad76b76a4c905f8 = /*#__PURE__*/ $17add675b6a5b2c1$export$bc9b55530897c558();









(0, $03bd938f38111844$export$e2e6e3f3f3b782e3)((0, $50813aefa7450ddb$exports.useSyncExternalStoreWithSelector));
(0, $efdc42c6d84b565a$export$36d45daa6a4925b8)((0, $4QrSY.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $917cb4d654abf0d9$export$4b9874722d0da7bc)((0, $80Kwh.unstable_batchedUpdates));



/**
 * React Router DOM v6.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eXaQ2 = parcelRequire("eXaQ2");
/**
 * @remix-run/router v1.7.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $bc1baedb84a53039$var$_extends() {
    $bc1baedb84a53039$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc1baedb84a53039$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $bc1baedb84a53039$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($bc1baedb84a53039$export$e19cd5f9376f8cee || ($bc1baedb84a53039$export$e19cd5f9376f8cee = {}));
const $bc1baedb84a53039$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $bc1baedb84a53039$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $bc1baedb84a53039$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $bc1baedb84a53039$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $bc1baedb84a53039$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $bc1baedb84a53039$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $bc1baedb84a53039$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $bc1baedb84a53039$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $bc1baedb84a53039$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $bc1baedb84a53039$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $bc1baedb84a53039$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $bc1baedb84a53039$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $bc1baedb84a53039$export$fe53371bee54353d(to);
    }
    return $bc1baedb84a53039$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $bc1baedb84a53039$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $bc1baedb84a53039$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $bc1baedb84a53039$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $bc1baedb84a53039$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $bc1baedb84a53039$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $bc1baedb84a53039$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $bc1baedb84a53039$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $bc1baedb84a53039$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $bc1baedb84a53039$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $bc1baedb84a53039$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $bc1baedb84a53039$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $bc1baedb84a53039$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $bc1baedb84a53039$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $bc1baedb84a53039$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $bc1baedb84a53039$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $bc1baedb84a53039$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $bc1baedb84a53039$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $bc1baedb84a53039$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($bc1baedb84a53039$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $bc1baedb84a53039$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $bc1baedb84a53039$export$e19cd5f9376f8cee.Push;
        let location = $bc1baedb84a53039$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $bc1baedb84a53039$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $bc1baedb84a53039$export$e19cd5f9376f8cee.Replace;
        let location = $bc1baedb84a53039$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $bc1baedb84a53039$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $bc1baedb84a53039$export$fe53371bee54353d(to);
        $bc1baedb84a53039$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($bc1baedb84a53039$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($bc1baedb84a53039$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $bc1baedb84a53039$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($bc1baedb84a53039$var$ResultType || ($bc1baedb84a53039$var$ResultType = {}));
const $bc1baedb84a53039$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $bc1baedb84a53039$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $bc1baedb84a53039$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $bc1baedb84a53039$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $bc1baedb84a53039$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($bc1baedb84a53039$var$isIndexRoute(route)) {
            let indexRoute = $bc1baedb84a53039$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $bc1baedb84a53039$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $bc1baedb84a53039$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $bc1baedb84a53039$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $bc1baedb84a53039$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $bc1baedb84a53039$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $bc1baedb84a53039$var$flattenRoutes(routes);
    $bc1baedb84a53039$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $bc1baedb84a53039$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $bc1baedb84a53039$var$safelyDecodeURI(pathname));
    return matches;
}
function $bc1baedb84a53039$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $bc1baedb84a53039$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $bc1baedb84a53039$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $bc1baedb84a53039$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $bc1baedb84a53039$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $bc1baedb84a53039$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $bc1baedb84a53039$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $bc1baedb84a53039$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $bc1baedb84a53039$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $bc1baedb84a53039$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $bc1baedb84a53039$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $bc1baedb84a53039$var$paramRe = /^:\w+$/;
const $bc1baedb84a53039$var$dynamicSegmentValue = 3;
const $bc1baedb84a53039$var$indexRouteValue = 2;
const $bc1baedb84a53039$var$emptySegmentValue = 1;
const $bc1baedb84a53039$var$staticSegmentValue = 10;
const $bc1baedb84a53039$var$splatPenalty = -2;
const $bc1baedb84a53039$var$isSplat = (s)=>s === "*";
function $bc1baedb84a53039$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($bc1baedb84a53039$var$isSplat)) initialScore += $bc1baedb84a53039$var$splatPenalty;
    if (index) initialScore += $bc1baedb84a53039$var$indexRouteValue;
    return segments.filter((s)=>!$bc1baedb84a53039$var$isSplat(s)).reduce((score, segment)=>score + ($bc1baedb84a53039$var$paramRe.test(segment) ? $bc1baedb84a53039$var$dynamicSegmentValue : segment === "" ? $bc1baedb84a53039$var$emptySegmentValue : $bc1baedb84a53039$var$staticSegmentValue), initialScore);
}
function $bc1baedb84a53039$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $bc1baedb84a53039$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $bc1baedb84a53039$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $bc1baedb84a53039$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $bc1baedb84a53039$export$a5c6d149b50c1d86($bc1baedb84a53039$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $bc1baedb84a53039$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $bc1baedb84a53039$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $bc1baedb84a53039$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $bc1baedb84a53039$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $bc1baedb84a53039$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $bc1baedb84a53039$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $bc1baedb84a53039$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $bc1baedb84a53039$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $bc1baedb84a53039$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $bc1baedb84a53039$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $bc1baedb84a53039$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $bc1baedb84a53039$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $bc1baedb84a53039$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $bc1baedb84a53039$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $bc1baedb84a53039$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $bc1baedb84a53039$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $bc1baedb84a53039$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $bc1baedb84a53039$var$normalizeSearch(search),
        hash: $bc1baedb84a53039$var$normalizeHash(hash)
    };
}
function $bc1baedb84a53039$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $bc1baedb84a53039$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $bc1baedb84a53039$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $bc1baedb84a53039$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $bc1baedb84a53039$export$8ccf933b0513f8d0(toArg);
    else {
        to = $bc1baedb84a53039$var$_extends({}, toArg);
        $bc1baedb84a53039$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $bc1baedb84a53039$var$getInvalidPathError("?", "pathname", "search", to));
        $bc1baedb84a53039$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $bc1baedb84a53039$var$getInvalidPathError("#", "pathname", "hash", to));
        $bc1baedb84a53039$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $bc1baedb84a53039$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $bc1baedb84a53039$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $bc1baedb84a53039$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $bc1baedb84a53039$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $bc1baedb84a53039$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $bc1baedb84a53039$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $bc1baedb84a53039$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $bc1baedb84a53039$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $bc1baedb84a53039$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $bc1baedb84a53039$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $bc1baedb84a53039$export$42a99a7a4bc0e76a extends Error {
}
class $bc1baedb84a53039$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $bc1baedb84a53039$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $bc1baedb84a53039$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $bc1baedb84a53039$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $bc1baedb84a53039$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $bc1baedb84a53039$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $bc1baedb84a53039$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $bc1baedb84a53039$var$unwrapTrackedPromise(value) {
    if (!$bc1baedb84a53039$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $bc1baedb84a53039$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $bc1baedb84a53039$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $bc1baedb84a53039$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $bc1baedb84a53039$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $bc1baedb84a53039$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $bc1baedb84a53039$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $bc1baedb84a53039$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $bc1baedb84a53039$var$validMutationMethods = new Set($bc1baedb84a53039$var$validMutationMethodsArr);
const $bc1baedb84a53039$var$validRequestMethodsArr = [
    "get",
    ...$bc1baedb84a53039$var$validMutationMethodsArr
];
const $bc1baedb84a53039$var$validRequestMethods = new Set($bc1baedb84a53039$var$validRequestMethodsArr);
const $bc1baedb84a53039$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $bc1baedb84a53039$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $bc1baedb84a53039$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $bc1baedb84a53039$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $bc1baedb84a53039$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $bc1baedb84a53039$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $bc1baedb84a53039$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $bc1baedb84a53039$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $bc1baedb84a53039$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $bc1baedb84a53039$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $bc1baedb84a53039$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $bc1baedb84a53039$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $bc1baedb84a53039$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $bc1baedb84a53039$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $bc1baedb84a53039$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $bc1baedb84a53039$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $bc1baedb84a53039$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $bc1baedb84a53039$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $bc1baedb84a53039$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($bc1baedb84a53039$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $bc1baedb84a53039$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $bc1baedb84a53039$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $bc1baedb84a53039$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $bc1baedb84a53039$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $bc1baedb84a53039$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $bc1baedb84a53039$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $bc1baedb84a53039$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $bc1baedb84a53039$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($bc1baedb84a53039$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $bc1baedb84a53039$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $bc1baedb84a53039$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $bc1baedb84a53039$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $bc1baedb84a53039$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $bc1baedb84a53039$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $bc1baedb84a53039$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $bc1baedb84a53039$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $bc1baedb84a53039$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $bc1baedb84a53039$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $bc1baedb84a53039$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $bc1baedb84a53039$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $bc1baedb84a53039$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $bc1baedb84a53039$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $bc1baedb84a53039$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $bc1baedb84a53039$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $bc1baedb84a53039$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $bc1baedb84a53039$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$bc1baedb84a53039$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $bc1baedb84a53039$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $bc1baedb84a53039$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $bc1baedb84a53039$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $bc1baedb84a53039$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $bc1baedb84a53039$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $bc1baedb84a53039$var$ResultType.error,
            error: $bc1baedb84a53039$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $bc1baedb84a53039$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($bc1baedb84a53039$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($bc1baedb84a53039$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $bc1baedb84a53039$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $bc1baedb84a53039$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($bc1baedb84a53039$var$isDeferredResult(result)) throw $bc1baedb84a53039$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $bc1baedb84a53039$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $bc1baedb84a53039$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $bc1baedb84a53039$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $bc1baedb84a53039$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $bc1baedb84a53039$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($bc1baedb84a53039$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $bc1baedb84a53039$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $bc1baedb84a53039$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $bc1baedb84a53039$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $bc1baedb84a53039$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $bc1baedb84a53039$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $bc1baedb84a53039$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $bc1baedb84a53039$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $bc1baedb84a53039$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $bc1baedb84a53039$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $bc1baedb84a53039$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $bc1baedb84a53039$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $bc1baedb84a53039$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $bc1baedb84a53039$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $bc1baedb84a53039$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($bc1baedb84a53039$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $bc1baedb84a53039$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $bc1baedb84a53039$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    submission: submission,
                    isFetchActionRedirect: true
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($bc1baedb84a53039$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($bc1baedb84a53039$var$isDeferredResult(actionResult)) throw $bc1baedb84a53039$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $bc1baedb84a53039$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $bc1baedb84a53039$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $bc1baedb84a53039$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $bc1baedb84a53039$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $bc1baedb84a53039$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $bc1baedb84a53039$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $bc1baedb84a53039$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $bc1baedb84a53039$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $bc1baedb84a53039$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $bc1baedb84a53039$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($bc1baedb84a53039$var$_extends({
                errors: errors,
                loaderData: $bc1baedb84a53039$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $bc1baedb84a53039$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $bc1baedb84a53039$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $bc1baedb84a53039$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($bc1baedb84a53039$var$isDeferredResult(result)) result = await $bc1baedb84a53039$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($bc1baedb84a53039$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $bc1baedb84a53039$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($bc1baedb84a53039$var$isErrorResult(result)) {
            let boundaryMatch = $bc1baedb84a53039$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $bc1baedb84a53039$export$3e9cee6b33872309(!$bc1baedb84a53039$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $bc1baedb84a53039$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $bc1baedb84a53039$var$createLocation(state.location, redirect.location, $bc1baedb84a53039$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $bc1baedb84a53039$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($bc1baedb84a53039$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $bc1baedb84a53039$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $bc1baedb84a53039$export$e19cd5f9376f8cee.Replace : $bc1baedb84a53039$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $bc1baedb84a53039$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($bc1baedb84a53039$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $bc1baedb84a53039$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $bc1baedb84a53039$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $bc1baedb84a53039$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $bc1baedb84a53039$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$bc1baedb84a53039$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $bc1baedb84a53039$var$callLoaderOrAction("loader", $bc1baedb84a53039$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $bc1baedb84a53039$var$ResultType.error,
                        error: $bc1baedb84a53039$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $bc1baedb84a53039$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $bc1baedb84a53039$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $bc1baedb84a53039$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $bc1baedb84a53039$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $bc1baedb84a53039$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $bc1baedb84a53039$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $bc1baedb84a53039$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $bc1baedb84a53039$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $bc1baedb84a53039$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $bc1baedb84a53039$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $bc1baedb84a53039$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $bc1baedb84a53039$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$bc1baedb84a53039$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $bc1baedb84a53039$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $bc1baedb84a53039$export$4d0306f8f6a4585b = Symbol("deferred");
function $bc1baedb84a53039$export$3336b097a6fbc59a(routes, opts) {
    $bc1baedb84a53039$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $bc1baedb84a53039$var$defaultMapRouteProperties;
    let dataRoutes = $bc1baedb84a53039$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $bc1baedb84a53039$var$createLocation("", $bc1baedb84a53039$export$fe53371bee54353d(url), null, "default");
        let matches = $bc1baedb84a53039$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$bc1baedb84a53039$var$isValidMethod(method) && method !== "HEAD") {
            let error = $bc1baedb84a53039$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $bc1baedb84a53039$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $bc1baedb84a53039$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $bc1baedb84a53039$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($bc1baedb84a53039$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $bc1baedb84a53039$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $bc1baedb84a53039$var$createLocation("", $bc1baedb84a53039$export$fe53371bee54353d(url), null, "default");
        let matches = $bc1baedb84a53039$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$bc1baedb84a53039$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $bc1baedb84a53039$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $bc1baedb84a53039$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $bc1baedb84a53039$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $bc1baedb84a53039$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $bc1baedb84a53039$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($bc1baedb84a53039$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$bc1baedb84a53039$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $bc1baedb84a53039$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($bc1baedb84a53039$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $bc1baedb84a53039$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $bc1baedb84a53039$var$isResponse(result) ? result : $bc1baedb84a53039$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($bc1baedb84a53039$var$isQueryRouteResponse(e)) {
                if (e.type === $bc1baedb84a53039$var$ResultType.error && !$bc1baedb84a53039$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($bc1baedb84a53039$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $bc1baedb84a53039$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $bc1baedb84a53039$var$ResultType.error,
                error: error
            };
        } else {
            result = await $bc1baedb84a53039$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($bc1baedb84a53039$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($bc1baedb84a53039$var$isDeferredResult(result)) {
            let error = $bc1baedb84a53039$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $bc1baedb84a53039$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($bc1baedb84a53039$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($bc1baedb84a53039$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $bc1baedb84a53039$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $bc1baedb84a53039$var$_extends({}, context, {
                statusCode: $bc1baedb84a53039$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $bc1baedb84a53039$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $bc1baedb84a53039$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $bc1baedb84a53039$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $bc1baedb84a53039$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $bc1baedb84a53039$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$bc1baedb84a53039$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $bc1baedb84a53039$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $bc1baedb84a53039$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $bc1baedb84a53039$export$fec11da027c70692(routes, context, error) {
    let newContext = $bc1baedb84a53039$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $bc1baedb84a53039$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $bc1baedb84a53039$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $bc1baedb84a53039$export$cae722b0cc860f13(to ? to : ".", $bc1baedb84a53039$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $bc1baedb84a53039$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$bc1baedb84a53039$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $bc1baedb84a53039$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $bc1baedb84a53039$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $bc1baedb84a53039$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$bc1baedb84a53039$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$bc1baedb84a53039$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $bc1baedb84a53039$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $bc1baedb84a53039$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $bc1baedb84a53039$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$bc1baedb84a53039$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$bc1baedb84a53039$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $bc1baedb84a53039$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $bc1baedb84a53039$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $bc1baedb84a53039$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $bc1baedb84a53039$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $bc1baedb84a53039$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($bc1baedb84a53039$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $bc1baedb84a53039$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $bc1baedb84a53039$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $bc1baedb84a53039$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $bc1baedb84a53039$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $bc1baedb84a53039$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $bc1baedb84a53039$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($bc1baedb84a53039$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $bc1baedb84a53039$var$shouldRevalidateLoader(match, $bc1baedb84a53039$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $bc1baedb84a53039$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $bc1baedb84a53039$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $bc1baedb84a53039$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $bc1baedb84a53039$var$shouldRevalidateLoader(fetcherMatch, $bc1baedb84a53039$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $bc1baedb84a53039$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $bc1baedb84a53039$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $bc1baedb84a53039$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $bc1baedb84a53039$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $bc1baedb84a53039$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $bc1baedb84a53039$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$bc1baedb84a53039$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $bc1baedb84a53039$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $bc1baedb84a53039$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $bc1baedb84a53039$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $bc1baedb84a53039$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $bc1baedb84a53039$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $bc1baedb84a53039$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $bc1baedb84a53039$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $bc1baedb84a53039$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $bc1baedb84a53039$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($bc1baedb84a53039$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($bc1baedb84a53039$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $bc1baedb84a53039$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$bc1baedb84a53039$var$ABSOLUTE_URL_REGEX.test(location)) location = $bc1baedb84a53039$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $bc1baedb84a53039$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $bc1baedb84a53039$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $bc1baedb84a53039$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $bc1baedb84a53039$var$ResultType.error) return {
            type: resultType,
            error: new $bc1baedb84a53039$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $bc1baedb84a53039$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $bc1baedb84a53039$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($bc1baedb84a53039$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $bc1baedb84a53039$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $bc1baedb84a53039$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $bc1baedb84a53039$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($bc1baedb84a53039$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $bc1baedb84a53039$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $bc1baedb84a53039$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $bc1baedb84a53039$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $bc1baedb84a53039$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $bc1baedb84a53039$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $bc1baedb84a53039$export$3e9cee6b33872309(!$bc1baedb84a53039$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($bc1baedb84a53039$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $bc1baedb84a53039$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $bc1baedb84a53039$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($bc1baedb84a53039$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $bc1baedb84a53039$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $bc1baedb84a53039$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $bc1baedb84a53039$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($bc1baedb84a53039$var$isErrorResult(result)) {
            let boundaryMatch = $bc1baedb84a53039$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $bc1baedb84a53039$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($bc1baedb84a53039$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $bc1baedb84a53039$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($bc1baedb84a53039$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $bc1baedb84a53039$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $bc1baedb84a53039$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $bc1baedb84a53039$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $bc1baedb84a53039$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $bc1baedb84a53039$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $bc1baedb84a53039$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $bc1baedb84a53039$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $bc1baedb84a53039$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $bc1baedb84a53039$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($bc1baedb84a53039$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $bc1baedb84a53039$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $bc1baedb84a53039$export$8ccf933b0513f8d0(path) : path;
    return $bc1baedb84a53039$export$fe53371bee54353d($bc1baedb84a53039$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $bc1baedb84a53039$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $bc1baedb84a53039$var$isDeferredResult(result) {
    return result.type === $bc1baedb84a53039$var$ResultType.deferred;
}
function $bc1baedb84a53039$var$isErrorResult(result) {
    return result.type === $bc1baedb84a53039$var$ResultType.error;
}
function $bc1baedb84a53039$var$isRedirectResult(result) {
    return (result && result.type) === $bc1baedb84a53039$var$ResultType.redirect;
}
function $bc1baedb84a53039$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $bc1baedb84a53039$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $bc1baedb84a53039$var$isRedirectResponse(result) {
    if (!$bc1baedb84a53039$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $bc1baedb84a53039$var$isQueryRouteResponse(obj) {
    return obj && $bc1baedb84a53039$var$isResponse(obj.response) && (obj.type === $bc1baedb84a53039$var$ResultType.data || $bc1baedb84a53039$var$ResultType.error);
}
function $bc1baedb84a53039$var$isValidMethod(method) {
    return $bc1baedb84a53039$var$validRequestMethods.has(method.toLowerCase());
}
function $bc1baedb84a53039$var$isMutationMethod(method) {
    return $bc1baedb84a53039$var$validMutationMethods.has(method.toLowerCase());
}
async function $bc1baedb84a53039$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$bc1baedb84a53039$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($bc1baedb84a53039$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $bc1baedb84a53039$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $bc1baedb84a53039$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $bc1baedb84a53039$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $bc1baedb84a53039$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $bc1baedb84a53039$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $bc1baedb84a53039$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $bc1baedb84a53039$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $bc1baedb84a53039$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $bc1baedb84a53039$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $bc1baedb84a53039$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $bc1baedb84a53039$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $bc1baedb84a53039$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $bc1baedb84a53039$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $bc1baedb84a53039$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $bc1baedb84a53039$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $bc1baedb84a53039$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $bc1baedb84a53039$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $bc1baedb84a53039$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

/**
 * React Router v6.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eXaQ2 = parcelRequire("eXaQ2");

function $3fc8353d3146dc49$var$_extends() {
    $3fc8353d3146dc49$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3fc8353d3146dc49$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $3fc8353d3146dc49$export$3add0d5dce533e2e = /*#__PURE__*/ $eXaQ2.createContext(null);
const $3fc8353d3146dc49$export$145dfa71566a64dc = /*#__PURE__*/ $eXaQ2.createContext(null);
const $3fc8353d3146dc49$var$AwaitContext = /*#__PURE__*/ $eXaQ2.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $3fc8353d3146dc49$export$26749e8557646306 = /*#__PURE__*/ $eXaQ2.createContext(null);
const $3fc8353d3146dc49$export$c7914228fb69b0f5 = /*#__PURE__*/ $eXaQ2.createContext(null);
const $3fc8353d3146dc49$export$9072aa6dd1f93057 = /*#__PURE__*/ $eXaQ2.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $3fc8353d3146dc49$var$RouteErrorContext = /*#__PURE__*/ $eXaQ2.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $3fc8353d3146dc49$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$3fc8353d3146dc49$export$9c954a9d03d32f4a() && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $eXaQ2.useContext($3fc8353d3146dc49$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $3fc8353d3146dc49$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $bc1baedb84a53039$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $3fc8353d3146dc49$export$9c954a9d03d32f4a() {
    return $eXaQ2.useContext($3fc8353d3146dc49$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $3fc8353d3146dc49$export$45d76561a5302f2b() {
    !$3fc8353d3146dc49$export$9c954a9d03d32f4a() && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    return $eXaQ2.useContext($3fc8353d3146dc49$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $3fc8353d3146dc49$export$1b3f31771c5d07c() {
    return $eXaQ2.useContext($3fc8353d3146dc49$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $3fc8353d3146dc49$export$6c330e8992e8a295(pattern) {
    !$3fc8353d3146dc49$export$9c954a9d03d32f4a() && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $3fc8353d3146dc49$export$45d76561a5302f2b();
    return $eXaQ2.useMemo(()=>(0, $bc1baedb84a53039$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $3fc8353d3146dc49$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $3fc8353d3146dc49$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eXaQ2.useContext($3fc8353d3146dc49$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eXaQ2.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $3fc8353d3146dc49$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $3fc8353d3146dc49$var$useNavigateStable() : $3fc8353d3146dc49$var$useNavigateUnstable();
}
function $3fc8353d3146dc49$var$useNavigateUnstable() {
    !$3fc8353d3146dc49$export$9c954a9d03d32f4a() && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    let dataRouterContext = $eXaQ2.useContext($3fc8353d3146dc49$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $eXaQ2.useContext($3fc8353d3146dc49$export$26749e8557646306);
    let { matches: matches } = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3fc8353d3146dc49$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bc1baedb84a53039$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $eXaQ2.useRef(false);
    $3fc8353d3146dc49$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eXaQ2.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $bc1baedb84a53039$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bc1baedb84a53039$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $3fc8353d3146dc49$var$OutletContext = /*#__PURE__*/ $eXaQ2.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $3fc8353d3146dc49$export$4138103a3ae699cc() {
    return $eXaQ2.useContext($3fc8353d3146dc49$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $3fc8353d3146dc49$export$a3be3530d8e40d0b(context) {
    let outlet = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $3fc8353d3146dc49$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $3fc8353d3146dc49$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3fc8353d3146dc49$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bc1baedb84a53039$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $eXaQ2.useMemo(()=>(0, $bc1baedb84a53039$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $3fc8353d3146dc49$export$5d3fca4a98652595(routes, locationArg) {
    return $3fc8353d3146dc49$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $3fc8353d3146dc49$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$3fc8353d3146dc49$export$9c954a9d03d32f4a() && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $eXaQ2.useContext($3fc8353d3146dc49$export$26749e8557646306);
    let { matches: parentMatches } = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $3fc8353d3146dc49$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $bc1baedb84a53039$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $bc1baedb84a53039$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $3fc8353d3146dc49$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $bc1baedb84a53039$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $bc1baedb84a53039$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $3fc8353d3146dc49$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $bc1baedb84a53039$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $3fc8353d3146dc49$var$DefaultErrorComponent() {
    let error = $3fc8353d3146dc49$export$ed527bf60f6e05f2();
    let message = (0, $bc1baedb84a53039$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eXaQ2.createElement($eXaQ2.Fragment, null, /*#__PURE__*/ $eXaQ2.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eXaQ2.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eXaQ2.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $3fc8353d3146dc49$var$defaultErrorElement = /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$DefaultErrorComponent, null);
class $3fc8353d3146dc49$var$RenderErrorBoundary extends $eXaQ2.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $3fc8353d3146dc49$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eXaQ2.useContext($3fc8353d3146dc49$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $3fc8353d3146dc49$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $3fc8353d3146dc49$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eXaQ2.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $3fc8353d3146dc49$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($3fc8353d3146dc49$var$DataRouterHook || ($3fc8353d3146dc49$var$DataRouterHook = {}));
var $3fc8353d3146dc49$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($3fc8353d3146dc49$var$DataRouterStateHook || ($3fc8353d3146dc49$var$DataRouterStateHook = {}));
function $3fc8353d3146dc49$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $3fc8353d3146dc49$var$useDataRouterContext(hookName) {
    let ctx = $eXaQ2.useContext($3fc8353d3146dc49$export$3add0d5dce533e2e);
    !ctx && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    return ctx;
}
function $3fc8353d3146dc49$var$useDataRouterState(hookName) {
    let state = $eXaQ2.useContext($3fc8353d3146dc49$export$145dfa71566a64dc);
    !state && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    return state;
}
function $3fc8353d3146dc49$var$useRouteContext(hookName) {
    let route = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057);
    !route && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $3fc8353d3146dc49$var$useCurrentRouteId(hookName) {
    let route = $3fc8353d3146dc49$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $3fc8353d3146dc49$export$5fc8298006ad9e58() {
    return $3fc8353d3146dc49$var$useCurrentRouteId($3fc8353d3146dc49$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $3fc8353d3146dc49$export$d0fd4b7106de2769() {
    let state = $3fc8353d3146dc49$var$useDataRouterState($3fc8353d3146dc49$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $3fc8353d3146dc49$export$600dc272ed516c15() {
    let dataRouterContext = $3fc8353d3146dc49$var$useDataRouterContext($3fc8353d3146dc49$var$DataRouterHook.UseRevalidator);
    let state = $3fc8353d3146dc49$var$useDataRouterState($3fc8353d3146dc49$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $3fc8353d3146dc49$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $3fc8353d3146dc49$var$useDataRouterState($3fc8353d3146dc49$var$DataRouterStateHook.UseMatches);
    return $eXaQ2.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $3fc8353d3146dc49$export$1448a5050d252c4d() {
    let state = $3fc8353d3146dc49$var$useDataRouterState($3fc8353d3146dc49$var$DataRouterStateHook.UseLoaderData);
    let routeId = $3fc8353d3146dc49$var$useCurrentRouteId($3fc8353d3146dc49$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $3fc8353d3146dc49$export$fd5d37484eab868d(routeId) {
    let state = $3fc8353d3146dc49$var$useDataRouterState($3fc8353d3146dc49$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $3fc8353d3146dc49$export$fdc00f3f26066d5e() {
    let state = $3fc8353d3146dc49$var$useDataRouterState($3fc8353d3146dc49$var$DataRouterStateHook.UseActionData);
    let route = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057);
    !route && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $3fc8353d3146dc49$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eXaQ2.useContext($3fc8353d3146dc49$var$RouteErrorContext);
    let state = $3fc8353d3146dc49$var$useDataRouterState($3fc8353d3146dc49$var$DataRouterStateHook.UseRouteError);
    let routeId = $3fc8353d3146dc49$var$useCurrentRouteId($3fc8353d3146dc49$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $3fc8353d3146dc49$export$78a72ddb39bdd145() {
    let value = $eXaQ2.useContext($3fc8353d3146dc49$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $3fc8353d3146dc49$export$17f53340677d5831() {
    let value = $eXaQ2.useContext($3fc8353d3146dc49$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $3fc8353d3146dc49$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $3fc8353d3146dc49$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $3fc8353d3146dc49$var$useDataRouterContext($3fc8353d3146dc49$var$DataRouterHook.UseBlocker);
    let state = $3fc8353d3146dc49$var$useDataRouterState($3fc8353d3146dc49$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eXaQ2.useState("");
    let blockerFunction = $eXaQ2.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $3fc8353d3146dc49$var$_extends({}, currentLocation, {
                pathname: (0, $bc1baedb84a53039$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $3fc8353d3146dc49$var$_extends({}, nextLocation, {
                pathname: (0, $bc1baedb84a53039$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eXaQ2.useEffect(()=>{
        let key = String(++$3fc8353d3146dc49$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eXaQ2.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $bc1baedb84a53039$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $3fc8353d3146dc49$var$useNavigateStable() {
    let { router: router } = $3fc8353d3146dc49$var$useDataRouterContext($3fc8353d3146dc49$var$DataRouterHook.UseNavigateStable);
    let id = $3fc8353d3146dc49$var$useCurrentRouteId($3fc8353d3146dc49$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eXaQ2.useRef(false);
    $3fc8353d3146dc49$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eXaQ2.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $3fc8353d3146dc49$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $3fc8353d3146dc49$var$alreadyWarned = {};
function $3fc8353d3146dc49$var$warningOnce(key, cond, message) {
    if (!cond && !$3fc8353d3146dc49$var$alreadyWarned[key]) $3fc8353d3146dc49$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $3fc8353d3146dc49$var$START_TRANSITION = "startTransition";
const $3fc8353d3146dc49$var$startTransitionImpl = $eXaQ2[$3fc8353d3146dc49$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $3fc8353d3146dc49$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $eXaQ2.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eXaQ2.useCallback((newState)=>{
        v7_startTransition && $3fc8353d3146dc49$var$startTransitionImpl ? $3fc8353d3146dc49$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eXaQ2.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $eXaQ2.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eXaQ2.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eXaQ2.createElement($eXaQ2.Fragment, null, /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $3fc8353d3146dc49$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $3fc8353d3146dc49$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $3fc8353d3146dc49$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eXaQ2.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bc1baedb84a53039$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eXaQ2.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eXaQ2.useCallback((newState)=>{
        v7_startTransition && $3fc8353d3146dc49$var$startTransitionImpl ? $3fc8353d3146dc49$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eXaQ2.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $3fc8353d3146dc49$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$3fc8353d3146dc49$export$9c954a9d03d32f4a() && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    let { matches: matches } = $eXaQ2.useContext($3fc8353d3146dc49$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3fc8353d3146dc49$export$45d76561a5302f2b();
    let navigate = $3fc8353d3146dc49$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $bc1baedb84a53039$export$cae722b0cc860f13)(to, (0, $bc1baedb84a53039$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eXaQ2.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $3fc8353d3146dc49$export$910ae8079b2c2852(props) {
    return $3fc8353d3146dc49$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $3fc8353d3146dc49$export$e7b0ac011bb776c6(_props) {
    (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $3fc8353d3146dc49$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $bc1baedb84a53039$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$3fc8353d3146dc49$export$9c954a9d03d32f4a() && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eXaQ2.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $bc1baedb84a53039$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eXaQ2.useMemo(()=>{
        let trailingPathname = (0, $bc1baedb84a53039$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $3fc8353d3146dc49$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $3fc8353d3146dc49$export$5d3fca4a98652595($3fc8353d3146dc49$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $3fc8353d3146dc49$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$ResolveAwait, null, children));
}
var $3fc8353d3146dc49$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($3fc8353d3146dc49$var$AwaitRenderStatus || ($3fc8353d3146dc49$var$AwaitRenderStatus = {}));
const $3fc8353d3146dc49$var$neverSettledPromise = new Promise(()=>{});
class $3fc8353d3146dc49$var$AwaitErrorBoundary extends $eXaQ2.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $3fc8353d3146dc49$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $3fc8353d3146dc49$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $3fc8353d3146dc49$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $3fc8353d3146dc49$var$AwaitRenderStatus.error : promise._data !== undefined ? $3fc8353d3146dc49$var$AwaitRenderStatus.success : $3fc8353d3146dc49$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $3fc8353d3146dc49$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $3fc8353d3146dc49$var$AwaitRenderStatus.error && promise._error instanceof (0, $bc1baedb84a53039$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $3fc8353d3146dc49$var$neverSettledPromise;
        if (status === $3fc8353d3146dc49$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $3fc8353d3146dc49$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $3fc8353d3146dc49$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eXaQ2.createElement($3fc8353d3146dc49$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $3fc8353d3146dc49$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $3fc8353d3146dc49$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eXaQ2.createElement($eXaQ2.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $3fc8353d3146dc49$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eXaQ2.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eXaQ2.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eXaQ2.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $3fc8353d3146dc49$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $3fc8353d3146dc49$export$e7b0ac011bb776c6) && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $3fc8353d3146dc49$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $3fc8353d3146dc49$export$daf73786167a7f72(matches) {
    return $3fc8353d3146dc49$var$_renderMatches(matches);
}
function $3fc8353d3146dc49$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eXaQ2.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eXaQ2.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $3fc8353d3146dc49$export$f30f7e456d254e83(routes, opts) {
    return (0, $bc1baedb84a53039$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3fc8353d3146dc49$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bc1baedb84a53039$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $3fc8353d3146dc49$export$52b333d321859367
    }).initialize();
}



function $6365d8eb34426354$var$_extends() {
    $6365d8eb34426354$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6365d8eb34426354$var$_extends.apply(this, arguments);
}
function $6365d8eb34426354$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $6365d8eb34426354$var$defaultMethod = "get";
const $6365d8eb34426354$var$defaultEncType = "application/x-www-form-urlencoded";
function $6365d8eb34426354$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $6365d8eb34426354$var$isButtonElement(object) {
    return $6365d8eb34426354$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $6365d8eb34426354$var$isFormElement(object) {
    return $6365d8eb34426354$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $6365d8eb34426354$var$isInputElement(object) {
    return $6365d8eb34426354$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $6365d8eb34426354$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $6365d8eb34426354$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$6365d8eb34426354$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $6365d8eb34426354$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $6365d8eb34426354$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $6365d8eb34426354$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
// One-time check for submitter support
let $6365d8eb34426354$var$_formDataSupportsSubmitter = null;
function $6365d8eb34426354$var$isFormDataSubmitterSupported() {
    if ($6365d8eb34426354$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $6365d8eb34426354$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $6365d8eb34426354$var$_formDataSupportsSubmitter = true;
    }
    return $6365d8eb34426354$var$_formDataSupportsSubmitter;
}
const $6365d8eb34426354$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $6365d8eb34426354$var$getFormEncType(encType) {
    if (encType != null && !$6365d8eb34426354$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $6365d8eb34426354$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($6365d8eb34426354$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $bc1baedb84a53039$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $6365d8eb34426354$var$defaultMethod;
        encType = $6365d8eb34426354$var$getFormEncType(target.getAttribute("enctype")) || $6365d8eb34426354$var$defaultEncType;
        formData = new FormData(target);
    } else if ($6365d8eb34426354$var$isButtonElement(target) || $6365d8eb34426354$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $bc1baedb84a53039$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $6365d8eb34426354$var$defaultMethod;
        encType = $6365d8eb34426354$var$getFormEncType(target.getAttribute("formenctype")) || $6365d8eb34426354$var$getFormEncType(form.getAttribute("enctype")) || $6365d8eb34426354$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$6365d8eb34426354$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($6365d8eb34426354$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $6365d8eb34426354$var$defaultMethod;
        action = null;
        encType = $6365d8eb34426354$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $6365d8eb34426354$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $6365d8eb34426354$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $6365d8eb34426354$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $6365d8eb34426354$export$1f3f55432a00e06d(routes, opts) {
    return (0, $bc1baedb84a53039$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6365d8eb34426354$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bc1baedb84a53039$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $6365d8eb34426354$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3fc8353d3146dc49$export$52b333d321859367)
    }).initialize();
}
function $6365d8eb34426354$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $bc1baedb84a53039$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6365d8eb34426354$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bc1baedb84a53039$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $6365d8eb34426354$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3fc8353d3146dc49$export$52b333d321859367)
    }).initialize();
}
function $6365d8eb34426354$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $6365d8eb34426354$var$_extends({}, state, {
        errors: $6365d8eb34426354$var$deserializeErrors(state.errors)
    });
    return state;
}
function $6365d8eb34426354$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $bc1baedb84a53039$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6365d8eb34426354$var$START_TRANSITION = "startTransition";
const $6365d8eb34426354$var$startTransitionImpl = $eXaQ2[$6365d8eb34426354$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $6365d8eb34426354$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $eXaQ2.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bc1baedb84a53039$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eXaQ2.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eXaQ2.useCallback((newState)=>{
        v7_startTransition && $6365d8eb34426354$var$startTransitionImpl ? $6365d8eb34426354$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eXaQ2.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eXaQ2.createElement((0, $3fc8353d3146dc49$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $6365d8eb34426354$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $eXaQ2.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bc1baedb84a53039$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eXaQ2.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eXaQ2.useCallback((newState)=>{
        v7_startTransition && $6365d8eb34426354$var$startTransitionImpl ? $6365d8eb34426354$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eXaQ2.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eXaQ2.createElement((0, $3fc8353d3146dc49$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $6365d8eb34426354$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $eXaQ2.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eXaQ2.useCallback((newState)=>{
        v7_startTransition && $6365d8eb34426354$var$startTransitionImpl ? $6365d8eb34426354$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eXaQ2.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eXaQ2.createElement((0, $3fc8353d3146dc49$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $6365d8eb34426354$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $6365d8eb34426354$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $6365d8eb34426354$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eXaQ2.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $6365d8eb34426354$var$_objectWithoutPropertiesLoose(_ref4, $6365d8eb34426354$var$_excluded);
    let { basename: basename } = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $6365d8eb34426354$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($6365d8eb34426354$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $bc1baedb84a53039$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $3fc8353d3146dc49$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $6365d8eb34426354$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eXaQ2.createElement("a", $6365d8eb34426354$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $6365d8eb34426354$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eXaQ2.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $6365d8eb34426354$var$_objectWithoutPropertiesLoose(_ref5, $6365d8eb34426354$var$_excluded2);
    let path = (0, $3fc8353d3146dc49$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $3fc8353d3146dc49$export$45d76561a5302f2b)();
    let routerState = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$145dfa71566a64dc));
    let { navigator: navigator } = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $eXaQ2.createElement($6365d8eb34426354$export$a6c7ac8248d6e38a, $6365d8eb34426354$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $6365d8eb34426354$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eXaQ2.forwardRef((props, ref)=>{
    let submit = $6365d8eb34426354$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $eXaQ2.createElement($6365d8eb34426354$var$FormImpl, $6365d8eb34426354$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $6365d8eb34426354$var$FormImpl = /*#__PURE__*/ $eXaQ2.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $6365d8eb34426354$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $6365d8eb34426354$var$_objectWithoutPropertiesLoose(_ref6, $6365d8eb34426354$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $6365d8eb34426354$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $eXaQ2.createElement("form", $6365d8eb34426354$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $6365d8eb34426354$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $6365d8eb34426354$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $6365d8eb34426354$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($6365d8eb34426354$var$DataRouterHook || ($6365d8eb34426354$var$DataRouterHook = {}));
var $6365d8eb34426354$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($6365d8eb34426354$var$DataRouterStateHook || ($6365d8eb34426354$var$DataRouterStateHook = {}));
function $6365d8eb34426354$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6365d8eb34426354$var$useDataRouterContext(hookName) {
    let ctx = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$3add0d5dce533e2e));
    !ctx && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    return ctx;
}
function $6365d8eb34426354$var$useDataRouterState(hookName) {
    let state = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$145dfa71566a64dc));
    !state && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $6365d8eb34426354$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $3fc8353d3146dc49$export$9770f232ac06a008)();
    let location = (0, $3fc8353d3146dc49$export$45d76561a5302f2b)();
    let path = (0, $3fc8353d3146dc49$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $eXaQ2.useCallback((event)=>{
        if ($6365d8eb34426354$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $bc1baedb84a53039$export$fe53371bee54353d)(location) === (0, $bc1baedb84a53039$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $6365d8eb34426354$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $eXaQ2.useRef($6365d8eb34426354$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eXaQ2.useRef(false);
    let location = (0, $3fc8353d3146dc49$export$45d76561a5302f2b)();
    let searchParams = $eXaQ2.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $6365d8eb34426354$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $3fc8353d3146dc49$export$9770f232ac06a008)();
    let setSearchParams = $eXaQ2.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $6365d8eb34426354$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $6365d8eb34426354$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $6365d8eb34426354$export$47c85c6e3a081d3() {
    let { router: router } = $6365d8eb34426354$var$useDataRouterContext($6365d8eb34426354$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$26749e8557646306));
    let currentRouteId = (0, $3fc8353d3146dc49$export$5fc8298006ad9e58)();
    return $eXaQ2.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $6365d8eb34426354$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $6365d8eb34426354$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $6365d8eb34426354$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $6365d8eb34426354$var$useDataRouterContext($6365d8eb34426354$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$26749e8557646306));
    return $eXaQ2.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $6365d8eb34426354$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $6365d8eb34426354$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $6365d8eb34426354$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$26749e8557646306));
    let routeContext = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$9072aa6dd1f93057));
    !routeContext && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $6365d8eb34426354$var$_extends({}, (0, $3fc8353d3146dc49$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $3fc8353d3146dc49$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bc1baedb84a53039$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $bc1baedb84a53039$export$fe53371bee54353d)(path);
}
function $6365d8eb34426354$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $eXaQ2.forwardRef((props, ref)=>{
        let submit = $6365d8eb34426354$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $eXaQ2.createElement($6365d8eb34426354$var$FormImpl, $6365d8eb34426354$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $6365d8eb34426354$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $6365d8eb34426354$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $6365d8eb34426354$var$useDataRouterContext($6365d8eb34426354$var$DataRouterHook.UseFetcher);
    let route = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$9072aa6dd1f93057));
    !route && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $eXaQ2.useState(()=>String(++$6365d8eb34426354$var$fetcherId));
    let [Form] = $eXaQ2.useState(()=>{
        !routeId && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
        return $6365d8eb34426354$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $eXaQ2.useState(()=>(href)=>{
            !router && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
            !routeId && (0, $bc1baedb84a53039$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $6365d8eb34426354$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $eXaQ2.useMemo(()=>$6365d8eb34426354$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $eXaQ2.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $6365d8eb34426354$export$fa996778a3a31087() {
    let state = $6365d8eb34426354$var$useDataRouterState($6365d8eb34426354$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $6365d8eb34426354$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $6365d8eb34426354$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $6365d8eb34426354$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $6365d8eb34426354$var$useDataRouterContext($6365d8eb34426354$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $6365d8eb34426354$var$useDataRouterState($6365d8eb34426354$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $eXaQ2.useContext((0, $3fc8353d3146dc49$export$26749e8557646306));
    let location = (0, $3fc8353d3146dc49$export$45d76561a5302f2b)();
    let matches = (0, $3fc8353d3146dc49$export$2378eb7f5ff86053)();
    let navigation = (0, $3fc8353d3146dc49$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $eXaQ2.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $6365d8eb34426354$var$usePageHide($eXaQ2.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $6365d8eb34426354$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $6365d8eb34426354$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($6365d8eb34426354$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eXaQ2.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $6365d8eb34426354$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $6365d8eb34426354$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eXaQ2.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($6365d8eb34426354$var$_extends({}, location, {
                    pathname: (0, $bc1baedb84a53039$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($6365d8eb34426354$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eXaQ2.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $6365d8eb34426354$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eXaQ2.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $6365d8eb34426354$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eXaQ2.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $6365d8eb34426354$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $3fc8353d3146dc49$export$2af03a1de5c0910)(when);
    $eXaQ2.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $eXaQ2.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}


var $fb481f68a427bf09$exports = {};
"use strict";
var $0cbd21a7984beb16$exports = {};
"use strict";
var $621ce24d54e1e1d1$exports = {};
"use strict";
var $1ddc2580a00c5fb2$exports = {};
"use strict";
Object.defineProperty($1ddc2580a00c5fb2$exports, "__esModule", {
    value: true
});
var $1ddc2580a00c5fb2$var$warn = function warn(s) {
    console.warn("[react-gtm]", s);
};
$1ddc2580a00c5fb2$exports.default = $1ddc2580a00c5fb2$var$warn;


var $621ce24d54e1e1d1$var$_warn2 = $621ce24d54e1e1d1$var$_interopRequireDefault($1ddc2580a00c5fb2$exports);
function $621ce24d54e1e1d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://developers.google.com/tag-manager/quickstart
var $621ce24d54e1e1d1$var$Snippets = {
    tags: function tags(_ref) {
        var id = _ref.id, events = _ref.events, dataLayer = _ref.dataLayer, dataLayerName = _ref.dataLayerName, preview = _ref.preview, auth = _ref.auth;
        var gtm_auth = "&gtm_auth=" + auth;
        var gtm_preview = "&gtm_preview=" + preview;
        if (!id) (0, $621ce24d54e1e1d1$var$_warn2.default)("GTM Id is required");
        var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
        var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', " + JSON.stringify(events).slice(1, -1) + "});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'" + gtm_auth + gtm_preview + "&gtm_cookies_win=x';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,'script','" + dataLayerName + "','" + id + "');";
        var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
        return {
            iframe: iframe,
            script: script,
            dataLayerVar: dataLayerVar
        };
    },
    dataLayer: function dataLayer(_dataLayer, dataLayerName) {
        return "\n      window." + dataLayerName + " = window." + dataLayerName + " || [];\n      window." + dataLayerName + ".push(" + JSON.stringify(_dataLayer) + ")";
    }
};
$621ce24d54e1e1d1$exports = $621ce24d54e1e1d1$var$Snippets;


var $0cbd21a7984beb16$var$_Snippets2 = $0cbd21a7984beb16$var$_interopRequireDefault($621ce24d54e1e1d1$exports);
function $0cbd21a7984beb16$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0cbd21a7984beb16$var$TagManager = {
    dataScript: function dataScript(dataLayer) {
        var script = document.createElement("script");
        script.innerHTML = dataLayer;
        return script;
    },
    gtm: function gtm(args) {
        var snippets = $0cbd21a7984beb16$var$_Snippets2.default.tags(args);
        var noScript = function noScript() {
            var noscript = document.createElement("noscript");
            noscript.innerHTML = snippets.iframe;
            return noscript;
        };
        var script = function script() {
            var script = document.createElement("script");
            script.innerHTML = snippets.script;
            return script;
        };
        var dataScript = this.dataScript(snippets.dataLayerVar);
        return {
            noScript: noScript,
            script: script,
            dataScript: dataScript
        };
    },
    initialize: function initialize(_ref) {
        var gtmId = _ref.gtmId, _ref$events = _ref.events, events = _ref$events === undefined ? {} : _ref$events, dataLayer = _ref.dataLayer, _ref$dataLayerName = _ref.dataLayerName, dataLayerName = _ref$dataLayerName === undefined ? "dataLayer" : _ref$dataLayerName, _ref$auth = _ref.auth, auth = _ref$auth === undefined ? "" : _ref$auth, _ref$preview = _ref.preview, preview = _ref$preview === undefined ? "" : _ref$preview;
        var gtm = this.gtm({
            id: gtmId,
            events: events,
            dataLayer: dataLayer || undefined,
            dataLayerName: dataLayerName,
            auth: auth,
            preview: preview
        });
        if (dataLayer) document.head.appendChild(gtm.dataScript);
        document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
        document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
    },
    dataLayer: function dataLayer(_ref2) {
        var _dataLayer = _ref2.dataLayer, _ref2$dataLayerName = _ref2.dataLayerName, dataLayerName = _ref2$dataLayerName === undefined ? "dataLayer" : _ref2$dataLayerName;
        if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
        var snippets = $0cbd21a7984beb16$var$_Snippets2.default.dataLayer(_dataLayer, dataLayerName);
        var dataScript = this.dataScript(snippets);
        document.head.insertBefore(dataScript, document.head.childNodes[0]);
    }
};
$0cbd21a7984beb16$exports = $0cbd21a7984beb16$var$TagManager;


var $fb481f68a427bf09$var$_TagManager2 = $fb481f68a427bf09$var$_interopRequireDefault($0cbd21a7984beb16$exports);
function $fb481f68a427bf09$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$fb481f68a427bf09$exports = $fb481f68a427bf09$var$_TagManager2.default;


var $87ae4e00b7a962b0$exports = {};
"use client";
"use strict";
let $87ae4e00b7a962b0$var$_ = (t)=>t, $87ae4e00b7a962b0$var$t, $87ae4e00b7a962b0$var$t1, $87ae4e00b7a962b0$var$t2, $87ae4e00b7a962b0$var$t3, $87ae4e00b7a962b0$var$t4, $87ae4e00b7a962b0$var$t5, $87ae4e00b7a962b0$var$t6, $87ae4e00b7a962b0$var$t7, $87ae4e00b7a962b0$var$t8, $87ae4e00b7a962b0$var$t9, $87ae4e00b7a962b0$var$t10, $87ae4e00b7a962b0$var$t11, $87ae4e00b7a962b0$var$t12, $87ae4e00b7a962b0$var$t13, $87ae4e00b7a962b0$var$t14, $87ae4e00b7a962b0$var$t15;
var $87ae4e00b7a962b0$var$Y = Object.create;
var $87ae4e00b7a962b0$var$E = Object.defineProperty;
var $87ae4e00b7a962b0$var$q = Object.getOwnPropertyDescriptor;
var $87ae4e00b7a962b0$var$G = Object.getOwnPropertyNames;
var $87ae4e00b7a962b0$var$K = Object.getPrototypeOf, $87ae4e00b7a962b0$var$Z = Object.prototype.hasOwnProperty;
var $87ae4e00b7a962b0$var$ee = (e, t)=>{
    for(var o in t)$87ae4e00b7a962b0$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $87ae4e00b7a962b0$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $87ae4e00b7a962b0$var$G(t))!$87ae4e00b7a962b0$var$Z.call(e, r) && r !== o && $87ae4e00b7a962b0$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $87ae4e00b7a962b0$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $87ae4e00b7a962b0$var$W = (e, t, o)=>(o = e != null ? $87ae4e00b7a962b0$var$Y($87ae4e00b7a962b0$var$K(e)) : {}, $87ae4e00b7a962b0$var$j(t || !e || !e.__esModule ? $87ae4e00b7a962b0$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $87ae4e00b7a962b0$var$te = (e)=>$87ae4e00b7a962b0$var$j($87ae4e00b7a962b0$var$E({}, "__esModule", {
        value: !0
    }), e);
var $87ae4e00b7a962b0$var$Ve = {};
$87ae4e00b7a962b0$var$ee($87ae4e00b7a962b0$var$Ve, {
    CheckmarkIcon: ()=>$87ae4e00b7a962b0$var$F,
    ErrorIcon: ()=>$87ae4e00b7a962b0$var$w,
    LoaderIcon: ()=>$87ae4e00b7a962b0$var$M,
    ToastBar: ()=>$87ae4e00b7a962b0$var$$,
    ToastIcon: ()=>$87ae4e00b7a962b0$var$U,
    Toaster: ()=>$87ae4e00b7a962b0$var$J,
    default: ()=>$87ae4e00b7a962b0$var$_e,
    resolveValue: ()=>$87ae4e00b7a962b0$var$u,
    toast: ()=>$87ae4e00b7a962b0$var$n,
    useToaster: ()=>$87ae4e00b7a962b0$var$V,
    useToasterStore: ()=>$87ae4e00b7a962b0$var$_1
});
$87ae4e00b7a962b0$exports = $87ae4e00b7a962b0$var$te($87ae4e00b7a962b0$var$Ve);
var $87ae4e00b7a962b0$var$oe = (e)=>typeof e == "function", $87ae4e00b7a962b0$var$u = (e, t)=>$87ae4e00b7a962b0$var$oe(e) ? e(t) : e;
var $87ae4e00b7a962b0$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $87ae4e00b7a962b0$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $87ae4e00b7a962b0$var$re = 20;
var $87ae4e00b7a962b0$var$v = new Map, $87ae4e00b7a962b0$var$se = 1e3, $87ae4e00b7a962b0$var$X = (e)=>{
    if ($87ae4e00b7a962b0$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $87ae4e00b7a962b0$var$v.delete(e), $87ae4e00b7a962b0$var$l({
            type: 4,
            toastId: e
        });
    }, $87ae4e00b7a962b0$var$se);
    $87ae4e00b7a962b0$var$v.set(e, t);
}, $87ae4e00b7a962b0$var$ae = (e)=>{
    let t = $87ae4e00b7a962b0$var$v.get(e);
    t && clearTimeout(t);
}, $87ae4e00b7a962b0$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $87ae4e00b7a962b0$var$re)
            };
        case 1:
            return t.toast.id && $87ae4e00b7a962b0$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $87ae4e00b7a962b0$var$H(e, {
                type: 1,
                toast: o
            }) : $87ae4e00b7a962b0$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $87ae4e00b7a962b0$var$X(s) : e.toasts.forEach((a)=>{
                $87ae4e00b7a962b0$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $87ae4e00b7a962b0$var$I = [], $87ae4e00b7a962b0$var$D = {
    toasts: [],
    pausedAt: void 0
}, $87ae4e00b7a962b0$var$l = (e)=>{
    $87ae4e00b7a962b0$var$D = $87ae4e00b7a962b0$var$H($87ae4e00b7a962b0$var$D, e), $87ae4e00b7a962b0$var$I.forEach((t)=>{
        t($87ae4e00b7a962b0$var$D);
    });
}, $87ae4e00b7a962b0$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $87ae4e00b7a962b0$var$_1 = (e = {})=>{
    let [t, o] = (0, (parcelRequire("eXaQ2")).useState)($87ae4e00b7a962b0$var$D);
    (0, (parcelRequire("eXaQ2")).useEffect)(()=>($87ae4e00b7a962b0$var$I.push(o), ()=>{
            let r = $87ae4e00b7a962b0$var$I.indexOf(o);
            r > -1 && $87ae4e00b7a962b0$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $87ae4e00b7a962b0$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $87ae4e00b7a962b0$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $87ae4e00b7a962b0$var$Q()
    }), $87ae4e00b7a962b0$var$S = (e)=>(t, o)=>{
        let s = $87ae4e00b7a962b0$var$ce(t, e, o);
        return $87ae4e00b7a962b0$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $87ae4e00b7a962b0$var$n = (e, t)=>$87ae4e00b7a962b0$var$S("blank")(e, t);
$87ae4e00b7a962b0$var$n.error = $87ae4e00b7a962b0$var$S("error");
$87ae4e00b7a962b0$var$n.success = $87ae4e00b7a962b0$var$S("success");
$87ae4e00b7a962b0$var$n.loading = $87ae4e00b7a962b0$var$S("loading");
$87ae4e00b7a962b0$var$n.custom = $87ae4e00b7a962b0$var$S("custom");
$87ae4e00b7a962b0$var$n.dismiss = (e)=>{
    $87ae4e00b7a962b0$var$l({
        type: 3,
        toastId: e
    });
};
$87ae4e00b7a962b0$var$n.remove = (e)=>$87ae4e00b7a962b0$var$l({
        type: 4,
        toastId: e
    });
$87ae4e00b7a962b0$var$n.promise = (e, t, o)=>{
    let s = $87ae4e00b7a962b0$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($87ae4e00b7a962b0$var$n.success($87ae4e00b7a962b0$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $87ae4e00b7a962b0$var$n.error($87ae4e00b7a962b0$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $87ae4e00b7a962b0$var$pe = (e, t)=>{
    $87ae4e00b7a962b0$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $87ae4e00b7a962b0$var$de = ()=>{
    $87ae4e00b7a962b0$var$l({
        type: 5,
        time: Date.now()
    });
}, $87ae4e00b7a962b0$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $87ae4e00b7a962b0$var$_1(e);
    (0, (parcelRequire("eXaQ2")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $87ae4e00b7a962b0$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$87ae4e00b7a962b0$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("eXaQ2")).useCallback)(()=>{
        o && $87ae4e00b7a962b0$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("eXaQ2")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $87ae4e00b7a962b0$var$pe,
            startPause: $87ae4e00b7a962b0$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $87ae4e00b7a962b0$var$T = $87ae4e00b7a962b0$var$W((parcelRequire("eXaQ2")));
let $6fc8a37e9a949fe9$var$e = {
    data: ""
}, $6fc8a37e9a949fe9$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $6fc8a37e9a949fe9$var$e, $6fc8a37e9a949fe9$export$54aba348a7896325 = (e)=>{
    let r = $6fc8a37e9a949fe9$var$t(e), l = r.data;
    return r.data = "", l;
}, $6fc8a37e9a949fe9$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $6fc8a37e9a949fe9$var$a = /\/\*[^]*?\*\/|  +/g, $6fc8a37e9a949fe9$var$n = /\n+/g, $6fc8a37e9a949fe9$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $6fc8a37e9a949fe9$var$o(c, n) : n + "{" + $6fc8a37e9a949fe9$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $6fc8a37e9a949fe9$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $6fc8a37e9a949fe9$var$o.p ? $6fc8a37e9a949fe9$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $6fc8a37e9a949fe9$var$c = {}, $6fc8a37e9a949fe9$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $6fc8a37e9a949fe9$var$s(e[r]);
        return t;
    }
    return e;
}, $6fc8a37e9a949fe9$var$i = (e, t, r, i, p)=>{
    let u = $6fc8a37e9a949fe9$var$s(e), d = $6fc8a37e9a949fe9$var$c[u] || ($6fc8a37e9a949fe9$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$6fc8a37e9a949fe9$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $6fc8a37e9a949fe9$var$l.exec(e.replace($6fc8a37e9a949fe9$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($6fc8a37e9a949fe9$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($6fc8a37e9a949fe9$var$n, " ").trim();
            return o[0];
        })(e);
        $6fc8a37e9a949fe9$var$c[d] = $6fc8a37e9a949fe9$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $6fc8a37e9a949fe9$var$c.g ? $6fc8a37e9a949fe9$var$c.g : null;
    return r && ($6fc8a37e9a949fe9$var$c.g = $6fc8a37e9a949fe9$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($6fc8a37e9a949fe9$var$c[d], t, i, f), d;
}, $6fc8a37e9a949fe9$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $6fc8a37e9a949fe9$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $6fc8a37e9a949fe9$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $6fc8a37e9a949fe9$var$i(l.unshift ? l.raw ? $6fc8a37e9a949fe9$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $6fc8a37e9a949fe9$var$t(r.target), r.g, r.o, r.k);
}
let $6fc8a37e9a949fe9$var$d, $6fc8a37e9a949fe9$var$f, $6fc8a37e9a949fe9$var$g, $6fc8a37e9a949fe9$export$442f1a04865e4790 = $6fc8a37e9a949fe9$export$dbf350e5966cf602.bind({
    g: 1
}), $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e = $6fc8a37e9a949fe9$export$dbf350e5966cf602.bind({
    k: 1
});
function $6fc8a37e9a949fe9$export$de27182ff8187d6c(e, t, r, l) {
    $6fc8a37e9a949fe9$var$o.p = t, $6fc8a37e9a949fe9$var$d = e, $6fc8a37e9a949fe9$var$f = r, $6fc8a37e9a949fe9$var$g = l;
}
function $6fc8a37e9a949fe9$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $6fc8a37e9a949fe9$var$f && $6fc8a37e9a949fe9$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $6fc8a37e9a949fe9$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $6fc8a37e9a949fe9$var$g && i[0] && $6fc8a37e9a949fe9$var$g(c), $6fc8a37e9a949fe9$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $87ae4e00b7a962b0$var$y = $87ae4e00b7a962b0$var$W((parcelRequire("eXaQ2")));


var $87ae4e00b7a962b0$var$me = $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e($87ae4e00b7a962b0$var$t || ($87ae4e00b7a962b0$var$t = $87ae4e00b7a962b0$var$_`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`)), $87ae4e00b7a962b0$var$ue = $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e($87ae4e00b7a962b0$var$t1 || ($87ae4e00b7a962b0$var$t1 = $87ae4e00b7a962b0$var$_`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`)), $87ae4e00b7a962b0$var$le = $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e($87ae4e00b7a962b0$var$t2 || ($87ae4e00b7a962b0$var$t2 = $87ae4e00b7a962b0$var$_`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`)), $87ae4e00b7a962b0$var$w = (0, $6fc8a37e9a949fe9$export$3817b7a54a07cec7)("div")($87ae4e00b7a962b0$var$t3 || ($87ae4e00b7a962b0$var$t3 = $87ae4e00b7a962b0$var$_`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${0};
  position: relative;
  transform: rotate(45deg);

  animation: ${0} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${0} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${0};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${0} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`), (e)=>e.primary || "#ff4b4b", $87ae4e00b7a962b0$var$me, $87ae4e00b7a962b0$var$ue, (e)=>e.secondary || "#fff", $87ae4e00b7a962b0$var$le);

var $87ae4e00b7a962b0$var$Te = $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e($87ae4e00b7a962b0$var$t4 || ($87ae4e00b7a962b0$var$t4 = $87ae4e00b7a962b0$var$_`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`)), $87ae4e00b7a962b0$var$M = (0, $6fc8a37e9a949fe9$export$3817b7a54a07cec7)("div")($87ae4e00b7a962b0$var$t5 || ($87ae4e00b7a962b0$var$t5 = $87ae4e00b7a962b0$var$_`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${0};
  border-right-color: ${0};
  animation: ${0} 1s linear infinite;
`), (e)=>e.secondary || "#e0e0e0", (e)=>e.primary || "#616161", $87ae4e00b7a962b0$var$Te);

var $87ae4e00b7a962b0$var$fe = $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e($87ae4e00b7a962b0$var$t6 || ($87ae4e00b7a962b0$var$t6 = $87ae4e00b7a962b0$var$_`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`)), $87ae4e00b7a962b0$var$ye = $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e($87ae4e00b7a962b0$var$t7 || ($87ae4e00b7a962b0$var$t7 = $87ae4e00b7a962b0$var$_`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`)), $87ae4e00b7a962b0$var$F = (0, $6fc8a37e9a949fe9$export$3817b7a54a07cec7)("div")($87ae4e00b7a962b0$var$t8 || ($87ae4e00b7a962b0$var$t8 = $87ae4e00b7a962b0$var$_`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${0};
  position: relative;
  transform: rotate(45deg);

  animation: ${0} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${0} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${0};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`), (e)=>e.primary || "#61d345", $87ae4e00b7a962b0$var$fe, $87ae4e00b7a962b0$var$ye, (e)=>e.secondary || "#fff");
var $87ae4e00b7a962b0$var$ge = (0, $6fc8a37e9a949fe9$export$3817b7a54a07cec7)("div")($87ae4e00b7a962b0$var$t9 || ($87ae4e00b7a962b0$var$t9 = $87ae4e00b7a962b0$var$_`
  position: absolute;
`)), $87ae4e00b7a962b0$var$he = (0, $6fc8a37e9a949fe9$export$3817b7a54a07cec7)("div")($87ae4e00b7a962b0$var$t10 || ($87ae4e00b7a962b0$var$t10 = $87ae4e00b7a962b0$var$_`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`)), $87ae4e00b7a962b0$var$xe = $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e($87ae4e00b7a962b0$var$t11 || ($87ae4e00b7a962b0$var$t11 = $87ae4e00b7a962b0$var$_`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`)), $87ae4e00b7a962b0$var$be = (0, $6fc8a37e9a949fe9$export$3817b7a54a07cec7)("div")($87ae4e00b7a962b0$var$t12 || ($87ae4e00b7a962b0$var$t12 = $87ae4e00b7a962b0$var$_`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${0} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`), $87ae4e00b7a962b0$var$xe), $87ae4e00b7a962b0$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $87ae4e00b7a962b0$var$y.createElement($87ae4e00b7a962b0$var$be, null, t) : t : o === "blank" ? null : $87ae4e00b7a962b0$var$y.createElement($87ae4e00b7a962b0$var$he, null, $87ae4e00b7a962b0$var$y.createElement($87ae4e00b7a962b0$var$M, {
        ...s
    }), o !== "loading" && $87ae4e00b7a962b0$var$y.createElement($87ae4e00b7a962b0$var$ge, null, o === "error" ? $87ae4e00b7a962b0$var$y.createElement($87ae4e00b7a962b0$var$w, {
        ...s
    }) : $87ae4e00b7a962b0$var$y.createElement($87ae4e00b7a962b0$var$F, {
        ...s
    })));
};
var $87ae4e00b7a962b0$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $87ae4e00b7a962b0$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $87ae4e00b7a962b0$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $87ae4e00b7a962b0$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $87ae4e00b7a962b0$var$Ee = (0, $6fc8a37e9a949fe9$export$3817b7a54a07cec7)("div")($87ae4e00b7a962b0$var$t13 || ($87ae4e00b7a962b0$var$t13 = $87ae4e00b7a962b0$var$_`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`)), $87ae4e00b7a962b0$var$Re = (0, $6fc8a37e9a949fe9$export$3817b7a54a07cec7)("div")($87ae4e00b7a962b0$var$t14 || ($87ae4e00b7a962b0$var$t14 = $87ae4e00b7a962b0$var$_`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`)), $87ae4e00b7a962b0$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $87ae4e00b7a962b0$var$R() ? [
        $87ae4e00b7a962b0$var$Pe,
        $87ae4e00b7a962b0$var$Oe
    ] : [
        $87ae4e00b7a962b0$var$Se(s),
        $87ae4e00b7a962b0$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $6fc8a37e9a949fe9$export$d25ddfdf17c3ad3e)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $87ae4e00b7a962b0$var$$ = $87ae4e00b7a962b0$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $87ae4e00b7a962b0$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $87ae4e00b7a962b0$var$T.createElement($87ae4e00b7a962b0$var$U, {
        toast: e
    }), c = $87ae4e00b7a962b0$var$T.createElement($87ae4e00b7a962b0$var$Re, {
        ...e.ariaProps
    }, $87ae4e00b7a962b0$var$u(e.message, e));
    return $87ae4e00b7a962b0$var$T.createElement($87ae4e00b7a962b0$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $87ae4e00b7a962b0$var$T.createElement($87ae4e00b7a962b0$var$T.Fragment, null, a, c));
});


var $87ae4e00b7a962b0$var$f = $87ae4e00b7a962b0$var$W((parcelRequire("eXaQ2")));
(0, $6fc8a37e9a949fe9$export$de27182ff8187d6c)($87ae4e00b7a962b0$var$f.createElement);
var $87ae4e00b7a962b0$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $87ae4e00b7a962b0$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $87ae4e00b7a962b0$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $87ae4e00b7a962b0$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $87ae4e00b7a962b0$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $87ae4e00b7a962b0$var$ke = $6fc8a37e9a949fe9$export$dbf350e5966cf602($87ae4e00b7a962b0$var$t15 || ($87ae4e00b7a962b0$var$t15 = $87ae4e00b7a962b0$var$_`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`)), $87ae4e00b7a962b0$var$L = 16, $87ae4e00b7a962b0$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $87ae4e00b7a962b0$var$V(o);
    return $87ae4e00b7a962b0$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $87ae4e00b7a962b0$var$L,
            left: $87ae4e00b7a962b0$var$L,
            right: $87ae4e00b7a962b0$var$L,
            bottom: $87ae4e00b7a962b0$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $87ae4e00b7a962b0$var$De(g, z);
        return $87ae4e00b7a962b0$var$f.createElement($87ae4e00b7a962b0$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $87ae4e00b7a962b0$var$ke : "",
            style: O
        }, p.type === "custom" ? $87ae4e00b7a962b0$var$u(p.message, p) : r ? r(p) : $87ae4e00b7a962b0$var$f.createElement($87ae4e00b7a962b0$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $87ae4e00b7a962b0$var$_e = $87ae4e00b7a962b0$var$n;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $e86a7d058696b512$var$extendStatics = function(d, b) {
    $e86a7d058696b512$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e86a7d058696b512$var$extendStatics(d, b);
};
function $e86a7d058696b512$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e86a7d058696b512$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e86a7d058696b512$export$18ce0697a983be9b = function() {
    $e86a7d058696b512$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e86a7d058696b512$export$18ce0697a983be9b.apply(this, arguments);
};
function $e86a7d058696b512$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e86a7d058696b512$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e86a7d058696b512$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e86a7d058696b512$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e86a7d058696b512$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e86a7d058696b512$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e86a7d058696b512$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e86a7d058696b512$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e86a7d058696b512$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e86a7d058696b512$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e86a7d058696b512$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e86a7d058696b512$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e86a7d058696b512$export$45d3717a4c69092e(o, m, p);
}
function $e86a7d058696b512$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e86a7d058696b512$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e86a7d058696b512$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e86a7d058696b512$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e86a7d058696b512$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e86a7d058696b512$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e86a7d058696b512$export$10c90e4f7922046c(v) {
    return this instanceof $e86a7d058696b512$export$10c90e4f7922046c ? (this.v = v, this) : new $e86a7d058696b512$export$10c90e4f7922046c(v);
}
function $e86a7d058696b512$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e86a7d058696b512$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e86a7d058696b512$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e86a7d058696b512$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e86a7d058696b512$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e86a7d058696b512$export$19a8beecd37a4c45 === "function" ? $e86a7d058696b512$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e86a7d058696b512$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e86a7d058696b512$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e86a7d058696b512$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e86a7d058696b512$export$45d3717a4c69092e(result, mod, k);
    }
    $e86a7d058696b512$var$__setModuleDefault(result, mod);
    return result;
}
function $e86a7d058696b512$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e86a7d058696b512$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e86a7d058696b512$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e86a7d058696b512$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e86a7d058696b512$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e86a7d058696b512$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e86a7d058696b512$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e86a7d058696b512$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $e86a7d058696b512$export$2e2bcd8739ae039 = {
    __extends: $e86a7d058696b512$export$a8ba968b8961cb8a,
    __assign: $e86a7d058696b512$export$18ce0697a983be9b,
    __rest: $e86a7d058696b512$export$3c9a16f847548506,
    __decorate: $e86a7d058696b512$export$29e00dfd3077644b,
    __param: $e86a7d058696b512$export$d5ad3fd78186038f,
    __metadata: $e86a7d058696b512$export$f1db080c865becb9,
    __awaiter: $e86a7d058696b512$export$1050f835b63b671e,
    __generator: $e86a7d058696b512$export$67ebef60e6f28a6,
    __createBinding: $e86a7d058696b512$export$45d3717a4c69092e,
    __exportStar: $e86a7d058696b512$export$f33643c0debef087,
    __values: $e86a7d058696b512$export$19a8beecd37a4c45,
    __read: $e86a7d058696b512$export$8d051b38c9118094,
    __spread: $e86a7d058696b512$export$afc72e2116322959,
    __spreadArrays: $e86a7d058696b512$export$6388937ca91ccae8,
    __spreadArray: $e86a7d058696b512$export$1216008129fb82ed,
    __await: $e86a7d058696b512$export$10c90e4f7922046c,
    __asyncGenerator: $e86a7d058696b512$export$e427f37a30a4de9b,
    __asyncDelegator: $e86a7d058696b512$export$bbd80228419bb833,
    __asyncValues: $e86a7d058696b512$export$e3b29a3d6162315f,
    __makeTemplateObject: $e86a7d058696b512$export$4fb47efe1390b86f,
    __importStar: $e86a7d058696b512$export$c21735bcef00d192,
    __importDefault: $e86a7d058696b512$export$da59b14a69baef04,
    __classPrivateFieldGet: $e86a7d058696b512$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e86a7d058696b512$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e86a7d058696b512$export$81fdc39f203e4e04,
    __addDisposableResource: $e86a7d058696b512$export$88ac25d8e944e405,
    __disposeResources: $e86a7d058696b512$export$8f076105dc360e92
};




var $f6c473f280f541f1$var$genericMessage = "Invariant Violation";
var $f6c473f280f541f1$var$_a = Object.setPrototypeOf, $f6c473f280f541f1$var$setPrototypeOf = $f6c473f280f541f1$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $f6c473f280f541f1$var$_a;
var $f6c473f280f541f1$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $f6c473f280f541f1$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $f6c473f280f541f1$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $f6c473f280f541f1$var$genericMessage;
        $f6c473f280f541f1$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $f6c473f280f541f1$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $f6c473f280f541f1$export$cea12affaee22fe8(message);
}
var $f6c473f280f541f1$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $f6c473f280f541f1$var$verbosityLevel = $f6c473f280f541f1$var$verbosityLevels.indexOf("log");
function $f6c473f280f541f1$var$wrapConsoleMethod(name) {
    return function() {
        if ($f6c473f280f541f1$var$verbosityLevels.indexOf(name) >= $f6c473f280f541f1$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $f6c473f280f541f1$var$wrapConsoleMethod("debug");
    invariant.log = $f6c473f280f541f1$var$wrapConsoleMethod("log");
    invariant.warn = $f6c473f280f541f1$var$wrapConsoleMethod("warn");
    invariant.error = $f6c473f280f541f1$var$wrapConsoleMethod("error");
})($f6c473f280f541f1$export$f5708dca728d7177 || ($f6c473f280f541f1$export$f5708dca728d7177 = {}));
function $f6c473f280f541f1$export$a80e09f2cd325fb8(level) {
    var old = $f6c473f280f541f1$var$verbosityLevels[$f6c473f280f541f1$var$verbosityLevel];
    $f6c473f280f541f1$var$verbosityLevel = Math.max(0, $f6c473f280f541f1$var$verbosityLevels.indexOf(level));
    return old;
}
var $f6c473f280f541f1$export$2e2bcd8739ae039 = $f6c473f280f541f1$export$f5708dca728d7177;


var $0f8685bb80f81a33$export$83d89fbfd8236492 = "3.8.0";


function $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $afa97bba87d2ecbf$export$2e2bcd8739ae039 = (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $1699e981531d98d6$var$prefixCounts = new Map();
function $1699e981531d98d6$export$d0c8ec0fe1b18b70(prefix) {
    var count = $1699e981531d98d6$var$prefixCounts.get(prefix) || 1;
    $1699e981531d98d6$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $6e454447f1ebf41f$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $1699e981531d98d6$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $90037d9f94267989$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        fn.apply(void 0, (0, $e86a7d058696b512$export$1216008129fb82ed)([
            typeof message === "number" ? $90037d9f94267989$var$getErrorMsg(message) : message
        ], args, false));
    };
}
var $90037d9f94267989$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $f6c473f280f541f1$export$f5708dca728d7177)(condition, $90037d9f94267989$var$getErrorMsg(message, args));
}, {
    debug: $90037d9f94267989$var$wrap((0, $f6c473f280f541f1$export$f5708dca728d7177).debug),
    log: $90037d9f94267989$var$wrap((0, $f6c473f280f541f1$export$f5708dca728d7177).log),
    warn: $90037d9f94267989$var$wrap((0, $f6c473f280f541f1$export$f5708dca728d7177).warn),
    error: $90037d9f94267989$var$wrap((0, $f6c473f280f541f1$export$f5708dca728d7177).error)
});
function $90037d9f94267989$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $f6c473f280f541f1$export$cea12affaee22fe8)($90037d9f94267989$var$getErrorMsg(message, optionalParams));
}
var $90037d9f94267989$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $0f8685bb80f81a33$export$83d89fbfd8236492));
function $90037d9f94267989$var$getErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    var args = messageArgs.map(function(arg) {
        return typeof arg == "string" ? arg : (0, $6e454447f1ebf41f$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    });
    return (0, $afa97bba87d2ecbf$export$2e2bcd8739ae039)[$90037d9f94267989$export$b8ca975fa04efdf3] && (0, $afa97bba87d2ecbf$export$2e2bcd8739ae039)[$90037d9f94267989$export$b8ca975fa04efdf3](message, args) || "An error occured! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $0f8685bb80f81a33$export$83d89fbfd8236492),
        message: message,
        args: args
    })));
}




var $60e1fd36a8483faf$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;



var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");

var $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) !== "ReactNative";
var $ba22ce8d716d9f8d$export$7293b8a0b474028d = typeof WeakSet === "function";
var $ba22ce8d716d9f8d$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $ba22ce8d716d9f8d$export$c34f882e9f1c1637 = $ba22ce8d716d9f8d$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $ba22ce8d716d9f8d$export$71594e8a50f746f4 = typeof (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $ba22ce8d716d9f8d$var$usingJSDOM = (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $ba22ce8d716d9f8d$export$4001f6cd4a62405b = $ba22ce8d716d9f8d$export$71594e8a50f746f4 && !$ba22ce8d716d9f8d$var$usingJSDOM;



var $26109d2cb69f3084$var$contextKey = (0, $ba22ce8d716d9f8d$export$23ba675b4b838b92) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $26109d2cb69f3084$export$a47505d961ee3a1() {
    (0, $90037d9f94267989$export$f5708dca728d7177)("createContext" in $eXaQ2, 43);
    var context = $eXaQ2.createContext[$26109d2cb69f3084$var$contextKey];
    if (!context) {
        Object.defineProperty($eXaQ2.createContext, $26109d2cb69f3084$var$contextKey, {
            value: context = $eXaQ2.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $26109d2cb69f3084$export$c2ee824bcc89ca6a = $26109d2cb69f3084$export$a47505d961ee3a1;


var $b202b70e175d000e$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $26109d2cb69f3084$export$a47505d961ee3a1)();
    var parentContext = $eXaQ2.useContext(ApolloContext);
    var context = $eXaQ2.useMemo(function() {
        return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $90037d9f94267989$export$f5708dca728d7177)(context.client, 44);
    return $eXaQ2.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};





function $61235f95b05576d5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $61235f95b05576d5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $61235f95b05576d5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $61235f95b05576d5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $61235f95b05576d5$var$_arrayLikeToArray(o, minLen);
}
function $61235f95b05576d5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $61235f95b05576d5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $61235f95b05576d5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $61235f95b05576d5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $61235f95b05576d5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $61235f95b05576d5$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $61235f95b05576d5$var$hasSymbol = function(name) {
    return $61235f95b05576d5$var$hasSymbols() && Boolean(Symbol[name]);
};
var $61235f95b05576d5$var$getSymbol = function(name) {
    return $61235f95b05576d5$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($61235f95b05576d5$var$hasSymbols() && !$61235f95b05576d5$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $61235f95b05576d5$var$SymbolIterator = $61235f95b05576d5$var$getSymbol("iterator");
var $61235f95b05576d5$var$SymbolObservable = $61235f95b05576d5$var$getSymbol("observable");
var $61235f95b05576d5$var$SymbolSpecies = $61235f95b05576d5$var$getSymbol("species"); // === Abstract Operations ===
function $61235f95b05576d5$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $61235f95b05576d5$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$61235f95b05576d5$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $61235f95b05576d5$export$77cea355fa80b5f4;
}
function $61235f95b05576d5$var$isObservable(x) {
    return x instanceof $61235f95b05576d5$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $61235f95b05576d5$var$hostReportError(e) {
    if ($61235f95b05576d5$var$hostReportError.log) $61235f95b05576d5$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $61235f95b05576d5$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $61235f95b05576d5$var$hostReportError(e);
        }
    });
}
function $61235f95b05576d5$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $61235f95b05576d5$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $61235f95b05576d5$var$hostReportError(e);
    }
}
function $61235f95b05576d5$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $61235f95b05576d5$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $61235f95b05576d5$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $61235f95b05576d5$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $61235f95b05576d5$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $61235f95b05576d5$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $61235f95b05576d5$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $61235f95b05576d5$var$hostReportError(e);
    }
    if (subscription._state === "closed") $61235f95b05576d5$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $61235f95b05576d5$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $61235f95b05576d5$var$enqueue(function() {
            return $61235f95b05576d5$var$flushSubscription(subscription);
        });
        return;
    }
    $61235f95b05576d5$var$notifySubscription(subscription, type, value);
}
var $61235f95b05576d5$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $61235f95b05576d5$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== "closed") {
            $61235f95b05576d5$var$closeSubscription(this);
            $61235f95b05576d5$var$cleanupSubscription(this);
        }
    };
    $61235f95b05576d5$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $61235f95b05576d5$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $61235f95b05576d5$var$onNotify(this._subscription, "next", value);
    };
    _proto2.error = function error(value) {
        $61235f95b05576d5$var$onNotify(this._subscription, "error", value);
    };
    _proto2.complete = function complete() {
        $61235f95b05576d5$var$onNotify(this._subscription, "complete");
    };
    $61235f95b05576d5$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $61235f95b05576d5$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== "object" || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $61235f95b05576d5$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== "function") {
                reject(new TypeError(fn + " is not a function"));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $61235f95b05576d5$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $61235f95b05576d5$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $61235f95b05576d5$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $61235f95b05576d5$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $61235f95b05576d5$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$61235f95b05576d5$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === "function" ? this : Observable;
        if (x == null) throw new TypeError(x + " is not an object");
        var method = $61235f95b05576d5$var$getMethod(x, $61235f95b05576d5$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
            if ($61235f95b05576d5$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($61235f95b05576d5$var$hasSymbol("iterator")) {
            method = $61235f95b05576d5$var$getMethod(x, $61235f95b05576d5$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $61235f95b05576d5$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $61235f95b05576d5$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $61235f95b05576d5$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + " is not observable");
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === "function" ? this : Observable;
        return new C(function(observer) {
            $61235f95b05576d5$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $61235f95b05576d5$var$_createClass(Observable, null, [
        {
            key: $61235f95b05576d5$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($61235f95b05576d5$var$hasSymbols()) Object.defineProperty($61235f95b05576d5$export$77cea355fa80b5f4, Symbol("extensions"), {
    value: {
        symbol: $61235f95b05576d5$var$SymbolObservable,
        hostReportError: $61235f95b05576d5$var$hostReportError
    },
    configurable: true
});


parcelRequire("b3NZy");
var $e925f6c293a06d5e$var$prototype = (0, $61235f95b05576d5$export$77cea355fa80b5f4).prototype;
var $e925f6c293a06d5e$var$fakeObsSymbol = "@@observable";
if (!$e925f6c293a06d5e$var$prototype[$e925f6c293a06d5e$var$fakeObsSymbol]) $e925f6c293a06d5e$var$prototype[$e925f6c293a06d5e$var$fakeObsSymbol] = function() {
    return this;
};



function $edc5ccd25929a1cc$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $44aaa2f331f80eb9$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $44aaa2f331f80eb9$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}




function $fb5c30f911b56608$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === "OperationDefinition") throw (0, $90037d9f94267989$export$3991762405098ea)(68, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    if (typeof actualFragmentName === "undefined") {
        (0, $90037d9f94267989$export$f5708dca728d7177)(fragments.length === 1, 69, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $e86a7d058696b512$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $fb5c30f911b56608$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $fb5c30f911b56608$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $90037d9f94267989$export$f5708dca728d7177)(fragment, 70, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}


function $42efdf4b92188e48$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $42efdf4b92188e48$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $42efdf4b92188e48$export$540432d49fcec6c9(value) {
    return (0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $42efdf4b92188e48$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $42efdf4b92188e48$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $42efdf4b92188e48$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $42efdf4b92188e48$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $42efdf4b92188e48$var$isVariable(value) {
    return value.kind === "Variable";
}
function $42efdf4b92188e48$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $42efdf4b92188e48$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $42efdf4b92188e48$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $42efdf4b92188e48$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $42efdf4b92188e48$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($42efdf4b92188e48$var$isIntValue(value) || $42efdf4b92188e48$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($42efdf4b92188e48$var$isBooleanValue(value) || $42efdf4b92188e48$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($42efdf4b92188e48$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $42efdf4b92188e48$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($42efdf4b92188e48$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($42efdf4b92188e48$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $42efdf4b92188e48$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($42efdf4b92188e48$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($42efdf4b92188e48$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $90037d9f94267989$export$3991762405098ea)(79, name.value, value.kind);
}
function $42efdf4b92188e48$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $42efdf4b92188e48$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $42efdf4b92188e48$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $42efdf4b92188e48$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $42efdf4b92188e48$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
var $42efdf4b92188e48$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($42efdf4b92188e48$var$stringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = $42efdf4b92188e48$var$stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($42efdf4b92188e48$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($42efdf4b92188e48$var$stringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $42efdf4b92188e48$var$stringify;
        $42efdf4b92188e48$var$stringify = s;
        return previous;
    }
});
var $42efdf4b92188e48$var$stringify = function defaultStringify(value) {
    return JSON.stringify(value, $42efdf4b92188e48$var$stringifyReplacer);
};
function $42efdf4b92188e48$var$stringifyReplacer(_key, value) {
    if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value) && !Array.isArray(value)) value = Object.keys(value).sort().reduce(function(copy, key) {
        copy[key] = value[key];
        return copy;
    }, {});
    return value;
}
function $42efdf4b92188e48$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $42efdf4b92188e48$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $42efdf4b92188e48$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $42efdf4b92188e48$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($42efdf4b92188e48$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$42efdf4b92188e48$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $42efdf4b92188e48$export$cf7bf7e4f289cc26(result, (0, $fb5c30f911b56608$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $42efdf4b92188e48$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $42efdf4b92188e48$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $6c3bf25907af95d3$export$a7d0d8111d2386df(doc) {
    (0, $90037d9f94267989$export$f5708dca728d7177)(doc && doc.kind === "Document", 71);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $90037d9f94267989$export$3991762405098ea)(72, definition.kind);
        return definition;
    });
    (0, $90037d9f94267989$export$f5708dca728d7177)(operations.length <= 1, 73, operations.length);
    return doc;
}
function $6c3bf25907af95d3$export$7a5b1fa979d2c158(doc) {
    $6c3bf25907af95d3$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $6c3bf25907af95d3$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $6c3bf25907af95d3$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $6c3bf25907af95d3$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $6c3bf25907af95d3$export$7a5b1fa979d2c158(doc);
    (0, $90037d9f94267989$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 74);
    return queryDef;
}
function $6c3bf25907af95d3$export$772111caef41b3f5(doc) {
    (0, $90037d9f94267989$export$f5708dca728d7177)(doc.kind === "Document", 75);
    (0, $90037d9f94267989$export$f5708dca728d7177)(doc.definitions.length <= 1, 76);
    var fragmentDef = doc.definitions[0];
    (0, $90037d9f94267989$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 77);
    return fragmentDef;
}
function $6c3bf25907af95d3$export$f431198736b7f96d(queryDoc) {
    $6c3bf25907af95d3$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $90037d9f94267989$export$3991762405098ea)(78);
}
function $6c3bf25907af95d3$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $42efdf4b92188e48$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $ed2eed50653d1959$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $6c3bf25907af95d3$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $57815f42ae6dceb6$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $90037d9f94267989$export$3991762405098ea)(41, key);
    }
    return operation;
}


function $261579e958b80d0b$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
}
function $261579e958b80d0b$var$toLink(handler) {
    return typeof handler === "function" ? new $261579e958b80d0b$export$2fed3d61f740bc7f(handler) : handler;
}
function $261579e958b80d0b$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $261579e958b80d0b$export$2fed3d61f740bc7f = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($261579e958b80d0b$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $261579e958b80d0b$var$toLink(left);
        var rightLink = $261579e958b80d0b$var$toLink(right || new ApolloLink($261579e958b80d0b$var$passthrough));
        if ($261579e958b80d0b$var$isTerminating(leftLink) && $261579e958b80d0b$var$isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $edc5ccd25929a1cc$export$f29bedd62f56fcb2)(operation.context, (0, $ed2eed50653d1959$export$4f3f7df1b558c729)((0, $57815f42ae6dceb6$export$a92a48117d546c9)(operation)))) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $261579e958b80d0b$var$toLink(first);
        if ($261579e958b80d0b$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(33, firstLink);
            return firstLink;
        }
        var nextLink = $261579e958b80d0b$var$toLink(second);
        if ($261579e958b80d0b$var$isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
            }) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
            }) || (0, $61235f95b05576d5$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($261579e958b80d0b$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $90037d9f94267989$export$3991762405098ea)(34);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $19de69a0941a1739$export$51396ec711da548b = (0, $261579e958b80d0b$export$2fed3d61f740bc7f).execute;









function $be5cbb698bc72cab$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $484bc9abac08b289$var$MAX_ARRAY_LENGTH = 10;
const $484bc9abac08b289$var$MAX_RECURSIVE_DEPTH = 2;
function $484bc9abac08b289$export$9dec5d1b3b6a130d(value) {
    return $484bc9abac08b289$var$formatValue(value, []);
}
function $484bc9abac08b289$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $484bc9abac08b289$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $484bc9abac08b289$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($484bc9abac08b289$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $484bc9abac08b289$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $484bc9abac08b289$var$formatArray(value, seenValues);
    return $484bc9abac08b289$var$formatObject(value, seenValues);
}
function $484bc9abac08b289$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $484bc9abac08b289$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $484bc9abac08b289$var$MAX_RECURSIVE_DEPTH) return "[" + $484bc9abac08b289$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $484bc9abac08b289$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $484bc9abac08b289$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $484bc9abac08b289$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($484bc9abac08b289$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($484bc9abac08b289$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $484bc9abac08b289$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $71999aa847a84d89$export$18a2be9195644f38 {
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
}
class $71999aa847a84d89$export$50792b0e93539fde {
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
}
const $71999aa847a84d89$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $71999aa847a84d89$var$kindValues = new Set(Object.keys($71999aa847a84d89$export$4fcd777a40ccf407));
function $71999aa847a84d89$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $71999aa847a84d89$var$kindValues.has(maybeKind);
}
/** Name */ var $71999aa847a84d89$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($71999aa847a84d89$export$f58c50edb4aef9d4 || ($71999aa847a84d89$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed kind values for AST nodes.
 */ var $497daa5850a219ed$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($497daa5850a219ed$export$a84bdc57c5122798 || ($497daa5850a219ed$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

const $70bd4df305f91616$export$a89c95c098ac2a58 = Object.freeze({});
function $70bd4df305f91616$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $71999aa847a84d89$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $497daa5850a219ed$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $70bd4df305f91616$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $71999aa847a84d89$export$8ee0fc9ee280b4ee)(node) || (0, $be5cbb698bc72cab$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $484bc9abac08b289$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $70bd4df305f91616$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $71999aa847a84d89$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $70bd4df305f91616$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $497daa5850a219ed$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $70bd4df305f91616$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $70bd4df305f91616$export$a89c95c098ac2a58) skipping[i] = $70bd4df305f91616$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $70bd4df305f91616$export$a89c95c098ac2a58) skipping[i] = $70bd4df305f91616$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $70bd4df305f91616$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $70bd4df305f91616$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $70bd4df305f91616$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $44cb04994d01448c$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $44cb04994d01448c$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $90037d9f94267989$export$f5708dca728d7177)(evaledValue !== void 0, 64, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $44cb04994d01448c$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $44cb04994d01448c$export$528b5e7d8ba07fbf = function(names, root) {
    return $44cb04994d01448c$export$2dafb573e282fe8d(names, root, false);
};
var $44cb04994d01448c$export$ad1b63b26c1a9b76 = function(names, root) {
    return $44cb04994d01448c$export$2dafb573e282fe8d(names, root, true);
};
function $44cb04994d01448c$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $70bd4df305f91616$export$a89c95c098ac2a58;
        }
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $44cb04994d01448c$export$8d1e9e5bbfa5d09a(document) {
    return document && $44cb04994d01448c$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $44cb04994d01448c$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $44cb04994d01448c$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$44cb04994d01448c$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $90037d9f94267989$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 65, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $90037d9f94267989$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 66, directiveName);
        var ifValue = ifArgument.value;
        (0, $90037d9f94267989$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 67, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}







var $763d36c6d12d5d9a$export$43bee75e5e14138e = Array.isArray;
function $763d36c6d12d5d9a$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


var $8c907b3dc6702288$var$TYPENAME_FIELD = {
    kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $8c907b3dc6702288$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_SPREAD && $8c907b3dc6702288$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $8c907b3dc6702288$var$nullIfDocIsEmpty(doc) {
    return $8c907b3dc6702288$var$isEmpty((0, $6c3bf25907af95d3$export$7a5b1fa979d2c158)(doc) || (0, $6c3bf25907af95d3$export$772111caef41b3f5)(doc), (0, $fb5c30f911b56608$export$193789b4c8246dd4)((0, $6c3bf25907af95d3$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $8c907b3dc6702288$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $8c907b3dc6702288$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            variables: new Set,
            fragmentSpreads: new Set
        });
        return inUse;
    };
}
function $8c907b3dc6702288$export$e5ae0530da5fe96c(directives, doc) {
    (0, $6c3bf25907af95d3$export$a7d0d8111d2386df)(doc);
    var getInUseByOperationName = $8c907b3dc6702288$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $8c907b3dc6702288$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OPERATION_DEFINITION) return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).error(80);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $8c907b3dc6702288$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(doc, {
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) return node;
                if (operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) return doc;
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_DEFINITION && operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    allFragmentNamesUsed.forEach(function(fragmentName) {
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!(!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $8c907b3dc6702288$var$nullIfDocIsEmpty((0, $70bd4df305f91616$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        FragmentSpread: enterVisitor,
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $8c907b3dc6702288$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return (0, $42efdf4b92188e48$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ((0, $42efdf4b92188e48$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $e86a7d058696b512$export$1216008129fb82ed)((0, $e86a7d058696b512$export$1216008129fb82ed)([], selections, true), [
                        $8c907b3dc6702288$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $8c907b3dc6702288$var$TYPENAME_FIELD;
    }
});
var $8c907b3dc6702288$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(81);
        }
        return willRemove;
    }
};
function $8c907b3dc6702288$export$74985f3324559867(doc) {
    return $8c907b3dc6702288$export$e5ae0530da5fe96c([
        $8c907b3dc6702288$var$connectionRemoveConfig
    ], (0, $6c3bf25907af95d3$export$a7d0d8111d2386df)(doc));
}
function $8c907b3dc6702288$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $8c907b3dc6702288$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $8c907b3dc6702288$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $42efdf4b92188e48$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($8c907b3dc6702288$var$getDirectiveMatcher(directives)) || nestedCheck && $8c907b3dc6702288$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $8c907b3dc6702288$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $8c907b3dc6702288$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $8c907b3dc6702288$var$getArgumentMatcher(config);
    return $8c907b3dc6702288$var$nullIfDocIsEmpty((0, $70bd4df305f91616$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, node), {
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $8c907b3dc6702288$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $8c907b3dc6702288$var$nullIfDocIsEmpty((0, $70bd4df305f91616$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $8c907b3dc6702288$export$57c368c23873f32b(document) {
    var definition = (0, $6c3bf25907af95d3$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") return document;
    var modifiedDoc = (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $8c907b3dc6702288$export$8eae69e876ee321e(document) {
    (0, $6c3bf25907af95d3$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $8c907b3dc6702288$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}



var $2f903c42561f6b3b$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $90037d9f94267989$export$3991762405098ea)(37, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $11f075da675b5bc1$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};




function $53cce3a69cc74ead$export$18f63c735264ee11(value) {
    return !!value.body;
}
function $53cce3a69cc74ead$export$ac613ff475b69d05(value) {
    return !!value.getReader;
}
function $53cce3a69cc74ead$export$fe1556bffc7e68ee(value) {
    return !!((0, $ba22ce8d716d9f8d$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $53cce3a69cc74ead$export$70be23b513fb72ac(value) {
    return !!value.stream;
}
function $53cce3a69cc74ead$export$5bcd6e94ed871c88(value) {
    return !!value.arrayBuffer;
}
function $53cce3a69cc74ead$export$530196473208426f(value) {
    return !!value.pipe;
}


function $5cd56d8c6b997198$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}



function $68adc0db119f1085$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $ba22ce8d716d9f8d$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}



function $82b13f0befdd9e06$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $ba22ce8d716d9f8d$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}



function $3a9700c9f62bb3d0$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $ba22ce8d716d9f8d$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $50017cecf77dedc5$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ((0, $53cce3a69cc74ead$export$18f63c735264ee11)(response)) body = response.body;
    if ((0, $53cce3a69cc74ead$export$fe1556bffc7e68ee)(body)) return (0, $5cd56d8c6b997198$export$2e2bcd8739ae039)(body);
    if ((0, $53cce3a69cc74ead$export$ac613ff475b69d05)(body)) return (0, $3a9700c9f62bb3d0$export$2e2bcd8739ae039)(body.getReader());
    if ((0, $53cce3a69cc74ead$export$70be23b513fb72ac)(body)) return (0, $3a9700c9f62bb3d0$export$2e2bcd8739ae039)(body.stream().getReader());
    if ((0, $53cce3a69cc74ead$export$5bcd6e94ed871c88)(body)) return (0, $82b13f0befdd9e06$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ((0, $53cce3a69cc74ead$export$530196473208426f)(body)) return (0, $68adc0db119f1085$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


var $78af17126ca2153c$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};





var $e174ce09a0f32944$export$4995664c1b49842e = Symbol();
function $e174ce09a0f32944$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$e174ce09a0f32944$export$4995664c1b49842e]);
    return false;
}
function $e174ce09a0f32944$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
var $e174ce09a0f32944$var$generateErrorMessage = function(err) {
    var errors = (0, $e86a7d058696b512$export$1216008129fb82ed)((0, $e86a7d058696b512$export$1216008129fb82ed)((0, $e86a7d058696b512$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors.map(function(err) {
        return (0, $44aaa2f331f80eb9$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $e174ce09a0f32944$export$26a337512320b8c6 = function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $e174ce09a0f32944$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);






var $dca2b5b7b9771289$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $dca2b5b7b9771289$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $dca2b5b7b9771289$export$160070228be94b08(sources);
}
function $dca2b5b7b9771289$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $dca2b5b7b9771289$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $dca2b5b7b9771289$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $dca2b5b7b9771289$export$509e11c221f576c0 = function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $dca2b5b7b9771289$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $44aaa2f331f80eb9$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(source) && (0, $44aaa2f331f80eb9$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($dca2b5b7b9771289$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $e86a7d058696b512$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $e86a7d058696b512$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $6e60f3121a4aab70$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $6e60f3121a4aab70$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $6e60f3121a4aab70$export$f90dc0a3531b8b83(value) {
    return $6e60f3121a4aab70$export$879767c5cdf33cb3(value) || $6e60f3121a4aab70$export$6c17a45d8c64ff02(value);
}
function $6e60f3121a4aab70$export$3f32b6369f408f33(value) {
    return (0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value) && "payload" in value;
}
function $6e60f3121a4aab70$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $dca2b5b7b9771289$export$509e11c221f576c0)();
    if ($6e60f3121a4aab70$export$879767c5cdf33cb3(result) && (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $6c8dd1ab33d497f3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6c8dd1ab33d497f3$export$ccb60864026baf09(response, nextValue) {
    var _a;
    return (0, $e86a7d058696b512$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _b, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _c, _d;
        return (0, $e86a7d058696b512$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $50017cecf77dedc5$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        iterator.next()
                    ];
                case 2:
                    _b = _e.sent(), value = _b.value, done = _b.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _c = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _c[0], buffer = _c[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $6c8dd1ab33d497f3$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $6c8dd1ab33d497f3$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $6e60f3121a4aab70$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) next = (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, result.payload);
                                    if ("errors" in result) next = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_d = {}, _d[0, $e174ce09a0f32944$export$4995664c1b49842e] = result.errors, _d))
                                    });
                                    nextValue(next);
                                } else nextValue(result);
                            } else if (Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
}
function $6c8dd1ab33d497f3$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $6c8dd1ab33d497f3$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $78af17126ca2153c$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $6c8dd1ab33d497f3$export$d3da1ecaf1206c58(err, observer) {
    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
    observer.error(err);
}
function $6c8dd1ab33d497f3$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $6c8dd1ab33d497f3$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (response.status >= 300) (0, $78af17126ca2153c$export$c33ef9219f27efd7)(response, result, "Response not successful: Received status code ".concat(response.status));
            if (!Array.isArray(result) && !$6c8dd1ab33d497f3$var$hasOwnProperty.call(result, "data") && !$6c8dd1ab33d497f3$var$hasOwnProperty.call(result, "errors")) (0, $78af17126ca2153c$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $af2ef9a205297738$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $90037d9f94267989$export$3991762405098ea)(35);
};



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $ffbef1569f292b56$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $ffbef1569f292b56$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $ffbef1569f292b56$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $ffbef1569f292b56$export$45a677ea7cb6d5c8(code) {
    return $ffbef1569f292b56$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $ffbef1569f292b56$export$d3f406ff46035894(code) {
    return $ffbef1569f292b56$export$79c5d5217943d6a7(code) || $ffbef1569f292b56$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $caa811299716c7dd$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $caa811299716c7dd$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $caa811299716c7dd$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $ffbef1569f292b56$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $caa811299716c7dd$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $caa811299716c7dd$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $ffbef1569f292b56$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $ffbef1569f292b56$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $ac3b5ffb45a60480$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($ac3b5ffb45a60480$var$escapedRegExp, $ac3b5ffb45a60480$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $ac3b5ffb45a60480$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $ac3b5ffb45a60480$var$escapedReplacer(str) {
    return $ac3b5ffb45a60480$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $ac3b5ffb45a60480$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];



function $e800e4074af36bc4$export$c2d084dc44961371(ast) {
    return (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(ast, $e800e4074af36bc4$var$printDocASTReducer);
}
const $e800e4074af36bc4$var$MAX_LINE_LENGTH = 80;
const $e800e4074af36bc4$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$e800e4074af36bc4$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $e800e4074af36bc4$var$wrap("(", $e800e4074af36bc4$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $e800e4074af36bc4$var$join([
                node.operation,
                $e800e4074af36bc4$var$join([
                    node.name,
                    varDefs
                ]),
                $e800e4074af36bc4$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $e800e4074af36bc4$var$wrap(" = ", defaultValue) + $e800e4074af36bc4$var$wrap(" ", $e800e4074af36bc4$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$e800e4074af36bc4$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $e800e4074af36bc4$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $e800e4074af36bc4$var$wrap("(", $e800e4074af36bc4$var$join(args, ", "), ")");
            if (argsLine.length > $e800e4074af36bc4$var$MAX_LINE_LENGTH) argsLine = prefix + $e800e4074af36bc4$var$wrap("(\n", $e800e4074af36bc4$var$indent($e800e4074af36bc4$var$join(args, "\n")), "\n)");
            return $e800e4074af36bc4$var$join([
                argsLine,
                $e800e4074af36bc4$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $e800e4074af36bc4$var$wrap(" ", $e800e4074af36bc4$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$e800e4074af36bc4$var$join([
                "...",
                $e800e4074af36bc4$var$wrap("on ", typeCondition),
                $e800e4074af36bc4$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$e800e4074af36bc4$var$wrap("(", $e800e4074af36bc4$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$e800e4074af36bc4$var$wrap("", $e800e4074af36bc4$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $caa811299716c7dd$export$adb6ca997eeb1f45)(value) : (0, $ac3b5ffb45a60480$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $e800e4074af36bc4$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $e800e4074af36bc4$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $e800e4074af36bc4$var$wrap("(", $e800e4074af36bc4$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                "schema",
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                "scalar",
                name,
                $e800e4074af36bc4$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                "type",
                name,
                $e800e4074af36bc4$var$wrap("implements ", $e800e4074af36bc4$var$join(interfaces, " & ")),
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$e800e4074af36bc4$var$wrap("", description, "\n") + name + ($e800e4074af36bc4$var$hasMultilineItems(args) ? $e800e4074af36bc4$var$wrap("(\n", $e800e4074af36bc4$var$indent($e800e4074af36bc4$var$join(args, "\n")), "\n)") : $e800e4074af36bc4$var$wrap("(", $e800e4074af36bc4$var$join(args, ", "), ")")) + ": " + type + $e800e4074af36bc4$var$wrap(" ", $e800e4074af36bc4$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                name + ": " + type,
                $e800e4074af36bc4$var$wrap("= ", defaultValue),
                $e800e4074af36bc4$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                "interface",
                name,
                $e800e4074af36bc4$var$wrap("implements ", $e800e4074af36bc4$var$join(interfaces, " & ")),
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                "union",
                name,
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$wrap("= ", $e800e4074af36bc4$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                "enum",
                name,
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                name,
                $e800e4074af36bc4$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$e800e4074af36bc4$var$wrap("", description, "\n") + $e800e4074af36bc4$var$join([
                "input",
                name,
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$e800e4074af36bc4$var$wrap("", description, "\n") + "directive @" + name + ($e800e4074af36bc4$var$hasMultilineItems(args) ? $e800e4074af36bc4$var$wrap("(\n", $e800e4074af36bc4$var$indent($e800e4074af36bc4$var$join(args, "\n")), "\n)") : $e800e4074af36bc4$var$wrap("(", $e800e4074af36bc4$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $e800e4074af36bc4$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$e800e4074af36bc4$var$join([
                "extend schema",
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$e800e4074af36bc4$var$join([
                "extend scalar",
                name,
                $e800e4074af36bc4$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e800e4074af36bc4$var$join([
                "extend type",
                name,
                $e800e4074af36bc4$var$wrap("implements ", $e800e4074af36bc4$var$join(interfaces, " & ")),
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e800e4074af36bc4$var$join([
                "extend interface",
                name,
                $e800e4074af36bc4$var$wrap("implements ", $e800e4074af36bc4$var$join(interfaces, " & ")),
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$e800e4074af36bc4$var$join([
                "extend union",
                name,
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$wrap("= ", $e800e4074af36bc4$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$e800e4074af36bc4$var$join([
                "extend enum",
                name,
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$e800e4074af36bc4$var$join([
                "extend input",
                name,
                $e800e4074af36bc4$var$join(directives, " "),
                $e800e4074af36bc4$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e800e4074af36bc4$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $e800e4074af36bc4$var$block(array) {
    return $e800e4074af36bc4$var$wrap("{\n", $e800e4074af36bc4$var$indent($e800e4074af36bc4$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e800e4074af36bc4$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $e800e4074af36bc4$var$indent(str) {
    return $e800e4074af36bc4$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $e800e4074af36bc4$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}



var $cc3c800a908b17d2$var$printCache = (0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9) ? new WeakMap() : undefined;
var $cc3c800a908b17d2$export$c2d084dc44961371 = function(ast) {
    var result;
    result = $cc3c800a908b17d2$var$printCache === null || $cc3c800a908b17d2$var$printCache === void 0 ? void 0 : $cc3c800a908b17d2$var$printCache.get(ast);
    if (!result) {
        result = (0, $e800e4074af36bc4$export$c2d084dc44961371)(ast);
        $cc3c800a908b17d2$var$printCache === null || $cc3c800a908b17d2$var$printCache === void 0 || $cc3c800a908b17d2$var$printCache.set(ast, result);
    }
    return result;
};


var $ed80e411c36705f8$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $ed80e411c36705f8$var$defaultHeaders = {
    accept: "*/*",
    "content-type": "application/json"
};
var $ed80e411c36705f8$var$defaultOptions = {
    method: "POST"
};
var $ed80e411c36705f8$export$dd86f00dc866e75d = {
    http: $ed80e411c36705f8$var$defaultHttpOptions,
    headers: $ed80e411c36705f8$var$defaultHeaders,
    options: $ed80e411c36705f8$var$defaultOptions
};
var $ed80e411c36705f8$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $ed80e411c36705f8$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $ed80e411c36705f8$export$12d90ccf75844275.apply(void 0, (0, $e86a7d058696b512$export$1216008129fb82ed)([
        operation,
        $ed80e411c36705f8$export$e88934976ca4fd65
    ], configs, false));
}
function $ed80e411c36705f8$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $ed80e411c36705f8$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = printer(query, (0, $cc3c800a908b17d2$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
function $ed80e411c36705f8$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $2e76291cf297c7a2$export$fb82bb094b6f76b5(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $2f903c42561f6b3b$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $2f903c42561f6b3b$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}




function $f9695f0d553575c2$export$de246493ae27fe3f(variables, query) {
    var result = (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $a9c6648b09920aa3$export$4fd972edbe7450d3(errorValue) {
    return new (0, $61235f95b05576d5$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $0883ade327e7160b$var$backupFetch = (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $0883ade327e7160b$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $ed80e411c36705f8$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $e86a7d058696b512$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) (0, $af2ef9a205297738$export$8423f0cd3773115e)(preferredFetch || $0883ade327e7160b$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $261579e958b80d0b$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $11f075da675b5bc1$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $44cb04994d01448c$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $8c907b3dc6702288$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $a9c6648b09920aa3$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        var _b = (0, $ed80e411c36705f8$export$12d90ccf75844275)(operation, print, (0, $ed80e411c36705f8$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $f9695f0d553575c2$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $6c3bf25907af95d3$export$f431198736b7f96d)(operation.query));
        var hasDefer = (0, $44cb04994d01448c$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(36);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $2e76291cf297c7a2$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $a9c6648b09920aa3$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $2f903c42561f6b3b$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $a9c6648b09920aa3$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $61235f95b05576d5$export$77cea355fa80b5f4)(function(observer) {
            var currentFetch = preferredFetch || (0, $8f41e2d4c2b71e9a$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $0883ade327e7160b$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $6c8dd1ab33d497f3$export$ccb60864026baf09)(response, observerNext);
                else return (0, $6c8dd1ab33d497f3$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $6c8dd1ab33d497f3$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};


var $11d4a93442a9ed17$export$f4bbf1aec241cc1 = function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $0883ade327e7160b$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $261579e958b80d0b$export$2fed3d61f740bc7f));




const { toString: $8a2a53380af04d4b$var$toString, hasOwnProperty: $8a2a53380af04d4b$var$hasOwnProperty } = Object.prototype;
const $8a2a53380af04d4b$var$fnToStr = Function.prototype.toString;
const $8a2a53380af04d4b$var$previousComparisons = new Map();
function $8a2a53380af04d4b$export$411ce8e5a71e3069(a, b) {
    try {
        return $8a2a53380af04d4b$var$check(a, b);
    } finally{
        $8a2a53380af04d4b$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$8a2a53380af04d4b$export$2e2bcd8739ae039 = $8a2a53380af04d4b$export$411ce8e5a71e3069;
function $8a2a53380af04d4b$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $8a2a53380af04d4b$var$toString.call(a);
    const bTag = $8a2a53380af04d4b$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            {
                if ($8a2a53380af04d4b$var$previouslyCompared(a, b)) return true;
                const aKeys = $8a2a53380af04d4b$var$definedKeys(a);
                const bKeys = $8a2a53380af04d4b$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$8a2a53380af04d4b$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$8a2a53380af04d4b$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == `${b}`;
        case "[object Map]":
        case "[object Set]":
            {
                if (a.size !== b.size) return false;
                if ($8a2a53380af04d4b$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === "[object Map]";
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$8a2a53380af04d4b$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case "[object Uint16Array]":
        case "[object Uint8Array]":
        case "[object Uint32Array]":
        case "[object Int32Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object ArrayBuffer]":
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case "[object DataView]":
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case "[object AsyncFunction]":
        case "[object GeneratorFunction]":
        case "[object AsyncGeneratorFunction]":
        case "[object Function]":
            {
                const aCode = $8a2a53380af04d4b$var$fnToStr.call(a);
                if (aCode !== $8a2a53380af04d4b$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$8a2a53380af04d4b$var$endsWith(aCode, $8a2a53380af04d4b$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $8a2a53380af04d4b$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($8a2a53380af04d4b$var$isDefinedKey, obj);
}
function $8a2a53380af04d4b$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $8a2a53380af04d4b$var$nativeCodeSuffix = "{ [native code] }";
function $8a2a53380af04d4b$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $8a2a53380af04d4b$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $8a2a53380af04d4b$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $8a2a53380af04d4b$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}




function $2517fdd76eefbd20$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $61235f95b05576d5$export$77cea355fa80b5f4)(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, delegate) {
            if (examiner) return function(arg) {
                ++activeCallbackCount;
                var both = function() {
                    return examiner(arg);
                };
                promiseQueue = promiseQueue.then(both, both).then(function(result) {
                    --activeCallbackCount;
                    next && next.call(observer, result);
                    if (completed) handler.complete();
                }, function(error) {
                    --activeCallbackCount;
                    throw error;
                }).catch(function(caught) {
                    error && error.call(observer, caught);
                });
            };
            else return function(arg) {
                return delegate && delegate.call(observer, arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function() {
                completed = true;
                if (!activeCallbackCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}



function $7f1e65fc354b75d7$export$9f6c99ae166dbeca(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $2764a24013a7cff8$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, {
            value: (0, $61235f95b05576d5$export$77cea355fa80b5f4)
        });
    }
    if ((0, $ba22ce8d716d9f8d$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    set("@@species");
    return subclass;
}


function $79181b485fc9b84c$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var $79181b485fc9b84c$export$ae0cf2ec7a6fa78e = function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $7f1e65fc354b75d7$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $7f1e65fc354b75d7$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        (0, $7f1e65fc354b75d7$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($79181b485fc9b84c$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    });
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function(_) {});
        if (typeof sources === "function") sources = [
            new (0, $61235f95b05576d5$export$77cea355fa80b5f4)(sources)
        ];
        if ($79181b485fc9b84c$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $61235f95b05576d5$export$77cea355fa80b5f4));
(0, $2764a24013a7cff8$export$33c8bd820eece9b2)($79181b485fc9b84c$export$ae0cf2ec7a6fa78e);

// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $0fbf71c7f46d62d0$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $0fbf71c7f46d62d0$var$forEach, slice: $0fbf71c7f46d62d0$var$slice } = Array.prototype;
const { hasOwnProperty: $0fbf71c7f46d62d0$var$hasOwnProperty } = Object.prototype;
class $0fbf71c7f46d62d0$export$73571c50d0f2507e {
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        $0fbf71c7f46d62d0$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $0fbf71c7f46d62d0$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($0fbf71c7f46d62d0$var$slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = this.weakness && $0fbf71c7f46d62d0$var$isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && $0fbf71c7f46d62d0$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child) map.set(key, child = new $0fbf71c7f46d62d0$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    constructor(weakness = true, makeData = $0fbf71c7f46d62d0$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
}
function $0fbf71c7f46d62d0$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}





function $51442340ed782c5f$var$identity(document) {
    return document;
}
var $51442340ed782c5f$export$f887060e48e5dc1b = function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $ba22ce8d716d9f8d$export$7293b8a0b474028d) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) this.getCacheKey = options.getCacheKey;
        if (options.cache !== false) this.stableCacheKeys = new (0, $0fbf71c7f46d62d0$export$73571c50d0f2507e)((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9), function(key) {
            return {
                key: key
            };
        });
    }
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        return new DocumentTransform($51442340ed782c5f$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, {
            cache: false
        });
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        if (this.resultCache.has(document)) return document;
        var cacheEntry = this.getStableCacheEntry(document);
        if (cacheEntry && cacheEntry.value) return cacheEntry.value;
        (0, $6c3bf25907af95d3$export$a7d0d8111d2386df)(document);
        var transformedDocument = this.transform(document);
        this.resultCache.add(transformedDocument);
        if (cacheEntry) cacheEntry.value = transformedDocument;
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, {
            cache: false
        });
    };
    DocumentTransform.prototype.getStableCacheEntry = function(document) {
        if (!this.stableCacheKeys) return;
        var cacheKeys = this.getCacheKey(document);
        if (cacheKeys) {
            (0, $90037d9f94267989$export$f5708dca728d7177)(Array.isArray(cacheKeys), 63);
            return this.stableCacheKeys.lookupArray(cacheKeys);
        }
    };
    return DocumentTransform;
}();



function $42ff4ed032b9cc1f$export$b4df399e879e53ab(result) {
    var errors = $42ff4ed032b9cc1f$export$a163557155188b6e(result);
    return (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(errors);
}
function $42ff4ed032b9cc1f$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $6e60f3121a4aab70$export$879767c5cdf33cb3)(result) && (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}





function $70dcb8ce73dffddb$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}


var $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $753d0d78ac8d1d6c$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $753d0d78ac8d1d6c$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$753d0d78ac8d1d6c$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$753d0d78ac8d1d6c$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        if ($753d0d78ac8d1d6c$export$b931b78cbb3caf86(id) && !$753d0d78ac8d1d6c$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$753d0d78ac8d1d6c$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $753d0d78ac8d1d6c$var$defaultConfig = {
    dataIdFromObject: $753d0d78ac8d1d6c$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false
};
function $753d0d78ac8d1d6c$export$fa542f9ee3f7f4e2(config) {
    return (0, $70dcb8ce73dffddb$export$8e16b83750b44988)($753d0d78ac8d1d6c$var$defaultConfig, config);
}
function $753d0d78ac8d1d6c$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $753d0d78ac8d1d6c$var$defaultConfig.canonizeResults : value;
}
function $753d0d78ac8d1d6c$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $42efdf4b92188e48$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $753d0d78ac8d1d6c$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $753d0d78ac8d1d6c$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($753d0d78ac8d1d6c$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $753d0d78ac8d1d6c$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(result)) return (0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $753d0d78ac8d1d6c$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $42efdf4b92188e48$export$fb56ad75dd311c12)(field) && (0, $44cb04994d01448c$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $42efdf4b92188e48$export$7d1ad22471852218)(field);
            return $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $753d0d78ac8d1d6c$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        return true;
    });
    return false;
}
function $753d0d78ac8d1d6c$export$4f39afca21bd938e(value) {
    return (0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value) && !(0, $42efdf4b92188e48$export$fa99cac1c0883c47)(value) && !(0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(value);
}
function $753d0d78ac8d1d6c$export$b874a818f7a2fa6d() {
    return new (0, $dca2b5b7b9771289$export$509e11c221f576c0);
}
function $753d0d78ac8d1d6c$export$3a33c00f0ae4a480(document, fragments) {
    var fragmentMap = (0, $fb5c30f911b56608$export$193789b4c8246dd4)((0, $6c3bf25907af95d3$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


function $87dbe8b2a1cf9cd8$var$shallowCopy(value) {
    if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value)) return (0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $e86a7d058696b512$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
var $87dbe8b2a1cf9cd8$export$c2e7fdd82233f4a4 = function() {
    function ObjectCanon() {
        this.known = new ((0, $ba22ce8d716d9f8d$export$7293b8a0b474028d) ? WeakSet : Set)();
        this.pool = new (0, $0fbf71c7f46d62d0$export$73571c50d0f2507e)((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9));
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value)) {
            var copy = $87dbe8b2a1cf9cd8$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();
var $87dbe8b2a1cf9cd8$export$88a0ad9b6f961b51 = Object.assign(function(value) {
    if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value)) {
        if ($87dbe8b2a1cf9cd8$var$stringifyCanon === void 0) $87dbe8b2a1cf9cd8$var$resetCanonicalStringify();
        var canonical = $87dbe8b2a1cf9cd8$var$stringifyCanon.admit(value);
        var json = $87dbe8b2a1cf9cd8$var$stringifyCache.get(canonical);
        if (json === void 0) $87dbe8b2a1cf9cd8$var$stringifyCache.set(canonical, json = JSON.stringify(canonical));
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: $87dbe8b2a1cf9cd8$var$resetCanonicalStringify
});
var $87dbe8b2a1cf9cd8$var$stringifyCanon;
var $87dbe8b2a1cf9cd8$var$stringifyCache;
function $87dbe8b2a1cf9cd8$var$resetCanonicalStringify() {
    $87dbe8b2a1cf9cd8$var$stringifyCanon = new $87dbe8b2a1cf9cd8$export$c2e7fdd82233f4a4;
    $87dbe8b2a1cf9cd8$var$stringifyCache = new ((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
}







var $43f21a53b07f28f6$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($43f21a53b07f28f6$export$bd096ddbd246c79c || ($43f21a53b07f28f6$export$bd096ddbd246c79c = {}));
function $43f21a53b07f28f6$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $43f21a53b07f28f6$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}


var $51b1e8c9ceec485b$var$toString = Object.prototype.toString;
function $51b1e8c9ceec485b$export$629a2bd3f5a49ecc(value) {
    return $51b1e8c9ceec485b$var$cloneDeepHelper(value);
}
function $51b1e8c9ceec485b$var$cloneDeepHelper(val, seen) {
    switch($51b1e8c9ceec485b$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $51b1e8c9ceec485b$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $51b1e8c9ceec485b$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}





function $e3dc763975674e4f$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $e86a7d058696b512$export$3c9a16f847548506)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $e86a7d058696b512$export$3c9a16f847548506)(_b, [
        "data"
    ]);
    return (0, $8a2a53380af04d4b$export$2e2bcd8739ae039)(aRest, bRest) && $e3dc763975674e4f$var$equalBySelectionSet((0, $6c3bf25907af95d3$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $fb5c30f911b56608$export$193789b4c8246dd4)((0, $6c3bf25907af95d3$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $e3dc763975674e4f$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    return selectionSet.selections.every(function(selection) {
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        if (!(0, $44cb04994d01448c$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        if ($e3dc763975674e4f$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $42efdf4b92188e48$export$fb56ad75dd311c12)(selection)) {
            var resultKey = (0, $42efdf4b92188e48$export$7d1ad22471852218)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) return (0, $8a2a53380af04d4b$export$2e2bcd8739ae039)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$e3dc763975674e4f$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $e3dc763975674e4f$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $fb5c30f911b56608$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                if ($e3dc763975674e4f$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $e3dc763975674e4f$var$equalBySelectionSet(fragment.selectionSet, aResult, bResult, context);
            }
        }
    });
}
function $e3dc763975674e4f$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($e3dc763975674e4f$var$directiveIsNonreactive);
}
function $e3dc763975674e4f$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}


var $1faba75f406506d4$var$assign = Object.assign, $1faba75f406506d4$var$hasOwnProperty = Object.hasOwnProperty;
var $1faba75f406506d4$export$6c1b56eac59c9584 = function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $1faba75f406506d4$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            if (first) _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.waitForOwnResult = $1faba75f406506d4$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            initialFetchPolicy: initialFetchPolicy,
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $6c3bf25907af95d3$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).ready;
        var result = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $43f21a53b07f28f6$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if ($1faba75f406506d4$var$skipCacheDataFor(fetchPolicy) || this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                delete result.partial;
                if (diff.complete && result.networkStatus === (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $1faba75f406506d4$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !(0, $e3dc763975674e4f$export$5e40714c5ad44445)(this.query, this.last.result, newResult, this.variables) : !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $1faba75f406506d4$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $6c3bf25907af95d3$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(18, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(this.options.variables, variables)) reobserveOptions.variables = this.options.variables = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            if (!updatedQuerySet.has(_this.query)) $1faba75f406506d4$export$419171d60552792a(_this);
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).error(19, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $70dcb8ce73dffddb$export$8e16b83750b44988)(this.options, newOptions || {});
        $1faba75f406506d4$var$assign(this.options, mergedOptions);
    };
    ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(this.variables, variables)) return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).setVariables);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $90037d9f94267989$export$f5708dca728d7177)(pollInterval, 20);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            if (_this.pollingInfo) {
                if (!(0, $43f21a53b07f28f6$export$37509604341a3464)(_this.queryInfo.networkStatus)) _this.reobserve({
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        if (error && this.last && !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $e86a7d058696b512$export$18ce0697a983be9b)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $51b1e8c9ceec485b$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).refetch || newNetworkStatus === (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).fetchMore || newNetworkStatus === (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $70dcb8ce73dffddb$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? mergedOptions : $1faba75f406506d4$var$assign(this.options, mergedOptions);
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions && newOptions.variables && !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && options.fetchPolicy !== "standby" && options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).setVariables;
            }
        }
        var fetchOptions = query === options.query ? options : (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            query: query
        });
        this.waitForOwnResult && (this.waitForOwnResult = $1faba75f406506d4$var$skipCacheDataFor(fetchOptions.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = fetchOptions.variables && (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, fetchOptions.variables);
        var _a = this.fetch(fetchOptions, newNetworkStatus), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                finishWaitingForOwnResult();
                _this.reportResult(result, variables);
            },
            error: function(error) {
                finishWaitingForOwnResult();
                _this.reportError(error, variables);
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.observe = function() {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $7f1e65fc354b75d7$export$9f6c99ae166dbeca)(this.observers, "next", result);
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        var errorResult = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $7f1e65fc354b75d7$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}((0, $61235f95b05576d5$export$77cea355fa80b5f4));
(0, $2764a24013a7cff8$export$33c8bd820eece9b2)($1faba75f406506d4$export$6c1b56eac59c9584);
function $1faba75f406506d4$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        nextFetchPolicy: function() {
            this.nextFetchPolicy = nextFetchPolicy;
            if (typeof nextFetchPolicy === "function") return nextFetchPolicy.apply(this, arguments);
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $1faba75f406506d4$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).error(21, error.message, error.stack);
}
function $1faba75f406506d4$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).debug(22, missing);
}
function $1faba75f406506d4$var$skipCacheDataFor(fetchPolicy) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}






function $9990c5aad367019f$export$e7ecd7c16613ccfd(node) {
    return $9990c5aad367019f$export$4cedd8740794bd78(node) || $9990c5aad367019f$export$b05c7141ec7770ba(node) || $9990c5aad367019f$export$fbc18e88163d676d(node);
}
function $9990c5aad367019f$export$4cedd8740794bd78(node) {
    return node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $9990c5aad367019f$export$65772b71e1d017ba(node) {
    return node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FIELD || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $9990c5aad367019f$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).INT || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FLOAT || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).STRING || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).NULL || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).ENUM || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).LIST || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OBJECT;
}
function $9990c5aad367019f$export$f95bfad9e6aea45f(node) {
    return $9990c5aad367019f$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).LIST ? node.values.some($9990c5aad367019f$export$f95bfad9e6aea45f) : node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OBJECT ? node.fields.some((field)=>$9990c5aad367019f$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $497daa5850a219ed$export$a84bdc57c5122798).VARIABLE);
}
function $9990c5aad367019f$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $9990c5aad367019f$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).SCHEMA_DEFINITION || $9990c5aad367019f$export$a3584bba04f5bfe0(node) || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $9990c5aad367019f$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $9990c5aad367019f$export$fbc18e88163d676d(node) {
    return node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).SCHEMA_EXTENSION || $9990c5aad367019f$export$d7907721b241e11f(node);
}
function $9990c5aad367019f$export$d7907721b241e11f(node) {
    return node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}




function $73042ac6c421f083$var$defaultDispose() {}
class $73042ac6c421f083$export$94affb487e701bf2 {
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
    constructor(max = Infinity, dispose = $73042ac6c421f083$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
}


// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $8bf3c46acb3759ee$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $8bf3c46acb3759ee$var$MISSING_VALUE = {};
let $8bf3c46acb3759ee$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $8bf3c46acb3759ee$var$makeSlotClass = ()=>{
    class Slot {
        hasValue() {
            for(let context = $8bf3c46acb3759ee$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $8bf3c46acb3759ee$var$MISSING_VALUE) break;
                if (context !== $8bf3c46acb3759ee$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $8bf3c46acb3759ee$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($8bf3c46acb3759ee$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $8bf3c46acb3759ee$var$currentContext.slots[this.id] = $8bf3c46acb3759ee$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $8bf3c46acb3759ee$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $8bf3c46acb3759ee$var$currentContext;
            $8bf3c46acb3759ee$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $8bf3c46acb3759ee$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $8bf3c46acb3759ee$var$currentContext;
            return function() {
                const saved = $8bf3c46acb3759ee$var$currentContext;
                try {
                    $8bf3c46acb3759ee$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $8bf3c46acb3759ee$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($8bf3c46acb3759ee$var$currentContext) {
                const saved = $8bf3c46acb3759ee$var$currentContext;
                try {
                    $8bf3c46acb3759ee$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $8bf3c46acb3759ee$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $8bf3c46acb3759ee$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
    }
    return Slot;
};
function $8bf3c46acb3759ee$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $8bf3c46acb3759ee$var$globalKey = "@wry/context:Slot";
const $8bf3c46acb3759ee$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$8bf3c46acb3759ee$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$8bf3c46acb3759ee$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $8bf3c46acb3759ee$var$globalHost = $8bf3c46acb3759ee$var$host;
const $8bf3c46acb3759ee$export$8c6ed5c666ac1360 = $8bf3c46acb3759ee$var$globalHost[$8bf3c46acb3759ee$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$8bf3c46acb3759ee$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($8bf3c46acb3759ee$var$globalHost, $8bf3c46acb3759ee$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($8bf3c46acb3759ee$var$makeSlotClass());


const { bind: $4ee36ed99c9ba0ad$export$2385a24977818dd0, noContext: $4ee36ed99c9ba0ad$export$9fa6f2e300a97f8 } = (0, $8bf3c46acb3759ee$export$8c6ed5c666ac1360);
function $4ee36ed99c9ba0ad$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($4ee36ed99c9ba0ad$export$2385a24977818dd0(callback), delay);
}
function $4ee36ed99c9ba0ad$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $4ee36ed99c9ba0ad$export$2385a24977818dd0(gen.next);
        const boundThrow = $4ee36ed99c9ba0ad$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($4ee36ed99c9ba0ad$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $4ee36ed99c9ba0ad$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $4ee36ed99c9ba0ad$var$wrappedFibers = [];
function $4ee36ed99c9ba0ad$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($4ee36ed99c9ba0ad$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $4ee36ed99c9ba0ad$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $4ee36ed99c9ba0ad$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $6ef3641b5944e03e$export$11fa9682b6ba79b1 = new (0, $8bf3c46acb3759ee$export$8c6ed5c666ac1360)();
function $6ef3641b5944e03e$export$d906efd39458576(fn) {
    return $6ef3641b5944e03e$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $4d11fc6576972670$export$5a15a386532a5ea4 } = Object.prototype;
const $4d11fc6576972670$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $4d11fc6576972670$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $3c48ee58698b256b$var$emptySetPool = [];
const $3c48ee58698b256b$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $3c48ee58698b256b$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $3c48ee58698b256b$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $3c48ee58698b256b$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $3c48ee58698b256b$var$valueCopy(value) {
    return value.slice(0);
}
class $3c48ee58698b256b$export$3bb977b3ba9d3b59 {
    peek() {
        if (this.value.length === 1 && !$3c48ee58698b256b$var$mightBeDirty(this)) {
            $3c48ee58698b256b$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $3c48ee58698b256b$var$assert(!this.recomputing, "already recomputing");
        $3c48ee58698b256b$var$rememberParent(this);
        return $3c48ee58698b256b$var$mightBeDirty(this) ? $3c48ee58698b256b$var$reallyRecompute(this, args) : $3c48ee58698b256b$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $3c48ee58698b256b$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $4d11fc6576972670$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $3c48ee58698b256b$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $3c48ee58698b256b$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $3c48ee58698b256b$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $3c48ee58698b256b$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $4d11fc6576972670$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $3c48ee58698b256b$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$3c48ee58698b256b$export$3bb977b3ba9d3b59.count;
    }
}
$3c48ee58698b256b$export$3bb977b3ba9d3b59.count = 0;
function $3c48ee58698b256b$var$rememberParent(child) {
    const parent = (0, $6ef3641b5944e03e$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($3c48ee58698b256b$var$mightBeDirty(child)) $3c48ee58698b256b$var$reportDirtyChild(parent, child);
        else $3c48ee58698b256b$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $3c48ee58698b256b$var$reallyRecompute(entry, args) {
    $3c48ee58698b256b$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $6ef3641b5944e03e$export$11fa9682b6ba79b1).withValue(entry, $3c48ee58698b256b$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($3c48ee58698b256b$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $3c48ee58698b256b$var$setClean(entry);
    return $3c48ee58698b256b$var$valueGet(entry.value);
}
function $3c48ee58698b256b$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $3c48ee58698b256b$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $3c48ee58698b256b$var$setClean(entry) {
    entry.dirty = false;
    if ($3c48ee58698b256b$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $3c48ee58698b256b$var$reportClean(entry);
}
function $3c48ee58698b256b$var$reportDirty(child) {
    $3c48ee58698b256b$var$eachParent(child, $3c48ee58698b256b$var$reportDirtyChild);
}
function $3c48ee58698b256b$var$reportClean(child) {
    $3c48ee58698b256b$var$eachParent(child, $3c48ee58698b256b$var$reportCleanChild);
}
function $3c48ee58698b256b$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $4d11fc6576972670$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $3c48ee58698b256b$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $3c48ee58698b256b$var$assert(parent.childValues.has(child));
    $3c48ee58698b256b$var$assert($3c48ee58698b256b$var$mightBeDirty(child));
    const parentWasClean = !$3c48ee58698b256b$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $3c48ee58698b256b$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $3c48ee58698b256b$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $3c48ee58698b256b$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $3c48ee58698b256b$var$assert(parent.childValues.has(child));
    $3c48ee58698b256b$var$assert(!$3c48ee58698b256b$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $3c48ee58698b256b$var$valueCopy(child.value));
    else if (!$3c48ee58698b256b$var$valueIs(childValue, child.value)) parent.setDirty();
    $3c48ee58698b256b$var$removeDirtyChild(parent, child);
    if ($3c48ee58698b256b$var$mightBeDirty(parent)) return;
    $3c48ee58698b256b$var$reportClean(parent);
}
function $3c48ee58698b256b$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($3c48ee58698b256b$var$emptySetPool.length < $3c48ee58698b256b$var$POOL_TARGET_SIZE) $3c48ee58698b256b$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $3c48ee58698b256b$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $3c48ee58698b256b$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $3c48ee58698b256b$var$assert(parent.dirtyChildren === null);
}
function $3c48ee58698b256b$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $3c48ee58698b256b$var$removeDirtyChild(parent, child);
}
function $3c48ee58698b256b$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $4d11fc6576972670$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $14e2d6f82cbc5ac0$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $14e2d6f82cbc5ac0$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $6ef3641b5944e03e$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $4d11fc6576972670$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $4d11fc6576972670$export$5a15a386532a5ea4).call($14e2d6f82cbc5ac0$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $4d11fc6576972670$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $4d11fc6576972670$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $23146c9ee5f3301f$var$defaultKeyTrie;
function $23146c9ee5f3301f$export$cd3144f8dd136006(...args) {
    const trie = $23146c9ee5f3301f$var$defaultKeyTrie || ($23146c9ee5f3301f$var$defaultKeyTrie = new (0, $0fbf71c7f46d62d0$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $23146c9ee5f3301f$var$caches = new Set();
function $23146c9ee5f3301f$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), makeCacheKey: makeCacheKey = $23146c9ee5f3301f$export$cd3144f8dd136006, keyArgs: keyArgs, subscribe: subscribe } = Object.create(null)) {
    const cache = new (0, $73042ac6c421f083$export$94affb487e701bf2)(max, (entry)=>entry.dispose());
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $3c48ee58698b256b$export$3bb977b3ba9d3b59)(originalFunction));
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $23146c9ee5f3301f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $6ef3641b5944e03e$export$11fa9682b6ba79b1).hasValue()) {
            $23146c9ee5f3301f$var$caches.forEach((cache)=>cache.clean());
            $23146c9ee5f3301f$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        makeCacheKey: makeCacheKey,
        keyArgs: keyArgs,
        subscribe: subscribe
    });
    function dirtyKey(key) {
        const entry = cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



var $11f80e7a6f0c7f52$export$ac9723609f5c76c2 = new (0, $8bf3c46acb3759ee$export$8c6ed5c666ac1360)();
var $11f80e7a6f0c7f52$var$cacheInfoMap = new WeakMap();
function $11f80e7a6f0c7f52$var$getCacheInfo(cache) {
    var info = $11f80e7a6f0c7f52$var$cacheInfoMap.get(cache);
    if (!info) $11f80e7a6f0c7f52$var$cacheInfoMap.set(cache, info = {
        vars: new Set,
        dep: (0, $14e2d6f82cbc5ac0$export$c723b7eff9d8f870)()
    });
    return info;
}
function $11f80e7a6f0c7f52$export$cbe12faed7725318(cache) {
    $11f80e7a6f0c7f52$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $11f80e7a6f0c7f52$export$f342bdd61b3e9412(cache) {
    $11f80e7a6f0c7f52$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $11f80e7a6f0c7f52$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    $11f80e7a6f0c7f52$var$getCacheInfo(cache).dep.dirty(rv);
                    $11f80e7a6f0c7f52$var$broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            var cache = $11f80e7a6f0c7f52$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $11f80e7a6f0c7f52$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $11f80e7a6f0c7f52$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $11f80e7a6f0c7f52$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $1e410163764eb4a5$export$19901bcd339c3ded = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $dca2b5b7b9771289$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $dca2b5b7b9771289$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $e86a7d058696b512$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e86a7d058696b512$export$67ebef60e6f28a6)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $44cb04994d01448c$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return (0, $8c907b3dc6702288$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $e86a7d058696b512$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $e86a7d058696b512$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $70bd4df305f91616$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $8c907b3dc6702288$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $e86a7d058696b512$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0, $e86a7d058696b512$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $6c3bf25907af95d3$export$f431198736b7f96d)(document);
                fragments = (0, $6c3bf25907af95d3$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $fb5c30f911b56608$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $e86a7d058696b512$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $e86a7d058696b512$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $e86a7d058696b512$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $e86a7d058696b512$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) return [
                                2
                            ];
                            if (!(0, $44cb04994d01448c$export$3dc388a5f013b4a5)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42efdf4b92188e48$export$fb56ad75dd311c12)(selection)) return [
                                2,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $42efdf4b92188e48$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42efdf4b92188e48$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $90037d9f94267989$export$f5708dca728d7177)(fragment, 16, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $dca2b5b7b9771289$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $e86a7d058696b512$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $e86a7d058696b512$export$67ebef60e6f28a6)(this, function(_a) {
                if (!rootValue) return [
                    2,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42efdf4b92188e48$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve((0, $11f80e7a6f0c7f52$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $42efdf4b92188e48$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $70bd4df305f91616$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $9990c5aad367019f$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $90037d9f94267989$export$f5708dca728d7177)(fragment, 17, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $9990c5aad367019f$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();







var $ff12735eef88b87a$var$destructiveMethodCounts = new ((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $ff12735eef88b87a$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") cache[methodName] = function() {
        $ff12735eef88b87a$var$destructiveMethodCounts.set(cache, ($ff12735eef88b87a$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        return original.apply(this, arguments);
    };
}
function $ff12735eef88b87a$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var $ff12735eef88b87a$export$79a6120a39c90b6a = function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!$ff12735eef88b87a$var$destructiveMethodCounts.has(cache)) {
            $ff12735eef88b87a$var$destructiveMethodCounts.set(cache, 0);
            $ff12735eef88b87a$var$wrapDestructiveCacheMethod(cache, "evict");
            $ff12735eef88b87a$var$wrapDestructiveCacheMethod(cache, "modify");
            $ff12735eef88b87a$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).loading && !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).setVariables;
        if (!(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $ff12735eef88b87a$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function(variables) {
        if (variables === void 0) variables = this.variables;
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) oq["observe"]();
                else (0, $1faba75f406506d4$export$419171d60552792a)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $ff12735eef88b87a$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $43f21a53b07f28f6$export$37509604341a3464)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && lastWrite.dmCount === $ff12735eef88b87a$var$destructiveMethodCounts.get(this.cache) && (0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $dca2b5b7b9771289$export$509e11c221f576c0)();
        var graphQLErrors = (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        this.reset();
        if ("incremental" in result && (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $6e60f3121a4aab70$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0) {
            if ($ff12735eef88b87a$export$5f47a9fb9a521654(result, options.errorPolicy)) this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $ff12735eef88b87a$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                if (!_this.stopped) _this.updateWatch(options.variables);
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $ff12735eef88b87a$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $42ff4ed032b9cc1f$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}


var $49d2515faade62c7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $49d2515faade62c7$export$b986383a50b53ea4 = function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e;
        var _this = this;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new ((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        var defaultDocumentTransform = new (0, $51442340ed782c5f$export$f887060e48e5dc1b)(function(document) {
            return _this.cache.transformDocument(document);
        }, {
            cache: false
        });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $1e410163764eb4a5$export$19901bcd339c3ded)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform).concat(defaultDocumentTransform) : defaultDocumentTransform;
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $90037d9f94267989$export$3991762405098ea)(23));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0, $e86a7d058696b512$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mutationId, hasClientExports, mutationStoreValue, self;
            return (0, $e86a7d058696b512$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        (0, $90037d9f94267989$export$f5708dca728d7177)(mutation, 24);
                        (0, $90037d9f94267989$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 25);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _h.sent();
                        _h.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        if (optimisticResponse) this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                return (0, $2517fdd76eefbd20$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false), function(result) {
                                    if ((0, $42ff4ed032b9cc1f$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $e174ce09a0f32944$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $42ff4ed032b9cc1f$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $42ff4ed032b9cc1f$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $e174ce09a0f32944$export$26a337512320b8c6) ? err : new (0, $e174ce09a0f32944$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $ff12735eef88b87a$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $6e60f3121a4aab70$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $6e60f3121a4aab70$export$879767c5cdf33cb3)(result) && (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $6e60f3121a4aab70$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$49d2515faade62c7$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $6c3bf25907af95d3$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || mutation.refetchQueries || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    var update = mutation.update;
                    var isFinalResult = !(0, $6e60f3121a4aab70$export$f90dc0a3531b8b83)(result) || (0, $6e60f3121a4aab70$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables) : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                hasClientExports: (0, $44cb04994d01448c$export$8d1e9e5bbfa5d09a)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $44cb04994d01448c$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $8c907b3dc6702288$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    }
                ], document),
                defaultVars: (0, $6c3bf25907af95d3$export$84c19026e616569e)((0, $6c3bf25907af95d3$export$7a5b1fa979d2c158)(document)),
                asQuery: (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        options = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $ff12735eef88b87a$export$79a6120a39c90b6a)(this);
        var observable = new (0, $1faba75f406506d4$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $90037d9f94267989$export$f5708dca728d7177)(options.query, 26);
        (0, $90037d9f94267989$export$f5708dca728d7177)(options.query.kind === "Document", 27);
        (0, $90037d9f94267989$export$f5708dca728d7177)(!options.returnPartialData, 28);
        (0, $90037d9f94267989$export$f5708dca728d7177)(!options.pollInterval, 29);
        return this.fetchQuery(queryId, (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            query: this.transform(options.query)
        })).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        this.cancelPendingFetches((0, $90037d9f94267989$export$3991762405098ea)(30));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) queryInfo.networkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $42efdf4b92188e48$export$540432d49fcec6c9)(desc)) queryNamesAndDocs.set(_this.transform(desc), false);
            else if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            var queryId = (0, $1699e981531d98d6$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $1faba75f406506d4$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $90037d9f94267989$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(typeof nameOrDoc === "string" ? 31 : 32, nameOrDoc);
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    if ((0, $ff12735eef88b87a$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $42ff4ed032b9cc1f$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $e174ce09a0f32944$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $e174ce09a0f32944$export$4995664c1b49842e];
                    throw new (0, $e174ce09a0f32944$export$26a337512320b8c6)(errors);
                }
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $61235f95b05576d5$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $6c3bf25907af95d3$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $cc3c800a908b17d2$export$c2d084dc44961371)(serverQuery);
                var byVariables_1 = inFlightLinkObservables_1.get(printedServerQuery_1) || new Map();
                inFlightLinkObservables_1.set(printedServerQuery_1, byVariables_1);
                var varJson_1 = (0, $87dbe8b2a1cf9cd8$export$88a0ad9b6f961b51)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new (0, $79181b485fc9b84c$export$ae0cf2ec7a6fa78e)([
                        (0, $19de69a0941a1739$export$51396ec711da548b)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function() {
                        if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) inFlightLinkObservables_1.delete(printedServerQuery_1);
                    });
                }
            } else observable = new (0, $79181b485fc9b84c$export$ae0cf2ec7a6fa78e)([
                (0, $19de69a0941a1739$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $79181b485fc9b84c$export$ae0cf2ec7a6fa78e)([
                (0, $61235f95b05576d5$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $2517fdd76eefbd20$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $2517fdd76eefbd20$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $42ff4ed032b9cc1f$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") throw queryInfo.markError(new (0, $e174ce09a0f32944$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $e174ce09a0f32944$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $e174ce09a0f32944$export$26a337512320b8c6)({
                networkError: networkError
            });
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).loading;
        var query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" && sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $79181b485fc9b84c$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $79181b485fc9b84c$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $1699e981531d98d6$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map;
        if (updateCache) this.cache.batch({
            update: updateCache,
            optimistic: optimistic && removeOptimistic || false,
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $ff12735eef88b87a$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) result = oq.refetch();
                        if (result !== false) results.set(oq, result);
                        return result;
                    }
                    if (onQueryUpdated !== null) includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset();
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff(variables);
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(data, {})) (0, $1faba75f406506d4$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $61235f95b05576d5$export$77cea355fa80b5f4).of((0, $e86a7d058696b512$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $43f21a53b07f28f6$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            if (errorPolicy === "none" && networkStatus === (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 : networkStatus === (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 : 2;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $43f21a53b07f28f6$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $ff12735eef88b87a$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();





function $51b07d6991982f9b$export$235b7fc70b9fc359(defaults, options) {
    return (0, $70dcb8ce73dffddb$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $70dcb8ce73dffddb$export$8e16b83750b44988)((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables))
    });
}


var $aea30b064d9e9fe5$var$hasSuggestedDevtools = false;
var $aea30b064d9e9fe5$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $90037d9f94267989$export$3991762405098ea)(13);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $11d4a93442a9ed17$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $261579e958b80d0b$export$2fed3d61f740bc7f).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === "object") window.__APOLLO_CLIENT__ = this;
        if (!$aea30b064d9e9fe5$var$hasSuggestedDevtools && connectToDevTools && globalThis.__DEV__ !== false) {
            $aea30b064d9e9fe5$var$hasSuggestedDevtools = true;
            if (typeof window !== "undefined" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                }
                if (url) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
            }
        }
        this.version = (0, $0f8685bb80f81a33$export$83d89fbfd8236492);
        this.localState = new (0, $1e410163764eb4a5$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $49d2515faade62c7$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
    }
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $51b07d6991982f9b$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $51b07d6991982f9b$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        (0, $90037d9f94267989$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 14);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $51b07d6991982f9b$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $19de69a0941a1739$export$51396ec711da548b)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).debug(15, error);
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}();









var $ea6642dbe2b3c02d$export$5fc74f25506aa9c = function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        this.getFragmentDoc = (0, $23146c9ee5f3301f$export$4997ffc0176396a6)((0, $fb5c30f911b56608$export$abbf37c7cf644e41));
    }
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $e86a7d058696b512$export$3c9a16f847548506)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $e86a7d058696b512$export$3c9a16f847548506)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();



var $c9b610f7aacfca7a$export$257c68286583b0f9 = function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);








function $8e47f607a8a61e2d$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(obj) && $8e47f607a8a61e2d$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $8e47f607a8a61e2d$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $8e47f607a8a61e2d$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $8e47f607a8a61e2d$var$deepFreeze(obj);
    return obj;
}









var $f969f8f7860b4be7$var$DELETE = Object.create(null);
var $f969f8f7860b4be7$var$delModifier = function() {
    return $f969f8f7860b4be7$var$DELETE;
};
var $f969f8f7860b4be7$var$INVALIDATE = Object.create(null);
var $f969f8f7860b4be7$export$cb507f57054c7321 = function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $8e47f607a8a61e2d$export$7f9c177735b71f18)((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        this.canRead = function(objOrRef) {
            return (0, $42efdf4b92188e48$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $42efdf4b92188e48$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $42efdf4b92188e48$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function() {
        return (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $f969f8f7860b4be7$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $f969f8f7860b4be7$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        if (!incoming) return;
        (0, $90037d9f94267989$export$f5708dca728d7177)(typeof dataId === "string", 1);
        var merged = new (0, $dca2b5b7b9771289$export$509e11c221f576c0)($f969f8f7860b4be7$var$storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing) fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = (0, $753d0d78ac8d1d6c$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $f969f8f7860b4be7$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $f969f8f7860b4be7$var$DELETE,
                INVALIDATE: $f969f8f7860b4be7$var$INVALIDATE,
                isReference: (0, $42efdf4b92188e48$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $42efdf4b92188e48$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $753d0d78ac8d1d6c$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $f969f8f7860b4be7$var$delModifier ? $f969f8f7860b4be7$var$DELETE : modify((0, $8e47f607a8a61e2d$export$7f9c177735b71f18)(fieldValue), (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $f969f8f7860b4be7$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $f969f8f7860b4be7$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $f969f8f7860b4be7$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $f969f8f7860b4be7$var$delModifier, _a) : $f969f8f7860b4be7$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $f969f8f7860b4be7$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $e86a7d058696b512$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $f969f8f7860b4be7$var$Layer) this.parent.getRootIdSet(ids);
        else Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $f969f8f7860b4be7$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            workSet_1.forEach(function(obj) {
                if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
var $f969f8f7860b4be7$var$CacheGroup = function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $14e2d6f82cbc5ac0$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $0fbf71c7f46d62d0$export$73571c50d0f2507e)((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($f969f8f7860b4be7$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $753d0d78ac8d1d6c$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) this.d($f969f8f7860b4be7$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($f969f8f7860b4be7$var$makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $f969f8f7860b4be7$var$makeDepKey(dataId, storeFieldName) {
    return storeFieldName + "#" + dataId;
}
function $f969f8f7860b4be7$export$f8068a30967ddc18(store, entityId) {
    if ($f969f8f7860b4be7$export$488c0743feab3d61(store)) store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    var Root = function(_super) {
        (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $f969f8f7860b4be7$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $f969f8f7860b4be7$var$Stump(_this);
            _this.storageTrie = new (0, $0fbf71c7f46d62d0$export$73571c50d0f2507e)((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($f969f8f7860b4be7$export$cb507f57054c7321 || ($f969f8f7860b4be7$export$cb507f57054c7321 = {}));
var $f969f8f7860b4be7$var$Layer = function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) _this.delete(dataId);
                else if (!ownStoreObject) {
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        if (parent === this.parent) return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}($f969f8f7860b4be7$export$cb507f57054c7321);
var $f969f8f7860b4be7$var$Stump = function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $f969f8f7860b4be7$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        return this;
    };
    Stump.prototype.merge = function() {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}($f969f8f7860b4be7$var$Layer);
function $f969f8f7860b4be7$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $f969f8f7860b4be7$export$488c0743feab3d61(store) {
    return !!(store instanceof $f969f8f7860b4be7$export$cb507f57054c7321 && store.group.caching);
}





function $aca4c0ad3483a010$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults
    ];
}
var $aca4c0ad3483a010$export$628ef07ba8965f12 = function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $70dcb8ce73dffddb$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $753d0d78ac8d1d6c$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $87dbe8b2a1cf9cd8$export$c2e7fdd82233f4a4);
        this.executeSelectionSet = (0, $23146c9ee5f3301f$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $aca4c0ad3483a010$var$execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, other), {
                    result: _this.canon.admit(other.result)
                });
                return other;
            }
            (0, $f969f8f7860b4be7$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: $aca4c0ad3483a010$var$execSelectionSetKeyArgs,
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $f969f8f7860b4be7$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $42efdf4b92188e48$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $23146c9ee5f3301f$export$4997ffc0176396a6)(function(options) {
            (0, $f969f8f7860b4be7$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $f969f8f7860b4be7$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $87dbe8b2a1cf9cd8$export$c2e7fdd82233f4a4);
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, (0, $6c3bf25907af95d3$export$84c19026e616569e)((0, $6c3bf25907af95d3$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $42efdf4b92188e48$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $6c3bf25907af95d3$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $e86a7d058696b512$export$18ce0697a983be9b)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $87dbe8b2a1cf9cd8$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $753d0d78ac8d1d6c$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            missing = [
                new (0, $c9b610f7aacfca7a$export$257c68286583b0f9)($aca4c0ad3483a010$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $f969f8f7860b4be7$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $dca2b5b7b9771289$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            if (!(0, $44cb04994d01448c$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $42efdf4b92188e48$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $42efdf4b92188e48$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $8c907b3dc6702288$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    enclosingRef: enclosingRef,
                    context: context
                }), resultName);
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $42efdf4b92188e48$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $fb5c30f911b56608$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $90037d9f94267989$export$3991762405098ea)(7, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $dca2b5b7b9771289$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $8e47f607a8a61e2d$export$7f9c177735b71f18)(finalResult);
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $dca2b5b7b9771289$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            if (item === null) return null;
            if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $42efdf4b92188e48$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $aca4c0ad3483a010$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $aca4c0ad3483a010$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $aca4c0ad3483a010$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value)) {
                (0, $90037d9f94267989$export$f5708dca728d7177)(!(0, $42efdf4b92188e48$export$fa99cac1c0883c47)(value), 8, (0, $753d0d78ac8d1d6c$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}



















var $04a809143e3804b7$var$specifierInfoCache = Object.create(null);
function $04a809143e3804b7$var$lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return $04a809143e3804b7$var$specifierInfoCache[cacheKey] || ($04a809143e3804b7$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $04a809143e3804b7$export$f1953a0407594d2c(specifier) {
    var info = $04a809143e3804b7$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $04a809143e3804b7$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $04a809143e3804b7$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) extracted = $04a809143e3804b7$export$e8f64f7a025887d3(object, schemaKeyPath, $04a809143e3804b7$var$extractKey);
            (0, $90037d9f94267989$export$f5708dca728d7177)(extracted !== void 0, 2, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $04a809143e3804b7$export$550737ee0cc371ac(specifier) {
    var info = $04a809143e3804b7$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $04a809143e3804b7$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    var directiveArgs = d && (0, $42efdf4b92188e48$export$3f5a60fb6a781b4f)(d, variables);
                    return directiveArgs && $04a809143e3804b7$export$e8f64f7a025887d3(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $04a809143e3804b7$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                return;
            }
            if (args) return $04a809143e3804b7$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $04a809143e3804b7$export$2db31da99613c21f(specifier, extractor) {
    var merger = new (0, $dca2b5b7b9771289$export$509e11c221f576c0);
    return $04a809143e3804b7$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $04a809143e3804b7$export$eca459f173e85801(spec) {
    var info = $04a809143e3804b7$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(s)) {
                $04a809143e3804b7$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $04a809143e3804b7$var$extractKey(object, key) {
    return object[key];
}
function $04a809143e3804b7$export$e8f64f7a025887d3(object, path, extract) {
    extract = extract || $04a809143e3804b7$var$extractKey;
    return $04a809143e3804b7$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $04a809143e3804b7$var$normalize(value) {
    if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(value)) {
        if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(value)) return value.map($04a809143e3804b7$var$normalize);
        return $04a809143e3804b7$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $04a809143e3804b7$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}


(0, $42efdf4b92188e48$export$3cdb6c178b88cabe).setStringify((0, $87dbe8b2a1cf9cd8$export$88a0ad9b6f961b51));
function $268615c35530870e$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $42efdf4b92188e48$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $268615c35530870e$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $268615c35530870e$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
var $268615c35530870e$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $268615c35530870e$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $268615c35530870e$export$e9859ad90648930b = function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $e86a7d058696b512$export$18ce0697a983be9b)({
            dataIdFromObject: (0, $753d0d78ac8d1d6c$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $268615c35530870e$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, object), storeObject), context);
            if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $04a809143e3804b7$export$f1953a0407594d2c)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $e86a7d058696b512$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $268615c35530870e$var$mergeTrueFn : merge === false ? $268615c35530870e$var$mergeFalseFn : existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn = keyFields === false ? $268615c35530870e$var$nullKeyFieldsFn : (0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(keyFields) ? (0, $04a809143e3804b7$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = keyArgs === false ? $268615c35530870e$var$simpleKeyArgsFn : (0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(keyArgs) ? (0, $04a809143e3804b7$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) existing.keyFn = existing.keyFn || $268615c35530870e$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $90037d9f94267989$export$f5708dca728d7177)(!old || old === which, 3, which);
            if (old) delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $753d0d78ac8d1d6c$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                supertypes_1 = this.getSupertypeSet(typename, true);
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $e86a7d058696b512$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(4, typename, supertype);
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && i === workQueue_1.length - 1 && (0, $753d0d78ac8d1d6c$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $268615c35530870e$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $04a809143e3804b7$export$550737ee0cc371ac)(specifierOrString);
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $42efdf4b92188e48$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $42efdf4b92188e48$export$3cdb6c178b88cabe)(fieldName, $268615c35530870e$var$argsFromFieldSpecifier(fieldSpec));
        if (storeFieldName === false) return fieldName;
        return fieldName === (0, $753d0d78ac8d1d6c$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $753d0d78ac8d1d6c$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $268615c35530870e$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            return (0, $11f80e7a6f0c7f52$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $268615c35530870e$var$mergeTrueFn) return $268615c35530870e$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $268615c35530870e$var$mergeFalseFn) return incoming;
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $268615c35530870e$var$makeFieldFunctionOptions(this, void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $268615c35530870e$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $753d0d78ac8d1d6c$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $268615c35530870e$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $42efdf4b92188e48$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($268615c35530870e$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $268615c35530870e$var$makeMergeObjectsFunction(context.store)
    };
}
function $268615c35530870e$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, fieldNameOrOptions);
        if (!(0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(5, (0, $6e454447f1ebf41f$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $268615c35530870e$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(existing) || (0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(incoming)) throw (0, $90037d9f94267989$export$3991762405098ea)(6);
        if ((0, $44aaa2f331f80eb9$export$417207af72fad9c9)(existing) && (0, $44aaa2f331f80eb9$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(existing) && (0, $753d0d78ac8d1d6c$export$4f39afca21bd938e)(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $753d0d78ac8d1d6c$export$4f39afca21bd938e)(existing) && (0, $42efdf4b92188e48$export$fa99cac1c0883c47)(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $753d0d78ac8d1d6c$export$4f39afca21bd938e)(existing) && (0, $753d0d78ac8d1d6c$export$4f39afca21bd938e)(incoming)) return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}


function $20f93230909b5629$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $20f93230909b5629$export$eb8361c5d132fb8f = function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $6c3bf25907af95d3$export$7a5b1fa979d2c158)(query);
        var merger = (0, $753d0d78ac8d1d6c$export$b874a818f7a2fa6d)();
        variables = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, (0, $6c3bf25907af95d3$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $87dbe8b2a1cf9cd8$export$88a0ad9b6f961b51)(variables)
        }, (0, $753d0d78ac8d1d6c$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map,
            clientOnly: false,
            deferred: false,
            flavors: new Map
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map
            },
            context: context
        });
        if (!(0, $42efdf4b92188e48$export$fa99cac1c0883c47)(ref)) throw (0, $90037d9f94267989$export$3991762405098ea)(9, result);
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $42efdf4b92188e48$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(applied)) return;
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $753d0d78ac8d1d6c$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $20f93230909b5629$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $42efdf4b92188e48$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        var readField = function() {
            var options = (0, $268615c35530870e$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $42efdf4b92188e48$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $20f93230909b5629$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet ? $20f93230909b5629$var$getContextFlavor(context, false, false) : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet && ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(incomingValue) || (0, $753d0d78ac8d1d6c$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $20f93230909b5629$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $8c907b3dc6702288$export$43b332f87950a467).added(field) && !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).error(10, (0, $42efdf4b92188e48$export$7d1ad22471852218)(field), result);
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) incoming = context.merge(incoming, keyObject);
        } catch (e) {
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $42efdf4b92188e48$export$634ae0e932e9be99)(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $20f93230909b5629$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                mergeTree: $20f93230909b5629$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) return globalThis.__DEV__ !== false ? (0, $51b1e8c9ceec485b$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $20f93230909b5629$var$getChildMergeTree(mergeTree, i));
            $20f93230909b5629$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $42efdf4b92188e48$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $0fbf71c7f46d62d0$export$73571c50d0f2507e)(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $44cb04994d01448c$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) && (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $42efdf4b92188e48$export$3f5a60fb6a781b4f)(dir, context.variables);
                        if (!args || args.if !== false) deferred = true;
                    }
                });
                if ((0, $42efdf4b92188e48$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $20f93230909b5629$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $fb5c30f911b56608$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $90037d9f94267989$export$3991762405098ea)(11, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $20f93230909b5629$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $42efdf4b92188e48$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = !(0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(incoming) && ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(existing) || (0, $753d0d78ac8d1d6c$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $42efdf4b92188e48$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $90037d9f94267989$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                incoming = (0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $e86a7d058696b512$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $20f93230909b5629$var$emptyMergeTreePool = [];
function $20f93230909b5629$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $20f93230909b5629$var$emptyMergeTreePool.pop() || {
        map: new Map
    });
    return map.get(name);
}
function $20f93230909b5629$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $20f93230909b5629$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $20f93230909b5629$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $20f93230909b5629$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $20f93230909b5629$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $20f93230909b5629$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $20f93230909b5629$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $20f93230909b5629$var$mergeTreeIsEmpty(childTree)) {
        $20f93230909b5629$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $20f93230909b5629$var$warnings = new Set();
function $20f93230909b5629$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(existing)) return;
    if ((0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(existing, incoming)) return;
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $753d0d78ac8d1d6c$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if ($20f93230909b5629$var$warnings.has(typeDotName)) return;
    $20f93230909b5629$var$warnings.add(typeDotName);
    var childTypenames = [];
    if (!(0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(existing) && !(0, $763d36c6d12d5d9a$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(12, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, existing, incoming);
}







var $db48c96b873d5959$export$467265324939f47f = function(_super) {
    (0, $e86a7d058696b512$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $51442340ed782c5f$export$f887060e48e5dc1b)((0, $8c907b3dc6702288$export$43b332f87950a467));
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $11f80e7a6f0c7f52$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        _this.config = (0, $753d0d78ac8d1d6c$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $268615c35530870e$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        var rootStore = this.data = new (0, $f969f8f7860b4be7$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new (0, $20f93230909b5629$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $aca4c0ad3483a010$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $753d0d78ac8d1d6c$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $23146c9ee5f3301f$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function(c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $f969f8f7860b4be7$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, (0, $87dbe8b2a1cf9cd8$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $c9b610f7aacfca7a$export$257c68286583b0f9)) return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) return false;
        var store = options.optimistic ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) (0, $11f80e7a6f0c7f52$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $11f80e7a6f0c7f52$export$cbe12faed7725318)(_this);
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        (0, $87dbe8b2a1cf9cd8$export$88a0ad9b6f961b51).reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $42efdf4b92188e48$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $753d0d78ac8d1d6c$export$b5a638e9b3fff9f3).call(options, "id")) return false;
            options = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $87dbe8b2a1cf9cd8$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $11f80e7a6f0c7f52$export$cbe12faed7725318)(this);
        } else this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) this.broadcastWatches((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) perform(this.data);
        else perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) alreadyDirty.delete(watch);
                    return result;
                }
            }));
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) return;
        }
        if (!lastDiff || !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $ea6642dbe2b3c02d$export$5fc74f25506aa9c));


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $258edca80fd7b5e2$var$extendStatics = function(d, b) {
    $258edca80fd7b5e2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $258edca80fd7b5e2$var$extendStatics(d, b);
};
function $258edca80fd7b5e2$export$a8ba968b8961cb8a(d, b) {
    $258edca80fd7b5e2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $258edca80fd7b5e2$export$18ce0697a983be9b = function() {
    $258edca80fd7b5e2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $258edca80fd7b5e2$export$18ce0697a983be9b.apply(this, arguments);
};
function $258edca80fd7b5e2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $258edca80fd7b5e2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $258edca80fd7b5e2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $258edca80fd7b5e2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $258edca80fd7b5e2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $258edca80fd7b5e2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $258edca80fd7b5e2$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $258edca80fd7b5e2$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $258edca80fd7b5e2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $258edca80fd7b5e2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $258edca80fd7b5e2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($258edca80fd7b5e2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $258edca80fd7b5e2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $258edca80fd7b5e2$export$10c90e4f7922046c(v) {
    return this instanceof $258edca80fd7b5e2$export$10c90e4f7922046c ? (this.v = v, this) : new $258edca80fd7b5e2$export$10c90e4f7922046c(v);
}
function $258edca80fd7b5e2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $258edca80fd7b5e2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $258edca80fd7b5e2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $258edca80fd7b5e2$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $258edca80fd7b5e2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $258edca80fd7b5e2$export$19a8beecd37a4c45 === "function" ? $258edca80fd7b5e2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $258edca80fd7b5e2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $258edca80fd7b5e2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $258edca80fd7b5e2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $258edca80fd7b5e2$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $258edca80fd7b5e2$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $05899443f2bafcd0$exports = {};

$05899443f2bafcd0$exports = (parcelRequire("9flmG")).Observable;


var $96dde1abc5261bd1$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($05899443f2bafcd0$exports)));
var $96dde1abc5261bd1$export$2e2bcd8739ae039 = $96dde1abc5261bd1$export$77cea355fa80b5f4;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $36df75aa58d2742d$var$extendStatics = function(d, b) {
    $36df75aa58d2742d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $36df75aa58d2742d$var$extendStatics(d, b);
};
function $36df75aa58d2742d$export$a8ba968b8961cb8a(d, b) {
    $36df75aa58d2742d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $36df75aa58d2742d$export$18ce0697a983be9b = function() {
    $36df75aa58d2742d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36df75aa58d2742d$export$18ce0697a983be9b.apply(this, arguments);
};
function $36df75aa58d2742d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $36df75aa58d2742d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $36df75aa58d2742d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $36df75aa58d2742d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $36df75aa58d2742d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $36df75aa58d2742d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $36df75aa58d2742d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $36df75aa58d2742d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $36df75aa58d2742d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $36df75aa58d2742d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $36df75aa58d2742d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($36df75aa58d2742d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $36df75aa58d2742d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $36df75aa58d2742d$export$10c90e4f7922046c(v) {
    return this instanceof $36df75aa58d2742d$export$10c90e4f7922046c ? (this.v = v, this) : new $36df75aa58d2742d$export$10c90e4f7922046c(v);
}
function $36df75aa58d2742d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $36df75aa58d2742d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $36df75aa58d2742d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $36df75aa58d2742d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $36df75aa58d2742d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $36df75aa58d2742d$export$19a8beecd37a4c45 === "function" ? $36df75aa58d2742d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $36df75aa58d2742d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $36df75aa58d2742d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $36df75aa58d2742d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $36df75aa58d2742d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $36df75aa58d2742d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $0748a729b35c8c72$exports = {};
// shim for using process in browser
var $0748a729b35c8c72$var$process = $0748a729b35c8c72$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0748a729b35c8c72$var$cachedSetTimeout;
var $0748a729b35c8c72$var$cachedClearTimeout;
function $0748a729b35c8c72$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $0748a729b35c8c72$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $0748a729b35c8c72$var$cachedSetTimeout = setTimeout;
        else $0748a729b35c8c72$var$cachedSetTimeout = $0748a729b35c8c72$var$defaultSetTimout;
    } catch (e) {
        $0748a729b35c8c72$var$cachedSetTimeout = $0748a729b35c8c72$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $0748a729b35c8c72$var$cachedClearTimeout = clearTimeout;
        else $0748a729b35c8c72$var$cachedClearTimeout = $0748a729b35c8c72$var$defaultClearTimeout;
    } catch (e) {
        $0748a729b35c8c72$var$cachedClearTimeout = $0748a729b35c8c72$var$defaultClearTimeout;
    }
})();
function $0748a729b35c8c72$var$runTimeout(fun) {
    if ($0748a729b35c8c72$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0748a729b35c8c72$var$cachedSetTimeout === $0748a729b35c8c72$var$defaultSetTimout || !$0748a729b35c8c72$var$cachedSetTimeout) && setTimeout) {
        $0748a729b35c8c72$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0748a729b35c8c72$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0748a729b35c8c72$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0748a729b35c8c72$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0748a729b35c8c72$var$runClearTimeout(marker) {
    if ($0748a729b35c8c72$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0748a729b35c8c72$var$cachedClearTimeout === $0748a729b35c8c72$var$defaultClearTimeout || !$0748a729b35c8c72$var$cachedClearTimeout) && clearTimeout) {
        $0748a729b35c8c72$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0748a729b35c8c72$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0748a729b35c8c72$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0748a729b35c8c72$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0748a729b35c8c72$var$queue = [];
var $0748a729b35c8c72$var$draining = false;
var $0748a729b35c8c72$var$currentQueue;
var $0748a729b35c8c72$var$queueIndex = -1;
function $0748a729b35c8c72$var$cleanUpNextTick() {
    if (!$0748a729b35c8c72$var$draining || !$0748a729b35c8c72$var$currentQueue) return;
    $0748a729b35c8c72$var$draining = false;
    if ($0748a729b35c8c72$var$currentQueue.length) $0748a729b35c8c72$var$queue = $0748a729b35c8c72$var$currentQueue.concat($0748a729b35c8c72$var$queue);
    else $0748a729b35c8c72$var$queueIndex = -1;
    if ($0748a729b35c8c72$var$queue.length) $0748a729b35c8c72$var$drainQueue();
}
function $0748a729b35c8c72$var$drainQueue() {
    if ($0748a729b35c8c72$var$draining) return;
    var timeout = $0748a729b35c8c72$var$runTimeout($0748a729b35c8c72$var$cleanUpNextTick);
    $0748a729b35c8c72$var$draining = true;
    var len = $0748a729b35c8c72$var$queue.length;
    while(len){
        $0748a729b35c8c72$var$currentQueue = $0748a729b35c8c72$var$queue;
        $0748a729b35c8c72$var$queue = [];
        while(++$0748a729b35c8c72$var$queueIndex < len)if ($0748a729b35c8c72$var$currentQueue) $0748a729b35c8c72$var$currentQueue[$0748a729b35c8c72$var$queueIndex].run();
        $0748a729b35c8c72$var$queueIndex = -1;
        len = $0748a729b35c8c72$var$queue.length;
    }
    $0748a729b35c8c72$var$currentQueue = null;
    $0748a729b35c8c72$var$draining = false;
    $0748a729b35c8c72$var$runClearTimeout(timeout);
}
$0748a729b35c8c72$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0748a729b35c8c72$var$queue.push(new $0748a729b35c8c72$var$Item(fun, args));
    if ($0748a729b35c8c72$var$queue.length === 1 && !$0748a729b35c8c72$var$draining) $0748a729b35c8c72$var$runTimeout($0748a729b35c8c72$var$drainQueue);
};
// v8 likes predictible objects
function $0748a729b35c8c72$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0748a729b35c8c72$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0748a729b35c8c72$var$process.title = "browser";
$0748a729b35c8c72$var$process.browser = true;
$0748a729b35c8c72$var$process.env = {};
$0748a729b35c8c72$var$process.argv = [];
$0748a729b35c8c72$var$process.version = ""; // empty string to avoid regexp issues
$0748a729b35c8c72$var$process.versions = {};
function $0748a729b35c8c72$var$noop() {}
$0748a729b35c8c72$var$process.on = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.addListener = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.once = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.off = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.removeListener = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.removeAllListeners = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.emit = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.prependListener = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.prependOnceListener = $0748a729b35c8c72$var$noop;
$0748a729b35c8c72$var$process.listeners = function(name) {
    return [];
};
$0748a729b35c8c72$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$0748a729b35c8c72$var$process.cwd = function() {
    return "/";
};
$0748a729b35c8c72$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$0748a729b35c8c72$var$process.umask = function() {
    return 0;
};


var $f0c8d25f23d653fa$var$genericMessage = "Invariant Violation";
var $f0c8d25f23d653fa$var$_a = Object.setPrototypeOf, $f0c8d25f23d653fa$var$setPrototypeOf = $f0c8d25f23d653fa$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $f0c8d25f23d653fa$var$_a;
var $f0c8d25f23d653fa$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $36df75aa58d2742d$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $f0c8d25f23d653fa$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $f0c8d25f23d653fa$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $f0c8d25f23d653fa$var$genericMessage;
        $f0c8d25f23d653fa$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $f0c8d25f23d653fa$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $f0c8d25f23d653fa$export$cea12affaee22fe8(message);
}
function $f0c8d25f23d653fa$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $f0c8d25f23d653fa$var$wrapConsoleMethod("warn");
    invariant.error = $f0c8d25f23d653fa$var$wrapConsoleMethod("error");
})($f0c8d25f23d653fa$export$f5708dca728d7177 || ($f0c8d25f23d653fa$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $f0c8d25f23d653fa$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $0748a729b35c8c72$exports === "object") $f0c8d25f23d653fa$export$e54fe5b0f43758f7 = $0748a729b35c8c72$exports;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($f0c8d25f23d653fa$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $f0c8d25f23d653fa$var$invariant$1 = $f0c8d25f23d653fa$export$f5708dca728d7177;
var $f0c8d25f23d653fa$export$2e2bcd8739ae039 = $f0c8d25f23d653fa$var$invariant$1;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $924c6d39ecfe4883$var$extendStatics = function(d, b) {
    $924c6d39ecfe4883$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $924c6d39ecfe4883$var$extendStatics(d, b);
};
function $924c6d39ecfe4883$export$a8ba968b8961cb8a(d, b) {
    $924c6d39ecfe4883$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $924c6d39ecfe4883$export$18ce0697a983be9b = function() {
    $924c6d39ecfe4883$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $924c6d39ecfe4883$export$18ce0697a983be9b.apply(this, arguments);
};
function $924c6d39ecfe4883$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $924c6d39ecfe4883$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $924c6d39ecfe4883$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $924c6d39ecfe4883$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $924c6d39ecfe4883$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $924c6d39ecfe4883$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $924c6d39ecfe4883$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $924c6d39ecfe4883$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $924c6d39ecfe4883$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $924c6d39ecfe4883$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $924c6d39ecfe4883$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($924c6d39ecfe4883$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $924c6d39ecfe4883$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $924c6d39ecfe4883$export$10c90e4f7922046c(v) {
    return this instanceof $924c6d39ecfe4883$export$10c90e4f7922046c ? (this.v = v, this) : new $924c6d39ecfe4883$export$10c90e4f7922046c(v);
}
function $924c6d39ecfe4883$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $924c6d39ecfe4883$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $924c6d39ecfe4883$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $924c6d39ecfe4883$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $924c6d39ecfe4883$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $924c6d39ecfe4883$export$19a8beecd37a4c45 === "function" ? $924c6d39ecfe4883$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $924c6d39ecfe4883$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $924c6d39ecfe4883$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $924c6d39ecfe4883$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $924c6d39ecfe4883$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $924c6d39ecfe4883$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $fc6591121c2ff6a2$exports = {};
"use strict";
Object.defineProperty($fc6591121c2ff6a2$exports, "__esModule", {
    value: true
});
$fc6591121c2ff6a2$exports.BREAK = void 0;
$fc6591121c2ff6a2$exports.getEnterLeaveForKind = $fc6591121c2ff6a2$var$getEnterLeaveForKind;
$fc6591121c2ff6a2$exports.getVisitFn = $fc6591121c2ff6a2$var$getVisitFn;
$fc6591121c2ff6a2$exports.visit = $fc6591121c2ff6a2$var$visit;
$fc6591121c2ff6a2$exports.visitInParallel = $fc6591121c2ff6a2$var$visitInParallel;
var $5c47140bac9b8ddc$exports = {};
"use strict";
Object.defineProperty($5c47140bac9b8ddc$exports, "__esModule", {
    value: true
});
$5c47140bac9b8ddc$exports.devAssert = $5c47140bac9b8ddc$var$devAssert;
function $5c47140bac9b8ddc$var$devAssert(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


var $a1b1607da05cbbd0$exports = {};
"use strict";
Object.defineProperty($a1b1607da05cbbd0$exports, "__esModule", {
    value: true
});
$a1b1607da05cbbd0$exports.inspect = $a1b1607da05cbbd0$var$inspect;
const $a1b1607da05cbbd0$var$MAX_ARRAY_LENGTH = 10;
const $a1b1607da05cbbd0$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $a1b1607da05cbbd0$var$inspect(value) {
    return $a1b1607da05cbbd0$var$formatValue(value, []);
}
function $a1b1607da05cbbd0$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $a1b1607da05cbbd0$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $a1b1607da05cbbd0$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($a1b1607da05cbbd0$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $a1b1607da05cbbd0$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $a1b1607da05cbbd0$var$formatArray(value, seenValues);
    return $a1b1607da05cbbd0$var$formatObject(value, seenValues);
}
function $a1b1607da05cbbd0$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $a1b1607da05cbbd0$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $a1b1607da05cbbd0$var$MAX_RECURSIVE_DEPTH) return "[" + $a1b1607da05cbbd0$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $a1b1607da05cbbd0$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $a1b1607da05cbbd0$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $a1b1607da05cbbd0$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($a1b1607da05cbbd0$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($a1b1607da05cbbd0$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $a1b1607da05cbbd0$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}


var $6b99e5c34a92d0e9$exports = {};
"use strict";
Object.defineProperty($6b99e5c34a92d0e9$exports, "__esModule", {
    value: true
});
$6b99e5c34a92d0e9$exports.Token = $6b99e5c34a92d0e9$exports.QueryDocumentKeys = $6b99e5c34a92d0e9$exports.OperationTypeNode = $6b99e5c34a92d0e9$exports.Location = void 0;
$6b99e5c34a92d0e9$exports.isNode = $6b99e5c34a92d0e9$var$isNode;
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $6b99e5c34a92d0e9$var$Location {
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ $6b99e5c34a92d0e9$exports.Location = $6b99e5c34a92d0e9$var$Location;
class $6b99e5c34a92d0e9$var$Token {
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
}
/**
 * The list of all possible AST node types.
 */ $6b99e5c34a92d0e9$exports.Token = $6b99e5c34a92d0e9$var$Token;
/**
 * @internal
 */ const $6b99e5c34a92d0e9$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
$6b99e5c34a92d0e9$exports.QueryDocumentKeys = $6b99e5c34a92d0e9$var$QueryDocumentKeys;
const $6b99e5c34a92d0e9$var$kindValues = new Set(Object.keys($6b99e5c34a92d0e9$var$QueryDocumentKeys));
/**
 * @internal
 */ function $6b99e5c34a92d0e9$var$isNode(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $6b99e5c34a92d0e9$var$kindValues.has(maybeKind);
}
/** Name */ var $6b99e5c34a92d0e9$var$OperationTypeNode;
$6b99e5c34a92d0e9$exports.OperationTypeNode = $6b99e5c34a92d0e9$var$OperationTypeNode;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($6b99e5c34a92d0e9$var$OperationTypeNode || ($6b99e5c34a92d0e9$exports.OperationTypeNode = $6b99e5c34a92d0e9$var$OperationTypeNode = {}));


var $860c7378a2440bd2$exports = {};
"use strict";
Object.defineProperty($860c7378a2440bd2$exports, "__esModule", {
    value: true
});
$860c7378a2440bd2$exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $860c7378a2440bd2$var$Kind;
$860c7378a2440bd2$exports.Kind = $860c7378a2440bd2$var$Kind;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($860c7378a2440bd2$var$Kind || ($860c7378a2440bd2$exports.Kind = $860c7378a2440bd2$var$Kind = {})); /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 


const $fc6591121c2ff6a2$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */ $fc6591121c2ff6a2$exports.BREAK = $fc6591121c2ff6a2$var$BREAK;
function $fc6591121c2ff6a2$var$visit(root, visitor, visitorKeys = $6b99e5c34a92d0e9$exports.QueryDocumentKeys) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values($860c7378a2440bd2$exports.Kind))enterLeaveMap.set(kind, $fc6591121c2ff6a2$var$getEnterLeaveForKind(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $6b99e5c34a92d0e9$exports.isNode)(node) || (0, $5c47140bac9b8ddc$exports.devAssert)(false, `Invalid AST Node: ${(0, $a1b1607da05cbbd0$exports.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $fc6591121c2ff6a2$var$BREAK) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $6b99e5c34a92d0e9$exports.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $fc6591121c2ff6a2$var$visitInParallel(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values($860c7378a2440bd2$exports.Kind)){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $fc6591121c2ff6a2$var$getEnterLeaveForKind(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $fc6591121c2ff6a2$var$BREAK) skipping[i] = $fc6591121c2ff6a2$var$BREAK;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $fc6591121c2ff6a2$var$BREAK) skipping[i] = $fc6591121c2ff6a2$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */ function $fc6591121c2ff6a2$var$getEnterLeaveForKind(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */ /* c8 ignore next 8 */ function $fc6591121c2ff6a2$var$getVisitFn(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $fc6591121c2ff6a2$var$getEnterLeaveForKind(visitor, kind);
    return isLeaving ? leave : enter;
}



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b5d8e2aeb6b818d7$var$extendStatics = function(d, b) {
    $b5d8e2aeb6b818d7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b5d8e2aeb6b818d7$var$extendStatics(d, b);
};
function $b5d8e2aeb6b818d7$export$a8ba968b8961cb8a(d, b) {
    $b5d8e2aeb6b818d7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b5d8e2aeb6b818d7$export$18ce0697a983be9b = function() {
    $b5d8e2aeb6b818d7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b5d8e2aeb6b818d7$export$18ce0697a983be9b.apply(this, arguments);
};
function $b5d8e2aeb6b818d7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b5d8e2aeb6b818d7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b5d8e2aeb6b818d7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b5d8e2aeb6b818d7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b5d8e2aeb6b818d7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b5d8e2aeb6b818d7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b5d8e2aeb6b818d7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b5d8e2aeb6b818d7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b5d8e2aeb6b818d7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b5d8e2aeb6b818d7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b5d8e2aeb6b818d7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b5d8e2aeb6b818d7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b5d8e2aeb6b818d7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b5d8e2aeb6b818d7$export$10c90e4f7922046c(v) {
    return this instanceof $b5d8e2aeb6b818d7$export$10c90e4f7922046c ? (this.v = v, this) : new $b5d8e2aeb6b818d7$export$10c90e4f7922046c(v);
}
function $b5d8e2aeb6b818d7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b5d8e2aeb6b818d7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b5d8e2aeb6b818d7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b5d8e2aeb6b818d7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b5d8e2aeb6b818d7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b5d8e2aeb6b818d7$export$19a8beecd37a4c45 === "function" ? $b5d8e2aeb6b818d7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b5d8e2aeb6b818d7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b5d8e2aeb6b818d7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b5d8e2aeb6b818d7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b5d8e2aeb6b818d7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b5d8e2aeb6b818d7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $d39a7c5210ad9dc1$exports = {};
"use strict";
$d39a7c5210ad9dc1$exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};


var $b2b28138123bd1d8$var$_a = Object.prototype, $b2b28138123bd1d8$var$toString = $b2b28138123bd1d8$var$_a.toString, $b2b28138123bd1d8$var$hasOwnProperty = $b2b28138123bd1d8$var$_a.hasOwnProperty;
var $b2b28138123bd1d8$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $b2b28138123bd1d8$export$411ce8e5a71e3069(a, b) {
    try {
        return $b2b28138123bd1d8$var$check(a, b);
    } finally{
        $b2b28138123bd1d8$var$previousComparisons.clear();
    }
}
function $b2b28138123bd1d8$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $b2b28138123bd1d8$var$toString.call(a);
    var bTag = $b2b28138123bd1d8$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            if ($b2b28138123bd1d8$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$b2b28138123bd1d8$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$b2b28138123bd1d8$var$check(a[key], b[key])) return false;
            }
            return true;
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == "" + b;
        case "[object Map]":
        case "[object Set]":
            if (a.size !== b.size) return false;
            if ($b2b28138123bd1d8$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === "[object Map]";
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$b2b28138123bd1d8$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $b2b28138123bd1d8$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $b2b28138123bd1d8$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $b2b28138123bd1d8$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $b2b28138123bd1d8$export$2e2bcd8739ae039 = $b2b28138123bd1d8$export$411ce8e5a71e3069;



function $2f7a33a694830c16$export$dc071f102752d0eb(value) {
    return [
        "StringValue",
        "BooleanValue",
        "EnumValue"
    ].indexOf(value.kind) > -1;
}
function $2f7a33a694830c16$export$3ff5e9927c3257c6(value) {
    return [
        "IntValue",
        "FloatValue"
    ].indexOf(value.kind) > -1;
}
function $2f7a33a694830c16$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $2f7a33a694830c16$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $2f7a33a694830c16$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $2f7a33a694830c16$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $2f7a33a694830c16$var$isVariable(value) {
    return value.kind === "Variable";
}
function $2f7a33a694830c16$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $2f7a33a694830c16$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $2f7a33a694830c16$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $2f7a33a694830c16$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $2f7a33a694830c16$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f7a33a694830c16$var$isIntValue(value) || $2f7a33a694830c16$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f7a33a694830c16$var$isBooleanValue(value) || $2f7a33a694830c16$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f7a33a694830c16$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f7a33a694830c16$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f7a33a694830c16$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f7a33a694830c16$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f7a33a694830c16$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f7a33a694830c16$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f7a33a694830c16$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $f0c8d25f23d653fa$export$cea12affaee22fe8)(17);
}
function $2f7a33a694830c16$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f7a33a694830c16$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f7a33a694830c16$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f7a33a694830c16$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f7a33a694830c16$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export"
];
function $2f7a33a694830c16$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives["connection"]["key"] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($d39a7c5210ad9dc1$exports)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f7a33a694830c16$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f7a33a694830c16$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f7a33a694830c16$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f7a33a694830c16$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f7a33a694830c16$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $2f7a33a694830c16$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}
function $2f7a33a694830c16$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === "id" && typeof idObject.generated === "boolean";
}
function $2f7a33a694830c16$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)({
        type: "id",
        generated: generated
    }, typeof idConfig === "string" ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f7a33a694830c16$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === "object" && jsonObject.type === "json";
}
function $2f7a33a694830c16$var$defaultValueFromVariable(node) {
    throw new (0, $f0c8d25f23d653fa$export$cea12affaee22fe8)(18);
}
function $2f7a33a694830c16$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f7a33a694830c16$var$defaultValueFromVariable;
    switch(node.kind){
        case "Variable":
            return onVariable(node);
        case "NullValue":
            return null;
        case "IntValue":
            return parseInt(node.value, 10);
        case "FloatValue":
            return parseFloat(node.value);
        case "ListValue":
            return node.values.map(function(v) {
                return $2f7a33a694830c16$export$b3db129ed867b445(v, onVariable);
            });
        case "ObjectValue":
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f7a33a694830c16$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f7a33a694830c16$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f7a33a694830c16$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f7a33a694830c16$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f7a33a694830c16$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $2f7a33a694830c16$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $fc6591121c2ff6a2$exports.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f7a33a694830c16$export$2dafb573e282fe8d(names, doc) {
    return $2f7a33a694830c16$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f7a33a694830c16$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f7a33a694830c16$export$2dafb573e282fe8d([
        "client"
    ], document) && $2f7a33a694830c16$export$2dafb573e282fe8d([
        "export"
    ], document);
}
function $2f7a33a694830c16$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $2f7a33a694830c16$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f7a33a694830c16$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 15);
        var ifValue = ifArgument.value;
        (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f7a33a694830c16$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === "OperationDefinition") throw new (0, $f0c8d25f23d653fa$export$cea12affaee22fe8)(11);
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    if (typeof actualFragmentName === "undefined") {
        (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)((0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $b5d8e2aeb6b818d7$export$6388937ca91ccae8)([
            {
                kind: "OperationDefinition",
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f7a33a694830c16$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === "undefined" || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f7a33a694830c16$export$a92e7a440b22bdf0(doc) {
    $2f7a33a694830c16$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && definition.operation === "mutation";
    })[0];
    (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(mutationDef, 1);
    return mutationDef;
}
function $2f7a33a694830c16$export$a7d0d8111d2386df(doc) {
    (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(doc && doc.kind === "Document", 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw new (0, $f0c8d25f23d653fa$export$cea12affaee22fe8)(3);
        return definition;
    });
    (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(operations.length <= 1, 4);
    return doc;
}
function $2f7a33a694830c16$export$7a5b1fa979d2c158(doc) {
    $2f7a33a694830c16$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $2f7a33a694830c16$export$78a8e95d8d43ad7f(document) {
    var def = $2f7a33a694830c16$export$7a5b1fa979d2c158(document);
    (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(def, 5);
    return def;
}
function $2f7a33a694830c16$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f7a33a694830c16$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $2f7a33a694830c16$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f7a33a694830c16$export$7a5b1fa979d2c158(doc);
    (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 6);
    return queryDef;
}
function $2f7a33a694830c16$export$772111caef41b3f5(doc) {
    (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(doc.kind === "Document", 7);
    (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $f0c8d25f23d653fa$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 9);
    return fragmentDef;
}
function $2f7a33a694830c16$export$f431198736b7f96d(queryDoc) {
    $2f7a33a694830c16$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $f0c8d25f23d653fa$export$cea12affaee22fe8)(10);
}
function $2f7a33a694830c16$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f7a33a694830c16$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f7a33a694830c16$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f7a33a694830c16$export$e6e34fd1f2686227.apply(void 0, (0, $b5d8e2aeb6b818d7$export$6388937ca91ccae8)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f7a33a694830c16$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f7a33a694830c16$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f7a33a694830c16$var$TYPENAME_FIELD = {
    kind: "Field",
    name: {
        kind: "Name",
        value: "__typename"
    }
};
function $2f7a33a694830c16$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === "FragmentSpread" && $2f7a33a694830c16$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f7a33a694830c16$var$nullIfDocIsEmpty(doc) {
    return $2f7a33a694830c16$var$isEmpty($2f7a33a694830c16$export$7a5b1fa979d2c158(doc) || $2f7a33a694830c16$export$772111caef41b3f5(doc), $2f7a33a694830c16$export$193789b4c8246dd4($2f7a33a694830c16$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f7a33a694830c16$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f7a33a694830c16$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f7a33a694830c16$var$nullIfDocIsEmpty((0, $fc6591121c2ff6a2$exports.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== "VariableDefinition") variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f7a33a694830c16$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === "Variable") variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f7a33a694830c16$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f7a33a694830c16$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f7a33a694830c16$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f7a33a694830c16$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f7a33a694830c16$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f7a33a694830c16$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f7a33a694830c16$export$43b332f87950a467(doc) {
    return (0, $fc6591121c2ff6a2$exports.visit)($2f7a33a694830c16$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === "OperationDefinition") return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f7a33a694830c16$export$fb56ad75dd311c12(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f7a33a694830c16$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                return (0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)((0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $b5d8e2aeb6b818d7$export$6388937ca91ccae8)(selections, [
                        $2f7a33a694830c16$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f7a33a694830c16$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === "key";
        });
        return willRemove;
    }
};
function $2f7a33a694830c16$export$74985f3324559867(doc) {
    return $2f7a33a694830c16$export$e5ae0530da5fe96c([
        $2f7a33a694830c16$var$connectionRemoveConfig
    ], $2f7a33a694830c16$export$a7d0d8111d2386df(doc));
}
function $2f7a33a694830c16$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f7a33a694830c16$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f7a33a694830c16$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f7a33a694830c16$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f7a33a694830c16$var$getDirectiveMatcher(directives)) || nestedCheck && $2f7a33a694830c16$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f7a33a694830c16$export$deed3420cb5d2e1d(directives, doc) {
    $2f7a33a694830c16$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f7a33a694830c16$var$nullIfDocIsEmpty((0, $fc6591121c2ff6a2$exports.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join("-");
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f7a33a694830c16$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f7a33a694830c16$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)((0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f7a33a694830c16$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === "Variable" && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f7a33a694830c16$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f7a33a694830c16$var$getArgumentMatcher(config);
    return $2f7a33a694830c16$var$nullIfDocIsEmpty((0, $fc6591121c2ff6a2$exports.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)((0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f7a33a694830c16$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f7a33a694830c16$var$nullIfDocIsEmpty((0, $fc6591121c2ff6a2$exports.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f7a33a694830c16$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f7a33a694830c16$export$fb56ad75dd311c12(selection) || $2f7a33a694830c16$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f7a33a694830c16$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === "FragmentSpread") allFragments.push(selection);
    });
    return allFragments;
}
function $2f7a33a694830c16$export$57c368c23873f32b(document) {
    var definition = $2f7a33a694830c16$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") return document;
    var modifiedDoc = (0, $fc6591121c2ff6a2$exports.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)((0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f7a33a694830c16$export$8eae69e876ee321e(document) {
    $2f7a33a694830c16$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f7a33a694830c16$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $fc6591121c2ff6a2$exports.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f7a33a694830c16$export$fb56ad75dd311c12(selection) && selection.name.value === "__typename";
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f7a33a694830c16$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !(typeof navigator === "object" && navigator.product === "ReactNative");
var $2f7a33a694830c16$var$toString = Object.prototype.toString;
function $2f7a33a694830c16$export$629a2bd3f5a49ecc(value) {
    return $2f7a33a694830c16$var$cloneDeepHelper(value, new Map());
}
function $2f7a33a694830c16$var$cloneDeepHelper(val, seen) {
    switch($2f7a33a694830c16$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f7a33a694830c16$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f7a33a694830c16$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f7a33a694830c16$export$4bd44a2aa29d3d6e() {
    if (typeof $0748a729b35c8c72$exports !== "undefined" && "production") return "production";
    return "development";
}
function $2f7a33a694830c16$export$f0cb0fda19c18b37(env) {
    return $2f7a33a694830c16$export$4bd44a2aa29d3d6e() === env;
}
function $2f7a33a694830c16$export$f15d00aa73aafac4() {
    return $2f7a33a694830c16$export$f0cb0fda19c18b37("production") === true;
}
function $2f7a33a694830c16$export$df77466336fe5355() {
    return $2f7a33a694830c16$export$f0cb0fda19c18b37("development") === true;
}
function $2f7a33a694830c16$export$410cbc2864fa25b5() {
    return $2f7a33a694830c16$export$f0cb0fda19c18b37("test") === true;
}
function $2f7a33a694830c16$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f7a33a694830c16$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f7a33a694830c16$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === "object" || typeof o[prop] === "function") && !Object.isFrozen(o[prop])) $2f7a33a694830c16$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f7a33a694830c16$export$7f9c177735b71f18(obj) {
    if ($2f7a33a694830c16$export$df77466336fe5355() || $2f7a33a694830c16$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === "function" && typeof Symbol("") === "string";
        if (!symbolIsPolyfilled) return $2f7a33a694830c16$var$deepFreeze(obj);
    }
    return obj;
}
var $2f7a33a694830c16$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f7a33a694830c16$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f7a33a694830c16$export$160070228be94b08(sources);
}
function $2f7a33a694830c16$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f7a33a694830c16$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f7a33a694830c16$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f7a33a694830c16$var$isObject(obj) {
    return obj !== null && typeof obj === "object";
}
function $2f7a33a694830c16$var$mergeHelper(target, source, pastCopies) {
    if ($2f7a33a694830c16$var$isObject(source) && $2f7a33a694830c16$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f7a33a694830c16$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f7a33a694830c16$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f7a33a694830c16$var$mergeHelper($2f7a33a694830c16$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f7a33a694830c16$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === "object" && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $b5d8e2aeb6b818d7$export$18ce0697a983be9b)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f7a33a694830c16$var$haveWarned = Object.create({});
function $2f7a33a694830c16$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = "warn";
    if (!$2f7a33a694830c16$export$f15d00aa73aafac4() && !$2f7a33a694830c16$var$haveWarned[msg]) {
        if (!$2f7a33a694830c16$export$410cbc2864fa25b5()) $2f7a33a694830c16$var$haveWarned[msg] = true;
        if (type === "error") console.error(msg);
        else console.warn(msg);
    }
}
function $2f7a33a694830c16$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}


function $9aa2faf8993d1281$var$validateOperation(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $f0c8d25f23d653fa$export$cea12affaee22fe8)(2);
    }
    return operation;
}
var $9aa2faf8993d1281$var$LinkError = function(_super) {
    (0, $924c6d39ecfe4883$export$a8ba968b8961cb8a)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function $9aa2faf8993d1281$var$isTerminating(link) {
    return link.request.length <= 1;
}
function $9aa2faf8993d1281$export$4dbaaf6c79705e6c(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var $9aa2faf8993d1281$export$1625492ec82002b9 = $9aa2faf8993d1281$export$4dbaaf6c79705e6c;
function $9aa2faf8993d1281$export$60f45028237c39d1(promise) {
    return new (0, $96dde1abc5261bd1$export$2e2bcd8739ae039)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function $9aa2faf8993d1281$export$4fd972edbe7450d3(errorValue) {
    return new (0, $96dde1abc5261bd1$export$2e2bcd8739ae039)(function(observer) {
        observer.error(errorValue);
    });
}
function $9aa2faf8993d1281$var$transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $2f7a33a694830c16$export$41bca9dc6871dd4e)(transformedOperation.query) : "";
    return transformedOperation;
}
function $9aa2faf8993d1281$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $924c6d39ecfe4883$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $924c6d39ecfe4883$export$18ce0697a983be9b)({}, context, next(context));
        else context = (0, $924c6d39ecfe4883$export$18ce0697a983be9b)({}, context, next);
    };
    var getContext = function() {
        return (0, $924c6d39ecfe4883$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, "toKey", {
        enumerable: false,
        value: function() {
            return $9aa2faf8993d1281$var$getKey(operation);
        }
    });
    return operation;
}
function $9aa2faf8993d1281$var$getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function $9aa2faf8993d1281$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
}
function $9aa2faf8993d1281$var$toLink(handler) {
    return typeof handler === "function" ? new $9aa2faf8993d1281$export$2fed3d61f740bc7f(handler) : handler;
}
function $9aa2faf8993d1281$export$6e22c362a0406a2c() {
    return new $9aa2faf8993d1281$export$2fed3d61f740bc7f(function() {
        return (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
    });
}
function $9aa2faf8993d1281$export$6788812c4e6611e6(links) {
    if (links.length === 0) return $9aa2faf8993d1281$export$6e22c362a0406a2c();
    return links.map($9aa2faf8993d1281$var$toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function $9aa2faf8993d1281$export$65980d18b75784e2(test, left, right) {
    var leftLink = $9aa2faf8993d1281$var$toLink(left);
    var rightLink = $9aa2faf8993d1281$var$toLink(right || new $9aa2faf8993d1281$export$2fed3d61f740bc7f($9aa2faf8993d1281$var$passthrough));
    if ($9aa2faf8993d1281$var$isTerminating(leftLink) && $9aa2faf8993d1281$var$isTerminating(rightLink)) return new $9aa2faf8993d1281$export$2fed3d61f740bc7f(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of() : rightLink.request(operation) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
    });
    else return new $9aa2faf8993d1281$export$2fed3d61f740bc7f(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of() : rightLink.request(operation, forward) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
    });
}
var $9aa2faf8993d1281$export$ee1b3e54f0441b22 = function(first, second) {
    var firstLink = $9aa2faf8993d1281$var$toLink(first);
    if ($9aa2faf8993d1281$var$isTerminating(firstLink)) return firstLink;
    var nextLink = $9aa2faf8993d1281$var$toLink(second);
    if ($9aa2faf8993d1281$var$isTerminating(nextLink)) return new $9aa2faf8993d1281$export$2fed3d61f740bc7f(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
        }) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
    });
    else return new $9aa2faf8993d1281$export$2fed3d61f740bc7f(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
        }) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
    });
};
var $9aa2faf8993d1281$export$2fed3d61f740bc7f = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat($9aa2faf8993d1281$export$65980d18b75784e2(test, left, right || new ApolloLink($9aa2faf8993d1281$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return $9aa2faf8993d1281$export$ee1b3e54f0441b22(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $f0c8d25f23d653fa$export$cea12affaee22fe8)(1);
    };
    ApolloLink.empty = $9aa2faf8993d1281$export$6e22c362a0406a2c;
    ApolloLink.from = $9aa2faf8993d1281$export$6788812c4e6611e6;
    ApolloLink.split = $9aa2faf8993d1281$export$65980d18b75784e2;
    ApolloLink.execute = $9aa2faf8993d1281$export$51396ec711da548b;
    return ApolloLink;
}();
function $9aa2faf8993d1281$export$51396ec711da548b(link, operation) {
    return link.request($9aa2faf8993d1281$export$f29bedd62f56fcb2(operation.context, $9aa2faf8993d1281$var$transformOperation($9aa2faf8993d1281$var$validateOperation(operation)))) || (0, $96dde1abc5261bd1$export$2e2bcd8739ae039).of();
}


function $48eeb2c376070dcd$export$2f04de43fe27971a(setter) {
    return new (0, $9aa2faf8993d1281$export$2fed3d61f740bc7f)(function(operation, forward) {
        var request = (0, $258edca80fd7b5e2$export$3c9a16f847548506)(operation, []);
        return new (0, $96dde1abc5261bd1$export$2e2bcd8739ae039)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}


const $e9e8aa5eaa0eee51$var$httpLink = (0, $0883ade327e7160b$export$95180a16573d6675)({
    uri: "https://stag.strapi.pennypincher.com/graphql/"
});
const $e9e8aa5eaa0eee51$var$authLink = (0, $48eeb2c376070dcd$export$2f04de43fe27971a)((_, { headers: headers })=>{
    const token = "37ec90954756650a23c4258ae5e408f2286c4ef369b7f87448c7efa6953e5c7610a99c9a43ce2da5ba3f03c63df0135f7bf93b46a337a2ae527d4df3f548d45b6509719d6f7eb014942f8ab691a9de84a29a50e6dfbe5e1d4d8ae5d4057de4a106380156e6ed28f7ca5134b8b524f8b24cfcbae2ccd241dfa55d3ed37bbd4fd9";
    return {
        headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : ""
        }
    };
});
const $e9e8aa5eaa0eee51$var$client = new (0, $aea30b064d9e9fe5$export$13f5a5f0f1dbab88)({
    link: $e9e8aa5eaa0eee51$var$authLink.concat($e9e8aa5eaa0eee51$var$httpLink),
    cache: new (0, $db48c96b873d5959$export$467265324939f47f)()
});
var $e9e8aa5eaa0eee51$export$2e2bcd8739ae039 = $e9e8aa5eaa0eee51$var$client;






var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $1a1188d546cac9cf$var$extendStatics = function(d, b) {
    $1a1188d546cac9cf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1a1188d546cac9cf$var$extendStatics(d, b);
};
function $1a1188d546cac9cf$var$__extends(d, b) {
    $1a1188d546cac9cf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1a1188d546cac9cf$var$__assign = function() {
    $1a1188d546cac9cf$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a1188d546cac9cf$var$__assign.apply(this, arguments);
};
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */ function $1a1188d546cac9cf$var$throttle(delay, noTrailing, callback, debounceMode) {
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    } // `noTrailing` defaults to falsy.
    if (typeof noTrailing !== "boolean") {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        var self = this;
        var elapsed = Date.now() - lastExec;
        var args = arguments;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, args);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */ exec();
        else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
var $1a1188d546cac9cf$var$ThresholdUnits = {
    Pixel: "Pixel",
    Percent: "Percent"
};
var $1a1188d546cac9cf$var$defaultThreshold = {
    unit: $1a1188d546cac9cf$var$ThresholdUnits.Percent,
    value: 0.8
};
function $1a1188d546cac9cf$var$parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === "number") return {
        unit: $1a1188d546cac9cf$var$ThresholdUnits.Percent,
        value: scrollThreshold * 100
    };
    if (typeof scrollThreshold === "string") {
        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) return {
            unit: $1a1188d546cac9cf$var$ThresholdUnits.Pixel,
            value: parseFloat(scrollThreshold)
        };
        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) return {
            unit: $1a1188d546cac9cf$var$ThresholdUnits.Percent,
            value: parseFloat(scrollThreshold)
        };
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return $1a1188d546cac9cf$var$defaultThreshold;
    }
    console.warn("scrollThreshold should be string or number");
    return $1a1188d546cac9cf$var$defaultThreshold;
}
var $1a1188d546cac9cf$var$InfiniteScroll = /** @class */ function(_super) {
    $1a1188d546cac9cf$var$__extends(InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollTop = 0;
        _this.actionTriggered = false;
        // variables to keep track of pull down behaviour
        _this.startY = 0;
        _this.currentY = 0;
        _this.dragging = false;
        // will be populated in componentDidMount
        // based on the height of the pull down element
        _this.maxPullDownDistance = 0;
        _this.getScrollableTarget = function() {
            if (_this.props.scrollableTarget instanceof HTMLElement) return _this.props.scrollableTarget;
            if (typeof _this.props.scrollableTarget === "string") return document.getElementById(_this.props.scrollableTarget);
            if (_this.props.scrollableTarget === null) console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
            return null;
        };
        _this.onStart = function(evt) {
            if (_this.lastScrollTop) return;
            _this.dragging = true;
            if (evt instanceof MouseEvent) _this.startY = evt.pageY;
            else if (evt instanceof TouchEvent) _this.startY = evt.touches[0].pageY;
            _this.currentY = _this.startY;
            if (_this._infScroll) {
                _this._infScroll.style.willChange = "transform";
                _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
            }
        };
        _this.onMove = function(evt) {
            if (!_this.dragging) return;
            if (evt instanceof MouseEvent) _this.currentY = evt.pageY;
            else if (evt instanceof TouchEvent) _this.currentY = evt.touches[0].pageY;
            // user is scrolling down to up
            if (_this.currentY < _this.startY) return;
            if (_this.currentY - _this.startY >= Number(_this.props.pullDownToRefreshThreshold)) _this.setState({
                pullToRefreshThresholdBreached: true
            });
            // so you can drag upto 1.5 times of the maxPullDownDistance
            if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5) return;
            if (_this._infScroll) {
                _this._infScroll.style.overflow = "visible";
                _this._infScroll.style.transform = "translate3d(0px, " + (_this.currentY - _this.startY) + "px, 0px)";
            }
        };
        _this.onEnd = function() {
            _this.startY = 0;
            _this.currentY = 0;
            _this.dragging = false;
            if (_this.state.pullToRefreshThresholdBreached) {
                _this.props.refreshFunction && _this.props.refreshFunction();
                _this.setState({
                    pullToRefreshThresholdBreached: false
                });
            }
            requestAnimationFrame(function() {
                // this._infScroll
                if (_this._infScroll) {
                    _this._infScroll.style.overflow = "auto";
                    _this._infScroll.style.transform = "none";
                    _this._infScroll.style.willChange = "unset";
                }
            });
        };
        _this.onScrollListener = function(event) {
            if (typeof _this.props.onScroll === "function") // Execute this callback in next tick so that it does not affect the
            // functionality of the library.
            setTimeout(function() {
                return _this.props.onScroll && _this.props.onScroll(event);
            }, 0);
            var target = _this.props.height || _this._scrollableNode ? event.target : document.documentElement.scrollTop ? document.documentElement : document.body;
            // return immediately if the action has already been triggered,
            // prevents multiple triggers.
            if (_this.actionTriggered) return;
            var atBottom = _this.props.inverse ? _this.isElementAtTop(target, _this.props.scrollThreshold) : _this.isElementAtBottom(target, _this.props.scrollThreshold);
            // call the `next` function in the props to trigger the next data fetch
            if (atBottom && _this.props.hasMore) {
                _this.actionTriggered = true;
                _this.setState({
                    showLoader: true
                });
                _this.props.next && _this.props.next();
            }
            _this.lastScrollTop = target.scrollTop;
        };
        _this.state = {
            showLoader: false,
            pullToRefreshThresholdBreached: false,
            prevDataLength: props.dataLength
        };
        _this.throttledOnScrollListener = $1a1188d546cac9cf$var$throttle(150, _this.onScrollListener).bind(_this);
        _this.onStart = _this.onStart.bind(_this);
        _this.onMove = _this.onMove.bind(_this);
        _this.onEnd = _this.onEnd.bind(_this);
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function() {
        if (typeof this.props.dataLength === "undefined") throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
        this._scrollableNode = this.getScrollableTarget();
        this.el = this.props.height ? this._infScroll : this._scrollableNode || window;
        if (this.el) this.el.addEventListener("scroll", this.throttledOnScrollListener);
        if (typeof this.props.initialScrollY === "number" && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY) this.el.scrollTo(0, this.props.initialScrollY);
        if (this.props.pullDownToRefresh && this.el) {
            this.el.addEventListener("touchstart", this.onStart);
            this.el.addEventListener("touchmove", this.onMove);
            this.el.addEventListener("touchend", this.onEnd);
            this.el.addEventListener("mousedown", this.onStart);
            this.el.addEventListener("mousemove", this.onMove);
            this.el.addEventListener("mouseup", this.onEnd);
            // get BCR of pullDown element to position it above
            this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0;
            this.forceUpdate();
            if (typeof this.props.refreshFunction !== "function") throw new Error('Mandatory prop "refreshFunction" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage\'');
        }
    };
    InfiniteScroll.prototype.componentWillUnmount = function() {
        if (this.el) {
            this.el.removeEventListener("scroll", this.throttledOnScrollListener);
            if (this.props.pullDownToRefresh) {
                this.el.removeEventListener("touchstart", this.onStart);
                this.el.removeEventListener("touchmove", this.onMove);
                this.el.removeEventListener("touchend", this.onEnd);
                this.el.removeEventListener("mousedown", this.onStart);
                this.el.removeEventListener("mousemove", this.onMove);
                this.el.removeEventListener("mouseup", this.onEnd);
            }
        }
    };
    InfiniteScroll.prototype.componentDidUpdate = function(prevProps) {
        // do nothing when dataLength is unchanged
        if (this.props.dataLength === prevProps.dataLength) return;
        this.actionTriggered = false;
        // update state when new data was sent in
        this.setState({
            showLoader: false
        });
    };
    InfiniteScroll.getDerivedStateFromProps = function(nextProps, prevState) {
        var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
        // reset when data changes
        if (dataLengthChanged) return $1a1188d546cac9cf$var$__assign($1a1188d546cac9cf$var$__assign({}, prevState), {
            prevDataLength: nextProps.dataLength
        });
        return null;
    };
    InfiniteScroll.prototype.isElementAtTop = function(target, scrollThreshold) {
        if (scrollThreshold === void 0) scrollThreshold = 0.8;
        var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
        var threshold = $1a1188d546cac9cf$var$parseThreshold(scrollThreshold);
        if (threshold.unit === $1a1188d546cac9cf$var$ThresholdUnits.Pixel) return target.scrollTop <= threshold.value + clientHeight - target.scrollHeight + 1;
        return target.scrollTop <= threshold.value / 100 + clientHeight - target.scrollHeight + 1;
    };
    InfiniteScroll.prototype.isElementAtBottom = function(target, scrollThreshold) {
        if (scrollThreshold === void 0) scrollThreshold = 0.8;
        var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
        var threshold = $1a1188d546cac9cf$var$parseThreshold(scrollThreshold);
        if (threshold.unit === $1a1188d546cac9cf$var$ThresholdUnits.Pixel) return target.scrollTop + clientHeight >= target.scrollHeight - threshold.value;
        return target.scrollTop + clientHeight >= threshold.value / 100 * target.scrollHeight;
    };
    InfiniteScroll.prototype.render = function() {
        var _this = this;
        var style = $1a1188d546cac9cf$var$__assign({
            height: this.props.height || "auto",
            overflow: "auto",
            WebkitOverflowScrolling: "touch"
        }, this.props.style);
        var hasChildren = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length);
        // because heighted infiniteScroll visualy breaks
        // on drag down as overflow becomes visible
        var outerDivStyle = this.props.pullDownToRefresh && this.props.height ? {
            overflow: "auto"
        } : {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", {
            style: outerDivStyle,
            className: "infinite-scroll-component__outerdiv"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", {
            className: "infinite-scroll-component " + (this.props.className || ""),
            ref: function(infScroll) {
                return _this._infScroll = infScroll;
            },
            style: style
        }, this.props.pullDownToRefresh && (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", {
            style: {
                position: "relative"
            },
            ref: function(pullDown) {
                return _this._pullDown = pullDown;
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", {
            style: {
                position: "absolute",
                left: 0,
                right: 0,
                top: -1 * this.maxPullDownDistance
            }
        }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)), this.props.children, !this.state.showLoader && !hasChildren && this.props.hasMore && this.props.loader, this.state.showLoader && this.props.hasMore && this.props.loader, !this.props.hasMore && this.props.endMessage));
    };
    return InfiniteScroll;
}((0, $eXaQ2.Component));
var $1a1188d546cac9cf$export$2e2bcd8739ae039 = $1a1188d546cac9cf$var$InfiniteScroll;




var $eXaQ2 = parcelRequire("eXaQ2");

function $34c3e0df3dad45a4$export$eb9a56e7a29e494(override) {
    var context = $eXaQ2.useContext((0, $26109d2cb69f3084$export$a47505d961ee3a1)());
    var client = override || context.client;
    (0, $90037d9f94267989$export$f5708dca728d7177)(!!client, 47);
    return client;
}




var $eXaQ2 = parcelRequire("eXaQ2");


var $eXaQ2 = parcelRequire("eXaQ2");

var $21f078a1bdeeb4db$var$didWarnUncachedGetSnapshot = false;
var $21f078a1bdeeb4db$var$uSESKey = "useSyncExternalStore";
var $21f078a1bdeeb4db$var$realHook = $eXaQ2[$21f078a1bdeeb4db$var$uSESKey];
var $21f078a1bdeeb4db$export$306c0aa65ff9ec16 = $21f078a1bdeeb4db$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (globalThis.__DEV__ !== false && !$21f078a1bdeeb4db$var$didWarnUncachedGetSnapshot && value !== getSnapshot()) {
        $21f078a1bdeeb4db$var$didWarnUncachedGetSnapshot = true;
        globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).error(56);
    }
    var _a = $eXaQ2.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    if (0, $ba22ce8d716d9f8d$export$4001f6cd4a62405b) $eXaQ2.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        if ($21f078a1bdeeb4db$var$checkIfSnapshotChanged(inst)) forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $eXaQ2.useEffect(function() {
        if ($21f078a1bdeeb4db$var$checkIfSnapshotChanged(inst)) forceUpdate({
            inst: inst
        });
        return subscribe(function handleStoreChange() {
            if ($21f078a1bdeeb4db$var$checkIfSnapshotChanged(inst)) forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    return value;
};
function $21f078a1bdeeb4db$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}








var $84f6821b4734fce9$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($84f6821b4734fce9$export$d1d99cf900472499 || ($84f6821b4734fce9$export$d1d99cf900472499 = {}));
var $84f6821b4734fce9$var$cache = new Map();
function $84f6821b4734fce9$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $84f6821b4734fce9$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $84f6821b4734fce9$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $84f6821b4734fce9$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $84f6821b4734fce9$export$8f49e4af10703ce3(document) {
    var cached = $84f6821b4734fce9$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $90037d9f94267989$export$f5708dca728d7177)(!!document && !!document.kind, 57, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $90037d9f94267989$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 58);
    (0, $90037d9f94267989$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 59, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $84f6821b4734fce9$export$d1d99cf900472499.Query : $84f6821b4734fce9$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $84f6821b4734fce9$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $90037d9f94267989$export$f5708dca728d7177)(definitions.length === 1, 60, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data";
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $84f6821b4734fce9$var$cache.set(document, payload);
    return payload;
}
function $84f6821b4734fce9$export$6dfb8732f737404c(document, type) {
    var operation = $84f6821b4734fce9$export$8f49e4af10703ce3(document);
    var requiredOperationName = $84f6821b4734fce9$export$5db520940cf00715(type);
    var usedOperationName = $84f6821b4734fce9$export$5db520940cf00715(operation.type);
    (0, $90037d9f94267989$export$f5708dca728d7177)(operation.type === type, 61, requiredOperationName, requiredOperationName, usedOperationName);
}



var $cb89595d8b20dae2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $cb89595d8b20dae2$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return $cb89595d8b20dae2$export$6342ea8c555e49e5((0, $34c3e0df3dad45a4$export$eb9a56e7a29e494)(options.client), query).useQuery(options);
}
function $cb89595d8b20dae2$export$6342ea8c555e49e5(client, query) {
    var stateRef = $eXaQ2.useRef();
    if (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) stateRef.current = new $cb89595d8b20dae2$var$InternalState(client, query, stateRef.current);
    var state = stateRef.current;
    state.forceUpdateState = $eXaQ2.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    return state;
}
var $cb89595d8b20dae2$var$InternalState = function() {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        this.forceUpdate = function() {
            return _this.forceUpdateState();
        };
        this.ssrDisabledResult = (0, $8e47f607a8a61e2d$export$7f9c177735b71f18)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).loading
        });
        this.skipStandbyResult = (0, $8e47f607a8a61e2d$export$7f9c177735b71f18)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).ready
        });
        this.toQueryResultCache = new ((0, $ba22ce8d716d9f8d$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        (0, $84f6821b4734fce9$export$6dfb8732f737404c)(query, (0, $84f6821b4734fce9$export$d1d99cf900472499).Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) this.previousData = previousData;
    }
    InternalState.prototype.forceUpdateState = function() {
        globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(48);
    };
    InternalState.prototype.executeQuery = function(options) {
        var _this = this;
        var _a;
        if (options.query) Object.assign(this, {
            query: options.query
        });
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function(resolve) {
            var result;
            concast.subscribe({
                next: function(value) {
                    result = value;
                },
                error: function() {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function() {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    InternalState.prototype.useQuery = function(options) {
        var _this = this;
        this.renderPromises = $eXaQ2.useContext((0, $26109d2cb69f3084$export$a47505d961ee3a1)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0, $21f078a1bdeeb4db$export$306c0aa65ff9ec16)($eXaQ2.useCallback(function(handleStoreChange) {
            if (_this.renderPromises) return function() {};
            _this.forceUpdate = handleStoreChange;
            var onNext = function() {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(previousResult.data, result.data)) return;
                _this.setResult(result);
            };
            var onError = function(error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                } finally{
                    obsQuery["last"] = last;
                }
                if (!$cb89595d8b20dae2$var$hasOwnProperty.call(error, "graphQLErrors")) throw error;
                var previousResult = _this.result;
                if (!previousResult || previousResult && previousResult.loading || !(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(error, previousResult.error)) _this.setResult({
                    data: previousResult && previousResult.data,
                    error: error,
                    loading: false,
                    networkStatus: (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).error
                });
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function() {
                setTimeout(function() {
                    return subscription.unsubscribe();
                });
                _this.forceUpdate = function() {
                    return _this.forceUpdateState();
                };
            };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches
        ]), function() {
            return _this.getCurrentResult();
        }, function() {
            return _this.getCurrentResult();
        });
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function(options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0, $8a2a53380af04d4b$export$411ce8e5a71e3069)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === false && !this.queryHookOptions.skip) this.result = this.ssrDisabledResult;
        else if (this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby") this.result = this.skipStandbyResult;
        else if (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) this.result = void 0;
    };
    InternalState.prototype.getObsQueryOptions = function() {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults) toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) toMerge.push(this.queryHookOptions.defaultOptions);
        toMerge.push((0, $70dcb8ce73dffddb$export$8e16b83750b44988)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce((0, $51b07d6991982f9b$export$235b7fc70b9fc359));
    };
    InternalState.prototype.createWatchQueryOptions = function(_a) {
        var _b;
        if (_a === void 0) _a = {};
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, otherOptions = (0, $e86a7d058696b512$export$3c9a16f847548506)(_a, [
            "skip",
            "ssr",
            "onCompleted",
            "onError",
            "defaultOptions"
        ]);
        var watchQueryOptions = Object.assign(otherOptions, {
            query: this.query
        });
        if (this.renderPromises && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby"
            });
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy();
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function() {
        var _a, _b;
        return ((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
    };
    InternalState.prototype.onCompleted = function(data) {};
    InternalState.prototype.onError = function(error) {};
    InternalState.prototype.useObservableQuery = function() {
        var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = $eXaQ2.useMemo(function() {
            return {
                refetch: obsQuery.refetch.bind(obsQuery),
                reobserve: obsQuery.reobserve.bind(obsQuery),
                fetchMore: obsQuery.fetchMore.bind(obsQuery),
                updateQuery: obsQuery.updateQuery.bind(obsQuery),
                startPolling: obsQuery.startPolling.bind(obsQuery),
                stopPolling: obsQuery.stopPolling.bind(obsQuery),
                subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
            };
        }, [
            obsQuery
        ]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) this.renderPromises.addObservableQueryPromise(obsQuery);
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function(nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) this.previousData = previousResult.data;
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function(result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            Promise.resolve().then(function() {
                if (error_1) _this.onError(error_1);
                else if (result.data && (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus && result.networkStatus === (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).ready) _this.onCompleted(result.data);
            }).catch(function(error) {
                globalThis.__DEV__ !== false && (0, $90037d9f94267989$export$f5708dca728d7177).warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function(result) {
        return (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(result.errors) ? new (0, $e174ce09a0f32944$export$26a337512320b8c6)({
            graphQLErrors: result.errors
        }) : result.error;
    };
    InternalState.prototype.getCurrentResult = function() {
        if (!this.result) this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        return this.result;
    };
    InternalState.prototype.toQueryResult = function(result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult) return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0, $e86a7d058696b512$export$3c9a16f847548506)(result, [
            "data",
            "partial"
        ]);
        this.toQueryResultCache.set(result, queryResult = (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({
            data: data
        }, resultWithoutPartial), this.obsQueryFields), {
            client: this.client,
            observable: this.observable,
            variables: this.observable.variables,
            called: !this.queryHookOptions.skip,
            previousData: this.previousData
        }));
        if (!queryResult.error && (0, $763d36c6d12d5d9a$export$d307f5934e447d0e)(result.errors)) queryResult.error = new (0, $e174ce09a0f32944$export$26a337512320b8c6)({
            graphQLErrors: result.errors
        });
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function(result) {
        if (result.partial && this.queryHookOptions.partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: (0, $43f21a53b07f28f6$export$bd096ddbd246c79c).refetch
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}();



var $6d2c48be626fe9c2$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6d2c48be626fe9c2$var$ReactIs, $6d2c48be626fe9c2$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$6d2c48be626fe9c2$exports = (parcelRequire("igxP1"))();


var $7d1e34e814b39338$exports = {};
"use strict";
function $7d1e34e814b39338$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $eXaQ2 = parcelRequire("eXaQ2");
var $7d1e34e814b39338$var$React__default = $7d1e34e814b39338$var$_interopDefault($eXaQ2);
function $7d1e34e814b39338$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d1e34e814b39338$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $7d1e34e814b39338$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $7d1e34e814b39338$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $7d1e34e814b39338$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $7d1e34e814b39338$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($eXaQ2.PureComponent);
        $7d1e34e814b39338$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $7d1e34e814b39338$var$_defineProperty(SideEffect, "canUseDOM", $7d1e34e814b39338$var$canUseDOM);
        return SideEffect;
    };
}
$7d1e34e814b39338$exports = $7d1e34e814b39338$var$withSideEffect;


var $a229d548c7879529$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a229d548c7879529$var$hasElementType = typeof Element !== "undefined";
var $a229d548c7879529$var$hasMap = typeof Map === "function";
var $a229d548c7879529$var$hasSet = typeof Set === "function";
var $a229d548c7879529$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a229d548c7879529$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a229d548c7879529$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a229d548c7879529$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a229d548c7879529$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a229d548c7879529$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a229d548c7879529$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a229d548c7879529$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a229d548c7879529$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$a229d548c7879529$exports = function isEqual(a, b) {
    try {
        return $a229d548c7879529$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $eXaQ2 = parcelRequire("eXaQ2");
var $84b2cb81ddf52c18$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $84b2cb81ddf52c18$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $84b2cb81ddf52c18$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $84b2cb81ddf52c18$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $84b2cb81ddf52c18$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $84b2cb81ddf52c18$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$84b2cb81ddf52c18$exports = $84b2cb81ddf52c18$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $84b2cb81ddf52c18$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($84b2cb81ddf52c18$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($84b2cb81ddf52c18$var$getOwnPropertySymbols) {
            symbols = $84b2cb81ddf52c18$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($84b2cb81ddf52c18$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $1f02524b81d370cb$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $1f02524b81d370cb$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $1f02524b81d370cb$var$VALID_TAG_NAMES = Object.keys($1f02524b81d370cb$var$TAG_NAMES).map(function(name) {
    return $1f02524b81d370cb$var$TAG_NAMES[name];
});
var $1f02524b81d370cb$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $1f02524b81d370cb$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $1f02524b81d370cb$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $1f02524b81d370cb$var$HTML_TAG_MAP = Object.keys($1f02524b81d370cb$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$1f02524b81d370cb$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $1f02524b81d370cb$var$SELF_CLOSING_TAGS = [
    $1f02524b81d370cb$var$TAG_NAMES.NOSCRIPT,
    $1f02524b81d370cb$var$TAG_NAMES.SCRIPT,
    $1f02524b81d370cb$var$TAG_NAMES.STYLE
];
var $1f02524b81d370cb$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $1f02524b81d370cb$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $1f02524b81d370cb$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $1f02524b81d370cb$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $1f02524b81d370cb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $1f02524b81d370cb$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $1f02524b81d370cb$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $1f02524b81d370cb$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $1f02524b81d370cb$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $1f02524b81d370cb$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $1f02524b81d370cb$var$getInnermostProperty(propsList, $1f02524b81d370cb$var$TAG_NAMES.TITLE);
    var innermostTemplate = $1f02524b81d370cb$var$getInnermostProperty(propsList, $1f02524b81d370cb$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $1f02524b81d370cb$var$getInnermostProperty(propsList, $1f02524b81d370cb$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $1f02524b81d370cb$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $1f02524b81d370cb$var$getInnermostProperty(propsList, $1f02524b81d370cb$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $1f02524b81d370cb$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $1f02524b81d370cb$var$_extends({}, tagAttrs, current);
    }, {});
};
var $1f02524b81d370cb$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$1f02524b81d370cb$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$1f02524b81d370cb$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $1f02524b81d370cb$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $1f02524b81d370cb$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $1f02524b81d370cb$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $1f02524b81d370cb$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $1f02524b81d370cb$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $1f02524b81d370cb$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $1f02524b81d370cb$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $1f02524b81d370cb$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($84b2cb81ddf52c18$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $1f02524b81d370cb$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $1f02524b81d370cb$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $1f02524b81d370cb$var$getBaseTagFromPropsList([
            $1f02524b81d370cb$var$TAG_PROPERTIES.HREF,
            $1f02524b81d370cb$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $1f02524b81d370cb$var$getAttributesFromPropsList($1f02524b81d370cb$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $1f02524b81d370cb$var$getInnermostProperty(propsList, $1f02524b81d370cb$var$HELMET_PROPS.DEFER),
        encode: $1f02524b81d370cb$var$getInnermostProperty(propsList, $1f02524b81d370cb$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $1f02524b81d370cb$var$getAttributesFromPropsList($1f02524b81d370cb$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $1f02524b81d370cb$var$getTagsFromPropsList($1f02524b81d370cb$var$TAG_NAMES.LINK, [
            $1f02524b81d370cb$var$TAG_PROPERTIES.REL,
            $1f02524b81d370cb$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $1f02524b81d370cb$var$getTagsFromPropsList($1f02524b81d370cb$var$TAG_NAMES.META, [
            $1f02524b81d370cb$var$TAG_PROPERTIES.NAME,
            $1f02524b81d370cb$var$TAG_PROPERTIES.CHARSET,
            $1f02524b81d370cb$var$TAG_PROPERTIES.HTTPEQUIV,
            $1f02524b81d370cb$var$TAG_PROPERTIES.PROPERTY,
            $1f02524b81d370cb$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $1f02524b81d370cb$var$getTagsFromPropsList($1f02524b81d370cb$var$TAG_NAMES.NOSCRIPT, [
            $1f02524b81d370cb$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $1f02524b81d370cb$var$getOnChangeClientState(propsList),
        scriptTags: $1f02524b81d370cb$var$getTagsFromPropsList($1f02524b81d370cb$var$TAG_NAMES.SCRIPT, [
            $1f02524b81d370cb$var$TAG_PROPERTIES.SRC,
            $1f02524b81d370cb$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $1f02524b81d370cb$var$getTagsFromPropsList($1f02524b81d370cb$var$TAG_NAMES.STYLE, [
            $1f02524b81d370cb$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $1f02524b81d370cb$var$getTitleFromPropsList(propsList),
        titleAttributes: $1f02524b81d370cb$var$getAttributesFromPropsList($1f02524b81d370cb$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $1f02524b81d370cb$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $1f02524b81d370cb$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $1f02524b81d370cb$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $1f02524b81d370cb$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $1f02524b81d370cb$var$rafPolyfill : $parcel$global.requestAnimationFrame || $1f02524b81d370cb$var$rafPolyfill;
var $1f02524b81d370cb$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $1f02524b81d370cb$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $1f02524b81d370cb$var$cafPolyfill;
var $1f02524b81d370cb$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $1f02524b81d370cb$var$_helmetCallback = null;
var $1f02524b81d370cb$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($1f02524b81d370cb$var$_helmetCallback) $1f02524b81d370cb$var$cancelAnimationFrame($1f02524b81d370cb$var$_helmetCallback);
    if (newState.defer) $1f02524b81d370cb$var$_helmetCallback = $1f02524b81d370cb$var$requestAnimationFrame(function() {
        $1f02524b81d370cb$var$commitTagChanges(newState, function() {
            $1f02524b81d370cb$var$_helmetCallback = null;
        });
    });
    else {
        $1f02524b81d370cb$var$commitTagChanges(newState);
        $1f02524b81d370cb$var$_helmetCallback = null;
    }
};
var $1f02524b81d370cb$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $1f02524b81d370cb$var$updateAttributes($1f02524b81d370cb$var$TAG_NAMES.BODY, bodyAttributes);
    $1f02524b81d370cb$var$updateAttributes($1f02524b81d370cb$var$TAG_NAMES.HTML, htmlAttributes);
    $1f02524b81d370cb$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $1f02524b81d370cb$var$updateTags($1f02524b81d370cb$var$TAG_NAMES.BASE, baseTag),
        linkTags: $1f02524b81d370cb$var$updateTags($1f02524b81d370cb$var$TAG_NAMES.LINK, linkTags),
        metaTags: $1f02524b81d370cb$var$updateTags($1f02524b81d370cb$var$TAG_NAMES.META, metaTags),
        noscriptTags: $1f02524b81d370cb$var$updateTags($1f02524b81d370cb$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $1f02524b81d370cb$var$updateTags($1f02524b81d370cb$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $1f02524b81d370cb$var$updateTags($1f02524b81d370cb$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $1f02524b81d370cb$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $1f02524b81d370cb$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $1f02524b81d370cb$var$flattenArray(title);
    $1f02524b81d370cb$var$updateAttributes($1f02524b81d370cb$var$TAG_NAMES.TITLE, attributes);
};
var $1f02524b81d370cb$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($1f02524b81d370cb$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($1f02524b81d370cb$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($1f02524b81d370cb$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($1f02524b81d370cb$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $1f02524b81d370cb$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($1f02524b81d370cb$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $1f02524b81d370cb$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $1f02524b81d370cb$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $1f02524b81d370cb$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($1f02524b81d370cb$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $1f02524b81d370cb$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $1f02524b81d370cb$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $1f02524b81d370cb$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $1f02524b81d370cb$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $1f02524b81d370cb$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $1f02524b81d370cb$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $1f02524b81d370cb$var$HELMET_ATTRIBUTE + '="true">' + $1f02524b81d370cb$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $1f02524b81d370cb$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $1f02524b81d370cb$var$TAG_PROPERTIES.INNER_HTML || attribute === $1f02524b81d370cb$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $1f02524b81d370cb$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $1f02524b81d370cb$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $1f02524b81d370cb$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $1f02524b81d370cb$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$1f02524b81d370cb$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $1f02524b81d370cb$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$1f02524b81d370cb$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $1f02524b81d370cb$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$1f02524b81d370cb$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $1f02524b81d370cb$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($1f02524b81d370cb$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $1f02524b81d370cb$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$1f02524b81d370cb$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $1f02524b81d370cb$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $1f02524b81d370cb$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $1f02524b81d370cb$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement(type, mappedTag);
    });
};
var $1f02524b81d370cb$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $1f02524b81d370cb$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $1f02524b81d370cb$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $1f02524b81d370cb$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $1f02524b81d370cb$var$ATTRIBUTE_NAMES.BODY:
        case $1f02524b81d370cb$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $1f02524b81d370cb$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $1f02524b81d370cb$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $1f02524b81d370cb$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $1f02524b81d370cb$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $1f02524b81d370cb$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$TAG_NAMES.META, metaTags, encode),
        noscript: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $1f02524b81d370cb$var$getMethodsForTag($1f02524b81d370cb$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $1f02524b81d370cb$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $1f02524b81d370cb$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $1f02524b81d370cb$var$classCallCheck(this, HelmetWrapper);
            return $1f02524b81d370cb$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($a229d548c7879529$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $1f02524b81d370cb$var$TAG_NAMES.SCRIPT:
                case $1f02524b81d370cb$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $1f02524b81d370cb$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $1f02524b81d370cb$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $1f02524b81d370cb$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $1f02524b81d370cb$var$TAG_NAMES.TITLE:
                    return $1f02524b81d370cb$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $1f02524b81d370cb$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $1f02524b81d370cb$var$TAG_NAMES.BODY:
                    return $1f02524b81d370cb$var$_extends({}, newProps, {
                        bodyAttributes: $1f02524b81d370cb$var$_extends({}, newChildProps)
                    });
                case $1f02524b81d370cb$var$TAG_NAMES.HTML:
                    return $1f02524b81d370cb$var$_extends({}, newProps, {
                        htmlAttributes: $1f02524b81d370cb$var$_extends({}, newChildProps)
                    });
            }
            return $1f02524b81d370cb$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $1f02524b81d370cb$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $1f02524b81d370cb$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $1f02524b81d370cb$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $1f02524b81d370cb$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $1f02524b81d370cb$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $1f02524b81d370cb$var$TAG_NAMES.LINK:
                    case $1f02524b81d370cb$var$TAG_NAMES.META:
                    case $1f02524b81d370cb$var$TAG_NAMES.NOSCRIPT:
                    case $1f02524b81d370cb$var$TAG_NAMES.SCRIPT:
                    case $1f02524b81d370cb$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $1f02524b81d370cb$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $1f02524b81d370cb$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement(Component, newProps);
        };
        $1f02524b81d370cb$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($6d2c48be626fe9c2$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $1f02524b81d370cb$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $1f02524b81d370cb$var$NullComponent = function NullComponent() {
    return null;
};
var $1f02524b81d370cb$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($7d1e34e814b39338$exports)))($1f02524b81d370cb$var$reducePropsToState, $1f02524b81d370cb$var$handleClientStateChange, $1f02524b81d370cb$var$mapStateOnServer)($1f02524b81d370cb$var$NullComponent);
var $1f02524b81d370cb$export$dcef8f9bb9a41431 = $1f02524b81d370cb$var$Helmet($1f02524b81d370cb$var$HelmetSideEffects);
$1f02524b81d370cb$export$dcef8f9bb9a41431.renderStatic = $1f02524b81d370cb$export$dcef8f9bb9a41431.rewind;
var $1f02524b81d370cb$export$2e2bcd8739ae039 = $1f02524b81d370cb$export$dcef8f9bb9a41431;




var $eXaQ2 = parcelRequire("eXaQ2");


var $eXaQ2 = parcelRequire("eXaQ2");
function $f7bc6ba166fb9018$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $f7bc6ba166fb9018$export$4659b591c19bdf3d), t;
}



var $eXaQ2 = parcelRequire("eXaQ2");
function $5bc3faf0a7aa157d$export$ce4ab0c55987d1ff(...n) {
    return n.filter(Boolean).join(" ");
}



var $5d4205bcd60f27f1$export$617d79dae526d2cf = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($5d4205bcd60f27f1$export$617d79dae526d2cf || {}), $5d4205bcd60f27f1$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($5d4205bcd60f27f1$export$80c0a745e59f7989 || {});
function $5d4205bcd60f27f1$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: a, features: s, visible: n = !0, name: f }) {
    let o = $5d4205bcd60f27f1$var$N(t, r);
    if (n) return $5d4205bcd60f27f1$var$c(o, e, a, f);
    let u = s != null ? s : 0;
    if (u & 2) {
        let { static: l = !1, ...p } = o;
        if (l) return $5d4205bcd60f27f1$var$c(p, e, a, f);
    }
    if (u & 1) {
        let { unmount: l = !0, ...p } = o;
        return (0, $f7bc6ba166fb9018$export$4659b591c19bdf3d)(l ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $5d4205bcd60f27f1$var$c({
                    ...p,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, a, f);
            }
        });
    }
    return $5d4205bcd60f27f1$var$c(o, e, a, f);
}
function $5d4205bcd60f27f1$var$c(r, t = {}, e, a) {
    let { as: s = e, children: n, refName: f = "ref", ...o } = $5d4205bcd60f27f1$var$g(r, [
        "unmount",
        "static"
    ]), u = r.ref !== void 0 ? {
        [f]: r.ref
    } : {}, l = typeof n == "function" ? n(t) : n;
    "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(t));
    let p = {};
    if (t) {
        let i = !1, m = [];
        for (let [y, d] of Object.entries(t))typeof d == "boolean" && (i = !0), d === !0 && m.push(y);
        i && (p["data-headlessui-state"] = m.join(" "));
    }
    if (s === (0, $eXaQ2.Fragment) && Object.keys($5d4205bcd60f27f1$export$8e16b83750b44988(o)).length > 0) {
        if (!(0, $eXaQ2.isValidElement)(l) || Array.isArray(l) && l.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${a} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(o).map((d)=>`  - ${d}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((d)=>`  - ${d}`).join(`
`)
        ].join(`
`));
        let i = l.props, m = typeof (i == null ? void 0 : i.className) == "function" ? (...d)=>(0, $5bc3faf0a7aa157d$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className(...d), o.className) : (0, $5bc3faf0a7aa157d$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className, o.className), y = m ? {
            className: m
        } : {};
        return (0, $eXaQ2.cloneElement)(l, Object.assign({}, $5d4205bcd60f27f1$var$N(l.props, $5d4205bcd60f27f1$export$8e16b83750b44988($5d4205bcd60f27f1$var$g(o, [
            "ref"
        ]))), p, u, $5d4205bcd60f27f1$var$w(l.ref, u.ref), y));
    }
    return (0, $eXaQ2.createElement)(s, Object.assign({}, $5d4205bcd60f27f1$var$g(o, [
        "ref"
    ]), s !== (0, $eXaQ2.Fragment) && u, s !== (0, $eXaQ2.Fragment) && p), l);
}
function $5d4205bcd60f27f1$var$w(...r) {
    return {
        ref: r.every((t)=>t == null) ? void 0 : (t)=>{
            for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
        }
    };
}
function $5d4205bcd60f27f1$var$N(...r) {
    var a;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let s of r)for(let n in s)n.startsWith("on") && typeof s[n] == "function" ? ((a = e[n]) != null || (e[n] = []), e[n].push(s[n])) : t[n] = s[n];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((s)=>[
            s,
            void 0
        ])));
    for(let s in e)Object.assign(t, {
        [s] (n, ...f) {
            let o = e[s];
            for (let u of o){
                if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
                u(n, ...f);
            }
        }
    });
    return t;
}
function $5d4205bcd60f27f1$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $eXaQ2.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $5d4205bcd60f27f1$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $5d4205bcd60f27f1$var$g(r, t = []) {
    let e = Object.assign({}, r);
    for (let a of t)a in e && delete e[a];
    return e;
}



var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");
var $b86fddc59d9d5f5e$var$i = Object.defineProperty;
var $b86fddc59d9d5f5e$var$d = (t, e, n)=>e in t ? $b86fddc59d9d5f5e$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $b86fddc59d9d5f5e$var$r = (t, e, n)=>($b86fddc59d9d5f5e$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $b86fddc59d9d5f5e$var$o {
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
    constructor(){
        $b86fddc59d9d5f5e$var$r(this, "current", this.detect());
        $b86fddc59d9d5f5e$var$r(this, "handoffState", "pending");
        $b86fddc59d9d5f5e$var$r(this, "currentId", 0);
    }
}
let $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3 = new $b86fddc59d9d5f5e$var$o;


let $ef967070258a0d27$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).isServer ? (0, $eXaQ2.useEffect)(e, f) : (0, $eXaQ2.useLayoutEffect)(e, f);
};


function $31f1af853d6a581a$export$86c4283a11f23f95(e) {
    let r = (0, $eXaQ2.useRef)(e);
    return (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


let $7be81799544fd475$export$90fc3a17d93f704c = function(t) {
    let e = (0, $31f1af853d6a581a$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};


let $49458ecf29eec77d$var$u = Symbol();
function $49458ecf29eec77d$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$49458ecf29eec77d$var$u]: n
    });
}
function $49458ecf29eec77d$export$f6a25a78204acc7e(...t) {
    let n = (0, $eXaQ2.useRef)(t);
    (0, $eXaQ2.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $7be81799544fd475$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$49458ecf29eec77d$var$u])) ? void 0 : c;
}


var $e1fa4e8f87f38de0$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($e1fa4e8f87f38de0$export$4b0075e5ea5e1f26 || {});


function $3fd2a67fca6494ad$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $3fd2a67fca6494ad$var$i(l) ? !1 : t;
}
function $3fd2a67fca6494ad$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}



var $eXaQ2 = parcelRequire("eXaQ2");


var $eXaQ2 = parcelRequire("eXaQ2");

function $ac6f64b33cbfbccb$export$44ab2b9f2d09b0fa() {
    let [e, f] = (0, $eXaQ2.useState)((0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && f(!1), (0, $eXaQ2.useEffect)(()=>{
        e !== !0 && f(!0);
    }, [
        e
    ]), (0, $eXaQ2.useEffect)(()=>(0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).handoff(), []), e;
}



var $52be9c2c83b043d2$var$o;
let $52be9c2c83b043d2$export$f680877a34711e37 = ($52be9c2c83b043d2$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).useId) != null ? $52be9c2c83b043d2$var$o : function() {
    let n = (0, $ac6f64b33cbfbccb$export$44ab2b9f2d09b0fa)(), [e, u] = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).useState(n ? ()=>(0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).nextId() : null);
    return (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>{
        e === null && u((0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};



var $eXaQ2 = parcelRequire("eXaQ2");




let $3d1b1474537b27af$var$a = "div";
var $3d1b1474537b27af$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($3d1b1474537b27af$export$617d79dae526d2cf || {});
function $3d1b1474537b27af$var$s(t, o) {
    let { features: n = 1, ...e } = t, d = {
        ref: o,
        "aria-hidden": (n & 2) === 2 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(n & 4) === 4 && (n & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: e,
        slot: {},
        defaultTag: $3d1b1474537b27af$var$a,
        name: "Hidden"
    });
}
let $3d1b1474537b27af$export$8dc98ba7eadeaa56 = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($3d1b1474537b27af$var$s);


function $10bf00f60741bfef$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $358a8b74684f1a60$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $10bf00f60741bfef$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $358a8b74684f1a60$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}




function $13897f2bb70e7945$export$b204af158042fbac(r) {
    return (0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}


let $e55041340c7187e8$var$c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $e55041340c7187e8$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))($e55041340c7187e8$export$807a7eae502106e7 || {}), $e55041340c7187e8$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($e55041340c7187e8$export$abf286375dfa6dbd || {}), $e55041340c7187e8$var$F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($e55041340c7187e8$var$F || {});
function $e55041340c7187e8$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($e55041340c7187e8$var$c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $e55041340c7187e8$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($e55041340c7187e8$export$27112a34f2f8402d || {});
function $e55041340c7187e8$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $13897f2bb70e7945$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $f7bc6ba166fb9018$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($e55041340c7187e8$var$c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($e55041340c7187e8$var$c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $e55041340c7187e8$export$46388676ec35ab85(e) {
    let r = (0, $13897f2bb70e7945$export$b204af158042fbac)(e);
    (0, $358a8b74684f1a60$export$12b26c28a05aa001)().nextFrame(()=>{
        r && !$e55041340c7187e8$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $e55041340c7187e8$export$5fed9cc43865dc7e(e);
    });
}
var $e55041340c7187e8$var$w = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($e55041340c7187e8$var$w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $e55041340c7187e8$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $e55041340c7187e8$var$S = [
    "textarea",
    "input"
].join(",");
function $e55041340c7187e8$var$H(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $e55041340c7187e8$var$S)) != null ? t : !1;
}
function $e55041340c7187e8$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $e55041340c7187e8$export$7fb6c844b485e870(e, r) {
    return $e55041340c7187e8$export$82e1f4f412218a1d($e55041340c7187e8$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $e55041340c7187e8$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? $e55041340c7187e8$export$20305e96f91bf103(e) : e : $e55041340c7187e8$export$433aaa1f216cf32d(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let E = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = r & 32 ? {
        preventScroll: !0
    } : {}, d = 0, a = n.length, u;
    do {
        if (d >= a || d + a <= 0) return 0;
        let s = x + d;
        if (r & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = n[s], u == null || u.focus(p), d += E;
    }while (u !== i.activeElement);
    return r & 6 && $e55041340c7187e8$var$H(u) && u.select(), 2;
}





var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");

function $0037ae9f2b3596fd$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $31f1af853d6a581a$export$86c4283a11f23f95)(r);
    (0, $eXaQ2.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}


var $358f1789b00f7864$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($358f1789b00f7864$export$cacd6541cfeeb6c1 || {});
function $358f1789b00f7864$export$19b797546aece48f() {
    let e = (0, $eXaQ2.useRef)(0);
    return (0, $0037ae9f2b3596fd$export$ee579bb285b8d4aa)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}



var $eXaQ2 = parcelRequire("eXaQ2");

function $439003492602e7a2$export$80c2a3957bcb42ea() {
    let e = (0, $eXaQ2.useRef)(!1);
    return (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}



var $eXaQ2 = parcelRequire("eXaQ2");

function $f19c31415490ad89$export$dd9fbcea3de0ae36(...e) {
    return (0, $eXaQ2.useMemo)(()=>(0, $13897f2bb70e7945$export$b204af158042fbac)(...e), [
        ...e
    ]);
}



var $eXaQ2 = parcelRequire("eXaQ2");

function $675d311c5bcdbbd1$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $31f1af853d6a581a$export$86c4283a11f23f95)(a);
    (0, $eXaQ2.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}




var $eXaQ2 = parcelRequire("eXaQ2");

function $e827283ab691803d$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $eXaQ2.useRef)([]), r = (0, $7be81799544fd475$export$90fc3a17d93f704c)(u);
    (0, $eXaQ2.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}



var $eXaQ2 = parcelRequire("eXaQ2");

function $e0337e24b7d03b84$export$fd183955ff4b45d9() {
    let [e] = (0, $eXaQ2.useState)((0, $358a8b74684f1a60$export$12b26c28a05aa001));
    return (0, $eXaQ2.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}


function $9d12f9992963daa9$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}



var $eXaQ2 = parcelRequire("eXaQ2");


function $fb1c3331912d3ea5$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $7be81799544fd475$export$90fc3a17d93f704c)(t), e = (0, $eXaQ2.useRef)(!1);
    (0, $eXaQ2.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $10bf00f60741bfef$export$a5ff0d6a738703ca)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}


function $a794712f1796e403$var$P(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let r = new Set;
    for (let e of t.current)e.current instanceof HTMLElement && r.add(e.current);
    return r;
}
let $a794712f1796e403$var$J = "div";
var $a794712f1796e403$var$h = ((n)=>(n[n.None = 1] = "None", n[n.InitialFocus = 2] = "InitialFocus", n[n.TabLock = 4] = "TabLock", n[n.FocusLock = 8] = "FocusLock", n[n.RestoreFocus = 16] = "RestoreFocus", n[n.All = 30] = "All", n))($a794712f1796e403$var$h || {});
function $a794712f1796e403$var$X(t, r) {
    let e = (0, $eXaQ2.useRef)(null), o = (0, $49458ecf29eec77d$export$f6a25a78204acc7e)(e, r), { initialFocus: u, containers: i, features: n = 30, ...l } = t;
    (0, $ac6f64b33cbfbccb$export$44ab2b9f2d09b0fa)() || (n = 1);
    let m = (0, $f19c31415490ad89$export$dd9fbcea3de0ae36)(e);
    $a794712f1796e403$var$Y({
        ownerDocument: m
    }, Boolean(n & 16));
    let c = $a794712f1796e403$var$Z({
        ownerDocument: m,
        container: e,
        initialFocus: u
    }, Boolean(n & 2));
    $a794712f1796e403$var$$({
        ownerDocument: m,
        container: e,
        containers: i,
        previousActiveElement: c
    }, Boolean(n & 8));
    let v = (0, $358f1789b00f7864$export$19b797546aece48f)(), y = (0, $7be81799544fd475$export$90fc3a17d93f704c)((s)=>{
        let T = e.current;
        if (!T) return;
        ((B)=>B())(()=>{
            (0, $f7bc6ba166fb9018$export$4659b591c19bdf3d)(v.current, {
                [(0, $358f1789b00f7864$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    (0, $e55041340c7187e8$export$82e1f4f412218a1d)(T, (0, $e55041340c7187e8$export$807a7eae502106e7).First, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                },
                [(0, $358f1789b00f7864$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    (0, $e55041340c7187e8$export$82e1f4f412218a1d)(T, (0, $e55041340c7187e8$export$807a7eae502106e7).Last, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                }
            });
        });
    }), _ = (0, $e0337e24b7d03b84$export$fd183955ff4b45d9)(), b = (0, $eXaQ2.useRef)(!1), j = {
        ref: o,
        onKeyDown (s) {
            s.key == "Tab" && (b.current = !0, _.requestAnimationFrame(()=>{
                b.current = !1;
            }));
        },
        onBlur (s) {
            let T = $a794712f1796e403$var$P(i);
            e.current instanceof HTMLElement && T.add(e.current);
            let d = s.relatedTarget;
            d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && ($a794712f1796e403$var$S(T, d) || (b.current ? (0, $e55041340c7187e8$export$82e1f4f412218a1d)(e.current, (0, $f7bc6ba166fb9018$export$4659b591c19bdf3d)(v.current, {
                [(0, $358f1789b00f7864$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $e55041340c7187e8$export$807a7eae502106e7).Next,
                [(0, $358f1789b00f7864$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $e55041340c7187e8$export$807a7eae502106e7).Previous
            }) | (0, $e55041340c7187e8$export$807a7eae502106e7).WrapAround, {
                relativeTo: s.target
            }) : s.target instanceof HTMLElement && (0, $e55041340c7187e8$export$5fed9cc43865dc7e)(s.target)));
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).Fragment, null, Boolean(n & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $3d1b1474537b27af$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: y,
        features: (0, $3d1b1474537b27af$export$617d79dae526d2cf).Focusable
    }), (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: j,
        theirProps: l,
        defaultTag: $a794712f1796e403$var$J,
        name: "FocusTrap"
    }), Boolean(n & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $3d1b1474537b27af$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: y,
        features: (0, $3d1b1474537b27af$export$617d79dae526d2cf).Focusable
    }));
}
let $a794712f1796e403$var$z = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($a794712f1796e403$var$X), $a794712f1796e403$export$34eba2437817a67b = Object.assign($a794712f1796e403$var$z, {
    features: $a794712f1796e403$var$h
}), $a794712f1796e403$var$a = [];
(0, $9d12f9992963daa9$export$a6a2315df743a26b)(()=>{
    function t(r) {
        r.target instanceof HTMLElement && r.target !== document.body && $a794712f1796e403$var$a[0] !== r.target && ($a794712f1796e403$var$a.unshift(r.target), $a794712f1796e403$var$a = $a794712f1796e403$var$a.filter((e)=>e != null && e.isConnected), $a794712f1796e403$var$a.splice(10));
    }
    window.addEventListener("click", t, {
        capture: !0
    }), window.addEventListener("mousedown", t, {
        capture: !0
    }), window.addEventListener("focus", t, {
        capture: !0
    }), document.body.addEventListener("click", t, {
        capture: !0
    }), document.body.addEventListener("mousedown", t, {
        capture: !0
    }), document.body.addEventListener("focus", t, {
        capture: !0
    });
});
function $a794712f1796e403$var$Q(t = !0) {
    let r = (0, $eXaQ2.useRef)($a794712f1796e403$var$a.slice());
    return (0, $e827283ab691803d$export$3c773aa2b84f29e0)(([e], [o])=>{
        o === !0 && e === !1 && (0, $10bf00f60741bfef$export$a5ff0d6a738703ca)(()=>{
            r.current.splice(0);
        }), o === !1 && e === !0 && (r.current = $a794712f1796e403$var$a.slice());
    }, [
        t,
        $a794712f1796e403$var$a,
        r
    ]), (0, $7be81799544fd475$export$90fc3a17d93f704c)(()=>{
        var e;
        return (e = r.current.find((o)=>o != null && o.isConnected)) != null ? e : null;
    });
}
function $a794712f1796e403$var$Y({ ownerDocument: t }, r) {
    let e = $a794712f1796e403$var$Q(r);
    (0, $e827283ab691803d$export$3c773aa2b84f29e0)(()=>{
        r || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && (0, $e55041340c7187e8$export$5fed9cc43865dc7e)(e());
    }, [
        r
    ]), (0, $fb1c3331912d3ea5$export$cd059ee7fd0e9f3d)(()=>{
        r && (0, $e55041340c7187e8$export$5fed9cc43865dc7e)(e());
    });
}
function $a794712f1796e403$var$Z({ ownerDocument: t, container: r, initialFocus: e }, o) {
    let u = (0, $eXaQ2.useRef)(null), i = (0, $439003492602e7a2$export$80c2a3957bcb42ea)();
    return (0, $e827283ab691803d$export$3c773aa2b84f29e0)(()=>{
        if (!o) return;
        let n = r.current;
        n && (0, $10bf00f60741bfef$export$a5ff0d6a738703ca)(()=>{
            if (!i.current) return;
            let l = t == null ? void 0 : t.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === l) {
                    u.current = l;
                    return;
                }
            } else if (n.contains(l)) {
                u.current = l;
                return;
            }
            e != null && e.current ? (0, $e55041340c7187e8$export$5fed9cc43865dc7e)(e.current) : (0, $e55041340c7187e8$export$82e1f4f412218a1d)(n, (0, $e55041340c7187e8$export$807a7eae502106e7).First) === (0, $e55041340c7187e8$export$abf286375dfa6dbd).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), u.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        o
    ]), u;
}
function $a794712f1796e403$var$$({ ownerDocument: t, container: r, containers: e, previousActiveElement: o }, u) {
    let i = (0, $439003492602e7a2$export$80c2a3957bcb42ea)();
    (0, $675d311c5bcdbbd1$export$7080b3e976bc91ab)(t == null ? void 0 : t.defaultView, "focus", (n)=>{
        if (!u || !i.current) return;
        let l = $a794712f1796e403$var$P(e);
        r.current instanceof HTMLElement && l.add(r.current);
        let m = o.current;
        if (!m) return;
        let c = n.target;
        c && c instanceof HTMLElement ? $a794712f1796e403$var$S(l, c) ? (o.current = c, (0, $e55041340c7187e8$export$5fed9cc43865dc7e)(c)) : (n.preventDefault(), n.stopPropagation(), (0, $e55041340c7187e8$export$5fed9cc43865dc7e)(m)) : (0, $e55041340c7187e8$export$5fed9cc43865dc7e)(o.current);
    }, !0);
}
function $a794712f1796e403$var$S(t, r) {
    for (let e of t)if (e.contains(r)) return !0;
    return !1;
}



var $eXaQ2 = parcelRequire("eXaQ2");

var $80Kwh = parcelRequire("80Kwh");



var $eXaQ2 = parcelRequire("eXaQ2");
let $a96a6036f575b272$var$e = (0, $eXaQ2.createContext)(!1);
function $a96a6036f575b272$export$6ecd3efa4eebe261() {
    return (0, $eXaQ2.useContext)($a96a6036f575b272$var$e);
}
function $a96a6036f575b272$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($a96a6036f575b272$var$e.Provider, {
        value: o.force
    }, o.children);
}








function $f0788102f157383f$var$F(p) {
    let l = (0, $a96a6036f575b272$export$6ecd3efa4eebe261)(), n = (0, $eXaQ2.useContext)($f0788102f157383f$var$v), e = (0, $f19c31415490ad89$export$dd9fbcea3de0ae36)(p), [a, o] = (0, $eXaQ2.useState)(()=>{
        if (!l && n !== null || (0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let r = e.createElement("div");
        return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
    return (0, $eXaQ2.useEffect)(()=>{
        a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
    }, [
        a,
        e
    ]), (0, $eXaQ2.useEffect)(()=>{
        l || n !== null && o(n.current);
    }, [
        n,
        o,
        l
    ]), a;
}
let $f0788102f157383f$var$U = (0, $eXaQ2.Fragment);
function $f0788102f157383f$var$N(p, l) {
    let n = p, e = (0, $eXaQ2.useRef)(null), a = (0, $49458ecf29eec77d$export$f6a25a78204acc7e)((0, $49458ecf29eec77d$export$7029785b750eb74)((u)=>{
        e.current = u;
    }), l), o = (0, $f19c31415490ad89$export$dd9fbcea3de0ae36)(e), t = $f0788102f157383f$var$F(e), [r] = (0, $eXaQ2.useState)(()=>{
        var u;
        return (0, $b86fddc59d9d5f5e$export$a7b6bc01c63cdfc3).isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }), i = (0, $eXaQ2.useContext)($f0788102f157383f$var$f), C = (0, $ac6f64b33cbfbccb$export$44ab2b9f2d09b0fa)();
    return (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>{
        !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
    }, [
        t,
        r
    ]), (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>{
        if (r && i) return i.register(r);
    }, [
        i,
        r
    ]), (0, $fb1c3331912d3ea5$export$cd059ee7fd0e9f3d)(()=>{
        var u;
        !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
    }), C ? !t || !r ? null : (0, $80Kwh.createPortal)((0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a
        },
        theirProps: n,
        defaultTag: $f0788102f157383f$var$U,
        name: "Portal"
    }), r) : null;
}
let $f0788102f157383f$var$S = (0, $eXaQ2.Fragment), $f0788102f157383f$var$v = (0, $eXaQ2.createContext)(null);
function $f0788102f157383f$var$j(p, l) {
    let { target: n, ...e } = p, o = {
        ref: (0, $49458ecf29eec77d$export$f6a25a78204acc7e)(l)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($f0788102f157383f$var$v.Provider, {
        value: n
    }, (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: e,
        defaultTag: $f0788102f157383f$var$S,
        name: "Popover.Group"
    }));
}
let $f0788102f157383f$var$f = (0, $eXaQ2.createContext)(null);
function $f0788102f157383f$export$26b8c35244a70b37() {
    let p = (0, $eXaQ2.useContext)($f0788102f157383f$var$f), l = (0, $eXaQ2.useRef)([]), n = (0, $7be81799544fd475$export$90fc3a17d93f704c)((o)=>(l.current.push(o), p && p.register(o), ()=>e(o))), e = (0, $7be81799544fd475$export$90fc3a17d93f704c)((o)=>{
        let t = l.current.indexOf(o);
        t !== -1 && l.current.splice(t, 1), p && p.unregister(o);
    }), a = (0, $eXaQ2.useMemo)(()=>({
            register: n,
            unregister: e,
            portals: l
        }), [
        n,
        e,
        l
    ]);
    return [
        l,
        (0, $eXaQ2.useMemo)(()=>function({ children: t }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($f0788102f157383f$var$f.Provider, {
                    value: a
                }, t);
            }, [
            a
        ])
    ];
}
let $f0788102f157383f$var$D = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($f0788102f157383f$var$N), $f0788102f157383f$var$I = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($f0788102f157383f$var$j), $f0788102f157383f$export$602eac185826482c = Object.assign($f0788102f157383f$var$D, {
    Group: $f0788102f157383f$var$I
});




var $eXaQ2 = parcelRequire("eXaQ2");





let $ba0921105532c6c7$var$d = (0, $eXaQ2.createContext)(null);
function $ba0921105532c6c7$var$f() {
    let r = (0, $eXaQ2.useContext)($ba0921105532c6c7$var$d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $ba0921105532c6c7$var$f), t;
    }
    return r;
}
function $ba0921105532c6c7$export$babde88292020af7() {
    let [r, t] = (0, $eXaQ2.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $eXaQ2.useMemo)(()=>function(e) {
                let i = (0, $7be81799544fd475$export$90fc3a17d93f704c)((s)=>(t((o)=>[
                            ...o,
                            s
                        ]), ()=>t((o)=>{
                            let p = o.slice(), c = p.indexOf(s);
                            return c !== -1 && p.splice(c, 1), p;
                        }))), n = (0, $eXaQ2.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($ba0921105532c6c7$var$d.Provider, {
                    value: n
                }, e.children);
            }, [
            t
        ])
    ];
}
let $ba0921105532c6c7$var$S = "p";
function $ba0921105532c6c7$var$h(r, t) {
    let a = (0, $52be9c2c83b043d2$export$f680877a34711e37)(), { id: e = `headlessui-description-${a}`, ...i } = r, n = $ba0921105532c6c7$var$f(), s = (0, $49458ecf29eec77d$export$f6a25a78204acc7e)(t);
    (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>n.register(e), [
        e,
        n.register
    ]);
    let o = {
        ref: s,
        ...n.props,
        id: e
    };
    return (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: i,
        slot: n.slot || {},
        defaultTag: $ba0921105532c6c7$var$S,
        name: n.name || "Description"
    });
}
let $ba0921105532c6c7$var$y = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($ba0921105532c6c7$var$h), $ba0921105532c6c7$export$393edc798c47379d = Object.assign($ba0921105532c6c7$var$y, {});



var $eXaQ2 = parcelRequire("eXaQ2");
let $bb96fd71846c729c$var$n = (0, $eXaQ2.createContext)(null);
$bb96fd71846c729c$var$n.displayName = "OpenClosedContext";
var $bb96fd71846c729c$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($bb96fd71846c729c$export$7254cc27399e90bd || {});
function $bb96fd71846c729c$export$fc6fdf0ecf360e() {
    return (0, $eXaQ2.useContext)($bb96fd71846c729c$var$n);
}
function $bb96fd71846c729c$export$2a0ed818b175f558({ value: o, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($bb96fd71846c729c$var$n.Provider, {
        value: o
    }, r);
}




var $eXaQ2 = parcelRequire("eXaQ2");


let $55e58938447ca419$var$a = (0, $eXaQ2.createContext)(()=>{});
$55e58938447ca419$var$a.displayName = "StackContext";
var $55e58938447ca419$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($55e58938447ca419$export$2dd25ef07fea092e || {});
function $55e58938447ca419$export$59510f5936c4d8c4() {
    return (0, $eXaQ2.useContext)($55e58938447ca419$var$a);
}
function $55e58938447ca419$export$4aac1a6640027f56({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = $55e58938447ca419$export$59510f5936c4d8c4(), o = (0, $7be81799544fd475$export$90fc3a17d93f704c)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($55e58938447ca419$var$a.Provider, {
        value: o
    }, i);
}



var $eXaQ2 = parcelRequire("eXaQ2");


var $eXaQ2 = parcelRequire("eXaQ2");

function $6353bf28e4da2f0e$export$55d2b5df396a097b(e, r, n) {
    let o = (0, $31f1af853d6a581a$export$86c4283a11f23f95)(r);
    (0, $eXaQ2.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}



function $83ed4e5ad2b9ff75$export$71b2224f1ce5e08e(s, m, a = !0) {
    let i = (0, $eXaQ2.useRef)(!1);
    (0, $eXaQ2.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = a;
        });
    }, [
        a
    ]);
    function c(e, r) {
        if (!i.current || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
        let E = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(s);
        for (let u of E){
            if (u === null) continue;
            let n = u instanceof HTMLElement ? u : u.current;
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, $e55041340c7187e8$export$ff1ec1c740b3c8d5)(t, (0, $e55041340c7187e8$export$27112a34f2f8402d).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let o = (0, $eXaQ2.useRef)(null);
    (0, $6353bf28e4da2f0e$export$55d2b5df396a097b)("pointerdown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $6353bf28e4da2f0e$export$55d2b5df396a097b)("mousedown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $6353bf28e4da2f0e$export$55d2b5df396a097b)("click", (e)=>{
        o.current && (c(e, ()=>o.current), o.current = null);
    }, !0), (0, $6353bf28e4da2f0e$export$55d2b5df396a097b)("touchend", (e)=>c(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, $0037ae9f2b3596fd$export$ee579bb285b8d4aa)("blur", (e)=>c(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}







var $eXaQ2 = parcelRequire("eXaQ2");

var $eXaQ2 = parcelRequire("eXaQ2");
function $ebae910f9a018d22$var$i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const $ebae910f9a018d22$var$d = typeof Object.is == "function" ? Object.is : $ebae910f9a018d22$var$i, { useState: $ebae910f9a018d22$var$u, useEffect: $ebae910f9a018d22$var$h, useLayoutEffect: $ebae910f9a018d22$var$f, useDebugValue: $ebae910f9a018d22$var$p } = $eXaQ2;
let $ebae910f9a018d22$var$S = !1, $ebae910f9a018d22$var$_ = !1;
function $ebae910f9a018d22$export$306c0aa65ff9ec16(e, t, c) {
    const a = t(), [{ inst: n }, o] = $ebae910f9a018d22$var$u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return $ebae910f9a018d22$var$f(()=>{
        n.value = a, n.getSnapshot = t, $ebae910f9a018d22$var$r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), $ebae910f9a018d22$var$h(()=>($ebae910f9a018d22$var$r(n) && o({
            inst: n
        }), e(()=>{
            $ebae910f9a018d22$var$r(n) && o({
                inst: n
            });
        })), [
        e
    ]), $ebae910f9a018d22$var$p(a), a;
}
function $ebae910f9a018d22$var$r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !$ebae910f9a018d22$var$d(c, a);
    } catch  {
        return !0;
    }
}


function $4f0374e84f74f524$export$306c0aa65ff9ec16(r, e, n) {
    return e();
}


const $4c2d6374f974a347$var$r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", $4c2d6374f974a347$var$s = !$4c2d6374f974a347$var$r, $4c2d6374f974a347$var$c = $4c2d6374f974a347$var$s ? (0, $4f0374e84f74f524$export$306c0aa65ff9ec16) : (0, $ebae910f9a018d22$export$306c0aa65ff9ec16), $4c2d6374f974a347$export$306c0aa65ff9ec16 = "useSyncExternalStore" in $eXaQ2 ? ((n)=>n.useSyncExternalStore)($eXaQ2) : $4c2d6374f974a347$var$c;


function $2ead1171bf06c610$export$6ccbb43953eebf8(t) {
    return (0, $4c2d6374f974a347$export$306c0aa65ff9ec16)(t.subscribe, t.getSnapshot, t.getSnapshot);
}



function $e4b0002037643d70$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}


function $dd8d48f16d4cacd5$export$110627fb35ef9205() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}


function $984d309d811fdca2$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $984d309d811fdca2$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $984d309d811fdca2$export$d0a8044dce8ff2fc() {
    return $984d309d811fdca2$export$fedb369cb70207f1() || $984d309d811fdca2$export$a11b0059900ceec8();
}


function $ab15032e19aee7c2$export$e3a523dfabf27286() {
    if (!(0, $984d309d811fdca2$export$fedb369cb70207f1)()) return {};
    let o;
    return {
        before () {
            o = window.pageYOffset;
        },
        after ({ doc: r, d: l, meta: s }) {
            function i(e) {
                return s.containers.flatMap((t)=>t()).some((t)=>t.contains(e));
            }
            l.style(r.body, "marginTop", `-${o}px`), window.scrollTo(0, 0);
            let n = null;
            l.addEventListener(r, "click", (e)=>{
                if (e.target instanceof HTMLElement) try {
                    let t = e.target.closest("a");
                    if (!t) return;
                    let { hash: c } = new URL(t.href), a = r.querySelector(c);
                    a && !i(a) && (n = a);
                } catch  {}
            }, !0), l.addEventListener(r, "touchmove", (e)=>{
                e.target instanceof HTMLElement && !i(e.target) && e.preventDefault();
            }, {
                passive: !1
            }), l.add(()=>{
                window.scrollTo(0, window.pageYOffset + o), n && n.isConnected && (n.scrollIntoView({
                    block: "nearest"
                }), n = null);
            });
        }
    };
}


function $ce7ec64f85cf1f42$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $a456e7f73ed11c6a$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $a456e7f73ed11c6a$export$a4161f418919b5aa = (0, $e4b0002037643d70$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $358a8b74684f1a60$export$12b26c28a05aa001)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $a456e7f73ed11c6a$var$m(t)
        }, c = [
            (0, $ab15032e19aee7c2$export$e3a523dfabf27286)(),
            (0, $dd8d48f16d4cacd5$export$110627fb35ef9205)(),
            (0, $ce7ec64f85cf1f42$export$d8b6ff28805e84e9)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$a456e7f73ed11c6a$export$a4161f418919b5aa.subscribe(()=>{
    let e = $a456e7f73ed11c6a$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $a456e7f73ed11c6a$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $a456e7f73ed11c6a$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $9f677b51e8c6df39$export$bb0ae4a42bcd9e0(e, r, n) {
    let f = (0, $2ead1171bf06c610$export$6ccbb43953eebf8)((0, $a456e7f73ed11c6a$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $a456e7f73ed11c6a$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $a456e7f73ed11c6a$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}



let $3fed96e59d495f89$var$u = new Map, $3fed96e59d495f89$var$t = new Map;
function $3fed96e59d495f89$export$bbe4e2927a3450da(r, l = !0) {
    (0, $ef967070258a0d27$export$ce5ed857c741fd71)(()=>{
        var o;
        if (!l) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function a() {
            var d;
            if (!e) return;
            let i = (d = $3fed96e59d495f89$var$t.get(e)) != null ? d : 1;
            if (i === 1 ? $3fed96e59d495f89$var$t.delete(e) : $3fed96e59d495f89$var$t.set(e, i - 1), i !== 1) return;
            let n = $3fed96e59d495f89$var$u.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, $3fed96e59d495f89$var$u.delete(e));
        }
        let f = (o = $3fed96e59d495f89$var$t.get(e)) != null ? o : 0;
        return $3fed96e59d495f89$var$t.set(e, f + 1), f !== 0 || ($3fed96e59d495f89$var$u.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
    }, [
        r,
        l
    ]);
}



var $eXaQ2 = parcelRequire("eXaQ2");



function $68d02a3e88db4eac$export$445f2d1a3d9b1b9f({ defaultContainers: f = [], portals: o } = {}) {
    let t = (0, $eXaQ2.useRef)(null), i = (0, $f19c31415490ad89$export$dd9fbcea3de0ae36)(t), u = (0, $7be81799544fd475$export$90fc3a17d93f704c)(()=>{
        var r;
        let n = [];
        for (let e of f)e !== null && (e instanceof HTMLElement ? n.push(e) : "current" in e && e.current instanceof HTMLElement && n.push(e.current));
        if (o != null && o.current) for (let e of o.current)n.push(e);
        for (let e of (r = i == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? r : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || n.some((c)=>e.contains(c)) || n.push(e));
        return n;
    });
    return {
        resolveContainers: u,
        contains: (0, $7be81799544fd475$export$90fc3a17d93f704c)((n)=>u().some((r)=>r.contains(n))),
        mainTreeNodeRef: t,
        MainTreeNode: (0, $eXaQ2.useMemo)(()=>function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $3d1b1474537b27af$export$8dc98ba7eadeaa56), {
                    features: (0, $3d1b1474537b27af$export$617d79dae526d2cf).Hidden,
                    ref: t
                });
            }, [
            t
        ])
    };
}


var $929e4da6068570b0$var$_e = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($929e4da6068570b0$var$_e || {}), $929e4da6068570b0$var$Ie = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($929e4da6068570b0$var$Ie || {});
let $929e4da6068570b0$var$Me = {
    [0] (t, e) {
        return t.titleId === e.id ? t : {
            ...t,
            titleId: e.id
        };
    }
}, $929e4da6068570b0$var$I = (0, $eXaQ2.createContext)(null);
$929e4da6068570b0$var$I.displayName = "DialogContext";
function $929e4da6068570b0$var$b(t) {
    let e = (0, $eXaQ2.useContext)($929e4da6068570b0$var$I);
    if (e === null) {
        let o = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $929e4da6068570b0$var$b), o;
    }
    return e;
}
function $929e4da6068570b0$var$we(t, e, o = ()=>[
        document.body
    ]) {
    (0, $9f677b51e8c6df39$export$bb0ae4a42bcd9e0)(t, e, (i)=>{
        var n;
        return {
            containers: [
                ...(n = i.containers) != null ? n : [],
                o
            ]
        };
    });
}
function $929e4da6068570b0$var$Be(t, e) {
    return (0, $f7bc6ba166fb9018$export$4659b591c19bdf3d)(e.type, $929e4da6068570b0$var$Me, t, e);
}
let $929e4da6068570b0$var$He = "div", $929e4da6068570b0$var$Ge = (0, $5d4205bcd60f27f1$export$617d79dae526d2cf).RenderStrategy | (0, $5d4205bcd60f27f1$export$617d79dae526d2cf).Static;
function $929e4da6068570b0$var$Ne(t, e) {
    var X;
    let o = (0, $52be9c2c83b043d2$export$f680877a34711e37)(), { id: i = `headlessui-dialog-${o}`, open: n, onClose: l, initialFocus: s, __demoMode: g = !1, ...T } = t, [m, h] = (0, $eXaQ2.useState)(0), a = (0, $bb96fd71846c729c$export$fc6fdf0ecf360e)();
    n === void 0 && a !== null && (n = (a & (0, $bb96fd71846c729c$export$7254cc27399e90bd).Open) === (0, $bb96fd71846c729c$export$7254cc27399e90bd).Open);
    let D = (0, $eXaQ2.useRef)(null), Q = (0, $49458ecf29eec77d$export$f6a25a78204acc7e)(D, e), f = (0, $f19c31415490ad89$export$dd9fbcea3de0ae36)(D), N = t.hasOwnProperty("open") || a !== null, U = t.hasOwnProperty("onClose");
    if (!N && !U) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!N) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!U) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let p = n ? 0 : 1, [S, Z] = (0, $eXaQ2.useReducer)($929e4da6068570b0$var$Be, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $eXaQ2.createRef)()
    }), P = (0, $7be81799544fd475$export$90fc3a17d93f704c)(()=>l(!1)), W = (0, $7be81799544fd475$export$90fc3a17d93f704c)((r)=>Z({
            type: 0,
            id: r
        })), L = (0, $ac6f64b33cbfbccb$export$44ab2b9f2d09b0fa)() ? g ? !1 : p === 0 : !1, F = m > 1, Y = (0, $eXaQ2.useContext)($929e4da6068570b0$var$I) !== null, [ee, te] = (0, $f0788102f157383f$export$26b8c35244a70b37)(), { resolveContainers: M, mainTreeNodeRef: k, MainTreeNode: oe } = (0, $68d02a3e88db4eac$export$445f2d1a3d9b1b9f)({
        portals: ee,
        defaultContainers: [
            (X = S.panelRef.current) != null ? X : D.current
        ]
    }), re = F ? "parent" : "leaf", $ = a !== null ? (a & (0, $bb96fd71846c729c$export$7254cc27399e90bd).Closing) === (0, $bb96fd71846c729c$export$7254cc27399e90bd).Closing : !1, ne = (()=>Y || $ ? !1 : L)(), le = (0, $eXaQ2.useCallback)(()=>{
        var r, c;
        return (c = Array.from((r = f == null ? void 0 : f.querySelectorAll("body > *")) != null ? r : []).find((d)=>d.id === "headlessui-portal-root" ? !1 : d.contains(k.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        k
    ]);
    (0, $3fed96e59d495f89$export$bbe4e2927a3450da)(le, ne);
    let ae = (()=>F ? !0 : L)(), ie = (0, $eXaQ2.useCallback)(()=>{
        var r, c;
        return (c = Array.from((r = f == null ? void 0 : f.querySelectorAll("[data-headlessui-portal]")) != null ? r : []).find((d)=>d.contains(k.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        k
    ]);
    (0, $3fed96e59d495f89$export$bbe4e2927a3450da)(ie, ae);
    let se = (()=>!(!L || F))();
    (0, $83ed4e5ad2b9ff75$export$71b2224f1ce5e08e)(M, P, se);
    let pe = (()=>!(F || p !== 0))();
    (0, $675d311c5bcdbbd1$export$7080b3e976bc91ab)(f == null ? void 0 : f.defaultView, "keydown", (r)=>{
        pe && (r.defaultPrevented || r.key === (0, $e1fa4e8f87f38de0$export$4b0075e5ea5e1f26).Escape && (r.preventDefault(), r.stopPropagation(), P()));
    });
    let de = (()=>!($ || p !== 0 || Y))();
    $929e4da6068570b0$var$we(f, de, M), (0, $eXaQ2.useEffect)(()=>{
        if (p !== 0 || !D.current) return;
        let r = new ResizeObserver((c)=>{
            for (let d of c){
                let x = d.target.getBoundingClientRect();
                x.x === 0 && x.y === 0 && x.width === 0 && x.height === 0 && P();
            }
        });
        return r.observe(D.current), ()=>r.disconnect();
    }, [
        p,
        D,
        P
    ]);
    let [ue, fe] = (0, $ba0921105532c6c7$export$babde88292020af7)(), ge = (0, $eXaQ2.useMemo)(()=>[
            {
                dialogState: p,
                close: P,
                setTitleId: W
            },
            S
        ], [
        p,
        S,
        P,
        W
    ]), J = (0, $eXaQ2.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), Te = {
        ref: Q,
        id: i,
        role: "dialog",
        "aria-modal": p === 0 ? !0 : void 0,
        "aria-labelledby": S.titleId,
        "aria-describedby": ue
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $55e58938447ca419$export$4aac1a6640027f56), {
        type: "Dialog",
        enabled: p === 0,
        element: D,
        onUpdate: (0, $7be81799544fd475$export$90fc3a17d93f704c)((r, c)=>{
            c === "Dialog" && (0, $f7bc6ba166fb9018$export$4659b591c19bdf3d)(r, {
                [(0, $55e58938447ca419$export$2dd25ef07fea092e).Add]: ()=>h((d)=>d + 1),
                [(0, $55e58938447ca419$export$2dd25ef07fea092e).Remove]: ()=>h((d)=>d - 1)
            });
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $a96a6036f575b272$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $f0788102f157383f$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($929e4da6068570b0$var$I.Provider, {
        value: ge
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $f0788102f157383f$export$602eac185826482c).Group, {
        target: D
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $a96a6036f575b272$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement(fe, {
        slot: J,
        name: "Dialog.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $a794712f1796e403$export$34eba2437817a67b), {
        initialFocus: s,
        containers: M,
        features: L ? (0, $f7bc6ba166fb9018$export$4659b591c19bdf3d)(re, {
            parent: (0, $a794712f1796e403$export$34eba2437817a67b).features.RestoreFocus,
            leaf: (0, $a794712f1796e403$export$34eba2437817a67b).features.All & ~(0, $a794712f1796e403$export$34eba2437817a67b).features.FocusLock
        }) : (0, $a794712f1796e403$export$34eba2437817a67b).features.None
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement(te, null, (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: Te,
        theirProps: T,
        slot: J,
        defaultTag: $929e4da6068570b0$var$He,
        features: $929e4da6068570b0$var$Ge,
        visible: p === 0,
        name: "Dialog"
    }))))))))), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement(oe, null));
}
let $929e4da6068570b0$var$Ue = "div";
function $929e4da6068570b0$var$We(t, e) {
    let o = (0, $52be9c2c83b043d2$export$f680877a34711e37)(), { id: i = `headlessui-dialog-overlay-${o}`, ...n } = t, [{ dialogState: l, close: s }] = $929e4da6068570b0$var$b("Dialog.Overlay"), g = (0, $49458ecf29eec77d$export$f6a25a78204acc7e)(e), T = (0, $7be81799544fd475$export$90fc3a17d93f704c)((a)=>{
        if (a.target === a.currentTarget) {
            if ((0, $3fd2a67fca6494ad$export$db61f031a278447c)(a.currentTarget)) return a.preventDefault();
            a.preventDefault(), a.stopPropagation(), s();
        }
    }), m = (0, $eXaQ2.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: g,
            id: i,
            "aria-hidden": !0,
            onClick: T
        },
        theirProps: n,
        slot: m,
        defaultTag: $929e4da6068570b0$var$Ue,
        name: "Dialog.Overlay"
    });
}
let $929e4da6068570b0$var$Ye = "div";
function $929e4da6068570b0$var$$e(t, e) {
    let o = (0, $52be9c2c83b043d2$export$f680877a34711e37)(), { id: i = `headlessui-dialog-backdrop-${o}`, ...n } = t, [{ dialogState: l }, s] = $929e4da6068570b0$var$b("Dialog.Backdrop"), g = (0, $49458ecf29eec77d$export$f6a25a78204acc7e)(e);
    (0, $eXaQ2.useEffect)(()=>{
        if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        s.panelRef
    ]);
    let T = (0, $eXaQ2.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $a96a6036f575b272$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $f0788102f157383f$export$602eac185826482c), null, (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: g,
            id: i,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: T,
        defaultTag: $929e4da6068570b0$var$Ye,
        name: "Dialog.Backdrop"
    })));
}
let $929e4da6068570b0$var$Je = "div";
function $929e4da6068570b0$var$Xe(t, e) {
    let o = (0, $52be9c2c83b043d2$export$f680877a34711e37)(), { id: i = `headlessui-dialog-panel-${o}`, ...n } = t, [{ dialogState: l }, s] = $929e4da6068570b0$var$b("Dialog.Panel"), g = (0, $49458ecf29eec77d$export$f6a25a78204acc7e)(e, s.panelRef), T = (0, $eXaQ2.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), m = (0, $7be81799544fd475$export$90fc3a17d93f704c)((a)=>{
        a.stopPropagation();
    });
    return (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: g,
            id: i,
            onClick: m
        },
        theirProps: n,
        slot: T,
        defaultTag: $929e4da6068570b0$var$Je,
        name: "Dialog.Panel"
    });
}
let $929e4da6068570b0$var$je = "h2";
function $929e4da6068570b0$var$Ke(t, e) {
    let o = (0, $52be9c2c83b043d2$export$f680877a34711e37)(), { id: i = `headlessui-dialog-title-${o}`, ...n } = t, [{ dialogState: l, setTitleId: s }] = $929e4da6068570b0$var$b("Dialog.Title"), g = (0, $49458ecf29eec77d$export$f6a25a78204acc7e)(e);
    (0, $eXaQ2.useEffect)(()=>(s(i), ()=>s(null)), [
        i,
        s
    ]);
    let T = (0, $eXaQ2.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $5d4205bcd60f27f1$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: g,
            id: i
        },
        theirProps: n,
        slot: T,
        defaultTag: $929e4da6068570b0$var$je,
        name: "Dialog.Title"
    });
}
let $929e4da6068570b0$var$Ve = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($929e4da6068570b0$var$Ne), $929e4da6068570b0$var$qe = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($929e4da6068570b0$var$$e), $929e4da6068570b0$var$ze = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($929e4da6068570b0$var$Xe), $929e4da6068570b0$var$Qe = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($929e4da6068570b0$var$We), $929e4da6068570b0$var$Ze = (0, $5d4205bcd60f27f1$export$e43f39796049410c)($929e4da6068570b0$var$Ke), $929e4da6068570b0$export$3ddf2d174ce01153 = Object.assign($929e4da6068570b0$var$Ve, {
    Backdrop: $929e4da6068570b0$var$qe,
    Panel: $929e4da6068570b0$var$ze,
    Overlay: $929e4da6068570b0$var$Qe,
    Title: $929e4da6068570b0$var$Ze,
    Description: (0, $ba0921105532c6c7$export$393edc798c47379d)
});



var $eXaQ2 = parcelRequire("eXaQ2");
function $48424eb92acda2f2$var$ChevronLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $eXaQ2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $eXaQ2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $eXaQ2.createElement("path", {
        fillRule: "evenodd",
        d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
        clipRule: "evenodd"
    }));
}
const $48424eb92acda2f2$var$ForwardRef = $eXaQ2.forwardRef($48424eb92acda2f2$var$ChevronLeftIcon);
var $48424eb92acda2f2$export$2e2bcd8739ae039 = $48424eb92acda2f2$var$ForwardRef;



var $eXaQ2 = parcelRequire("eXaQ2");
function $8ab4152c85822e31$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $eXaQ2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $eXaQ2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $eXaQ2.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $8ab4152c85822e31$var$ForwardRef = $eXaQ2.forwardRef($8ab4152c85822e31$var$Bars3Icon);
var $8ab4152c85822e31$export$2e2bcd8739ae039 = $8ab4152c85822e31$var$ForwardRef;


var $eXaQ2 = parcelRequire("eXaQ2");
function $de228018d8a12a5f$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $eXaQ2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $eXaQ2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $eXaQ2.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18L18 6M6 6l12 12"
    }));
}
const $de228018d8a12a5f$var$ForwardRef = $eXaQ2.forwardRef($de228018d8a12a5f$var$XMarkIcon);
var $de228018d8a12a5f$export$2e2bcd8739ae039 = $de228018d8a12a5f$var$ForwardRef;





/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $a64bf2737d1fce7c$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}


function $efd124c0c5db56c0$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}


const $11f46ffe43ae20f0$var$LineRegExp = /\r\n|[\n\r]/g;
function $11f46ffe43ae20f0$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($11f46ffe43ae20f0$var$LineRegExp)){
        typeof match.index === "number" || (0, $efd124c0c5db56c0$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $94c338777984db43$export$96a9681e539deed(location) {
    return $94c338777984db43$export$867940333fd9f869(location.source, (0, $11f46ffe43ae20f0$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $94c338777984db43$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $94c338777984db43$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $94c338777984db43$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $94c338777984db43$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}


function $bb2b5d74360644a2$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $bb2b5d74360644a2$export$92d6ed0888e7cb7f extends Error {
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $94c338777984db43$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $94c338777984db43$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $bb2b5d74360644a2$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $bb2b5d74360644a2$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $bb2b5d74360644a2$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $11f46ffe43ae20f0$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $11f46ffe43ae20f0$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $a64bf2737d1fce7c$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $bb2b5d74360644a2$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
}
function $bb2b5d74360644a2$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $bb2b5d74360644a2$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $bb2b5d74360644a2$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $6e62dbcae396b7bc$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $bb2b5d74360644a2$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}



/**
 * The set of allowed directive location values.
 */ var $f66ea10ea342ca0d$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($f66ea10ea342ca0d$export$b45ffd2948484c41 || ($f66ea10ea342ca0d$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 






/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $5f6be201d30989ad$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($5f6be201d30989ad$export$8b9d26ab11394711 || ($5f6be201d30989ad$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $07d7522274d20ac2$export$6168dc8908a6c652 {
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $5f6be201d30989ad$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $07d7522274d20ac2$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $71999aa847a84d89$export$50792b0e93539fde)((0, $5f6be201d30989ad$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
}
function $07d7522274d20ac2$export$59ac0f4da287406a(kind) {
    return kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).BANG || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).DOLLAR || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).AMP || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_L || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_R || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).SPREAD || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).EQUALS || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).AT || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_L || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_R || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).PIPE || kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $07d7522274d20ac2$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $07d7522274d20ac2$var$isSupplementaryCodePoint(body, location) {
    return $07d7522274d20ac2$var$isLeadingSurrogate(body.charCodeAt(location)) && $07d7522274d20ac2$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $07d7522274d20ac2$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $07d7522274d20ac2$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $07d7522274d20ac2$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $5f6be201d30989ad$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $07d7522274d20ac2$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $71999aa847a84d89$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $07d7522274d20ac2$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $07d7522274d20ac2$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $07d7522274d20ac2$var$readBlockString(lexer, position);
                return $07d7522274d20ac2$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $ffbef1569f292b56$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $07d7522274d20ac2$var$readNumber(lexer, position, code);
         // Name
        if ((0, $ffbef1569f292b56$export$45a677ea7cb6d5c8)(code)) return $07d7522274d20ac2$var$readName(lexer, position);
        throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $07d7522274d20ac2$var$isUnicodeScalarValue(code) || $07d7522274d20ac2$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$07d7522274d20ac2$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$07d7522274d20ac2$var$printCodePointAt(lexer, position)}.`);
    }
    return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $07d7522274d20ac2$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($07d7522274d20ac2$var$isUnicodeScalarValue(code)) ++position;
        else if ($07d7522274d20ac2$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $07d7522274d20ac2$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $ffbef1569f292b56$export$727d9dbc4fbb948f)(code)) throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$07d7522274d20ac2$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $07d7522274d20ac2$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $07d7522274d20ac2$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $07d7522274d20ac2$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $ffbef1569f292b56$export$45a677ea7cb6d5c8)(code)) throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$07d7522274d20ac2$var$printCodePointAt(lexer, position)}.`);
    return $07d7522274d20ac2$var$createToken(lexer, isFloat ? (0, $5f6be201d30989ad$export$8b9d26ab11394711).FLOAT : (0, $5f6be201d30989ad$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $07d7522274d20ac2$var$readDigits(lexer, start, firstCode) {
    if (!(0, $ffbef1569f292b56$export$727d9dbc4fbb948f)(firstCode)) throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$07d7522274d20ac2$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $ffbef1569f292b56$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $07d7522274d20ac2$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $07d7522274d20ac2$var$readEscapedUnicodeVariableWidth(lexer, position) : $07d7522274d20ac2$var$readEscapedUnicodeFixedWidth(lexer, position) : $07d7522274d20ac2$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($07d7522274d20ac2$var$isUnicodeScalarValue(code)) ++position;
        else if ($07d7522274d20ac2$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$07d7522274d20ac2$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $07d7522274d20ac2$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$07d7522274d20ac2$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $07d7522274d20ac2$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $07d7522274d20ac2$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $07d7522274d20ac2$var$read16BitHexCode(body, position + 2);
    if ($07d7522274d20ac2$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($07d7522274d20ac2$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $07d7522274d20ac2$var$read16BitHexCode(body, position + 8);
            if ($07d7522274d20ac2$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $07d7522274d20ac2$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $07d7522274d20ac2$var$readHexDigit(body.charCodeAt(position)) << 12 | $07d7522274d20ac2$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $07d7522274d20ac2$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $07d7522274d20ac2$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $07d7522274d20ac2$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $07d7522274d20ac2$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $07d7522274d20ac2$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $caa811299716c7dd$export$d5ee19b441e8d2ae)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($07d7522274d20ac2$var$isUnicodeScalarValue(code)) ++position;
        else if ($07d7522274d20ac2$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$07d7522274d20ac2$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $07d7522274d20ac2$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $ffbef1569f292b56$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $07d7522274d20ac2$var$createToken(lexer, (0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}





const $a1afa4546093424e$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $484bc9abac08b289$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $b640b4d7dbf3c096$export$1d2df86270c81ecb {
    get [Symbol.toStringTag]() {
        return "Source";
    }
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $be5cbb698bc72cab$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $484bc9abac08b289$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $be5cbb698bc72cab$export$b6cb5906f04696c8)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $be5cbb698bc72cab$export$b6cb5906f04696c8)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
}
function $b640b4d7dbf3c096$export$75135ee9ed6e435b(source) {
    return (0, $a1afa4546093424e$export$ca03416d6c9e029e)(source, $b640b4d7dbf3c096$export$1d2df86270c81ecb);
}



function $e4eff5da7e1b5143$export$98e6a39c04603d36(source, options) {
    const parser = new $e4eff5da7e1b5143$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $e4eff5da7e1b5143$export$5303528d1070ff6f(source, options) {
    const parser = new $e4eff5da7e1b5143$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).EOF);
    return value;
}
function $e4eff5da7e1b5143$export$e14c466bd0916f7a(source, options) {
    const parser = new $e4eff5da7e1b5143$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).EOF);
    return value;
}
function $e4eff5da7e1b5143$export$28b8f402ccc88182(source, options) {
    const parser = new $e4eff5da7e1b5143$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).EOF);
    return type;
}
class $e4eff5da7e1b5143$export$7acfa6ed01010e37 {
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $5f6be201d30989ad$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $5f6be201d30989ad$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $71999aa847a84d89$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $71999aa847a84d89$export$f58c50edb4aef9d4).QUERY;
            case "mutation":
                return (0, $71999aa847a84d89$export$f58c50edb4aef9d4).MUTATION;
            case "subscription":
                return (0, $71999aa847a84d89$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_L, item, (0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $5f6be201d30989ad$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $5f6be201d30989ad$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $5f6be201d30989ad$export$8b9d26ab11394711).STRING:
            case (0, $5f6be201d30989ad$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $5f6be201d30989ad$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).LIST,
            values: this.any((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_L, item, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L, item, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).STRING) || this.peek((0, $5f6be201d30989ad$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $5f6be201d30989ad$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$e4eff5da7e1b5143$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $5f6be201d30989ad$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $5f6be201d30989ad$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $497daa5850a219ed$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $5f6be201d30989ad$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $f66ea10ea342ca0d$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $71999aa847a84d89$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$e4eff5da7e1b5143$var$getTokenKindDesc(kind)}, found ${$e4eff5da7e1b5143$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$e4eff5da7e1b5143$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $5f6be201d30989ad$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$e4eff5da7e1b5143$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $5f6be201d30989ad$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $6e62dbcae396b7bc$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
    constructor(source, options = {}){
        const sourceObj = (0, $b640b4d7dbf3c096$export$75135ee9ed6e435b)(source) ? source : new (0, $b640b4d7dbf3c096$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $07d7522274d20ac2$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $e4eff5da7e1b5143$var$getTokenDesc(token) {
    const value = token.value;
    return $e4eff5da7e1b5143$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $e4eff5da7e1b5143$var$getTokenKindDesc(kind) {
    return (0, $07d7522274d20ac2$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


var $fd0c0e1ba95e1f7a$var$docCache = new Map();
var $fd0c0e1ba95e1f7a$var$fragmentSourceMap = new Map();
var $fd0c0e1ba95e1f7a$var$printFragmentWarnings = true;
var $fd0c0e1ba95e1f7a$var$experimentalFragmentVariables = false;
function $fd0c0e1ba95e1f7a$var$normalize(string) {
    return string.replace(/[\s,]+/g, " ").trim();
}
function $fd0c0e1ba95e1f7a$var$cacheKeyFromLoc(loc) {
    return $fd0c0e1ba95e1f7a$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $fd0c0e1ba95e1f7a$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === "FragmentDefinition") {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $fd0c0e1ba95e1f7a$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $fd0c0e1ba95e1f7a$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($fd0c0e1ba95e1f7a$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $fd0c0e1ba95e1f7a$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $e86a7d058696b512$export$18ce0697a983be9b)((0, $e86a7d058696b512$export$18ce0697a983be9b)({}, ast), {
        definitions: definitions
    });
}
function $fd0c0e1ba95e1f7a$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === "object") workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $fd0c0e1ba95e1f7a$var$parseDocument(source) {
    var cacheKey = $fd0c0e1ba95e1f7a$var$normalize(source);
    if (!$fd0c0e1ba95e1f7a$var$docCache.has(cacheKey)) {
        var parsed = (0, $e4eff5da7e1b5143$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $fd0c0e1ba95e1f7a$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $fd0c0e1ba95e1f7a$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== "Document") throw new Error("Not a valid GraphQL document.");
        $fd0c0e1ba95e1f7a$var$docCache.set(cacheKey, $fd0c0e1ba95e1f7a$var$stripLoc($fd0c0e1ba95e1f7a$var$processFragments(parsed)));
    }
    return $fd0c0e1ba95e1f7a$var$docCache.get(cacheKey);
}
function $fd0c0e1ba95e1f7a$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === "string") literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === "Document") result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $fd0c0e1ba95e1f7a$var$parseDocument(result);
}
function $fd0c0e1ba95e1f7a$export$657554ef4dc7ac2d() {
    $fd0c0e1ba95e1f7a$var$docCache.clear();
    $fd0c0e1ba95e1f7a$var$fragmentSourceMap.clear();
}
function $fd0c0e1ba95e1f7a$export$e4294e638636c6ab() {
    $fd0c0e1ba95e1f7a$var$printFragmentWarnings = false;
}
function $fd0c0e1ba95e1f7a$export$78cf889af350c840() {
    $fd0c0e1ba95e1f7a$var$experimentalFragmentVariables = true;
}
function $fd0c0e1ba95e1f7a$export$5290df9bbbd3cfa() {
    $fd0c0e1ba95e1f7a$var$experimentalFragmentVariables = false;
}
var $fd0c0e1ba95e1f7a$var$extras = {
    gql: $fd0c0e1ba95e1f7a$export$72e4926bf8358653,
    resetCaches: $fd0c0e1ba95e1f7a$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $fd0c0e1ba95e1f7a$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $fd0c0e1ba95e1f7a$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $fd0c0e1ba95e1f7a$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $fd0c0e1ba95e1f7a$var$extras.gql, gql_1.resetCaches = $fd0c0e1ba95e1f7a$var$extras.resetCaches, gql_1.disableFragmentWarnings = $fd0c0e1ba95e1f7a$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $fd0c0e1ba95e1f7a$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $fd0c0e1ba95e1f7a$var$extras.disableExperimentalFragmentVariables;
})($fd0c0e1ba95e1f7a$export$72e4926bf8358653 || ($fd0c0e1ba95e1f7a$export$72e4926bf8358653 = {}));
$fd0c0e1ba95e1f7a$export$72e4926bf8358653["default"] = $fd0c0e1ba95e1f7a$export$72e4926bf8358653;
var $fd0c0e1ba95e1f7a$export$2e2bcd8739ae039 = $fd0c0e1ba95e1f7a$export$72e4926bf8358653;


let $a5cf1c5d3684f0e3$var$_ = (t)=>t, $a5cf1c5d3684f0e3$var$t;
const $a5cf1c5d3684f0e3$var$NAVIGATION = (0, $fd0c0e1ba95e1f7a$export$72e4926bf8358653)($a5cf1c5d3684f0e3$var$t || ($a5cf1c5d3684f0e3$var$t = $a5cf1c5d3684f0e3$var$_`
  query {
    global {
      data {
        attributes {
          navigation {
            links {
              label
              category {
                data {
                  id
                  attributes {
                    href
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`));
var $a5cf1c5d3684f0e3$export$2e2bcd8739ae039 = $a5cf1c5d3684f0e3$var$NAVIGATION;



const $d21880b1f67d3704$export$f9b2060e5b09a7ee = ()=>{
    const { loading: loading, error: error, data: data } = (0, $cb89595d8b20dae2$export$dd0a697e1782aedd)((0, $a5cf1c5d3684f0e3$export$2e2bcd8739ae039));
    const { pathname: pathname } = (0, $3fc8353d3146dc49$export$45d76561a5302f2b)();
    if (loading) return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
        role: "status",
        className: "mx-auto hidden max-w-7xl animate-pulse justify-around py-4 lg:flex",
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "h-2 w-24 rounded-full bg-gray-200 py-2"
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "h-2 w-24 rounded-full bg-gray-300 py-2"
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "h-2 w-24 rounded-full bg-gray-200 py-2"
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "h-2 w-24 rounded-full bg-gray-300 py-2"
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "h-2 w-24 rounded-full bg-gray-200 py-2"
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "h-2 w-24 rounded-full bg-gray-300 py-2"
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "h-2 w-24 rounded-full bg-gray-200 py-2"
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
        children: "Error :("
    });
    const links = data.global.data.attributes.navigation.links;
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {});
};
const $d21880b1f67d3704$export$ef87c8bc47155a01 = ()=>{
    const { loading: loading, error: error, data: data } = (0, $cb89595d8b20dae2$export$dd0a697e1782aedd)((0, $a5cf1c5d3684f0e3$export$2e2bcd8739ae039));
    if (loading) return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
        children: "Loading"
    });
    if (error) return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
        children: "Error :("
    });
    const links = data.global.data.attributes.navigation.links;
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {});
};


var $de1e84199e1f36c0$exports = {};

$de1e84199e1f36c0$exports = new URL((parcelRequire("20Q2C")).resolve("d7O5J"), import.meta.url).toString();


const $c4a0eeccdd74febb$var$Header = ()=>{
    const [mobileMenuOpen, setMobileMenuOpen] = (0, $eXaQ2.useState)(false);
    const navigate = (0, $3fc8353d3146dc49$export$9770f232ac06a008)();
    const location = (0, $3fc8353d3146dc49$export$45d76561a5302f2b)();
    const buttonStyle = location.pathname === "/" ? {
        display: "none"
    } : {};
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
        className: "sticky top-0 z-50",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
            className: "bg-white",
            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("header", {
                className: "shadow-md",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("nav", {
                        "aria-label": "Global",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "border-b",
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    className: "mx-auto flex max-w-7xl items-center justify-between p-3 md:p-3 ",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "flex lg:flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $48424eb92acda2f2$export$2e2bcd8739ae039), {
                                                    style: buttonStyle,
                                                    onClick: ()=>navigate(-1),
                                                    className: "mr-2 h-7 w-7 md:hidden"
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                                                    href: "/",
                                                    className: "-m-1.5 p-1.5 font-mono text-xl uppercase tracking-tight md:text-3xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($de1e84199e1f36c0$exports))),
                                                        className: "w-40 md:w-60"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "flex lg:hidden",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("button", {
                                                type: "button",
                                                className: "-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700",
                                                onClick: ()=>setMobileMenuOpen(true),
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open main menu"
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $8ab4152c85822e31$export$2e2bcd8739ae039), {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "hidden lg:flex lg:gap-x-12"
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "hidden lg:flex lg:flex-1 lg:justify-end"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $d21880b1f67d3704$export$f9b2060e5b09a7ee), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $929e4da6068570b0$export$3ddf2d174ce01153), {
                        as: "div",
                        className: "lg:hidden",
                        open: mobileMenuOpen,
                        onClose: setMobileMenuOpen,
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "fixed inset-0 z-50"
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $929e4da6068570b0$export$3ddf2d174ce01153).Panel, {
                                className: "fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-gray-900/10 sm:ring-1",
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                                                href: "/",
                                                className: "-m-1.5 p-1.5 font-mono text-xl uppercase tracking-tight md:text-3xl",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($de1e84199e1f36c0$exports))),
                                                    className: "w-44 md:w-60"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("button", {
                                                type: "button",
                                                className: "-m-2.5 rounded-md p-2.5 text-gray-700",
                                                onClick: ()=>setMobileMenuOpen(false),
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Close menu"
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $de228018d8a12a5f$export$2e2bcd8739ae039), {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "mt-6 flow-root",
                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "-my-6 divide-y divide-gray-500/10",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                className: "space-y-1 py-6",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $d21880b1f67d3704$export$ef87c8bc47155a01), {})
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $c4a0eeccdd74febb$export$2e2bcd8739ae039 = $c4a0eeccdd74febb$var$Header;


const $86a0a2c7143f17cc$var$MainLayout = ({ children: children, className: className = "", title: title, description: description })=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $a1cc52fbd40b0eb4$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $1f02524b81d370cb$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "pb-8 md:pb-20",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $c4a0eeccdd74febb$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("main", {
                        className: `${className} mt-4 md:mt-10`,
                        children: children
                    })
                ]
            })
        ]
    });
};
var $86a0a2c7143f17cc$export$2e2bcd8739ae039 = $86a0a2c7143f17cc$var$MainLayout;




const $d8415b00580724f1$var$SideFooter = ()=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
        className: "mt-10 border-t border-gray-300 pt-4 text-center text-sm tracking-tight text-gray-400",
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "flex flex-wrap justify-center gap-2 text-center",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                        to: "/about-us",
                        className: "px-2",
                        children: "About Us"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                        to: "/contact",
                        className: "px-2",
                        children: "Contact"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                        to: "/terms",
                        className: "px-2",
                        children: "Terms of Service"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                        to: "/privacy",
                        className: "px-2",
                        children: "Privacy Policy"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                        to: "/do-not-sell",
                        className: "px-2",
                        children: "Do Not Sell"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "mt-6",
                children: "2024 Penny Pincher. All rights reserved."
            })
        ]
    });
};
var $d8415b00580724f1$export$2e2bcd8739ae039 = $d8415b00580724f1$var$SideFooter;



parcelRequire("eXaQ2");

const $4c532a3998b026b9$var$FeaturedThumbnails = ({ articles: articles })=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
        className: "mx-2 mt-4 grid gap-6 sm:grid-cols-3 md:mx-0",
        children: articles ? articles.map((item, index)=>{
            var _item_attributes_primary_image_data;
            /*#__PURE__*/ return (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                to: `${item.attributes.category.data.attributes.href}/${item.attributes.slug}`,
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                    className: "article-container",
                    children: [
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                            className: "h-40 w-full rounded-lg object-cover",
                            src: (_item_attributes_primary_image_data = item.attributes.primary_image.data) === null || _item_attributes_primary_image_data === void 0 ? void 0 : _item_attributes_primary_image_data.attributes.url
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "headline mt-1 line-clamp-2 text-sm font-semibold leading-normal tracking-tight md:text-base",
                            children: item.attributes.title
                        })
                    ]
                }, index)
            }, index);
        }) : Array(3).fill(0).map((_, ind)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                role: "status",
                className: "grid animate-pulse grid-cols-1 gap-4",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "flex items-center justify-center rounded bg-gray-300 dark:bg-gray-700",
                        style: {
                            aspectRatio: 16 / 9
                        },
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                            className: "h-12 w-12 text-gray-200",
                            xmlns: "http://www.w3.org/2000/svg",
                            "aria-hidden": "true",
                            fill: "currentColor",
                            viewBox: "0 0 640 512",
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "flex w-full flex-col items-center justify-center",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "mb-4 h-3 w-full rounded-full bg-gray-200 dark:bg-gray-700"
                        })
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                        className: "sr-only",
                        children: "Loading..."
                    })
                ]
            }, ind))
    });
};
var $4c532a3998b026b9$export$2e2bcd8739ae039 = $4c532a3998b026b9$var$FeaturedThumbnails;



let $57e26d152c1a4c5c$var$_ = (t)=>t, $57e26d152c1a4c5c$var$t, $57e26d152c1a4c5c$var$t1;
const $57e26d152c1a4c5c$export$bac5958cb736511f = (0, $fd0c0e1ba95e1f7a$export$72e4926bf8358653)($57e26d152c1a4c5c$var$t || ($57e26d152c1a4c5c$var$t = $57e26d152c1a4c5c$var$_`
  query {
    homepage {
      data {
        attributes {
          featured_article {
            data {
              attributes {
                title
                slug
                preview_text
                category {
                  data {
                    id
                    attributes {
                      name
                      href
                    }
                  }
                }
                primary_image {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
          featured_article_cta
        }
      }
    }
    articles(sort: "id:desc", pagination: { pageSize: 20 }) {
      data {
        id
        attributes {
          slug
          title
          category {
            data {
              id
              attributes {
                name
                href
                category_color
              }
            }
          }
          primary_image {
            data {
              attributes {
                name
                url
                formats
              }
            }
          }
        }
      }
    }
  }
`));
const $57e26d152c1a4c5c$export$84147760a6fe7fa1 = (pageNumber)=>(0, $fd0c0e1ba95e1f7a$export$72e4926bf8358653)($57e26d152c1a4c5c$var$t1 || ($57e26d152c1a4c5c$var$t1 = $57e26d152c1a4c5c$var$_`
  query {
    articles(sort: "id:desc", pagination: { pageSize: 20, page: ${0} }) {
      data {
        id
        attributes {
          slug
          title
          category {
            data {
              id
              attributes {
                name
                href
                category_color
              }
            }
          }
          primary_image {
            data {
              attributes {
                name
                url
                formats
              }
            }
          }
        }
      }
    }
  }
`), pageNumber);


const $f31944e06b8d605e$var$Home = ()=>{
    const [articles, setArticles] = (0, $eXaQ2.useState)();
    const [currentPage, setCurrentPage] = (0, $eXaQ2.useState)(1);
    const [hasMore, setHasMore] = (0, $eXaQ2.useState)(true);
    const client = (0, $34c3e0df3dad45a4$export$eb9a56e7a29e494)();
    const { loading: loading, error: error, data: data } = (0, $cb89595d8b20dae2$export$dd0a697e1782aedd)((0, $57e26d152c1a4c5c$export$bac5958cb736511f));
    (0, $eXaQ2.useEffect)(()=>{
        setArticles(data === null || data === void 0 ? void 0 : data.articles.data.filter((article)=>data.homepage.data !== article.attributes.slug));
        if ((data === null || data === void 0 ? void 0 : data.articles.data.length) < 20) setHasMore(false);
    }, [
        data
    ]);
    const onNextArticles = async ()=>{
        if (!articles) return;
        const { data: data } = await client.query({
            query: (0, $57e26d152c1a4c5c$export$84147760a6fe7fa1)(currentPage + 1)
        });
        const temp = articles;
        temp.push(...data.articles.data);
        setArticles(temp);
        if (data.articles.data.length < 20) setHasMore(false);
        else setCurrentPage((prev)=>prev + 1);
    };
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $86a0a2c7143f17cc$export$2e2bcd8739ae039), {
        title: "Penny Pincher News",
        description: "Offering strategic financial advice, diverse money-saving tips, and a wealth of resources to help you maximize your savings and effectively manage your budget.",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
            className: "mx-auto max-w-7xl md:px-4",
            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "gap-8 md:flex",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        className: "basis-3/4",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "inline border-l-[8px] border-purple-600 pl-2 text-lg font-bold",
                                children: "Trending Stories"
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4c532a3998b026b9$export$2e2bcd8739ae039), {
                                articles: articles === null || articles === void 0 ? void 0 : articles.slice(0, 3)
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $1a1188d546cac9cf$export$2e2bcd8739ae039), {
                                dataLength: (articles === null || articles === void 0 ? void 0 : articles.length) || 0,
                                next: onNextArticles,
                                hasMore: hasMore,
                                loader: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                    children: "Loading..."
                                }),
                                endMessage: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $a1cc52fbd40b0eb4$exports.Fragment), {}),
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4c532a3998b026b9$export$2e2bcd8739ae039), {
                                    articles: articles === null || articles === void 0 ? void 0 : articles.slice(3, articles.length)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "basis-1/4",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "sticky top-32",
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $d8415b00580724f1$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            })
        })
    });
};
var $f31944e06b8d605e$export$2e2bcd8739ae039 = $f31944e06b8d605e$var$Home;







var $801f587ccda2fa3e$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");
var $c8af07426a56b9a9$export$26ecbb5c9753d95f = function(visible) {
    return {
        display: visible ? "flex" : "none"
    };
};


var $45e7cbc4949e453a$export$37394b0fa44b998c = "#4fa94d";
var $45e7cbc4949e453a$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "status"
};


var $801f587ccda2fa3e$var$__assign = undefined && undefined.__assign || function() {
    $801f587ccda2fa3e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $801f587ccda2fa3e$var$__assign.apply(this, arguments);
};
var $801f587ccda2fa3e$var$Audio = function(_a) {
    var _b = _a.height, height = _b === void 0 ? "100" : _b, _c = _a.width, width = _c === void 0 ? "100" : _c, _d = _a.color, color = _d === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "audio-loading" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $801f587ccda2fa3e$var$__assign({
        style: $801f587ccda2fa3e$var$__assign($801f587ccda2fa3e$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        height: "".concat(height),
        width: "".concat(width),
        fill: color,
        viewBox: "0 0 55 80",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "audio-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "matrix(1 0 0 -1 0 80)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        width: "10",
        height: "20",
        rx: "3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "4.3s",
        values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "15",
        width: "10",
        height: "80",
        rx: "3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "2s",
        values: "80;55;33;5;75;23;73;33;12;14;60;80",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "30",
        width: "10",
        height: "50",
        rx: "3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "1.4s",
        values: "50;34;78;23;56;23;34;76;80;54;21;50",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "45",
        width: "10",
        height: "30",
        rx: "3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "2s",
        values: "30;45;13;80;56;72;45;76;34;23;67;30",
        calcMode: "linear",
        repeatCount: "indefinite"
    })))));
};
var $801f587ccda2fa3e$export$2e2bcd8739ae039 = $801f587ccda2fa3e$var$Audio;


var $a28571bf18518cd4$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $a28571bf18518cd4$var$__assign = undefined && undefined.__assign || function() {
    $a28571bf18518cd4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a28571bf18518cd4$var$__assign.apply(this, arguments);
};
var $a28571bf18518cd4$var$BallTriangle = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 100 : _b, _c = _a.width, width = _c === void 0 ? 100 : _c, _d = _a.radius, radius = _d === void 0 ? 5 : _d, _e = _a.color, color = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "ball-triangle-loading" : _f, wrapperClass = _a.wrapperClass, wrapperStyle = _a.wrapperStyle, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $a28571bf18518cd4$var$__assign({
        style: $a28571bf18518cd4$var$__assign($a28571bf18518cd4$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        height: height,
        width: width,
        stroke: color,
        viewBox: "0 0 57 57",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "ball-triangle-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(1 1)",
        strokeWidth: "2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "5",
        cy: "50",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        begin: "0s",
        dur: "2.2s",
        values: "50;5;50;50",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cx",
        begin: "0s",
        dur: "2.2s",
        values: "5;27;49;5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "27",
        cy: "5",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        begin: "0s",
        dur: "2.2s",
        from: "5",
        to: "5",
        values: "5;50;50;5",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cx",
        begin: "0s",
        dur: "2.2s",
        from: "27",
        to: "27",
        values: "27;49;5;27",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "49",
        cy: "50",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        begin: "0s",
        dur: "2.2s",
        values: "50;50;5;50",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cx",
        from: "49",
        to: "49",
        begin: "0s",
        dur: "2.2s",
        values: "49;5;27;49",
        calcMode: "linear",
        repeatCount: "indefinite"
    }))))));
};
var $a28571bf18518cd4$export$2e2bcd8739ae039 = $a28571bf18518cd4$var$BallTriangle;


var $686f148604a80f7f$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $686f148604a80f7f$var$__assign = undefined && undefined.__assign || function() {
    $686f148604a80f7f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $686f148604a80f7f$var$__assign.apply(this, arguments);
};
var $686f148604a80f7f$var$Bars = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "bars-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $686f148604a80f7f$var$__assign({
        style: $686f148604a80f7f$var$__assign($686f148604a80f7f$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        fill: color,
        viewBox: "0 0 135 140",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "bars-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0.5s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "y",
        begin: "0.5s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "30",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0.25s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "y",
        begin: "0.25s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "60",
        width: "15",
        height: "140",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "y",
        begin: "0s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "90",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0.25s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "y",
        begin: "0.25s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "120",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        begin: "0.5s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "y",
        begin: "0.5s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    }))));
};
var $686f148604a80f7f$export$2e2bcd8739ae039 = $686f148604a80f7f$var$Bars;


var $08f30011a0ffdeb8$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $08f30011a0ffdeb8$var$__assign = undefined && undefined.__assign || function() {
    $08f30011a0ffdeb8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $08f30011a0ffdeb8$var$__assign.apply(this, arguments);
};
var $08f30011a0ffdeb8$var$Circles = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "circles-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $08f30011a0ffdeb8$var$__assign({
        style: $08f30011a0ffdeb8$var$__assign($08f30011a0ffdeb8$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 135 135",
        xmlns: "http://www.w3.org/2000/svg",
        fill: color,
        "data-testid": "circles-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 67 67",
        to: "-360 67 67",
        dur: "2.5s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 67 67",
        to: "360 67 67",
        dur: "8s",
        repeatCount: "indefinite"
    }))));
};
var $08f30011a0ffdeb8$export$2e2bcd8739ae039 = $08f30011a0ffdeb8$var$Circles;


var $8ed72af97df80595$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $8ed72af97df80595$var$__assign = undefined && undefined.__assign || function() {
    $8ed72af97df80595$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ed72af97df80595$var$__assign.apply(this, arguments);
};
var $8ed72af97df80595$var$CirclesWithBar = function(_a) {
    var _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b, _c = _a.visible, visible = _c === void 0 ? true : _c, _d = _a.wrapperClass, wrapperClass = _d === void 0 ? "" : _d, _e = _a.height, height = _e === void 0 ? 100 : _e, _f = _a.width, width = _f === void 0 ? 100 : _f, _g = _a.color, color = _g === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _g, outerCircleColor = _a.outerCircleColor, innerCircleColor = _a.innerCircleColor, barColor = _a.barColor, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "circles-with-bar-loading" : _h;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $8ed72af97df80595$var$__assign({
        style: $8ed72af97df80595$var$__assign($8ed72af97df80595$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18), {
        "data-testid": "circles-with-bar-wrapper"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        version: "1.1",
        id: "L1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        height: "".concat(height),
        width: "".concat(width),
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve",
        "data-testid": "circles-with-bar-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        fill: "none",
        stroke: "".concat(outerCircleColor || color),
        strokeWidth: "6",
        strokeMiterlimit: "15",
        strokeDasharray: "14.2472,14.2472",
        cx: "50",
        cy: "50",
        r: "47"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "5s",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        fill: "none",
        stroke: "".concat(innerCircleColor || color),
        strokeWidth: "1",
        strokeMiterlimit: "10",
        strokeDasharray: "10,10",
        cx: "50",
        cy: "50",
        r: "39"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "5s",
        from: "0 50 50",
        to: "-360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        fill: "".concat(barColor || color),
        "data-testid": "circles-with-bar-svg-bar"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "30",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.1"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "40",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.2"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "50",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.3"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "60",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.4"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "70",
        y: "35",
        width: "5",
        height: "30"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        type: "translate",
        values: "0 5 ; 0 -5; 0 5",
        repeatCount: "indefinite",
        begin: "0.5"
    })))));
};
var $8ed72af97df80595$export$2e2bcd8739ae039 = $8ed72af97df80595$var$CirclesWithBar;


var $382c59f92e2304ef$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $382c59f92e2304ef$var$__assign = undefined && undefined.__assign || function() {
    $382c59f92e2304ef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $382c59f92e2304ef$var$__assign.apply(this, arguments);
};
var $382c59f92e2304ef$export$ef2184bd89960b14 = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 12.5 : _d, _e = _a.color, color = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "grid-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $382c59f92e2304ef$var$__assign({
        style: $382c59f92e2304ef$var$__assign($382c59f92e2304ef$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 105 105",
        fill: color,
        "data-testid": "grid-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "12.5",
        cy: "12.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "0s",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "12.5",
        cy: "52.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "100ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "52.5",
        cy: "12.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "300ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "52.5",
        cy: "52.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "600ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "92.5",
        cy: "12.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "800ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "92.5",
        cy: "52.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "400ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "12.5",
        cy: "92.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "700ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "52.5",
        cy: "92.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "500ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "92.5",
        cy: "92.5",
        r: "".concat(radius)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "200ms",
        dur: "1s",
        values: "1;.2;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    }))));
};
var $382c59f92e2304ef$export$2e2bcd8739ae039 = $382c59f92e2304ef$export$ef2184bd89960b14;


var $82e23ed882fcf016$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $82e23ed882fcf016$var$__assign = undefined && undefined.__assign || function() {
    $82e23ed882fcf016$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $82e23ed882fcf016$var$__assign.apply(this, arguments);
};
var $82e23ed882fcf016$var$Hearts = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "hearts-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $82e23ed882fcf016$var$__assign({
        style: $82e23ed882fcf016$var$__assign($82e23ed882fcf016$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 140 64",
        xmlns: "http://www.w3.org/2000/svg",
        fill: color,
        "data-testid": "hearts-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
        attributeName: "fill-opacity",
        from: "0",
        to: ".5"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "0s",
        dur: "1.4s",
        values: "0.5;1;0.5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
        attributeName: "fill-opacity",
        from: "0",
        to: ".5"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        begin: "0.7s",
        dur: "1.4s",
        values: "0.5;1;0.5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
    })));
};
var $82e23ed882fcf016$export$2e2bcd8739ae039 = $82e23ed882fcf016$var$Hearts;


var $4366a99288ef8d33$exports = {};

$parcel$export($4366a99288ef8d33$exports, "default", function () { return $4366a99288ef8d33$export$2e2bcd8739ae039; });

var $eXaQ2 = parcelRequire("eXaQ2");


var $eXaQ2 = parcelRequire("eXaQ2");
var $e82e7dae911a2a65$exports = {};
//
$e82e7dae911a2a65$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $9f8d7ad5af4cbb63$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9f8d7ad5af4cbb63$export$2e2bcd8739ae039 = $9f8d7ad5af4cbb63$var$stylis_min;


var $39677225df4fc993$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $39677225df4fc993$export$2e2bcd8739ae039 = $39677225df4fc993$var$unitlessKeys;


function $43d13a4b388d6eb1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $e0ca667df205aae0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e0ca667df205aae0$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $43d13a4b388d6eb1$export$2e2bcd8739ae039)(function(prop) {
    return $e0ca667df205aae0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});




function $eda5e13de0b1cf9e$var$y() {
    return ($eda5e13de0b1cf9e$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $eda5e13de0b1cf9e$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $eda5e13de0b1cf9e$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $c8569a20eda3db7e$exports.typeOf)(t);
}, $eda5e13de0b1cf9e$var$S = Object.freeze([]), $eda5e13de0b1cf9e$var$w = Object.freeze({});
function $eda5e13de0b1cf9e$var$E(e) {
    return "function" == typeof e;
}
function $eda5e13de0b1cf9e$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $eda5e13de0b1cf9e$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $eda5e13de0b1cf9e$var$N = ("undefined" != typeof $0748a729b35c8c72$exports && void 0 !== $0748a729b35c8c72$exports.env && undefined, "data-styled"), $eda5e13de0b1cf9e$export$83d89fbfd8236492 = "5.3.11", $eda5e13de0b1cf9e$var$C = "undefined" != typeof window && "HTMLElement" in window, $eda5e13de0b1cf9e$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $0748a729b35c8c72$exports && void 0 !== $0748a729b35c8c72$exports.env && false), $eda5e13de0b1cf9e$var$P = {}, $eda5e13de0b1cf9e$var$O = {};
function $eda5e13de0b1cf9e$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $eda5e13de0b1cf9e$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $eda5e13de0b1cf9e$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $eda5e13de0b1cf9e$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $eda5e13de0b1cf9e$var$T = new Map, $eda5e13de0b1cf9e$var$x = new Map, $eda5e13de0b1cf9e$var$k = 1, $eda5e13de0b1cf9e$var$V = function(e) {
    if ($eda5e13de0b1cf9e$var$T.has(e)) return $eda5e13de0b1cf9e$var$T.get(e);
    for(; $eda5e13de0b1cf9e$var$x.has($eda5e13de0b1cf9e$var$k);)$eda5e13de0b1cf9e$var$k++;
    var t = $eda5e13de0b1cf9e$var$k++;
    return $eda5e13de0b1cf9e$var$T.set(e, t), $eda5e13de0b1cf9e$var$x.set(t, e), t;
}, $eda5e13de0b1cf9e$var$B = function(e) {
    return $eda5e13de0b1cf9e$var$x.get(e);
}, $eda5e13de0b1cf9e$var$z = function(e, t) {
    t >= $eda5e13de0b1cf9e$var$k && ($eda5e13de0b1cf9e$var$k = t + 1), $eda5e13de0b1cf9e$var$T.set(e, t), $eda5e13de0b1cf9e$var$x.set(t, e);
}, $eda5e13de0b1cf9e$var$M = "style[" + $eda5e13de0b1cf9e$var$N + '][data-styled-version="5.3.11"]', $eda5e13de0b1cf9e$var$G = new RegExp("^" + $eda5e13de0b1cf9e$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $eda5e13de0b1cf9e$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $eda5e13de0b1cf9e$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($eda5e13de0b1cf9e$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($eda5e13de0b1cf9e$var$z(u, c), $eda5e13de0b1cf9e$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $eda5e13de0b1cf9e$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $eda5e13de0b1cf9e$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($eda5e13de0b1cf9e$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($eda5e13de0b1cf9e$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $eda5e13de0b1cf9e$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $eda5e13de0b1cf9e$var$H = function() {
    function e(e) {
        var t = this.element = $eda5e13de0b1cf9e$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $eda5e13de0b1cf9e$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $eda5e13de0b1cf9e$var$$ = function() {
    function e(e) {
        var t = this.element = $eda5e13de0b1cf9e$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $eda5e13de0b1cf9e$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $eda5e13de0b1cf9e$var$U = $eda5e13de0b1cf9e$var$C, $eda5e13de0b1cf9e$var$J = {
    isServer: !$eda5e13de0b1cf9e$var$C,
    useCSSOMInjection: !$eda5e13de0b1cf9e$var$I
}, $eda5e13de0b1cf9e$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $eda5e13de0b1cf9e$var$w), void 0 === t && (t = {}), this.options = $eda5e13de0b1cf9e$var$y({}, $eda5e13de0b1cf9e$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $eda5e13de0b1cf9e$var$C && $eda5e13de0b1cf9e$var$U && ($eda5e13de0b1cf9e$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($eda5e13de0b1cf9e$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($eda5e13de0b1cf9e$var$N) && ($eda5e13de0b1cf9e$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $eda5e13de0b1cf9e$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($eda5e13de0b1cf9e$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $eda5e13de0b1cf9e$var$W(o) : r ? new $eda5e13de0b1cf9e$var$H(o) : new $eda5e13de0b1cf9e$var$$(o), new $eda5e13de0b1cf9e$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($eda5e13de0b1cf9e$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($eda5e13de0b1cf9e$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($eda5e13de0b1cf9e$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $eda5e13de0b1cf9e$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $eda5e13de0b1cf9e$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $eda5e13de0b1cf9e$var$Z = /(a)(d)/gi, $eda5e13de0b1cf9e$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $eda5e13de0b1cf9e$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $eda5e13de0b1cf9e$var$K(t % 52) + n;
    return ($eda5e13de0b1cf9e$var$K(t % 52) + n).replace($eda5e13de0b1cf9e$var$Z, "$1-$2");
}
var $eda5e13de0b1cf9e$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $eda5e13de0b1cf9e$var$te = function(e) {
    return $eda5e13de0b1cf9e$var$ee(5381, e);
};
function $eda5e13de0b1cf9e$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($eda5e13de0b1cf9e$var$E(n) && !$eda5e13de0b1cf9e$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $eda5e13de0b1cf9e$var$re = $eda5e13de0b1cf9e$var$te("5.3.11"), $eda5e13de0b1cf9e$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $eda5e13de0b1cf9e$var$ne(e), this.componentId = t, this.baseHash = $eda5e13de0b1cf9e$var$ee($eda5e13de0b1cf9e$var$re, t), this.baseStyle = n, $eda5e13de0b1cf9e$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $eda5e13de0b1cf9e$var$_e(this.rules, e, t, n).join(""), i = $eda5e13de0b1cf9e$var$Q($eda5e13de0b1cf9e$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $eda5e13de0b1cf9e$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $eda5e13de0b1cf9e$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $eda5e13de0b1cf9e$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $eda5e13de0b1cf9e$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $eda5e13de0b1cf9e$var$se = /^\s*\/\/.*$/gm, $eda5e13de0b1cf9e$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $eda5e13de0b1cf9e$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $eda5e13de0b1cf9e$var$w : e, i = s.options, a = void 0 === i ? $eda5e13de0b1cf9e$var$w : i, c = s.plugins, u = void 0 === c ? $eda5e13de0b1cf9e$var$S : c, l = new (0, $9f8d7ad5af4cbb63$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $eda5e13de0b1cf9e$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($eda5e13de0b1cf9e$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $eda5e13de0b1cf9e$var$D(15), $eda5e13de0b1cf9e$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $eda5e13de0b1cf9e$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createContext(), $eda5e13de0b1cf9e$export$91317688fc694efa = $eda5e13de0b1cf9e$export$8c190ef828af4c86.Consumer, $eda5e13de0b1cf9e$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createContext(), $eda5e13de0b1cf9e$var$de = ($eda5e13de0b1cf9e$var$le.Consumer, new $eda5e13de0b1cf9e$var$X), $eda5e13de0b1cf9e$var$he = $eda5e13de0b1cf9e$var$ae();
function $eda5e13de0b1cf9e$var$pe() {
    return (0, $eXaQ2.useContext)($eda5e13de0b1cf9e$export$8c190ef828af4c86) || $eda5e13de0b1cf9e$var$de;
}
function $eda5e13de0b1cf9e$var$fe() {
    return (0, $eXaQ2.useContext)($eda5e13de0b1cf9e$var$le) || $eda5e13de0b1cf9e$var$he;
}
function $eda5e13de0b1cf9e$export$a473771da2f0ff7c(e) {
    var t = (0, $eXaQ2.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $eda5e13de0b1cf9e$var$pe(), u = (0, $eXaQ2.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $eXaQ2.useMemo)(function() {
        return $eda5e13de0b1cf9e$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $eXaQ2.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($e82e7dae911a2a65$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($eda5e13de0b1cf9e$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($eda5e13de0b1cf9e$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $eda5e13de0b1cf9e$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $eda5e13de0b1cf9e$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $eda5e13de0b1cf9e$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $eda5e13de0b1cf9e$var$he), this.name + e.hash;
    }, e;
}(), $eda5e13de0b1cf9e$var$ve = /([A-Z])/, $eda5e13de0b1cf9e$var$ge = /([A-Z])/g, $eda5e13de0b1cf9e$var$Se = /^ms-/, $eda5e13de0b1cf9e$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $eda5e13de0b1cf9e$var$Ee(e) {
    return $eda5e13de0b1cf9e$var$ve.test(e) ? e.replace($eda5e13de0b1cf9e$var$ge, $eda5e13de0b1cf9e$var$we).replace($eda5e13de0b1cf9e$var$Se, "-ms-") : e;
}
var $eda5e13de0b1cf9e$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $eda5e13de0b1cf9e$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $eda5e13de0b1cf9e$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($eda5e13de0b1cf9e$var$be(e)) return "";
    if ($eda5e13de0b1cf9e$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($eda5e13de0b1cf9e$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $eda5e13de0b1cf9e$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $eda5e13de0b1cf9e$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $eda5e13de0b1cf9e$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$eda5e13de0b1cf9e$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $eda5e13de0b1cf9e$var$E(t[i]) ? s.push($eda5e13de0b1cf9e$var$Ee(i) + ":", t[i], ";") : $eda5e13de0b1cf9e$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($eda5e13de0b1cf9e$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $39677225df4fc993$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $eda5e13de0b1cf9e$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $eda5e13de0b1cf9e$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $eda5e13de0b1cf9e$var$E(e) || $eda5e13de0b1cf9e$var$g(e) ? $eda5e13de0b1cf9e$var$Ne($eda5e13de0b1cf9e$var$_e($eda5e13de0b1cf9e$var$v($eda5e13de0b1cf9e$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $eda5e13de0b1cf9e$var$Ne($eda5e13de0b1cf9e$var$_e($eda5e13de0b1cf9e$var$v(e, n)));
}
var $eda5e13de0b1cf9e$var$Ce = /invalid hook call/i, $eda5e13de0b1cf9e$var$Ie = new Set, $eda5e13de0b1cf9e$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $eda5e13de0b1cf9e$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $eda5e13de0b1cf9e$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $eda5e13de0b1cf9e$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $eda5e13de0b1cf9e$var$De = /(^-|-$)/g;
function $eda5e13de0b1cf9e$var$je(e) {
    return e.replace($eda5e13de0b1cf9e$var$Re, "-").replace($eda5e13de0b1cf9e$var$De, "");
}
var $eda5e13de0b1cf9e$var$Te = function(e) {
    return $eda5e13de0b1cf9e$var$Q($eda5e13de0b1cf9e$var$te(e) >>> 0);
};
function $eda5e13de0b1cf9e$var$xe(e) {
    return "string" == typeof e && true;
}
var $eda5e13de0b1cf9e$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $eda5e13de0b1cf9e$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $eda5e13de0b1cf9e$var$Be(e, t, n) {
    var r = e[n];
    $eda5e13de0b1cf9e$var$ke(t) && $eda5e13de0b1cf9e$var$ke(r) ? $eda5e13de0b1cf9e$var$ze(r, t) : e[n] = t;
}
function $eda5e13de0b1cf9e$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($eda5e13de0b1cf9e$var$ke(i)) for(var a in i)$eda5e13de0b1cf9e$var$Ve(a) && $eda5e13de0b1cf9e$var$Be(e, i[a], a);
    }
    return e;
}
var $eda5e13de0b1cf9e$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createContext(), $eda5e13de0b1cf9e$export$b631efc24e9d5e2f = $eda5e13de0b1cf9e$export$2c657da244d00bd6.Consumer;
function $eda5e13de0b1cf9e$export$d8964aec282183a3(e) {
    var t = (0, $eXaQ2.useContext)($eda5e13de0b1cf9e$export$2c657da244d00bd6), n = (0, $eXaQ2.useMemo)(function() {
        return function(e, t) {
            if (!e) return $eda5e13de0b1cf9e$var$D(14);
            if ($eda5e13de0b1cf9e$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $eda5e13de0b1cf9e$var$D(8) : t ? $eda5e13de0b1cf9e$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($eda5e13de0b1cf9e$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $eda5e13de0b1cf9e$var$Fe = {};
function $eda5e13de0b1cf9e$var$Ye(e, t, n) {
    var o = $eda5e13de0b1cf9e$export$7ba318d8d2f06c76(e), i = !$eda5e13de0b1cf9e$var$xe(e), a = t.attrs, c = void 0 === a ? $eda5e13de0b1cf9e$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $eda5e13de0b1cf9e$var$je(e);
        $eda5e13de0b1cf9e$var$Fe[n] = ($eda5e13de0b1cf9e$var$Fe[n] || 0) + 1;
        var r = n + "-" + $eda5e13de0b1cf9e$var$Te("5.3.11" + n + $eda5e13de0b1cf9e$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $eda5e13de0b1cf9e$var$xe(e) ? "styled." + e : "Styled(" + $eda5e13de0b1cf9e$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $eda5e13de0b1cf9e$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $eda5e13de0b1cf9e$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $eda5e13de0b1cf9e$var$w);
                var r = $eda5e13de0b1cf9e$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $eda5e13de0b1cf9e$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($eda5e13de0b1cf9e$var$Oe(t, (0, $eXaQ2.useContext)($eda5e13de0b1cf9e$export$2c657da244d00bd6), a) || $eda5e13de0b1cf9e$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $eda5e13de0b1cf9e$var$pe(), s = $eda5e13de0b1cf9e$var$fe(), i = t ? e.generateAndInjectStyles($eda5e13de0b1cf9e$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $eda5e13de0b1cf9e$var$xe(b), N = v !== t ? $eda5e13de0b1cf9e$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $e0ca667df205aae0$export$2e2bcd8739ae039), b) : !_ || (0, $e0ca667df205aae0$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $eda5e13de0b1cf9e$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $eXaQ2.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $eda5e13de0b1cf9e$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($eda5e13de0b1cf9e$var$xe(e) ? e : $eda5e13de0b1cf9e$var$je($eda5e13de0b1cf9e$var$b(e)));
        return $eda5e13de0b1cf9e$var$Ye(e, $eda5e13de0b1cf9e$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $eda5e13de0b1cf9e$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($dbde4074519d49fa$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $eda5e13de0b1cf9e$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $eda5e13de0b1cf9e$var$w), !(0, $c8569a20eda3db7e$exports.isValidElementType)(r)) return $eda5e13de0b1cf9e$var$D(1, String(r));
        var s = function() {
            return t(r, o, $eda5e13de0b1cf9e$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $eda5e13de0b1cf9e$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $eda5e13de0b1cf9e$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($eda5e13de0b1cf9e$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $eda5e13de0b1cf9e$var$qe[e] = $eda5e13de0b1cf9e$var$qe(e);
});
var $eda5e13de0b1cf9e$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $eda5e13de0b1cf9e$var$ne(e), $eda5e13de0b1cf9e$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($eda5e13de0b1cf9e$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $eda5e13de0b1cf9e$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $eda5e13de0b1cf9e$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $eda5e13de0b1cf9e$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $eda5e13de0b1cf9e$var$Te(JSON.stringify(i)), u = new $eda5e13de0b1cf9e$var$He(i, a);
    function d(e) {
        var t = $eda5e13de0b1cf9e$var$pe(), n = $eda5e13de0b1cf9e$var$fe(), o = (0, $eXaQ2.useContext)($eda5e13de0b1cf9e$export$2c657da244d00bd6), d = (0, $eXaQ2.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $eXaQ2.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $eda5e13de0b1cf9e$var$P, n, o);
        else {
            var s = $eda5e13de0b1cf9e$var$y({}, t, {
                theme: $eda5e13de0b1cf9e$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).memo(d);
}
function $eda5e13de0b1cf9e$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $eda5e13de0b1cf9e$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $eda5e13de0b1cf9e$var$Te(o);
    return new $eda5e13de0b1cf9e$var$ye(s, o);
}
var $eda5e13de0b1cf9e$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $eda5e13de0b1cf9e$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $eda5e13de0b1cf9e$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $eda5e13de0b1cf9e$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $eda5e13de0b1cf9e$var$D(2);
            var n = ((t = {})[$eda5e13de0b1cf9e$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $eda5e13de0b1cf9e$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("style", $eda5e13de0b1cf9e$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $eda5e13de0b1cf9e$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $eda5e13de0b1cf9e$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($eda5e13de0b1cf9e$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $eda5e13de0b1cf9e$var$D(3);
    }, e;
}(), $eda5e13de0b1cf9e$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).forwardRef(function(t, n) {
        var o = (0, $eXaQ2.useContext)($eda5e13de0b1cf9e$export$2c657da244d00bd6), i = e.defaultProps, a = $eda5e13de0b1cf9e$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement(e, $eda5e13de0b1cf9e$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($dbde4074519d49fa$exports)))(t, e), t.displayName = "WithTheme(" + $eda5e13de0b1cf9e$var$b(e) + ")", t;
}, $eda5e13de0b1cf9e$export$93d4e7f90805808f = function() {
    return (0, $eXaQ2.useContext)($eda5e13de0b1cf9e$export$2c657da244d00bd6);
}, $eda5e13de0b1cf9e$export$5c87cfe6c475f500 = {
    StyleSheet: $eda5e13de0b1cf9e$var$X,
    masterSheet: $eda5e13de0b1cf9e$var$de
};
var $eda5e13de0b1cf9e$export$2e2bcd8739ae039 = $eda5e13de0b1cf9e$var$qe;



var $4366a99288ef8d33$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $4366a99288ef8d33$var$len = 242.776657104492;
var $4366a99288ef8d33$var$time = 1.6;
var $4366a99288ef8d33$var$anim = (0, $eda5e13de0b1cf9e$export$d25ddfdf17c3ad3e)($4366a99288ef8d33$var$templateObject_1 || ($4366a99288ef8d33$var$templateObject_1 = $4366a99288ef8d33$var$__makeTemplateObject([
    "\n  12.5% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n  43.75% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n  100% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n"
], [
    "\n  12.5% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n  43.75% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n  100% {\n    stroke-dasharray: ",
    "px, ",
    "px;\n    stroke-dashoffset: -",
    "px;\n  }\n"
])), $4366a99288ef8d33$var$len * 0.14, $4366a99288ef8d33$var$len, $4366a99288ef8d33$var$len * 0.11, $4366a99288ef8d33$var$len * 0.35, $4366a99288ef8d33$var$len, $4366a99288ef8d33$var$len * 0.35, $4366a99288ef8d33$var$len * 0.01, $4366a99288ef8d33$var$len, $4366a99288ef8d33$var$len * 0.99);
var $4366a99288ef8d33$var$Path = (0, $eda5e13de0b1cf9e$export$2e2bcd8739ae039).path($4366a99288ef8d33$var$templateObject_2 || ($4366a99288ef8d33$var$templateObject_2 = $4366a99288ef8d33$var$__makeTemplateObject([
    "\n  stroke-dasharray: ",
    "px, ",
    ";\n  stroke-dashoffset: 0;\n  animation: ",
    " ",
    "s linear infinite;\n"
], [
    "\n  stroke-dasharray: ",
    "px, ",
    ";\n  stroke-dashoffset: 0;\n  animation: ",
    " ",
    "s linear infinite;\n"
])), $4366a99288ef8d33$var$len * 0.01, $4366a99288ef8d33$var$len, $4366a99288ef8d33$var$anim, $4366a99288ef8d33$var$time);
var $4366a99288ef8d33$var$InfinitySpin = function(_a) {
    var _b = _a.color, color = _b === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _b, _c = _a.width, width = _c === void 0 ? "200" : _c;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "".concat(width),
        height: "".concat(Number(width) * 0.5),
        viewBox: "0 0 ".concat(width, " ").concat(Number(100)),
        "data-testid": "infinity-spin"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($4366a99288ef8d33$var$Path, {
        "data-testid": "infinity-spin-path-1",
        stroke: color,
        fill: "none",
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        "data-testid": "infinity-spin-path-2",
        opacity: "0.07",
        fill: "none",
        stroke: color,
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
    }));
};
var $4366a99288ef8d33$export$2e2bcd8739ae039 = $4366a99288ef8d33$var$InfinitySpin;
var $4366a99288ef8d33$var$templateObject_1, $4366a99288ef8d33$var$templateObject_2;


var $8cb709ead2ab99a3$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $8cb709ead2ab99a3$var$__assign = undefined && undefined.__assign || function() {
    $8cb709ead2ab99a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8cb709ead2ab99a3$var$__assign.apply(this, arguments);
};
var $8cb709ead2ab99a3$var$LineWave = function(_a) {
    var _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b, _c = _a.visible, visible = _c === void 0 ? true : _c, _d = _a.wrapperClass, wrapperClass = _d === void 0 ? "" : _d, _e = _a.height, height = _e === void 0 ? 100 : _e, _f = _a.width, width = _f === void 0 ? 100 : _f, _g = _a.color, color = _g === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "line-wave-loading" : _h, firstLineColor = _a.firstLineColor, middleLineColor = _a.middleLineColor, lastLineColor = _a.lastLineColor;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $8cb709ead2ab99a3$var$__assign({
        style: $8cb709ead2ab99a3$var$__assign($8cb709ead2ab99a3$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        version: "1.1",
        height: "".concat(height),
        width: "".concat(width),
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 0 0",
        xmlSpace: "preserve",
        "data-testid": "line-wave-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "20",
        y: "50",
        width: "4",
        height: "10",
        fill: firstLineColor || color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0",
        dur: "0.6s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "30",
        y: "50",
        width: "4",
        height: "10",
        fill: middleLineColor || color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0.2s",
        dur: "0.6s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "40",
        y: "50",
        width: "4",
        height: "10",
        fill: lastLineColor || color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0.4s",
        dur: "0.6s",
        repeatCount: "indefinite"
    }))));
};
var $8cb709ead2ab99a3$export$2e2bcd8739ae039 = $8cb709ead2ab99a3$var$LineWave;


var $a986f8e917903479$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $a986f8e917903479$var$__assign = undefined && undefined.__assign || function() {
    $a986f8e917903479$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a986f8e917903479$var$__assign.apply(this, arguments);
};
var $a986f8e917903479$var$MutatingDots = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 90 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 12.5 : _d, _e = _a.color, color = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.secondaryColor, secondaryColor = _f === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "mutating-dots-loading" : _g, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _h = _a.visible, visible = _h === void 0 ? true : _h;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $a986f8e917903479$var$__assign({
        style: $a986f8e917903479$var$__assign($a986f8e917903479$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        id: "goo-loader",
        width: width,
        height: height,
        "data-testid": "mutating-dots-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("filter", {
        id: "fancy-goo"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("feGaussianBlur", {
        in: "SourceGraphic",
        stdDeviation: "6",
        result: "blur"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("feColorMatrix", {
        in: "blur",
        mode: "matrix",
        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
        result: "goo"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("feComposite", {
        in: "SourceGraphic",
        in2: "goo",
        operator: "atop"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        filter: "url(#fancy-goo)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        id: "mainAnim",
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        from: "0 50 50",
        to: "359 50 50",
        dur: "1.2s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "50%",
        cy: "40",
        r: radius,
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        id: "cAnim1",
        attributeType: "XML",
        attributeName: "cy",
        dur: "0.6s",
        begin: "0;cAnim1.end+0.2s",
        calcMode: "spline",
        values: "40;20;40",
        keyTimes: "0;0.3;1",
        keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "50%",
        cy: "60",
        r: radius,
        fill: secondaryColor
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        id: "cAnim2",
        attributeType: "XML",
        attributeName: "cy",
        dur: "0.6s",
        begin: "0.4s;cAnim2.end+0.2s",
        calcMode: "spline",
        values: "60;80;60",
        keyTimes: "0;0.3;1",
        keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
    })))));
};
var $a986f8e917903479$export$2e2bcd8739ae039 = $a986f8e917903479$var$MutatingDots;


var $951a268bafb228d6$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $951a268bafb228d6$var$__assign = undefined && undefined.__assign || function() {
    $951a268bafb228d6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $951a268bafb228d6$var$__assign.apply(this, arguments);
};
var $951a268bafb228d6$var$RADIUS = 20;
var $951a268bafb228d6$var$getPath = function(radius) {
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
var $951a268bafb228d6$var$getViewBoxSize = function(strokeWidth, secondaryStrokeWidth, radius) {
    var maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    var startingPoint = -radius - maxStrokeWidth / 2 + 1;
    var endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
var $951a268bafb228d6$var$Oval = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _d, _e = _a.secondaryColor, secondaryColor = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "oval-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g, _h = _a.strokeWidth, strokeWidth = _h === void 0 ? 2 : _h, strokeWidthSecondary = _a.strokeWidthSecondary;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $951a268bafb228d6$var$__assign({
        style: $951a268bafb228d6$var$__assign($951a268bafb228d6$var$__assign($951a268bafb228d6$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle), {
            padding: 3
        }),
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        viewBox: $951a268bafb228d6$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $951a268bafb228d6$var$RADIUS),
        xmlns: "http://www.w3.org/2000/svg",
        stroke: color,
        "data-testid": "oval-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(1 1)",
        strokeWidth: Number(strokeWidthSecondary || strokeWidth),
        "data-testid": "oval-secondary-group"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        strokeOpacity: ".5",
        cx: "0",
        cy: "0",
        r: $951a268bafb228d6$var$RADIUS,
        stroke: secondaryColor,
        strokeWidth: strokeWidth
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: $951a268bafb228d6$var$getPath($951a268bafb228d6$var$RADIUS)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 0 0",
        to: "360 0 0",
        dur: "1s",
        repeatCount: "indefinite"
    }))))));
};
var $951a268bafb228d6$export$2e2bcd8739ae039 = $951a268bafb228d6$var$Oval;


var $eaffef625848332b$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $eaffef625848332b$var$__assign = undefined && undefined.__assign || function() {
    $eaffef625848332b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eaffef625848332b$var$__assign.apply(this, arguments);
};
var $eaffef625848332b$export$83d2259ec538613b = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 1 : _d, _e = _a.color, color = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "puff-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $eaffef625848332b$var$__assign({
        style: $eaffef625848332b$var$__assign($eaffef625848332b$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 44 44",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: color,
        "data-testid": "puff-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        strokeWidth: "2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        begin: "0s",
        dur: "1.8s",
        values: "1; 20",
        calcMode: "spline",
        keyTimes: "0; 1",
        keySplines: "0.165, 0.84, 0.44, 1",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "strokeOpacity",
        begin: "0s",
        dur: "1.8s",
        values: "1; 0",
        calcMode: "spline",
        keyTimes: "0; 1",
        keySplines: "0.3, 0.61, 0.355, 1",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        begin: "-0.9s",
        dur: "1.8s",
        values: "1; 20",
        calcMode: "spline",
        keyTimes: "0; 1",
        keySplines: "0.165, 0.84, 0.44, 1",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "strokeOpacity",
        begin: "-0.9s",
        dur: "1.8s",
        values: "1; 0",
        calcMode: "spline",
        keyTimes: "0; 1",
        keySplines: "0.3, 0.61, 0.355, 1",
        repeatCount: "indefinite"
    })))));
};
var $eaffef625848332b$export$2e2bcd8739ae039 = $eaffef625848332b$export$83d2259ec538613b;


var $be2cd0dde1257660$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $be2cd0dde1257660$var$__assign = undefined && undefined.__assign || function() {
    $be2cd0dde1257660$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be2cd0dde1257660$var$__assign.apply(this, arguments);
};
var $be2cd0dde1257660$var$RevolvingDot = function(_a) {
    var _b = _a.radius, radius = _b === void 0 ? 45 : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 5 : _c, _d = _a.color, color = _d === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _d, secondaryColor = _a.secondaryColor, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "revolving-dot-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $be2cd0dde1257660$var$__assign({
        style: $be2cd0dde1257660$var$__assign($be2cd0dde1257660$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        version: "1.1",
        width: "calc(".concat(radius, " * 2.5)"),
        height: "calc(".concat(radius, " * 2.5)"),
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        "data-testid": "revolving-dot-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        fill: "none",
        stroke: secondaryColor || color,
        strokeWidth: strokeWidth,
        cx: "calc(".concat(radius, " * 1.28)"),
        cy: "calc(".concat(radius, " * 1.28)"),
        r: radius,
        style: {
            opacity: 0.5
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        fill: color,
        stroke: color,
        strokeWidth: "3",
        cx: "calc(".concat(radius, " * 1.28)"),
        cy: "calc(".concat(radius, " / 3.5)"),
        r: "calc(".concat(radius, " / 5)"),
        style: {
            transformOrigin: "50% 50%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "2s",
        type: "rotate",
        from: "0",
        to: "360",
        repeatCount: "indefinite"
    }))));
};
var $be2cd0dde1257660$export$2e2bcd8739ae039 = $be2cd0dde1257660$var$RevolvingDot;


var $17d85f25dcd89488$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $17d85f25dcd89488$var$__assign = undefined && undefined.__assign || function() {
    $17d85f25dcd89488$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17d85f25dcd89488$var$__assign.apply(this, arguments);
};
var $17d85f25dcd89488$export$fdd9e2f491a77de7 = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 6 : _d, _e = _a.color, color = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "rings-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $17d85f25dcd89488$var$__assign({
        style: $17d85f25dcd89488$var$__assign($17d85f25dcd89488$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 45 45",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: color,
        "data-testid": "rings-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(1 1)",
        strokeWidth: "2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: radius,
        strokeOpacity: "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        begin: "1.5s",
        dur: "3s",
        values: "6;22",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "stroke-opacity",
        begin: "1.5s",
        dur: "3s",
        values: "1;0",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "stroke-width",
        begin: "1.5s",
        dur: "3s",
        values: "2;0",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: radius,
        strokeOpacity: "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        begin: "3s",
        dur: "3s",
        values: "6;22",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "strokeOpacity",
        begin: "3s",
        dur: "3s",
        values: "1;0",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "strokeWidth",
        begin: "3s",
        dur: "3s",
        values: "2;0",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "22",
        cy: "22",
        r: Number(radius) + 2
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        begin: "0s",
        dur: "1.5s",
        values: "6;1;2;3;4;5;6",
        calcMode: "linear",
        repeatCount: "indefinite"
    })))));
};
var $17d85f25dcd89488$export$2e2bcd8739ae039 = $17d85f25dcd89488$export$fdd9e2f491a77de7;


var $30c758f7a22a5491$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $30c758f7a22a5491$var$__assign = undefined && undefined.__assign || function() {
    $30c758f7a22a5491$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $30c758f7a22a5491$var$__assign.apply(this, arguments);
};
var $30c758f7a22a5491$var$RotatingSquare = function(_a) {
    var _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.color, color = _c === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _c, _d = _a.height, height = _d === void 0 ? 100 : _d, _e = _a.width, width = _e === void 0 ? 100 : _e, _f = _a.strokeWidth, strokeWidth = _f === void 0 ? 4 : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "rotating-square-loading" : _g, _h = _a.wrapperStyle, wrapperStyle = _h === void 0 ? {} : _h, _j = _a.visible, visible = _j === void 0 ? true : _j;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $30c758f7a22a5491$var$__assign({
        style: $30c758f7a22a5491$var$__assign($30c758f7a22a5491$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        height: "".concat(height),
        width: "".concat(width),
        "data-testid": "rotating-square-svg",
        xmlSpace: "preserve"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        fill: "none",
        stroke: color,
        strokeWidth: strokeWidth,
        x: "25",
        y: "25",
        width: "50",
        height: "50"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "0.5s",
        from: "0 50 50",
        to: "180 50 50",
        type: "rotate",
        id: "strokeBox",
        attributeType: "XML",
        begin: "rectBox.end"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "27",
        y: "27",
        fill: color,
        width: "46",
        height: "50"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "height",
        dur: "1.3s",
        attributeType: "XML",
        from: "50",
        to: "0",
        id: "rectBox",
        fill: "freeze",
        begin: "0s;strokeBox.end"
    }))));
};
var $30c758f7a22a5491$export$2e2bcd8739ae039 = $30c758f7a22a5491$var$RotatingSquare;


var $7125259861455c11$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

/**
 * Returns the value of `props[path]` or `defaultValue`
 * @example
 * import styled from "styled-components";
 * import { prop } from "styled-tools";
 *
 * const Button = styled.button`
 *   color: ${prop("color", "red")};
 * `;
 */ var $93dc525f98e288ea$var$prop = function prop(path, defaultValue) {
    return function() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (typeof props[path] !== "undefined") return props[path];
        if (path && path.indexOf(".") > 0) {
            var paths = path.split(".");
            var length = paths.length;
            var object = props[paths[0]];
            var index = 1;
            while(object != null && index < length){
                object = object[paths[index]];
                index += 1;
            }
            if (typeof object !== "undefined") return object;
        }
        return defaultValue;
    };
};
var $93dc525f98e288ea$export$2e2bcd8739ae039 = $93dc525f98e288ea$var$prop;


function $40a7a1b3380808a0$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $40a7a1b3380808a0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $40a7a1b3380808a0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $40a7a1b3380808a0$var$_typeof(obj);
}
var $40a7a1b3380808a0$var$parseFunction = function parseFunction(props, test) {
    return Boolean(test(props));
};
var $40a7a1b3380808a0$var$parseObject = function parseObject(props, test) {
    var keys = Object.keys(test);
    var length = keys.length;
    for(var index = 0; index < length; index += 1){
        var key = keys[index];
        var expected = test[key];
        var value = (0, $93dc525f98e288ea$export$2e2bcd8739ae039)(key)(props);
        if (expected !== value) return false;
    }
    return true;
};
var $40a7a1b3380808a0$var$parseString = function parseString(props, test) {
    return Boolean((0, $93dc525f98e288ea$export$2e2bcd8739ae039)(test)(props));
};
var $40a7a1b3380808a0$var$parseMap = {
    function: $40a7a1b3380808a0$var$parseFunction,
    object: $40a7a1b3380808a0$var$parseObject,
    string: $40a7a1b3380808a0$var$parseString
};
/**
 * Returns `pass` if prop is truthy. Otherwise returns `fail`
 * @example
 * import styled from "styled-components";
 * import { ifProp, palette } from "styled-tools";
 *
 * const Button = styled.button`
 *   background-color: ${ifProp("transparent", "transparent", palette(0))};
 *   color: ${ifProp(["transparent", "accent"], palette("secondary"))};
 *   font-size: ${ifProp({ size: "large" }, "20px", ifProp({ size: "medium" }, "16px", "12px"))};
 * `;
 */ var $40a7a1b3380808a0$var$ifProp = function ifProp(test) {
    var pass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var fail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return function() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var result = true;
        if (Array.isArray(test)) {
            var length = test.length;
            var index = 0;
            while(result && index < length){
                result = $40a7a1b3380808a0$var$parseMap[$40a7a1b3380808a0$var$_typeof(test[index])](props, test[index]);
                index += 1;
            }
        } else result = $40a7a1b3380808a0$var$parseMap[$40a7a1b3380808a0$var$_typeof(test)](props, test);
        var value = result ? pass : fail;
        return typeof value === "function" ? value(props) : value;
    };
};
var $40a7a1b3380808a0$export$2e2bcd8739ae039 = $40a7a1b3380808a0$var$ifProp;


/**
 * Returns `pass` if prop is falsy. Otherwise returns `fail`
 * @example
 * import styled from "styled-components";
 * import { ifNotProp } from "styled-tools";
 *
 * const Button = styled.button`
 *   font-size: ${ifNotProp("large", "20px", "30px")};
 * `;
 */ var $0edf703bbf4fb023$var$ifNotProp = function ifNotProp(test, pass, fail) {
    return (0, $40a7a1b3380808a0$export$2e2bcd8739ae039)(test, fail, pass);
};
var $0edf703bbf4fb023$export$2e2bcd8739ae039 = $0edf703bbf4fb023$var$ifNotProp;




var $7cd579199beee5b1$var$toArray = function toArray(arg) {
    return Array.isArray(arg) ? arg : [
        arg
    ];
};
var $7cd579199beee5b1$var$clamp = function clamp(number, min, max) {
    if (number < min) return min;
    if (number > max) return max;
    return number;
};
/**
 * Returns `props.theme.palette[key || props.palette][tone || props.tone || 0]` or `defaultValue`.
 * @example
 * import styled, { ThemeProvider } from "styled-components";
 * import { palette } from "styled-tools";
 *
 * const theme = {
 *   palette: {
 *     primary: ['#1976d2', '#2196f3', '#71bcf7', '#c2e2fb'],
 *     secondary: ['#c2185b', '#e91e63', '#f06292', '#f8bbd0']
 *   }
 * };
 *
 * const Button = styled.button`
 *   color: ${palette(1)};                    // props.theme.palette[props.palette][1]
 *   color: ${palette("primary", 1)};         // props.theme.palette.primary[1]
 *   color: ${palette("primary")};            // props.theme.palette.primary[props.tone || 0]
 *   color: ${palette("primary", -1)};        // props.theme.palette.primary[3]
 *   color: ${palette("primary", 10)};        // props.theme.palette.primary[3]
 *   color: ${palette("primary", -10)};       // props.theme.palette.primary[0]
 *   color: ${palette("primary", 0, "red")};  // props.theme.palette.primary[0] || red
 * `;
 *
 * <ThemeProvider theme={theme}>
 *   <Button palette="secondary" />
 * </ThemeProvider>
 */ var $7cd579199beee5b1$var$palette = function palette(keyOrTone, toneOrDefaultValue, defaultValue) {
    return function(props) {
        var key = typeof keyOrTone === "string" ? keyOrTone : props.palette;
        var tone = typeof keyOrTone === "number" ? keyOrTone : typeof toneOrDefaultValue === "number" ? toneOrDefaultValue : props.tone || 0;
        var finalDefaultValue = toneOrDefaultValue !== tone ? toneOrDefaultValue : defaultValue;
        if (!props.theme.palette || !props.theme.palette[key]) return finalDefaultValue;
        var tones = $7cd579199beee5b1$var$toArray(props.theme.palette[key]);
        if (tone < 0) return tones[$7cd579199beee5b1$var$clamp(tones.length + tone, 0, tones.length - 1)];
        return tones[$7cd579199beee5b1$var$clamp(tone, 0, tones.length - 1)];
    };
};
var $7cd579199beee5b1$export$2e2bcd8739ae039 = $7cd579199beee5b1$var$palette;



/**
 * Switches on a given prop. Returns the value or function for a given prop value. Third parameter is default value.
 * @example
 * import styled, { css } from "styled-components";
 * import { switchProp, prop } from "styled-tools";
 *
 * const Button = styled.button`
 *   font-size: ${switchProp(prop("size", "medium"), {
 *     small: prop("theme.sizes.sm", "12px"),
 *     medium: prop("theme.sizes.md", "16px"),
 *     large: prop("theme.sizes.lg", "20px")
 *   }, prop("theme.sizes.md", "16px"))};
 *   ${switchProp("theme.kind", {
 *     light: css`
 *       color: LightBlue;
 *     `,
 *     dark: css`
 *       color: DarkBlue;
 *     `
 *   }, css`color: black;`)}
 * `;
 *
 * <Button size="large" theme={{ kind: "light" }} />
 */ var $bde2382395085bd9$var$switchProp = function switchProp(needle, cases, defaultCase) {
    return function() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var value = typeof needle === "function" ? needle(props) : (0, $93dc525f98e288ea$export$2e2bcd8739ae039)(needle)(props);
        var finalCases = typeof cases === "function" ? cases(props) : cases;
        if (value in finalCases) return finalCases[value];
        return defaultCase;
    };
};
var $bde2382395085bd9$export$2e2bcd8739ae039 = $bde2382395085bd9$var$switchProp;



/**
 * Same as `prop`, except that it returns `props.theme[path]` instead of
 * `props[path]`.
 * @example
 * import styled from "styled-components";
 * import { theme } from "styled-tools";
 *
 * const Button = styled.button`
 *  color: ${theme("button.color", "red")};
 * `;
 */ var $c50ecf860cf095ca$var$theme = function theme(path, defaultValue) {
    return function(props) {
        return (0, $93dc525f98e288ea$export$2e2bcd8739ae039)(path, defaultValue)(props.theme);
    };
};
var $c50ecf860cf095ca$export$2e2bcd8739ae039 = $c50ecf860cf095ca$var$theme;



function $b2faa2d1ade3109c$var$_toConsumableArray(arr) {
    return $b2faa2d1ade3109c$var$_arrayWithoutHoles(arr) || $b2faa2d1ade3109c$var$_iterableToArray(arr) || $b2faa2d1ade3109c$var$_nonIterableSpread();
}
function $b2faa2d1ade3109c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $b2faa2d1ade3109c$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $b2faa2d1ade3109c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
/**
 * Calls a function passing properties values as arguments.
 * @example
 * // example with polished
 * import styled from "styled-components";
 * import { darken } from "polished";
 * import { withProp, prop } from "styled-tools";
 *
 * const Button = styled.button`
 *   border-color: ${withProp(prop("theme.primaryColor", "blue"), darken(0.5))};
 *   font-size: ${withProp("theme.size", size => `${size + 1}px`)};
 *   background: ${withProp(["foo", "bar"], (foo, bar) => `${foo}${bar}`)};
 * `;
 */ var $b2faa2d1ade3109c$var$withProp = function withProp(needle, fn) {
    return function() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (Array.isArray(needle)) {
            var needles = needle.map(function(arg) {
                return withProp(arg, function(x) {
                    return x;
                })(props);
            });
            return fn.apply(void 0, $b2faa2d1ade3109c$var$_toConsumableArray(needles));
        }
        if (typeof needle === "function") return fn(needle(props));
        return fn((0, $93dc525f98e288ea$export$2e2bcd8739ae039)(needle)(props));
    };
};
var $b2faa2d1ade3109c$export$2e2bcd8739ae039 = $b2faa2d1ade3109c$var$withProp;





var $7125259861455c11$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $7125259861455c11$var$__assign = undefined && undefined.__assign || function() {
    $7125259861455c11$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7125259861455c11$var$__assign.apply(this, arguments);
};
var $7125259861455c11$var$spin = (0, $eda5e13de0b1cf9e$export$d25ddfdf17c3ad3e)($7125259861455c11$var$templateObject_1 || ($7125259861455c11$var$templateObject_1 = $7125259861455c11$var$__makeTemplateObject([
    "\n to {\n    transform: rotate(360deg);\n  }\n"
], [
    "\n to {\n    transform: rotate(360deg);\n  }\n"
])));
var $7125259861455c11$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
var $7125259861455c11$var$Svg = (0, $eda5e13de0b1cf9e$export$2e2bcd8739ae039).svg($7125259861455c11$var$templateObject_2 || ($7125259861455c11$var$templateObject_2 = $7125259861455c11$var$__makeTemplateObject([
    "\n  animation: ",
    " 0.75s steps(12, end) infinite;\n  animation-duration: ",
    "s;\n"
], [
    "\n  animation: ",
    " 0.75s steps(12, end) infinite;\n  animation-duration: ",
    "s;\n"
])), $7125259861455c11$var$spin, (0, $93dc525f98e288ea$export$2e2bcd8739ae039)("speed", "0.75"));
var $7125259861455c11$var$Polyline = (0, $eda5e13de0b1cf9e$export$2e2bcd8739ae039).polyline($7125259861455c11$var$templateObject_3 || ($7125259861455c11$var$templateObject_3 = $7125259861455c11$var$__makeTemplateObject([
    "\n  stroke-width: ",
    "px;\n  stroke-linecap: round;\n\n  &:nth-child(12n + 0) {\n    stroke-opacity: 0.08;\n  }\n\n  &:nth-child(12n + 1) {\n    stroke-opacity: 0.17;\n  }\n\n  &:nth-child(12n + 2) {\n    stroke-opacity: 0.25;\n  }\n\n  &:nth-child(12n + 3) {\n    stroke-opacity: 0.33;\n  }\n\n  &:nth-child(12n + 4) {\n    stroke-opacity: 0.42;\n  }\n\n  &:nth-child(12n + 5) {\n    stroke-opacity: 0.5;\n  }\n\n  &:nth-child(12n + 6) {\n    stroke-opacity: 0.58;\n  }\n\n  &:nth-child(12n + 7) {\n    stroke-opacity: 0.66;\n  }\n\n  &:nth-child(12n + 8) {\n    stroke-opacity: 0.75;\n  }\n\n  &:nth-child(12n + 9) {\n    stroke-opacity: 0.83;\n  }\n\n  &:nth-child(12n + 11) {\n    stroke-opacity: 0.92;\n  }\n"
], [
    "\n  stroke-width: ",
    "px;\n  stroke-linecap: round;\n\n  &:nth-child(12n + 0) {\n    stroke-opacity: 0.08;\n  }\n\n  &:nth-child(12n + 1) {\n    stroke-opacity: 0.17;\n  }\n\n  &:nth-child(12n + 2) {\n    stroke-opacity: 0.25;\n  }\n\n  &:nth-child(12n + 3) {\n    stroke-opacity: 0.33;\n  }\n\n  &:nth-child(12n + 4) {\n    stroke-opacity: 0.42;\n  }\n\n  &:nth-child(12n + 5) {\n    stroke-opacity: 0.5;\n  }\n\n  &:nth-child(12n + 6) {\n    stroke-opacity: 0.58;\n  }\n\n  &:nth-child(12n + 7) {\n    stroke-opacity: 0.66;\n  }\n\n  &:nth-child(12n + 8) {\n    stroke-opacity: 0.75;\n  }\n\n  &:nth-child(12n + 9) {\n    stroke-opacity: 0.83;\n  }\n\n  &:nth-child(12n + 11) {\n    stroke-opacity: 0.92;\n  }\n"
])), function(props) {
    return props.width;
});
function $7125259861455c11$export$2e2bcd8739ae039(_a) {
    var _b = _a.strokeColor, strokeColor = _b === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? "5" : _c, _d = _a.animationDuration, animationDuration = _d === void 0 ? "0.75" : _d, _e = _a.width, width = _e === void 0 ? "96" : _e, _f = _a.visible, visible = _f === void 0 ? true : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "rotating-lines-loading" : _g;
    var lines = (0, $eXaQ2.useCallback)(function() {
        return $7125259861455c11$var$POINTS.map(function(point) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($7125259861455c11$var$Polyline, {
                key: point,
                points: "24,12 24,4",
                width: strokeWidth,
                transform: "rotate(".concat(point, ", 24, 24)")
            });
        });
    }, [
        strokeWidth
    ]);
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($7125259861455c11$var$Svg, $7125259861455c11$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), lines());
}
var $7125259861455c11$var$templateObject_1, $7125259861455c11$var$templateObject_2, $7125259861455c11$var$templateObject_3;


var $c566160c5286d318$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $c566160c5286d318$var$__assign = undefined && undefined.__assign || function() {
    $c566160c5286d318$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c566160c5286d318$var$__assign.apply(this, arguments);
};
var $c566160c5286d318$export$f8e5ae7506d65b32 = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 1 : _d, _e = _a.color, color = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "tail-spin-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $c566160c5286d318$var$__assign({
        style: $c566160c5286d318$var$__assign($c566160c5286d318$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 38 38",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "tail-spin-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("linearGradient", {
        x1: "8.042%",
        y1: "0%",
        x2: "65.682%",
        y2: "23.865%",
        id: "a"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("stop", {
        stopColor: color,
        stopOpacity: "0",
        offset: "0%"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("stop", {
        stopColor: color,
        stopOpacity: ".631",
        offset: "63.146%"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("stop", {
        stopColor: color,
        offset: "100%"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(1 1)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M36 18c0-9.94-8.06-18-18-18",
        id: "Oval-2",
        stroke: color,
        strokeWidth: "2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 18 18",
        to: "360 18 18",
        dur: "0.9s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        fill: "#fff",
        cx: "36",
        cy: "18",
        r: radius
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 18 18",
        to: "360 18 18",
        dur: "0.9s",
        repeatCount: "indefinite"
    }))))));
};
var $c566160c5286d318$export$2e2bcd8739ae039 = $c566160c5286d318$export$f8e5ae7506d65b32;


var $455d9a934b6ee0ed$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $455d9a934b6ee0ed$var$__assign = undefined && undefined.__assign || function() {
    $455d9a934b6ee0ed$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $455d9a934b6ee0ed$var$__assign.apply(this, arguments);
};
var $455d9a934b6ee0ed$var$ThreeCircles = function(_a) {
    var _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b, _c = _a.visible, visible = _c === void 0 ? true : _c, _d = _a.wrapperClass, wrapperClass = _d === void 0 ? "" : _d, _e = _a.height, height = _e === void 0 ? 100 : _e, _f = _a.width, width = _f === void 0 ? 100 : _f, _g = _a.color, color = _g === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "three-circles-loading" : _h, outerCircleColor = _a.outerCircleColor, innerCircleColor = _a.innerCircleColor, middleCircleColor = _a.middleCircleColor;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $455d9a934b6ee0ed$var$__assign({
        style: $455d9a934b6ee0ed$var$__assign($455d9a934b6ee0ed$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        version: "1.1",
        height: "".concat(height),
        width: "".concat(width),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve",
        "data-testid": "three-circles-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: outerCircleColor || color,
        d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3\n  c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "2s",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: middleCircleColor || color,
        d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7\n  c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "1s",
        from: "0 50 50",
        to: "-360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: innerCircleColor || color,
        d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5\n  L82,35.7z"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        type: "rotate",
        dur: "2s",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    }))));
};
var $455d9a934b6ee0ed$export$2e2bcd8739ae039 = $455d9a934b6ee0ed$var$ThreeCircles;


var $39ba2f6e2ab62225$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $39ba2f6e2ab62225$var$__assign = undefined && undefined.__assign || function() {
    $39ba2f6e2ab62225$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39ba2f6e2ab62225$var$__assign.apply(this, arguments);
};
var $39ba2f6e2ab62225$var$ThreeDots = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 9 : _d, _e = _a.color, color = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "three-dots-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $39ba2f6e2ab62225$var$__assign({
        style: $39ba2f6e2ab62225$var$__assign($39ba2f6e2ab62225$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 120 30",
        xmlns: "http://www.w3.org/2000/svg",
        fill: color,
        "data-testid": "three-dots-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "15",
        cy: "15",
        r: Number(radius) + 6
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        from: "15",
        to: "15",
        begin: "0s",
        dur: "0.8s",
        values: "15;9;15",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "1",
        to: "1",
        begin: "0s",
        dur: "0.8s",
        values: "1;.5;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "60",
        cy: "15",
        r: radius,
        attributeName: "fill-opacity",
        from: "1",
        to: "0.3"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        from: "9",
        to: "9",
        begin: "0s",
        dur: "0.8s",
        values: "9;15;9",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "0.5",
        to: "0.5",
        begin: "0s",
        dur: "0.8s",
        values: ".5;1;.5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "105",
        cy: "15",
        r: Number(radius) + 6
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        from: "15",
        to: "15",
        begin: "0s",
        dur: "0.8s",
        values: "15;9;15",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "1",
        to: "1",
        begin: "0s",
        dur: "0.8s",
        values: "1;.5;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    }))));
};
var $39ba2f6e2ab62225$export$2e2bcd8739ae039 = $39ba2f6e2ab62225$var$ThreeDots;


var $fccd34e398bea19a$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");



var $fccd34e398bea19a$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $fccd34e398bea19a$var$__assign = undefined && undefined.__assign || function() {
    $fccd34e398bea19a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fccd34e398bea19a$var$__assign.apply(this, arguments);
};
var $fccd34e398bea19a$var$dash = (0, $eda5e13de0b1cf9e$export$d25ddfdf17c3ad3e)($fccd34e398bea19a$var$templateObject_1 || ($fccd34e398bea19a$var$templateObject_1 = $fccd34e398bea19a$var$__makeTemplateObject([
    "\n to {\n    stroke-dashoffset: 136;\n  }\n"
], [
    "\n to {\n    stroke-dashoffset: 136;\n  }\n"
])));
var $fccd34e398bea19a$var$Polygon = (0, $eda5e13de0b1cf9e$export$2e2bcd8739ae039).polygon($fccd34e398bea19a$var$templateObject_2 || ($fccd34e398bea19a$var$templateObject_2 = $fccd34e398bea19a$var$__makeTemplateObject([
    "\n  stroke-dasharray: 17;\n  animation: ",
    " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"
], [
    "\n  stroke-dasharray: 17;\n  animation: ",
    " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"
])), $fccd34e398bea19a$var$dash);
var $fccd34e398bea19a$var$SVG = (0, $eda5e13de0b1cf9e$export$2e2bcd8739ae039).svg($fccd34e398bea19a$var$templateObject_3 || ($fccd34e398bea19a$var$templateObject_3 = $fccd34e398bea19a$var$__makeTemplateObject([
    "\n  transform-origin: 50% 65%;\n"
], [
    "\n  transform-origin: 50% 65%;\n"
])));
var $fccd34e398bea19a$var$Triangle = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.color, color = _d === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "triangle-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.visible, visible = _f === void 0 ? true : _f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $fccd34e398bea19a$var$__assign({
        style: $fccd34e398bea19a$var$__assign($fccd34e398bea19a$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: "".concat(wrapperClass),
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($fccd34e398bea19a$var$SVG, {
        id: "triangle",
        width: width,
        height: height,
        viewBox: "-3 -4 39 39",
        "data-testid": "triangle-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement($fccd34e398bea19a$var$Polygon, {
        fill: "transparent",
        stroke: color,
        strokeWidth: "1",
        points: "16,0 32,32 0,32"
    })));
};
var $fccd34e398bea19a$export$2e2bcd8739ae039 = $fccd34e398bea19a$var$Triangle;
var $fccd34e398bea19a$var$templateObject_1, $fccd34e398bea19a$var$templateObject_2, $fccd34e398bea19a$var$templateObject_3;


var $cc6928765e4fed4d$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $cc6928765e4fed4d$var$__assign = undefined && undefined.__assign || function() {
    $cc6928765e4fed4d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cc6928765e4fed4d$var$__assign.apply(this, arguments);
};
var $cc6928765e4fed4d$var$Watch = function(_a) {
    var _b = _a.height, height = _b === void 0 ? 80 : _b, _c = _a.width, width = _c === void 0 ? 80 : _c, _d = _a.radius, radius = _d === void 0 ? 48 : _d, _e = _a.color, color = _e === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _e, _f = _a.ariaLabel, ariaLabel = _f === void 0 ? "watch-loading" : _f, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _g = _a.visible, visible = _g === void 0 ? true : _g;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("div", $cc6928765e4fed4d$var$__assign({
        style: $cc6928765e4fed4d$var$__assign($cc6928765e4fed4d$var$__assign({}, (0, $c8af07426a56b9a9$export$26ecbb5c9753d95f)(visible)), wrapperStyle),
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", {
        width: width,
        height: height,
        version: "1.1",
        id: "L2",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve",
        "data-testid": "watch-svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        fill: "none",
        stroke: color,
        strokeWidth: "4",
        strokeMiterlimit: "10",
        cx: "50",
        cy: "50",
        r: radius
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("line", {
        fill: "none",
        strokeLinecap: "round",
        stroke: color,
        strokeWidth: "4",
        strokeMiterlimit: "10",
        x1: "50",
        y1: "50",
        x2: "85",
        y2: "50.5"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "2s",
        type: "rotate",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("line", {
        fill: "none",
        strokeLinecap: "round",
        stroke: color,
        strokeWidth: "4",
        strokeMiterlimit: "10",
        x1: "50",
        y1: "50",
        x2: "49.5",
        y2: "74"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        dur: "15s",
        type: "rotate",
        from: "0 50 50",
        to: "360 50 50",
        repeatCount: "indefinite"
    }))));
};
var $cc6928765e4fed4d$export$2e2bcd8739ae039 = $cc6928765e4fed4d$var$Watch;


var $74a14722d40a9f0f$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $74a14722d40a9f0f$var$__assign = undefined && undefined.__assign || function() {
    $74a14722d40a9f0f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $74a14722d40a9f0f$var$__assign.apply(this, arguments);
};
var $74a14722d40a9f0f$var$FallingLines = function(_a) {
    var _b = _a.color, color = _b === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _b, _c = _a.width, width = _c === void 0 ? "100" : _c, _d = _a.visible, visible = _d === void 0 ? true : _d;
    return visible ? (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $74a14722d40a9f0f$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        y: "25",
        width: "10",
        height: "50",
        rx: "4",
        ry: "4",
        fill: color,
        "data-testid": "falling-lines-rect-1"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "x",
        values: "10;100",
        dur: "1.2s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 10 70",
        to: "-60 100 70",
        dur: "1.2s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "opacity",
        values: "0;1;0",
        dur: "1.2s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        y: "25",
        width: "10",
        height: "50",
        rx: "4",
        ry: "4",
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "x",
        values: "10;100",
        dur: "1.2s",
        begin: "0.4s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 10 70",
        to: "-60 100 70",
        dur: "1.2s",
        begin: "0.4s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "opacity",
        values: "0;1;0",
        dur: "1.2s",
        begin: "0.4s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        y: "25",
        width: "10",
        height: "50",
        rx: "4",
        ry: "4",
        fill: color,
        "data-testid": "falling-lines-rect-2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "x",
        values: "10;100",
        dur: "1.2s",
        begin: "0.8s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 10 70",
        to: "-60 100 70",
        dur: "1.2s",
        begin: "0.8s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "opacity",
        values: "0;1;0",
        dur: "1.2s",
        begin: "0.8s",
        repeatCount: "indefinite"
    }))) : null;
};
var $74a14722d40a9f0f$export$2e2bcd8739ae039 = $74a14722d40a9f0f$var$FallingLines;


var $f8e11054710665ff$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $f8e11054710665ff$var$__assign = undefined && undefined.__assign || function() {
    $f8e11054710665ff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8e11054710665ff$var$__assign.apply(this, arguments);
};
var $f8e11054710665ff$var$Vortex = function(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "vortex-loading" : _e, wrapperStyle = _a.wrapperStyle, wrapperClass = _a.wrapperClass, _f = _a.colors, colors = _f === void 0 ? [
        "#1B5299",
        "#EF8354",
        "#DB5461",
        "#1B5299",
        "#EF8354",
        "#DB5461"
    ] : _f;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $f8e11054710665ff$var$__assign({
        height: height,
        width: width,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(50,50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "scale(0.7)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(-50,-50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "rotate(137.831 50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        repeatCount: "indefinite",
        values: "360 50 50;0 50 50",
        keyTimes: "0;1",
        dur: "1",
        keySplines: "0.5 0.5 0.5 0.5",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: colors[0],
        d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: colors[1],
        d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: colors[2],
        d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: colors[3],
        d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: colors[4],
        d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: colors[5],
        d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
    }))))));
};
var $f8e11054710665ff$export$2e2bcd8739ae039 = $f8e11054710665ff$var$Vortex;


var $332bfdb476d0d342$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $332bfdb476d0d342$var$__assign = undefined && undefined.__assign || function() {
    $332bfdb476d0d342$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $332bfdb476d0d342$var$__assign.apply(this, arguments);
};
function $332bfdb476d0d342$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "rotating-triangle-loading" : _g, _h = _a.colors, colors = _h === void 0 ? [
        "#1B5299",
        "#EF8354",
        "#DB5461"
    ] : _h;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $332bfdb476d0d342$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(50,42)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "scale(0.8)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(-50,-50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("polygon", {
        "ng-attr-fill": "{{config.c1}}",
        points: "72.5,50 50,11 27.5,50 50,50",
        fill: colors[0],
        transform: "rotate(186 50 38.5)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 50 38.5;360 50 38.5",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("polygon", {
        "ng-attr-fill": "{{config.c2}}",
        points: "5,89 50,89 27.5,50",
        fill: colors[1],
        transform: "rotate(186 27.5 77.5)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 27.5 77.5;360 27.5 77.5",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("polygon", {
        "ng-attr-fill": "{{config.c3}}",
        points: "72.5,50 50,89 95,89",
        fill: colors[2],
        transform: "rotate(186 72.2417 77.5)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 72.5 77.5;360 72 77.5",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    }))))));
}


var $b721a02bfbfcdde4$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $b721a02bfbfcdde4$var$__assign = undefined && undefined.__assign || function() {
    $b721a02bfbfcdde4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b721a02bfbfcdde4$var$__assign.apply(this, arguments);
};
function $b721a02bfbfcdde4$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "radio-loading" : _g, _h = _a.colors, colors = _h === void 0 ? [
        (0, $45e7cbc4949e453a$export$37394b0fa44b998c),
        (0, $45e7cbc4949e453a$export$37394b0fa44b998c),
        (0, $45e7cbc4949e453a$export$37394b0fa44b998c)
    ] : _h;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $b721a02bfbfcdde4$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "28",
        cy: "75",
        r: "11",
        "ng-attr-fill": "{{config.c1}}",
        fill: colors[0]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill-opacity",
        calcMode: "linear",
        values: "0;1;1",
        keyTimes: "0;0.2;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M28 47A28 28 0 0 1 56 75",
        fill: "none",
        "ng-attr-stroke": "{{config.c2}}",
        strokeWidth: "10",
        stroke: colors[1]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "stroke-opacity",
        calcMode: "linear",
        values: "0;1;1",
        keyTimes: "0;0.2;1",
        dur: "1",
        begin: "0.1s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M28 25A50 50 0 0 1 78 75",
        fill: "none",
        "ng-attr-stroke": "{{config.c3}}",
        strokeWidth: "10",
        stroke: colors[2]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "stroke-opacity",
        calcMode: "linear",
        values: "0;1;1",
        keyTimes: "0;0.2;1",
        dur: "1",
        begin: "0.2s",
        repeatCount: "indefinite"
    })));
}


var $813526568b31b09d$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $813526568b31b09d$var$__assign = undefined && undefined.__assign || function() {
    $813526568b31b09d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $813526568b31b09d$var$__assign.apply(this, arguments);
};
function $813526568b31b09d$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "progress-bar-loading" : _g, _h = _a.borderColor, borderColor = _h === void 0 ? "#F4442E" : _h, _j = _a.barColor, barColor = _j === void 0 ? "#51E5FF" : _j;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $813526568b31b09d$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("clipPath", {
        "ng-attr-id": "{{config.cpid}}",
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        id: "lds-progress-cpid-5009611b8a418"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "0",
        y: "0",
        width: "66.6667",
        height: "100"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "width",
        calcMode: "linear",
        values: "0;100;100",
        keyTimes: "0;0.5;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "x",
        calcMode: "linear",
        values: "0;0;100",
        keyTimes: "0;0.5;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        fill: "none",
        "ng-attr-stroke": "{{config.c1}}",
        strokeWidth: "2.7928",
        d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
        stroke: borderColor
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        "ng-attr-fill": "{{config.c2}}",
        "ng-attr-clip-path": "url(#{{config.cpid}})",
        d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
        fill: barColor,
        clipPath: "url(#lds-progress-cpid-5009611b8a418)"
    }));
}


var $359697b95c2b9c64$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $359697b95c2b9c64$var$__assign = undefined && undefined.__assign || function() {
    $359697b95c2b9c64$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $359697b95c2b9c64$var$__assign.apply(this, arguments);
};
function $359697b95c2b9c64$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.width, width = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "magnifying-glass-loading" : _g, _h = _a.glassColor, glassColor = _h === void 0 ? "#c0efff" : _h, _j = _a.color, color = _j === void 0 ? "#e15b64" : _j;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $359697b95c2b9c64$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(50,50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        "ng-attr-transform": "scale({{config.scale}})",
        transform: "scale(0.82)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(-50,-50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(16.3636 -20)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "translate",
        calcMode: "linear",
        values: "-20 -20;20 -20;0 20;-20 -20",
        keyTimes: "0;0.33;0.66;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        "ng-attr-fill": "{{config.glass}}",
        d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
        fill: glassColor
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        "ng-attr-fill": "{{config.frame}}",
        d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
        fill: color
    }))))));
}


var $1df71c1b423672b3$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $1df71c1b423672b3$var$__assign = undefined && undefined.__assign || function() {
    $1df71c1b423672b3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1df71c1b423672b3$var$__assign.apply(this, arguments);
};
function $1df71c1b423672b3$export$2e2bcd8739ae039(_a) {
    var _b = _a.width, width = _b === void 0 ? "80" : _b, _c = _a.height, height = _c === void 0 ? "80" : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? (0, $45e7cbc4949e453a$export$37394b0fa44b998c) : _d, _e = _a.ballColors, ballColors = _e === void 0 ? [
        "#fc636b",
        "#6a67ce",
        "#ffb900"
    ] : _e, _f = _a.wrapperClass, wrapperClass = _f === void 0 ? "" : _f, _g = _a.wrapperStyle, wrapperStyle = _g === void 0 ? {} : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "fidget-spinner-loader" : _h, _j = _a.visible, visible = _j === void 0 ? true : _j;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $1df71c1b423672b3$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "rotate(6 50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        "ng-attr-transform": "scale({{config.r}})",
        transform: "scale(0.9)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        transform: "translate(-50 -58)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        "ng-attr-fill": "{{config.c2}}",
        d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
        fill: ballColors[0]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        "ng-attr-fill": "{{config.c3}}",
        d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
        fill: ballColors[1]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        "ng-attr-fill": "{{config.c4}}",
        cx: "50",
        cy: "27",
        r: "7.4",
        fill: ballColors[2]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        "ng-attr-fill": "{{config.c1}}",
        d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
        fill: backgroundColor
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    })));
}


var $0c7a50d25425b268$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $0c7a50d25425b268$var$__assign = undefined && undefined.__assign || function() {
    $0c7a50d25425b268$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0c7a50d25425b268$var$__assign.apply(this, arguments);
};
function $0c7a50d25425b268$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "dna-loading" : _g;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $0c7a50d25425b268$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "6.451612903225806",
        cy: "60.6229",
        r: "3.41988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.5s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "0s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.5s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "6.451612903225806",
        cy: "39.3771",
        r: "2.58012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.5s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.5s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "16.129032258064512",
        cy: "68.1552",
        r: "3.17988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.7s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.7s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "16.129032258064512",
        cy: "31.8448",
        r: "2.82012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.7s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.7s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "25.806451612903224",
        cy: "69.3634",
        r: "2.93988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.9s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.4s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.9s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "25.806451612903224",
        cy: "30.6366",
        r: "3.06012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.9s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.4s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.9s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "35.48387096774193",
        cy: "65.3666",
        r: "2.69988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.1s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.6s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.1s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "35.48387096774193",
        cy: "34.6334",
        r: "3.30012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.1s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.6s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.1s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "45.16129032258064",
        cy: "53.8474",
        r: "2.45988",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.3s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-0.8s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.3s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "45.16129032258064",
        cy: "46.1526",
        r: "3.54012",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.3s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.8s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.3s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "54.838709677419345",
        cy: "39.3771",
        r: "2.58012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.5s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.5s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "54.838709677419345",
        cy: "60.6229",
        r: "3.41988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.5s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.5s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "64.51612903225805",
        cy: "31.8448",
        r: "2.82012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.7s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.7s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "64.51612903225805",
        cy: "68.1552",
        r: "3.17988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.7s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.2s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.7s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "74.19354838709677",
        cy: "30.6366",
        r: "3.06012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.9s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.4s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.9s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "74.19354838709677",
        cy: "69.3634",
        r: "2.93988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.9s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.4s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.9s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "83.87096774193547",
        cy: "34.6334",
        r: "3.30012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.1s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.6s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.1s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "83.87096774193547",
        cy: "65.3666",
        r: "2.69988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-3.1s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.6s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.1s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "93.54838709677418",
        cy: "46.1526",
        r: "3.54012",
        fill: "rgba(233, 12, 89, 0.5125806451612902)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.3s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-1.8s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.3s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "93.54838709677418",
        cy: "53.8474",
        r: "2.45988",
        fill: "#46dff0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "r",
        keyTimes: "0;0.5;1",
        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-3.3s"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "cy",
        keyTimes: "0;0.5;1",
        values: "30.5;69.5;30.5",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.8s",
        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
        calcMode: "spline"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        keyTimes: "0;0.5;1",
        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
        dur: "2s",
        repeatCount: "indefinite",
        begin: "-2.3s"
    })));
}


var $7fb09d794dcd713f$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $7fb09d794dcd713f$var$__assign = undefined && undefined.__assign || function() {
    $7fb09d794dcd713f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fb09d794dcd713f$var$__assign.apply(this, arguments);
};
function $7fb09d794dcd713f$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "discuss-loading" : _g, _h = _a.colors, colors = _h === void 0 ? [
        "#ff727d",
        "#ff727d"
    ] : _h;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $7fb09d794dcd713f$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        "ng-attr-d": "{{config.d}}",
        "ng-attr-stroke-width": "{{config.width}}",
        "ng-attr-stroke": "{{config.stroke}}",
        fill: "none",
        d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
        strokeWidth: "5",
        stroke: colors[0]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "50",
        cy: "50",
        "ng-attr-r": "{{config.radius2}}",
        "ng-attr-stroke-width": "{{config.width}}",
        "ng-attr-stroke": "{{config.stroke}}",
        "ng-attr-stroke-dasharray": "{{config.dasharray}}",
        fill: "none",
        strokeLinecap: "round",
        r: "20",
        strokeWidth: "5",
        stroke: colors[1],
        strokeDasharray: "31.41592653589793 31.41592653589793",
        transform: "rotate(96 50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        calcMode: "linear",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
    })));
}


var $746d02961b1b404f$exports = {};

$parcel$export($746d02961b1b404f$exports, "default", function () { return $746d02961b1b404f$export$2e2bcd8739ae039; });

var $eXaQ2 = parcelRequire("eXaQ2");

var $746d02961b1b404f$var$__assign = undefined && undefined.__assign || function() {
    $746d02961b1b404f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $746d02961b1b404f$var$__assign.apply(this, arguments);
};
function $746d02961b1b404f$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.colors, colors = _e === void 0 ? [
        "#e15b64",
        "#f47e60",
        "#f8b26a",
        "#abbd81",
        "#849b87"
    ] : _e, _f = _a.wrapperClass, wrapperClass = _f === void 0 ? "" : _f, _g = _a.wrapperStyle, wrapperStyle = _g === void 0 ? {} : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? "color-ring-loading" : _h;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $746d02961b1b404f$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("mask", {
        id: "ldio-4offds5dlws-mask"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "50",
        cy: "50",
        r: "26",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeDasharray: "122.52211349000194 40.840704496667314",
        strokeWidth: "9",
        transform: "rotate(198.018 50 50)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1",
        dur: "1s",
        repeatCount: "indefinite"
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("g", {
        mask: "url(#ldio-4offds5dlws-mask)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "14.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[0]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "-0.8s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "28.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[1]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "-0.6s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "42.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[2]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "-0.4s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "56.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[3]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "-0.2s"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "70.5",
        y: "0",
        width: "15",
        height: "100",
        fill: colors[4]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: colors.join(";").toString(),
        keyTimes: "0;0.25;0.5;0.75;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    }))));
}


var $719f6803984f17b6$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $719f6803984f17b6$var$__assign = undefined && undefined.__assign || function() {
    $719f6803984f17b6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $719f6803984f17b6$var$__assign.apply(this, arguments);
};
function $719f6803984f17b6$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? "#ff6d00" : _e, _f = _a.color, color = _f === void 0 ? "#fff" : _f, _g = _a.wrapperClass, wrapperClass = _g === void 0 ? "" : _g, _h = _a.wrapperStyle, wrapperStyle = _h === void 0 ? {} : _h, _j = _a.ariaLabel, ariaLabel = _j === void 0 ? "comment-loading" : _j;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $719f6803984f17b6$var$__assign({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
        d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
        "ng-attr-fill": "{{config.c1}}",
        fill: backgroundColor
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "30",
        cy: "47",
        r: "5",
        "ng-attr-fill": "{{config.c2}}",
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "opacity",
        calcMode: "linear",
        values: "0;1;1",
        keyTimes: "0;0.2;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "50",
        cy: "47",
        r: "5",
        "ng-attr-fill": "{{config.c3}}",
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "opacity",
        calcMode: "linear",
        values: "0;0;1;1",
        keyTimes: "0;0.2;0.4;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
        cx: "70",
        cy: "47",
        r: "5",
        "ng-attr-fill": "{{config.c4}}",
        fill: color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "opacity",
        calcMode: "linear",
        values: "0;0;1;1",
        keyTimes: "0;0.4;0.6;1",
        dur: "1",
        begin: "0s",
        repeatCount: "indefinite"
    })));
}


var $162d2db249990438$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");

var $162d2db249990438$var$__assign = undefined && undefined.__assign || function() {
    $162d2db249990438$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $162d2db249990438$var$__assign.apply(this, arguments);
};
function $162d2db249990438$export$2e2bcd8739ae039(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? "80" : _c, _d = _a.height, height = _d === void 0 ? "80" : _d, _e = _a.wrapperClass, wrapperClass = _e === void 0 ? "" : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? {} : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? "blocks-loading" : _g;
    return !visible ? null : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $162d2db249990438$var$__assign({
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg"
    }, (0, $45e7cbc4949e453a$export$6bfda33bcd6c2d18)), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "17",
        y: "17",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "40",
        y: "17",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.125s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "63",
        y: "17",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.25s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "17",
        y: "40",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.875s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "63",
        y: "40",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.375s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "17",
        y: "63",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.75s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "40",
        y: "63",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.625s",
        calcMode: "discrete"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
        x: "63",
        y: "63",
        width: "20",
        height: "20",
        fill: "#577c9b"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("animate", {
        attributeName: "fill",
        values: "#0dceff;#577c9b;#577c9b",
        keyTimes: "0;0.125;1",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.5s",
        calcMode: "discrete"
    })));
}







const $16b22f66b453992c$var$RelatedArticles = ({ article: article, stories: stories })=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
        className: "mt-10",
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "border-l-[8px] border-orange-600 pl-2 text-base font-medium md:text-xl",
                children: "Related Stories"
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "mt-4 grid grid-cols-2 gap-6 md:grid-cols-3",
                children: article && stories && stories.articles && stories.articles.data.map((item, ind)=>{
                    var _item_attributes_primary_image_data, _item_attributes;
                    /*#__PURE__*/ return (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                        to: `${stories.href}/${item.attributes.slug}`,
                        className: article.title === item.attributes.title ? "hidden" : "",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "article-container",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                    className: "h-24 w-full rounded-lg object-cover md:h-40",
                                    src: (_item_attributes_primary_image_data = item === null || item === void 0 ? void 0 : (_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.primary_image.data) === null || _item_attributes_primary_image_data === void 0 ? void 0 : _item_attributes_primary_image_data.attributes.url
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "headline mt-1 line-clamp-2 text-sm font-semibold leading-normal tracking-tight md:text-lg",
                                    children: item.attributes.title
                                })
                            ]
                        })
                    }, ind);
                })
            })
        ]
    });
};
var $16b22f66b453992c$export$2e2bcd8739ae039 = $16b22f66b453992c$var$RelatedArticles;



let $4f9b5537dbedb61d$var$_ = (t)=>t, $4f9b5537dbedb61d$var$t;
const $4f9b5537dbedb61d$var$GET_ARTICLE = (slug)=>(0, $fd0c0e1ba95e1f7a$export$72e4926bf8358653)($4f9b5537dbedb61d$var$t || ($4f9b5537dbedb61d$var$t = $4f9b5537dbedb61d$var$_`
  query {
    articles(filters: { slug: { eq: "${0}" } }) {
      data {
        id
        attributes {
          title
          slug
          publishedAt
                  author {
          data {
            attributes {
              name
              role
              avatar {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
          display_ads
          preview_text
          content
          primary_image_description
          primary_image {
            data {
              attributes {
                url
              }
            }
          }
          sub_category {
            data {
              id
              attributes {
                name
                articles(pagination: { pageSize: 8 }) {
                  data {
                    id
                    attributes {
                      title
                      slug
                      primary_image {
                        data {
                          attributes {
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          category {
            data {
              id
              attributes {
                name
                href
                category_color
                articles (sort: "id:desc", pagination: {pageSize: 7}) {
                  data {
                    id
                    attributes {
                      title
                      slug
                      primary_image {
                        data {
                          attributes {
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`), slug);
var $4f9b5537dbedb61d$export$2e2bcd8739ae039 = $4f9b5537dbedb61d$var$GET_ARTICLE;


const $d2b3ba3d4a6ef45d$export$a274e22fb40f762e = (...args)=>{
    return args.filter(Boolean).join(" ");
};


var $bdde851a722932d6$exports = {};

$parcel$export($bdde851a722932d6$exports, "default", function () { return $bdde851a722932d6$export$2e2bcd8739ae039; });

var $eXaQ2 = parcelRequire("eXaQ2");
var $bdde851a722932d6$var$__assign = undefined && undefined.__assign || function() {
    $bdde851a722932d6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bdde851a722932d6$var$__assign.apply(this, arguments);
};
var $bdde851a722932d6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $bdde851a722932d6$export$2e2bcd8739ae039(iconConfig) {
    var Icon = function(_a) {
        var bgStyle = _a.bgStyle, borderRadius = _a.borderRadius, iconFillColor = _a.iconFillColor, round = _a.round, size = _a.size, rest = $bdde851a722932d6$var$__rest(_a, [
            "bgStyle",
            "borderRadius",
            "iconFillColor",
            "round",
            "size"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("svg", $bdde851a722932d6$var$__assign({
            viewBox: "0 0 64 64",
            width: size,
            height: size
        }, rest), round ? (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("circle", {
            cx: "32",
            cy: "32",
            r: "31",
            fill: iconConfig.color,
            style: bgStyle
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("rect", {
            width: "64",
            height: "64",
            rx: borderRadius,
            ry: borderRadius,
            fill: iconConfig.color,
            style: bgStyle
        }), (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("path", {
            d: iconConfig.path,
            fill: iconFillColor
        }));
    };
    Icon.defaultProps = {
        bgStyle: {},
        borderRadius: 0,
        iconFillColor: "white",
        size: 64
    };
    return Icon;
}


var $4e5d9c2e70cb7e4d$var$EmailIcon = (0, $bdde851a722932d6$exports.default)({
    color: "#7f7f7f",
    networkName: "email",
    path: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
});
var $4e5d9c2e70cb7e4d$export$2e2bcd8739ae039 = $4e5d9c2e70cb7e4d$var$EmailIcon;

function $6065224640359e1b$export$2e2bcd8739ae039(object) {
    var params = Object.entries(object).filter(function(_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    }).map(function(_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join("&")) : "";
}


var $3bc770cb2f2834f1$exports = {};

$parcel$export($3bc770cb2f2834f1$exports, "default", function () { return $3bc770cb2f2834f1$export$2e2bcd8739ae039; });

var $eXaQ2 = parcelRequire("eXaQ2");
var $09f51b2e589c6d41$exports = {};

$parcel$export($09f51b2e589c6d41$exports, "default", function () { return $09f51b2e589c6d41$export$2e2bcd8739ae039; });

var $eXaQ2 = parcelRequire("eXaQ2");
var $a25f5a5ebb44e773$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $a25f5a5ebb44e773$exports) {
        classNames.default = classNames;
        $a25f5a5ebb44e773$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $09f51b2e589c6d41$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $09f51b2e589c6d41$var$__assign = undefined && undefined.__assign || function() {
    $09f51b2e589c6d41$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $09f51b2e589c6d41$var$__assign.apply(this, arguments);
};
var $09f51b2e589c6d41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $09f51b2e589c6d41$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $09f51b2e589c6d41$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $09f51b2e589c6d41$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $09f51b2e589c6d41$var$getBoxPositionOnWindowCenter = function(width, height) {
    return {
        left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
        top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2
    };
};
var $09f51b2e589c6d41$var$getBoxPositionOnScreenCenter = function(width, height) {
    return {
        top: (window.screen.height - height) / 2,
        left: (window.screen.width - width) / 2
    };
};
function $09f51b2e589c6d41$var$windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = $09f51b2e589c6d41$var$__rest(_a, [
        "height",
        "width"
    ]);
    var config = $09f51b2e589c6d41$var$__assign({
        height: height,
        width: width,
        location: "no",
        toolbar: "no",
        status: "no",
        directories: "no",
        menubar: "no",
        scrollbars: "yes",
        resizable: "no",
        centerscreen: "yes",
        chrome: "yes"
    }, configRest);
    var shareDialog = window.open(url, "", Object.keys(config).map(function(key) {
        return "".concat(key, "=").concat(config[key]);
    }).join(", "));
    if (onClose) var interval_1 = window.setInterval(function() {
        try {
            if (shareDialog === null || shareDialog.closed) {
                window.clearInterval(interval_1);
                onClose(shareDialog);
            }
        } catch (e) {
            /* eslint-disable no-console */ console.error(e);
        /* eslint-enable no-console */ }
    }, 1000);
    return shareDialog;
}
var $09f51b2e589c6d41$var$ShareButton = /** @class */ function(_super) {
    $09f51b2e589c6d41$var$__extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function(link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? "windowCenter" : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = $09f51b2e589c6d41$var$__assign({
                height: windowHeight,
                width: windowWidth
            }, windowPosition === "windowCenter" ? $09f51b2e589c6d41$var$getBoxPositionOnWindowCenter(windowWidth, windowHeight) : $09f51b2e589c6d41$var$getBoxPositionOnScreenCenter(windowWidth, windowHeight));
            $09f51b2e589c6d41$var$windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function(event) {
            return $09f51b2e589c6d41$var$__awaiter(_this, void 0, void 0, function() {
                var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
                return $09f51b2e589c6d41$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                            link = networkLink(url, opts);
                            if (disabled) return [
                                2 /*return*/ 
                            ];
                            event.preventDefault();
                            if (!beforeOnClick) return [
                                3 /*break*/ ,
                                2
                            ];
                            returnVal = beforeOnClick();
                            if (!$09f51b2e589c6d41$var$isPromise(returnVal)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                returnVal
                            ];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            if (openShareDialogOnClick) this.openShareDialog(link);
                            if (onClick) onClick(event, link);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _this;
    }
    ShareButton.prototype.render = function() {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = $09f51b2e589c6d41$var$__rest(_a, [
            "beforeOnClick",
            "children",
            "className",
            "disabled",
            "disabledStyle",
            "forwardedRef",
            "networkLink",
            "networkName",
            "onShareWindowClose",
            "openShareDialogOnClick",
            "opts",
            "resetButtonStyle",
            "style",
            "url",
            "windowHeight",
            "windowPosition",
            "windowWidth"
        ]);
        var newClassName = (0, (/*@__PURE__*/$parcel$interopDefault($a25f5a5ebb44e773$exports)))("react-share__ShareButton", {
            "react-share__ShareButton--disabled": !!disabled,
            disabled: !!disabled
        }, className);
        var newStyle = resetButtonStyle ? $09f51b2e589c6d41$var$__assign($09f51b2e589c6d41$var$__assign({
            backgroundColor: "transparent",
            border: "none",
            padding: 0,
            font: "inherit",
            color: "inherit",
            cursor: "pointer"
        }, style), disabled && disabledStyle) : $09f51b2e589c6d41$var$__assign($09f51b2e589c6d41$var$__assign({}, style), disabled && disabledStyle);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement("button", $09f51b2e589c6d41$var$__assign({}, rest, {
            "aria-label": rest["aria-label"] || networkName,
            className: newClassName,
            onClick: this.handleClick,
            ref: forwardedRef,
            style: newStyle
        }), children);
    };
    ShareButton.defaultProps = {
        disabledStyle: {
            opacity: 0.6
        },
        openShareDialogOnClick: true,
        resetButtonStyle: true
    };
    return ShareButton;
}((0, $eXaQ2.Component));
var $09f51b2e589c6d41$export$2e2bcd8739ae039 = $09f51b2e589c6d41$var$ShareButton;


var $3bc770cb2f2834f1$var$__assign = undefined && undefined.__assign || function() {
    $3bc770cb2f2834f1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bc770cb2f2834f1$var$__assign.apply(this, arguments);
};
function $3bc770cb2f2834f1$var$createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = $3bc770cb2f2834f1$var$__assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function(key) {
            delete passedProps[key];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).createElement((0, $09f51b2e589c6d41$exports.default), $3bc770cb2f2834f1$var$__assign({}, defaultProps, passedProps, {
            forwardedRef: ref,
            networkName: networkName,
            networkLink: link,
            opts: optsMap(props)
        }));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0, $eXaQ2.forwardRef)(CreatedButton);
}
var $3bc770cb2f2834f1$export$2e2bcd8739ae039 = $3bc770cb2f2834f1$var$createShareButton;


function $0b964c456c1e8428$var$emailLink(url, _a) {
    var subject = _a.subject, body = _a.body, separator = _a.separator;
    return "mailto:" + (0, $6065224640359e1b$export$2e2bcd8739ae039)({
        subject: subject,
        body: body ? body + separator + url : url
    });
}
var $0b964c456c1e8428$var$EmailShareButton = (0, $3bc770cb2f2834f1$exports.default)("email", $0b964c456c1e8428$var$emailLink, function(props) {
    return {
        subject: props.subject,
        body: props.body,
        separator: props.separator || " "
    };
}, {
    openShareDialogOnClick: false,
    onClick: function(_, link) {
        window.location.href = link;
    }
});
var $0b964c456c1e8428$export$2e2bcd8739ae039 = $0b964c456c1e8428$var$EmailShareButton;


var $8a159eb746c45103$var$FacebookIcon = (0, $bdde851a722932d6$exports.default)({
    color: "#3b5998",
    networkName: "facebook",
    path: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
});
var $8a159eb746c45103$export$2e2bcd8739ae039 = $8a159eb746c45103$var$FacebookIcon;

var $6a1546248535b551$exports = {};

$parcel$export($6a1546248535b551$exports, "default", function () { return $6a1546248535b551$export$2e2bcd8739ae039; });
var $6a1546248535b551$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6a1546248535b551$var$AssertionError = /** @class */ function(_super) {
    $6a1546248535b551$var$__extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "AssertionError";
        return _this;
    }
    return AssertionError;
}(Error);
function $6a1546248535b551$export$2e2bcd8739ae039(value, message) {
    if (!value) throw new $6a1546248535b551$var$AssertionError(message);
}




function $71d7f456c2bcf939$var$facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    (0, $6a1546248535b551$exports.default)(url, "facebook.url");
    return "https://www.facebook.com/sharer/sharer.php" + (0, $6065224640359e1b$export$2e2bcd8739ae039)({
        u: url,
        quote: quote,
        hashtag: hashtag
    });
}
var $71d7f456c2bcf939$var$FacebookShareButton = (0, $3bc770cb2f2834f1$exports.default)("facebook", $71d7f456c2bcf939$var$facebookLink, function(props) {
    return {
        quote: props.quote,
        hashtag: props.hashtag
    };
}, {
    windowWidth: 550,
    windowHeight: 400
});
var $71d7f456c2bcf939$export$2e2bcd8739ae039 = $71d7f456c2bcf939$var$FacebookShareButton;


var $6bea8182eabe6443$var$PinterestIcon = (0, $bdde851a722932d6$exports.default)({
    color: "#cb2128",
    networkName: "pinterest",
    path: "M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z"
});
var $6bea8182eabe6443$export$2e2bcd8739ae039 = $6bea8182eabe6443$var$PinterestIcon;




function $fd67a11c65e70f21$var$pinterestLink(url, _a) {
    var media = _a.media, description = _a.description;
    (0, $6a1546248535b551$exports.default)(url, "pinterest.url");
    (0, $6a1546248535b551$exports.default)(media, "pinterest.media");
    return "https://pinterest.com/pin/create/button/" + (0, $6065224640359e1b$export$2e2bcd8739ae039)({
        url: url,
        media: media,
        description: description
    });
}
var $fd67a11c65e70f21$var$PinterestShareButton = (0, $3bc770cb2f2834f1$exports.default)("pinterest", $fd67a11c65e70f21$var$pinterestLink, function(props) {
    return {
        media: props.media,
        description: props.description
    };
}, {
    windowWidth: 1000,
    windowHeight: 730
});
var $fd67a11c65e70f21$export$2e2bcd8739ae039 = $fd67a11c65e70f21$var$PinterestShareButton;


var $a14054030ee52bfe$var$TwitterIcon = (0, $bdde851a722932d6$exports.default)({
    color: "#00aced",
    networkName: "twitter",
    path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
var $a14054030ee52bfe$export$2e2bcd8739ae039 = $a14054030ee52bfe$var$TwitterIcon;




function $f7f2e2987282f3eb$var$twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    (0, $6a1546248535b551$exports.default)(url, "twitter.url");
    (0, $6a1546248535b551$exports.default)(Array.isArray(hashtags), "twitter.hashtags is not an array");
    (0, $6a1546248535b551$exports.default)(Array.isArray(related), "twitter.related is not an array");
    return "https://twitter.com/share" + (0, $6065224640359e1b$export$2e2bcd8739ae039)({
        url: url,
        text: title,
        via: via,
        hashtags: hashtags.length > 0 ? hashtags.join(",") : undefined,
        related: related.length > 0 ? related.join(",") : undefined
    });
}
var $f7f2e2987282f3eb$var$TwitterShareButton = (0, $3bc770cb2f2834f1$exports.default)("twitter", $f7f2e2987282f3eb$var$twitterLink, function(props) {
    return {
        hashtags: props.hashtags,
        title: props.title,
        via: props.via,
        related: props.related
    };
}, {
    windowWidth: 550,
    windowHeight: 400
});
var $f7f2e2987282f3eb$export$2e2bcd8739ae039 = $f7f2e2987282f3eb$var$TwitterShareButton;


var $d9f5b5fd2b946ae4$var$WhatsappIcon = (0, $bdde851a722932d6$exports.default)({
    color: "#25D366",
    networkName: "whatsapp",
    path: "m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915"
});
var $d9f5b5fd2b946ae4$export$2e2bcd8739ae039 = $d9f5b5fd2b946ae4$var$WhatsappIcon;




function $117188c0d5dcac7f$var$isMobileOrTablet() {
    return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}
function $117188c0d5dcac7f$var$whatsappLink(url, _a) {
    var title = _a.title, separator = _a.separator;
    (0, $6a1546248535b551$exports.default)(url, "whatsapp.url");
    return "https://" + ($117188c0d5dcac7f$var$isMobileOrTablet() ? "api" : "web") + ".whatsapp.com/send" + (0, $6065224640359e1b$export$2e2bcd8739ae039)({
        text: title ? title + separator + url : url
    });
}
var $117188c0d5dcac7f$var$WhatsappShareButton = (0, $3bc770cb2f2834f1$exports.default)("whatsapp", $117188c0d5dcac7f$var$whatsappLink, function(props) {
    return {
        title: props.title,
        separator: props.separator || " "
    };
}, {
    windowWidth: 550,
    windowHeight: 400
});
var $117188c0d5dcac7f$export$2e2bcd8739ae039 = $117188c0d5dcac7f$var$WhatsappShareButton;




var $bf64202f0e346303$exports = {};

$bf64202f0e346303$exports = new URL((parcelRequire("20Q2C")).resolve("5jQuC"), import.meta.url).toString();


const $230c037f02067870$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
        className: "mt-20 w-full bg-gray-900 py-10",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
            className: "mx-auto max-w-7xl px-2",
            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "mb-6 grid-cols-3 md:grid",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "col-span-2 text-center md:text-left",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                            href: "/",
                            className: "font-mono text-sm uppercase tracking-tight text-white md:text-xl",
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($bf64202f0e346303$exports))),
                                className: "mx-auto w-32 md:mx-0 md:w-44"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "mt-6 grid grid-cols-4 place-items-center text-center text-sm text-gray-200 md:mt-0",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                                    to: "/terms",
                                    children: "Terms"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                                    to: "/privacy",
                                    children: "Privacy"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                                    to: "/about-us",
                                    children: "About Us"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                                    to: "/contact",
                                    children: "Contact"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $230c037f02067870$export$2e2bcd8739ae039 = $230c037f02067870$var$Footer;


const $8a4d8776ca5ad60e$var$Article = ()=>{
    var _article_primary_image_data, _article_author_data_attributes_avatar_data, _article_author_data, _article_author_data1, _article_author_data2, _article_primary_image_data1;
    const { slug: slug } = (0, $3fc8353d3146dc49$export$99eaa27ddbbb95ef)();
    const { loading: loading, error: error, data: data } = (0, $cb89595d8b20dae2$export$dd0a697e1782aedd)((0, $4f9b5537dbedb61d$export$2e2bcd8739ae039)(slug));
    if (error) return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
        children: "Error :("
    });
    const article = data === null || data === void 0 ? void 0 : data.articles.data[0].attributes;
    const location = (0, $3fc8353d3146dc49$export$45d76561a5302f2b)();
    const fullURL = window.location.href + "?utm_source=shareIcon";
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $a1cc52fbd40b0eb4$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $86a0a2c7143f17cc$export$2e2bcd8739ae039), {
                title: article && article.title ? article.title + " | Penny Pincher News" : "Loading... | Penny Pincher News",
                description: article && article.preview_text ? article.preview_text : "Penny Pincher News",
                children: loading ? /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4366a99288ef8d33$exports.default), {
                        color: "#5850E0"
                    })
                }) : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                    className: "relative mx-auto max-w-7xl px-4",
                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        className: "gap-8 lg:flex",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                className: "basis-3/4",
                                itemScope: true,
                                itemType: "https://schema.org/NewsArticle",
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: (0, $d2b3ba3d4a6ef45d$export$a274e22fb40f762e)("inline text-xs font-black md:text-base", article.category.data.attributes.category_color ? `text-${article.category.data.attributes.category_color}` : "text-blue-500"),
                                        children: article.category.data.attributes.name
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "mt-2 text-xl font-bold md:mt-4 md:text-3xl",
                                        itemProp: "headline",
                                        children: article.title
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                        className: "mt-4 h-[250px] w-full rounded-lg object-cover md:h-[500px]",
                                        itemProp: "image",
                                        src: (_article_primary_image_data = article.primary_image.data) === null || _article_primary_image_data === void 0 ? void 0 : _article_primary_image_data.attributes.url
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "mt-4 text-xs text-gray-500 md:text-sm"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                        className: "relative mt-8 flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                                src: (_article_author_data_attributes_avatar_data = (_article_author_data = article.author.data) === null || _article_author_data === void 0 ? void 0 : _article_author_data.attributes.avatar.data) === null || _article_author_data_attributes_avatar_data === void 0 ? void 0 : _article_author_data_attributes_avatar_data.attributes.url,
                                                alt: "",
                                                className: "h-10 w-10 rounded-full bg-gray-50 object-cover"
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                                className: "text-sm leading-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("p", {
                                                        className: "font-semibold text-gray-900",
                                                        children: [
                                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                                                className: "absolute inset-0"
                                                            }),
                                                            (_article_author_data1 = article.author.data) === null || _article_author_data1 === void 0 ? void 0 : _article_author_data1.attributes.name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                                        className: "text-gray-600",
                                                        children: (_article_author_data2 = article.author.data) === null || _article_author_data2 === void 0 ? void 0 : _article_author_data2.attributes.role
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                        className: "mt-2 text-sm text-gray-500 md:mt-6 md:text-base",
                                        itemProp: "datePublished",
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                                className: "mr-1",
                                                children: "Published on:"
                                            }),
                                            new Date(article.publishedAt).toLocaleString("en-US", {
                                                year: "numeric",
                                                month: "long",
                                                day: "2-digit",
                                                hour: "numeric",
                                                minute: "2-digit",
                                                hour12: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "my-4 2xl:absolute 2xl:sticky 2xl:top-[140px] 2xl:float-left 2xl:-ml-20 2xl:-mt-1 2xl:h-20",
                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "2xl:grid 2xl:grid-cols-1 2xl:gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "pb-2 text-xs font-bold uppercase text-gray-600 sm:mr-2 sm:inline-block sm:pt-3 sm:align-top sm:text-sm 2xl:-ml-4 2xl:pb-0",
                                                    children: "Share on:"
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $71d7f456c2bcf939$export$2e2bcd8739ae039), {
                                                    url: fullURL,
                                                    quote: article.title,
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $8a159eb746c45103$export$2e2bcd8739ae039), {
                                                        round: true,
                                                        size: 42,
                                                        className: "share-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $f7f2e2987282f3eb$export$2e2bcd8739ae039), {
                                                    url: fullURL,
                                                    title: article.title,
                                                    className: "ml-2 2xl:ml-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $a14054030ee52bfe$export$2e2bcd8739ae039), {
                                                        round: true,
                                                        size: 42,
                                                        className: "share-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $fd67a11c65e70f21$export$2e2bcd8739ae039), {
                                                    url: fullURL,
                                                    media: (_article_primary_image_data1 = article.primary_image.data) === null || _article_primary_image_data1 === void 0 ? void 0 : _article_primary_image_data1.attributes.url,
                                                    description: article.title,
                                                    className: "ml-2 2xl:ml-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6bea8182eabe6443$export$2e2bcd8739ae039), {
                                                        round: true,
                                                        size: 42,
                                                        className: "share-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $117188c0d5dcac7f$export$2e2bcd8739ae039), {
                                                    url: fullURL,
                                                    title: article.title,
                                                    className: "ml-2 2xl:ml-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $d9f5b5fd2b946ae4$export$2e2bcd8739ae039), {
                                                        round: true,
                                                        size: 42,
                                                        className: "share-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $0b964c456c1e8428$export$2e2bcd8739ae039), {
                                                    url: fullURL,
                                                    subject: article.title,
                                                    body: "Check out this article on PennyPincher.com!",
                                                    separator: "\n \n",
                                                    className: "ml-2 2xl:ml-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4e5d9c2e70cb7e4d$export$2e2bcd8739ae039), {
                                                        round: true,
                                                        size: 42,
                                                        className: "share-icon"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "my-4 w-36 border-b-[8px] border-gray-800 md:w-56"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        itemProp: "articleBody",
                                        className: "article-body prose max-w-none",
                                        dangerouslySetInnerHTML: {
                                            __html: article.content
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $16b22f66b453992c$export$2e2bcd8739ae039), {
                                        article: article,
                                        stories: data.articles.data[0].attributes.category.data.attributes
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "basis-1/4",
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "sticky top-28"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $230c037f02067870$export$2e2bcd8739ae039), {})
        ]
    });
};
var $8a4d8776ca5ad60e$export$2e2bcd8739ae039 = $8a4d8776ca5ad60e$var$Article;






var $eXaQ2 = parcelRequire("eXaQ2");






const $d3dc59bec2c4e97a$var$FeaturedPost = ({ article: article })=>{
    return article ? /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {}) : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {});
};
var $d3dc59bec2c4e97a$export$2e2bcd8739ae039 = $d3dc59bec2c4e97a$var$FeaturedPost;




var $eXaQ2 = parcelRequire("eXaQ2");


const $55aef0c5205c5471$var$ArticleFeedVersion2 = ({ featuredArticle: featuredArticle, articles: articles, from: from, textColor: textColor })=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
        className: "px-2 md:px-0",
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "text-md mb-4 mt-6 border-l-[8px] border-orange-600 pl-2 font-bold md:text-lg",
                children: from ? `Latest From ${from}` : "Latest Articles"
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "grid grid-cols-2 gap-4 md:gap-8",
                children: articles ? articles === null || articles === void 0 ? void 0 : articles.map((item, index)=>{
                    var _item_attributes_primary_image_data;
                    /*#__PURE__*/ return (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $eXaQ2.Fragment), {
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                            to: item.attributes.slug,
                            className: featuredArticle ? featuredArticle.featured_article.data.attributes.slug === item.attributes.slug ? "hidden" : "" : "",
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                className: "article-container",
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                        className: "mb-2 h-32 w-full rounded-lg object-cover md:h-52",
                                        src: (_item_attributes_primary_image_data = item.attributes.primary_image.data) === null || _item_attributes_primary_image_data === void 0 ? void 0 : _item_attributes_primary_image_data.attributes.url
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: (0, $d2b3ba3d4a6ef45d$export$a274e22fb40f762e)("inline text-xs font-black md:text-sm", textColor ? textColor : "text-blue-500"),
                                        children: item.category
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "headline line-clamp-3 text-sm font-semibold md:mt-1 md:line-clamp-3 md:text-lg md:tracking-tight",
                                        children: item.attributes.title
                                    })
                                ]
                            })
                        })
                    }, index);
                }) : Array(4).fill(0).map((_, ind)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        role: "status",
                        className: "grid animate-pulse grid-cols-1 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "flex items-center justify-center rounded bg-gray-300 dark:bg-gray-700",
                                style: {
                                    aspectRatio: 16 / 9
                                },
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                    className: "h-12 w-12 text-gray-200",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    fill: "currentColor",
                                    viewBox: "0 0 640 512",
                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                        d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "flex w-full flex-col items-center justify-center",
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "mb-4 h-3 w-full rounded-full bg-gray-200 dark:bg-gray-700"
                                })
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                className: "sr-only",
                                children: "Loading..."
                            })
                        ]
                    }, ind))
            })
        ]
    });
};
var $55aef0c5205c5471$export$2e2bcd8739ae039 = $55aef0c5205c5471$var$ArticleFeedVersion2;




var $eXaQ2 = parcelRequire("eXaQ2");


"use strict";
function $cf1d9957b8ad3fd5$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $f04166365b052d26$var$toString } = Object.prototype;
const { getPrototypeOf: $f04166365b052d26$var$getPrototypeOf } = Object;
const $f04166365b052d26$var$kindOf = ((cache)=>(thing)=>{
        const str = $f04166365b052d26$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $f04166365b052d26$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$f04166365b052d26$var$kindOf(thing) === type;
};
const $f04166365b052d26$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $f04166365b052d26$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $f04166365b052d26$var$isUndefined = $f04166365b052d26$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $f04166365b052d26$var$isBuffer(val) {
    return val !== null && !$f04166365b052d26$var$isUndefined(val) && val.constructor !== null && !$f04166365b052d26$var$isUndefined(val.constructor) && $f04166365b052d26$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $f04166365b052d26$var$isArrayBuffer = $f04166365b052d26$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $f04166365b052d26$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $f04166365b052d26$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $f04166365b052d26$var$isString = $f04166365b052d26$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $f04166365b052d26$var$isFunction = $f04166365b052d26$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $f04166365b052d26$var$isNumber = $f04166365b052d26$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $f04166365b052d26$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $f04166365b052d26$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $f04166365b052d26$var$isPlainObject = (val)=>{
    if ($f04166365b052d26$var$kindOf(val) !== "object") return false;
    const prototype = $f04166365b052d26$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $f04166365b052d26$var$isDate = $f04166365b052d26$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $f04166365b052d26$var$isFile = $f04166365b052d26$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $f04166365b052d26$var$isBlob = $f04166365b052d26$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $f04166365b052d26$var$isFileList = $f04166365b052d26$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $f04166365b052d26$var$isStream = (val)=>$f04166365b052d26$var$isObject(val) && $f04166365b052d26$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $f04166365b052d26$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $f04166365b052d26$var$isFunction(thing.append) && ((kind = $f04166365b052d26$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $f04166365b052d26$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $f04166365b052d26$var$isURLSearchParams = $f04166365b052d26$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $f04166365b052d26$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $f04166365b052d26$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($f04166365b052d26$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $f04166365b052d26$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $f04166365b052d26$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $f04166365b052d26$var$isContextDefined = (context)=>!$f04166365b052d26$var$isUndefined(context) && context !== $f04166365b052d26$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $f04166365b052d26$var$merge() {
    const { caseless: caseless } = $f04166365b052d26$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $f04166365b052d26$var$findKey(result, key) || key;
        if ($f04166365b052d26$var$isPlainObject(result[targetKey]) && $f04166365b052d26$var$isPlainObject(val)) result[targetKey] = $f04166365b052d26$var$merge(result[targetKey], val);
        else if ($f04166365b052d26$var$isPlainObject(val)) result[targetKey] = $f04166365b052d26$var$merge({}, val);
        else if ($f04166365b052d26$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $f04166365b052d26$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $f04166365b052d26$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $f04166365b052d26$var$forEach(b, (val, key)=>{
        if (thisArg && $f04166365b052d26$var$isFunction(val)) a[key] = (0, $cf1d9957b8ad3fd5$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $f04166365b052d26$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $f04166365b052d26$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $f04166365b052d26$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $f04166365b052d26$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $f04166365b052d26$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $f04166365b052d26$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($f04166365b052d26$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$f04166365b052d26$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $f04166365b052d26$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $f04166365b052d26$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $f04166365b052d26$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $f04166365b052d26$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $f04166365b052d26$var$isHTMLForm = $f04166365b052d26$var$kindOfTest("HTMLFormElement");
const $f04166365b052d26$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $f04166365b052d26$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $f04166365b052d26$var$isRegExp = $f04166365b052d26$var$kindOfTest("RegExp");
const $f04166365b052d26$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $f04166365b052d26$var$forEach(descriptors, (descriptor, name)=>{
        if (reducer(descriptor, name, obj) !== false) reducedDescriptors[name] = descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $f04166365b052d26$var$freezeMethods = (obj)=>{
    $f04166365b052d26$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($f04166365b052d26$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$f04166365b052d26$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $f04166365b052d26$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $f04166365b052d26$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $f04166365b052d26$var$noop = ()=>{};
const $f04166365b052d26$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $f04166365b052d26$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $f04166365b052d26$var$DIGIT = "0123456789";
const $f04166365b052d26$var$ALPHABET = {
    DIGIT: $f04166365b052d26$var$DIGIT,
    ALPHA: $f04166365b052d26$var$ALPHA,
    ALPHA_DIGIT: $f04166365b052d26$var$ALPHA + $f04166365b052d26$var$ALPHA.toUpperCase() + $f04166365b052d26$var$DIGIT
};
const $f04166365b052d26$var$generateString = (size = 16, alphabet = $f04166365b052d26$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $f04166365b052d26$var$isSpecCompliantForm(thing) {
    return !!(thing && $f04166365b052d26$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $f04166365b052d26$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($f04166365b052d26$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $f04166365b052d26$var$isArray(source) ? [] : {};
                $f04166365b052d26$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$f04166365b052d26$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $f04166365b052d26$var$isAsyncFn = $f04166365b052d26$var$kindOfTest("AsyncFunction");
const $f04166365b052d26$var$isThenable = (thing)=>thing && ($f04166365b052d26$var$isObject(thing) || $f04166365b052d26$var$isFunction(thing)) && $f04166365b052d26$var$isFunction(thing.then) && $f04166365b052d26$var$isFunction(thing.catch);
var $f04166365b052d26$export$2e2bcd8739ae039 = {
    isArray: $f04166365b052d26$var$isArray,
    isArrayBuffer: $f04166365b052d26$var$isArrayBuffer,
    isBuffer: $f04166365b052d26$var$isBuffer,
    isFormData: $f04166365b052d26$var$isFormData,
    isArrayBufferView: $f04166365b052d26$var$isArrayBufferView,
    isString: $f04166365b052d26$var$isString,
    isNumber: $f04166365b052d26$var$isNumber,
    isBoolean: $f04166365b052d26$var$isBoolean,
    isObject: $f04166365b052d26$var$isObject,
    isPlainObject: $f04166365b052d26$var$isPlainObject,
    isUndefined: $f04166365b052d26$var$isUndefined,
    isDate: $f04166365b052d26$var$isDate,
    isFile: $f04166365b052d26$var$isFile,
    isBlob: $f04166365b052d26$var$isBlob,
    isRegExp: $f04166365b052d26$var$isRegExp,
    isFunction: $f04166365b052d26$var$isFunction,
    isStream: $f04166365b052d26$var$isStream,
    isURLSearchParams: $f04166365b052d26$var$isURLSearchParams,
    isTypedArray: $f04166365b052d26$var$isTypedArray,
    isFileList: $f04166365b052d26$var$isFileList,
    forEach: $f04166365b052d26$var$forEach,
    merge: $f04166365b052d26$var$merge,
    extend: $f04166365b052d26$var$extend,
    trim: $f04166365b052d26$var$trim,
    stripBOM: $f04166365b052d26$var$stripBOM,
    inherits: $f04166365b052d26$var$inherits,
    toFlatObject: $f04166365b052d26$var$toFlatObject,
    kindOf: $f04166365b052d26$var$kindOf,
    kindOfTest: $f04166365b052d26$var$kindOfTest,
    endsWith: $f04166365b052d26$var$endsWith,
    toArray: $f04166365b052d26$var$toArray,
    forEachEntry: $f04166365b052d26$var$forEachEntry,
    matchAll: $f04166365b052d26$var$matchAll,
    isHTMLForm: $f04166365b052d26$var$isHTMLForm,
    hasOwnProperty: $f04166365b052d26$var$hasOwnProperty,
    hasOwnProp: $f04166365b052d26$var$hasOwnProperty,
    reduceDescriptors: $f04166365b052d26$var$reduceDescriptors,
    freezeMethods: $f04166365b052d26$var$freezeMethods,
    toObjectSet: $f04166365b052d26$var$toObjectSet,
    toCamelCase: $f04166365b052d26$var$toCamelCase,
    noop: $f04166365b052d26$var$noop,
    toFiniteNumber: $f04166365b052d26$var$toFiniteNumber,
    findKey: $f04166365b052d26$var$findKey,
    global: $f04166365b052d26$var$_global,
    isContextDefined: $f04166365b052d26$var$isContextDefined,
    ALPHABET: $f04166365b052d26$var$ALPHABET,
    generateString: $f04166365b052d26$var$generateString,
    isSpecCompliantForm: $f04166365b052d26$var$isSpecCompliantForm,
    toJSONObject: $f04166365b052d26$var$toJSONObject,
    isAsyncFn: $f04166365b052d26$var$isAsyncFn,
    isThenable: $f04166365b052d26$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $88fed3efb32a29b2$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $f04166365b052d26$export$2e2bcd8739ae039).inherits($88fed3efb32a29b2$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $f04166365b052d26$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $88fed3efb32a29b2$var$prototype = $88fed3efb32a29b2$var$AxiosError.prototype;
const $88fed3efb32a29b2$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $88fed3efb32a29b2$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($88fed3efb32a29b2$var$AxiosError, $88fed3efb32a29b2$var$descriptors);
Object.defineProperty($88fed3efb32a29b2$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$88fed3efb32a29b2$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($88fed3efb32a29b2$var$prototype);
    (0, $f04166365b052d26$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $88fed3efb32a29b2$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $88fed3efb32a29b2$export$2e2bcd8739ae039 = $88fed3efb32a29b2$var$AxiosError;


// eslint-disable-next-line strict
var $7795102a8dca891e$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $eb82b2fbe6e05f81$export$a143d493d941bafc;
var $eb82b2fbe6e05f81$export$e4cf37d7f6fb9e0a;
var $eb82b2fbe6e05f81$export$f99ded8fe4b79145;
var $eb82b2fbe6e05f81$export$599f31c3813fae4d;
"use strict";
var $3edd0946852b9107$export$a48f0734ac7c2329;
var $3edd0946852b9107$export$d622b2ad8d90c771;
var $3edd0946852b9107$export$6100ba28696e12de;
"use strict";
$3edd0946852b9107$export$a48f0734ac7c2329 = $3edd0946852b9107$var$byteLength;
$3edd0946852b9107$export$d622b2ad8d90c771 = $3edd0946852b9107$var$toByteArray;
$3edd0946852b9107$export$6100ba28696e12de = $3edd0946852b9107$var$fromByteArray;
var $3edd0946852b9107$var$lookup = [];
var $3edd0946852b9107$var$revLookup = [];
var $3edd0946852b9107$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3edd0946852b9107$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3edd0946852b9107$var$i = 0, $3edd0946852b9107$var$len = $3edd0946852b9107$var$code.length; $3edd0946852b9107$var$i < $3edd0946852b9107$var$len; ++$3edd0946852b9107$var$i){
    $3edd0946852b9107$var$lookup[$3edd0946852b9107$var$i] = $3edd0946852b9107$var$code[$3edd0946852b9107$var$i];
    $3edd0946852b9107$var$revLookup[$3edd0946852b9107$var$code.charCodeAt($3edd0946852b9107$var$i)] = $3edd0946852b9107$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3edd0946852b9107$var$revLookup["-".charCodeAt(0)] = 62;
$3edd0946852b9107$var$revLookup["_".charCodeAt(0)] = 63;
function $3edd0946852b9107$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3edd0946852b9107$var$byteLength(b64) {
    var lens = $3edd0946852b9107$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3edd0946852b9107$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3edd0946852b9107$var$toByteArray(b64) {
    var tmp;
    var lens = $3edd0946852b9107$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3edd0946852b9107$var$Arr($3edd0946852b9107$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3edd0946852b9107$var$revLookup[b64.charCodeAt(i)] << 18 | $3edd0946852b9107$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3edd0946852b9107$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3edd0946852b9107$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3edd0946852b9107$var$revLookup[b64.charCodeAt(i)] << 2 | $3edd0946852b9107$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3edd0946852b9107$var$revLookup[b64.charCodeAt(i)] << 10 | $3edd0946852b9107$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3edd0946852b9107$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3edd0946852b9107$var$tripletToBase64(num) {
    return $3edd0946852b9107$var$lookup[num >> 18 & 0x3F] + $3edd0946852b9107$var$lookup[num >> 12 & 0x3F] + $3edd0946852b9107$var$lookup[num >> 6 & 0x3F] + $3edd0946852b9107$var$lookup[num & 0x3F];
}
function $3edd0946852b9107$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3edd0946852b9107$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3edd0946852b9107$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3edd0946852b9107$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3edd0946852b9107$var$lookup[tmp >> 2] + $3edd0946852b9107$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3edd0946852b9107$var$lookup[tmp >> 10] + $3edd0946852b9107$var$lookup[tmp >> 4 & 0x3F] + $3edd0946852b9107$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $30e6e6b4ecf2dddc$export$aafa59e2e03f2942;
var $30e6e6b4ecf2dddc$export$68d8715fc104d294;
$30e6e6b4ecf2dddc$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$30e6e6b4ecf2dddc$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $eb82b2fbe6e05f81$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$eb82b2fbe6e05f81$export$a143d493d941bafc = $eb82b2fbe6e05f81$var$Buffer;
$eb82b2fbe6e05f81$export$e4cf37d7f6fb9e0a = $eb82b2fbe6e05f81$var$SlowBuffer;
$eb82b2fbe6e05f81$export$f99ded8fe4b79145 = 50;
var $eb82b2fbe6e05f81$var$K_MAX_LENGTH = 0x7fffffff;
$eb82b2fbe6e05f81$export$599f31c3813fae4d = $eb82b2fbe6e05f81$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $eb82b2fbe6e05f81$var$Buffer.TYPED_ARRAY_SUPPORT = $eb82b2fbe6e05f81$var$typedArraySupport();
if (!$eb82b2fbe6e05f81$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $eb82b2fbe6e05f81$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($eb82b2fbe6e05f81$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$eb82b2fbe6e05f81$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($eb82b2fbe6e05f81$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$eb82b2fbe6e05f81$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $eb82b2fbe6e05f81$var$createBuffer(length) {
    if (length > $eb82b2fbe6e05f81$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $eb82b2fbe6e05f81$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $eb82b2fbe6e05f81$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $eb82b2fbe6e05f81$var$allocUnsafe(arg);
    }
    return $eb82b2fbe6e05f81$var$from(arg, encodingOrOffset, length);
}
$eb82b2fbe6e05f81$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $eb82b2fbe6e05f81$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $eb82b2fbe6e05f81$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $eb82b2fbe6e05f81$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($eb82b2fbe6e05f81$var$isInstance(value, ArrayBuffer) || value && $eb82b2fbe6e05f81$var$isInstance(value.buffer, ArrayBuffer)) return $eb82b2fbe6e05f81$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($eb82b2fbe6e05f81$var$isInstance(value, SharedArrayBuffer) || value && $eb82b2fbe6e05f81$var$isInstance(value.buffer, SharedArrayBuffer))) return $eb82b2fbe6e05f81$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $eb82b2fbe6e05f81$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $eb82b2fbe6e05f81$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $eb82b2fbe6e05f81$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $eb82b2fbe6e05f81$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $eb82b2fbe6e05f81$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($eb82b2fbe6e05f81$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($eb82b2fbe6e05f81$var$Buffer, Uint8Array);
function $eb82b2fbe6e05f81$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $eb82b2fbe6e05f81$var$alloc(size, fill, encoding) {
    $eb82b2fbe6e05f81$var$assertSize(size);
    if (size <= 0) return $eb82b2fbe6e05f81$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $eb82b2fbe6e05f81$var$createBuffer(size).fill(fill, encoding) : $eb82b2fbe6e05f81$var$createBuffer(size).fill(fill);
    return $eb82b2fbe6e05f81$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $eb82b2fbe6e05f81$var$Buffer.alloc = function(size, fill, encoding) {
    return $eb82b2fbe6e05f81$var$alloc(size, fill, encoding);
};
function $eb82b2fbe6e05f81$var$allocUnsafe(size) {
    $eb82b2fbe6e05f81$var$assertSize(size);
    return $eb82b2fbe6e05f81$var$createBuffer(size < 0 ? 0 : $eb82b2fbe6e05f81$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $eb82b2fbe6e05f81$var$Buffer.allocUnsafe = function(size) {
    return $eb82b2fbe6e05f81$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $eb82b2fbe6e05f81$var$Buffer.allocUnsafeSlow = function(size) {
    return $eb82b2fbe6e05f81$var$allocUnsafe(size);
};
function $eb82b2fbe6e05f81$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$eb82b2fbe6e05f81$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $eb82b2fbe6e05f81$var$byteLength(string, encoding) | 0;
    var buf = $eb82b2fbe6e05f81$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $eb82b2fbe6e05f81$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $eb82b2fbe6e05f81$var$checked(array.length) | 0;
    var buf = $eb82b2fbe6e05f81$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $eb82b2fbe6e05f81$var$fromArrayView(arrayView) {
    if ($eb82b2fbe6e05f81$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $eb82b2fbe6e05f81$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $eb82b2fbe6e05f81$var$fromArrayLike(arrayView);
}
function $eb82b2fbe6e05f81$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $eb82b2fbe6e05f81$var$Buffer.prototype);
    return buf;
}
function $eb82b2fbe6e05f81$var$fromObject(obj) {
    if ($eb82b2fbe6e05f81$var$Buffer.isBuffer(obj)) {
        var len = $eb82b2fbe6e05f81$var$checked(obj.length) | 0;
        var buf = $eb82b2fbe6e05f81$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $eb82b2fbe6e05f81$var$numberIsNaN(obj.length)) return $eb82b2fbe6e05f81$var$createBuffer(0);
        return $eb82b2fbe6e05f81$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $eb82b2fbe6e05f81$var$fromArrayLike(obj.data);
}
function $eb82b2fbe6e05f81$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $eb82b2fbe6e05f81$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $eb82b2fbe6e05f81$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $eb82b2fbe6e05f81$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $eb82b2fbe6e05f81$var$Buffer.alloc(+length);
}
$eb82b2fbe6e05f81$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $eb82b2fbe6e05f81$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$eb82b2fbe6e05f81$var$Buffer.compare = function compare(a, b) {
    if ($eb82b2fbe6e05f81$var$isInstance(a, Uint8Array)) a = $eb82b2fbe6e05f81$var$Buffer.from(a, a.offset, a.byteLength);
    if ($eb82b2fbe6e05f81$var$isInstance(b, Uint8Array)) b = $eb82b2fbe6e05f81$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$eb82b2fbe6e05f81$var$Buffer.isBuffer(a) || !$eb82b2fbe6e05f81$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$eb82b2fbe6e05f81$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$eb82b2fbe6e05f81$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $eb82b2fbe6e05f81$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $eb82b2fbe6e05f81$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($eb82b2fbe6e05f81$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $eb82b2fbe6e05f81$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$eb82b2fbe6e05f81$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $eb82b2fbe6e05f81$var$byteLength(string, encoding) {
    if ($eb82b2fbe6e05f81$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $eb82b2fbe6e05f81$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $eb82b2fbe6e05f81$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $eb82b2fbe6e05f81$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $eb82b2fbe6e05f81$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$eb82b2fbe6e05f81$var$Buffer.byteLength = $eb82b2fbe6e05f81$var$byteLength;
function $eb82b2fbe6e05f81$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $eb82b2fbe6e05f81$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $eb82b2fbe6e05f81$var$utf8Slice(this, start, end);
        case "ascii":
            return $eb82b2fbe6e05f81$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $eb82b2fbe6e05f81$var$latin1Slice(this, start, end);
        case "base64":
            return $eb82b2fbe6e05f81$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $eb82b2fbe6e05f81$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$eb82b2fbe6e05f81$var$Buffer.prototype._isBuffer = true;
function $eb82b2fbe6e05f81$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$eb82b2fbe6e05f81$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$eb82b2fbe6e05f81$var$swap(this, i, i + 1);
    return this;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $eb82b2fbe6e05f81$var$swap(this, i, i + 3);
        $eb82b2fbe6e05f81$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $eb82b2fbe6e05f81$var$swap(this, i, i + 7);
        $eb82b2fbe6e05f81$var$swap(this, i + 1, i + 6);
        $eb82b2fbe6e05f81$var$swap(this, i + 2, i + 5);
        $eb82b2fbe6e05f81$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $eb82b2fbe6e05f81$var$utf8Slice(this, 0, length);
    return $eb82b2fbe6e05f81$var$slowToString.apply(this, arguments);
};
$eb82b2fbe6e05f81$var$Buffer.prototype.toLocaleString = $eb82b2fbe6e05f81$var$Buffer.prototype.toString;
$eb82b2fbe6e05f81$var$Buffer.prototype.equals = function equals(b) {
    if (!$eb82b2fbe6e05f81$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $eb82b2fbe6e05f81$var$Buffer.compare(this, b) === 0;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $eb82b2fbe6e05f81$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($eb82b2fbe6e05f81$var$customInspectSymbol) $eb82b2fbe6e05f81$var$Buffer.prototype[$eb82b2fbe6e05f81$var$customInspectSymbol] = $eb82b2fbe6e05f81$var$Buffer.prototype.inspect;
$eb82b2fbe6e05f81$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($eb82b2fbe6e05f81$var$isInstance(target, Uint8Array)) target = $eb82b2fbe6e05f81$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$eb82b2fbe6e05f81$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $eb82b2fbe6e05f81$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($eb82b2fbe6e05f81$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $eb82b2fbe6e05f81$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($eb82b2fbe6e05f81$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $eb82b2fbe6e05f81$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $eb82b2fbe6e05f81$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $eb82b2fbe6e05f81$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$eb82b2fbe6e05f81$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $eb82b2fbe6e05f81$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$eb82b2fbe6e05f81$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $eb82b2fbe6e05f81$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $eb82b2fbe6e05f81$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($eb82b2fbe6e05f81$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $eb82b2fbe6e05f81$var$utf8Write(buf, string, offset, length) {
    return $eb82b2fbe6e05f81$var$blitBuffer($eb82b2fbe6e05f81$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $eb82b2fbe6e05f81$var$asciiWrite(buf, string, offset, length) {
    return $eb82b2fbe6e05f81$var$blitBuffer($eb82b2fbe6e05f81$var$asciiToBytes(string), buf, offset, length);
}
function $eb82b2fbe6e05f81$var$base64Write(buf, string, offset, length) {
    return $eb82b2fbe6e05f81$var$blitBuffer($eb82b2fbe6e05f81$var$base64ToBytes(string), buf, offset, length);
}
function $eb82b2fbe6e05f81$var$ucs2Write(buf, string, offset, length) {
    return $eb82b2fbe6e05f81$var$blitBuffer($eb82b2fbe6e05f81$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$eb82b2fbe6e05f81$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $eb82b2fbe6e05f81$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $eb82b2fbe6e05f81$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $eb82b2fbe6e05f81$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $eb82b2fbe6e05f81$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $eb82b2fbe6e05f81$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$eb82b2fbe6e05f81$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $eb82b2fbe6e05f81$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3edd0946852b9107$export$6100ba28696e12de(buf);
    else return $3edd0946852b9107$export$6100ba28696e12de(buf.slice(start, end));
}
function $eb82b2fbe6e05f81$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $eb82b2fbe6e05f81$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $eb82b2fbe6e05f81$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $eb82b2fbe6e05f81$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $eb82b2fbe6e05f81$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $eb82b2fbe6e05f81$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $eb82b2fbe6e05f81$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $eb82b2fbe6e05f81$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $eb82b2fbe6e05f81$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $eb82b2fbe6e05f81$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $eb82b2fbe6e05f81$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$eb82b2fbe6e05f81$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $eb82b2fbe6e05f81$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $eb82b2fbe6e05f81$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$eb82b2fbe6e05f81$var$Buffer.prototype.readUintLE = $eb82b2fbe6e05f81$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readUintBE = $eb82b2fbe6e05f81$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readUint8 = $eb82b2fbe6e05f81$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readUint16LE = $eb82b2fbe6e05f81$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readUint16BE = $eb82b2fbe6e05f81$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readUint32LE = $eb82b2fbe6e05f81$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readUint32BE = $eb82b2fbe6e05f81$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 4, this.length);
    return $30e6e6b4ecf2dddc$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 4, this.length);
    return $30e6e6b4ecf2dddc$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 8, this.length);
    return $30e6e6b4ecf2dddc$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$eb82b2fbe6e05f81$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkOffset(offset, 8, this.length);
    return $30e6e6b4ecf2dddc$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $eb82b2fbe6e05f81$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$eb82b2fbe6e05f81$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$eb82b2fbe6e05f81$var$Buffer.prototype.writeUintLE = $eb82b2fbe6e05f81$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $eb82b2fbe6e05f81$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeUintBE = $eb82b2fbe6e05f81$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $eb82b2fbe6e05f81$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeUint8 = $eb82b2fbe6e05f81$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeUint16LE = $eb82b2fbe6e05f81$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeUint16BE = $eb82b2fbe6e05f81$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeUint32LE = $eb82b2fbe6e05f81$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeUint32BE = $eb82b2fbe6e05f81$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $eb82b2fbe6e05f81$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $eb82b2fbe6e05f81$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $eb82b2fbe6e05f81$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $eb82b2fbe6e05f81$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $30e6e6b4ecf2dddc$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$eb82b2fbe6e05f81$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $eb82b2fbe6e05f81$var$writeFloat(this, value, offset, true, noAssert);
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $eb82b2fbe6e05f81$var$writeFloat(this, value, offset, false, noAssert);
};
function $eb82b2fbe6e05f81$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eb82b2fbe6e05f81$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $30e6e6b4ecf2dddc$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$eb82b2fbe6e05f81$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $eb82b2fbe6e05f81$var$writeDouble(this, value, offset, true, noAssert);
};
$eb82b2fbe6e05f81$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $eb82b2fbe6e05f81$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$eb82b2fbe6e05f81$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$eb82b2fbe6e05f81$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$eb82b2fbe6e05f81$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$eb82b2fbe6e05f81$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $eb82b2fbe6e05f81$var$Buffer.isBuffer(val) ? val : $eb82b2fbe6e05f81$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $eb82b2fbe6e05f81$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $eb82b2fbe6e05f81$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($eb82b2fbe6e05f81$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $eb82b2fbe6e05f81$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $eb82b2fbe6e05f81$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $eb82b2fbe6e05f81$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $eb82b2fbe6e05f81$var$base64ToBytes(str) {
    return $3edd0946852b9107$export$d622b2ad8d90c771($eb82b2fbe6e05f81$var$base64clean(str));
}
function $eb82b2fbe6e05f81$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $eb82b2fbe6e05f81$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $eb82b2fbe6e05f81$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $eb82b2fbe6e05f81$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $102483a667398a86$require$Buffer = $eb82b2fbe6e05f81$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $102483a667398a86$var$isVisitable(thing) {
    return (0, $f04166365b052d26$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $102483a667398a86$var$removeBrackets(key) {
    return (0, $f04166365b052d26$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $102483a667398a86$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $102483a667398a86$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $102483a667398a86$var$isFlatArray(arr) {
    return (0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(arr) && !arr.some($102483a667398a86$var$isVisitable);
}
const $102483a667398a86$var$predicates = (0, $f04166365b052d26$export$2e2bcd8739ae039).toFlatObject((0, $f04166365b052d26$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $102483a667398a86$var$toFormData(obj, formData, options) {
    if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $7795102a8dca891e$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $f04166365b052d26$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $f04166365b052d26$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $f04166365b052d26$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $f04166365b052d26$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $102483a667398a86$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(value) && $102483a667398a86$var$isFlatArray(value) || ((0, $f04166365b052d26$export$2e2bcd8739ae039).isFileList(value) || (0, $f04166365b052d26$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $f04166365b052d26$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $102483a667398a86$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $102483a667398a86$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($102483a667398a86$var$isVisitable(value)) return true;
        formData.append($102483a667398a86$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($102483a667398a86$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $102483a667398a86$var$isVisitable
    });
    function build(value, path) {
        if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $f04166365b052d26$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $f04166365b052d26$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $102483a667398a86$export$2e2bcd8739ae039 = $102483a667398a86$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $dc20f81026b6e097$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $dc20f81026b6e097$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $102483a667398a86$export$2e2bcd8739ae039)(params, this, options);
}
const $dc20f81026b6e097$var$prototype = $dc20f81026b6e097$var$AxiosURLSearchParams.prototype;
$dc20f81026b6e097$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$dc20f81026b6e097$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $dc20f81026b6e097$var$encode);
    } : $dc20f81026b6e097$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $dc20f81026b6e097$export$2e2bcd8739ae039 = $dc20f81026b6e097$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $591c0560cc056b4f$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $591c0560cc056b4f$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $591c0560cc056b4f$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $f04166365b052d26$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $dc20f81026b6e097$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $cce8b066edd8c109$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $f04166365b052d26$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $cce8b066edd8c109$export$2e2bcd8739ae039 = $cce8b066edd8c109$var$InterceptorManager;





"use strict";
var $073d145dd33d7d0d$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $dcc054ff570bacd9$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $dc20f81026b6e097$export$2e2bcd8739ae039);


"use strict";
var $0c2e3afde6950ab7$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $441591ca726cb179$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $ba05f9d31a830953$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $ba05f9d31a830953$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $ba05f9d31a830953$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $dcc054ff570bacd9$export$2e2bcd8739ae039,
        FormData: $0c2e3afde6950ab7$export$2e2bcd8739ae039,
        Blob: $441591ca726cb179$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $ba05f9d31a830953$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $ba05f9d31a830953$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $4a8bcc55d17715ce$export$2e2bcd8739ae039(data, options) {
    return (0, $102483a667398a86$export$2e2bcd8739ae039)(data, new (0, $ba05f9d31a830953$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $ba05f9d31a830953$export$2e2bcd8739ae039).isNode && (0, $f04166365b052d26$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $e760bd4f4969c6e1$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $f04166365b052d26$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $e760bd4f4969c6e1$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $e760bd4f4969c6e1$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $f04166365b052d26$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $e760bd4f4969c6e1$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isFormData(formData) && (0, $f04166365b052d26$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $f04166365b052d26$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($e760bd4f4969c6e1$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $e760bd4f4969c6e1$export$2e2bcd8739ae039 = $e760bd4f4969c6e1$var$formDataToJSON;


"use strict";
const $a9b8e07b51ceac6f$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": undefined
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a9b8e07b51ceac6f$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $f04166365b052d26$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a9b8e07b51ceac6f$var$defaults = {
    transitional: (0, $073d145dd33d7d0d$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $f04166365b052d26$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $f04166365b052d26$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $f04166365b052d26$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $e760bd4f4969c6e1$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $f04166365b052d26$export$2e2bcd8739ae039).isBuffer(data) || (0, $f04166365b052d26$export$2e2bcd8739ae039).isStream(data) || (0, $f04166365b052d26$export$2e2bcd8739ae039).isFile(data) || (0, $f04166365b052d26$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $4a8bcc55d17715ce$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $f04166365b052d26$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $102483a667398a86$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $a9b8e07b51ceac6f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $a9b8e07b51ceac6f$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $f04166365b052d26$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).from(e, (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $ba05f9d31a830953$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $ba05f9d31a830953$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
(0, $f04166365b052d26$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $a9b8e07b51ceac6f$var$defaults.headers[method] = {};
});
(0, $f04166365b052d26$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $a9b8e07b51ceac6f$var$defaults.headers[method] = (0, $f04166365b052d26$export$2e2bcd8739ae039).merge($a9b8e07b51ceac6f$var$DEFAULT_CONTENT_TYPE);
});
var $a9b8e07b51ceac6f$export$2e2bcd8739ae039 = $a9b8e07b51ceac6f$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $74c5457dd7a149e7$var$ignoreDuplicateOf = (0, $f04166365b052d26$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $74c5457dd7a149e7$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $74c5457dd7a149e7$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $63599538a7d18ee4$var$$internals = Symbol("internals");
function $63599538a7d18ee4$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $63599538a7d18ee4$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(value) ? value.map($63599538a7d18ee4$var$normalizeValue) : String(value);
}
function $63599538a7d18ee4$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $63599538a7d18ee4$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $63599538a7d18ee4$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $63599538a7d18ee4$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $63599538a7d18ee4$var$buildAccessors(obj, header) {
    const accessorName = (0, $f04166365b052d26$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $63599538a7d18ee4$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $63599538a7d18ee4$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $f04166365b052d26$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $63599538a7d18ee4$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $f04166365b052d26$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$63599538a7d18ee4$var$isValidHeaderName(header)) setHeaders((0, $74c5457dd7a149e7$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $63599538a7d18ee4$var$normalizeHeader(header);
        if (header) {
            const key = (0, $f04166365b052d26$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $63599538a7d18ee4$var$parseTokens(value);
                if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $63599538a7d18ee4$var$normalizeHeader(header);
        if (header) {
            const key = (0, $f04166365b052d26$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $63599538a7d18ee4$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $63599538a7d18ee4$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $f04166365b052d26$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $63599538a7d18ee4$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $63599538a7d18ee4$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $f04166365b052d26$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $f04166365b052d26$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $63599538a7d18ee4$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $63599538a7d18ee4$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $63599538a7d18ee4$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $f04166365b052d26$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$63599538a7d18ee4$var$$internals] = this[$63599538a7d18ee4$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $63599538a7d18ee4$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $63599538a7d18ee4$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$63599538a7d18ee4$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
(0, $f04166365b052d26$export$2e2bcd8739ae039).freezeMethods($63599538a7d18ee4$var$AxiosHeaders.prototype);
(0, $f04166365b052d26$export$2e2bcd8739ae039).freezeMethods($63599538a7d18ee4$var$AxiosHeaders);
var $63599538a7d18ee4$export$2e2bcd8739ae039 = $63599538a7d18ee4$var$AxiosHeaders;


"use strict";
function $7a8b8c3ae7e7ba4e$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a9b8e07b51ceac6f$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $63599538a7d18ee4$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $f04166365b052d26$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $b70a9f4ded142b1c$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $d805ff8823fd5213$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $f04166365b052d26$export$2e2bcd8739ae039).inherits($d805ff8823fd5213$var$CanceledError, (0, $88fed3efb32a29b2$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $d805ff8823fd5213$export$2e2bcd8739ae039 = $d805ff8823fd5213$var$CanceledError;







"use strict";
function $5997f051e9506ed8$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $8470f1e88dfb3bde$export$2e2bcd8739ae039 = (0, $ba05f9d31a830953$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $37a68ca0e4da133a$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $4a751bc94ff57afc$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $ecff422b65cef4b7$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $37a68ca0e4da133a$export$2e2bcd8739ae039)(requestedURL)) return (0, $4a751bc94ff57afc$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $c96b57e447b8f33e$export$2e2bcd8739ae039 = (0, $ba05f9d31a830953$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $f04166365b052d26$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $8452775952a6ee89$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $ca83c0675afb2244$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $ca83c0675afb2244$export$2e2bcd8739ae039 = $ca83c0675afb2244$var$speedometer;


"use strict";
function $2b0c6982648089ce$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $ca83c0675afb2244$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $2b0c6982648089ce$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $2b0c6982648089ce$export$2e2bcd8739ae039 = $2b0c6982648089ce$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $63599538a7d18ee4$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $ba05f9d31a830953$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $ba05f9d31a830953$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $ecff422b65cef4b7$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $591c0560cc056b4f$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $63599538a7d18ee4$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $5997f051e9506ed8$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)("Request aborted", (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)("Network Error", (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $073d145dd33d7d0d$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ETIMEDOUT : (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $ba05f9d31a830953$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $c96b57e447b8f33e$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $8470f1e88dfb3bde$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $f04166365b052d26$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $2b0c6982648089ce$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $2b0c6982648089ce$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $d805ff8823fd5213$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $8452775952a6ee89$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $ba05f9d31a830953$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $55d12d993186cf6d$var$knownAdapters = {
    http: (0, $7795102a8dca891e$export$2e2bcd8739ae039),
    xhr: (0, $2b0c6982648089ce$export$2e2bcd8739ae039)
};
(0, $f04166365b052d26$export$2e2bcd8739ae039).forEach($55d12d993186cf6d$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $55d12d993186cf6d$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $f04166365b052d26$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $55d12d993186cf6d$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $f04166365b052d26$export$2e2bcd8739ae039).hasOwnProp($55d12d993186cf6d$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $55d12d993186cf6d$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $6d148ab2bd0fb2e4$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $d805ff8823fd5213$export$2e2bcd8739ae039)(null, config);
}
function $6d148ab2bd0fb2e4$export$2e2bcd8739ae039(config) {
    $6d148ab2bd0fb2e4$var$throwIfCancellationRequested(config);
    config.headers = (0, $63599538a7d18ee4$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $7a8b8c3ae7e7ba4e$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $55d12d993186cf6d$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a9b8e07b51ceac6f$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $6d148ab2bd0fb2e4$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7a8b8c3ae7e7ba4e$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $63599538a7d18ee4$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $b70a9f4ded142b1c$export$2e2bcd8739ae039)(reason)) {
            $6d148ab2bd0fb2e4$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7a8b8c3ae7e7ba4e$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $63599538a7d18ee4$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $211978f5cd04d074$var$headersToObject = (thing)=>thing instanceof (0, $63599538a7d18ee4$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $211978f5cd04d074$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isPlainObject(target) && (0, $f04166365b052d26$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $f04166365b052d26$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $f04166365b052d26$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($211978f5cd04d074$var$headersToObject(a), $211978f5cd04d074$var$headersToObject(b), true)
    };
    (0, $f04166365b052d26$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $f04166365b052d26$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $2d2857e3acaf217c$export$a4ad2735b021c132 = "1.4.0";



"use strict";
const $faadc7c016f409b7$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $faadc7c016f409b7$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $faadc7c016f409b7$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $faadc7c016f409b7$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $2d2857e3acaf217c$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$faadc7c016f409b7$var$deprecatedWarnings[opt]) {
            $faadc7c016f409b7$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $faadc7c016f409b7$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)("options must be an object", (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $88fed3efb32a29b2$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $88fed3efb32a29b2$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $faadc7c016f409b7$export$2e2bcd8739ae039 = {
    assertOptions: $faadc7c016f409b7$var$assertOptions,
    validators: $faadc7c016f409b7$var$validators
};



"use strict";
const $13ef9fe8cb75606a$var$validators = (0, $faadc7c016f409b7$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $13ef9fe8cb75606a$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $211978f5cd04d074$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $faadc7c016f409b7$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $13ef9fe8cb75606a$var$validators.transitional($13ef9fe8cb75606a$var$validators.boolean),
            forcedJSONParsing: $13ef9fe8cb75606a$var$validators.transitional($13ef9fe8cb75606a$var$validators.boolean),
            clarifyTimeoutError: $13ef9fe8cb75606a$var$validators.transitional($13ef9fe8cb75606a$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $f04166365b052d26$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $faadc7c016f409b7$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $13ef9fe8cb75606a$var$validators.function,
                serialize: $13ef9fe8cb75606a$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        let contextHeaders;
        // Flatten headers
        contextHeaders = headers && (0, $f04166365b052d26$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        contextHeaders && (0, $f04166365b052d26$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $63599538a7d18ee4$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $6d148ab2bd0fb2e4$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $6d148ab2bd0fb2e4$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $211978f5cd04d074$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $ecff422b65cef4b7$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $591c0560cc056b4f$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $cce8b066edd8c109$export$2e2bcd8739ae039)(),
            response: new (0, $cce8b066edd8c109$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $f04166365b052d26$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $13ef9fe8cb75606a$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $211978f5cd04d074$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $f04166365b052d26$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $211978f5cd04d074$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $13ef9fe8cb75606a$var$Axios.prototype[method] = generateHTTPMethod();
    $13ef9fe8cb75606a$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $13ef9fe8cb75606a$export$2e2bcd8739ae039 = $13ef9fe8cb75606a$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $85a6af1e2077f338$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $85a6af1e2077f338$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $d805ff8823fd5213$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $85a6af1e2077f338$export$2e2bcd8739ae039 = $85a6af1e2077f338$var$CancelToken;






"use strict";
function $2d1aaa9f529bc999$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $2cc7f6c85b0b338b$export$2e2bcd8739ae039(payload) {
    return (0, $f04166365b052d26$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}



const $d3ee1c12a17004f6$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($d3ee1c12a17004f6$var$HttpStatusCode).forEach(([key, value])=>{
    $d3ee1c12a17004f6$var$HttpStatusCode[value] = key;
});
var $d3ee1c12a17004f6$export$2e2bcd8739ae039 = $d3ee1c12a17004f6$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c5f0b6e54481011a$var$createInstance(defaultConfig) {
    const context = new (0, $13ef9fe8cb75606a$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $cf1d9957b8ad3fd5$export$2e2bcd8739ae039)((0, $13ef9fe8cb75606a$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $f04166365b052d26$export$2e2bcd8739ae039).extend(instance, (0, $13ef9fe8cb75606a$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $f04166365b052d26$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c5f0b6e54481011a$var$createInstance((0, $211978f5cd04d074$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c5f0b6e54481011a$var$axios = $c5f0b6e54481011a$var$createInstance((0, $a9b8e07b51ceac6f$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c5f0b6e54481011a$var$axios.Axios = (0, $13ef9fe8cb75606a$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c5f0b6e54481011a$var$axios.CanceledError = (0, $d805ff8823fd5213$export$2e2bcd8739ae039);
$c5f0b6e54481011a$var$axios.CancelToken = (0, $85a6af1e2077f338$export$2e2bcd8739ae039);
$c5f0b6e54481011a$var$axios.isCancel = (0, $b70a9f4ded142b1c$export$2e2bcd8739ae039);
$c5f0b6e54481011a$var$axios.VERSION = (0, $2d2857e3acaf217c$export$a4ad2735b021c132);
$c5f0b6e54481011a$var$axios.toFormData = (0, $102483a667398a86$export$2e2bcd8739ae039);
// Expose AxiosError class
$c5f0b6e54481011a$var$axios.AxiosError = (0, $88fed3efb32a29b2$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c5f0b6e54481011a$var$axios.Cancel = $c5f0b6e54481011a$var$axios.CanceledError;
// Expose all/spread
$c5f0b6e54481011a$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c5f0b6e54481011a$var$axios.spread = (0, $2d1aaa9f529bc999$export$2e2bcd8739ae039);
// Expose isAxiosError
$c5f0b6e54481011a$var$axios.isAxiosError = (0, $2cc7f6c85b0b338b$export$2e2bcd8739ae039);
// Expose mergeConfig
$c5f0b6e54481011a$var$axios.mergeConfig = (0, $211978f5cd04d074$export$2e2bcd8739ae039);
$c5f0b6e54481011a$var$axios.AxiosHeaders = (0, $63599538a7d18ee4$export$2e2bcd8739ae039);
$c5f0b6e54481011a$var$axios.formToJSON = (thing)=>(0, $e760bd4f4969c6e1$export$2e2bcd8739ae039)((0, $f04166365b052d26$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c5f0b6e54481011a$var$axios.HttpStatusCode = (0, $d3ee1c12a17004f6$export$2e2bcd8739ae039);
$c5f0b6e54481011a$var$axios.default = $c5f0b6e54481011a$var$axios;
var // this module should only have a default export
$c5f0b6e54481011a$export$2e2bcd8739ae039 = $c5f0b6e54481011a$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $a9a7a38b9fb8a524$export$1c00760e9e5a4e95, AxiosError: $a9a7a38b9fb8a524$export$c1fbed17c2f6a328, CanceledError: $a9a7a38b9fb8a524$export$1ab0c6b20d94fa14, isCancel: $a9a7a38b9fb8a524$export$3b22524397b493c6, CancelToken: $a9a7a38b9fb8a524$export$fd08e3cb425f0d61, VERSION: $a9a7a38b9fb8a524$export$a4ad2735b021c132, all: $a9a7a38b9fb8a524$export$84bf76cd7afc7469, Cancel: $a9a7a38b9fb8a524$export$848c9b7ead0df967, isAxiosError: $a9a7a38b9fb8a524$export$fbafdbe06a5b5a9a, spread: $a9a7a38b9fb8a524$export$3ae0fd4797ed47c8, toFormData: $a9a7a38b9fb8a524$export$10ae0d317ea97f8b, AxiosHeaders: $a9a7a38b9fb8a524$export$4e7d6ff0f3e6520, HttpStatusCode: $a9a7a38b9fb8a524$export$a972f69c851492b3, formToJSON: $a9a7a38b9fb8a524$export$86d7c59254d6a2c9, mergeConfig: $a9a7a38b9fb8a524$export$7ec1ebcfa9d8bd6a } = (0, $c5f0b6e54481011a$export$2e2bcd8739ae039);


const $23db1d9b3d332e51$export$f040a3be666afa9a = "https://hammerhead-app-hxnyl.ondigitalocean.app/list_vbq9ahkh";


const $64a5026d49b29421$export$687f60ead63618ec = async (email)=>{
    try {
        const { data: data } = await (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).post((0, $23db1d9b3d332e51$export$f040a3be666afa9a) || "", {
            record: {
                emailAddress: email
            }
        });
        return data;
    } catch (err) {
        throw err;
    }
};


const $17f7cd8692aafc3b$var$EmailSignUp = ()=>{
    const [loading, setLoading] = (0, $eXaQ2.useState)(false);
    const [submitted, setSubmitted] = (0, $eXaQ2.useState)(false);
    const [email, setEmail] = (0, $eXaQ2.useState)("");
    const handleSignUp = async ()=>{
        if (email === "") {
            (0, $87ae4e00b7a962b0$exports.toast).error("Please input email address");
            return;
        }
        try {
            setLoading(true);
            await (0, $64a5026d49b29421$export$687f60ead63618ec)(email);
            setSubmitted(true);
        } catch (err) {
            (0, $87ae4e00b7a962b0$exports.toast).error(err.message || "Something went wrong, please try again later");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
        className: "mx-4 mb-16 mt-6 md:mx-0 md:mt-0 lg:px-2",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
            className: "relative rounded-sm border border-t-[8px] border-indigo-600 shadow-xl",
            children: [
                submitted ? /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                    className: "p-6 text-center text-2xl font-bold text-gray-800",
                    children: "Thank you!"
                }) : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $a1cc52fbd40b0eb4$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "p-6 text-center text-xl font-bold text-gray-800 lg:text-2xl",
                            children: "Get Exclusive Penny Pinching Tips!"
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "px-3 text-center text-sm font-medium text-gray-700 lg:text-base",
                            children: "Get advice on making, saving and managing your money sent directly to your inbox daily."
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "mt-6 max-w-md px-4 pb-4",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("label", {
                                    htmlFor: "email-address",
                                    className: "sr-only",
                                    children: "Email address"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("input", {
                                    id: "email-address",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    required: true,
                                    className: "border-1 block w-full min-w-0 rounded-sm bg-white/5 px-3.5 py-3 font-medium text-black ring-inset ring-white/10 shadow-sm ring-1 focus:ring-inset focus:ring-indigo-500 focus:ring-2 sm:text-sm sm:leading-6",
                                    placeholder: "Enter your email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("button", {
                                    type: "submit",
                                    className: "mt-2 block w-full rounded-md bg-indigo-600 py-3 text-base font-semibold uppercase text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 lg:text-lg",
                                    onClick: handleSignUp,
                                    children: "Sign Me Up!"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    className: "mt-4 text-center text-xs font-bold leading-tight tracking-tight text-gray-700",
                                    children: [
                                        'By clicking on "SIGN ME UP!", you agree to our',
                                        " ",
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                                            href: "/terms",
                                            className: "underline",
                                            children: "Terms of Use"
                                        }),
                                        " ",
                                        "&",
                                        " ",
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                                            href: "/privacy",
                                            className: "underline",
                                            children: "Privacy Policy"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                loading && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                    className: "absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-white/70",
                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $746d02961b1b404f$exports.default), {})
                })
            ]
        })
    });
};
var $17f7cd8692aafc3b$export$2e2bcd8739ae039 = $17f7cd8692aafc3b$var$EmailSignUp;



let $4aa56da3c81bb6e8$var$_ = (t)=>t, $4aa56da3c81bb6e8$var$t;
const $4aa56da3c81bb6e8$var$GET_CATEGORY = (href, pageNumber)=>(0, $fd0c0e1ba95e1f7a$export$72e4926bf8358653)($4aa56da3c81bb6e8$var$t || ($4aa56da3c81bb6e8$var$t = $4aa56da3c81bb6e8$var$_`
  query {
    categories(filters: { href: { eq: "${0}" } }) {
      data {
        attributes {
          name
          category_color
          headline
          featured_article {
            data {
              id
              attributes {
                title
                preview_text
                slug
                primary_image {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
          featured_article_cta
          href
          articles (sort: "id:desc", pagination: {pageSize: 20, page: ${0}}) {
            data {
              id
              attributes {
                title
                slug
                sub_category {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
                primary_image {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`), href, pageNumber);
var $4aa56da3c81bb6e8$export$2e2bcd8739ae039 = $4aa56da3c81bb6e8$var$GET_CATEGORY;


const $d7d775de2cef8dcb$var$Category = ()=>{
    const [articles, setArticles] = (0, $eXaQ2.useState)();
    const [currentPage, setCurrentPage] = (0, $eXaQ2.useState)(1);
    const [hasMore, setHasMore] = (0, $eXaQ2.useState)(true);
    const { category: category } = (0, $3fc8353d3146dc49$export$99eaa27ddbbb95ef)();
    const client = (0, $34c3e0df3dad45a4$export$eb9a56e7a29e494)();
    const { loading: loading, error: error, data: data } = (0, $cb89595d8b20dae2$export$dd0a697e1782aedd)((0, $4aa56da3c81bb6e8$export$2e2bcd8739ae039)(`/${category}`, currentPage));
    if (error) return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
        children: "Error :("
    });
    const featuredArticle = data === null || data === void 0 ? void 0 : data.categories.data[0].attributes;
    const from = data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.name;
    const textColor = `text-${data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.category_color}`;
    (0, $eXaQ2.useEffect)(()=>{
        setArticles(data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.articles.data);
        if ((data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.articles.data.length) < 20) setHasMore(false);
    }, [
        data
    ]);
    const onNextArticles = async ()=>{
        if (!articles) return;
        const { data: data } = await client.query({
            query: (0, $4aa56da3c81bb6e8$export$2e2bcd8739ae039)(`/${category}`, currentPage + 1)
        });
        const temp = articles;
        temp.push(...data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.articles.data);
        setArticles(temp);
        if ((data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.articles.data.length) < 20) setHasMore(false);
        else setCurrentPage((prev)=>prev + 1);
    };
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $86a0a2c7143f17cc$export$2e2bcd8739ae039), {
        title: (data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.name) + " | Penny Pincher News",
        description: data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.headline,
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "relative isolate -mt-8 overflow-hidden bg-gray-900 md:-mt-10 lg:-mt-20",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("svg", {
                        className: "absolute inset-0 -z-10 h-full w-full stroke-white/40 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("pattern", {
                                    id: "983e3e4c-de6d-4c3f-8d64-b9761d1534cc",
                                    width: 200,
                                    height: 200,
                                    x: "50%",
                                    y: -1,
                                    patternUnits: "userSpaceOnUse",
                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                        d: "M.5 200V.5H200",
                                        fill: "none"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                x: "50%",
                                y: -1,
                                className: "overflow-visible fill-gray-800/20",
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                    d: "M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z",
                                    strokeWidth: 0
                                })
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("rect", {
                                width: "100%",
                                height: "100%",
                                strokeWidth: 0,
                                fill: "url(#983e3e4c-de6d-4c3f-8d64-b9761d1534cc)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "absolute left-[calc(50%-4rem)] top-10 -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)]",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20",
                            style: {
                                clipPath: "polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        className: "mx-auto max-w-7xl px-6 pb-8 pt-10 sm:pb-10 md:pb-12 lg:px-8 lg:pt-24",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "text-2xl text-white md:text-5xl",
                                children: data ? data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.name : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    role: "status",
                                    className: "my-8 h-5 w-48 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700"
                                })
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "mt-2 max-w-3xl text-sm text-gray-400 md:mt-4 md:text-xl",
                                children: data ? data === null || data === void 0 ? void 0 : data.categories.data[0].attributes.headline : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    role: "status",
                                    className: "h-3 w-80 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "mx-auto max-w-7xl px-4",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                    className: "mt-4 gap-8 md:mt-10 lg:flex",
                    children: [
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "basis-3/4",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $d3dc59bec2c4e97a$export$2e2bcd8739ae039), {
                                    article: featuredArticle
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $1a1188d546cac9cf$export$2e2bcd8739ae039), {
                                    dataLength: (articles === null || articles === void 0 ? void 0 : articles.length) || 0,
                                    next: onNextArticles,
                                    hasMore: hasMore,
                                    loader: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                        children: "Loading..."
                                    }),
                                    endMessage: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $a1cc52fbd40b0eb4$exports.Fragment), {}),
                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $55aef0c5205c5471$export$2e2bcd8739ae039), {
                                        featuredArticle: featuredArticle,
                                        articles: articles,
                                        from: from,
                                        textColor: textColor
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "hidden basis-1/4 lg:block",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $17f7cd8692aafc3b$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "sticky top-36 -mt-8",
                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $d8415b00580724f1$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $d7d775de2cef8dcb$export$2e2bcd8739ae039 = $d7d775de2cef8dcb$var$Category;






var $eXaQ2 = parcelRequire("eXaQ2");



var $eXaQ2 = parcelRequire("eXaQ2");


//      
var $945261947a191e8f$var$charCodeOfDot = ".".charCodeAt(0);
var $945261947a191e8f$var$reEscapeChar = /\\(\\)?/g;
var $945261947a191e8f$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $945261947a191e8f$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $945261947a191e8f$var$charCodeOfDot) result.push("");
    string.replace($945261947a191e8f$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($945261947a191e8f$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $945261947a191e8f$var$keysCache = {};
var $945261947a191e8f$var$keysRegex = /[.[\]]+/;
var $945261947a191e8f$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($945261947a191e8f$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $945261947a191e8f$var$keysCache[key] = key.split($945261947a191e8f$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $945261947a191e8f$var$keysCache[key] = $945261947a191e8f$var$stringToPath(key);
    }
    return $945261947a191e8f$var$keysCache[key];
};
//      
var $945261947a191e8f$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $945261947a191e8f$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $945261947a191e8f$var$_toPropertyKey(arg) {
    var key = $945261947a191e8f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $945261947a191e8f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $945261947a191e8f$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index]; // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result2 = setInRecursor(undefined, index + 1, path, value1, destroyArrays); // delete or create an object
            return _result2 === undefined ? undefined : (_ref = {}, _ref[key] = _result2, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
         // current exists, so make a copy of all its values, and add/update the new one
        var _result = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ac03236e4a254241$export$2e2bcd8739ae039)(current, [
                key
            ].map($945261947a191e8f$var$_toPropertyKey));
            return _final;
        } // set result in key
        return (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, current, (_extends2 = {}, _extends2[key] = _result, _extends2));
    } // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays); // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
         // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
     // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays); // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $945261947a191e8f$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
     // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $945261947a191e8f$var$setInRecursor(state, 0, $945261947a191e8f$var$toPath(key), value1, destroyArrays);
};
var $945261947a191e8f$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $945261947a191e8f$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $945261947a191e8f$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $945261947a191e8f$export$c52e5867d5879e24(values, name);
    var error = $945261947a191e8f$export$c52e5867d5879e24(errors, name);
    if (error && error[$945261947a191e8f$export$735bebc8ffabf28a]) error = error[$945261947a191e8f$export$735bebc8ffabf28a];
    var submitError = submitErrors && $945261947a191e8f$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $945261947a191e8f$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($945261947a191e8f$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $945261947a191e8f$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $945261947a191e8f$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $945261947a191e8f$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$945261947a191e8f$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $945261947a191e8f$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $945261947a191e8f$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $945261947a191e8f$var$subscriptionFilter(result, state, previousState, subscription, $945261947a191e8f$export$41e855cb628c1b55, $945261947a191e8f$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $945261947a191e8f$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $945261947a191e8f$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $945261947a191e8f$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $945261947a191e8f$var$subscriptionFilter(result, state, previousState, subscription, $945261947a191e8f$export$f1ff97b9d1c7a3c3, $945261947a191e8f$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $945261947a191e8f$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$945261947a191e8f$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $945261947a191e8f$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $945261947a191e8f$export$83d89fbfd8236492 = "4.20.9";
var $945261947a191e8f$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $945261947a191e8f$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $945261947a191e8f$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $945261947a191e8f$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $945261947a191e8f$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $945261947a191e8f$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $945261947a191e8f$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $945261947a191e8f$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)]; // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($945261947a191e8f$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $945261947a191e8f$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $945261947a191e8f$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $945261947a191e8f$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $945261947a191e8f$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $945261947a191e8f$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $945261947a191e8f$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    }; // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $945261947a191e8f$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $945261947a191e8f$export$e6bdf135a54e021b,
                    shallowEqual: $945261947a191e8f$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, state.formState.values)); // clone to avoid writing
            if ($945261947a191e8f$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($945261947a191e8f$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $945261947a191e8f$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $945261947a191e8f$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        } // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey)); // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $945261947a191e8f$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $945261947a191e8f$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $945261947a191e8f$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$945261947a191e8f$export$735bebc8ffabf28a]) {
                    var existing = $945261947a191e8f$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$945261947a191e8f$export$735bebc8ffabf28a] = error[$945261947a191e8f$export$735bebc8ffabf28a];
                    merged = $945261947a191e8f$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$945261947a191e8f$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$945261947a191e8f$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        } // process sync errors
        processErrors(false); // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $945261947a191e8f$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $945261947a191e8f$var$notify(fieldSubscriber, fieldState, lastFieldState, $945261947a191e8f$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $945261947a191e8f$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, fields);
        var safeFieldKeys = Object.keys(safeFields); // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($945261947a191e8f$export$c52e5867d5879e24(formState.values, key), $945261947a191e8f$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($945261947a191e8f$export$c52e5867d5879e24(formState.values, key), $945261947a191e8f$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$945261947a191e8f$var$hasAnyError(formState.errors) && !(formState.submitErrors && $945261947a191e8f$var$hasAnyError(formState.submitErrors));
        var nextFormState = $945261947a191e8f$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $945261947a191e8f$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $945261947a191e8f$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $945261947a191e8f$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $945261947a191e8f$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $945261947a191e8f$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $945261947a191e8f$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $945261947a191e8f$var$notify(state.subscribers, nextFormState, lastFormState, $945261947a191e8f$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    }; // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($945261947a191e8f$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($945261947a191e8f$export$c52e5867d5879e24(formState.values, key), $945261947a191e8f$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $945261947a191e8f$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {}; // update initalValues and values
            formState.initialValues = values;
            formState.values = values; // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $945261947a191e8f$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++; // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $945261947a191e8f$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            }; // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $945261947a191e8f$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            }; // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $945261947a191e8f$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $945261947a191e8f$export$c52e5867d5879e24(state.formState.values, name) === $945261947a191e8f$export$c52e5867d5879e24(state.formState.initialValues, name) // only initialize if we don't yet have any value for this field
                )) {
                    state.formState.initialValues = $945261947a191e8f$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $945261947a191e8f$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                } // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $945261947a191e8f$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $945261947a191e8f$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false; // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $945261947a191e8f$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $945261947a191e8f$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $945261947a191e8f$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$945261947a191e8f$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, formState.values);
            resetModifiedAfterSubmit(); // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $945261947a191e8f$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $945261947a191e8f$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $945261947a191e8f$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $945261947a191e8f$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}


var $73e84f96b8d2f4df$var$_excluded$3 = [
    "render",
    "children",
    "component"
];
// shared logic between components that use either render prop,
// children render function, or component prop
function $73e84f96b8d2f4df$var$renderComponent(props, lazyProps, name) {
    var render = props.render, children = props.children, component = props.component, rest = (0, $ac03236e4a254241$export$2e2bcd8739ae039)(props, $73e84f96b8d2f4df$var$_excluded$3);
    if (component) return /*#__PURE__*/ $eXaQ2.createElement(component, Object.assign(lazyProps, rest, {
        children: children,
        render: render
    }));
    if (render) return render(children === undefined ? Object.assign(lazyProps, rest) : Object.assign(lazyProps, rest, {
        children: children
    }));
    if (typeof children !== "function") throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
    return children(Object.assign(lazyProps, rest));
}
function $73e84f96b8d2f4df$var$useWhenValueChanges(value, callback, isEqual) {
    if (isEqual === void 0) isEqual = function isEqual(a, b) {
        return a === b;
    };
    var previous = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).useEffect(function() {
        if (!isEqual(value, previous.current)) {
            callback();
            previous.current = value;
        }
    });
}
/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param {Function} init - A function to generate the value
 */ function $73e84f96b8d2f4df$var$useConstant(init) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).useRef();
    if (!ref.current) ref.current = init();
    return ref.current;
}
var $73e84f96b8d2f4df$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
var $73e84f96b8d2f4df$var$isSyntheticEvent = function isSyntheticEvent(candidate) {
    return !!(candidate && typeof candidate.stopPropagation === "function");
};
var $73e84f96b8d2f4df$var$ReactFinalFormContext = /*#__PURE__*/ $eXaQ2.createContext();
function $73e84f96b8d2f4df$var$useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($eXaQ2))).useEffect(function() {
        ref.current = value;
    });
    return ref;
}
var $73e84f96b8d2f4df$export$83d89fbfd8236492 = "6.5.8";
var $73e84f96b8d2f4df$var$addLazyState = function addLazyState(dest, state, keys) {
    keys.forEach(function(key) {
        Object.defineProperty(dest, key, {
            get: function get() {
                return state[key];
            },
            enumerable: true
        });
    });
};
var $73e84f96b8d2f4df$var$addLazyFormState = function addLazyFormState(dest, state) {
    return $73e84f96b8d2f4df$var$addLazyState(dest, state, [
        "active",
        "dirty",
        "dirtyFields",
        "dirtySinceLastSubmit",
        "dirtyFieldsSinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ]);
};
var $73e84f96b8d2f4df$var$addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
    return $73e84f96b8d2f4df$var$addLazyState(dest, state, [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "visited"
    ]);
};
var $73e84f96b8d2f4df$var$_excluded$2 = [
    "debug",
    "decorators",
    "destroyOnUnregister",
    "form",
    "initialValues",
    "initialValuesEqual",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "subscription",
    "validate",
    "validateOnBlur"
];
var $73e84f96b8d2f4df$var$versions = {
    "final-form": (0, $945261947a191e8f$export$83d89fbfd8236492),
    "react-final-form": $73e84f96b8d2f4df$export$83d89fbfd8236492
};
var $73e84f96b8d2f4df$var$all$1 = (0, $945261947a191e8f$export$f1ff97b9d1c7a3c3).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
function $73e84f96b8d2f4df$export$a7fed597f4b8afd8(_ref) {
    var debug = _ref.debug, _ref$decorators = _ref.decorators, decorators = _ref$decorators === void 0 ? [] : _ref$decorators, destroyOnUnregister = _ref.destroyOnUnregister, alternateFormApi = _ref.form, initialValues = _ref.initialValues, initialValuesEqual = _ref.initialValuesEqual, keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize, mutators = _ref.mutators, onSubmit = _ref.onSubmit, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $73e84f96b8d2f4df$var$all$1 : _ref$subscription, validate = _ref.validate, validateOnBlur = _ref.validateOnBlur, rest = (0, $ac03236e4a254241$export$2e2bcd8739ae039)(_ref, $73e84f96b8d2f4df$var$_excluded$2);
    var config = {
        debug: debug,
        destroyOnUnregister: destroyOnUnregister,
        initialValues: initialValues,
        keepDirtyOnReinitialize: keepDirtyOnReinitialize,
        mutators: mutators,
        onSubmit: onSubmit,
        validate: validate,
        validateOnBlur: validateOnBlur
    };
    var form = $73e84f96b8d2f4df$var$useConstant(function() {
        var f = alternateFormApi || (0, $945261947a191e8f$export$f681a8129d2e9d28)(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)
        f.pauseValidation();
        return f;
    }); // synchronously register and unregister to query form state for our subscription on first render
    var _React$useState = $eXaQ2.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1]; // save a copy of state that can break through the closure
    // on the shallowEqual() line below.
    var stateRef = $73e84f96b8d2f4df$var$useLatest(state);
    $eXaQ2.useEffect(function() {
        // We have rendered, so all fields are now registered, so we can unpause validation
        form.isValidationPaused() && form.resumeValidation();
        var unsubscriptions = [
            form.subscribe(function(s) {
                if (!$73e84f96b8d2f4df$var$shallowEqual(s, stateRef.current)) setState(s);
            }, subscription)
        ].concat(decorators ? decorators.map(function(decorator) {
            return(// istanbul ignore next
            decorator(form));
        }) : []);
        return function() {
            form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
            unsubscriptions.reverse().forEach(function(unsubscribe) {
                return unsubscribe();
            }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, decorators); // warn about decorator changes
    $73e84f96b8d2f4df$var$useWhenValueChanges(debug, function() {
        form.setConfig("debug", debug);
    });
    $73e84f96b8d2f4df$var$useWhenValueChanges(destroyOnUnregister, function() {
        form.destroyOnUnregister = !!destroyOnUnregister;
    });
    $73e84f96b8d2f4df$var$useWhenValueChanges(keepDirtyOnReinitialize, function() {
        form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
    });
    $73e84f96b8d2f4df$var$useWhenValueChanges(initialValues, function() {
        form.setConfig("initialValues", initialValues);
    }, initialValuesEqual || $73e84f96b8d2f4df$var$shallowEqual);
    $73e84f96b8d2f4df$var$useWhenValueChanges(mutators, function() {
        form.setConfig("mutators", mutators);
    });
    $73e84f96b8d2f4df$var$useWhenValueChanges(onSubmit, function() {
        form.setConfig("onSubmit", onSubmit);
    });
    $73e84f96b8d2f4df$var$useWhenValueChanges(validate, function() {
        form.setConfig("validate", validate);
    });
    $73e84f96b8d2f4df$var$useWhenValueChanges(validateOnBlur, function() {
        form.setConfig("validateOnBlur", validateOnBlur);
    });
    var handleSubmit = function handleSubmit(event) {
        if (event) {
            // sometimes not true, e.g. React Native
            if (typeof event.preventDefault === "function") event.preventDefault();
            if (typeof event.stopPropagation === "function") // prevent any outer forms from receiving the event too
            event.stopPropagation();
        }
        return form.submit();
    };
    var renderProps = {
        form: (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, form, {
            reset: function reset(eventOrValues) {
                if ($73e84f96b8d2f4df$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                form.reset();
                else form.reset(eventOrValues);
            }
        }),
        handleSubmit: handleSubmit
    };
    $73e84f96b8d2f4df$var$addLazyFormState(renderProps, state);
    return /*#__PURE__*/ $eXaQ2.createElement($73e84f96b8d2f4df$var$ReactFinalFormContext.Provider, {
        value: form
    }, $73e84f96b8d2f4df$var$renderComponent((0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, rest, {
        __versions: $73e84f96b8d2f4df$var$versions
    }), renderProps, "ReactFinalForm"));
}
function $73e84f96b8d2f4df$export$87c0cf8eb5a167e0(componentName) {
    var form = $eXaQ2.useContext($73e84f96b8d2f4df$var$ReactFinalFormContext);
    if (!form) throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
    return form;
}
function $73e84f96b8d2f4df$export$606f11b2eb45ecc6(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, onChange = _ref.onChange, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $73e84f96b8d2f4df$var$all$1 : _ref$subscription;
    var form = $73e84f96b8d2f4df$export$87c0cf8eb5a167e0("useFormState");
    var firstRender = $eXaQ2.useRef(true);
    var onChangeRef = $eXaQ2.useRef(onChange);
    onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $eXaQ2.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        if (onChange) onChange(initialState);
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $eXaQ2.useEffect(function() {
        return form.subscribe(function(newState) {
            if (firstRender.current) firstRender.current = false;
            else {
                setState(newState);
                if (onChangeRef.current) onChangeRef.current(newState);
            }
        }, subscription);
    }, []);
    var lazyState = {};
    $73e84f96b8d2f4df$var$addLazyFormState(lazyState, state);
    return lazyState;
}
var $73e84f96b8d2f4df$var$_excluded$1 = [
    "onChange",
    "subscription"
];
function $73e84f96b8d2f4df$export$d2e89184086487cb(_ref) {
    var onChange = _ref.onChange, subscription = _ref.subscription, rest = (0, $ac03236e4a254241$export$2e2bcd8739ae039)(_ref, $73e84f96b8d2f4df$var$_excluded$1);
    var reactFinalForm = $73e84f96b8d2f4df$export$87c0cf8eb5a167e0("FormSpy");
    var state = $73e84f96b8d2f4df$export$606f11b2eb45ecc6({
        onChange: onChange,
        subscription: subscription
    });
    if (onChange) return null;
    var renderProps = {
        form: (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, reactFinalForm, {
            reset: function reset(eventOrValues) {
                if ($73e84f96b8d2f4df$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                reactFinalForm.reset();
                else reactFinalForm.reset(eventOrValues);
            }
        })
    };
    return $73e84f96b8d2f4df$var$renderComponent((0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, rest, renderProps), state, "FormSpy");
}
var $73e84f96b8d2f4df$var$isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
var $73e84f96b8d2f4df$var$getSelectedValues = function getSelectedValues(options) {
    var result = [];
    if (options) for(var index = 0; index < options.length; index++){
        var option = options[index];
        if (option.selected) result.push(option.value);
    }
    return result;
};
var $73e84f96b8d2f4df$var$getValue = function getValue(event, currentValue, valueProp, isReactNative) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;
    if (isReactNative && event.nativeEvent) return event.nativeEvent.text;
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked;
    switch(type){
        case "checkbox":
            if (valueProp !== undefined) {
                // we are maintaining an array, not just a boolean
                if (checked) // add value to current array value
                return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [
                    valueProp
                ];
                else {
                    // remove value from current array value
                    if (!Array.isArray(currentValue)) return currentValue;
                    var index = currentValue.indexOf(valueProp);
                    if (index < 0) return currentValue;
                    else return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
                }
            } else // it's just a boolean
            return !!checked;
        case "select-multiple":
            return $73e84f96b8d2f4df$var$getSelectedValues(event.target.options);
        default:
            return value;
    }
};
/**
 * Creates a callback, even with closures, that will be
 * instance === for the lifetime of the component, always
 * calling the most recent version of the function and its
 * closures.
 */ function $73e84f96b8d2f4df$var$useConstantCallback(callback) {
    var ref = $eXaQ2.useRef(callback);
    $eXaQ2.useEffect(function() {
        ref.current = callback;
    });
    return $eXaQ2.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(null, args);
    }, []);
}
var $73e84f96b8d2f4df$var$all = (0, $945261947a191e8f$export$41e855cb628c1b55).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
var $73e84f96b8d2f4df$var$defaultFormat = function defaultFormat(value, name) {
    return value === undefined ? "" : value;
};
var $73e84f96b8d2f4df$var$defaultParse = function defaultParse(value, name) {
    return value === "" ? undefined : value;
};
var $73e84f96b8d2f4df$var$defaultIsEqual = function defaultIsEqual(a, b) {
    return a === b;
};
function $73e84f96b8d2f4df$export$294aa081a6c6f55d(name, config) {
    if (config === void 0) config = {};
    var _config = config, afterSubmit = _config.afterSubmit, allowNull = _config.allowNull, component = _config.component, data = _config.data, defaultValue = _config.defaultValue, _config$format = _config.format, format = _config$format === void 0 ? $73e84f96b8d2f4df$var$defaultFormat : _config$format, formatOnBlur = _config.formatOnBlur, initialValue = _config.initialValue, multiple = _config.multiple, _config$parse = _config.parse, parse = _config$parse === void 0 ? $73e84f96b8d2f4df$var$defaultParse : _config$parse, _config$subscription = _config.subscription, subscription = _config$subscription === void 0 ? $73e84f96b8d2f4df$var$all : _config$subscription, type = _config.type, validateFields = _config.validateFields, _value = _config.value;
    var form = $73e84f96b8d2f4df$export$87c0cf8eb5a167e0("useField");
    var configRef = $73e84f96b8d2f4df$var$useLatest(config);
    var register = function register(callback, silent) {
        return(// because they would refer `state` from current execution context
        // whereas actual `state` would defined in the subsequent `useField` hook
        // execution
        // (that would be caused by `setState` call performed in `register` callback)
        form.registerField(name, callback, subscription, {
            afterSubmit: afterSubmit,
            beforeSubmit: function beforeSubmit() {
                var _configRef$current = configRef.current, beforeSubmit = _configRef$current.beforeSubmit, formatOnBlur = _configRef$current.formatOnBlur, _configRef$current$fo = _configRef$current.format, format = _configRef$current$fo === void 0 ? $73e84f96b8d2f4df$var$defaultFormat : _configRef$current$fo;
                if (formatOnBlur) {
                    var _ref = form.getFieldState(name), value = _ref.value;
                    var formatted = format(value, name);
                    if (formatted !== value) form.change(name, formatted);
                }
                return beforeSubmit && beforeSubmit();
            },
            data: data,
            defaultValue: defaultValue,
            getValidator: function getValidator() {
                return configRef.current.validate;
            },
            initialValue: initialValue,
            isEqual: function isEqual(a, b) {
                return (configRef.current.isEqual || $73e84f96b8d2f4df$var$defaultIsEqual)(a, b);
            },
            silent: silent,
            validateFields: validateFields
        }));
    };
    var firstRender = $eXaQ2.useRef(true); // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $eXaQ2.useState(function() {
        var initialState = {}; // temporarily disable destroyOnUnregister
        // temporarily disable destroyOnUnregister
        var destroyOnUnregister = form.destroyOnUnregister;
        form.destroyOnUnregister = false;
        register(function(state) {
            initialState = state;
        }, true)(); // return destroyOnUnregister to its original value
        // return destroyOnUnregister to its original value
        form.destroyOnUnregister = destroyOnUnregister;
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $eXaQ2.useEffect(function() {
        return register(function(state) {
            if (firstRender.current) firstRender.current = false;
            else setState(state);
        }, false);
    }, [
        name,
        data,
        defaultValue,
        // cannot reregister field every time validate function !==.
        // validate,
        initialValue // The validateFields array is often passed as validateFields={[]}, creating
    ]);
    var meta = {};
    $73e84f96b8d2f4df$var$addLazyFieldMetaState(meta, state);
    var input = {
        name: name,
        get value () {
            var value = state.value;
            if (formatOnBlur) {
                if (component === "input") value = $73e84f96b8d2f4df$var$defaultFormat(value);
            } else value = format(value, name);
            if (value === null && !allowNull) value = "";
            if (type === "checkbox" || type === "radio") return _value;
            else if (component === "select" && multiple) return value || [];
            return value;
        },
        get checked () {
            var value1 = state.value;
            if (type === "checkbox") {
                value1 = format(value1, name);
                if (_value === undefined) return !!value1;
                else return !!(Array.isArray(value1) && ~value1.indexOf(_value));
            } else if (type === "radio") return format(value1, name) === _value;
            return undefined;
        },
        onBlur: $73e84f96b8d2f4df$var$useConstantCallback(function(event) {
            state.blur();
            if (formatOnBlur) {
                /**
         * Here we must fetch the value directly from Final Form because we cannot
         * trust that our `state` closure has the most recent value. This is a problem
         * if-and-only-if the library consumer has called `onChange()` immediately
         * before calling `onBlur()`, but before the field has had a chance to receive
         * the value update from Final Form.
         */ var fieldState = form.getFieldState(state.name);
                state.change(format(fieldState.value, state.name));
            }
        }),
        onChange: $73e84f96b8d2f4df$var$useConstantCallback(function(event) {
            var targetType, unknown, _value2;
            var value = event && event.target ? $73e84f96b8d2f4df$var$getValue(event, state.value, _value, $73e84f96b8d2f4df$var$isReactNative) : event;
            state.change(parse(value, name));
        }),
        onFocus: $73e84f96b8d2f4df$var$useConstantCallback(function(event) {
            return state.focus();
        })
    };
    if (multiple) input.multiple = multiple;
    if (type !== undefined) input.type = type;
    var renderProps = {
        input: input,
        meta: meta
    }; // assign to force Flow check
    return renderProps;
}
var $73e84f96b8d2f4df$var$_excluded = [
    "afterSubmit",
    "allowNull",
    "beforeSubmit",
    "children",
    "component",
    "data",
    "defaultValue",
    "format",
    "formatOnBlur",
    "initialValue",
    "isEqual",
    "multiple",
    "name",
    "parse",
    "subscription",
    "type",
    "validate",
    "validateFields",
    "value"
];
var $73e84f96b8d2f4df$export$a455218a85c89869 = /*#__PURE__*/ $eXaQ2.forwardRef(function Field(_ref, ref) {
    var afterSubmit = _ref.afterSubmit, allowNull = _ref.allowNull, beforeSubmit = _ref.beforeSubmit, children = _ref.children, component = _ref.component, data = _ref.data, defaultValue = _ref.defaultValue, format = _ref.format, formatOnBlur = _ref.formatOnBlur, initialValue = _ref.initialValue, isEqual = _ref.isEqual, multiple = _ref.multiple, name = _ref.name, parse = _ref.parse, subscription = _ref.subscription, type = _ref.type, validate = _ref.validate, validateFields = _ref.validateFields, value = _ref.value, rest = (0, $ac03236e4a254241$export$2e2bcd8739ae039)(_ref, $73e84f96b8d2f4df$var$_excluded);
    var field = $73e84f96b8d2f4df$export$294aa081a6c6f55d(name, {
        afterSubmit: afterSubmit,
        allowNull: allowNull,
        beforeSubmit: beforeSubmit,
        children: children,
        component: component,
        data: data,
        defaultValue: defaultValue,
        format: format,
        formatOnBlur: formatOnBlur,
        initialValue: initialValue,
        isEqual: isEqual,
        multiple: multiple,
        parse: parse,
        subscription: subscription,
        type: type,
        validate: validate,
        validateFields: validateFields,
        value: value
    });
    if (typeof children === "function") return children((0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, field, rest));
    if (typeof component === "string") // ignore meta, combine input with any other props
    return /*#__PURE__*/ $eXaQ2.createElement(component, (0, $8226f1ee5684019b$export$2e2bcd8739ae039)({}, field.input, {
        children: children,
        ref: ref
    }, rest));
    if (!name) throw new Error("prop name cannot be undefined in <Field> component");
    return $73e84f96b8d2f4df$var$renderComponent((0, $8226f1ee5684019b$export$2e2bcd8739ae039)({
        children: children,
        component: component,
        ref: ref
    }, rest), field, "Field(" + name + ")");
});
function $73e84f96b8d2f4df$export$38f9b05178901e14() {
    return {
        Form: $73e84f96b8d2f4df$export$a7fed597f4b8afd8,
        FormSpy: $73e84f96b8d2f4df$export$d2e89184086487cb
    };
}



var $eXaQ2 = parcelRequire("eXaQ2");
function $4e29b91146e00802$var$BuildingOffice2Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $eXaQ2.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $eXaQ2.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $eXaQ2.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
    }));
}
const $4e29b91146e00802$var$ForwardRef = $eXaQ2.forwardRef($4e29b91146e00802$var$BuildingOffice2Icon);
var $4e29b91146e00802$export$2e2bcd8739ae039 = $4e29b91146e00802$var$ForwardRef;





const $068b8ebf52e31cd5$var$MainLayout = ({ children: children, className: className = "", title: title, description: description })=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $a1cc52fbd40b0eb4$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $1f02524b81d370cb$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $c4a0eeccdd74febb$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("main", {
                        className: `${className} mt-4 md:mt-10`,
                        children: children
                    })
                ]
            })
        ]
    });
};
var $068b8ebf52e31cd5$export$2e2bcd8739ae039 = $068b8ebf52e31cd5$var$MainLayout;




var $eXaQ2 = parcelRequire("eXaQ2");
var $e81189367059b163$exports = {};

$e81189367059b163$exports = (parcelRequire("hhjKe"));



const $b691b673e00e3e03$var$InputForm = ({ className: className, label: label, isPhone: isPhone = false, input: input, meta: meta, ...props })=>{
    const id = (0, $eXaQ2.useId)();
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
        className: (0, $d2b3ba3d4a6ef45d$export$a274e22fb40f762e)(className),
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("label", {
                htmlFor: id,
                className: "block text-sm font-semibold leading-6 text-gray-900",
                children: label
            }),
            !isPhone ? /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("input", {
                ...input,
                className: "mt-2.5 block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 ring-inset ring-gray-300 shadow-sm ring-1 placeholder:text-gray-400 focus:ring-inset focus:ring-indigo-600 focus:ring-2 sm:text-sm sm:leading-6",
                ...props
            }) : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e81189367059b163$exports))), {
                mask: "(999) 999-9999",
                value: input.value,
                onChange: input.onChange,
                children: (inputProps)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("input", {
                        ...inputProps,
                        className: "mt-2.5 block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 ring-inset ring-gray-300 shadow-sm ring-1 placeholder:text-gray-400 focus:ring-inset focus:ring-indigo-600 focus:ring-2 sm:text-sm sm:leading-6",
                        ...props
                    })
            }),
            meta.touched && meta.error && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                className: "mt-1 text-xs text-red-500",
                children: meta.error
            })
        ]
    });
};
var $b691b673e00e3e03$export$2e2bcd8739ae039 = $b691b673e00e3e03$var$InputForm;




var $eXaQ2 = parcelRequire("eXaQ2");

const $0e4e053c53fa16e3$var$TextareaForm = ({ className: className, label: label, input: input, meta: meta, ...props })=>{
    const id = (0, $eXaQ2.useId)();
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
        className: (0, $d2b3ba3d4a6ef45d$export$a274e22fb40f762e)(className),
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("label", {
                htmlFor: id,
                className: "block text-sm font-semibold leading-6 text-gray-900",
                children: label
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("textarea", {
                ...input,
                className: "mt-2.5 block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 ring-inset ring-gray-300 shadow-sm ring-1 placeholder:text-gray-400 focus:ring-inset focus:ring-indigo-600 focus:ring-2 sm:text-sm sm:leading-6",
                ...props
            }),
            meta.touched && meta.error && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                className: "mt-1 text-xs text-red-500",
                children: meta.error
            })
        ]
    });
};
var $0e4e053c53fa16e3$export$2e2bcd8739ae039 = $0e4e053c53fa16e3$var$TextareaForm;



const $f05b9ff6f59abe47$export$b135c3f9b9f02308 = (name)=>{
    if (!name || name === "") return "This field is required";
};
const $f05b9ff6f59abe47$export$18148d12c805c5b0 = (email)=>{
    if (!email || email === "") return "This field is required";
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) return "Please enter valid email address";
};
const $f05b9ff6f59abe47$export$30dc0b291f505e34 = (phoneNumber)=>{
    if (!phoneNumber || phoneNumber === "") return "This field is required";
    if (phoneNumber.replace(/\D/g, "").length !== 10) return "Please enter valid phone number";
};
const $f05b9ff6f59abe47$export$c17861b159b1b673 = (message)=>{
    if (!message || message === "") return "This field is required";
};


function $368ec9ce40b8ecb8$var$Contact() {
    const [submitted, setSubmitted] = (0, $eXaQ2.useState)(false);
    const [agreed, setAgreed] = (0, $eXaQ2.useState)(false);
    const [firstName, setFirstName] = (0, $eXaQ2.useState)("");
    const [lastName, setLastName] = (0, $eXaQ2.useState)("");
    const [email, setEmail] = (0, $eXaQ2.useState)("");
    const [phoneNumber, setPhoneNumber] = (0, $eXaQ2.useState)("");
    const [body, setBody] = (0, $eXaQ2.useState)("");
    const [country, setCountry] = (0, $eXaQ2.useState)("US");
    // const handleSubmit = async (event) => {
    //   event.preventDefault()
    //   const data = new FormData()
    //   data.append('First Name', firstName)
    //   data.append('Last Name', lastName)
    //   data.append('email', email)
    //   data.append('Country', country)
    //   data.append('Phone Number', phoneNumber)
    //   data.append('body', body)
    //   const url =
    //     'https://webhook.frontapp.com/forms/optimize_ad/SzgYgbQNvtn53iswxBHeMsuQ2kxelM9YYhm5e9GxlcI-KeZS61PayZUQHl5G3ao9FazXv9yfWPcZEEPPhNZDbS0McbcLTBqzS30O_eeMu3v2bQI'
    //   await fetch(url, {
    //     method: 'POST',
    //     body: data,
    //   })
    // }
    const onSubmit = async (values)=>{
        const data = new FormData();
        data.append("First Name", values.firstName);
        data.append("Last Name", values.lastName);
        data.append("email", values.email);
        data.append("Country", "US");
        data.append("Phone Number", values.phoneNumber.replace(/\D/g, ""));
        data.append("body", values.message);
        const url = "https://webhook.frontapp.com/forms/optimize_ad/SzgYgbQNvtn53iswxBHeMsuQ2kxelM9YYhm5e9GxlcI-KeZS61PayZUQHl5G3ao9FazXv9yfWPcZEEPPhNZDbS0McbcLTBqzS30O_eeMu3v2bQI";
        try {
            const res = await (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).post(url, data);
            console.log(res);
            setSubmitted(true);
        } catch (err) {
            console.log(err);
        }
    };
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $068b8ebf52e31cd5$export$2e2bcd8739ae039), {
        title: "Contact Us | Penny Pincher News",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
            className: "relative isolate -mt-20 bg-white",
            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "relative px-6 pb-20 pt-24 sm:pt-32 lg:static lg:px-8 lg:py-48",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "mx-auto max-w-xl lg:mx-0 lg:max-w-lg",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-gray-100 ring-gray-900/10 ring-1 lg:w-1/2",
                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("svg", {
                                        className: "absolute inset-0 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]",
                                        "aria-hidden": "true",
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("pattern", {
                                                    id: "83fd4e5a-9d52-42fc-97b6-718e5d7ee527",
                                                    width: 200,
                                                    height: 200,
                                                    x: "100%",
                                                    y: -1,
                                                    patternUnits: "userSpaceOnUse",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M130 200V.5M.5 .5H200",
                                                        fill: "none"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("rect", {
                                                width: "100%",
                                                height: "100%",
                                                strokeWidth: 0,
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                x: "100%",
                                                y: -1,
                                                className: "overflow-visible fill-gray-50",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M-470.5 0h201v201h-201Z",
                                                    strokeWidth: 0
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("rect", {
                                                width: "100%",
                                                height: "100%",
                                                strokeWidth: 0,
                                                fill: "url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h2", {
                                    className: "text-3xl font-bold tracking-tight text-gray-900",
                                    children: "Get in touch"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                    className: "mt-6 text-lg leading-8 text-gray-600",
                                    children: "If you have any questions, comments, or concerns please reach out to us and a member of our team will get back to you as soon as possible."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("dl", {
                                    className: "mt-10 space-y-4 text-base leading-7 text-gray-600",
                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                        className: "flex gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("dt", {
                                                className: "flex-none",
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Address"
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4e29b91146e00802$export$2e2bcd8739ae039), {
                                                        className: "h-7 w-6 text-gray-400",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("dd", {
                                                children: [
                                                    "30 N Gould St",
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("br", {}),
                                                    "Sheridan, WY 82801"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    submitted ? /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h2", {
                        className: "px-6 pb-24 pt-20 text-center text-xl text-gray-900 sm:pb-32 lg:px-8 lg:py-48",
                        children: "We have received your inquiry and will get back to you soon!"
                    }) : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $73e84f96b8d2f4df$export$a7fed597f4b8afd8), {
                        onSubmit: onSubmit,
                        render: ({ handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("form", {
                                className: "px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48",
                                onSubmit: handleSubmit,
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    className: "mx-auto max-w-xl lg:mr-0 lg:max-w-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $73e84f96b8d2f4df$export$a455218a85c89869), {
                                                    name: "firstName",
                                                    validate: (0, $f05b9ff6f59abe47$export$b135c3f9b9f02308),
                                                    children: (props)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $b691b673e00e3e03$export$2e2bcd8739ae039), {
                                                            label: "First name",
                                                            ...props
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $73e84f96b8d2f4df$export$a455218a85c89869), {
                                                    name: "lastName",
                                                    validate: (0, $f05b9ff6f59abe47$export$b135c3f9b9f02308),
                                                    children: (props)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $b691b673e00e3e03$export$2e2bcd8739ae039), {
                                                            label: "Last name",
                                                            ...props
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $73e84f96b8d2f4df$export$a455218a85c89869), {
                                                    name: "email",
                                                    validate: (0, $f05b9ff6f59abe47$export$18148d12c805c5b0),
                                                    children: (props)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $b691b673e00e3e03$export$2e2bcd8739ae039), {
                                                            className: "sm:col-span-2",
                                                            label: "Email",
                                                            ...props
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $73e84f96b8d2f4df$export$a455218a85c89869), {
                                                    name: "phoneNumber",
                                                    validate: (0, $f05b9ff6f59abe47$export$30dc0b291f505e34),
                                                    children: (props)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $b691b673e00e3e03$export$2e2bcd8739ae039), {
                                                            className: "sm:col-span-2",
                                                            label: "Phone number",
                                                            isPhone: true,
                                                            ...props
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $73e84f96b8d2f4df$export$a455218a85c89869), {
                                                    name: "message",
                                                    validate: (0, $f05b9ff6f59abe47$export$c17861b159b1b673),
                                                    children: (props)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $0e4e053c53fa16e3$export$2e2bcd8739ae039), {
                                                            className: "sm:col-span-2",
                                                            label: "Message",
                                                            rows: 4,
                                                            ...props
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "mt-8 flex justify-end",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("button", {
                                                type: "submit",
                                                className: "rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                                children: "Send message"
                                            })
                                        })
                                    ]
                                })
                            })
                    })
                ]
            })
        })
    });
}
var $368ec9ce40b8ecb8$export$2e2bcd8739ae039 = $368ec9ce40b8ecb8$var$Contact;






const $ef4b361f45089d9f$var$Privacy = ()=>{
    window.scrollTo(0, 0);
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $86a0a2c7143f17cc$export$2e2bcd8739ae039), {
        title: "Privacy Policy | Penny Pincher News",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
            className: "container mx-auto px-8",
            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "prose mx-auto max-w-7xl",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h1", {
                        children: "Privacy Policy "
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Last updated: May 29, 2023"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "This privacy policy has been compiled to better serve those who are concerned with how their ‘Personally identifiable information’ (PII) is being used online. PII, as used in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "What personal information do we collect from the people that visit our blog, website or app? When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number, credit card information or other details to help you with your experience."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "When do we collect information? "
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We collect information from you when you register on our site, place an order, subscribe to a newsletter, respond to a survey, fill out a form or enter information on our site"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "How do we use your information? "
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways: •To personalize user’s experience and to allow us to deliver the type of content and product offerings in which you are most interested. •To improve our website in order to better serve you. •To allow us to better service you in responding to your customer service requests. •To administer a contest, promotion, survey or other site feature. •To quickly process your transactions. •To send periodic emails regarding your order or other products and services."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "How do we protect visitor information?"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We do not use vulnerability scanning and/or scanning to PCI standards. We do not use Malware Scanning."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology. We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information. All transactions are processed through a gateway provider and are not stored or processed on our servers."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Do we use ‘cookies’?"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Yes. Cookies are small files that a site or its service provider transfers to your computer’s hard drive through your Web browser (if you allow) that enables the site’s or service provider’s systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "We use cookies to:"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Help remember and process the items in the shopping cart."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Understand and save user’s preferences for future visits."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Keep track of advertisements."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "TCompile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third party services that track this information on our behalf."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser (like Internet Explorer) settings. Each browser is a little different, so look at your browser’s Help menu to learn the correct way to modify your cookies."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "If you disable cookies off, some features will be disabled It won’t affect the users experience that make your site experience more efficient and some of our services will not function properly."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "However, you can still place orders."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Third Party Disclosure We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information unless we provide you with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential. We may also release your information when we believe release is appropriate to comply with the law, enforce our site policies, or protect ours or others’ rights, property, or safety."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Third Party Links Occasionally, at our discretion, we may include or offer third party products or services on our website. These third party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Google Google’s advertising requirements can be summed up by Google’s Advertising Principles. They are put in place to provide a positive experience for users. Check here"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "We use Google AdSense Advertising on our website."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Google, as a third party vendor, uses cookies to serve ads on our site. Google’s use of the DART cookie enables it to serve ads to our users based on their visit to our site and other sites on the Internet. Users may opt out of the use of the DART cookie by visiting the Google ad and content network privacy policy."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("p", {
                        children: [
                            "We have implemented the following:",
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "Remarketing with Google AdSense"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "Demographics and Interests Reporting"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "We along with third-party vendors, such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions, and other ad service functions as they relate to our website."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Opting out: "
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising initiative opt out page or permanently using the Google Analytics Opt Out Browser add on."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "California Online Privacy Protection Act"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law’s reach stretches well beyond California to require a person or company in the United States (and conceivably the world) that operates websites collecting personally identifiable information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals with whom it is being shared, and to comply with this policy."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "According to CalOPPA we agree to the following:"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Users can visit our site anonymously Once this privacy policy is created, we will add a link to it on our home page, or as a minimum on the first significant page after entering our website. Our Privacy Policy link includes the word ‘Privacy’, and can be easily be found on the page specified above. Users will be notified of any privacy policy changes: •On our Privacy Policy Page"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Users are able to change their personal information by logging in to their account"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "How does our site handle do not track signals?"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We honor do not track signals and do not track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Does our site allow third party behavioral tracking?"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "It’s also important to note that we do not allow third party behavioral tracking COPPA (Children Online Privacy Protection Act)"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "When it comes to the collection of personal information from children under 13, the Children’s Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, the nation’s consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children’s privacy and safety online."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We do not specifically market to children under 13."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Fair Information Practices The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur: We will notify the users via email within 7 business days"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We also agree to the individual redress principle, which requires that individuals have a right to pursue legally enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or a government agency to investigate and/or prosecute non-compliance by data processors. CAN SPAM Act The CAN-SPAM Act is a law that sets the rules for commercial email, establishes req–uirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "We collect your email address in order to:"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Send information, respond to inquiries, and/or other requests or questions."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Process orders and to send information and updates pertaining to orders"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "We may also send you additional information related to your product and/or service."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Market to our mailing list or continue to send emails to our clients after the original transaction has occurred"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "To be in accordance with CANSPAM we agree to the following:"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "NOT use false, or misleading subjects or email addresses physical address of our business or site headquarters"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Monitor third party email marketing services for compliance, if one is used."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Honor opt-out/unsubscribe requests quickly"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                    children: "Allow users to unsubscribe by using the link at the bottom of each email"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "If at any time you would like to unsubscribe from receiving future emails, you can: Follow the instructions at the bottom of each email and we will promptly remove you from ALL correspondence."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Contact Us"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "If there are any questions regarding this privacy policy you may contact us using the information below"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Optimize Ventures Inc (DBA Penny Pincher) - 30 N Gould St, Ste R Sheridan, WY 82801"
                    })
                ]
            })
        })
    });
};
var $ef4b361f45089d9f$export$2e2bcd8739ae039 = $ef4b361f45089d9f$var$Privacy;




const $9e55c085e1f96dfd$var$Terms = ()=>{
    window.scrollTo(0, 0);
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $86a0a2c7143f17cc$export$2e2bcd8739ae039), {
        title: "Terms of Use | Penny Pincher News",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
            className: "container mx-auto px-8",
            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "prose mx-auto max-w-7xl",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h1", {
                        children: "Terms of Use"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Last updated: May 29, 2023"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: 'Please read these Terms of Use ("Terms", "Terms of Use") carefully before using the Optimize Ventures website (the "Service") operated by Optimize Ventures Inc. ("us", "we", or "our").'
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Your access to and use of the Service is conditioned upon your acceptance of and compliance with these Terms without modification. These Terms apply to all visitors, users and others who wish to access or use the Service."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "By accessing or using the Service you agree to be bound by these Terms, whether or not you have read them. If you disagree with any part of the terms then you do not have permission to access the Service."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Purchases"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: 'If you wish to purchase any data made available through the Service ("Purchase"), you may be asked to supply certain information relevant to your Purchase including, without limitation, your credit card number, the expiration date of your credit card, your billing address, and your shipping information.'
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "You represent and warrant that: (i) you have the legal right to use any credit card(s) or other payment method(s) in connection with any Purchase; and that (ii) the information you supply to us is true, correct and complete."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "The service may employ the use of third party services for the purpose of facilitating payment and the completion of Purchases. By submitting your information, you grant us the right to provide the information to these third parties subject to our Privacy Policy."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "You acknowledge and agree that Optimize Ventures does not operate or control the internet or mobile networks and that (i) viruses, worms, Trojan horses or other undesirable data or software, or (ii) unauthorized users may attempt to obtain access to and damage your data, websites, hardware or networks. Service shall not be responsible for such activities."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We reserve the right to refuse or cancel your order at any time for reasons including but not limited to: product or service availability, errors in the description or price of the product or service, error in your order or other reasons."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: 'All data is sold "as is," "where is," and "with all faults," and, client shall have no right to request a refund. The Service will allow for a credit to your Optimize Ventures account of up to 10% of the cost for data you have purchased that is proven to be a disconnected phone number or a phone number that is not in service.'
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We reserve the right to refuse or cancel your order if fraud or an unauthorized or illegal transaction is suspected."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Availability, Errors and Inaccuracies"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We are constantly updating product and service offerings on the Service. We may experience delays in updating information on the Service and in our advertising on other web sites. The information found on the Service may contain errors or inaccuracies and may not be complete or current. Products or services may be mispriced, described inaccurately, or unavailable on the Service and we cannot guarantee the accuracy or completeness of any information found on the Service."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We therefore reserve the right to change or update information and to correct errors, inaccuracies, or omissions at any time without prior notice."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Contests, Sweepstakes and Promotions"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: 'Any contests, sweepstakes or other promotions (collectively, "Promotions") made available through the Service may be governed by rules that are separate from these Terms Conditions. If you participate in any Promotions, please review the applicable rules as well as our Privacy Policy. If the rules for a Promotion conflict with these Terms of Use, the Promotion rules will apply.'
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Accounts"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "When you create an account with us, you guarantee that you are above the age of 18, and that the information you provide to us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your account on the Service."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "You are responsible for maintaining the confidentiality of your account and password, including but not limited to the restriction of access to your computer and/or account. You accept responsibility for all activities or actions that occur under your account and/or password, whether your password is with our Service or a third-party service. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trademark that is subject to any rights of another person or entity other than you, without appropriate authorization. You may not use as a username any name that is offensive, vulgar or obscene."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We reserve the right to refuse service, terminate accounts, remove or edit content, or cancel orders in our sole discretion."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Intellectual Property"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "The Service and its original content, features and functionality are and will remain the exclusive property of Optimize Ventures Inc. and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Optimize Ventures Inc."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Links to Other Web Sites"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Our Service may contain links to third party web sites or services that are not owned or controlled by Optimize Ventures Inc. When you link to those sites, you leave the Optimize Ventures site. Optimize Ventures Inc. has no control over, and assumes no responsibility for the content, resources, privacy policies, or practices of any third-party web sites or services. We do not warrant the offerings of any of these entities/individuals or their websites. Our Privacy Policy does not apply to the practices of any companies or individuals operating the linked sites."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "You acknowledge and agree that Optimize Ventures Inc. shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such third party web sites or services."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We strongly advise you to read the terms and conditions and privacy policies of any third party web sites or services that you visit. Your use of such third party sites or services is at your own risk."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Termination"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms. We may also exercise all other legal and equitable remedies that may be available."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "If you wish to terminate your account, you may simply discontinue using the Service."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnification and limitations of liability."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Indemnification"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "You agree to defend, indemnify and hold harmless Optimize Ventures Inc. and its licensee and licensors, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees), resulting from or arising out of a) your use and access of the Service, by you or any person using your account and password, or b) a breach of these Terms."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Limitation Of Liability"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "In no event shall Optimize Ventures Inc., nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed its essential purpose."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "In no event shall Optimize Ventures’s total liability for all damages exceed the amount paid by you for the Service within the one year period prior to the alleged act or omission giving rise to Optimize Ventures’s alleged liability."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "You agree to bring any and all claims and actions against Optimize Ventures no more than one (1) year after the date of the alleged act or omission giving rise to Optimize Ventures's liability or be forever barred."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Disclaimer"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: 'Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.'
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Optimize Ventures Inc. its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function without interruption, be secure or available at any time or location; b) any errors or defects will be corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service will meet your requirements."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Exclusions"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Some jurisdictions do not allow the exclusion of certain warranties or the exclusion or limitation of liability for consequential or incidental damages, so the limitations above may not apply to you."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Governing Law"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "These Terms shall be governed and construed in accordance with the laws of Texas, United States, without regard to its conflict of law provisions."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the parties nevertheless agree that the court should endeavor to give effect to the parties’ intentions as reflected in the provision, and the remaining provisions of these Terms will remain in full force and effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have had between us regarding the Service."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Changes"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "We reserve the right, at our sole discretion, to modify or replace these Terms at any time, including by posting information regarding such changes on the Optimize Ventures’s website."
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use the Service. It is your responsibility to monitor these Terms and the Optimize Ventures’s website regarding modifications to these Terms."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                        children: "Contact Us"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "If you have any questions about these Terms, please contact us at info@optimizeventures.com"
                    })
                ]
            })
        })
    });
};
var $9e55c085e1f96dfd$export$2e2bcd8739ae039 = $9e55c085e1f96dfd$var$Terms;





const $a239df06d4f8aed5$var$AdvertorialLayout = ({ children: children, className: className = "", title: title })=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $a1cc52fbd40b0eb4$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $1f02524b81d370cb$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("title", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                className: "sticky top-0 z-50",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                    className: "bg-white",
                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("header", {
                        className: "shadow-md",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("nav", {
                            "aria-label": "Global",
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "border-b",
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    className: "mx-auto flex max-w-7xl items-center justify-between p-3 md:p-3 ",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "flex lg:flex-1",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("a", {
                                                href: "/",
                                                className: "-m-1.5 p-1.5 font-mono text-xl uppercase tracking-tight md:text-3xl",
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Penny"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                                        className: "-ml-2",
                                                        children: "Pincher"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "hidden lg:flex lg:gap-x-12",
                                            children: "Advertorial"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("main", {
                className: `${className} mt-4 md:mt-10`,
                children: children
            })
        ]
    });
};
var $a239df06d4f8aed5$export$2e2bcd8739ae039 = $a239df06d4f8aed5$var$AdvertorialLayout;





let $16d158a2d054cbe7$var$_ = (t)=>t, $16d158a2d054cbe7$var$t;
const $16d158a2d054cbe7$var$GET_ADVERTORIAL = (slug)=>(0, $fd0c0e1ba95e1f7a$export$72e4926bf8358653)($16d158a2d054cbe7$var$t || ($16d158a2d054cbe7$var$t = $16d158a2d054cbe7$var$_`
  query {
    advertorials(filters: { slug: { eq: "${0}" } }) {
    data {
      attributes {
        title
        slug
        primary_image {
          data {
            attributes {
              formats
            }
          }
        }
        primary_content {
          ... on ComponentAdvertorialContent {
            id
            content
            offer_url
            voluum_url
          }
          ... on ComponentAdvertorialAdvertorialButton {
            id
            text_above_buttons
            label
            columns
            color
            offer_url
            voluum_url
          }
        }
        offer {
          ... on ComponentAdvertorialContentBlock {
            id
            headline
            content
            offer_image {
              data {
                attributes {
                  url
                }
              }
            }
            offer_url
            voluum_url
          }
          ... on ComponentAdvertorialAdvertorialButton {
            id
            text_above_buttons
            label
            columns
            color
            offer_url
            voluum_url
          }
        }
        sources {
          label
          href
        }
      }
    }
    }
  }
`), slug);
var $16d158a2d054cbe7$export$2e2bcd8739ae039 = $16d158a2d054cbe7$var$GET_ADVERTORIAL;




var $eXaQ2 = parcelRequire("eXaQ2");

var $cE4fx = parcelRequire("cE4fx");
var $3b5e89e686ad814a$exports = {};
/** Types of elements found in htmlparser2's DOM */ var $82fcc15f99574aa5$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($82fcc15f99574aa5$export$b992dc138d950e31 || ($82fcc15f99574aa5$export$b992dc138d950e31 = {}));
function $82fcc15f99574aa5$export$3bf645f08efe3292(elem) {
    return elem.type === $82fcc15f99574aa5$export$b992dc138d950e31.Tag || elem.type === $82fcc15f99574aa5$export$b992dc138d950e31.Script || elem.type === $82fcc15f99574aa5$export$b992dc138d950e31.Style;
}
const $82fcc15f99574aa5$export$be92b6f5f03c0fe9 = $82fcc15f99574aa5$export$b992dc138d950e31.Root;
const $82fcc15f99574aa5$export$5f1af8db9871e1d6 = $82fcc15f99574aa5$export$b992dc138d950e31.Text;
const $82fcc15f99574aa5$export$befdefbdce210f91 = $82fcc15f99574aa5$export$b992dc138d950e31.Directive;
const $82fcc15f99574aa5$export$4d299b491347818a = $82fcc15f99574aa5$export$b992dc138d950e31.Comment;
const $82fcc15f99574aa5$export$2f8b47a141e57afc = $82fcc15f99574aa5$export$b992dc138d950e31.Script;
const $82fcc15f99574aa5$export$d9e45bc13d335801 = $82fcc15f99574aa5$export$b992dc138d950e31.Style;
const $82fcc15f99574aa5$export$3288d34c523a1192 = $82fcc15f99574aa5$export$b992dc138d950e31.Tag;
const $82fcc15f99574aa5$export$1f8b8f7e5c763232 = $82fcc15f99574aa5$export$b992dc138d950e31.CDATA;
const $82fcc15f99574aa5$export$31b44af36ff2c60f = $82fcc15f99574aa5$export$b992dc138d950e31.Doctype;



class $965dc8435b603929$export$85c928794f8d04d4 {
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $965dc8435b603929$export$ae8e35ea29ddac22(this, recursive);
    }
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
}
class $965dc8435b603929$export$c3569d91cd44d357 extends $965dc8435b603929$export$85c928794f8d04d4 {
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
}
class $965dc8435b603929$export$5f1af8db9871e1d6 extends $965dc8435b603929$export$c3569d91cd44d357 {
    get nodeType() {
        return 3;
    }
    constructor(){
        super(...arguments);
        this.type = (0, $82fcc15f99574aa5$export$b992dc138d950e31).Text;
    }
}
class $965dc8435b603929$export$4d299b491347818a extends $965dc8435b603929$export$c3569d91cd44d357 {
    get nodeType() {
        return 8;
    }
    constructor(){
        super(...arguments);
        this.type = (0, $82fcc15f99574aa5$export$b992dc138d950e31).Comment;
    }
}
class $965dc8435b603929$export$9269dce19ee35e96 extends $965dc8435b603929$export$c3569d91cd44d357 {
    get nodeType() {
        return 1;
    }
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $82fcc15f99574aa5$export$b992dc138d950e31).Directive;
    }
}
class $965dc8435b603929$export$62be934f90997196 extends $965dc8435b603929$export$85c928794f8d04d4 {
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
}
class $965dc8435b603929$export$1f8b8f7e5c763232 extends $965dc8435b603929$export$62be934f90997196 {
    get nodeType() {
        return 4;
    }
    constructor(){
        super(...arguments);
        this.type = (0, $82fcc15f99574aa5$export$b992dc138d950e31).CDATA;
    }
}
class $965dc8435b603929$export$b34a105447964f9f extends $965dc8435b603929$export$62be934f90997196 {
    get nodeType() {
        return 9;
    }
    constructor(){
        super(...arguments);
        this.type = (0, $82fcc15f99574aa5$export$b992dc138d950e31).Root;
    }
}
class $965dc8435b603929$export$db77ccec0bb4ccac extends $965dc8435b603929$export$62be934f90997196 {
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $82fcc15f99574aa5$export$b992dc138d950e31).Script : name === "style" ? (0, $82fcc15f99574aa5$export$b992dc138d950e31).Style : (0, $82fcc15f99574aa5$export$b992dc138d950e31).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
}
function $965dc8435b603929$export$3bf645f08efe3292(node) {
    return (0, $82fcc15f99574aa5$export$3bf645f08efe3292)(node);
}
function $965dc8435b603929$export$c2d65aed98d39b56(node) {
    return node.type === (0, $82fcc15f99574aa5$export$b992dc138d950e31).CDATA;
}
function $965dc8435b603929$export$1879817ac5c922b7(node) {
    return node.type === (0, $82fcc15f99574aa5$export$b992dc138d950e31).Text;
}
function $965dc8435b603929$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $82fcc15f99574aa5$export$b992dc138d950e31).Comment;
}
function $965dc8435b603929$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $82fcc15f99574aa5$export$b992dc138d950e31).Directive;
}
function $965dc8435b603929$export$62858bae88b53fd0(node) {
    return node.type === (0, $82fcc15f99574aa5$export$b992dc138d950e31).Root;
}
function $965dc8435b603929$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $965dc8435b603929$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($965dc8435b603929$export$1879817ac5c922b7(node)) result = new $965dc8435b603929$export$5f1af8db9871e1d6(node.data);
    else if ($965dc8435b603929$export$3ab01370f5e64ac8(node)) result = new $965dc8435b603929$export$4d299b491347818a(node.data);
    else if ($965dc8435b603929$export$3bf645f08efe3292(node)) {
        const children = recursive ? $965dc8435b603929$var$cloneChildren(node.children) : [];
        const clone = new $965dc8435b603929$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($965dc8435b603929$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $965dc8435b603929$var$cloneChildren(node.children) : [];
        const clone = new $965dc8435b603929$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($965dc8435b603929$export$62858bae88b53fd0(node)) {
        const children = recursive ? $965dc8435b603929$var$cloneChildren(node.children) : [];
        const clone = new $965dc8435b603929$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($965dc8435b603929$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $965dc8435b603929$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $965dc8435b603929$var$cloneChildren(childs) {
    const children = childs.map((child)=>$965dc8435b603929$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


// Default options
const $0252c32f503ba8c4$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $0252c32f503ba8c4$export$ff8ccbac9225de62 {
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $965dc8435b603929$export$b34a105447964f9f)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $82fcc15f99574aa5$export$b992dc138d950e31).Tag : undefined;
        const element = new (0, $965dc8435b603929$export$db77ccec0bb4ccac)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $82fcc15f99574aa5$export$b992dc138d950e31).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $965dc8435b603929$export$5f1af8db9871e1d6)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $82fcc15f99574aa5$export$b992dc138d950e31).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $965dc8435b603929$export$4d299b491347818a)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $965dc8435b603929$export$5f1af8db9871e1d6)("");
        const node = new (0, $965dc8435b603929$export$1f8b8f7e5c763232)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $965dc8435b603929$export$9269dce19ee35e96)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $965dc8435b603929$export$b34a105447964f9f)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $0252c32f503ba8c4$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $0252c32f503ba8c4$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
}
var $0252c32f503ba8c4$export$2e2bcd8739ae039 = $0252c32f503ba8c4$export$ff8ccbac9225de62;


var $9c2dde5e074f23cb$exports = {};

$parcel$defineInteropFlag($9c2dde5e074f23cb$exports);

$parcel$export($9c2dde5e074f23cb$exports, "default", function () { return $9c2dde5e074f23cb$export$2e2bcd8739ae039; });
var $ca847faa37cc56c8$exports = {};
// constants
var $ca847faa37cc56c8$var$HTML = "html";
var $ca847faa37cc56c8$var$HEAD = "head";
var $ca847faa37cc56c8$var$BODY = "body";
var $ca847faa37cc56c8$var$FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var $ca847faa37cc56c8$var$HEAD_TAG_REGEX = /<head[^]*>/i;
var $ca847faa37cc56c8$var$BODY_TAG_REGEX = /<body[^]*>/i;
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var $ca847faa37cc56c8$var$parseFromDocument = function() {
    throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
};
var $ca847faa37cc56c8$var$parseFromString = function() {
    throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
};
var $ca847faa37cc56c8$var$DOMParser = typeof window === "object" && window.DOMParser;
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */ if (typeof $ca847faa37cc56c8$var$DOMParser === "function") {
    var $ca847faa37cc56c8$var$domParser = new $ca847faa37cc56c8$var$DOMParser();
    var $ca847faa37cc56c8$var$mimeType = "text/html";
    /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */ $ca847faa37cc56c8$var$parseFromString = function(html, tagName) {
        if (tagName) html = "<" + tagName + ">" + html + "</" + tagName + ">";
        return $ca847faa37cc56c8$var$domParser.parseFromString(html, $ca847faa37cc56c8$var$mimeType);
    };
    $ca847faa37cc56c8$var$parseFromDocument = $ca847faa37cc56c8$var$parseFromString;
}
/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */ if (typeof document === "object" && document.implementation) {
    var $ca847faa37cc56c8$var$doc = document.implementation.createHTMLDocument();
    /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */ $ca847faa37cc56c8$var$parseFromDocument = function(html, tagName) {
        if (tagName) {
            var element = $ca847faa37cc56c8$var$doc.documentElement.querySelector(tagName);
            element.innerHTML = html;
            return $ca847faa37cc56c8$var$doc;
        }
        $ca847faa37cc56c8$var$doc.documentElement.innerHTML = html;
        return $ca847faa37cc56c8$var$doc;
    };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */ var $ca847faa37cc56c8$var$template = typeof document === "object" ? document.createElement("template") : {};
var $ca847faa37cc56c8$var$parseFromTemplate;
if ($ca847faa37cc56c8$var$template.content) /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */ $ca847faa37cc56c8$var$parseFromTemplate = function(html) {
    $ca847faa37cc56c8$var$template.innerHTML = html;
    return $ca847faa37cc56c8$var$template.content.childNodes;
};
/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */ function $ca847faa37cc56c8$var$domparser(html) {
    var firstTagName;
    var match = html.match($ca847faa37cc56c8$var$FIRST_TAG_REGEX);
    if (match && match[1]) firstTagName = match[1].toLowerCase();
    var doc;
    var element;
    var elements;
    switch(firstTagName){
        case $ca847faa37cc56c8$var$HTML:
            doc = $ca847faa37cc56c8$var$parseFromString(html);
            // the created document may come with filler head/body elements,
            // so make sure to remove them if they don't actually exist
            if (!$ca847faa37cc56c8$var$HEAD_TAG_REGEX.test(html)) {
                element = doc.querySelector($ca847faa37cc56c8$var$HEAD);
                if (element) element.parentNode.removeChild(element);
            }
            if (!$ca847faa37cc56c8$var$BODY_TAG_REGEX.test(html)) {
                element = doc.querySelector($ca847faa37cc56c8$var$BODY);
                if (element) element.parentNode.removeChild(element);
            }
            return doc.querySelectorAll($ca847faa37cc56c8$var$HTML);
        case $ca847faa37cc56c8$var$HEAD:
        case $ca847faa37cc56c8$var$BODY:
            doc = $ca847faa37cc56c8$var$parseFromDocument(html);
            elements = doc.querySelectorAll(firstTagName);
            // if there's a sibling element, then return both elements
            if ($ca847faa37cc56c8$var$BODY_TAG_REGEX.test(html) && $ca847faa37cc56c8$var$HEAD_TAG_REGEX.test(html)) return elements[0].parentNode.childNodes;
            return elements;
        // low-level tag or text
        default:
            if ($ca847faa37cc56c8$var$parseFromTemplate) return $ca847faa37cc56c8$var$parseFromTemplate(html);
            element = $ca847faa37cc56c8$var$parseFromDocument(html, $ca847faa37cc56c8$var$BODY).querySelector($ca847faa37cc56c8$var$BODY);
            return element.childNodes;
    }
}
$ca847faa37cc56c8$exports = $ca847faa37cc56c8$var$domparser;


var $c9841e7329780417$exports = {};

$parcel$export($c9841e7329780417$exports, "formatAttributes", function () { return $c9841e7329780417$export$9ca5fb17560152b9; }, function (v) { return $c9841e7329780417$export$9ca5fb17560152b9 = v; });
$parcel$export($c9841e7329780417$exports, "formatDOM", function () { return $c9841e7329780417$export$82ef7ce8825bcfd1; }, function (v) { return $c9841e7329780417$export$82ef7ce8825bcfd1 = v; });
var $c9841e7329780417$export$9ca5fb17560152b9;
var $c9841e7329780417$export$82ef7ce8825bcfd1;

/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z}
 */ var $d570af16530d6f35$export$fe8547a1bfbc8a99;
$d570af16530d6f35$export$fe8547a1bfbc8a99 = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
];


var $c9841e7329780417$var$CASE_SENSITIVE_TAG_NAMES = $d570af16530d6f35$export$fe8547a1bfbc8a99;
var $c9841e7329780417$var$Comment = $965dc8435b603929$export$4d299b491347818a;
var $c9841e7329780417$var$Element = $965dc8435b603929$export$db77ccec0bb4ccac;
var $c9841e7329780417$var$ProcessingInstruction = $965dc8435b603929$export$9269dce19ee35e96;
var $c9841e7329780417$var$Text = $965dc8435b603929$export$5f1af8db9871e1d6;
var $c9841e7329780417$var$caseSensitiveTagNamesMap = {};
var $c9841e7329780417$var$tagName;
for(var $c9841e7329780417$var$i = 0, $c9841e7329780417$var$len = $c9841e7329780417$var$CASE_SENSITIVE_TAG_NAMES.length; $c9841e7329780417$var$i < $c9841e7329780417$var$len; $c9841e7329780417$var$i++){
    $c9841e7329780417$var$tagName = $c9841e7329780417$var$CASE_SENSITIVE_TAG_NAMES[$c9841e7329780417$var$i];
    $c9841e7329780417$var$caseSensitiveTagNamesMap[$c9841e7329780417$var$tagName.toLowerCase()] = $c9841e7329780417$var$tagName;
}
/**
 * Gets case-sensitive tag name.
 *
 * @param {string} tagName - Tag name in lowercase.
 * @returns {string|undefined} - Case-sensitive tag name.
 */ function $c9841e7329780417$var$getCaseSensitiveTagName(tagName) {
    return $c9841e7329780417$var$caseSensitiveTagNamesMap[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param {NamedNodeMap} attributes - List of attributes.
 * @returns {object} - Map of attribute name to value.
 */ function $c9841e7329780417$var$formatAttributes(attributes) {
    var result = {};
    var attribute;
    // `NamedNodeMap` is array-like
    for(var i = 0, len = attributes.length; i < len; i++){
        attribute = attributes[i];
        result[attribute.name] = attribute.value;
    }
    return result;
}
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param {string} tagName - Lowercase tag name.
 * @returns {string} - Formatted tag name.
 */ function $c9841e7329780417$var$formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = $c9841e7329780417$var$getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) return caseSensitiveTagName;
    return tagName;
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param {NodeList} nodes - DOM nodes.
 * @param {Element|null} [parent=null] - Parent node.
 * @param {string} [directive] - Directive.
 * @returns {Array<Comment|Element|ProcessingInstruction|Text>}
 */ function $c9841e7329780417$var$formatDOM(nodes, parent, directive) {
    parent = parent || null;
    var result = [];
    var tagName;
    for(var index = 0, len = nodes.length; index < len; index++){
        var node = nodes[index];
        var current;
        // set the node data given the type
        switch(node.nodeType){
            case 1:
                tagName = $c9841e7329780417$var$formatTagName(node.nodeName);
                // script, style, or tag
                current = new $c9841e7329780417$var$Element(tagName, $c9841e7329780417$var$formatAttributes(node.attributes));
                current.children = $c9841e7329780417$var$formatDOM(// template children are on content
                tagName === "template" ? node.content.childNodes : node.childNodes, current);
                break;
            case 3:
                current = new $c9841e7329780417$var$Text(node.nodeValue);
                break;
            case 8:
                current = new $c9841e7329780417$var$Comment(node.nodeValue);
                break;
            default:
                continue;
        }
        // set previous node next
        var prev = result[index - 1] || null;
        if (prev) prev.next = current;
        // set properties for current node
        current.parent = parent;
        current.prev = prev;
        current.next = null;
        result.push(current);
    }
    if (directive) {
        current = new $c9841e7329780417$var$ProcessingInstruction(directive.substring(0, directive.indexOf(" ")).toLowerCase(), directive);
        current.next = result[0] || null;
        current.parent = parent;
        result.unshift(current);
        if (result[1]) result[1].prev = result[0];
    }
    return result;
}
$c9841e7329780417$export$9ca5fb17560152b9 = $c9841e7329780417$var$formatAttributes;
$c9841e7329780417$export$82ef7ce8825bcfd1 = $c9841e7329780417$var$formatDOM;


var $9c2dde5e074f23cb$var$formatDOM = (0, (/*@__PURE__*/$parcel$interopDefault($c9841e7329780417$exports))).formatDOM;
var $9c2dde5e074f23cb$var$DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
function $9c2dde5e074f23cb$export$2e2bcd8739ae039(html) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (html === "") return [];
    // match directive
    var match = html.match($9c2dde5e074f23cb$var$DIRECTIVE_REGEX);
    var directive;
    if (match && match[1]) directive = match[1];
    return $9c2dde5e074f23cb$var$formatDOM((0, (/*@__PURE__*/$parcel$interopDefault($ca847faa37cc56c8$exports)))(html), null, directive);
}


var $3b5e89e686ad814a$require$htmlToDOM = $9c2dde5e074f23cb$exports;
var $3e1db7c9fe5f1e2e$exports = {};
var $73211d7ed5e4fb48$exports = {};
"use strict";
Object.defineProperty($73211d7ed5e4fb48$exports, "__esModule", {
    value: true
});
function $73211d7ed5e4fb48$var$_slicedToArray(arr, i) {
    return $73211d7ed5e4fb48$var$_arrayWithHoles(arr) || $73211d7ed5e4fb48$var$_iterableToArrayLimit(arr, i) || $73211d7ed5e4fb48$var$_unsupportedIterableToArray(arr, i) || $73211d7ed5e4fb48$var$_nonIterableRest();
}
function $73211d7ed5e4fb48$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $73211d7ed5e4fb48$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $73211d7ed5e4fb48$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $73211d7ed5e4fb48$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $73211d7ed5e4fb48$var$_arrayLikeToArray(o, minLen);
}
function $73211d7ed5e4fb48$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $73211d7ed5e4fb48$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var $73211d7ed5e4fb48$var$RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
var $73211d7ed5e4fb48$var$STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
var $73211d7ed5e4fb48$var$BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
var $73211d7ed5e4fb48$var$BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
var $73211d7ed5e4fb48$var$OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
var $73211d7ed5e4fb48$var$NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
var $73211d7ed5e4fb48$var$POSITIVE_NUMERIC = 6;
function $73211d7ed5e4fb48$var$getPropertyInfo(name) {
    return $73211d7ed5e4fb48$var$properties.hasOwnProperty(name) ? $73211d7ed5e4fb48$var$properties[name] : null;
}
function $73211d7ed5e4fb48$var$PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
    this.acceptsBooleans = type === $73211d7ed5e4fb48$var$BOOLEANISH_STRING || type === $73211d7ed5e4fb48$var$BOOLEAN || type === $73211d7ed5e4fb48$var$OVERLOADED_BOOLEAN;
    this.attributeName = attributeName;
    this.attributeNamespace = attributeNamespace;
    this.mustUseProperty = mustUseProperty;
    this.propertyName = name;
    this.type = type;
    this.sanitizeURL = sanitizeURL;
    this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
var $73211d7ed5e4fb48$var$properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
var $73211d7ed5e4fb48$var$reservedProps = [
    "children",
    "dangerouslySetInnerHTML",
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
];
$73211d7ed5e4fb48$var$reservedProps.forEach(function(name) {
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$RESERVED, false, name, null, false, false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(_ref) {
    var _ref2 = $73211d7ed5e4fb48$var$_slicedToArray(_ref, 2), name = _ref2[0], attributeName = _ref2[1];
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$STRING, false, attributeName, null, false, false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(name) {
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(name) {
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$BOOLEANISH_STRING, false, name, null, false, false);
}); // These are HTML boolean attributes.
[
    "allowFullScreen",
    "async",
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    "itemScope"
].forEach(function(name) {
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$BOOLEAN, false, name.toLowerCase(), null, false, false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
[
    "checked",
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$BOOLEAN, true, name, null, false, false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
[
    "capture",
    "download" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$OVERLOADED_BOOLEAN, false, name, null, false, false);
}); // These are HTML attributes that must be positive numbers.
[
    "cols",
    "rows",
    "size",
    "span" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$POSITIVE_NUMERIC, false, name, null, false, false);
}); // These are HTML attributes that must be numbers.
[
    "rowSpan",
    "start"
].forEach(function(name) {
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$NUMERIC, false, name.toLowerCase(), null, false, false);
});
var $73211d7ed5e4fb48$var$CAMELIZE = /[\-\:]([a-z])/g;
var $73211d7ed5e4fb48$var$capitalize = function capitalize(token) {
    return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
[
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($73211d7ed5e4fb48$var$CAMELIZE, $73211d7ed5e4fb48$var$capitalize);
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$STRING, false, attributeName, null, false, false);
}); // String SVG attributes with the xlink namespace.
[
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($73211d7ed5e4fb48$var$CAMELIZE, $73211d7ed5e4fb48$var$capitalize);
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
}); // String SVG attributes with the xml namespace.
[
    "xml:base",
    "xml:lang",
    "xml:space" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($73211d7ed5e4fb48$var$CAMELIZE, $73211d7ed5e4fb48$var$capitalize);
    $73211d7ed5e4fb48$var$properties[name] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(name, $73211d7ed5e4fb48$var$STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
[
    "tabIndex",
    "crossOrigin"
].forEach(function(attributeName) {
    $73211d7ed5e4fb48$var$properties[attributeName] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(attributeName, $73211d7ed5e4fb48$var$STRING, false, attributeName.toLowerCase(), null, false, false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
var $73211d7ed5e4fb48$var$xlinkHref = "xlinkHref";
$73211d7ed5e4fb48$var$properties[$73211d7ed5e4fb48$var$xlinkHref] = new $73211d7ed5e4fb48$var$PropertyInfoRecord("xlinkHref", $73211d7ed5e4fb48$var$STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(attributeName) {
    $73211d7ed5e4fb48$var$properties[attributeName] = new $73211d7ed5e4fb48$var$PropertyInfoRecord(attributeName, $73211d7ed5e4fb48$var$STRING, false, attributeName.toLowerCase(), null, true, true);
});
// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var $8564ae5600788fbd$export$7359a57b3ac1f378;
var $8564ae5600788fbd$export$5ab28d07cff57c11;
var $8564ae5600788fbd$export$bbecfff5ecf65cd8;
var $8564ae5600788fbd$var$SAME = 0;
$8564ae5600788fbd$export$7359a57b3ac1f378 = $8564ae5600788fbd$var$SAME;
// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var $8564ae5600788fbd$var$CAMELCASE = 1;
$8564ae5600788fbd$export$5ab28d07cff57c11 = $8564ae5600788fbd$var$CAMELCASE;
$8564ae5600788fbd$export$bbecfff5ecf65cd8 = {
    accept: 0,
    acceptCharset: 1,
    "accept-charset": "acceptCharset",
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: "className",
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: "htmlFor",
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    "http-equiv": "httpEquiv",
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    "accent-height": "accentHeight",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    "alignment-baseline": "alignmentBaseline",
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    "arabic-form": "arabicForm",
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    "baseline-shift": "baselineShift",
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    "cap-height": "capHeight",
    clip: 0,
    clipPath: 1,
    "clip-path": "clipPath",
    clipPathUnits: 1,
    clipRule: 1,
    "clip-rule": "clipRule",
    color: 0,
    colorInterpolation: 1,
    "color-interpolation": "colorInterpolation",
    colorInterpolationFilters: 1,
    "color-interpolation-filters": "colorInterpolationFilters",
    colorProfile: 1,
    "color-profile": "colorProfile",
    colorRendering: 1,
    "color-rendering": "colorRendering",
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    "dominant-baseline": "dominantBaseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    "enable-background": "enableBackground",
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    "fill-opacity": "fillOpacity",
    fillRule: 1,
    "fill-rule": "fillRule",
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    "flood-opacity": "floodOpacity",
    floodColor: 1,
    "flood-color": "floodColor",
    focusable: 0,
    fontFamily: 1,
    "font-family": "fontFamily",
    fontSize: 1,
    "font-size": "fontSize",
    fontSizeAdjust: 1,
    "font-size-adjust": "fontSizeAdjust",
    fontStretch: 1,
    "font-stretch": "fontStretch",
    fontStyle: 1,
    "font-style": "fontStyle",
    fontVariant: 1,
    "font-variant": "fontVariant",
    fontWeight: 1,
    "font-weight": "fontWeight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    "glyph-name": "glyphName",
    glyphOrientationHorizontal: 1,
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphOrientationVertical: 1,
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    "horiz-adv-x": "horizAdvX",
    horizOriginX: 1,
    "horiz-origin-x": "horizOriginX",
    ideographic: 0,
    imageRendering: 1,
    "image-rendering": "imageRendering",
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    "letter-spacing": "letterSpacing",
    lightingColor: 1,
    "lighting-color": "lightingColor",
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    "marker-end": "markerEnd",
    markerHeight: 1,
    markerMid: 1,
    "marker-mid": "markerMid",
    markerStart: 1,
    "marker-start": "markerStart",
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    "overline-position": "overlinePosition",
    overlineThickness: 1,
    "overline-thickness": "overlineThickness",
    paintOrder: 1,
    "paint-order": "paintOrder",
    panose1: 0,
    "panose-1": "panose1",
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    "pointer-events": "pointerEvents",
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    "rendering-intent": "renderingIntent",
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    "shape-rendering": "shapeRendering",
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    "stop-color": "stopColor",
    stopOpacity: 1,
    "stop-opacity": "stopOpacity",
    strikethroughPosition: 1,
    "strikethrough-position": "strikethroughPosition",
    strikethroughThickness: 1,
    "strikethrough-thickness": "strikethroughThickness",
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    "stroke-dasharray": "strokeDasharray",
    strokeDashoffset: 1,
    "stroke-dashoffset": "strokeDashoffset",
    strokeLinecap: 1,
    "stroke-linecap": "strokeLinecap",
    strokeLinejoin: 1,
    "stroke-linejoin": "strokeLinejoin",
    strokeMiterlimit: 1,
    "stroke-miterlimit": "strokeMiterlimit",
    strokeWidth: 1,
    "stroke-width": "strokeWidth",
    strokeOpacity: 1,
    "stroke-opacity": "strokeOpacity",
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    "text-anchor": "textAnchor",
    textDecoration: 1,
    "text-decoration": "textDecoration",
    textLength: 1,
    textRendering: 1,
    "text-rendering": "textRendering",
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    "underline-position": "underlinePosition",
    underlineThickness: 1,
    "underline-thickness": "underlineThickness",
    unicode: 0,
    unicodeBidi: 1,
    "unicode-bidi": "unicodeBidi",
    unicodeRange: 1,
    "unicode-range": "unicodeRange",
    unitsPerEm: 1,
    "units-per-em": "unitsPerEm",
    unselectable: 0,
    vAlphabetic: 1,
    "v-alphabetic": "vAlphabetic",
    values: 0,
    vectorEffect: 1,
    "vector-effect": "vectorEffect",
    version: 0,
    vertAdvY: 1,
    "vert-adv-y": "vertAdvY",
    vertOriginX: 1,
    "vert-origin-x": "vertOriginX",
    vertOriginY: 1,
    "vert-origin-y": "vertOriginY",
    vHanging: 1,
    "v-hanging": "vHanging",
    vIdeographic: 1,
    "v-ideographic": "vIdeographic",
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    "v-mathematical": "vMathematical",
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    "word-spacing": "wordSpacing",
    writingMode: 1,
    "writing-mode": "writingMode",
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    "x-height": "xHeight",
    xlinkActuate: 1,
    "xlink:actuate": "xlinkActuate",
    xlinkArcrole: 1,
    "xlink:arcrole": "xlinkArcrole",
    xlinkHref: 1,
    "xlink:href": "xlinkHref",
    xlinkRole: 1,
    "xlink:role": "xlinkRole",
    xlinkShow: 1,
    "xlink:show": "xlinkShow",
    xlinkTitle: 1,
    "xlink:title": "xlinkTitle",
    xlinkType: 1,
    "xlink:type": "xlinkType",
    xmlBase: 1,
    "xml:base": "xmlBase",
    xmlLang: 1,
    "xml:lang": "xmlLang",
    xmlns: 0,
    "xml:space": "xmlSpace",
    xmlnsXlink: 1,
    "xmlns:xlink": "xmlnsXlink",
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
};


var $73211d7ed5e4fb48$var$CAMELCASE = $8564ae5600788fbd$export$5ab28d07cff57c11, $73211d7ed5e4fb48$var$SAME = $8564ae5600788fbd$export$7359a57b3ac1f378, $73211d7ed5e4fb48$var$possibleStandardNamesOptimized = $8564ae5600788fbd$export$bbecfff5ecf65cd8;
var $73211d7ed5e4fb48$var$ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var $73211d7ed5e4fb48$var$ATTRIBUTE_NAME_CHAR = $73211d7ed5e4fb48$var$ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */ var $73211d7ed5e4fb48$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp("^(data|aria)-[" + $73211d7ed5e4fb48$var$ATTRIBUTE_NAME_CHAR + "]*$"));
var $73211d7ed5e4fb48$var$possibleStandardNames = Object.keys($73211d7ed5e4fb48$var$possibleStandardNamesOptimized).reduce(function(accumulator, standardName) {
    var propName = $73211d7ed5e4fb48$var$possibleStandardNamesOptimized[standardName];
    if (propName === $73211d7ed5e4fb48$var$SAME) accumulator[standardName] = standardName;
    else if (propName === $73211d7ed5e4fb48$var$CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
    else accumulator[standardName] = propName;
    return accumulator;
}, {});
$73211d7ed5e4fb48$exports.BOOLEAN = $73211d7ed5e4fb48$var$BOOLEAN;
$73211d7ed5e4fb48$exports.BOOLEANISH_STRING = $73211d7ed5e4fb48$var$BOOLEANISH_STRING;
$73211d7ed5e4fb48$exports.NUMERIC = $73211d7ed5e4fb48$var$NUMERIC;
$73211d7ed5e4fb48$exports.OVERLOADED_BOOLEAN = $73211d7ed5e4fb48$var$OVERLOADED_BOOLEAN;
$73211d7ed5e4fb48$exports.POSITIVE_NUMERIC = $73211d7ed5e4fb48$var$POSITIVE_NUMERIC;
$73211d7ed5e4fb48$exports.RESERVED = $73211d7ed5e4fb48$var$RESERVED;
$73211d7ed5e4fb48$exports.STRING = $73211d7ed5e4fb48$var$STRING;
$73211d7ed5e4fb48$exports.getPropertyInfo = $73211d7ed5e4fb48$var$getPropertyInfo;
$73211d7ed5e4fb48$exports.isCustomAttribute = $73211d7ed5e4fb48$var$isCustomAttribute;
$73211d7ed5e4fb48$exports.possibleStandardNames = $73211d7ed5e4fb48$var$possibleStandardNames;


var $837699c17726687e$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");
var $665d4989e4a63811$exports = {};
"use strict";
var $665d4989e4a63811$var$__importDefault = $665d4989e4a63811$exports && $665d4989e4a63811$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
$665d4989e4a63811$exports.__esModule = true;

var $665d4989e4a63811$var$style_to_object_1 = $665d4989e4a63811$var$__importDefault((parcelRequire("kul33")));
var $7dc56dd9f7d57f01$export$1e511d4a378977f5;
var $7dc56dd9f7d57f01$export$8a7688a96d852767;
"use strict";
$7dc56dd9f7d57f01$export$1e511d4a378977f5 = true;
$7dc56dd9f7d57f01$export$8a7688a96d852767 = void 0;
var $7dc56dd9f7d57f01$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var $7dc56dd9f7d57f01$var$HYPHEN_REGEX = /-([a-z])/g;
var $7dc56dd9f7d57f01$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $7dc56dd9f7d57f01$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $7dc56dd9f7d57f01$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var $7dc56dd9f7d57f01$var$skipCamelCase = function(property) {
    return !property || $7dc56dd9f7d57f01$var$NO_HYPHEN_REGEX.test(property) || $7dc56dd9f7d57f01$var$CUSTOM_PROPERTY_REGEX.test(property);
};
var $7dc56dd9f7d57f01$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
var $7dc56dd9f7d57f01$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
var $7dc56dd9f7d57f01$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($7dc56dd9f7d57f01$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) property = property.replace($7dc56dd9f7d57f01$var$MS_VENDOR_PREFIX_REGEX, $7dc56dd9f7d57f01$var$trimHyphen);
    else property = property.replace($7dc56dd9f7d57f01$var$VENDOR_PREFIX_REGEX, $7dc56dd9f7d57f01$var$trimHyphen);
    return property.replace($7dc56dd9f7d57f01$var$HYPHEN_REGEX, $7dc56dd9f7d57f01$var$capitalize);
};
$7dc56dd9f7d57f01$export$8a7688a96d852767 = $7dc56dd9f7d57f01$var$camelCase;


function $665d4989e4a63811$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== "string") return output;
    (0, $665d4989e4a63811$var$style_to_object_1["default"])(style, function(property, value) {
        if (property && value) output[(0, $7dc56dd9f7d57f01$export$8a7688a96d852767)(property, options)] = value;
    });
    return output;
}
$665d4989e4a63811$exports["default"] = $665d4989e4a63811$var$StyleToJS;


var $837699c17726687e$require$styleToJS = $665d4989e4a63811$exports.default;
/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */ function $837699c17726687e$var$invertObject(obj, override) {
    if (!obj || typeof obj !== "object") throw new TypeError("First argument must be an object");
    var key;
    var value;
    var isOverridePresent = typeof override === "function";
    var overrides = {};
    var result = {};
    for(key in obj){
        value = obj[key];
        if (isOverridePresent) {
            overrides = override(key, value);
            if (overrides && overrides.length === 2) {
                result[overrides[0]] = overrides[1];
                continue;
            }
        }
        if (typeof value === "string") result[value] = key;
    }
    return result;
}
/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */ function $837699c17726687e$var$isCustomComponent(tagName, props) {
    if (tagName.indexOf("-") === -1) return props && typeof props.is === "string";
    switch(tagName){
        // These are reserved SVG and MathML elements.
        // We don't mind this whitelist too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return false;
        default:
            return true;
    }
}
var $837699c17726687e$var$styleToJSOptions = {
    reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */ function $837699c17726687e$var$setStyleProp(style, props) {
    if (style === null || style === undefined) return;
    try {
        props.style = $837699c17726687e$require$styleToJS(style, $837699c17726687e$var$styleToJSOptions);
    } catch (err) {
        props.style = {};
    }
}
/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */ var $837699c17726687e$var$PRESERVE_CUSTOM_ATTRIBUTES = $eXaQ2.version.split(".")[0] >= 16;
// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var $837699c17726687e$var$elementsWithNoTextChildren = new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
]);
/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */ function $837699c17726687e$var$canTextBeChildOfNode(node) {
    return !$837699c17726687e$var$elementsWithNoTextChildren.has(node.name);
}
$837699c17726687e$exports = {
    PRESERVE_CUSTOM_ATTRIBUTES: $837699c17726687e$var$PRESERVE_CUSTOM_ATTRIBUTES,
    invertObject: $837699c17726687e$var$invertObject,
    isCustomComponent: $837699c17726687e$var$isCustomComponent,
    setStyleProp: $837699c17726687e$var$setStyleProp,
    canTextBeChildOfNode: $837699c17726687e$var$canTextBeChildOfNode,
    elementsWithNoTextChildren: $837699c17726687e$var$elementsWithNoTextChildren
};


// https://reactjs.org/docs/uncontrolled-components.html
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var $3e1db7c9fe5f1e2e$var$UNCONTROLLED_COMPONENT_ATTRIBUTES = [
    "checked",
    "value"
];
var $3e1db7c9fe5f1e2e$var$UNCONTROLLED_COMPONENT_NAMES = [
    "input",
    "select",
    "textarea"
];
var $3e1db7c9fe5f1e2e$var$VALUE_ONLY_INPUTS = {
    reset: true,
    submit: true
};
/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @param {string} [nodeName] - DOM node name.
 * @returns - React props.
 */ $3e1db7c9fe5f1e2e$exports = function attributesToProps(attributes, nodeName) {
    attributes = attributes || {};
    var attributeName;
    var attributeNameLowerCased;
    var attributeValue;
    var propName;
    var propertyInfo;
    var props = {};
    var inputIsValueOnly = attributes.type && $3e1db7c9fe5f1e2e$var$VALUE_ONLY_INPUTS[attributes.type];
    for(attributeName in attributes){
        attributeValue = attributes[attributeName];
        // ARIA (aria-*) or custom data (data-*) attribute
        if ($73211d7ed5e4fb48$exports.isCustomAttribute(attributeName)) {
            props[attributeName] = attributeValue;
            continue;
        }
        // convert HTML/SVG attribute to React prop
        attributeNameLowerCased = attributeName.toLowerCase();
        propName = $3e1db7c9fe5f1e2e$var$getPropName(attributeNameLowerCased);
        if (propName) {
            propertyInfo = $73211d7ed5e4fb48$exports.getPropertyInfo(propName);
            // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
            if ($3e1db7c9fe5f1e2e$var$UNCONTROLLED_COMPONENT_ATTRIBUTES.indexOf(propName) !== -1 && $3e1db7c9fe5f1e2e$var$UNCONTROLLED_COMPONENT_NAMES.indexOf(nodeName) !== -1 && !inputIsValueOnly) propName = $3e1db7c9fe5f1e2e$var$getPropName("default" + attributeNameLowerCased);
            props[propName] = attributeValue;
            switch(propertyInfo && propertyInfo.type){
                case $73211d7ed5e4fb48$exports.BOOLEAN:
                    props[propName] = true;
                    break;
                case $73211d7ed5e4fb48$exports.OVERLOADED_BOOLEAN:
                    if (attributeValue === "") props[propName] = true;
                    break;
            }
            continue;
        }
        // preserve custom attribute if React >=16
        if ($837699c17726687e$exports.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
    }
    // transform inline style to object
    $837699c17726687e$exports.setStyleProp(attributes.style, props);
    return props;
};
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */ function $3e1db7c9fe5f1e2e$var$getPropName(attributeName) {
    return $73211d7ed5e4fb48$exports.possibleStandardNames[attributeName];
}


var $8e0e9eab503b151b$exports = {};

var $eXaQ2 = parcelRequire("eXaQ2");


var $8e0e9eab503b151b$var$setStyleProp = $837699c17726687e$exports.setStyleProp;
var $8e0e9eab503b151b$var$canTextBeChildOfNode = $837699c17726687e$exports.canTextBeChildOfNode;
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */ function $8e0e9eab503b151b$var$domToReact(nodes, options) {
    options = options || {};
    var library = options.library || $eXaQ2;
    var cloneElement = library.cloneElement;
    var createElement = library.createElement;
    var isValidElement = library.isValidElement;
    var result = [];
    var node;
    var isWhitespace;
    var hasReplace = typeof options.replace === "function";
    var replaceElement;
    var props;
    var children;
    var trim = options.trim;
    for(var i = 0, len = nodes.length; i < len; i++){
        node = nodes[i];
        // replace with custom React element (if present)
        if (hasReplace) {
            replaceElement = options.replace(node);
            if (isValidElement(replaceElement)) {
                // set "key" prop for sibling elements
                // https://fb.me/react-warning-keys
                if (len > 1) replaceElement = cloneElement(replaceElement, {
                    key: replaceElement.key || i
                });
                result.push(replaceElement);
                continue;
            }
        }
        if (node.type === "text") {
            isWhitespace = !node.data.trim().length;
            if (isWhitespace && node.parent && !$8e0e9eab503b151b$var$canTextBeChildOfNode(node.parent)) continue;
            if (trim && isWhitespace) continue;
            // We have a text node that's not whitespace and it can be nested
            // in its parent so add it to the results
            result.push(node.data);
            continue;
        }
        props = node.attribs;
        if ($8e0e9eab503b151b$var$skipAttributesToProps(node)) $8e0e9eab503b151b$var$setStyleProp(props.style, props);
        else if (props) props = $3e1db7c9fe5f1e2e$exports(props, node.name);
        children = null;
        switch(node.type){
            case "script":
            case "style":
                // prevent text in <script> or <style> from being escaped
                // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
                if (node.children[0]) props.dangerouslySetInnerHTML = {
                    __html: node.children[0].data
                };
                break;
            case "tag":
                // setting textarea value in children is an antipattern in React
                // https://reactjs.org/docs/forms.html#the-textarea-tag
                if (node.name === "textarea" && node.children[0]) props.defaultValue = node.children[0].data;
                else if (node.children && node.children.length) // continue recursion of creating React elements (if applicable)
                children = $8e0e9eab503b151b$var$domToReact(node.children, options);
                break;
            // skip all other cases (e.g., comment)
            default:
                continue;
        }
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) props.key = i;
        result.push(createElement(node.name, props, children));
    }
    return result.length === 1 ? result[0] : result;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */ function $8e0e9eab503b151b$var$skipAttributesToProps(node) {
    return $837699c17726687e$exports.PRESERVE_CUSTOM_ATTRIBUTES && node.type === "tag" && $837699c17726687e$exports.isCustomComponent(node.name, node.attribs);
}
$8e0e9eab503b151b$exports = $8e0e9eab503b151b$var$domToReact;


// support backwards compatibility for ES Module
$3b5e89e686ad814a$require$htmlToDOM = /* istanbul ignore next */ typeof $3b5e89e686ad814a$require$htmlToDOM.default === "function" ? $3b5e89e686ad814a$require$htmlToDOM.default : $3b5e89e686ad814a$require$htmlToDOM;
var $3b5e89e686ad814a$var$domParserOptions = {
    lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */ function $3b5e89e686ad814a$var$HTMLReactParser(html, options) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (html === "") return [];
    options = options || {};
    return $8e0e9eab503b151b$exports($3b5e89e686ad814a$require$htmlToDOM(html, options.htmlparser2 || $3b5e89e686ad814a$var$domParserOptions), options);
}
$3b5e89e686ad814a$var$HTMLReactParser.domToReact = $8e0e9eab503b151b$exports;
$3b5e89e686ad814a$var$HTMLReactParser.htmlToDOM = $3b5e89e686ad814a$require$htmlToDOM;
$3b5e89e686ad814a$var$HTMLReactParser.attributesToProps = $3e1db7c9fe5f1e2e$exports;
// domhandler
$3b5e89e686ad814a$var$HTMLReactParser.Comment = $965dc8435b603929$export$4d299b491347818a;
$3b5e89e686ad814a$var$HTMLReactParser.Element = $965dc8435b603929$export$db77ccec0bb4ccac;
$3b5e89e686ad814a$var$HTMLReactParser.ProcessingInstruction = $965dc8435b603929$export$9269dce19ee35e96;
$3b5e89e686ad814a$var$HTMLReactParser.Text = $965dc8435b603929$export$5f1af8db9871e1d6;
// support CommonJS and ES Modules
$3b5e89e686ad814a$exports = $3b5e89e686ad814a$var$HTMLReactParser;
$3b5e89e686ad814a$var$HTMLReactParser.default = $3b5e89e686ad814a$var$HTMLReactParser;


var $8addaec5ee3f7ec4$export$562c76a291853ae = (0, (/*@__PURE__*/$parcel$interopDefault($3b5e89e686ad814a$exports))).domToReact;
var $8addaec5ee3f7ec4$export$131c6d55a47cefc8 = (0, (/*@__PURE__*/$parcel$interopDefault($3b5e89e686ad814a$exports))).htmlToDOM;
var $8addaec5ee3f7ec4$export$af8e902ee50b21fc = (0, (/*@__PURE__*/$parcel$interopDefault($3b5e89e686ad814a$exports))).attributesToProps;
var $8addaec5ee3f7ec4$export$4d299b491347818a = (0, (/*@__PURE__*/$parcel$interopDefault($3b5e89e686ad814a$exports))).Comment;
var $8addaec5ee3f7ec4$export$db77ccec0bb4ccac = (0, (/*@__PURE__*/$parcel$interopDefault($3b5e89e686ad814a$exports))).Element;
var $8addaec5ee3f7ec4$export$9269dce19ee35e96 = (0, (/*@__PURE__*/$parcel$interopDefault($3b5e89e686ad814a$exports))).ProcessingInstruction;
var $8addaec5ee3f7ec4$export$5f1af8db9871e1d6 = (0, (/*@__PURE__*/$parcel$interopDefault($3b5e89e686ad814a$exports))).Text;
var $8addaec5ee3f7ec4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3b5e89e686ad814a$exports)));




const $4caffb14b2edfdf5$var$AdvertorialFooter = ({ advertorial: advertorial })=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
        className: "mt-20 w-full bg-gray-900 py-10",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
            className: "mx-auto max-w-5xl px-2",
            children: [
                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                    className: "mb-6 grid-cols-3 md:grid",
                    children: [
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "col-span-2 text-center md:text-left",
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("a", {
                                href: "/",
                                className: "font-mono text-sm uppercase tracking-tight text-white md:text-xl",
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                        className: "font-bold",
                                        children: "Penny"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                        className: "-ml-2",
                                        children: "Pincher"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                className: "mt-6 grid grid-cols-3 place-items-center text-sm text-gray-200 md:mt-0",
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                                        to: "/terms",
                                        children: "Terms"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                                        to: "/privacy",
                                        children: "Privacy Policy"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                                        to: "/contact",
                                        children: "Contact"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("p", {
                    className: "mt-6 text-sm text-gray-400",
                    children: [
                        "The article you have just read is an advertisement and not an actual news article, blog, or consumer protection update. We are not affiliated with any news source. Our intention is to provide an online resource that brings consumers important information that may help them make informed decisions.We hope you find our online resource informative and helpful. The story told here is for demonstration purposes only and people's results may vary. All images used above to depict consumers are used for dramatization purposes only. This website and the company that owns it is not responsible for any typographical or photographic errors. Any information, discounts or price quotations listed may not be applicable in your location or if certain requirements are not met. If you do not agree to our terms and policies, then please leave this site immediately.",
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("br", {}),
                        advertorial && advertorial.sources.length > 0 && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    children: "Sources:"
                                }),
                                advertorial.sources.map((source)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                                            className: "text-xs",
                                            href: source.href,
                                            target: "_blank",
                                            children: source.label
                                        })
                                    }, source.href))
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $4caffb14b2edfdf5$export$2e2bcd8739ae039 = $4caffb14b2edfdf5$var$AdvertorialFooter;


const $50f5bacc8d23bf10$var$Advertorial = ()=>{
    const params = new URLSearchParams(window.location.search);
    const { slug: slug } = (0, $3fc8353d3146dc49$export$99eaa27ddbbb95ef)();
    const { loading: loading, error: error, data: data } = (0, $cb89595d8b20dae2$export$dd0a697e1782aedd)((0, $16d158a2d054cbe7$export$2e2bcd8739ae039)(slug));
    if (error) return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
        children: "Error :("
    });
    const advertorial = data === null || data === void 0 ? void 0 : data.advertorials.data[0].attributes;
    const primary_content = data === null || data === void 0 ? void 0 : data.advertorials.data[0].attributes.primary_content;
    const offers = data === null || data === void 0 ? void 0 : data.advertorials.data[0].attributes.offer;
    const [date, setDate] = (0, $eXaQ2.useState)("");
    (0, $eXaQ2.useEffect)(()=>{
        const threeDaysAgo = (0, (/*@__PURE__*/$parcel$interopDefault($cE4fx)))().subtract(3, "day").format("MMMM DD, YYYY");
        setDate(threeDaysAgo);
    }, []);
    const options_primary = {
        replace: ({ attribs: attribs, children: children })=>{
            if (!attribs) return;
            primary_content.forEach((content)=>{
                if (content.offer_url && attribs.href) {
                    attribs.href = attribs.href = `${content.offer_url}?${params.toString()}`;
                    attribs.class = "cta-link";
                    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                        ...attribs,
                        children: (0, $8addaec5ee3f7ec4$export$562c76a291853ae)(children, options_primary)
                    });
                }
            });
        }
    };
    const options_offer = {
        replace: ({ attribs: attribs, children: children })=>{
            if (!attribs) return;
            offers.forEach((offer)=>{
                if (offer.offer_url && attribs.href) {
                    attribs.href = `${offer.offer_url}?${params.toString()}`;
                    attribs.class = "cta-link";
                    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                        ...attribs,
                        children: (0, $8addaec5ee3f7ec4$export$562c76a291853ae)(children, options_offer)
                    });
                }
            });
        }
    };
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $a239df06d4f8aed5$export$2e2bcd8739ae039), {
        title: advertorial && advertorial.title ? advertorial.title + " | Penny Pincher News" : "Loading... | Penny Pincher News",
        children: loading ? /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4366a99288ef8d33$exports.default), {
                color: "#5850E0"
            })
        }) : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                    className: "mx-auto max-w-3xl px-2",
                    children: [
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "mt-2 text-xl font-bold md:mt-4 md:text-4xl",
                            children: advertorial.title
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                            className: "mx-auto mt-4 w-full rounded-lg",
                            src: advertorial.primary_image.data.attributes.formats.medium.url
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "mt-4 text-xs text-gray-500 md:text-sm"
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "mt-6 text-sm text-gray-500 md:text-base",
                            children: [
                                "Last Updated: ",
                                date
                            ]
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            className: "mt-4 w-36 border-b-[6px] border-gray-600"
                        }),
                        primary_content.map((content)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                children: [
                                    content.content && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "article-body prose max-w-none prose-p:text-lg prose-p:leading-8",
                                        children: (0, $8addaec5ee3f7ec4$export$2e2bcd8739ae039)(content.content, options_primary)
                                    }),
                                    content.text_above_buttons && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "mb-1 mt-4 text-center text-lg font-bold md:text-xl",
                                        children: content.text_above_buttons
                                    }),
                                    content.label && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: `md:grid-cols-${content.columns} mt-0 grid w-full gap-x-2`,
                                        children: content.label.split(",").map((item, index)=>{
                                            return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                                                className: `adv-btn adv-btn-${content.color}`,
                                                href: `${content.offer_url}?${params.toString()}`,
                                                target: "_blank",
                                                children: item.trim()
                                            }, index);
                                        })
                                    })
                                ]
                            }, content.id)),
                        offers.map((offer)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                children: [
                                    offer.headline && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "mt-10 border-t border-t-gray-400 pt-16 text-xl font-bold md:mt-16 md:text-4xl",
                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "leading-tight",
                                            children: offer.headline
                                        })
                                    }),
                                    offer.offer_image && offer.offer_image.data && offer.offer_image.data.attributes && offer.offer_image.data.attributes.url && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                        className: "mx-auto mt-4 w-full rounded-lg",
                                        src: offer.offer_image.data.attributes.url
                                    }),
                                    offer.content && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "article-body prose mb-8 max-w-none prose-p:text-lg prose-p:leading-8",
                                        children: (0, $8addaec5ee3f7ec4$export$2e2bcd8739ae039)(offer.content, options_offer)
                                    }),
                                    offer.text_above_buttons && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "mb-1 mt-4 text-center text-lg font-bold md:text-xl",
                                        children: offer.text_above_buttons
                                    }),
                                    offer.label && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: `md:grid-cols-${offer.columns} mt-0 grid w-full gap-x-2`,
                                        children: offer.label.split(",").map((item, index)=>{
                                            return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("a", {
                                                className: `adv-btn adv-btn-${offer.color}`,
                                                href: `${offer.offer_url}?${params.toString()}`,
                                                target: "_blank",
                                                children: item.trim()
                                            }, index);
                                        })
                                    })
                                ]
                            }, offer.id))
                    ]
                }),
                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4caffb14b2edfdf5$export$2e2bcd8739ae039), {
                    advertorial: advertorial
                })
            ]
        })
    });
};
var $50f5bacc8d23bf10$export$2e2bcd8739ae039 = $50f5bacc8d23bf10$var$Advertorial;




var $58e170286b44dc5b$exports = {};
$58e170286b44dc5b$exports = "google.com, pub-3472996490014614, DIRECT, f08c47fec0942fa0\n";







let $6a21fb354c68802c$var$_ = (t)=>t, $6a21fb354c68802c$var$t;
const $6a21fb354c68802c$var$GET_AUTHORS = (0, $fd0c0e1ba95e1f7a$export$72e4926bf8358653)($6a21fb354c68802c$var$t || ($6a21fb354c68802c$var$t = $6a21fb354c68802c$var$_`
  query {
    authors {
      data {
        id
        attributes {
          name
          role
          bio
          avatar {
            data {
              attributes {
                formats
              }
            }
          }
        }
      }
    }
  }
`));
var $6a21fb354c68802c$export$2e2bcd8739ae039 = $6a21fb354c68802c$var$GET_AUTHORS;



const $1a64c521689eb9a3$var$Aboutus = ()=>{
    const { loading: loading, error: error, data: data } = (0, $cb89595d8b20dae2$export$dd0a697e1782aedd)((0, $6a21fb354c68802c$export$2e2bcd8739ae039));
    const authors = data === null || data === void 0 ? void 0 : data.authors.data;
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $86a0a2c7143f17cc$export$2e2bcd8739ae039), {
                title: "About Us | Penny Pincher News",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                    className: "mx-auto mt-10 max-w-7xl px-4",
                    children: [
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h1", {
                                    className: "text-center text-xl font-bold tracking-tight text-gray-900 sm:text-4xl md:mt-20",
                                    children: "About Us"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                    className: "mx-auto mt-6 max-w-5xl border-l-4 border-gray-400 bg-gray-100 p-3 text-sm font-medium italic leading-6 md:mt-10 md:p-5 md:text-xl md:leading-8 md:leading-9",
                                    children: "“The greatness of a man is not in how much wealth he acquires, but in his integrity and his ability to affect those around him positively.” -Bob Marley"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                    className: "mt-6 text-base leading-8 md:mt-8 md:text-lg md:leading-9",
                                    children: "In a time when it can be truly daunting to find real data that is not overcomplicated or downright misleading, we make a steadfast commitment to delivering straightforward access to uncomplicated information."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                    className: "mt-4 text-base leading-8 md:text-lg md:leading-9",
                                    children: "The information you'll find on PennyPincher.com is produced by our expert research teams who delve deep into various areas to produce concise, easy- to-read, and prioritized articles aimed at empowering you with the knowledge needed to make informed decisions. These decisions can enrich your life from before your first employment through financial evolution and onto retirement."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h2", {
                                    className: "mt-10 text-xl font-medium md:text-2xl",
                                    children: "Our Content"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                    className: "mt-4 text-base leading-8 md:text-lg md:leading-9",
                                    children: "At PennyPincher.com, we thoroughly explore the too-good-to-be-true deals, top-rated review sources, studies, and research releases to discover expert and dependable foundations for information, technology, finance, and development. We strive to curate and present this information in a way that is easy to understand, while continuously expanding our knowledge base. Our knowledge base and article layout are specifically designed to help our readers constantly grow, even when learning in a hurry. Whether you're facing the challenges of burdensome debt or choosing a new auto insurance carrier, we work every day to provide dependable and accurate information that you can act on to get closer to realizing your personal goals and dreams."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                    className: "mt-4 text-base leading-8 md:text-lg md:leading-9",
                                    children: "Every member of our team is dedicated to studying the most up-to-the- minute and relevant information, trends, and technological innovations. This allow us to build a consumer experience that is truly helpful, thereby ensuring that you can rely on us to consistently deliver exceptional and trustworthy content."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h2", {
                                    className: "mt-10 text-xl font-medium md:text-2xl",
                                    children: "Contact Us"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("p", {
                                    className: "mt-4 text-base leading-8 md:text-lg md:leading-9",
                                    children: [
                                        "Do you have any questions or comments you would like to share? We are open to all constructive feedback that can help us learn to better assist/serve our readers. Please feel free to",
                                        " ",
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$a6c7ac8248d6e38a), {
                                            to: "/contact",
                                            className: "cursor-pointer text-indigo-600 hover:underline",
                                            children: "reach out"
                                        }),
                                        " ",
                                        "with any broad or specific topics you would like to see more of!"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "mx-auto max-w-2xl text-center",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h2", {
                                    className: "mt-10 text-xl font-bold tracking-tight text-gray-900 sm:text-4xl md:mt-20 md:text-3xl",
                                    children: "Meet our team"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                    className: "mt-2 text-base leading-7 text-gray-600 md:mt-6 md:text-lg md:leading-8",
                                    children: "We’re a dynamic group of individuals who are passionate about what we do and dedicated to delivering the best results for our readers."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("ul", {
                                role: "list",
                                className: "grid-cols-3 gap-6 md:grid",
                                children: authors ? authors.map((author)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("li", {
                                        className: "mt-10 md:flex",
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("img", {
                                                className: "h-16 w-16 rounded-full object-cover md:h-20 md:w-20",
                                                src: author.attributes.avatar.data.attributes.formats.small.url,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                                className: "mt-4 md:ml-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                                                        className: "font-medium",
                                                        children: author.attributes.name
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                                        className: "text-sm leading-7 text-gray-600",
                                                        children: author.attributes.role
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                                        className: "mt-2 text-base leading-7 text-gray-800",
                                                        children: author.attributes.bio
                                                    })
                                                ]
                                            })
                                        ]
                                    }, author.id)) : /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("li", {
                                    className: "mt-10 md:flex",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            role: "status",
                                            className: "h-16 w-16 animate-pulse rounded-full bg-gray-200 md:h-20 md:w-20"
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "mt-4 md:ml-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Loading..."
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h3", {
                                                    className: "h-6 w-36 animate-pulse bg-gray-200"
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                                    className: "mt-2 h-4 w-24 animate-pulse bg-gray-100"
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                                    className: "mt-2 h-4 w-72 animate-pulse bg-gray-200"
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                                    className: "mt-2 h-4 w-72 animate-pulse bg-gray-200"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $230c037f02067870$export$2e2bcd8739ae039), {})
        ]
    });
};
var $1a64c521689eb9a3$export$2e2bcd8739ae039 = $1a64c521689eb9a3$var$Aboutus;




const $4f62174927065e73$var$DoNotSell = ()=>{
    window.scrollTo(0, 0);
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $86a0a2c7143f17cc$export$2e2bcd8739ae039), {
        title: "Do Not Sell | Penny Pincher News",
        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
            className: "container mx-auto px-8",
            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "prose mx-auto max-w-7xl",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("h1", {
                        children: "California Privacy Rights"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: "The California Consumer Privacy Act (CCPA) gives California residents certain rights regarding personal information given to businesses. One of the rights granted is to direct a business to stop selling your personal information. Along with the information contained in our privacy policy, we want to provide you a means to specifically state your preferences with regard to the selling of your information. To submit a request that your data not be sold, please fill out the form on this page."
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("form", {
                            action: "#",
                            method: "POST",
                            className: "px-6 pt-10",
                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                className: "mx-auto max-w-xl border border-gray-300 p-10 lg:max-w-lg",
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2",
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("label", {
                                                        htmlFor: "first-name",
                                                        className: "block text-sm font-semibold leading-6 text-gray-900",
                                                        children: "First name"
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "mt-2.5",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("input", {
                                                            type: "text",
                                                            name: "first-name",
                                                            id: "first-name",
                                                            autoComplete: "given-name",
                                                            className: "block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 ring-inset ring-gray-300 shadow-sm ring-1 placeholder:text-gray-400 focus:ring-inset focus:ring-indigo-600 focus:ring-2 sm:text-sm sm:leading-6"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("label", {
                                                        htmlFor: "last-name",
                                                        className: "block text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Last name"
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "mt-2.5",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("input", {
                                                            type: "text",
                                                            name: "last-name",
                                                            id: "last-name",
                                                            autoComplete: "family-name",
                                                            className: "block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 ring-inset ring-gray-300 shadow-sm ring-1 placeholder:text-gray-400 focus:ring-inset focus:ring-indigo-600 focus:ring-2 sm:text-sm sm:leading-6"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                                className: "sm:col-span-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("label", {
                                                        htmlFor: "email",
                                                        className: "block text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "mt-2.5",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("input", {
                                                            type: "email",
                                                            name: "email",
                                                            id: "email",
                                                            autoComplete: "email",
                                                            className: "block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 ring-inset ring-gray-300 shadow-sm ring-1 placeholder:text-gray-400 focus:ring-inset focus:ring-indigo-600 focus:ring-2 sm:text-sm sm:leading-6"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                                className: "sm:col-span-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("label", {
                                                        htmlFor: "phone-number",
                                                        className: "block text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Phone number"
                                                    }),
                                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "mt-2.5",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("input", {
                                                            type: "tel",
                                                            name: "phone-number",
                                                            id: "phone-number",
                                                            autoComplete: "tel",
                                                            className: "block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 ring-inset ring-gray-300 shadow-sm ring-1 placeholder:text-gray-400 focus:ring-inset focus:ring-indigo-600 focus:ring-2 sm:text-sm sm:leading-6"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                        className: "mt-8 flex justify-end",
                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("button", {
                                            type: "submit",
                                            className: "rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                            children: "Submit"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $4f62174927065e73$export$2e2bcd8739ae039 = $4f62174927065e73$var$DoNotSell;




var $eXaQ2 = parcelRequire("eXaQ2");

var $51e650b76d34b0b0$exports = {};

$parcel$export($51e650b76d34b0b0$exports, "extract", function () { return $51e650b76d34b0b0$export$f9380c9a627682d3; });
$parcel$export($51e650b76d34b0b0$exports, "parse", function () { return $51e650b76d34b0b0$export$98e6a39c04603d36; });
$parcel$export($51e650b76d34b0b0$exports, "stringify", function () { return $51e650b76d34b0b0$export$fac44ee5b035f737; });
$parcel$export($51e650b76d34b0b0$exports, "parseUrl", function () { return $51e650b76d34b0b0$export$7a5253c0f62e0150; });
$parcel$export($51e650b76d34b0b0$exports, "stringifyUrl", function () { return $51e650b76d34b0b0$export$a8c1621ea79325d3; });
$parcel$export($51e650b76d34b0b0$exports, "pick", function () { return $51e650b76d34b0b0$export$357523c63a2253b9; });
$parcel$export($51e650b76d34b0b0$exports, "exclude", function () { return $51e650b76d34b0b0$export$44c361b8ec72ef7f; });
const $92eb8313f4406699$var$token = "%[a-f0-9]{2}";
const $92eb8313f4406699$var$singleMatcher = new RegExp("(" + $92eb8313f4406699$var$token + ")|([^%]+?)", "gi");
const $92eb8313f4406699$var$multiMatcher = new RegExp("(" + $92eb8313f4406699$var$token + ")+", "gi");
function $92eb8313f4406699$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $92eb8313f4406699$var$decodeComponents(left), $92eb8313f4406699$var$decodeComponents(right));
}
function $92eb8313f4406699$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($92eb8313f4406699$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $92eb8313f4406699$var$decodeComponents(tokens, i).join("");
            tokens = input.match($92eb8313f4406699$var$singleMatcher) || [];
        }
        return input;
    }
}
function $92eb8313f4406699$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    let match = $92eb8313f4406699$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $92eb8313f4406699$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $92eb8313f4406699$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function $92eb8313f4406699$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $92eb8313f4406699$var$customDecodeURIComponent(encodedURI);
    }
}


function $c84afcf98cefe184$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}


function $6202a1195b077ddd$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor === null || descriptor === void 0 ? void 0 : descriptor.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $6202a1195b077ddd$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $6202a1195b077ddd$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $6202a1195b077ddd$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}


const $51e650b76d34b0b0$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $51e650b76d34b0b0$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $51e650b76d34b0b0$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $51e650b76d34b0b0$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $51e650b76d34b0b0$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $51e650b76d34b0b0$var$encode(key, options),
                            "[",
                            $51e650b76d34b0b0$var$encode(index, options),
                            "]=",
                            $51e650b76d34b0b0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $51e650b76d34b0b0$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $51e650b76d34b0b0$var$encode(key, options),
                            "[]=",
                            $51e650b76d34b0b0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $51e650b76d34b0b0$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $51e650b76d34b0b0$var$encode(key, options),
                            ":list=",
                            $51e650b76d34b0b0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $51e650b76d34b0b0$var$encode(key, options),
                                keyValueSep,
                                $51e650b76d34b0b0$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $51e650b76d34b0b0$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $51e650b76d34b0b0$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $51e650b76d34b0b0$var$encode(key, options),
                            "=",
                            $51e650b76d34b0b0$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $51e650b76d34b0b0$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $51e650b76d34b0b0$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $51e650b76d34b0b0$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$51e650b76d34b0b0$var$decode(item, options)) : value === null ? value : $51e650b76d34b0b0$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $51e650b76d34b0b0$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$51e650b76d34b0b0$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $51e650b76d34b0b0$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $51e650b76d34b0b0$var$encode(value, options) {
    if (options.encode) return options.strict ? $51e650b76d34b0b0$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $51e650b76d34b0b0$var$decode(value, options) {
    if (options.decode) return (0, $92eb8313f4406699$export$2e2bcd8739ae039)(value);
    return value;
}
function $51e650b76d34b0b0$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $51e650b76d34b0b0$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $51e650b76d34b0b0$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $51e650b76d34b0b0$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $51e650b76d34b0b0$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $51e650b76d34b0b0$export$f9380c9a627682d3(input) {
    input = $51e650b76d34b0b0$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $51e650b76d34b0b0$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $51e650b76d34b0b0$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $51e650b76d34b0b0$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, $c84afcf98cefe184$export$2e2bcd8739ae039)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $51e650b76d34b0b0$var$decode(value, options);
        formatter($51e650b76d34b0b0$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $51e650b76d34b0b0$var$parseValue(value2, options);
        else returnValue[key] = $51e650b76d34b0b0$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $51e650b76d34b0b0$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
function $51e650b76d34b0b0$export$fac44ee5b035f737(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    $51e650b76d34b0b0$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $51e650b76d34b0b0$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $51e650b76d34b0b0$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $51e650b76d34b0b0$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $51e650b76d34b0b0$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $51e650b76d34b0b0$var$encode(key, options) + "=" + $51e650b76d34b0b0$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function $51e650b76d34b0b0$export$7a5253c0f62e0150(url, options) {
    var _url__split;
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $c84afcf98cefe184$export$2e2bcd8739ae039)(url, "#");
    if (url_ === undefined) url_ = url;
    var _url__split_;
    return {
        url: (_url__split_ = (_url__split = url_ === null || url_ === void 0 ? void 0 : url_.split("?")) === null || _url__split === void 0 ? void 0 : _url__split[0]) !== null && _url__split_ !== void 0 ? _url__split_ : "",
        query: $51e650b76d34b0b0$export$98e6a39c04603d36($51e650b76d34b0b0$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $51e650b76d34b0b0$var$decode(hash, options)
        } : {}
    };
}
function $51e650b76d34b0b0$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$51e650b76d34b0b0$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $51e650b76d34b0b0$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $51e650b76d34b0b0$export$f9380c9a627682d3(object.url);
    const query = {
        ...$51e650b76d34b0b0$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $51e650b76d34b0b0$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $51e650b76d34b0b0$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$51e650b76d34b0b0$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $51e650b76d34b0b0$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$51e650b76d34b0b0$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $51e650b76d34b0b0$export$7a5253c0f62e0150(input, options);
    return $51e650b76d34b0b0$export$a8c1621ea79325d3({
        url: url,
        query: (0, $6202a1195b077ddd$export$ff05df6c2df24b52)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $51e650b76d34b0b0$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $51e650b76d34b0b0$export$357523c63a2253b9(input, exclusionFilter, options);
}


var $349305d40edd5bd7$export$2e2bcd8739ae039 = $51e650b76d34b0b0$exports;




function $b9c9a2b1d96044a6$var$CompareRates() {
    const [lead, setLead] = (0, $eXaQ2.useState)({});
    const [links, setLinks] = (0, $eXaQ2.useState)([]);
    const queryParams = (0, $349305d40edd5bd7$export$2e2bcd8739ae039).parse(window.location.search);
    const [loading, setLoading] = (0, $eXaQ2.useState)(true);
    const [isReadMoreClicked, setIsReadMoreClicked] = (0, $eXaQ2.useState)(false);
    const handleReadMoreClick = ()=>{
        setIsReadMoreClicked(true);
    };
    (0, $eXaQ2.useEffect)(()=>{
        if (queryParams.ctk) (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).get(`https://medigap-reader.telephone.workers.dev/${queryParams.ctk}`).then((result)=>{
            const updatedLead = {
                ...result.data,
                zipcode: result.data.zip
            };
            setLead(updatedLead);
        }).catch((error)=>console.log(error));
        else getCurrentzipCode();
    }, [
        queryParams.ctk
    ]);
    async function getCurrentzipCode() {
        try {
            const ipAddress = await (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).get("https://api.ipify.org");
            const result = await (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).get(`https://api.ipstack.com/${ipAddress.data}?access_key=933580893fcbddecf879a4047c5d4293`);
            if (result.data.zip) {
                const updatedLead = {
                    ...lead,
                    zipCode: result.data.zip,
                    city: result.data.city,
                    state: result.data.region_name
                };
                setLead(updatedLead);
            }
        } catch (error) {
            console.log(error);
        }
    }
    (0, $eXaQ2.useEffect)(()=>{
        if (lead.city || lead.state) getData();
    }, [
        lead
    ]);
    async function getData() {
        let leadData = {
            lead: lead,
            publisherToken: queryParams["pub_token"] || "",
            publisherClickId: queryParams["pub_click_id"] || "",
            source: queryParams["source"] || queryParams["utm_source"],
            adInfo: {
                ad_placement_id: queryParams["ad_placement_id"],
                ad_placement_name: queryParams["ad_placement_name"],
                ad_site_name: queryParams["ad_site_name"],
                ad_site_id: queryParams["ad_site_id"],
                ad_campaign_id: queryParams["cid"],
                ad_group_id: queryParams["cid"],
                ad_id: queryParams["aid"],
                utm_source: queryParams["source"],
                utm_medium: queryParams["utm_medium"],
                ad_click_id: queryParams["ad_click_id"],
                voluum_click_id: queryParams["clickid"]
            },
            tracking: {
                t1: queryParams["t1"],
                t2: queryParams["t2"],
                t3: queryParams["t3"],
                t4: queryParams["t4"],
                t5: queryParams["t5"]
            },
            token: "0ce30349-d383-4e9d-8185-b3cf288b889f",
            maxResults: 4,
            landingUrl: lead.lpurl,
            submissionUrl: "https://" + document.domain,
            userAgent: navigator.userAgent
        };
        try {
            const result = await (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).post("https://penguin.oapi.me/api/click/get-links", leadData, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            setLinks(result.data.data);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $a239df06d4f8aed5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "mx-auto max-w-3xl px-2",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        className: "text-xl font-bold md:text-3xl",
                        children: [
                            "Drivers ",
                            lead.state ? "in " + lead.state : "",
                            " Are Swapping Their Insurance Company & Doing This Instead"
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        className: "text-lg",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                className: "mt-4 font-bold text-red-700 md:mt-6",
                                children: "Do not pay your next auto insurance bill until you try this…"
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                className: "mt-4",
                                children: "There is a brand-new online system that most drivers don’t know about, and it was created to significantly reduce how much you pay for auto insurance. Here’s what we know so far. If you:"
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("ol", {
                                className: "ml-4 mt-4 list-disc",
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "Are currently insured"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "Live in eligible zip code"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "Drive less than 50 miles per day"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "result",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "mb-2 text-sm text-gray-800",
                                    children: "Sponsored listings"
                                }),
                                loading ? /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "flex items-center rounded-md bg-primary-600 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "h-5 w-2/3 animate-pulse bg-gray-100 opacity-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "1em",
                                                        viewBox: "0 0 512 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "mt-3 flex items-center rounded-md bg-primary-600 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "h-5 w-2/4 animate-pulse bg-gray-100 opacity-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "1em",
                                                        viewBox: "0 0 512 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "mt-3 flex items-center rounded-md bg-primary-600 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "h-5 w-1/3 animate-pulse bg-gray-100 opacity-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "1em",
                                                        viewBox: "0 0 512 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "mt-3 flex items-center rounded-md bg-primary-600 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "h-5 w-4/5 animate-pulse bg-gray-100 opacity-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "1em",
                                                        viewBox: "0 0 512 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : links.map((item, index)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("a", {
                                        className: `flex items-center rounded-md bg-primary-600 p-4 ${index === 0 ? "" : "mt-3"} cursor-pointer hover:bg-primary-700`,
                                        href: item.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>{
                                        // Handle cpc_click event
                                        // dataLayer.push({ event: 'cpc_click' });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                className: "grow-0",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 320 512",
                                                    className: "h-8 fill-white",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                children: item.headline
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                className: "grow-0",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "h-8 fill-white",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                    })
                                                })
                                            })
                                        ]
                                    }, index)),
                                !isReadMoreClicked && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "readmore mt-10 cursor-pointer text-center font-medium text-primary-600",
                                    onClick: handleReadMoreClick,
                                    children: "Read More..."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    className: `extracontent mt-10 text-lg leading-7 ${isReadMoreClicked ? "" : "hidden"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Maintain a Clean Driving Record"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "A history of accidents, traffic violations, and reckless driving can significantly increase your insurance premiums. By driving safely, obeying traffic rules, and avoiding accidents, you can demonstrate to insurance companies that you are a low-risk driver, leading to reduced rates. Periodically check your driving record to ensure all information is accurate and contest any discrepancies if necessary."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Shop Around and Compare Quotes"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Different insurance companies offer different rates based on their own criteria and risk assessments. By shopping around and getting quotes from multiple insurers, you can compare and choose the most affordable option. Remember to compare similar policies in terms of coverage, deductibles, and limits to get a true sense of which offers the best value."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Bundle Insurance Policies"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Many insurance companies offer discounts when you bundle multiple policies, such as auto and home insurance, with the same provider. This not only streamlines your billing and policy management but also can lead to significant savings. If you have multiple types of insurance needs, inquire about bundling options and discounts."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Increase Your Deductible"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Your deductible is the amount you pay out of pocket before your insurance coverage kicks in. By agreeing to a higher deductible, you reduce the insurer's risk, which often results in a lower premium. However, ensure that you're comfortable with and capable of paying the higher deductible in the event of a claim."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Take Advantage of Discounts"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Many insurance companies offer various discounts to drivers for factors like low mileage, good student achievements, completion of a defensive driving course, having safety features in the car, or being a member of certain associations or professions. Always inquire about potential discounts and ensure that you're getting all the reductions you qualify for."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4caffb14b2edfdf5$export$2e2bcd8739ae039), {})
        ]
    });
}
var $b9c9a2b1d96044a6$export$2e2bcd8739ae039 = $b9c9a2b1d96044a6$var$CompareRates;




var $eXaQ2 = parcelRequire("eXaQ2");




function $e303a168cc500e69$var$CompareRates2() {
    const [lead, setLead] = (0, $eXaQ2.useState)({});
    const [links, setLinks] = (0, $eXaQ2.useState)([]);
    const queryParams = (0, $349305d40edd5bd7$export$2e2bcd8739ae039).parse(window.location.search);
    const [loading, setLoading] = (0, $eXaQ2.useState)(true);
    const [isReadMoreClicked, setIsReadMoreClicked] = (0, $eXaQ2.useState)(false);
    const handleReadMoreClick = ()=>{
        setIsReadMoreClicked(true);
    };
    (0, $eXaQ2.useEffect)(()=>{
        if (queryParams.ctk) (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).get(`https://medigap-reader.telephone.workers.dev/${queryParams.ctk}`).then((result)=>{
            const updatedLead = {
                ...result.data,
                zipcode: result.data.zip
            };
            setLead(updatedLead);
        }).catch((error)=>console.log(error));
        else getCurrentzipCode();
    }, [
        queryParams.ctk
    ]);
    async function getCurrentzipCode() {
        try {
            const ipAddress = await (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).get("https://api.ipify.org");
            const result = await (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).get(`https://api.ipstack.com/${ipAddress.data}?access_key=933580893fcbddecf879a4047c5d4293`);
            if (result.data.zip) {
                const updatedLead = {
                    ...lead,
                    zipCode: result.data.zip,
                    city: result.data.city,
                    state: result.data.region_name
                };
                setLead(updatedLead);
            }
        } catch (error) {
            console.log(error);
        }
    }
    (0, $eXaQ2.useEffect)(()=>{
        if (lead.city || lead.state) getData();
    }, [
        lead
    ]);
    async function getData() {
        let leadData = {
            lead: lead,
            publisherToken: queryParams["pub_token"] || "",
            publisherClickId: queryParams["pub_click_id"] || "",
            source: queryParams["source"] || queryParams["utm_source"],
            adInfo: {
                ad_placement_id: queryParams["ad_placement_id"],
                ad_placement_name: queryParams["ad_placement_name"],
                ad_site_name: queryParams["ad_site_name"],
                ad_site_id: queryParams["ad_site_id"],
                ad_campaign_id: queryParams["cid"],
                ad_group_id: queryParams["cid"],
                ad_id: queryParams["aid"],
                utm_source: queryParams["source"],
                utm_medium: queryParams["utm_medium"],
                ad_click_id: queryParams["ad_click_id"],
                voluum_click_id: queryParams["clickid"]
            },
            tracking: {
                t1: queryParams["t1"],
                t2: queryParams["t2"],
                t3: queryParams["t3"],
                t4: queryParams["t4"],
                t5: queryParams["t5"]
            },
            token: "0ce30349-d383-4e9d-8185-b3cf288b889f",
            maxResults: 4,
            landingUrl: lead.lpurl,
            submissionUrl: "https://" + document.domain,
            userAgent: navigator.userAgent
        };
        try {
            const result = await (0, $c5f0b6e54481011a$export$2e2bcd8739ae039).post("https://penguin.oapi.me/api/click/get-links", leadData, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            setLinks(result.data.data);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $a239df06d4f8aed5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "mx-auto max-w-3xl px-2",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        className: "text-xl font-bold md:text-3xl",
                        children: [
                            "Drivers ",
                            lead.state ? "in " + lead.state : "",
                            " Are Swapping Their Insurance Company & Doing This Instead"
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        className: "text-lg",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                className: "mt-4 font-bold text-red-700 md:mt-6",
                                children: "Do not pay your next auto insurance bill until you try this…"
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                className: "mt-4",
                                children: "There is 1 simple truth your car insurance company doesn't want you to know. If you are currently insured, drive less than 50 miles/day, and live in a qualified zip code. The problem is that insurance agents are paid on commission and want to sell you the highest possible rate to increase their paycheck."
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                className: "mt-4",
                                children: "As an authority on everything insurance, we decided to put these services to the test and after entering our zip code and driver information we were shocked at the results we found.."
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("p", {
                                className: "mt-4",
                                children: [
                                    "So, what is this ",
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("strong", {
                                        children: '"New Rule"'
                                    }),
                                    "? NEVER buy insurance without comparing rates and discounts from an unbiased source first."
                                ]
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                className: "mt-4 block bg-amber-100 p-4 opacity-80",
                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("p", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("strong", {
                                            children: "Note:"
                                        }),
                                        " You are ",
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("strong", {
                                            children: "NEVER LOCKED"
                                        }),
                                        " into your current policy. If you've already paid your bill in full, you can very easily cancel, and be refunded your balance."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                className: "mt-4",
                                children: "Once you enter your zip code and go through a few questions, you will have the opportunity to compare the best carrier quotes in your area for an average savings of up to 32% a month."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "result",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "mb-2 text-sm text-gray-800",
                                    children: "Sponsored listings"
                                }),
                                loading ? /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "flex items-center rounded-md bg-primary-600 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "h-5 w-2/3 animate-pulse bg-gray-100 opacity-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "1em",
                                                        viewBox: "0 0 512 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "mt-3 flex items-center rounded-md bg-primary-600 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "h-5 w-2/4 animate-pulse bg-gray-100 opacity-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "1em",
                                                        viewBox: "0 0 512 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "mt-3 flex items-center rounded-md bg-primary-600 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "h-5 w-1/3 animate-pulse bg-gray-100 opacity-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "1em",
                                                        viewBox: "0 0 512 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                            className: "mt-3 flex items-center rounded-md bg-primary-600 p-4",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                        className: "h-5 w-4/5 animate-pulse bg-gray-100 opacity-30"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                    className: "grow-0",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "1em",
                                                        viewBox: "0 0 512 512",
                                                        className: "h-8 fill-white",
                                                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : links.map((item, index)=>/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("a", {
                                        className: `flex items-center rounded-md bg-primary-600 p-4 ${index === 0 ? "" : "mt-3"} cursor-pointer hover:bg-primary-700`,
                                        href: item.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>{
                                        // Handle cpc_click event
                                        // dataLayer.push({ event: 'cpc_click' });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                className: "grow-0",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 320 512",
                                                    className: "h-8 fill-white",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                                children: item.headline
                                            }),
                                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                                className: "grow-0",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "h-8 fill-white",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                    })
                                                })
                                            })
                                        ]
                                    }, index)),
                                !isReadMoreClicked && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "readmore mt-10 cursor-pointer text-center font-medium text-primary-600",
                                    onClick: handleReadMoreClick,
                                    children: "Read More..."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    className: `extracontent mt-10 text-lg leading-7 ${isReadMoreClicked ? "" : "hidden"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Maintain a Clean Driving Record"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "A history of accidents, traffic violations, and reckless driving can significantly increase your insurance premiums. By driving safely, obeying traffic rules, and avoiding accidents, you can demonstrate to insurance companies that you are a low-risk driver, leading to reduced rates. Periodically check your driving record to ensure all information is accurate and contest any discrepancies if necessary."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Shop Around and Compare Quotes"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Different insurance companies offer different rates based on their own criteria and risk assessments. By shopping around and getting quotes from multiple insurers, you can compare and choose the most affordable option. Remember to compare similar policies in terms of coverage, deductibles, and limits to get a true sense of which offers the best value."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Bundle Insurance Policies"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Many insurance companies offer discounts when you bundle multiple policies, such as auto and home insurance, with the same provider. This not only streamlines your billing and policy management but also can lead to significant savings. If you have multiple types of insurance needs, inquire about bundling options and discounts."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Increase Your Deductible"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Your deductible is the amount you pay out of pocket before your insurance coverage kicks in. By agreeing to a higher deductible, you reduce the insurer's risk, which often results in a lower premium. However, ensure that you're comfortable with and capable of paying the higher deductible in the event of a claim."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Take Advantage of Discounts"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Many insurance companies offer various discounts to drivers for factors like low mileage, good student achievements, completion of a defensive driving course, having safety features in the car, or being a member of certain associations or professions. Always inquire about potential discounts and ensure that you're getting all the reductions you qualify for."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4caffb14b2edfdf5$export$2e2bcd8739ae039), {})
        ]
    });
}
var $e303a168cc500e69$export$2e2bcd8739ae039 = $e303a168cc500e69$var$CompareRates2;




var $eXaQ2 = parcelRequire("eXaQ2");


function $27876a46f320101a$var$CompareRatesDemo() {
    const [isReadMoreClicked, setIsReadMoreClicked] = (0, $eXaQ2.useState)(false);
    const handleReadMoreClick = ()=>{
        setIsReadMoreClicked(true);
    };
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $a239df06d4f8aed5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                className: "mx-auto max-w-3xl px-2",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "text-xl font-bold md:text-3xl",
                        children: "Drivers Are Swapping Their Insurance Company & Doing This Instead"
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                        className: "text-lg",
                        children: [
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                className: "mt-4 font-bold text-red-700 md:mt-6",
                                children: "Do not pay your next auto insurance bill until you try this…"
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                className: "mt-4",
                                children: "There is a brand-new online system that most drivers don’t know about, and it was created to significantly reduce how much you pay for auto insurance. Here’s what we know so far. If you:"
                            }),
                            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("ol", {
                                className: "ml-4 mt-4 list-disc",
                                children: [
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "Are currently insured"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "Live in eligible zip code"
                                    }),
                                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("li", {
                                        children: "Drive less than 50 miles per day"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                            className: "result",
                            children: [
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "mb-2 text-sm text-gray-800",
                                    children: "Sponsored listings"
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("a", {
                                    className: `mt-3 flex cursor-pointer items-center rounded-md bg-primary-600
                 p-4 hover:bg-primary-700`,
                                    href: "https://google.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "grow-0",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 320 512",
                                                className: "h-8 fill-white",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                            children: "Affordable Auto Insurance Plans"
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "grow-0",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "1em",
                                                viewBox: "0 0 512 512",
                                                className: "h-8 fill-white",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("a", {
                                    className: `mt-3 flex cursor-pointer items-center rounded-md bg-primary-600
                 p-4 hover:bg-primary-700`,
                                    href: "https://google.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "grow-0",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 320 512",
                                                className: "h-8 fill-white",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                            children: "Get Cheap Auto Insurance Rates in TX!"
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "grow-0",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "1em",
                                                viewBox: "0 0 512 512",
                                                className: "h-8 fill-white",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("a", {
                                    className: `mt-3 flex cursor-pointer items-center rounded-md bg-primary-600
                 p-4 hover:bg-primary-700`,
                                    href: "https://google.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "grow-0",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 320 512",
                                                className: "h-8 fill-white",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                            children: "Auto Insurance As Low As $19/Mo in Texas"
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "grow-0",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "1em",
                                                viewBox: "0 0 512 512",
                                                className: "h-8 fill-white",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("a", {
                                    className: `mt-3 flex cursor-pointer items-center rounded-md bg-primary-600
                 p-4 hover:bg-primary-700`,
                                    href: "https://google.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "grow-0",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 320 512",
                                                className: "h-8 fill-white",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "mx-2 grow align-middle text-lg font-bold leading-7 text-white md:text-xl",
                                            children: "Smart Financial Auto Insurance Comparison"
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                            className: "grow-0",
                                            children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "1em",
                                                viewBox: "0 0 512 512",
                                                className: "h-8 fill-white",
                                                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                    d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                !isReadMoreClicked && /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("div", {
                                    className: "readmore mt-10 cursor-pointer text-center font-medium text-primary-600",
                                    onClick: handleReadMoreClick,
                                    children: "Read More..."
                                }),
                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("div", {
                                    className: `extracontent mt-10 text-lg leading-7 ${isReadMoreClicked ? "" : "hidden"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Maintain a Clean Driving Record"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "A history of accidents, traffic violations, and reckless driving can significantly increase your insurance premiums. By driving safely, obeying traffic rules, and avoiding accidents, you can demonstrate to insurance companies that you are a low-risk driver, leading to reduced rates. Periodically check your driving record to ensure all information is accurate and contest any discrepancies if necessary."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Shop Around and Compare Quotes"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Different insurance companies offer different rates based on their own criteria and risk assessments. By shopping around and getting quotes from multiple insurers, you can compare and choose the most affordable option. Remember to compare similar policies in terms of coverage, deductibles, and limits to get a true sense of which offers the best value."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Bundle Insurance Policies"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Many insurance companies offer discounts when you bundle multiple policies, such as auto and home insurance, with the same provider. This not only streamlines your billing and policy management but also can lead to significant savings. If you have multiple types of insurance needs, inquire about bundling options and discounts."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Increase Your Deductible"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Your deductible is the amount you pay out of pocket before your insurance coverage kicks in. By agreeing to a higher deductible, you reduce the insurer's risk, which often results in a lower premium. However, ensure that you're comfortable with and capable of paying the higher deductible in the event of a claim."
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)("h2", {
                                            className: "mb-2 mt-6 text-xl font-bold text-gray-800",
                                            children: [
                                                /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    height: "1em",
                                                    viewBox: "0 0 512 512",
                                                    className: "-mt-1 mr-2 inline fill-primary-600",
                                                    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("path", {
                                                        d: "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                                                    })
                                                }),
                                                "Take Advantage of Discounts"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                                            children: "Many insurance companies offer various discounts to drivers for factors like low mileage, good student achievements, completion of a defensive driving course, having safety features in the car, or being a member of certain associations or professions. Always inquire about potential discounts and ensure that you're getting all the reductions you qualify for."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4caffb14b2edfdf5$export$2e2bcd8739ae039), {})
        ]
    });
}
var $27876a46f320101a$export$2e2bcd8739ae039 = $27876a46f320101a$var$CompareRatesDemo;


const $e86f0d3ceec5fd72$var$AppRoutes = ()=>{
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $3fc8353d3146dc49$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $f31944e06b8d605e$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "contact",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $368ec9ce40b8ecb8$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "about-us",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $1a64c521689eb9a3$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "privacy",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $ef4b361f45089d9f$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "terms",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $9e55c085e1f96dfd$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "do-not-sell",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $4f62174927065e73$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "adv",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                    path: ":slug",
                    element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $50f5bacc8d23bf10$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "ads.txt",
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)("p", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($58e170286b44dc5b$exports)))
                    })
                })
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: ":category",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                        index: true,
                        element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $d7d775de2cef8dcb$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                        path: ":slug",
                        element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $8a4d8776ca5ad60e$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                path: "auto-insurance",
                children: [
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                        path: "compare-rates",
                        element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $b9c9a2b1d96044a6$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                        path: "compare-rates-2",
                        element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $e303a168cc500e69$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $3fc8353d3146dc49$export$e7b0ac011bb776c6), {
                        path: "compare-rates-demo",
                        element: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $27876a46f320101a$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $e86f0d3ceec5fd72$export$2e2bcd8739ae039 = $e86f0d3ceec5fd72$var$AppRoutes;


const $a61576c739e8aa08$var$tagManagerArgs = {
    gtmId: "GTM-MZXGFBG"
};
(0, (/*@__PURE__*/$parcel$interopDefault($fb481f68a427bf09$exports))).initialize($a61576c739e8aa08$var$tagManagerArgs);
function $a61576c739e8aa08$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsxs)((0, $b202b70e175d000e$export$c16b04c8a9956446), {
        client: (0, $e9e8aa5eaa0eee51$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $6365d8eb34426354$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $e86f0d3ceec5fd72$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $87ae4e00b7a962b0$exports.Toaster), {
                position: "top-right",
                reverseOrder: false
            })
        ]
    });
}


var $c24d9e5391c18db7$exports = {};
$parcel$export($c24d9e5391c18db7$exports, "applyMiddleware", function () { return $b66db12d315506ff$export$9ff26e0402cc7b7; }, function (v) { return $b66db12d315506ff$export$9ff26e0402cc7b7 = v; });
$parcel$export($c24d9e5391c18db7$exports, "combineReducers", function () { return $b66db12d315506ff$export$66e4520cdb265d18; }, function (v) { return $b66db12d315506ff$export$66e4520cdb265d18 = v; });
$parcel$export($c24d9e5391c18db7$exports, "compose", function () { return $b66db12d315506ff$export$f672e0b6f7222cd7; }, function (v) { return $b66db12d315506ff$export$f672e0b6f7222cd7 = v; });
$parcel$export($c24d9e5391c18db7$exports, "createStore", function () { return $b66db12d315506ff$export$f51a9068ac82ea43; }, function (v) { return $b66db12d315506ff$export$f51a9068ac82ea43 = v; });

$parcel$export($c24d9e5391c18db7$exports, "configureStore", function () { return $c24d9e5391c18db7$export$7d8a5b498da695ac; });
$parcel$export($c24d9e5391c18db7$exports, "createSlice", function () { return $c24d9e5391c18db7$export$4d8d9bd83c24ae8b; });
function $fb4adf1641919f0d$var$n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function $fb4adf1641919f0d$export$541ac630993a4c84(n) {
    return !!n && !!n[$fb4adf1641919f0d$var$Q];
}
function $fb4adf1641919f0d$export$16e3aed3edb85946(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === $fb4adf1641919f0d$var$Z;
    }(n) || Array.isArray(n) || !!n[$fb4adf1641919f0d$export$6ee2082928bcb0ee] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[$fb4adf1641919f0d$export$6ee2082928bcb0ee]) || $fb4adf1641919f0d$var$s(n) || $fb4adf1641919f0d$var$v(n));
}
function $fb4adf1641919f0d$export$22e8af3f75a010e3(t) {
    return $fb4adf1641919f0d$export$541ac630993a4c84(t) || $fb4adf1641919f0d$var$n(23, t), t[$fb4adf1641919f0d$var$Q].t;
}
function $fb4adf1641919f0d$var$i(n, r, t) {
    void 0 === t && (t = !1), 0 === $fb4adf1641919f0d$var$o(n) ? (t ? Object.keys : $fb4adf1641919f0d$var$nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function $fb4adf1641919f0d$var$o(n) {
    var r = n[$fb4adf1641919f0d$var$Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : $fb4adf1641919f0d$var$s(n) ? 2 : $fb4adf1641919f0d$var$v(n) ? 3 : 0;
}
function $fb4adf1641919f0d$var$u(n, r) {
    return 2 === $fb4adf1641919f0d$var$o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function $fb4adf1641919f0d$var$a(n, r) {
    return 2 === $fb4adf1641919f0d$var$o(n) ? n.get(r) : n[r];
}
function $fb4adf1641919f0d$var$f(n, r, t) {
    var e = $fb4adf1641919f0d$var$o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function $fb4adf1641919f0d$var$c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function $fb4adf1641919f0d$var$s(n) {
    return $fb4adf1641919f0d$var$X && n instanceof Map;
}
function $fb4adf1641919f0d$var$v(n) {
    return $fb4adf1641919f0d$var$q && n instanceof Set;
}
function $fb4adf1641919f0d$var$p(n) {
    return n.o || n.t;
}
function $fb4adf1641919f0d$var$l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = $fb4adf1641919f0d$var$rn(n);
    delete r[$fb4adf1641919f0d$var$Q];
    for(var t = $fb4adf1641919f0d$var$nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function $fb4adf1641919f0d$export$792f3d81ea979f55(n, e) {
    return void 0 === e && (e = !1), $fb4adf1641919f0d$var$y(n) || $fb4adf1641919f0d$export$541ac630993a4c84(n) || !$fb4adf1641919f0d$export$16e3aed3edb85946(n) || ($fb4adf1641919f0d$var$o(n) > 1 && (n.set = n.add = n.clear = n.delete = $fb4adf1641919f0d$var$h), Object.freeze(n), e && $fb4adf1641919f0d$var$i(n, function(n, r) {
        return $fb4adf1641919f0d$export$792f3d81ea979f55(r, !0);
    }, !0)), n;
}
function $fb4adf1641919f0d$var$h() {
    $fb4adf1641919f0d$var$n(2);
}
function $fb4adf1641919f0d$var$y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function $fb4adf1641919f0d$var$b(r) {
    var t = $fb4adf1641919f0d$var$tn[r];
    return t || $fb4adf1641919f0d$var$n(18, r), t;
}
function $fb4adf1641919f0d$var$m(n, r) {
    $fb4adf1641919f0d$var$tn[n] || ($fb4adf1641919f0d$var$tn[n] = r);
}
function $fb4adf1641919f0d$var$_() {
    return $fb4adf1641919f0d$var$U;
}
function $fb4adf1641919f0d$var$j(n, r) {
    r && ($fb4adf1641919f0d$var$b("Patches"), n.u = [], n.s = [], n.v = r);
}
function $fb4adf1641919f0d$var$g(n) {
    $fb4adf1641919f0d$var$O(n), n.p.forEach($fb4adf1641919f0d$var$S), n.p = null;
}
function $fb4adf1641919f0d$var$O(n) {
    n === $fb4adf1641919f0d$var$U && ($fb4adf1641919f0d$var$U = n.l);
}
function $fb4adf1641919f0d$var$w(n) {
    return $fb4adf1641919f0d$var$U = {
        p: [],
        l: $fb4adf1641919f0d$var$U,
        h: n,
        m: !0,
        _: 0
    };
}
function $fb4adf1641919f0d$var$S(n) {
    var r = n[$fb4adf1641919f0d$var$Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function $fb4adf1641919f0d$var$P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || $fb4adf1641919f0d$var$b("ES5").S(e, r, o), o ? (i[$fb4adf1641919f0d$var$Q].P && ($fb4adf1641919f0d$var$g(e), $fb4adf1641919f0d$var$n(4)), $fb4adf1641919f0d$export$16e3aed3edb85946(r) && (r = $fb4adf1641919f0d$var$M(e, r), e.l || $fb4adf1641919f0d$var$x(e, r)), e.u && $fb4adf1641919f0d$var$b("Patches").M(i[$fb4adf1641919f0d$var$Q].t, r, e.u, e.s)) : r = $fb4adf1641919f0d$var$M(e, i, []), $fb4adf1641919f0d$var$g(e), e.u && e.v(e.u, e.s), r !== $fb4adf1641919f0d$export$45b790e32b2810ee ? r : void 0;
}
function $fb4adf1641919f0d$var$M(n, r, t) {
    if ($fb4adf1641919f0d$var$y(r)) return r;
    var e = r[$fb4adf1641919f0d$var$Q];
    if (!e) return $fb4adf1641919f0d$var$i(r, function(i, o) {
        return $fb4adf1641919f0d$var$A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return $fb4adf1641919f0d$var$x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $fb4adf1641919f0d$var$l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), $fb4adf1641919f0d$var$i(u, function(r, i) {
            return $fb4adf1641919f0d$var$A(n, e, o, r, i, t, a);
        }), $fb4adf1641919f0d$var$x(n, o, !1), t && n.u && $fb4adf1641919f0d$var$b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function $fb4adf1641919f0d$var$A(e, i, o, a, c, s, v) {
    if ($fb4adf1641919f0d$export$541ac630993a4c84(c)) {
        var p = $fb4adf1641919f0d$var$M(e, c, s && i && 3 !== i.i && !$fb4adf1641919f0d$var$u(i.R, a) ? s.concat(a) : void 0);
        if ($fb4adf1641919f0d$var$f(o, a, p), !$fb4adf1641919f0d$export$541ac630993a4c84(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if ($fb4adf1641919f0d$export$16e3aed3edb85946(c) && !$fb4adf1641919f0d$var$y(c)) {
        if (!e.h.D && e._ < 1) return;
        $fb4adf1641919f0d$var$M(e, c), i && i.A.l || $fb4adf1641919f0d$var$x(e, c);
    }
}
function $fb4adf1641919f0d$var$x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && $fb4adf1641919f0d$export$792f3d81ea979f55(r, t);
}
function $fb4adf1641919f0d$var$z(n, r) {
    var t = n[$fb4adf1641919f0d$var$Q];
    return (t ? $fb4adf1641919f0d$var$p(t) : n)[r];
}
function $fb4adf1641919f0d$var$I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function $fb4adf1641919f0d$var$k(n) {
    n.P || (n.P = !0, n.l && $fb4adf1641919f0d$var$k(n.l));
}
function $fb4adf1641919f0d$var$E(n) {
    n.o || (n.o = $fb4adf1641919f0d$var$l(n.t));
}
function $fb4adf1641919f0d$var$N(n, r, t) {
    var e = $fb4adf1641919f0d$var$s(r) ? $fb4adf1641919f0d$var$b("MapSet").F(r, t) : $fb4adf1641919f0d$var$v(r) ? $fb4adf1641919f0d$var$b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : $fb4adf1641919f0d$var$_(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = $fb4adf1641919f0d$var$en;
        t && (i = [
            e
        ], o = $fb4adf1641919f0d$var$on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : $fb4adf1641919f0d$var$b("ES5").J(r, t);
    return (t ? t.A : $fb4adf1641919f0d$var$_()).p.push(e), e;
}
function $fb4adf1641919f0d$export$97aac956da55dae9(e) {
    return $fb4adf1641919f0d$export$541ac630993a4c84(e) || $fb4adf1641919f0d$var$n(22, e), function n(r) {
        if (!$fb4adf1641919f0d$export$16e3aed3edb85946(r)) return r;
        var e, u = r[$fb4adf1641919f0d$var$Q], c = $fb4adf1641919f0d$var$o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !$fb4adf1641919f0d$var$b("ES5").K(u))) return u.t;
            u.I = !0, e = $fb4adf1641919f0d$var$D(r, c), u.I = !1;
        } else e = $fb4adf1641919f0d$var$D(r, c);
        return $fb4adf1641919f0d$var$i(e, function(r, t) {
            u && $fb4adf1641919f0d$var$a(u.t, r) === t || $fb4adf1641919f0d$var$f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function $fb4adf1641919f0d$var$D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return $fb4adf1641919f0d$var$l(n);
}
function $fb4adf1641919f0d$export$56771cf63ee491f5() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[$fb4adf1641919f0d$var$Q];
                return $fb4adf1641919f0d$var$en.get(r, n);
            },
            set: function(r) {
                var t = this[$fb4adf1641919f0d$var$Q];
                $fb4adf1641919f0d$var$en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][$fb4adf1641919f0d$var$Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && $fb4adf1641919f0d$var$k(t);
                    break;
                case 4:
                    o(t) && $fb4adf1641919f0d$var$k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = $fb4adf1641919f0d$var$nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== $fb4adf1641919f0d$var$Q) {
                var a = r[o];
                if (void 0 === a && !$fb4adf1641919f0d$var$u(r, o)) return !0;
                var f = t[o], s = f && f[$fb4adf1641919f0d$var$Q];
                if (s ? s.t !== a : !$fb4adf1641919f0d$var$c(f, a)) return !0;
            }
        }
        var v = !!r[$fb4adf1641919f0d$var$Q];
        return e.length !== $fb4adf1641919f0d$var$nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && $fb4adf1641919f0d$var$n(3, JSON.stringify($fb4adf1641919f0d$var$p(r)));
    }
    var s = {};
    $fb4adf1641919f0d$var$m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = $fb4adf1641919f0d$var$rn(r);
                delete o[$fb4adf1641919f0d$var$Q];
                for(var u = $fb4adf1641919f0d$var$nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : $fb4adf1641919f0d$var$_(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, $fb4adf1641919f0d$var$Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? $fb4adf1641919f0d$export$541ac630993a4c84(t) && t[$fb4adf1641919f0d$var$Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[$fb4adf1641919f0d$var$Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) $fb4adf1641919f0d$var$i(o, function(r) {
                            r !== $fb4adf1641919f0d$var$Q && (void 0 !== e[r] || $fb4adf1641919f0d$var$u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, $fb4adf1641919f0d$var$k(t)));
                        }), $fb4adf1641919f0d$var$i(e, function(n) {
                            void 0 !== o[n] || $fb4adf1641919f0d$var$u(o, n) || (f[n] = !1, $fb4adf1641919f0d$var$k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && ($fb4adf1641919f0d$var$k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function $fb4adf1641919f0d$export$d3a6659991a0696c() {
    function e(n) {
        if (!$fb4adf1641919f0d$export$16e3aed3edb85946(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if ($fb4adf1641919f0d$var$s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if ($fb4adf1641919f0d$var$v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return $fb4adf1641919f0d$var$u(n, $fb4adf1641919f0d$export$6ee2082928bcb0ee) && (r[$fb4adf1641919f0d$export$6ee2082928bcb0ee] = n[$fb4adf1641919f0d$export$6ee2082928bcb0ee]), r;
    }
    function f(n) {
        return $fb4adf1641919f0d$export$541ac630993a4c84(n) ? e(n) : n;
    }
    var c = "add";
    $fb4adf1641919f0d$var$m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = $fb4adf1641919f0d$var$o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || $fb4adf1641919f0d$var$n(24), "function" == typeof f && "prototype" === p && $fb4adf1641919f0d$var$n(24), "object" != typeof (f = $fb4adf1641919f0d$var$a(f, p)) && $fb4adf1641919f0d$var$n(15, i.join("/"));
                }
                var l = $fb4adf1641919f0d$var$o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                $fb4adf1641919f0d$var$n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        $fb4adf1641919f0d$var$n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        $fb4adf1641919f0d$var$i(n.R, function(n, i) {
                            var v = $fb4adf1641919f0d$var$a(o, n), p = $fb4adf1641919f0d$var$a(s, n), l = i ? $fb4adf1641919f0d$var$u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === $fb4adf1641919f0d$export$45b790e32b2810ee ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function $fb4adf1641919f0d$export$7d9f65390203b435() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if ($fb4adf1641919f0d$export$16e3aed3edb85946(r)) {
                var e = $fb4adf1641919f0d$var$N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && $fb4adf1641919f0d$var$n(3, JSON.stringify($fb4adf1641919f0d$var$p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[$fb4adf1641919f0d$var$Q] = {
                i: 2,
                l: r,
                A: r ? r.A : $fb4adf1641919f0d$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return $fb4adf1641919f0d$var$p(this[$fb4adf1641919f0d$var$Q]).size;
            }
        }), o.has = function(n) {
            return $fb4adf1641919f0d$var$p(this[$fb4adf1641919f0d$var$Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[$fb4adf1641919f0d$var$Q];
            return u(t), $fb4adf1641919f0d$var$p(t).has(n) && $fb4adf1641919f0d$var$p(t).get(n) === r || (e(t), $fb4adf1641919f0d$var$k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$fb4adf1641919f0d$var$Q];
            return u(r), e(r), $fb4adf1641919f0d$var$k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[$fb4adf1641919f0d$var$Q];
            u(n), $fb4adf1641919f0d$var$p(n).size && (e(n), $fb4adf1641919f0d$var$k(n), n.R = new Map, $fb4adf1641919f0d$var$i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            $fb4adf1641919f0d$var$p(this[$fb4adf1641919f0d$var$Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[$fb4adf1641919f0d$var$Q];
            u(r);
            var i = $fb4adf1641919f0d$var$p(r).get(n);
            if (r.I || !$fb4adf1641919f0d$export$16e3aed3edb85946(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = $fb4adf1641919f0d$var$N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return $fb4adf1641919f0d$var$p(this[$fb4adf1641919f0d$var$Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$fb4adf1641919f0d$var$V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$fb4adf1641919f0d$var$V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[$fb4adf1641919f0d$var$V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[$fb4adf1641919f0d$var$Q] = {
                i: 3,
                l: r,
                A: r ? r.A : $fb4adf1641919f0d$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return $fb4adf1641919f0d$var$p(this[$fb4adf1641919f0d$var$Q]).size;
            }
        }), t.has = function(n) {
            var r = this[$fb4adf1641919f0d$var$Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[$fb4adf1641919f0d$var$Q];
            return u(r), this.has(n) || (o(r), $fb4adf1641919f0d$var$k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$fb4adf1641919f0d$var$Q];
            return u(r), o(r), $fb4adf1641919f0d$var$k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[$fb4adf1641919f0d$var$Q];
            u(n), $fb4adf1641919f0d$var$p(n).size && (o(n), $fb4adf1641919f0d$var$k(n), n.o.clear());
        }, t.values = function() {
            var n = this[$fb4adf1641919f0d$var$Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[$fb4adf1641919f0d$var$Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[$fb4adf1641919f0d$var$V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    $fb4adf1641919f0d$var$m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function $fb4adf1641919f0d$export$cae049b67c7d1bc9() {
    $fb4adf1641919f0d$export$56771cf63ee491f5(), $fb4adf1641919f0d$export$7d9f65390203b435(), $fb4adf1641919f0d$export$d3a6659991a0696c();
}
function $fb4adf1641919f0d$export$c05b21e3257751e5(n) {
    return n;
}
function $fb4adf1641919f0d$export$20f911b3f8cf0b74(n) {
    return n;
}
var $fb4adf1641919f0d$var$G, $fb4adf1641919f0d$var$U, $fb4adf1641919f0d$var$W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), $fb4adf1641919f0d$var$X = "undefined" != typeof Map, $fb4adf1641919f0d$var$q = "undefined" != typeof Set, $fb4adf1641919f0d$var$B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $fb4adf1641919f0d$export$45b790e32b2810ee = $fb4adf1641919f0d$var$W ? Symbol.for("immer-nothing") : (($fb4adf1641919f0d$var$G = {})["immer-nothing"] = !0, $fb4adf1641919f0d$var$G), $fb4adf1641919f0d$export$6ee2082928bcb0ee = $fb4adf1641919f0d$var$W ? Symbol.for("immer-draftable") : "__$immer_draftable", $fb4adf1641919f0d$var$Q = $fb4adf1641919f0d$var$W ? Symbol.for("immer-state") : "__$immer_state", $fb4adf1641919f0d$var$V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", $fb4adf1641919f0d$var$Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, $fb4adf1641919f0d$var$Z = "" + Object.prototype.constructor, $fb4adf1641919f0d$var$nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $fb4adf1641919f0d$var$rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return $fb4adf1641919f0d$var$nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, $fb4adf1641919f0d$var$tn = {}, $fb4adf1641919f0d$var$en = {
    get: function(n, r) {
        if (r === $fb4adf1641919f0d$var$Q) return n;
        var e = $fb4adf1641919f0d$var$p(n);
        if (!$fb4adf1641919f0d$var$u(e, r)) return function(n, r, t) {
            var e, i = $fb4adf1641919f0d$var$I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !$fb4adf1641919f0d$export$16e3aed3edb85946(i) ? i : i === $fb4adf1641919f0d$var$z(n.t, r) ? ($fb4adf1641919f0d$var$E(n), n.o[r] = $fb4adf1641919f0d$var$N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in $fb4adf1641919f0d$var$p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys($fb4adf1641919f0d$var$p(n));
    },
    set: function(n, r, t) {
        var e = $fb4adf1641919f0d$var$I($fb4adf1641919f0d$var$p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = $fb4adf1641919f0d$var$z($fb4adf1641919f0d$var$p(n), r), o = null == i ? void 0 : i[$fb4adf1641919f0d$var$Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if ($fb4adf1641919f0d$var$c(t, i) && (void 0 !== t || $fb4adf1641919f0d$var$u(n.t, r))) return !0;
            $fb4adf1641919f0d$var$E(n), $fb4adf1641919f0d$var$k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== $fb4adf1641919f0d$var$z(n.t, r) || r in n.t ? (n.R[r] = !1, $fb4adf1641919f0d$var$E(n), $fb4adf1641919f0d$var$k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = $fb4adf1641919f0d$var$p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        $fb4adf1641919f0d$var$n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        $fb4adf1641919f0d$var$n(12);
    }
}, $fb4adf1641919f0d$var$on = {};
$fb4adf1641919f0d$var$i($fb4adf1641919f0d$var$en, function(n, r) {
    $fb4adf1641919f0d$var$on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), $fb4adf1641919f0d$var$on.deleteProperty = function(r, t) {
    return $fb4adf1641919f0d$var$on.set.call(this, r, t, void 0);
}, $fb4adf1641919f0d$var$on.set = function(r, t, e) {
    return $fb4adf1641919f0d$var$en.set.call(this, r[0], t, e, r[0]);
};
var $fb4adf1641919f0d$export$aaadc6ff0f822719 = function() {
    function e(r) {
        var e = this;
        this.O = $fb4adf1641919f0d$var$B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && $fb4adf1641919f0d$var$n(6), void 0 !== o && "function" != typeof o && $fb4adf1641919f0d$var$n(7), $fb4adf1641919f0d$export$16e3aed3edb85946(r)) {
                var c = $fb4adf1641919f0d$var$w(e), s = $fb4adf1641919f0d$var$N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? $fb4adf1641919f0d$var$g(c) : $fb4adf1641919f0d$var$O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return $fb4adf1641919f0d$var$j(c, o), $fb4adf1641919f0d$var$P(n, c);
                }, function(n) {
                    throw $fb4adf1641919f0d$var$g(c), n;
                }) : ($fb4adf1641919f0d$var$j(c, o), $fb4adf1641919f0d$var$P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === $fb4adf1641919f0d$export$45b790e32b2810ee && (f = void 0), e.D && $fb4adf1641919f0d$export$792f3d81ea979f55(f, !0), o) {
                    var p = [], l = [];
                    $fb4adf1641919f0d$var$b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            $fb4adf1641919f0d$var$n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        $fb4adf1641919f0d$export$16e3aed3edb85946(e) || $fb4adf1641919f0d$var$n(8), $fb4adf1641919f0d$export$541ac630993a4c84(e) && (e = $fb4adf1641919f0d$export$97aac956da55dae9(e));
        var i = $fb4adf1641919f0d$var$w(this), o = $fb4adf1641919f0d$var$N(this, e, void 0);
        return o[$fb4adf1641919f0d$var$Q].C = !0, $fb4adf1641919f0d$var$O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[$fb4adf1641919f0d$var$Q];
        var i = e.A;
        return $fb4adf1641919f0d$var$j(i, t), $fb4adf1641919f0d$var$P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !$fb4adf1641919f0d$var$B && $fb4adf1641919f0d$var$n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = $fb4adf1641919f0d$var$b("Patches").$;
        return $fb4adf1641919f0d$export$541ac630993a4c84(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), $fb4adf1641919f0d$var$an = new $fb4adf1641919f0d$export$aaadc6ff0f822719, $fb4adf1641919f0d$export$b46cabe22e78bc00 = $fb4adf1641919f0d$var$an.produce, $fb4adf1641919f0d$export$4da66d41c9492c78 = $fb4adf1641919f0d$var$an.produceWithPatches.bind($fb4adf1641919f0d$var$an), $fb4adf1641919f0d$export$573f26f60825c493 = $fb4adf1641919f0d$var$an.setAutoFreeze.bind($fb4adf1641919f0d$var$an), $fb4adf1641919f0d$export$36ccd207ae29b74e = $fb4adf1641919f0d$var$an.setUseProxies.bind($fb4adf1641919f0d$var$an), $fb4adf1641919f0d$export$a8b8e03e6bbe5473 = $fb4adf1641919f0d$var$an.applyPatches.bind($fb4adf1641919f0d$var$an), $fb4adf1641919f0d$export$3c3214997190395f = $fb4adf1641919f0d$var$an.createDraft.bind($fb4adf1641919f0d$var$an), $fb4adf1641919f0d$export$c60f5e69c521b528 = $fb4adf1641919f0d$var$an.finishDraft.bind($fb4adf1641919f0d$var$an);
var $fb4adf1641919f0d$export$2e2bcd8739ae039 = $fb4adf1641919f0d$export$b46cabe22e78bc00;


function $f7e2db1b91f752a8$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $f7e2db1b91f752a8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f7e2db1b91f752a8$export$2e2bcd8739ae039(obj);
}



function $994493d710ed1bcc$export$2e2bcd8739ae039(input, hint) {
    if ((0, $f7e2db1b91f752a8$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $f7e2db1b91f752a8$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $745daef9d79361e8$export$2e2bcd8739ae039(arg) {
    var key = (0, $994493d710ed1bcc$export$2e2bcd8739ae039)(arg, "string");
    return (0, $f7e2db1b91f752a8$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $3d0da9995d35f2c0$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $745daef9d79361e8$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $ee81c5388a4439bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ee81c5388a4439bb$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ee81c5388a4439bb$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $3d0da9995d35f2c0$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ee81c5388a4439bb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $b66db12d315506ff$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $b66db12d315506ff$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $b66db12d315506ff$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $b66db12d315506ff$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $b66db12d315506ff$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $b66db12d315506ff$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $b66db12d315506ff$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $b66db12d315506ff$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $b66db12d315506ff$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($b66db12d315506ff$var$isDate(val)) return "date";
    if ($b66db12d315506ff$var$isError(val)) return "error";
    var constructorName = $b66db12d315506ff$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $b66db12d315506ff$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $b66db12d315506ff$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $b66db12d315506ff$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $b66db12d315506ff$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $b66db12d315506ff$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($b66db12d315506ff$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($b66db12d315506ff$var$formatProdErrorMessage(1));
        return enhancer($b66db12d315506ff$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($b66db12d315506ff$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($b66db12d315506ff$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($b66db12d315506ff$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($b66db12d315506ff$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($b66db12d315506ff$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$b66db12d315506ff$var$isPlainObject(action)) throw new Error($b66db12d315506ff$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($b66db12d315506ff$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($b66db12d315506ff$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($b66db12d315506ff$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $b66db12d315506ff$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($b66db12d315506ff$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$b66db12d315506ff$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $b66db12d315506ff$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$b66db12d315506ff$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $b66db12d315506ff$export$8928921ea2d3b126 = $b66db12d315506ff$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $b66db12d315506ff$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $b66db12d315506ff$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $b66db12d315506ff$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$b66db12d315506ff$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $b66db12d315506ff$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $b66db12d315506ff$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $b66db12d315506ff$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $b66db12d315506ff$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($b66db12d315506ff$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $b66db12d315506ff$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($b66db12d315506ff$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $b66db12d315506ff$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $b66db12d315506ff$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($b66db12d315506ff$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $b66db12d315506ff$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $b66db12d315506ff$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $b66db12d315506ff$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($b66db12d315506ff$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $b66db12d315506ff$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $b66db12d315506ff$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $b66db12d315506ff$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($b66db12d315506ff$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $b66db12d315506ff$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $ee81c5388a4439bb$export$2e2bcd8739ae039)((0, $ee81c5388a4439bb$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $a33ee809b4a5dfb3$var$NOT_FOUND = "NOT_FOUND";
function $a33ee809b4a5dfb3$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $a33ee809b4a5dfb3$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $a33ee809b4a5dfb3$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $a33ee809b4a5dfb3$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $a33ee809b4a5dfb3$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $a33ee809b4a5dfb3$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $a33ee809b4a5dfb3$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $a33ee809b4a5dfb3$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $a33ee809b4a5dfb3$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $a33ee809b4a5dfb3$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $a33ee809b4a5dfb3$var$createSingletonCache(comparator) : $a33ee809b4a5dfb3$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $a33ee809b4a5dfb3$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $65acb94a2569954a$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $65acb94a2569954a$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $65acb94a2569954a$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $65acb94a2569954a$export$595d22ed68ca2841 = /* #__PURE__ */ $65acb94a2569954a$export$5943f4447f6ef248((0, $a33ee809b4a5dfb3$export$281bff7f05488aa2));
var $65acb94a2569954a$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $65acb94a2569954a$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $4454257b123b95ea$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $4454257b123b95ea$var$thunk = $4454257b123b95ea$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$4454257b123b95ea$var$thunk.withExtraArgument = $4454257b123b95ea$var$createThunkMiddleware;
var $4454257b123b95ea$export$2e2bcd8739ae039 = $4454257b123b95ea$var$thunk;



var $c24d9e5391c18db7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c24d9e5391c18db7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c24d9e5391c18db7$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $c24d9e5391c18db7$var$__defProp = Object.defineProperty;
var $c24d9e5391c18db7$var$__defProps = Object.defineProperties;
var $c24d9e5391c18db7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c24d9e5391c18db7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c24d9e5391c18db7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c24d9e5391c18db7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c24d9e5391c18db7$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $c24d9e5391c18db7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $c24d9e5391c18db7$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($c24d9e5391c18db7$var$__hasOwnProp.call(b, prop)) $c24d9e5391c18db7$var$__defNormalProp(a, prop, b[prop]);
    if ($c24d9e5391c18db7$var$__getOwnPropSymbols) for(var _i = 0, _c = $c24d9e5391c18db7$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($c24d9e5391c18db7$var$__propIsEnum.call(b, prop)) $c24d9e5391c18db7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c24d9e5391c18db7$var$__spreadProps = function(a, b) {
    return $c24d9e5391c18db7$var$__defProps(a, $c24d9e5391c18db7$var$__getOwnPropDescs(b));
};
var $c24d9e5391c18db7$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $c24d9e5391c18db7$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $65acb94a2569954a$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $c24d9e5391c18db7$var$__spreadArray([
            (0, $fb4adf1641919f0d$export$541ac630993a4c84)(value) ? (0, $fb4adf1641919f0d$export$97aac956da55dae9)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $c24d9e5391c18db7$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $b66db12d315506ff$export$f672e0b6f7222cd7;
    return (0, $b66db12d315506ff$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $c24d9e5391c18db7$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $c24d9e5391c18db7$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $c24d9e5391c18db7$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $c24d9e5391c18db7$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $c24d9e5391c18db7$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $c24d9e5391c18db7$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $c24d9e5391c18db7$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $c24d9e5391c18db7$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $c24d9e5391c18db7$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $c24d9e5391c18db7$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $c24d9e5391c18db7$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $c24d9e5391c18db7$var$freezeDraftable(val) {
    return (0, $fb4adf1641919f0d$export$16e3aed3edb85946)(val) ? (0, $fb4adf1641919f0d$export$2e2bcd8739ae039)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $c24d9e5391c18db7$var$isProduction = true;
var $c24d9e5391c18db7$var$prefix = "Invariant failed";
function $c24d9e5391c18db7$var$invariant(condition, message) {
    if (condition) return;
    if ($c24d9e5391c18db7$var$isProduction) throw new Error($c24d9e5391c18db7$var$prefix);
    throw new Error($c24d9e5391c18db7$var$prefix + ": " + (message || ""));
}
function $c24d9e5391c18db7$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $c24d9e5391c18db7$var$getSerialize(serializer, decycler), indent);
}
function $c24d9e5391c18db7$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $c24d9e5391c18db7$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $c24d9e5391c18db7$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $c24d9e5391c18db7$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $c24d9e5391c18db7$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $c24d9e5391c18db7$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $c24d9e5391c18db7$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $c24d9e5391c18db7$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $c24d9e5391c18db7$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $c24d9e5391c18db7$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $c24d9e5391c18db7$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $c24d9e5391c18db7$export$53b83ca8eaab0383(val);
}
function $c24d9e5391c18db7$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $c24d9e5391c18db7$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $c24d9e5391c18db7$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $c24d9e5391c18db7$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $c24d9e5391c18db7$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$c24d9e5391c18db7$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $c24d9e5391c18db7$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $c24d9e5391c18db7$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $c24d9e5391c18db7$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $c24d9e5391c18db7$export$36c1185aeee5b0a6(options);
    };
}
function $c24d9e5391c18db7$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $c24d9e5391c18db7$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($c24d9e5391c18db7$var$isBoolean(thunk)) middlewareArray.push((0, $4454257b123b95ea$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $4454257b123b95ea$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $c24d9e5391c18db7$var$IS_PRODUCTION = true;
function $c24d9e5391c18db7$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $c24d9e5391c18db7$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($c24d9e5391c18db7$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $b66db12d315506ff$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$c24d9e5391c18db7$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$c24d9e5391c18db7$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $b66db12d315506ff$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $b66db12d315506ff$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $c24d9e5391c18db7$var$composeWithDevTools($c24d9e5391c18db7$var$__spreadValues({
        trace: !$c24d9e5391c18db7$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $c24d9e5391c18db7$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $c24d9e5391c18db7$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $b66db12d315506ff$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $c24d9e5391c18db7$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $c24d9e5391c18db7$var$__spreadValues($c24d9e5391c18db7$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $c24d9e5391c18db7$export$b956e38827fca970(action) {
    return $c24d9e5391c18db7$export$53b83ca8eaab0383(action) && "type" in action;
}
function $c24d9e5391c18db7$export$ebd532f9034651f3(action) {
    return $c24d9e5391c18db7$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($c24d9e5391c18db7$var$isValidKey);
}
function $c24d9e5391c18db7$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $c24d9e5391c18db7$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $c24d9e5391c18db7$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $c24d9e5391c18db7$var$isStateFunction(x) {
    return typeof x === "function";
}
var $c24d9e5391c18db7$var$hasWarnedAboutObjectNotation = false;
function $c24d9e5391c18db7$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $c24d9e5391c18db7$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($c24d9e5391c18db7$var$isStateFunction(initialState)) getInitialState = function() {
        return $c24d9e5391c18db7$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $c24d9e5391c18db7$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $c24d9e5391c18db7$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $fb4adf1641919f0d$export$541ac630993a4c84)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $fb4adf1641919f0d$export$16e3aed3edb85946)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $fb4adf1641919f0d$export$2e2bcd8739ae039)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $c24d9e5391c18db7$var$hasWarnedAboutObjectNotation2 = false;
function $c24d9e5391c18db7$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $c24d9e5391c18db7$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $0748a729b35c8c72$exports;
    var initialState = typeof options.initialState == "function" ? options.initialState : $c24d9e5391c18db7$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $c24d9e5391c18db7$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $c24d9e5391c18db7$export$309c7a02b0b0bc62(type, prepareCallback) : $c24d9e5391c18db7$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $c24d9e5391c18db7$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $c24d9e5391c18db7$var$__spreadValues($c24d9e5391c18db7$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $c24d9e5391c18db7$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $c24d9e5391c18db7$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $c24d9e5391c18db7$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($c24d9e5391c18db7$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $c24d9e5391c18db7$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $c24d9e5391c18db7$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $c24d9e5391c18db7$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $c24d9e5391c18db7$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $c24d9e5391c18db7$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $c24d9e5391c18db7$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $c24d9e5391c18db7$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $c24d9e5391c18db7$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $c24d9e5391c18db7$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $c24d9e5391c18db7$var$createSingleArgumentStateOperator(mutator) {
    var operator = $c24d9e5391c18db7$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $c24d9e5391c18db7$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $c24d9e5391c18db7$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $fb4adf1641919f0d$export$541ac630993a4c84)(state)) {
            runMutator(state);
            return state;
        } else return (0, $fb4adf1641919f0d$export$2e2bcd8739ae039)(state, runMutator);
    };
}
// src/entities/utils.ts
function $c24d9e5391c18db7$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $c24d9e5391c18db7$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $c24d9e5391c18db7$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $c24d9e5391c18db7$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $c24d9e5391c18db7$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $c24d9e5391c18db7$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $c24d9e5391c18db7$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $c24d9e5391c18db7$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $c24d9e5391c18db7$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $c24d9e5391c18db7$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $c24d9e5391c18db7$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $c24d9e5391c18db7$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $c24d9e5391c18db7$var$__spreadValues($c24d9e5391c18db7$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $c24d9e5391c18db7$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $c24d9e5391c18db7$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $c24d9e5391c18db7$var$createStateOperator(addOneMutably),
        addMany: $c24d9e5391c18db7$var$createStateOperator(addManyMutably),
        setOne: $c24d9e5391c18db7$var$createStateOperator(setOneMutably),
        setMany: $c24d9e5391c18db7$var$createStateOperator(setManyMutably),
        setAll: $c24d9e5391c18db7$var$createStateOperator(setAllMutably),
        updateOne: $c24d9e5391c18db7$var$createStateOperator(updateOneMutably),
        updateMany: $c24d9e5391c18db7$var$createStateOperator(updateManyMutably),
        upsertOne: $c24d9e5391c18db7$var$createStateOperator(upsertOneMutably),
        upsertMany: $c24d9e5391c18db7$var$createStateOperator(upsertManyMutably),
        removeOne: $c24d9e5391c18db7$var$createStateOperator(removeOneMutably),
        removeMany: $c24d9e5391c18db7$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $c24d9e5391c18db7$var$createSortedStateAdapter(selectId, sort) {
    var _c = $c24d9e5391c18db7$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $c24d9e5391c18db7$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($c24d9e5391c18db7$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $c24d9e5391c18db7$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $c24d9e5391c18db7$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $c24d9e5391c18db7$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $c24d9e5391c18db7$var$createStateOperator(addOneMutably),
        updateOne: $c24d9e5391c18db7$var$createStateOperator(updateOneMutably),
        upsertOne: $c24d9e5391c18db7$var$createStateOperator(upsertOneMutably),
        setOne: $c24d9e5391c18db7$var$createStateOperator(setOneMutably),
        setMany: $c24d9e5391c18db7$var$createStateOperator(setManyMutably),
        setAll: $c24d9e5391c18db7$var$createStateOperator(setAllMutably),
        addMany: $c24d9e5391c18db7$var$createStateOperator(addManyMutably),
        updateMany: $c24d9e5391c18db7$var$createStateOperator(updateManyMutably),
        upsertMany: $c24d9e5391c18db7$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $c24d9e5391c18db7$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $c24d9e5391c18db7$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $c24d9e5391c18db7$var$createInitialStateFactory();
    var selectorsFactory = $c24d9e5391c18db7$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $c24d9e5391c18db7$var$createSortedStateAdapter(selectId, sortComparer) : $c24d9e5391c18db7$var$createUnsortedStateAdapter(selectId);
    return $c24d9e5391c18db7$var$__spreadValues($c24d9e5391c18db7$var$__spreadValues($c24d9e5391c18db7$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $c24d9e5391c18db7$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $c24d9e5391c18db7$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $c24d9e5391c18db7$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $c24d9e5391c18db7$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $c24d9e5391c18db7$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $c24d9e5391c18db7$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $c24d9e5391c18db7$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $c24d9e5391c18db7$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $c24d9e5391c18db7$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $c24d9e5391c18db7$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $c24d9e5391c18db7$var$__spreadProps($c24d9e5391c18db7$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $c24d9e5391c18db7$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $c24d9e5391c18db7$var$__spreadProps($c24d9e5391c18db7$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $c24d9e5391c18db7$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $c24d9e5391c18db7$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $c24d9e5391c18db7$var$__spreadProps($c24d9e5391c18db7$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $c24d9e5391c18db7$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $c24d9e5391c18db7$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $c24d9e5391c18db7$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$c24d9e5391c18db7$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $c24d9e5391c18db7$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $c24d9e5391c18db7$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $c24d9e5391c18db7$var$RejectWithValue) throw result;
                                                if (result instanceof $c24d9e5391c18db7$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $c24d9e5391c18db7$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($c24d9e5391c18db7$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $c24d9e5391c18db7$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $c24d9e5391c18db7$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $c24d9e5391c18db7$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $c24d9e5391c18db7$var$matches = function(matcher, action) {
    if ($c24d9e5391c18db7$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $c24d9e5391c18db7$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $c24d9e5391c18db7$var$matches(matcher, action);
        });
    };
}
function $c24d9e5391c18db7$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $c24d9e5391c18db7$var$matches(matcher, action);
        });
    };
}
function $c24d9e5391c18db7$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $c24d9e5391c18db7$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $c24d9e5391c18db7$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $c24d9e5391c18db7$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$c24d9e5391c18db7$var$isAsyncThunkArray(asyncThunks)) return $c24d9e5391c18db7$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $c24d9e5391c18db7$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $c24d9e5391c18db7$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $c24d9e5391c18db7$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$c24d9e5391c18db7$var$isAsyncThunkArray(asyncThunks)) return $c24d9e5391c18db7$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $c24d9e5391c18db7$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $c24d9e5391c18db7$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $c24d9e5391c18db7$export$9dd1fb32974da385($c24d9e5391c18db7$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$c24d9e5391c18db7$var$isAsyncThunkArray(asyncThunks)) return $c24d9e5391c18db7$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $c24d9e5391c18db7$export$9dd1fb32974da385($c24d9e5391c18db7$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $c24d9e5391c18db7$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $c24d9e5391c18db7$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$c24d9e5391c18db7$var$isAsyncThunkArray(asyncThunks)) return $c24d9e5391c18db7$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $c24d9e5391c18db7$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $c24d9e5391c18db7$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $c24d9e5391c18db7$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$c24d9e5391c18db7$var$isAsyncThunkArray(asyncThunks)) return $c24d9e5391c18db7$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $c24d9e5391c18db7$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $c24d9e5391c18db7$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $c24d9e5391c18db7$var$noop = function() {};
var $c24d9e5391c18db7$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $c24d9e5391c18db7$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $c24d9e5391c18db7$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $c24d9e5391c18db7$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $c24d9e5391c18db7$var$task = "task";
var $c24d9e5391c18db7$var$listener = "listener";
var $c24d9e5391c18db7$var$completed = "completed";
var $c24d9e5391c18db7$var$cancelled = "cancelled";
var $c24d9e5391c18db7$var$taskCancelled = "task-" + $c24d9e5391c18db7$var$cancelled;
var $c24d9e5391c18db7$var$taskCompleted = "task-" + $c24d9e5391c18db7$var$completed;
var $c24d9e5391c18db7$var$listenerCancelled = $c24d9e5391c18db7$var$listener + "-" + $c24d9e5391c18db7$var$cancelled;
var $c24d9e5391c18db7$var$listenerCompleted = $c24d9e5391c18db7$var$listener + "-" + $c24d9e5391c18db7$var$completed;
var $c24d9e5391c18db7$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $c24d9e5391c18db7$var$task + " " + $c24d9e5391c18db7$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $c24d9e5391c18db7$var$validateActive = function(signal) {
    if (signal.aborted) throw new $c24d9e5391c18db7$export$cb1bdac908fed7f(signal.reason);
};
function $c24d9e5391c18db7$var$raceWithSignal(signal, promise2) {
    var cleanup = $c24d9e5391c18db7$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $c24d9e5391c18db7$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $c24d9e5391c18db7$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $c24d9e5391c18db7$var$noop;
    });
}
var $c24d9e5391c18db7$var$runTask = function(task2, cleanUp) {
    return $c24d9e5391c18db7$var$__async(void 0, null, function() {
        var value, error_1;
        return $c24d9e5391c18db7$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $c24d9e5391c18db7$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $c24d9e5391c18db7$var$createPause = function(signal) {
    return function(promise2) {
        return $c24d9e5391c18db7$var$catchRejection($c24d9e5391c18db7$var$raceWithSignal(signal, promise2).then(function(output) {
            $c24d9e5391c18db7$var$validateActive(signal);
            return output;
        }));
    };
};
var $c24d9e5391c18db7$var$createDelay = function(signal) {
    var pause = $c24d9e5391c18db7$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $c24d9e5391c18db7$var$assign = Object.assign;
var $c24d9e5391c18db7$var$INTERNAL_NIL_TOKEN = {};
var $c24d9e5391c18db7$var$alm = "listenerMiddleware";
var $c24d9e5391c18db7$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $c24d9e5391c18db7$var$addAbortSignalListener(parentAbortSignal, function() {
            return $c24d9e5391c18db7$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $c24d9e5391c18db7$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $c24d9e5391c18db7$var$runTask(function() {
            return $c24d9e5391c18db7$var$__async(void 0, null, function() {
                var result2;
                return $c24d9e5391c18db7$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $c24d9e5391c18db7$var$validateActive(parentAbortSignal);
                            $c24d9e5391c18db7$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $c24d9e5391c18db7$var$createPause(childAbortController.signal),
                                    delay: $c24d9e5391c18db7$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $c24d9e5391c18db7$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $c24d9e5391c18db7$var$abortControllerWithReason(childAbortController, $c24d9e5391c18db7$var$taskCompleted);
        });
        return {
            result: $c24d9e5391c18db7$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $c24d9e5391c18db7$var$abortControllerWithReason(childAbortController, $c24d9e5391c18db7$var$taskCancelled);
            }
        };
    };
};
var $c24d9e5391c18db7$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $c24d9e5391c18db7$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $c24d9e5391c18db7$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $c24d9e5391c18db7$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $c24d9e5391c18db7$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $c24d9e5391c18db7$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $c24d9e5391c18db7$var$catchRejection(take(predicate, timeout));
    };
};
var $c24d9e5391c18db7$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $c24d9e5391c18db7$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $c24d9e5391c18db7$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $c24d9e5391c18db7$var$createListenerEntry = function(options) {
    var _c = $c24d9e5391c18db7$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $c24d9e5391c18db7$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $c24d9e5391c18db7$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $c24d9e5391c18db7$var$abortControllerWithReason(controller, $c24d9e5391c18db7$var$listenerCancelled);
    });
};
var $c24d9e5391c18db7$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($c24d9e5391c18db7$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $c24d9e5391c18db7$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $c24d9e5391c18db7$export$f03a6b845d3fb58b = $c24d9e5391c18db7$export$309c7a02b0b0bc62($c24d9e5391c18db7$var$alm + "/add");
var $c24d9e5391c18db7$export$b1b8022855fb2b71 = $c24d9e5391c18db7$export$309c7a02b0b0bc62($c24d9e5391c18db7$var$alm + "/removeAll");
var $c24d9e5391c18db7$export$b03e9483f936dccb = $c24d9e5391c18db7$export$309c7a02b0b0bc62($c24d9e5391c18db7$var$alm + "/remove");
var $c24d9e5391c18db7$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $c24d9e5391c18db7$var$__spreadArray([
        $c24d9e5391c18db7$var$alm + "/error"
    ], args));
};
function $c24d9e5391c18db7$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $c24d9e5391c18db7$var$defaultErrorHandler : _c;
    $c24d9e5391c18db7$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $c24d9e5391c18db7$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $c24d9e5391c18db7$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $c24d9e5391c18db7$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $c24d9e5391c18db7$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $c24d9e5391c18db7$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $c24d9e5391c18db7$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $c24d9e5391c18db7$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $c24d9e5391c18db7$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $c24d9e5391c18db7$var$createDelay(internalTaskController.signal),
                                pause: $c24d9e5391c18db7$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $c24d9e5391c18db7$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $c24d9e5391c18db7$var$abortControllerWithReason(controller, $c24d9e5391c18db7$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $c24d9e5391c18db7$export$cb1bdac908fed7f)) $c24d9e5391c18db7$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $c24d9e5391c18db7$var$abortControllerWithReason(internalTaskController, $c24d9e5391c18db7$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $c24d9e5391c18db7$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$c24d9e5391c18db7$export$b956e38827fca970(action)) return next(action);
                if ($c24d9e5391c18db7$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($c24d9e5391c18db7$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($c24d9e5391c18db7$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $c24d9e5391c18db7$var$INTERNAL_NIL_TOKEN) throw new Error($c24d9e5391c18db7$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $c24d9e5391c18db7$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $c24d9e5391c18db7$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $c24d9e5391c18db7$export$8fb31c0f05df007b = "RTK_autoBatch";
var $c24d9e5391c18db7$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$c24d9e5391c18db7$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $c24d9e5391c18db7$var$promise;
var $c24d9e5391c18db7$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($c24d9e5391c18db7$var$promise || ($c24d9e5391c18db7$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $c24d9e5391c18db7$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $c24d9e5391c18db7$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $c24d9e5391c18db7$var$createQueueWithTimer(10);
var $c24d9e5391c18db7$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $c24d9e5391c18db7$var$queueMicrotaskShim : options.type === "raf" ? $c24d9e5391c18db7$var$rAF : options.type === "callback" ? options.queueNotification : $c24d9e5391c18db7$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$c24d9e5391c18db7$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $fb4adf1641919f0d$export$56771cf63ee491f5)();



const $97dadce6f2e742a7$var$initialState = {
    categories: {}
};
const $97dadce6f2e742a7$var$categorySlice = (0, $c24d9e5391c18db7$exports.createSlice)({
    name: "category",
    initialState: $97dadce6f2e742a7$var$initialState,
    reducers: {
        setCategories: (state, action)=>{
            state.categories = action.payload;
        }
    }
});
const { setCategories: $97dadce6f2e742a7$export$5094e6521d9d77b5 } = $97dadce6f2e742a7$var$categorySlice.actions;
var $97dadce6f2e742a7$export$2e2bcd8739ae039 = $97dadce6f2e742a7$var$categorySlice.reducer;


const $d5ffda0bf64adbbf$export$6f57813fe9f31bf9 = (0, $c24d9e5391c18db7$exports.configureStore)({
    reducer: {
        category: $97dadce6f2e742a7$export$2e2bcd8739ae039
    }
});



(0, $206751f6033bfbd8$export$882461b6382ed46c)(document.getElementById("root")).render(/*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $ab710f6f1c73e2e9$export$2e2bcd8739ae039), {
    store: (0, $d5ffda0bf64adbbf$export$6f57813fe9f31bf9),
    children: /*#__PURE__*/ (0, $a1cc52fbd40b0eb4$exports.jsx)((0, $a61576c739e8aa08$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.2ab4ca8a.js.map
